var __getOwnPropNames = Object.getOwnPropertyNames;
var __commonJS = (cb, mod) => function __require() {
  try {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  } catch (e) {
    throw mod = 0, e;
  }
};

// ../../node_modules/.pnpm/ajv@8.20.0/node_modules/ajv/dist/runtime/ucs2length.js
var require_ucs2length = __commonJS({
  "../../node_modules/.pnpm/ajv@8.20.0/node_modules/ajv/dist/runtime/ucs2length.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function ucs2length(str) {
      const len = str.length;
      let length = 0;
      let pos = 0;
      let value;
      while (pos < len) {
        length++;
        value = str.charCodeAt(pos++);
        if (value >= 55296 && value <= 56319 && pos < len) {
          value = str.charCodeAt(pos);
          if ((value & 64512) === 56320)
            pos++;
        }
      }
      return length;
    }
    exports.default = ucs2length;
    ucs2length.code = 'require("ajv/dist/runtime/ucs2length").default';
  }
});

// ../../node_modules/.pnpm/ajv-formats@3.0.1_ajv@8.20.0/node_modules/ajv-formats/dist/formats.js
var require_formats = __commonJS({
  "../../node_modules/.pnpm/ajv-formats@3.0.1_ajv@8.20.0/node_modules/ajv-formats/dist/formats.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.formatNames = exports.fastFormats = exports.fullFormats = void 0;
    function fmtDef(validate, compare) {
      return { validate, compare };
    }
    exports.fullFormats = {
      // date: http://tools.ietf.org/html/rfc3339#section-5.6
      date: fmtDef(date, compareDate),
      // date-time: http://tools.ietf.org/html/rfc3339#section-5.6
      time: fmtDef(getTime(true), compareTime),
      "date-time": fmtDef(getDateTime(true), compareDateTime),
      "iso-time": fmtDef(getTime(), compareIsoTime),
      "iso-date-time": fmtDef(getDateTime(), compareIsoDateTime),
      // duration: https://tools.ietf.org/html/rfc3339#appendix-A
      duration: /^P(?!$)((\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+S)?)?|(\d+W)?)$/,
      uri,
      "uri-reference": /^(?:[a-z][a-z0-9+\-.]*:)?(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'"()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?(?:\?(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i,
      // uri-template: https://tools.ietf.org/html/rfc6570
      "uri-template": /^(?:(?:[^\x00-\x20"'<>%\\^`{|}]|%[0-9a-f]{2})|\{[+#./;?&=,!@|]?(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?(?:,(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?)*\})*$/i,
      // For the source: https://gist.github.com/dperini/729294
      // For test cases: https://mathiasbynens.be/demo/url-regex
      url: /^(?:https?|ftp):\/\/(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u{00a1}-\u{ffff}]+-)*[a-z0-9\u{00a1}-\u{ffff}]+)(?:\.(?:[a-z0-9\u{00a1}-\u{ffff}]+-)*[a-z0-9\u{00a1}-\u{ffff}]+)*(?:\.(?:[a-z\u{00a1}-\u{ffff}]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?$/iu,
      email: /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i,
      hostname: /^(?=.{1,253}\.?$)[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[-0-9a-z]{0,61}[0-9a-z])?)*\.?$/i,
      // optimized https://www.safaribooksonline.com/library/view/regular-expressions-cookbook/9780596802837/ch07s16.html
      ipv4: /^(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)\.){3}(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)$/,
      ipv6: /^((([0-9a-f]{1,4}:){7}([0-9a-f]{1,4}|:))|(([0-9a-f]{1,4}:){6}(:[0-9a-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9a-f]{1,4}:){5}(((:[0-9a-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9a-f]{1,4}:){4}(((:[0-9a-f]{1,4}){1,3})|((:[0-9a-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){3}(((:[0-9a-f]{1,4}){1,4})|((:[0-9a-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){2}(((:[0-9a-f]{1,4}){1,5})|((:[0-9a-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){1}(((:[0-9a-f]{1,4}){1,6})|((:[0-9a-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9a-f]{1,4}){1,7})|((:[0-9a-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))$/i,
      regex,
      // uuid: http://tools.ietf.org/html/rfc4122
      uuid: /^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i,
      // JSON-pointer: https://tools.ietf.org/html/rfc6901
      // uri fragment: https://tools.ietf.org/html/rfc3986#appendix-A
      "json-pointer": /^(?:\/(?:[^~/]|~0|~1)*)*$/,
      "json-pointer-uri-fragment": /^#(?:\/(?:[a-z0-9_\-.!$&'()*+,;:=@]|%[0-9a-f]{2}|~0|~1)*)*$/i,
      // relative JSON-pointer: http://tools.ietf.org/html/draft-luff-relative-json-pointer-00
      "relative-json-pointer": /^(?:0|[1-9][0-9]*)(?:#|(?:\/(?:[^~/]|~0|~1)*)*)$/,
      // the following formats are used by the openapi specification: https://spec.openapis.org/oas/v3.0.0#data-types
      // byte: https://github.com/miguelmota/is-base64
      byte,
      // signed 32 bit integer
      int32: { type: "number", validate: validateInt32 },
      // signed 64 bit integer
      int64: { type: "number", validate: validateInt64 },
      // C-type float
      float: { type: "number", validate: validateNumber },
      // C-type double
      double: { type: "number", validate: validateNumber },
      // hint to the UI to hide input strings
      password: true,
      // unchecked string payload
      binary: true
    };
    exports.fastFormats = {
      ...exports.fullFormats,
      date: fmtDef(/^\d\d\d\d-[0-1]\d-[0-3]\d$/, compareDate),
      time: fmtDef(/^(?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)$/i, compareTime),
      "date-time": fmtDef(/^\d\d\d\d-[0-1]\d-[0-3]\dt(?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)$/i, compareDateTime),
      "iso-time": fmtDef(/^(?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)?$/i, compareIsoTime),
      "iso-date-time": fmtDef(/^\d\d\d\d-[0-1]\d-[0-3]\d[t\s](?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)?$/i, compareIsoDateTime),
      // uri: https://github.com/mafintosh/is-my-json-valid/blob/master/formats.js
      uri: /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/)?[^\s]*$/i,
      "uri-reference": /^(?:(?:[a-z][a-z0-9+\-.]*:)?\/?\/)?(?:[^\\\s#][^\s#]*)?(?:#[^\\\s]*)?$/i,
      // email (sources from jsen validator):
      // http://stackoverflow.com/questions/201323/using-a-regular-expression-to-validate-an-email-address#answer-8829363
      // http://www.w3.org/TR/html5/forms.html#valid-e-mail-address (search for 'wilful violation')
      email: /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/i
    };
    exports.formatNames = Object.keys(exports.fullFormats);
    function isLeapYear(year) {
      return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
    }
    var DATE = /^(\d\d\d\d)-(\d\d)-(\d\d)$/;
    var DAYS = [0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    function date(str) {
      const matches = DATE.exec(str);
      if (!matches)
        return false;
      const year = +matches[1];
      const month = +matches[2];
      const day = +matches[3];
      return month >= 1 && month <= 12 && day >= 1 && day <= (month === 2 && isLeapYear(year) ? 29 : DAYS[month]);
    }
    function compareDate(d1, d2) {
      if (!(d1 && d2))
        return void 0;
      if (d1 > d2)
        return 1;
      if (d1 < d2)
        return -1;
      return 0;
    }
    var TIME = /^(\d\d):(\d\d):(\d\d(?:\.\d+)?)(z|([+-])(\d\d)(?::?(\d\d))?)?$/i;
    function getTime(strictTimeZone) {
      return function time(str) {
        const matches = TIME.exec(str);
        if (!matches)
          return false;
        const hr = +matches[1];
        const min = +matches[2];
        const sec = +matches[3];
        const tz = matches[4];
        const tzSign = matches[5] === "-" ? -1 : 1;
        const tzH = +(matches[6] || 0);
        const tzM = +(matches[7] || 0);
        if (tzH > 23 || tzM > 59 || strictTimeZone && !tz)
          return false;
        if (hr <= 23 && min <= 59 && sec < 60)
          return true;
        const utcMin = min - tzM * tzSign;
        const utcHr = hr - tzH * tzSign - (utcMin < 0 ? 1 : 0);
        return (utcHr === 23 || utcHr === -1) && (utcMin === 59 || utcMin === -1) && sec < 61;
      };
    }
    function compareTime(s1, s2) {
      if (!(s1 && s2))
        return void 0;
      const t1 = (/* @__PURE__ */ new Date("2020-01-01T" + s1)).valueOf();
      const t2 = (/* @__PURE__ */ new Date("2020-01-01T" + s2)).valueOf();
      if (!(t1 && t2))
        return void 0;
      return t1 - t2;
    }
    function compareIsoTime(t1, t2) {
      if (!(t1 && t2))
        return void 0;
      const a1 = TIME.exec(t1);
      const a2 = TIME.exec(t2);
      if (!(a1 && a2))
        return void 0;
      t1 = a1[1] + a1[2] + a1[3];
      t2 = a2[1] + a2[2] + a2[3];
      if (t1 > t2)
        return 1;
      if (t1 < t2)
        return -1;
      return 0;
    }
    var DATE_TIME_SEPARATOR = /t|\s/i;
    function getDateTime(strictTimeZone) {
      const time = getTime(strictTimeZone);
      return function date_time(str) {
        const dateTime = str.split(DATE_TIME_SEPARATOR);
        return dateTime.length === 2 && date(dateTime[0]) && time(dateTime[1]);
      };
    }
    function compareDateTime(dt1, dt2) {
      if (!(dt1 && dt2))
        return void 0;
      const d1 = new Date(dt1).valueOf();
      const d2 = new Date(dt2).valueOf();
      if (!(d1 && d2))
        return void 0;
      return d1 - d2;
    }
    function compareIsoDateTime(dt1, dt2) {
      if (!(dt1 && dt2))
        return void 0;
      const [d1, t1] = dt1.split(DATE_TIME_SEPARATOR);
      const [d2, t2] = dt2.split(DATE_TIME_SEPARATOR);
      const res = compareDate(d1, d2);
      if (res === void 0)
        return void 0;
      return res || compareTime(t1, t2);
    }
    var NOT_URI_FRAGMENT = /\/|:/;
    var URI = /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)(?:\?(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i;
    function uri(str) {
      return NOT_URI_FRAGMENT.test(str) && URI.test(str);
    }
    var BYTE = /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/gm;
    function byte(str) {
      BYTE.lastIndex = 0;
      return BYTE.test(str);
    }
    var MIN_INT32 = -(2 ** 31);
    var MAX_INT32 = 2 ** 31 - 1;
    function validateInt32(value) {
      return Number.isInteger(value) && value <= MAX_INT32 && value >= MIN_INT32;
    }
    function validateInt64(value) {
      return Number.isInteger(value);
    }
    function validateNumber() {
      return true;
    }
    var Z_ANCHOR = /[^\\]\\Z/;
    function regex(str) {
      if (Z_ANCHOR.test(str))
        return false;
      try {
        new RegExp(str);
        return true;
      } catch (e) {
        return false;
      }
    }
  }
});

// validators.js
var validateInput0 = validate10;
var func2 = require_ucs2length().default;
function validate10(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.path === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "path" }, message: "must have required property 'path'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    for (const key0 in data) {
      if (!(key0 === "path" || key0 === "ifMatch")) {
        const err1 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
    }
    if (data.path !== void 0) {
      let data0 = data.path;
      if (typeof data0 === "string") {
        if (func2(data0) > 1024) {
          const err2 = { instancePath: instancePath + "/path", schemaPath: "#/properties/path/maxLength", keyword: "maxLength", params: { limit: 1024 }, message: "must NOT have more than 1024 characters" };
          if (vErrors === null) {
            vErrors = [err2];
          } else {
            vErrors.push(err2);
          }
          errors++;
        }
        if (func2(data0) < 1) {
          const err3 = { instancePath: instancePath + "/path", schemaPath: "#/properties/path/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
          if (vErrors === null) {
            vErrors = [err3];
          } else {
            vErrors.push(err3);
          }
          errors++;
        }
      } else {
        const err4 = { instancePath: instancePath + "/path", schemaPath: "#/properties/path/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
    if (data.ifMatch !== void 0) {
      let data1 = data.ifMatch;
      if (typeof data1 === "string") {
        if (func2(data1) < 1) {
          const err5 = { instancePath: instancePath + "/ifMatch", schemaPath: "#/properties/ifMatch/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
          if (vErrors === null) {
            vErrors = [err5];
          } else {
            vErrors.push(err5);
          }
          errors++;
        }
      } else {
        const err6 = { instancePath: instancePath + "/ifMatch", schemaPath: "#/properties/ifMatch/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
    }
  } else {
    const err7 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err7];
    } else {
      vErrors.push(err7);
    }
    errors++;
  }
  validate10.errors = vErrors;
  return errors === 0;
}
var validateOutput0 = validate11;
function validate11(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.object === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "object" }, message: "must have required property 'object'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.path === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "path" }, message: "must have required property 'path'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.deleted === void 0) {
      const err2 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "deleted" }, message: "must have required property 'deleted'" };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    for (const key0 in data) {
      if (!(key0 === "object" || key0 === "path" || key0 === "deleted")) {
        const err3 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.object !== void 0) {
      let data0 = data.object;
      if (typeof data0 !== "string") {
        const err4 = { instancePath: instancePath + "/object", schemaPath: "#/properties/object/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
      if ("file" !== data0) {
        const err5 = { instancePath: instancePath + "/object", schemaPath: "#/properties/object/const", keyword: "const", params: { allowedValue: "file" }, message: "must be equal to constant" };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
    }
    if (data.path !== void 0) {
      if (typeof data.path !== "string") {
        const err6 = { instancePath: instancePath + "/path", schemaPath: "#/properties/path/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
    }
    if (data.deleted !== void 0) {
      let data2 = data.deleted;
      if (typeof data2 !== "boolean") {
        const err7 = { instancePath: instancePath + "/deleted", schemaPath: "#/properties/deleted/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
      if (true !== data2) {
        const err8 = { instancePath: instancePath + "/deleted", schemaPath: "#/properties/deleted/const", keyword: "const", params: { allowedValue: true }, message: "must be equal to constant" };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
    }
  } else {
    const err9 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err9];
    } else {
      vErrors.push(err9);
    }
    errors++;
  }
  validate11.errors = vErrors;
  return errors === 0;
}
var validateInput1 = validate12;
function validate12(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    for (const key0 in data) {
      if (!(key0 === "limit")) {
        const err0 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err0];
        } else {
          vErrors.push(err0);
        }
        errors++;
      }
    }
    if (data.limit !== void 0) {
      let data0 = data.limit;
      if (!(typeof data0 == "number" && (!(data0 % 1) && !isNaN(data0)) && isFinite(data0))) {
        const err1 = { instancePath: instancePath + "/limit", schemaPath: "#/properties/limit/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
      if (typeof data0 == "number" && isFinite(data0)) {
        if (data0 > 100 || isNaN(data0)) {
          const err2 = { instancePath: instancePath + "/limit", schemaPath: "#/properties/limit/maximum", keyword: "maximum", params: { comparison: "<=", limit: 100 }, message: "must be <= 100" };
          if (vErrors === null) {
            vErrors = [err2];
          } else {
            vErrors.push(err2);
          }
          errors++;
        }
        if (data0 < 1 || isNaN(data0)) {
          const err3 = { instancePath: instancePath + "/limit", schemaPath: "#/properties/limit/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" };
          if (vErrors === null) {
            vErrors = [err3];
          } else {
            vErrors.push(err3);
          }
          errors++;
        }
      }
    }
  } else {
    const err4 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err4];
    } else {
      vErrors.push(err4);
    }
    errors++;
  }
  validate12.errors = vErrors;
  return errors === 0;
}
var validateOutput1 = validate13;
var formats0 = require_formats().fullFormats["date-time"];
var pattern0 = new RegExp("^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$", "u");
function validate13(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.object === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "object" }, message: "must have required property 'object'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.data === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "data" }, message: "must have required property 'data'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.has_more === void 0) {
      const err2 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "has_more" }, message: "must have required property 'has_more'" };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.url === void 0) {
      const err3 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "url" }, message: "must have required property 'url'" };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    for (const key0 in data) {
      if (!(key0 === "object" || key0 === "data" || key0 === "has_more" || key0 === "url")) {
        const err4 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
    if (data.object !== void 0) {
      let data0 = data.object;
      if (typeof data0 !== "string") {
        const err5 = { instancePath: instancePath + "/object", schemaPath: "#/properties/object/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
      if ("list" !== data0) {
        const err6 = { instancePath: instancePath + "/object", schemaPath: "#/properties/object/const", keyword: "const", params: { allowedValue: "list" }, message: "must be equal to constant" };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
    }
    if (data.data !== void 0) {
      let data1 = data.data;
      if (Array.isArray(data1)) {
        const len0 = data1.length;
        for (let i0 = 0; i0 < len0; i0++) {
          let data2 = data1[i0];
          if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
            if (data2.id === void 0) {
              const err7 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/properties/data/items/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property 'id'" };
              if (vErrors === null) {
                vErrors = [err7];
              } else {
                vErrors.push(err7);
              }
              errors++;
            }
            if (data2.object === void 0) {
              const err8 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/properties/data/items/required", keyword: "required", params: { missingProperty: "object" }, message: "must have required property 'object'" };
              if (vErrors === null) {
                vErrors = [err8];
              } else {
                vErrors.push(err8);
              }
              errors++;
            }
            if (data2.userId === void 0) {
              const err9 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/properties/data/items/required", keyword: "required", params: { missingProperty: "userId" }, message: "must have required property 'userId'" };
              if (vErrors === null) {
                vErrors = [err9];
              } else {
                vErrors.push(err9);
              }
              errors++;
            }
            if (data2.title === void 0) {
              const err10 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/properties/data/items/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
              if (vErrors === null) {
                vErrors = [err10];
              } else {
                vErrors.push(err10);
              }
              errors++;
            }
            if (data2.configuration === void 0) {
              const err11 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/properties/data/items/required", keyword: "required", params: { missingProperty: "configuration" }, message: "must have required property 'configuration'" };
              if (vErrors === null) {
                vErrors = [err11];
              } else {
                vErrors.push(err11);
              }
              errors++;
            }
            if (data2.createdAt === void 0) {
              const err12 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/properties/data/items/required", keyword: "required", params: { missingProperty: "createdAt" }, message: "must have required property 'createdAt'" };
              if (vErrors === null) {
                vErrors = [err12];
              } else {
                vErrors.push(err12);
              }
              errors++;
            }
            if (data2.updatedAt === void 0) {
              const err13 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/properties/data/items/required", keyword: "required", params: { missingProperty: "updatedAt" }, message: "must have required property 'updatedAt'" };
              if (vErrors === null) {
                vErrors = [err13];
              } else {
                vErrors.push(err13);
              }
              errors++;
            }
            for (const key1 in data2) {
              if (!(key1 === "id" || key1 === "object" || key1 === "userId" || key1 === "title" || key1 === "configuration" || key1 === "createdAt" || key1 === "updatedAt")) {
                const err14 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/properties/data/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
                if (vErrors === null) {
                  vErrors = [err14];
                } else {
                  vErrors.push(err14);
                }
                errors++;
              }
            }
            if (data2.id !== void 0) {
              if (typeof data2.id !== "string") {
                const err15 = { instancePath: instancePath + "/data/" + i0 + "/id", schemaPath: "#/properties/data/items/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err15];
                } else {
                  vErrors.push(err15);
                }
                errors++;
              }
            }
            if (data2.object !== void 0) {
              let data4 = data2.object;
              if (typeof data4 !== "string") {
                const err16 = { instancePath: instancePath + "/data/" + i0 + "/object", schemaPath: "#/properties/data/items/properties/object/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err16];
                } else {
                  vErrors.push(err16);
                }
                errors++;
              }
              if ("conversation" !== data4) {
                const err17 = { instancePath: instancePath + "/data/" + i0 + "/object", schemaPath: "#/properties/data/items/properties/object/const", keyword: "const", params: { allowedValue: "conversation" }, message: "must be equal to constant" };
                if (vErrors === null) {
                  vErrors = [err17];
                } else {
                  vErrors.push(err17);
                }
                errors++;
              }
            }
            if (data2.userId !== void 0) {
              if (typeof data2.userId !== "string") {
                const err18 = { instancePath: instancePath + "/data/" + i0 + "/userId", schemaPath: "#/properties/data/items/properties/userId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err18];
                } else {
                  vErrors.push(err18);
                }
                errors++;
              }
            }
            if (data2.title !== void 0) {
              if (typeof data2.title !== "string") {
                const err19 = { instancePath: instancePath + "/data/" + i0 + "/title", schemaPath: "#/properties/data/items/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err19];
                } else {
                  vErrors.push(err19);
                }
                errors++;
              }
            }
            if (data2.configuration !== void 0) {
              if (typeof data2.configuration !== "string") {
                const err20 = { instancePath: instancePath + "/data/" + i0 + "/configuration", schemaPath: "#/properties/data/items/properties/configuration/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err20];
                } else {
                  vErrors.push(err20);
                }
                errors++;
              }
            }
            if (data2.createdAt !== void 0) {
              let data8 = data2.createdAt;
              if (typeof data8 === "string") {
                if (!pattern0.test(data8)) {
                  const err21 = { instancePath: instancePath + "/data/" + i0 + "/createdAt", schemaPath: "#/properties/data/items/properties/createdAt/pattern", keyword: "pattern", params: { pattern: "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, message: 'must match pattern "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"' };
                  if (vErrors === null) {
                    vErrors = [err21];
                  } else {
                    vErrors.push(err21);
                  }
                  errors++;
                }
                if (!formats0.validate(data8)) {
                  const err22 = { instancePath: instancePath + "/data/" + i0 + "/createdAt", schemaPath: "#/properties/data/items/properties/createdAt/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' };
                  if (vErrors === null) {
                    vErrors = [err22];
                  } else {
                    vErrors.push(err22);
                  }
                  errors++;
                }
              } else {
                const err23 = { instancePath: instancePath + "/data/" + i0 + "/createdAt", schemaPath: "#/properties/data/items/properties/createdAt/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err23];
                } else {
                  vErrors.push(err23);
                }
                errors++;
              }
            }
            if (data2.updatedAt !== void 0) {
              let data9 = data2.updatedAt;
              if (typeof data9 === "string") {
                if (!pattern0.test(data9)) {
                  const err24 = { instancePath: instancePath + "/data/" + i0 + "/updatedAt", schemaPath: "#/properties/data/items/properties/updatedAt/pattern", keyword: "pattern", params: { pattern: "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, message: 'must match pattern "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"' };
                  if (vErrors === null) {
                    vErrors = [err24];
                  } else {
                    vErrors.push(err24);
                  }
                  errors++;
                }
                if (!formats0.validate(data9)) {
                  const err25 = { instancePath: instancePath + "/data/" + i0 + "/updatedAt", schemaPath: "#/properties/data/items/properties/updatedAt/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' };
                  if (vErrors === null) {
                    vErrors = [err25];
                  } else {
                    vErrors.push(err25);
                  }
                  errors++;
                }
              } else {
                const err26 = { instancePath: instancePath + "/data/" + i0 + "/updatedAt", schemaPath: "#/properties/data/items/properties/updatedAt/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err26];
                } else {
                  vErrors.push(err26);
                }
                errors++;
              }
            }
          } else {
            const err27 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/properties/data/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
              vErrors = [err27];
            } else {
              vErrors.push(err27);
            }
            errors++;
          }
        }
      } else {
        const err28 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/type", keyword: "type", params: { type: "array" }, message: "must be array" };
        if (vErrors === null) {
          vErrors = [err28];
        } else {
          vErrors.push(err28);
        }
        errors++;
      }
    }
    if (data.has_more !== void 0) {
      if (typeof data.has_more !== "boolean") {
        const err29 = { instancePath: instancePath + "/has_more", schemaPath: "#/properties/has_more/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
        if (vErrors === null) {
          vErrors = [err29];
        } else {
          vErrors.push(err29);
        }
        errors++;
      }
    }
    if (data.url !== void 0) {
      if (typeof data.url !== "string") {
        const err30 = { instancePath: instancePath + "/url", schemaPath: "#/properties/url/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err30];
        } else {
          vErrors.push(err30);
        }
        errors++;
      }
    }
  } else {
    const err31 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err31];
    } else {
      vErrors.push(err31);
    }
    errors++;
  }
  validate13.errors = vErrors;
  return errors === 0;
}
var validateInput2 = validate14;
function validate14(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.id === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property 'id'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    for (const key0 in data) {
      if (!(key0 === "id")) {
        const err1 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
    }
    if (data.id !== void 0) {
      let data0 = data.id;
      if (typeof data0 === "string") {
        if (func2(data0) < 1) {
          const err2 = { instancePath: instancePath + "/id", schemaPath: "#/properties/id/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
          if (vErrors === null) {
            vErrors = [err2];
          } else {
            vErrors.push(err2);
          }
          errors++;
        }
      } else {
        const err3 = { instancePath: instancePath + "/id", schemaPath: "#/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
  } else {
    const err4 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err4];
    } else {
      vErrors.push(err4);
    }
    errors++;
  }
  validate14.errors = vErrors;
  return errors === 0;
}
var validateOutput2 = validate15;
var schema16 = { "$schema": "http://json-schema.org/draft-07/schema#", "type": "object", "properties": { "id": { "type": "string" }, "object": { "type": "string", "const": "conversation" }, "userId": { "type": "string" }, "title": { "type": "string" }, "configuration": { "type": "string" }, "createdAt": { "type": "string", "format": "date-time", "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, "updatedAt": { "type": "string", "format": "date-time", "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, "runs": { "type": "array", "items": { "type": "object", "properties": { "id": { "type": "string" }, "object": { "type": "string", "const": "agent_run" }, "userId": { "type": "string" }, "prompt": { "type": "string" }, "status": { "type": "string", "enum": ["queued", "running", "completed", "failed", "cancelled"] }, "output": { "anyOf": [{ "type": "string" }, { "type": "null" }] }, "error": { "anyOf": [{ "type": "string" }, { "type": "null" }] }, "createdAt": { "type": "string", "format": "date-time", "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, "completedAt": { "anyOf": [{ "type": "string", "format": "date-time", "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, { "type": "null" }] }, "conversationId": { "anyOf": [{ "type": "string" }, { "type": "null" }] }, "turnNumber": { "anyOf": [{ "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, { "type": "null" }] }, "historyBoundary": { "anyOf": [{ "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, { "type": "null" }] } }, "required": ["id", "object", "userId", "prompt", "status", "output", "error", "createdAt", "completedAt", "conversationId", "turnNumber", "historyBoundary"], "additionalProperties": false } }, "messages": { "type": "array", "items": { "type": "object", "properties": { "runId": { "type": "string" }, "messageIndex": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "payload": { "oneOf": [{ "type": "object", "properties": { "role": { "type": "string", "const": "user" }, "content": { "type": "string" } }, "required": ["role", "content"], "additionalProperties": false }, { "type": "object", "properties": { "role": { "type": "string", "const": "assistant" }, "content": { "type": "string" }, "toolCalls": { "type": "array", "items": { "type": "object", "properties": { "id": { "type": "string" }, "thought": { "type": "string" }, "source": { "type": "string" } }, "required": ["id", "thought", "source"], "additionalProperties": false } } }, "required": ["role", "content", "toolCalls"], "additionalProperties": false }, { "type": "object", "properties": { "role": { "type": "string", "const": "tool" }, "toolCallId": { "type": "string" }, "content": { "type": "string" }, "isError": { "type": "boolean" }, "resources": { "type": "array", "items": { "type": "object", "properties": { "path": { "type": "string" }, "pattern": { "type": "string" }, "title": { "type": "string" } }, "required": ["path"], "additionalProperties": false } } }, "required": ["role", "toolCallId", "content"], "additionalProperties": false }] } }, "required": ["runId", "messageIndex", "payload"], "additionalProperties": false } }, "canContinue": { "type": "boolean" }, "feedback": { "type": "array", "items": { "type": "object", "properties": { "object": { "type": "string", "const": "feedback" }, "runId": { "type": "string" }, "target": { "type": "string", "enum": ["reply", "case"] }, "rating": { "type": "string", "enum": ["up", "down"] }, "note": { "anyOf": [{ "type": "string" }, { "type": "null" }] }, "createdAt": { "type": "string", "format": "date-time", "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" } }, "required": ["object", "runId", "target", "rating", "note", "createdAt"], "additionalProperties": false } } }, "required": ["id", "object", "userId", "title", "configuration", "createdAt", "updatedAt", "runs", "messages", "canContinue", "feedback"], "additionalProperties": false };
var func6 = Object.prototype.hasOwnProperty;
function validate15(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.id === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property 'id'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.object === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "object" }, message: "must have required property 'object'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.userId === void 0) {
      const err2 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "userId" }, message: "must have required property 'userId'" };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.title === void 0) {
      const err3 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.configuration === void 0) {
      const err4 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "configuration" }, message: "must have required property 'configuration'" };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
    if (data.createdAt === void 0) {
      const err5 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "createdAt" }, message: "must have required property 'createdAt'" };
      if (vErrors === null) {
        vErrors = [err5];
      } else {
        vErrors.push(err5);
      }
      errors++;
    }
    if (data.updatedAt === void 0) {
      const err6 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "updatedAt" }, message: "must have required property 'updatedAt'" };
      if (vErrors === null) {
        vErrors = [err6];
      } else {
        vErrors.push(err6);
      }
      errors++;
    }
    if (data.runs === void 0) {
      const err7 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "runs" }, message: "must have required property 'runs'" };
      if (vErrors === null) {
        vErrors = [err7];
      } else {
        vErrors.push(err7);
      }
      errors++;
    }
    if (data.messages === void 0) {
      const err8 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "messages" }, message: "must have required property 'messages'" };
      if (vErrors === null) {
        vErrors = [err8];
      } else {
        vErrors.push(err8);
      }
      errors++;
    }
    if (data.canContinue === void 0) {
      const err9 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "canContinue" }, message: "must have required property 'canContinue'" };
      if (vErrors === null) {
        vErrors = [err9];
      } else {
        vErrors.push(err9);
      }
      errors++;
    }
    if (data.feedback === void 0) {
      const err10 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "feedback" }, message: "must have required property 'feedback'" };
      if (vErrors === null) {
        vErrors = [err10];
      } else {
        vErrors.push(err10);
      }
      errors++;
    }
    for (const key0 in data) {
      if (!func6.call(schema16.properties, key0)) {
        const err11 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err11];
        } else {
          vErrors.push(err11);
        }
        errors++;
      }
    }
    if (data.id !== void 0) {
      if (typeof data.id !== "string") {
        const err12 = { instancePath: instancePath + "/id", schemaPath: "#/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err12];
        } else {
          vErrors.push(err12);
        }
        errors++;
      }
    }
    if (data.object !== void 0) {
      let data1 = data.object;
      if (typeof data1 !== "string") {
        const err13 = { instancePath: instancePath + "/object", schemaPath: "#/properties/object/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err13];
        } else {
          vErrors.push(err13);
        }
        errors++;
      }
      if ("conversation" !== data1) {
        const err14 = { instancePath: instancePath + "/object", schemaPath: "#/properties/object/const", keyword: "const", params: { allowedValue: "conversation" }, message: "must be equal to constant" };
        if (vErrors === null) {
          vErrors = [err14];
        } else {
          vErrors.push(err14);
        }
        errors++;
      }
    }
    if (data.userId !== void 0) {
      if (typeof data.userId !== "string") {
        const err15 = { instancePath: instancePath + "/userId", schemaPath: "#/properties/userId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err15];
        } else {
          vErrors.push(err15);
        }
        errors++;
      }
    }
    if (data.title !== void 0) {
      if (typeof data.title !== "string") {
        const err16 = { instancePath: instancePath + "/title", schemaPath: "#/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err16];
        } else {
          vErrors.push(err16);
        }
        errors++;
      }
    }
    if (data.configuration !== void 0) {
      if (typeof data.configuration !== "string") {
        const err17 = { instancePath: instancePath + "/configuration", schemaPath: "#/properties/configuration/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err17];
        } else {
          vErrors.push(err17);
        }
        errors++;
      }
    }
    if (data.createdAt !== void 0) {
      let data5 = data.createdAt;
      if (typeof data5 === "string") {
        if (!pattern0.test(data5)) {
          const err18 = { instancePath: instancePath + "/createdAt", schemaPath: "#/properties/createdAt/pattern", keyword: "pattern", params: { pattern: "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, message: 'must match pattern "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"' };
          if (vErrors === null) {
            vErrors = [err18];
          } else {
            vErrors.push(err18);
          }
          errors++;
        }
        if (!formats0.validate(data5)) {
          const err19 = { instancePath: instancePath + "/createdAt", schemaPath: "#/properties/createdAt/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' };
          if (vErrors === null) {
            vErrors = [err19];
          } else {
            vErrors.push(err19);
          }
          errors++;
        }
      } else {
        const err20 = { instancePath: instancePath + "/createdAt", schemaPath: "#/properties/createdAt/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err20];
        } else {
          vErrors.push(err20);
        }
        errors++;
      }
    }
    if (data.updatedAt !== void 0) {
      let data6 = data.updatedAt;
      if (typeof data6 === "string") {
        if (!pattern0.test(data6)) {
          const err21 = { instancePath: instancePath + "/updatedAt", schemaPath: "#/properties/updatedAt/pattern", keyword: "pattern", params: { pattern: "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, message: 'must match pattern "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"' };
          if (vErrors === null) {
            vErrors = [err21];
          } else {
            vErrors.push(err21);
          }
          errors++;
        }
        if (!formats0.validate(data6)) {
          const err22 = { instancePath: instancePath + "/updatedAt", schemaPath: "#/properties/updatedAt/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' };
          if (vErrors === null) {
            vErrors = [err22];
          } else {
            vErrors.push(err22);
          }
          errors++;
        }
      } else {
        const err23 = { instancePath: instancePath + "/updatedAt", schemaPath: "#/properties/updatedAt/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err23];
        } else {
          vErrors.push(err23);
        }
        errors++;
      }
    }
    if (data.runs !== void 0) {
      let data7 = data.runs;
      if (Array.isArray(data7)) {
        const len0 = data7.length;
        for (let i0 = 0; i0 < len0; i0++) {
          let data8 = data7[i0];
          if (data8 && typeof data8 == "object" && !Array.isArray(data8)) {
            if (data8.id === void 0) {
              const err24 = { instancePath: instancePath + "/runs/" + i0, schemaPath: "#/properties/runs/items/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property 'id'" };
              if (vErrors === null) {
                vErrors = [err24];
              } else {
                vErrors.push(err24);
              }
              errors++;
            }
            if (data8.object === void 0) {
              const err25 = { instancePath: instancePath + "/runs/" + i0, schemaPath: "#/properties/runs/items/required", keyword: "required", params: { missingProperty: "object" }, message: "must have required property 'object'" };
              if (vErrors === null) {
                vErrors = [err25];
              } else {
                vErrors.push(err25);
              }
              errors++;
            }
            if (data8.userId === void 0) {
              const err26 = { instancePath: instancePath + "/runs/" + i0, schemaPath: "#/properties/runs/items/required", keyword: "required", params: { missingProperty: "userId" }, message: "must have required property 'userId'" };
              if (vErrors === null) {
                vErrors = [err26];
              } else {
                vErrors.push(err26);
              }
              errors++;
            }
            if (data8.prompt === void 0) {
              const err27 = { instancePath: instancePath + "/runs/" + i0, schemaPath: "#/properties/runs/items/required", keyword: "required", params: { missingProperty: "prompt" }, message: "must have required property 'prompt'" };
              if (vErrors === null) {
                vErrors = [err27];
              } else {
                vErrors.push(err27);
              }
              errors++;
            }
            if (data8.status === void 0) {
              const err28 = { instancePath: instancePath + "/runs/" + i0, schemaPath: "#/properties/runs/items/required", keyword: "required", params: { missingProperty: "status" }, message: "must have required property 'status'" };
              if (vErrors === null) {
                vErrors = [err28];
              } else {
                vErrors.push(err28);
              }
              errors++;
            }
            if (data8.output === void 0) {
              const err29 = { instancePath: instancePath + "/runs/" + i0, schemaPath: "#/properties/runs/items/required", keyword: "required", params: { missingProperty: "output" }, message: "must have required property 'output'" };
              if (vErrors === null) {
                vErrors = [err29];
              } else {
                vErrors.push(err29);
              }
              errors++;
            }
            if (data8.error === void 0) {
              const err30 = { instancePath: instancePath + "/runs/" + i0, schemaPath: "#/properties/runs/items/required", keyword: "required", params: { missingProperty: "error" }, message: "must have required property 'error'" };
              if (vErrors === null) {
                vErrors = [err30];
              } else {
                vErrors.push(err30);
              }
              errors++;
            }
            if (data8.createdAt === void 0) {
              const err31 = { instancePath: instancePath + "/runs/" + i0, schemaPath: "#/properties/runs/items/required", keyword: "required", params: { missingProperty: "createdAt" }, message: "must have required property 'createdAt'" };
              if (vErrors === null) {
                vErrors = [err31];
              } else {
                vErrors.push(err31);
              }
              errors++;
            }
            if (data8.completedAt === void 0) {
              const err32 = { instancePath: instancePath + "/runs/" + i0, schemaPath: "#/properties/runs/items/required", keyword: "required", params: { missingProperty: "completedAt" }, message: "must have required property 'completedAt'" };
              if (vErrors === null) {
                vErrors = [err32];
              } else {
                vErrors.push(err32);
              }
              errors++;
            }
            if (data8.conversationId === void 0) {
              const err33 = { instancePath: instancePath + "/runs/" + i0, schemaPath: "#/properties/runs/items/required", keyword: "required", params: { missingProperty: "conversationId" }, message: "must have required property 'conversationId'" };
              if (vErrors === null) {
                vErrors = [err33];
              } else {
                vErrors.push(err33);
              }
              errors++;
            }
            if (data8.turnNumber === void 0) {
              const err34 = { instancePath: instancePath + "/runs/" + i0, schemaPath: "#/properties/runs/items/required", keyword: "required", params: { missingProperty: "turnNumber" }, message: "must have required property 'turnNumber'" };
              if (vErrors === null) {
                vErrors = [err34];
              } else {
                vErrors.push(err34);
              }
              errors++;
            }
            if (data8.historyBoundary === void 0) {
              const err35 = { instancePath: instancePath + "/runs/" + i0, schemaPath: "#/properties/runs/items/required", keyword: "required", params: { missingProperty: "historyBoundary" }, message: "must have required property 'historyBoundary'" };
              if (vErrors === null) {
                vErrors = [err35];
              } else {
                vErrors.push(err35);
              }
              errors++;
            }
            for (const key1 in data8) {
              if (!func6.call(schema16.properties.runs.items.properties, key1)) {
                const err36 = { instancePath: instancePath + "/runs/" + i0, schemaPath: "#/properties/runs/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
                if (vErrors === null) {
                  vErrors = [err36];
                } else {
                  vErrors.push(err36);
                }
                errors++;
              }
            }
            if (data8.id !== void 0) {
              if (typeof data8.id !== "string") {
                const err37 = { instancePath: instancePath + "/runs/" + i0 + "/id", schemaPath: "#/properties/runs/items/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err37];
                } else {
                  vErrors.push(err37);
                }
                errors++;
              }
            }
            if (data8.object !== void 0) {
              let data10 = data8.object;
              if (typeof data10 !== "string") {
                const err38 = { instancePath: instancePath + "/runs/" + i0 + "/object", schemaPath: "#/properties/runs/items/properties/object/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err38];
                } else {
                  vErrors.push(err38);
                }
                errors++;
              }
              if ("agent_run" !== data10) {
                const err39 = { instancePath: instancePath + "/runs/" + i0 + "/object", schemaPath: "#/properties/runs/items/properties/object/const", keyword: "const", params: { allowedValue: "agent_run" }, message: "must be equal to constant" };
                if (vErrors === null) {
                  vErrors = [err39];
                } else {
                  vErrors.push(err39);
                }
                errors++;
              }
            }
            if (data8.userId !== void 0) {
              if (typeof data8.userId !== "string") {
                const err40 = { instancePath: instancePath + "/runs/" + i0 + "/userId", schemaPath: "#/properties/runs/items/properties/userId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err40];
                } else {
                  vErrors.push(err40);
                }
                errors++;
              }
            }
            if (data8.prompt !== void 0) {
              if (typeof data8.prompt !== "string") {
                const err41 = { instancePath: instancePath + "/runs/" + i0 + "/prompt", schemaPath: "#/properties/runs/items/properties/prompt/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err41];
                } else {
                  vErrors.push(err41);
                }
                errors++;
              }
            }
            if (data8.status !== void 0) {
              let data13 = data8.status;
              if (typeof data13 !== "string") {
                const err42 = { instancePath: instancePath + "/runs/" + i0 + "/status", schemaPath: "#/properties/runs/items/properties/status/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err42];
                } else {
                  vErrors.push(err42);
                }
                errors++;
              }
              if (!(data13 === "queued" || data13 === "running" || data13 === "completed" || data13 === "failed" || data13 === "cancelled")) {
                const err43 = { instancePath: instancePath + "/runs/" + i0 + "/status", schemaPath: "#/properties/runs/items/properties/status/enum", keyword: "enum", params: { allowedValues: schema16.properties.runs.items.properties.status.enum }, message: "must be equal to one of the allowed values" };
                if (vErrors === null) {
                  vErrors = [err43];
                } else {
                  vErrors.push(err43);
                }
                errors++;
              }
            }
            if (data8.output !== void 0) {
              let data14 = data8.output;
              const _errs32 = errors;
              let valid4 = false;
              const _errs33 = errors;
              if (typeof data14 !== "string") {
                const err44 = { instancePath: instancePath + "/runs/" + i0 + "/output", schemaPath: "#/properties/runs/items/properties/output/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err44];
                } else {
                  vErrors.push(err44);
                }
                errors++;
              }
              var _valid0 = _errs33 === errors;
              valid4 = valid4 || _valid0;
              if (!valid4) {
                const _errs35 = errors;
                if (data14 !== null) {
                  const err45 = { instancePath: instancePath + "/runs/" + i0 + "/output", schemaPath: "#/properties/runs/items/properties/output/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                  if (vErrors === null) {
                    vErrors = [err45];
                  } else {
                    vErrors.push(err45);
                  }
                  errors++;
                }
                var _valid0 = _errs35 === errors;
                valid4 = valid4 || _valid0;
              }
              if (!valid4) {
                const err46 = { instancePath: instancePath + "/runs/" + i0 + "/output", schemaPath: "#/properties/runs/items/properties/output/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                if (vErrors === null) {
                  vErrors = [err46];
                } else {
                  vErrors.push(err46);
                }
                errors++;
              } else {
                errors = _errs32;
                if (vErrors !== null) {
                  if (_errs32) {
                    vErrors.length = _errs32;
                  } else {
                    vErrors = null;
                  }
                }
              }
            }
            if (data8.error !== void 0) {
              let data15 = data8.error;
              const _errs38 = errors;
              let valid5 = false;
              const _errs39 = errors;
              if (typeof data15 !== "string") {
                const err47 = { instancePath: instancePath + "/runs/" + i0 + "/error", schemaPath: "#/properties/runs/items/properties/error/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err47];
                } else {
                  vErrors.push(err47);
                }
                errors++;
              }
              var _valid1 = _errs39 === errors;
              valid5 = valid5 || _valid1;
              if (!valid5) {
                const _errs41 = errors;
                if (data15 !== null) {
                  const err48 = { instancePath: instancePath + "/runs/" + i0 + "/error", schemaPath: "#/properties/runs/items/properties/error/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                  if (vErrors === null) {
                    vErrors = [err48];
                  } else {
                    vErrors.push(err48);
                  }
                  errors++;
                }
                var _valid1 = _errs41 === errors;
                valid5 = valid5 || _valid1;
              }
              if (!valid5) {
                const err49 = { instancePath: instancePath + "/runs/" + i0 + "/error", schemaPath: "#/properties/runs/items/properties/error/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                if (vErrors === null) {
                  vErrors = [err49];
                } else {
                  vErrors.push(err49);
                }
                errors++;
              } else {
                errors = _errs38;
                if (vErrors !== null) {
                  if (_errs38) {
                    vErrors.length = _errs38;
                  } else {
                    vErrors = null;
                  }
                }
              }
            }
            if (data8.createdAt !== void 0) {
              let data16 = data8.createdAt;
              if (typeof data16 === "string") {
                if (!pattern0.test(data16)) {
                  const err50 = { instancePath: instancePath + "/runs/" + i0 + "/createdAt", schemaPath: "#/properties/runs/items/properties/createdAt/pattern", keyword: "pattern", params: { pattern: "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, message: 'must match pattern "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"' };
                  if (vErrors === null) {
                    vErrors = [err50];
                  } else {
                    vErrors.push(err50);
                  }
                  errors++;
                }
                if (!formats0.validate(data16)) {
                  const err51 = { instancePath: instancePath + "/runs/" + i0 + "/createdAt", schemaPath: "#/properties/runs/items/properties/createdAt/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' };
                  if (vErrors === null) {
                    vErrors = [err51];
                  } else {
                    vErrors.push(err51);
                  }
                  errors++;
                }
              } else {
                const err52 = { instancePath: instancePath + "/runs/" + i0 + "/createdAt", schemaPath: "#/properties/runs/items/properties/createdAt/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err52];
                } else {
                  vErrors.push(err52);
                }
                errors++;
              }
            }
            if (data8.completedAt !== void 0) {
              let data17 = data8.completedAt;
              const _errs46 = errors;
              let valid6 = false;
              const _errs47 = errors;
              if (typeof data17 === "string") {
                if (!pattern0.test(data17)) {
                  const err53 = { instancePath: instancePath + "/runs/" + i0 + "/completedAt", schemaPath: "#/properties/runs/items/properties/completedAt/anyOf/0/pattern", keyword: "pattern", params: { pattern: "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, message: 'must match pattern "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"' };
                  if (vErrors === null) {
                    vErrors = [err53];
                  } else {
                    vErrors.push(err53);
                  }
                  errors++;
                }
                if (!formats0.validate(data17)) {
                  const err54 = { instancePath: instancePath + "/runs/" + i0 + "/completedAt", schemaPath: "#/properties/runs/items/properties/completedAt/anyOf/0/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' };
                  if (vErrors === null) {
                    vErrors = [err54];
                  } else {
                    vErrors.push(err54);
                  }
                  errors++;
                }
              } else {
                const err55 = { instancePath: instancePath + "/runs/" + i0 + "/completedAt", schemaPath: "#/properties/runs/items/properties/completedAt/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err55];
                } else {
                  vErrors.push(err55);
                }
                errors++;
              }
              var _valid2 = _errs47 === errors;
              valid6 = valid6 || _valid2;
              if (!valid6) {
                const _errs49 = errors;
                if (data17 !== null) {
                  const err56 = { instancePath: instancePath + "/runs/" + i0 + "/completedAt", schemaPath: "#/properties/runs/items/properties/completedAt/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                  if (vErrors === null) {
                    vErrors = [err56];
                  } else {
                    vErrors.push(err56);
                  }
                  errors++;
                }
                var _valid2 = _errs49 === errors;
                valid6 = valid6 || _valid2;
              }
              if (!valid6) {
                const err57 = { instancePath: instancePath + "/runs/" + i0 + "/completedAt", schemaPath: "#/properties/runs/items/properties/completedAt/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                if (vErrors === null) {
                  vErrors = [err57];
                } else {
                  vErrors.push(err57);
                }
                errors++;
              } else {
                errors = _errs46;
                if (vErrors !== null) {
                  if (_errs46) {
                    vErrors.length = _errs46;
                  } else {
                    vErrors = null;
                  }
                }
              }
            }
            if (data8.conversationId !== void 0) {
              let data18 = data8.conversationId;
              const _errs52 = errors;
              let valid7 = false;
              const _errs53 = errors;
              if (typeof data18 !== "string") {
                const err58 = { instancePath: instancePath + "/runs/" + i0 + "/conversationId", schemaPath: "#/properties/runs/items/properties/conversationId/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err58];
                } else {
                  vErrors.push(err58);
                }
                errors++;
              }
              var _valid3 = _errs53 === errors;
              valid7 = valid7 || _valid3;
              if (!valid7) {
                const _errs55 = errors;
                if (data18 !== null) {
                  const err59 = { instancePath: instancePath + "/runs/" + i0 + "/conversationId", schemaPath: "#/properties/runs/items/properties/conversationId/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                  if (vErrors === null) {
                    vErrors = [err59];
                  } else {
                    vErrors.push(err59);
                  }
                  errors++;
                }
                var _valid3 = _errs55 === errors;
                valid7 = valid7 || _valid3;
              }
              if (!valid7) {
                const err60 = { instancePath: instancePath + "/runs/" + i0 + "/conversationId", schemaPath: "#/properties/runs/items/properties/conversationId/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                if (vErrors === null) {
                  vErrors = [err60];
                } else {
                  vErrors.push(err60);
                }
                errors++;
              } else {
                errors = _errs52;
                if (vErrors !== null) {
                  if (_errs52) {
                    vErrors.length = _errs52;
                  } else {
                    vErrors = null;
                  }
                }
              }
            }
            if (data8.turnNumber !== void 0) {
              let data19 = data8.turnNumber;
              const _errs58 = errors;
              let valid8 = false;
              const _errs59 = errors;
              if (!(typeof data19 == "number" && (!(data19 % 1) && !isNaN(data19)) && isFinite(data19))) {
                const err61 = { instancePath: instancePath + "/runs/" + i0 + "/turnNumber", schemaPath: "#/properties/runs/items/properties/turnNumber/anyOf/0/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                if (vErrors === null) {
                  vErrors = [err61];
                } else {
                  vErrors.push(err61);
                }
                errors++;
              }
              if (typeof data19 == "number" && isFinite(data19)) {
                if (data19 > 9007199254740991 || isNaN(data19)) {
                  const err62 = { instancePath: instancePath + "/runs/" + i0 + "/turnNumber", schemaPath: "#/properties/runs/items/properties/turnNumber/anyOf/0/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err62];
                  } else {
                    vErrors.push(err62);
                  }
                  errors++;
                }
                if (data19 < -9007199254740991 || isNaN(data19)) {
                  const err63 = { instancePath: instancePath + "/runs/" + i0 + "/turnNumber", schemaPath: "#/properties/runs/items/properties/turnNumber/anyOf/0/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err63];
                  } else {
                    vErrors.push(err63);
                  }
                  errors++;
                }
              }
              var _valid4 = _errs59 === errors;
              valid8 = valid8 || _valid4;
              if (!valid8) {
                const _errs61 = errors;
                if (data19 !== null) {
                  const err64 = { instancePath: instancePath + "/runs/" + i0 + "/turnNumber", schemaPath: "#/properties/runs/items/properties/turnNumber/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                  if (vErrors === null) {
                    vErrors = [err64];
                  } else {
                    vErrors.push(err64);
                  }
                  errors++;
                }
                var _valid4 = _errs61 === errors;
                valid8 = valid8 || _valid4;
              }
              if (!valid8) {
                const err65 = { instancePath: instancePath + "/runs/" + i0 + "/turnNumber", schemaPath: "#/properties/runs/items/properties/turnNumber/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                if (vErrors === null) {
                  vErrors = [err65];
                } else {
                  vErrors.push(err65);
                }
                errors++;
              } else {
                errors = _errs58;
                if (vErrors !== null) {
                  if (_errs58) {
                    vErrors.length = _errs58;
                  } else {
                    vErrors = null;
                  }
                }
              }
            }
            if (data8.historyBoundary !== void 0) {
              let data20 = data8.historyBoundary;
              const _errs64 = errors;
              let valid9 = false;
              const _errs65 = errors;
              if (!(typeof data20 == "number" && (!(data20 % 1) && !isNaN(data20)) && isFinite(data20))) {
                const err66 = { instancePath: instancePath + "/runs/" + i0 + "/historyBoundary", schemaPath: "#/properties/runs/items/properties/historyBoundary/anyOf/0/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                if (vErrors === null) {
                  vErrors = [err66];
                } else {
                  vErrors.push(err66);
                }
                errors++;
              }
              if (typeof data20 == "number" && isFinite(data20)) {
                if (data20 > 9007199254740991 || isNaN(data20)) {
                  const err67 = { instancePath: instancePath + "/runs/" + i0 + "/historyBoundary", schemaPath: "#/properties/runs/items/properties/historyBoundary/anyOf/0/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err67];
                  } else {
                    vErrors.push(err67);
                  }
                  errors++;
                }
                if (data20 < -9007199254740991 || isNaN(data20)) {
                  const err68 = { instancePath: instancePath + "/runs/" + i0 + "/historyBoundary", schemaPath: "#/properties/runs/items/properties/historyBoundary/anyOf/0/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err68];
                  } else {
                    vErrors.push(err68);
                  }
                  errors++;
                }
              }
              var _valid5 = _errs65 === errors;
              valid9 = valid9 || _valid5;
              if (!valid9) {
                const _errs67 = errors;
                if (data20 !== null) {
                  const err69 = { instancePath: instancePath + "/runs/" + i0 + "/historyBoundary", schemaPath: "#/properties/runs/items/properties/historyBoundary/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                  if (vErrors === null) {
                    vErrors = [err69];
                  } else {
                    vErrors.push(err69);
                  }
                  errors++;
                }
                var _valid5 = _errs67 === errors;
                valid9 = valid9 || _valid5;
              }
              if (!valid9) {
                const err70 = { instancePath: instancePath + "/runs/" + i0 + "/historyBoundary", schemaPath: "#/properties/runs/items/properties/historyBoundary/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                if (vErrors === null) {
                  vErrors = [err70];
                } else {
                  vErrors.push(err70);
                }
                errors++;
              } else {
                errors = _errs64;
                if (vErrors !== null) {
                  if (_errs64) {
                    vErrors.length = _errs64;
                  } else {
                    vErrors = null;
                  }
                }
              }
            }
          } else {
            const err71 = { instancePath: instancePath + "/runs/" + i0, schemaPath: "#/properties/runs/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
              vErrors = [err71];
            } else {
              vErrors.push(err71);
            }
            errors++;
          }
        }
      } else {
        const err72 = { instancePath: instancePath + "/runs", schemaPath: "#/properties/runs/type", keyword: "type", params: { type: "array" }, message: "must be array" };
        if (vErrors === null) {
          vErrors = [err72];
        } else {
          vErrors.push(err72);
        }
        errors++;
      }
    }
    if (data.messages !== void 0) {
      let data21 = data.messages;
      if (Array.isArray(data21)) {
        const len1 = data21.length;
        for (let i1 = 0; i1 < len1; i1++) {
          let data22 = data21[i1];
          if (data22 && typeof data22 == "object" && !Array.isArray(data22)) {
            if (data22.runId === void 0) {
              const err73 = { instancePath: instancePath + "/messages/" + i1, schemaPath: "#/properties/messages/items/required", keyword: "required", params: { missingProperty: "runId" }, message: "must have required property 'runId'" };
              if (vErrors === null) {
                vErrors = [err73];
              } else {
                vErrors.push(err73);
              }
              errors++;
            }
            if (data22.messageIndex === void 0) {
              const err74 = { instancePath: instancePath + "/messages/" + i1, schemaPath: "#/properties/messages/items/required", keyword: "required", params: { missingProperty: "messageIndex" }, message: "must have required property 'messageIndex'" };
              if (vErrors === null) {
                vErrors = [err74];
              } else {
                vErrors.push(err74);
              }
              errors++;
            }
            if (data22.payload === void 0) {
              const err75 = { instancePath: instancePath + "/messages/" + i1, schemaPath: "#/properties/messages/items/required", keyword: "required", params: { missingProperty: "payload" }, message: "must have required property 'payload'" };
              if (vErrors === null) {
                vErrors = [err75];
              } else {
                vErrors.push(err75);
              }
              errors++;
            }
            for (const key2 in data22) {
              if (!(key2 === "runId" || key2 === "messageIndex" || key2 === "payload")) {
                const err76 = { instancePath: instancePath + "/messages/" + i1, schemaPath: "#/properties/messages/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key2 }, message: "must NOT have additional properties" };
                if (vErrors === null) {
                  vErrors = [err76];
                } else {
                  vErrors.push(err76);
                }
                errors++;
              }
            }
            if (data22.runId !== void 0) {
              if (typeof data22.runId !== "string") {
                const err77 = { instancePath: instancePath + "/messages/" + i1 + "/runId", schemaPath: "#/properties/messages/items/properties/runId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err77];
                } else {
                  vErrors.push(err77);
                }
                errors++;
              }
            }
            if (data22.messageIndex !== void 0) {
              let data24 = data22.messageIndex;
              if (!(typeof data24 == "number" && (!(data24 % 1) && !isNaN(data24)) && isFinite(data24))) {
                const err78 = { instancePath: instancePath + "/messages/" + i1 + "/messageIndex", schemaPath: "#/properties/messages/items/properties/messageIndex/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                if (vErrors === null) {
                  vErrors = [err78];
                } else {
                  vErrors.push(err78);
                }
                errors++;
              }
              if (typeof data24 == "number" && isFinite(data24)) {
                if (data24 > 9007199254740991 || isNaN(data24)) {
                  const err79 = { instancePath: instancePath + "/messages/" + i1 + "/messageIndex", schemaPath: "#/properties/messages/items/properties/messageIndex/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err79];
                  } else {
                    vErrors.push(err79);
                  }
                  errors++;
                }
                if (data24 < -9007199254740991 || isNaN(data24)) {
                  const err80 = { instancePath: instancePath + "/messages/" + i1 + "/messageIndex", schemaPath: "#/properties/messages/items/properties/messageIndex/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err80];
                  } else {
                    vErrors.push(err80);
                  }
                  errors++;
                }
              }
            }
            if (data22.payload !== void 0) {
              let data25 = data22.payload;
              const _errs79 = errors;
              let valid13 = false;
              let passing0 = null;
              const _errs80 = errors;
              if (data25 && typeof data25 == "object" && !Array.isArray(data25)) {
                if (data25.role === void 0) {
                  const err81 = { instancePath: instancePath + "/messages/" + i1 + "/payload", schemaPath: "#/properties/messages/items/properties/payload/oneOf/0/required", keyword: "required", params: { missingProperty: "role" }, message: "must have required property 'role'" };
                  if (vErrors === null) {
                    vErrors = [err81];
                  } else {
                    vErrors.push(err81);
                  }
                  errors++;
                }
                if (data25.content === void 0) {
                  const err82 = { instancePath: instancePath + "/messages/" + i1 + "/payload", schemaPath: "#/properties/messages/items/properties/payload/oneOf/0/required", keyword: "required", params: { missingProperty: "content" }, message: "must have required property 'content'" };
                  if (vErrors === null) {
                    vErrors = [err82];
                  } else {
                    vErrors.push(err82);
                  }
                  errors++;
                }
                for (const key3 in data25) {
                  if (!(key3 === "role" || key3 === "content")) {
                    const err83 = { instancePath: instancePath + "/messages/" + i1 + "/payload", schemaPath: "#/properties/messages/items/properties/payload/oneOf/0/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key3 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                      vErrors = [err83];
                    } else {
                      vErrors.push(err83);
                    }
                    errors++;
                  }
                }
                if (data25.role !== void 0) {
                  let data26 = data25.role;
                  if (typeof data26 !== "string") {
                    const err84 = { instancePath: instancePath + "/messages/" + i1 + "/payload/role", schemaPath: "#/properties/messages/items/properties/payload/oneOf/0/properties/role/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err84];
                    } else {
                      vErrors.push(err84);
                    }
                    errors++;
                  }
                  if ("user" !== data26) {
                    const err85 = { instancePath: instancePath + "/messages/" + i1 + "/payload/role", schemaPath: "#/properties/messages/items/properties/payload/oneOf/0/properties/role/const", keyword: "const", params: { allowedValue: "user" }, message: "must be equal to constant" };
                    if (vErrors === null) {
                      vErrors = [err85];
                    } else {
                      vErrors.push(err85);
                    }
                    errors++;
                  }
                }
                if (data25.content !== void 0) {
                  if (typeof data25.content !== "string") {
                    const err86 = { instancePath: instancePath + "/messages/" + i1 + "/payload/content", schemaPath: "#/properties/messages/items/properties/payload/oneOf/0/properties/content/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err86];
                    } else {
                      vErrors.push(err86);
                    }
                    errors++;
                  }
                }
              } else {
                const err87 = { instancePath: instancePath + "/messages/" + i1 + "/payload", schemaPath: "#/properties/messages/items/properties/payload/oneOf/0/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                if (vErrors === null) {
                  vErrors = [err87];
                } else {
                  vErrors.push(err87);
                }
                errors++;
              }
              var _valid6 = _errs80 === errors;
              if (_valid6) {
                valid13 = true;
                passing0 = 0;
              }
              const _errs87 = errors;
              if (data25 && typeof data25 == "object" && !Array.isArray(data25)) {
                if (data25.role === void 0) {
                  const err88 = { instancePath: instancePath + "/messages/" + i1 + "/payload", schemaPath: "#/properties/messages/items/properties/payload/oneOf/1/required", keyword: "required", params: { missingProperty: "role" }, message: "must have required property 'role'" };
                  if (vErrors === null) {
                    vErrors = [err88];
                  } else {
                    vErrors.push(err88);
                  }
                  errors++;
                }
                if (data25.content === void 0) {
                  const err89 = { instancePath: instancePath + "/messages/" + i1 + "/payload", schemaPath: "#/properties/messages/items/properties/payload/oneOf/1/required", keyword: "required", params: { missingProperty: "content" }, message: "must have required property 'content'" };
                  if (vErrors === null) {
                    vErrors = [err89];
                  } else {
                    vErrors.push(err89);
                  }
                  errors++;
                }
                if (data25.toolCalls === void 0) {
                  const err90 = { instancePath: instancePath + "/messages/" + i1 + "/payload", schemaPath: "#/properties/messages/items/properties/payload/oneOf/1/required", keyword: "required", params: { missingProperty: "toolCalls" }, message: "must have required property 'toolCalls'" };
                  if (vErrors === null) {
                    vErrors = [err90];
                  } else {
                    vErrors.push(err90);
                  }
                  errors++;
                }
                for (const key4 in data25) {
                  if (!(key4 === "role" || key4 === "content" || key4 === "toolCalls")) {
                    const err91 = { instancePath: instancePath + "/messages/" + i1 + "/payload", schemaPath: "#/properties/messages/items/properties/payload/oneOf/1/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key4 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                      vErrors = [err91];
                    } else {
                      vErrors.push(err91);
                    }
                    errors++;
                  }
                }
                if (data25.role !== void 0) {
                  let data28 = data25.role;
                  if (typeof data28 !== "string") {
                    const err92 = { instancePath: instancePath + "/messages/" + i1 + "/payload/role", schemaPath: "#/properties/messages/items/properties/payload/oneOf/1/properties/role/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err92];
                    } else {
                      vErrors.push(err92);
                    }
                    errors++;
                  }
                  if ("assistant" !== data28) {
                    const err93 = { instancePath: instancePath + "/messages/" + i1 + "/payload/role", schemaPath: "#/properties/messages/items/properties/payload/oneOf/1/properties/role/const", keyword: "const", params: { allowedValue: "assistant" }, message: "must be equal to constant" };
                    if (vErrors === null) {
                      vErrors = [err93];
                    } else {
                      vErrors.push(err93);
                    }
                    errors++;
                  }
                }
                if (data25.content !== void 0) {
                  if (typeof data25.content !== "string") {
                    const err94 = { instancePath: instancePath + "/messages/" + i1 + "/payload/content", schemaPath: "#/properties/messages/items/properties/payload/oneOf/1/properties/content/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err94];
                    } else {
                      vErrors.push(err94);
                    }
                    errors++;
                  }
                }
                if (data25.toolCalls !== void 0) {
                  let data30 = data25.toolCalls;
                  if (Array.isArray(data30)) {
                    const len2 = data30.length;
                    for (let i2 = 0; i2 < len2; i2++) {
                      let data31 = data30[i2];
                      if (data31 && typeof data31 == "object" && !Array.isArray(data31)) {
                        if (data31.id === void 0) {
                          const err95 = { instancePath: instancePath + "/messages/" + i1 + "/payload/toolCalls/" + i2, schemaPath: "#/properties/messages/items/properties/payload/oneOf/1/properties/toolCalls/items/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property 'id'" };
                          if (vErrors === null) {
                            vErrors = [err95];
                          } else {
                            vErrors.push(err95);
                          }
                          errors++;
                        }
                        if (data31.thought === void 0) {
                          const err96 = { instancePath: instancePath + "/messages/" + i1 + "/payload/toolCalls/" + i2, schemaPath: "#/properties/messages/items/properties/payload/oneOf/1/properties/toolCalls/items/required", keyword: "required", params: { missingProperty: "thought" }, message: "must have required property 'thought'" };
                          if (vErrors === null) {
                            vErrors = [err96];
                          } else {
                            vErrors.push(err96);
                          }
                          errors++;
                        }
                        if (data31.source === void 0) {
                          const err97 = { instancePath: instancePath + "/messages/" + i1 + "/payload/toolCalls/" + i2, schemaPath: "#/properties/messages/items/properties/payload/oneOf/1/properties/toolCalls/items/required", keyword: "required", params: { missingProperty: "source" }, message: "must have required property 'source'" };
                          if (vErrors === null) {
                            vErrors = [err97];
                          } else {
                            vErrors.push(err97);
                          }
                          errors++;
                        }
                        for (const key5 in data31) {
                          if (!(key5 === "id" || key5 === "thought" || key5 === "source")) {
                            const err98 = { instancePath: instancePath + "/messages/" + i1 + "/payload/toolCalls/" + i2, schemaPath: "#/properties/messages/items/properties/payload/oneOf/1/properties/toolCalls/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key5 }, message: "must NOT have additional properties" };
                            if (vErrors === null) {
                              vErrors = [err98];
                            } else {
                              vErrors.push(err98);
                            }
                            errors++;
                          }
                        }
                        if (data31.id !== void 0) {
                          if (typeof data31.id !== "string") {
                            const err99 = { instancePath: instancePath + "/messages/" + i1 + "/payload/toolCalls/" + i2 + "/id", schemaPath: "#/properties/messages/items/properties/payload/oneOf/1/properties/toolCalls/items/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err99];
                            } else {
                              vErrors.push(err99);
                            }
                            errors++;
                          }
                        }
                        if (data31.thought !== void 0) {
                          if (typeof data31.thought !== "string") {
                            const err100 = { instancePath: instancePath + "/messages/" + i1 + "/payload/toolCalls/" + i2 + "/thought", schemaPath: "#/properties/messages/items/properties/payload/oneOf/1/properties/toolCalls/items/properties/thought/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err100];
                            } else {
                              vErrors.push(err100);
                            }
                            errors++;
                          }
                        }
                        if (data31.source !== void 0) {
                          if (typeof data31.source !== "string") {
                            const err101 = { instancePath: instancePath + "/messages/" + i1 + "/payload/toolCalls/" + i2 + "/source", schemaPath: "#/properties/messages/items/properties/payload/oneOf/1/properties/toolCalls/items/properties/source/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err101];
                            } else {
                              vErrors.push(err101);
                            }
                            errors++;
                          }
                        }
                      } else {
                        const err102 = { instancePath: instancePath + "/messages/" + i1 + "/payload/toolCalls/" + i2, schemaPath: "#/properties/messages/items/properties/payload/oneOf/1/properties/toolCalls/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                        if (vErrors === null) {
                          vErrors = [err102];
                        } else {
                          vErrors.push(err102);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err103 = { instancePath: instancePath + "/messages/" + i1 + "/payload/toolCalls", schemaPath: "#/properties/messages/items/properties/payload/oneOf/1/properties/toolCalls/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                      vErrors = [err103];
                    } else {
                      vErrors.push(err103);
                    }
                    errors++;
                  }
                }
              } else {
                const err104 = { instancePath: instancePath + "/messages/" + i1 + "/payload", schemaPath: "#/properties/messages/items/properties/payload/oneOf/1/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                if (vErrors === null) {
                  vErrors = [err104];
                } else {
                  vErrors.push(err104);
                }
                errors++;
              }
              var _valid6 = _errs87 === errors;
              if (_valid6 && valid13) {
                valid13 = false;
                passing0 = [passing0, 1];
              } else {
                if (_valid6) {
                  valid13 = true;
                  passing0 = 1;
                }
                const _errs105 = errors;
                if (data25 && typeof data25 == "object" && !Array.isArray(data25)) {
                  if (data25.role === void 0) {
                    const err105 = { instancePath: instancePath + "/messages/" + i1 + "/payload", schemaPath: "#/properties/messages/items/properties/payload/oneOf/2/required", keyword: "required", params: { missingProperty: "role" }, message: "must have required property 'role'" };
                    if (vErrors === null) {
                      vErrors = [err105];
                    } else {
                      vErrors.push(err105);
                    }
                    errors++;
                  }
                  if (data25.toolCallId === void 0) {
                    const err106 = { instancePath: instancePath + "/messages/" + i1 + "/payload", schemaPath: "#/properties/messages/items/properties/payload/oneOf/2/required", keyword: "required", params: { missingProperty: "toolCallId" }, message: "must have required property 'toolCallId'" };
                    if (vErrors === null) {
                      vErrors = [err106];
                    } else {
                      vErrors.push(err106);
                    }
                    errors++;
                  }
                  if (data25.content === void 0) {
                    const err107 = { instancePath: instancePath + "/messages/" + i1 + "/payload", schemaPath: "#/properties/messages/items/properties/payload/oneOf/2/required", keyword: "required", params: { missingProperty: "content" }, message: "must have required property 'content'" };
                    if (vErrors === null) {
                      vErrors = [err107];
                    } else {
                      vErrors.push(err107);
                    }
                    errors++;
                  }
                  for (const key6 in data25) {
                    if (!(key6 === "role" || key6 === "toolCallId" || key6 === "content" || key6 === "isError" || key6 === "resources")) {
                      const err108 = { instancePath: instancePath + "/messages/" + i1 + "/payload", schemaPath: "#/properties/messages/items/properties/payload/oneOf/2/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key6 }, message: "must NOT have additional properties" };
                      if (vErrors === null) {
                        vErrors = [err108];
                      } else {
                        vErrors.push(err108);
                      }
                      errors++;
                    }
                  }
                  if (data25.role !== void 0) {
                    let data35 = data25.role;
                    if (typeof data35 !== "string") {
                      const err109 = { instancePath: instancePath + "/messages/" + i1 + "/payload/role", schemaPath: "#/properties/messages/items/properties/payload/oneOf/2/properties/role/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                      if (vErrors === null) {
                        vErrors = [err109];
                      } else {
                        vErrors.push(err109);
                      }
                      errors++;
                    }
                    if ("tool" !== data35) {
                      const err110 = { instancePath: instancePath + "/messages/" + i1 + "/payload/role", schemaPath: "#/properties/messages/items/properties/payload/oneOf/2/properties/role/const", keyword: "const", params: { allowedValue: "tool" }, message: "must be equal to constant" };
                      if (vErrors === null) {
                        vErrors = [err110];
                      } else {
                        vErrors.push(err110);
                      }
                      errors++;
                    }
                  }
                  if (data25.toolCallId !== void 0) {
                    if (typeof data25.toolCallId !== "string") {
                      const err111 = { instancePath: instancePath + "/messages/" + i1 + "/payload/toolCallId", schemaPath: "#/properties/messages/items/properties/payload/oneOf/2/properties/toolCallId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                      if (vErrors === null) {
                        vErrors = [err111];
                      } else {
                        vErrors.push(err111);
                      }
                      errors++;
                    }
                  }
                  if (data25.content !== void 0) {
                    if (typeof data25.content !== "string") {
                      const err112 = { instancePath: instancePath + "/messages/" + i1 + "/payload/content", schemaPath: "#/properties/messages/items/properties/payload/oneOf/2/properties/content/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                      if (vErrors === null) {
                        vErrors = [err112];
                      } else {
                        vErrors.push(err112);
                      }
                      errors++;
                    }
                  }
                  if (data25.isError !== void 0) {
                    if (typeof data25.isError !== "boolean") {
                      const err113 = { instancePath: instancePath + "/messages/" + i1 + "/payload/isError", schemaPath: "#/properties/messages/items/properties/payload/oneOf/2/properties/isError/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                      if (vErrors === null) {
                        vErrors = [err113];
                      } else {
                        vErrors.push(err113);
                      }
                      errors++;
                    }
                  }
                  if (data25.resources !== void 0) {
                    let data39 = data25.resources;
                    if (Array.isArray(data39)) {
                      const len3 = data39.length;
                      for (let i3 = 0; i3 < len3; i3++) {
                        let data40 = data39[i3];
                        if (data40 && typeof data40 == "object" && !Array.isArray(data40)) {
                          if (data40.path === void 0) {
                            const err114 = { instancePath: instancePath + "/messages/" + i1 + "/payload/resources/" + i3, schemaPath: "#/properties/messages/items/properties/payload/oneOf/2/properties/resources/items/required", keyword: "required", params: { missingProperty: "path" }, message: "must have required property 'path'" };
                            if (vErrors === null) {
                              vErrors = [err114];
                            } else {
                              vErrors.push(err114);
                            }
                            errors++;
                          }
                          for (const key7 in data40) {
                            if (!(key7 === "path" || key7 === "pattern" || key7 === "title")) {
                              const err115 = { instancePath: instancePath + "/messages/" + i1 + "/payload/resources/" + i3, schemaPath: "#/properties/messages/items/properties/payload/oneOf/2/properties/resources/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key7 }, message: "must NOT have additional properties" };
                              if (vErrors === null) {
                                vErrors = [err115];
                              } else {
                                vErrors.push(err115);
                              }
                              errors++;
                            }
                          }
                          if (data40.path !== void 0) {
                            if (typeof data40.path !== "string") {
                              const err116 = { instancePath: instancePath + "/messages/" + i1 + "/payload/resources/" + i3 + "/path", schemaPath: "#/properties/messages/items/properties/payload/oneOf/2/properties/resources/items/properties/path/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                              if (vErrors === null) {
                                vErrors = [err116];
                              } else {
                                vErrors.push(err116);
                              }
                              errors++;
                            }
                          }
                          if (data40.pattern !== void 0) {
                            if (typeof data40.pattern !== "string") {
                              const err117 = { instancePath: instancePath + "/messages/" + i1 + "/payload/resources/" + i3 + "/pattern", schemaPath: "#/properties/messages/items/properties/payload/oneOf/2/properties/resources/items/properties/pattern/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                              if (vErrors === null) {
                                vErrors = [err117];
                              } else {
                                vErrors.push(err117);
                              }
                              errors++;
                            }
                          }
                          if (data40.title !== void 0) {
                            if (typeof data40.title !== "string") {
                              const err118 = { instancePath: instancePath + "/messages/" + i1 + "/payload/resources/" + i3 + "/title", schemaPath: "#/properties/messages/items/properties/payload/oneOf/2/properties/resources/items/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                              if (vErrors === null) {
                                vErrors = [err118];
                              } else {
                                vErrors.push(err118);
                              }
                              errors++;
                            }
                          }
                        } else {
                          const err119 = { instancePath: instancePath + "/messages/" + i1 + "/payload/resources/" + i3, schemaPath: "#/properties/messages/items/properties/payload/oneOf/2/properties/resources/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                          if (vErrors === null) {
                            vErrors = [err119];
                          } else {
                            vErrors.push(err119);
                          }
                          errors++;
                        }
                      }
                    } else {
                      const err120 = { instancePath: instancePath + "/messages/" + i1 + "/payload/resources", schemaPath: "#/properties/messages/items/properties/payload/oneOf/2/properties/resources/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                      if (vErrors === null) {
                        vErrors = [err120];
                      } else {
                        vErrors.push(err120);
                      }
                      errors++;
                    }
                  }
                } else {
                  const err121 = { instancePath: instancePath + "/messages/" + i1 + "/payload", schemaPath: "#/properties/messages/items/properties/payload/oneOf/2/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                  if (vErrors === null) {
                    vErrors = [err121];
                  } else {
                    vErrors.push(err121);
                  }
                  errors++;
                }
                var _valid6 = _errs105 === errors;
                if (_valid6 && valid13) {
                  valid13 = false;
                  passing0 = [passing0, 2];
                } else {
                  if (_valid6) {
                    valid13 = true;
                    passing0 = 2;
                  }
                }
              }
              if (!valid13) {
                const err122 = { instancePath: instancePath + "/messages/" + i1 + "/payload", schemaPath: "#/properties/messages/items/properties/payload/oneOf", keyword: "oneOf", params: { passingSchemas: passing0 }, message: "must match exactly one schema in oneOf" };
                if (vErrors === null) {
                  vErrors = [err122];
                } else {
                  vErrors.push(err122);
                }
                errors++;
              } else {
                errors = _errs79;
                if (vErrors !== null) {
                  if (_errs79) {
                    vErrors.length = _errs79;
                  } else {
                    vErrors = null;
                  }
                }
              }
            }
          } else {
            const err123 = { instancePath: instancePath + "/messages/" + i1, schemaPath: "#/properties/messages/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
              vErrors = [err123];
            } else {
              vErrors.push(err123);
            }
            errors++;
          }
        }
      } else {
        const err124 = { instancePath: instancePath + "/messages", schemaPath: "#/properties/messages/type", keyword: "type", params: { type: "array" }, message: "must be array" };
        if (vErrors === null) {
          vErrors = [err124];
        } else {
          vErrors.push(err124);
        }
        errors++;
      }
    }
    if (data.canContinue !== void 0) {
      if (typeof data.canContinue !== "boolean") {
        const err125 = { instancePath: instancePath + "/canContinue", schemaPath: "#/properties/canContinue/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
        if (vErrors === null) {
          vErrors = [err125];
        } else {
          vErrors.push(err125);
        }
        errors++;
      }
    }
    if (data.feedback !== void 0) {
      let data45 = data.feedback;
      if (Array.isArray(data45)) {
        const len4 = data45.length;
        for (let i4 = 0; i4 < len4; i4++) {
          let data46 = data45[i4];
          if (data46 && typeof data46 == "object" && !Array.isArray(data46)) {
            if (data46.object === void 0) {
              const err126 = { instancePath: instancePath + "/feedback/" + i4, schemaPath: "#/properties/feedback/items/required", keyword: "required", params: { missingProperty: "object" }, message: "must have required property 'object'" };
              if (vErrors === null) {
                vErrors = [err126];
              } else {
                vErrors.push(err126);
              }
              errors++;
            }
            if (data46.runId === void 0) {
              const err127 = { instancePath: instancePath + "/feedback/" + i4, schemaPath: "#/properties/feedback/items/required", keyword: "required", params: { missingProperty: "runId" }, message: "must have required property 'runId'" };
              if (vErrors === null) {
                vErrors = [err127];
              } else {
                vErrors.push(err127);
              }
              errors++;
            }
            if (data46.target === void 0) {
              const err128 = { instancePath: instancePath + "/feedback/" + i4, schemaPath: "#/properties/feedback/items/required", keyword: "required", params: { missingProperty: "target" }, message: "must have required property 'target'" };
              if (vErrors === null) {
                vErrors = [err128];
              } else {
                vErrors.push(err128);
              }
              errors++;
            }
            if (data46.rating === void 0) {
              const err129 = { instancePath: instancePath + "/feedback/" + i4, schemaPath: "#/properties/feedback/items/required", keyword: "required", params: { missingProperty: "rating" }, message: "must have required property 'rating'" };
              if (vErrors === null) {
                vErrors = [err129];
              } else {
                vErrors.push(err129);
              }
              errors++;
            }
            if (data46.note === void 0) {
              const err130 = { instancePath: instancePath + "/feedback/" + i4, schemaPath: "#/properties/feedback/items/required", keyword: "required", params: { missingProperty: "note" }, message: "must have required property 'note'" };
              if (vErrors === null) {
                vErrors = [err130];
              } else {
                vErrors.push(err130);
              }
              errors++;
            }
            if (data46.createdAt === void 0) {
              const err131 = { instancePath: instancePath + "/feedback/" + i4, schemaPath: "#/properties/feedback/items/required", keyword: "required", params: { missingProperty: "createdAt" }, message: "must have required property 'createdAt'" };
              if (vErrors === null) {
                vErrors = [err131];
              } else {
                vErrors.push(err131);
              }
              errors++;
            }
            for (const key8 in data46) {
              if (!(key8 === "object" || key8 === "runId" || key8 === "target" || key8 === "rating" || key8 === "note" || key8 === "createdAt")) {
                const err132 = { instancePath: instancePath + "/feedback/" + i4, schemaPath: "#/properties/feedback/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key8 }, message: "must NOT have additional properties" };
                if (vErrors === null) {
                  vErrors = [err132];
                } else {
                  vErrors.push(err132);
                }
                errors++;
              }
            }
            if (data46.object !== void 0) {
              let data47 = data46.object;
              if (typeof data47 !== "string") {
                const err133 = { instancePath: instancePath + "/feedback/" + i4 + "/object", schemaPath: "#/properties/feedback/items/properties/object/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err133];
                } else {
                  vErrors.push(err133);
                }
                errors++;
              }
              if ("feedback" !== data47) {
                const err134 = { instancePath: instancePath + "/feedback/" + i4 + "/object", schemaPath: "#/properties/feedback/items/properties/object/const", keyword: "const", params: { allowedValue: "feedback" }, message: "must be equal to constant" };
                if (vErrors === null) {
                  vErrors = [err134];
                } else {
                  vErrors.push(err134);
                }
                errors++;
              }
            }
            if (data46.runId !== void 0) {
              if (typeof data46.runId !== "string") {
                const err135 = { instancePath: instancePath + "/feedback/" + i4 + "/runId", schemaPath: "#/properties/feedback/items/properties/runId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err135];
                } else {
                  vErrors.push(err135);
                }
                errors++;
              }
            }
            if (data46.target !== void 0) {
              let data49 = data46.target;
              if (typeof data49 !== "string") {
                const err136 = { instancePath: instancePath + "/feedback/" + i4 + "/target", schemaPath: "#/properties/feedback/items/properties/target/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err136];
                } else {
                  vErrors.push(err136);
                }
                errors++;
              }
              if (!(data49 === "reply" || data49 === "case")) {
                const err137 = { instancePath: instancePath + "/feedback/" + i4 + "/target", schemaPath: "#/properties/feedback/items/properties/target/enum", keyword: "enum", params: { allowedValues: schema16.properties.feedback.items.properties.target.enum }, message: "must be equal to one of the allowed values" };
                if (vErrors === null) {
                  vErrors = [err137];
                } else {
                  vErrors.push(err137);
                }
                errors++;
              }
            }
            if (data46.rating !== void 0) {
              let data50 = data46.rating;
              if (typeof data50 !== "string") {
                const err138 = { instancePath: instancePath + "/feedback/" + i4 + "/rating", schemaPath: "#/properties/feedback/items/properties/rating/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err138];
                } else {
                  vErrors.push(err138);
                }
                errors++;
              }
              if (!(data50 === "up" || data50 === "down")) {
                const err139 = { instancePath: instancePath + "/feedback/" + i4 + "/rating", schemaPath: "#/properties/feedback/items/properties/rating/enum", keyword: "enum", params: { allowedValues: schema16.properties.feedback.items.properties.rating.enum }, message: "must be equal to one of the allowed values" };
                if (vErrors === null) {
                  vErrors = [err139];
                } else {
                  vErrors.push(err139);
                }
                errors++;
              }
            }
            if (data46.note !== void 0) {
              let data51 = data46.note;
              const _errs143 = errors;
              let valid26 = false;
              const _errs144 = errors;
              if (typeof data51 !== "string") {
                const err140 = { instancePath: instancePath + "/feedback/" + i4 + "/note", schemaPath: "#/properties/feedback/items/properties/note/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err140];
                } else {
                  vErrors.push(err140);
                }
                errors++;
              }
              var _valid7 = _errs144 === errors;
              valid26 = valid26 || _valid7;
              if (!valid26) {
                const _errs146 = errors;
                if (data51 !== null) {
                  const err141 = { instancePath: instancePath + "/feedback/" + i4 + "/note", schemaPath: "#/properties/feedback/items/properties/note/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                  if (vErrors === null) {
                    vErrors = [err141];
                  } else {
                    vErrors.push(err141);
                  }
                  errors++;
                }
                var _valid7 = _errs146 === errors;
                valid26 = valid26 || _valid7;
              }
              if (!valid26) {
                const err142 = { instancePath: instancePath + "/feedback/" + i4 + "/note", schemaPath: "#/properties/feedback/items/properties/note/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                if (vErrors === null) {
                  vErrors = [err142];
                } else {
                  vErrors.push(err142);
                }
                errors++;
              } else {
                errors = _errs143;
                if (vErrors !== null) {
                  if (_errs143) {
                    vErrors.length = _errs143;
                  } else {
                    vErrors = null;
                  }
                }
              }
            }
            if (data46.createdAt !== void 0) {
              let data52 = data46.createdAt;
              if (typeof data52 === "string") {
                if (!pattern0.test(data52)) {
                  const err143 = { instancePath: instancePath + "/feedback/" + i4 + "/createdAt", schemaPath: "#/properties/feedback/items/properties/createdAt/pattern", keyword: "pattern", params: { pattern: "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, message: 'must match pattern "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"' };
                  if (vErrors === null) {
                    vErrors = [err143];
                  } else {
                    vErrors.push(err143);
                  }
                  errors++;
                }
                if (!formats0.validate(data52)) {
                  const err144 = { instancePath: instancePath + "/feedback/" + i4 + "/createdAt", schemaPath: "#/properties/feedback/items/properties/createdAt/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' };
                  if (vErrors === null) {
                    vErrors = [err144];
                  } else {
                    vErrors.push(err144);
                  }
                  errors++;
                }
              } else {
                const err145 = { instancePath: instancePath + "/feedback/" + i4 + "/createdAt", schemaPath: "#/properties/feedback/items/properties/createdAt/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err145];
                } else {
                  vErrors.push(err145);
                }
                errors++;
              }
            }
          } else {
            const err146 = { instancePath: instancePath + "/feedback/" + i4, schemaPath: "#/properties/feedback/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
              vErrors = [err146];
            } else {
              vErrors.push(err146);
            }
            errors++;
          }
        }
      } else {
        const err147 = { instancePath: instancePath + "/feedback", schemaPath: "#/properties/feedback/type", keyword: "type", params: { type: "array" }, message: "must be array" };
        if (vErrors === null) {
          vErrors = [err147];
        } else {
          vErrors.push(err147);
        }
        errors++;
      }
    }
  } else {
    const err148 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err148];
    } else {
      vErrors.push(err148);
    }
    errors++;
  }
  validate15.errors = vErrors;
  return errors === 0;
}
var validateInput3 = validate16;
function validate16(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    for (const key0 in data) {
      if (!(key0 === "prefix" || key0 === "limit" || key0 === "startingAfter")) {
        const err0 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err0];
        } else {
          vErrors.push(err0);
        }
        errors++;
      }
    }
    if (data.prefix !== void 0) {
      if (typeof data.prefix !== "string") {
        const err1 = { instancePath: instancePath + "/prefix", schemaPath: "#/properties/prefix/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
    }
    if (data.limit !== void 0) {
      let data1 = data.limit;
      if (!(typeof data1 == "number" && (!(data1 % 1) && !isNaN(data1)) && isFinite(data1))) {
        const err2 = { instancePath: instancePath + "/limit", schemaPath: "#/properties/limit/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
      if (typeof data1 == "number" && isFinite(data1)) {
        if (data1 > 100 || isNaN(data1)) {
          const err3 = { instancePath: instancePath + "/limit", schemaPath: "#/properties/limit/maximum", keyword: "maximum", params: { comparison: "<=", limit: 100 }, message: "must be <= 100" };
          if (vErrors === null) {
            vErrors = [err3];
          } else {
            vErrors.push(err3);
          }
          errors++;
        }
        if (data1 < 1 || isNaN(data1)) {
          const err4 = { instancePath: instancePath + "/limit", schemaPath: "#/properties/limit/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" };
          if (vErrors === null) {
            vErrors = [err4];
          } else {
            vErrors.push(err4);
          }
          errors++;
        }
      }
    }
    if (data.startingAfter !== void 0) {
      let data2 = data.startingAfter;
      if (typeof data2 === "string") {
        if (func2(data2) < 1) {
          const err5 = { instancePath: instancePath + "/startingAfter", schemaPath: "#/properties/startingAfter/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
          if (vErrors === null) {
            vErrors = [err5];
          } else {
            vErrors.push(err5);
          }
          errors++;
        }
      } else {
        const err6 = { instancePath: instancePath + "/startingAfter", schemaPath: "#/properties/startingAfter/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
    }
  } else {
    const err7 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err7];
    } else {
      vErrors.push(err7);
    }
    errors++;
  }
  validate16.errors = vErrors;
  return errors === 0;
}
var validateOutput3 = validate17;
function validate17(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.object === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "object" }, message: "must have required property 'object'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.data === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "data" }, message: "must have required property 'data'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.has_more === void 0) {
      const err2 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "has_more" }, message: "must have required property 'has_more'" };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.url === void 0) {
      const err3 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "url" }, message: "must have required property 'url'" };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    for (const key0 in data) {
      if (!(key0 === "object" || key0 === "data" || key0 === "has_more" || key0 === "url")) {
        const err4 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
    if (data.object !== void 0) {
      let data0 = data.object;
      if (typeof data0 !== "string") {
        const err5 = { instancePath: instancePath + "/object", schemaPath: "#/properties/object/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
      if ("list" !== data0) {
        const err6 = { instancePath: instancePath + "/object", schemaPath: "#/properties/object/const", keyword: "const", params: { allowedValue: "list" }, message: "must be equal to constant" };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
    }
    if (data.data !== void 0) {
      let data1 = data.data;
      if (Array.isArray(data1)) {
        const len0 = data1.length;
        for (let i0 = 0; i0 < len0; i0++) {
          let data2 = data1[i0];
          if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
            if (data2.object === void 0) {
              const err7 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/definitions/File/required", keyword: "required", params: { missingProperty: "object" }, message: "must have required property 'object'" };
              if (vErrors === null) {
                vErrors = [err7];
              } else {
                vErrors.push(err7);
              }
              errors++;
            }
            if (data2.path === void 0) {
              const err8 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/definitions/File/required", keyword: "required", params: { missingProperty: "path" }, message: "must have required property 'path'" };
              if (vErrors === null) {
                vErrors = [err8];
              } else {
                vErrors.push(err8);
              }
              errors++;
            }
            if (data2.mimeType === void 0) {
              const err9 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/definitions/File/required", keyword: "required", params: { missingProperty: "mimeType" }, message: "must have required property 'mimeType'" };
              if (vErrors === null) {
                vErrors = [err9];
              } else {
                vErrors.push(err9);
              }
              errors++;
            }
            if (data2.size === void 0) {
              const err10 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/definitions/File/required", keyword: "required", params: { missingProperty: "size" }, message: "must have required property 'size'" };
              if (vErrors === null) {
                vErrors = [err10];
              } else {
                vErrors.push(err10);
              }
              errors++;
            }
            if (data2.etag === void 0) {
              const err11 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/definitions/File/required", keyword: "required", params: { missingProperty: "etag" }, message: "must have required property 'etag'" };
              if (vErrors === null) {
                vErrors = [err11];
              } else {
                vErrors.push(err11);
              }
              errors++;
            }
            if (data2.updatedAt === void 0) {
              const err12 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/definitions/File/required", keyword: "required", params: { missingProperty: "updatedAt" }, message: "must have required property 'updatedAt'" };
              if (vErrors === null) {
                vErrors = [err12];
              } else {
                vErrors.push(err12);
              }
              errors++;
            }
            for (const key1 in data2) {
              if (!(key1 === "object" || key1 === "path" || key1 === "mimeType" || key1 === "size" || key1 === "etag" || key1 === "updatedAt")) {
                const err13 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/definitions/File/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
                if (vErrors === null) {
                  vErrors = [err13];
                } else {
                  vErrors.push(err13);
                }
                errors++;
              }
            }
            if (data2.object !== void 0) {
              let data3 = data2.object;
              if (typeof data3 !== "string") {
                const err14 = { instancePath: instancePath + "/data/" + i0 + "/object", schemaPath: "#/definitions/File/properties/object/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err14];
                } else {
                  vErrors.push(err14);
                }
                errors++;
              }
              if ("file" !== data3) {
                const err15 = { instancePath: instancePath + "/data/" + i0 + "/object", schemaPath: "#/definitions/File/properties/object/const", keyword: "const", params: { allowedValue: "file" }, message: "must be equal to constant" };
                if (vErrors === null) {
                  vErrors = [err15];
                } else {
                  vErrors.push(err15);
                }
                errors++;
              }
            }
            if (data2.path !== void 0) {
              if (typeof data2.path !== "string") {
                const err16 = { instancePath: instancePath + "/data/" + i0 + "/path", schemaPath: "#/definitions/File/properties/path/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err16];
                } else {
                  vErrors.push(err16);
                }
                errors++;
              }
            }
            if (data2.mimeType !== void 0) {
              if (typeof data2.mimeType !== "string") {
                const err17 = { instancePath: instancePath + "/data/" + i0 + "/mimeType", schemaPath: "#/definitions/File/properties/mimeType/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err17];
                } else {
                  vErrors.push(err17);
                }
                errors++;
              }
            }
            if (data2.size !== void 0) {
              let data6 = data2.size;
              if (!(typeof data6 == "number" && (!(data6 % 1) && !isNaN(data6)) && isFinite(data6))) {
                const err18 = { instancePath: instancePath + "/data/" + i0 + "/size", schemaPath: "#/definitions/File/properties/size/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                if (vErrors === null) {
                  vErrors = [err18];
                } else {
                  vErrors.push(err18);
                }
                errors++;
              }
              if (typeof data6 == "number" && isFinite(data6)) {
                if (data6 > 9007199254740991 || isNaN(data6)) {
                  const err19 = { instancePath: instancePath + "/data/" + i0 + "/size", schemaPath: "#/definitions/File/properties/size/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err19];
                  } else {
                    vErrors.push(err19);
                  }
                  errors++;
                }
                if (data6 < 0 || isNaN(data6)) {
                  const err20 = { instancePath: instancePath + "/data/" + i0 + "/size", schemaPath: "#/definitions/File/properties/size/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
                  if (vErrors === null) {
                    vErrors = [err20];
                  } else {
                    vErrors.push(err20);
                  }
                  errors++;
                }
              }
            }
            if (data2.etag !== void 0) {
              if (typeof data2.etag !== "string") {
                const err21 = { instancePath: instancePath + "/data/" + i0 + "/etag", schemaPath: "#/definitions/File/properties/etag/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err21];
                } else {
                  vErrors.push(err21);
                }
                errors++;
              }
            }
            if (data2.updatedAt !== void 0) {
              let data8 = data2.updatedAt;
              if (typeof data8 === "string") {
                if (!pattern0.test(data8)) {
                  const err22 = { instancePath: instancePath + "/data/" + i0 + "/updatedAt", schemaPath: "#/definitions/File/properties/updatedAt/pattern", keyword: "pattern", params: { pattern: "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, message: 'must match pattern "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"' };
                  if (vErrors === null) {
                    vErrors = [err22];
                  } else {
                    vErrors.push(err22);
                  }
                  errors++;
                }
                if (!formats0.validate(data8)) {
                  const err23 = { instancePath: instancePath + "/data/" + i0 + "/updatedAt", schemaPath: "#/definitions/File/properties/updatedAt/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' };
                  if (vErrors === null) {
                    vErrors = [err23];
                  } else {
                    vErrors.push(err23);
                  }
                  errors++;
                }
              } else {
                const err24 = { instancePath: instancePath + "/data/" + i0 + "/updatedAt", schemaPath: "#/definitions/File/properties/updatedAt/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err24];
                } else {
                  vErrors.push(err24);
                }
                errors++;
              }
            }
          } else {
            const err25 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/definitions/File/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
              vErrors = [err25];
            } else {
              vErrors.push(err25);
            }
            errors++;
          }
        }
      } else {
        const err26 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/type", keyword: "type", params: { type: "array" }, message: "must be array" };
        if (vErrors === null) {
          vErrors = [err26];
        } else {
          vErrors.push(err26);
        }
        errors++;
      }
    }
    if (data.has_more !== void 0) {
      if (typeof data.has_more !== "boolean") {
        const err27 = { instancePath: instancePath + "/has_more", schemaPath: "#/properties/has_more/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
        if (vErrors === null) {
          vErrors = [err27];
        } else {
          vErrors.push(err27);
        }
        errors++;
      }
    }
    if (data.url !== void 0) {
      if (typeof data.url !== "string") {
        const err28 = { instancePath: instancePath + "/url", schemaPath: "#/properties/url/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err28];
        } else {
          vErrors.push(err28);
        }
        errors++;
      }
    }
  } else {
    const err29 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err29];
    } else {
      vErrors.push(err29);
    }
    errors++;
  }
  validate17.errors = vErrors;
  return errors === 0;
}
var validateInput4 = validate18;
function validate18(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.path === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "path" }, message: "must have required property 'path'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    for (const key0 in data) {
      if (!(key0 === "path")) {
        const err1 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
    }
    if (data.path !== void 0) {
      let data0 = data.path;
      if (typeof data0 === "string") {
        if (func2(data0) > 1024) {
          const err2 = { instancePath: instancePath + "/path", schemaPath: "#/properties/path/maxLength", keyword: "maxLength", params: { limit: 1024 }, message: "must NOT have more than 1024 characters" };
          if (vErrors === null) {
            vErrors = [err2];
          } else {
            vErrors.push(err2);
          }
          errors++;
        }
        if (func2(data0) < 1) {
          const err3 = { instancePath: instancePath + "/path", schemaPath: "#/properties/path/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
          if (vErrors === null) {
            vErrors = [err3];
          } else {
            vErrors.push(err3);
          }
          errors++;
        }
      } else {
        const err4 = { instancePath: instancePath + "/path", schemaPath: "#/properties/path/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
  } else {
    const err5 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err5];
    } else {
      vErrors.push(err5);
    }
    errors++;
  }
  validate18.errors = vErrors;
  return errors === 0;
}
var validateOutput4 = validate19;
var formats18 = require_formats().fullFormats.uri;
function validate19(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.object === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "object" }, message: "must have required property 'object'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.path === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "path" }, message: "must have required property 'path'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.mimeType === void 0) {
      const err2 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "mimeType" }, message: "must have required property 'mimeType'" };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.size === void 0) {
      const err3 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "size" }, message: "must have required property 'size'" };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.etag === void 0) {
      const err4 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "etag" }, message: "must have required property 'etag'" };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
    if (data.updatedAt === void 0) {
      const err5 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "updatedAt" }, message: "must have required property 'updatedAt'" };
      if (vErrors === null) {
        vErrors = [err5];
      } else {
        vErrors.push(err5);
      }
      errors++;
    }
    for (const key0 in data) {
      if (!(key0 === "object" || key0 === "path" || key0 === "mimeType" || key0 === "size" || key0 === "etag" || key0 === "updatedAt" || key0 === "content" || key0 === "url")) {
        const err6 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
    }
    if (data.object !== void 0) {
      let data0 = data.object;
      if (typeof data0 !== "string") {
        const err7 = { instancePath: instancePath + "/object", schemaPath: "#/properties/object/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
      if ("file" !== data0) {
        const err8 = { instancePath: instancePath + "/object", schemaPath: "#/properties/object/const", keyword: "const", params: { allowedValue: "file" }, message: "must be equal to constant" };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
    }
    if (data.path !== void 0) {
      if (typeof data.path !== "string") {
        const err9 = { instancePath: instancePath + "/path", schemaPath: "#/properties/path/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
    }
    if (data.mimeType !== void 0) {
      if (typeof data.mimeType !== "string") {
        const err10 = { instancePath: instancePath + "/mimeType", schemaPath: "#/properties/mimeType/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err10];
        } else {
          vErrors.push(err10);
        }
        errors++;
      }
    }
    if (data.size !== void 0) {
      let data3 = data.size;
      if (!(typeof data3 == "number" && (!(data3 % 1) && !isNaN(data3)) && isFinite(data3))) {
        const err11 = { instancePath: instancePath + "/size", schemaPath: "#/properties/size/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
        if (vErrors === null) {
          vErrors = [err11];
        } else {
          vErrors.push(err11);
        }
        errors++;
      }
      if (typeof data3 == "number" && isFinite(data3)) {
        if (data3 > 9007199254740991 || isNaN(data3)) {
          const err12 = { instancePath: instancePath + "/size", schemaPath: "#/properties/size/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
          if (vErrors === null) {
            vErrors = [err12];
          } else {
            vErrors.push(err12);
          }
          errors++;
        }
        if (data3 < 0 || isNaN(data3)) {
          const err13 = { instancePath: instancePath + "/size", schemaPath: "#/properties/size/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
          if (vErrors === null) {
            vErrors = [err13];
          } else {
            vErrors.push(err13);
          }
          errors++;
        }
      }
    }
    if (data.etag !== void 0) {
      if (typeof data.etag !== "string") {
        const err14 = { instancePath: instancePath + "/etag", schemaPath: "#/properties/etag/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err14];
        } else {
          vErrors.push(err14);
        }
        errors++;
      }
    }
    if (data.updatedAt !== void 0) {
      let data5 = data.updatedAt;
      if (typeof data5 === "string") {
        if (!pattern0.test(data5)) {
          const err15 = { instancePath: instancePath + "/updatedAt", schemaPath: "#/properties/updatedAt/pattern", keyword: "pattern", params: { pattern: "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, message: 'must match pattern "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"' };
          if (vErrors === null) {
            vErrors = [err15];
          } else {
            vErrors.push(err15);
          }
          errors++;
        }
        if (!formats0.validate(data5)) {
          const err16 = { instancePath: instancePath + "/updatedAt", schemaPath: "#/properties/updatedAt/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' };
          if (vErrors === null) {
            vErrors = [err16];
          } else {
            vErrors.push(err16);
          }
          errors++;
        }
      } else {
        const err17 = { instancePath: instancePath + "/updatedAt", schemaPath: "#/properties/updatedAt/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err17];
        } else {
          vErrors.push(err17);
        }
        errors++;
      }
    }
    if (data.content !== void 0) {
      if (typeof data.content !== "string") {
        const err18 = { instancePath: instancePath + "/content", schemaPath: "#/properties/content/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err18];
        } else {
          vErrors.push(err18);
        }
        errors++;
      }
    }
    if (data.url !== void 0) {
      let data7 = data.url;
      if (typeof data7 === "string") {
        if (!formats18(data7)) {
          const err19 = { instancePath: instancePath + "/url", schemaPath: "#/properties/url/format", keyword: "format", params: { format: "uri" }, message: 'must match format "uri"' };
          if (vErrors === null) {
            vErrors = [err19];
          } else {
            vErrors.push(err19);
          }
          errors++;
        }
      } else {
        const err20 = { instancePath: instancePath + "/url", schemaPath: "#/properties/url/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err20];
        } else {
          vErrors.push(err20);
        }
        errors++;
      }
    }
  } else {
    const err21 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err21];
    } else {
      vErrors.push(err21);
    }
    errors++;
  }
  validate19.errors = vErrors;
  return errors === 0;
}
var validateInput5 = validate20;
function validate20(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    for (const key0 in data) {
      const err0 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
  } else {
    const err1 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  validate20.errors = vErrors;
  return errors === 0;
}
var validateOutput5 = validate21;
var formats20 = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;
var pattern9 = new RegExp("^(?!\\.)(?!.*\\.\\.)([A-Za-z0-9_'+\\-\\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\\-]*\\.)+[A-Za-z]{2,}$", "u");
function validate21(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.id === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property 'id'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.object === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "object" }, message: "must have required property 'object'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.email === void 0) {
      const err2 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "email" }, message: "must have required property 'email'" };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.name === void 0) {
      const err3 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "name" }, message: "must have required property 'name'" };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.image === void 0) {
      const err4 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "image" }, message: "must have required property 'image'" };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
    if (data.credit === void 0) {
      const err5 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "credit" }, message: "must have required property 'credit'" };
      if (vErrors === null) {
        vErrors = [err5];
      } else {
        vErrors.push(err5);
      }
      errors++;
    }
    for (const key0 in data) {
      if (!(key0 === "id" || key0 === "object" || key0 === "email" || key0 === "name" || key0 === "image" || key0 === "credit")) {
        const err6 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
    }
    if (data.id !== void 0) {
      if (typeof data.id !== "string") {
        const err7 = { instancePath: instancePath + "/id", schemaPath: "#/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
    }
    if (data.object !== void 0) {
      let data1 = data.object;
      if (typeof data1 !== "string") {
        const err8 = { instancePath: instancePath + "/object", schemaPath: "#/properties/object/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
      if ("user" !== data1) {
        const err9 = { instancePath: instancePath + "/object", schemaPath: "#/properties/object/const", keyword: "const", params: { allowedValue: "user" }, message: "must be equal to constant" };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
    }
    if (data.email !== void 0) {
      let data2 = data.email;
      if (typeof data2 === "string") {
        if (!pattern9.test(data2)) {
          const err10 = { instancePath: instancePath + "/email", schemaPath: "#/properties/email/pattern", keyword: "pattern", params: { pattern: "^(?!\\.)(?!.*\\.\\.)([A-Za-z0-9_'+\\-\\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\\-]*\\.)+[A-Za-z]{2,}$" }, message: `must match pattern "^(?!\\.)(?!.*\\.\\.)([A-Za-z0-9_'+\\-\\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\\-]*\\.)+[A-Za-z]{2,}$"` };
          if (vErrors === null) {
            vErrors = [err10];
          } else {
            vErrors.push(err10);
          }
          errors++;
        }
        if (!formats20.test(data2)) {
          const err11 = { instancePath: instancePath + "/email", schemaPath: "#/properties/email/format", keyword: "format", params: { format: "email" }, message: 'must match format "email"' };
          if (vErrors === null) {
            vErrors = [err11];
          } else {
            vErrors.push(err11);
          }
          errors++;
        }
      } else {
        const err12 = { instancePath: instancePath + "/email", schemaPath: "#/properties/email/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err12];
        } else {
          vErrors.push(err12);
        }
        errors++;
      }
    }
    if (data.name !== void 0) {
      if (typeof data.name !== "string") {
        const err13 = { instancePath: instancePath + "/name", schemaPath: "#/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err13];
        } else {
          vErrors.push(err13);
        }
        errors++;
      }
    }
    if (data.image !== void 0) {
      let data4 = data.image;
      const _errs11 = errors;
      let valid1 = false;
      const _errs12 = errors;
      if (typeof data4 === "string") {
        if (!formats18(data4)) {
          const err14 = { instancePath: instancePath + "/image", schemaPath: "#/properties/image/anyOf/0/format", keyword: "format", params: { format: "uri" }, message: 'must match format "uri"' };
          if (vErrors === null) {
            vErrors = [err14];
          } else {
            vErrors.push(err14);
          }
          errors++;
        }
      } else {
        const err15 = { instancePath: instancePath + "/image", schemaPath: "#/properties/image/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err15];
        } else {
          vErrors.push(err15);
        }
        errors++;
      }
      var _valid0 = _errs12 === errors;
      valid1 = valid1 || _valid0;
      if (!valid1) {
        const _errs14 = errors;
        if (data4 !== null) {
          const err16 = { instancePath: instancePath + "/image", schemaPath: "#/properties/image/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
          if (vErrors === null) {
            vErrors = [err16];
          } else {
            vErrors.push(err16);
          }
          errors++;
        }
        var _valid0 = _errs14 === errors;
        valid1 = valid1 || _valid0;
      }
      if (!valid1) {
        const err17 = { instancePath: instancePath + "/image", schemaPath: "#/properties/image/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
        if (vErrors === null) {
          vErrors = [err17];
        } else {
          vErrors.push(err17);
        }
        errors++;
      } else {
        errors = _errs11;
        if (vErrors !== null) {
          if (_errs11) {
            vErrors.length = _errs11;
          } else {
            vErrors = null;
          }
        }
      }
    }
    if (data.credit !== void 0) {
      let data5 = data.credit;
      if (data5 && typeof data5 == "object" && !Array.isArray(data5)) {
        if (data5.currency === void 0) {
          const err18 = { instancePath: instancePath + "/credit", schemaPath: "#/properties/credit/required", keyword: "required", params: { missingProperty: "currency" }, message: "must have required property 'currency'" };
          if (vErrors === null) {
            vErrors = [err18];
          } else {
            vErrors.push(err18);
          }
          errors++;
        }
        if (data5.credit === void 0) {
          const err19 = { instancePath: instancePath + "/credit", schemaPath: "#/properties/credit/required", keyword: "required", params: { missingProperty: "credit" }, message: "must have required property 'credit'" };
          if (vErrors === null) {
            vErrors = [err19];
          } else {
            vErrors.push(err19);
          }
          errors++;
        }
        if (data5.spent === void 0) {
          const err20 = { instancePath: instancePath + "/credit", schemaPath: "#/properties/credit/required", keyword: "required", params: { missingProperty: "spent" }, message: "must have required property 'spent'" };
          if (vErrors === null) {
            vErrors = [err20];
          } else {
            vErrors.push(err20);
          }
          errors++;
        }
        if (data5.remaining === void 0) {
          const err21 = { instancePath: instancePath + "/credit", schemaPath: "#/properties/credit/required", keyword: "required", params: { missingProperty: "remaining" }, message: "must have required property 'remaining'" };
          if (vErrors === null) {
            vErrors = [err21];
          } else {
            vErrors.push(err21);
          }
          errors++;
        }
        for (const key1 in data5) {
          if (!(key1 === "currency" || key1 === "credit" || key1 === "spent" || key1 === "remaining")) {
            const err22 = { instancePath: instancePath + "/credit", schemaPath: "#/properties/credit/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
            if (vErrors === null) {
              vErrors = [err22];
            } else {
              vErrors.push(err22);
            }
            errors++;
          }
        }
        if (data5.currency !== void 0) {
          let data6 = data5.currency;
          if (typeof data6 !== "string") {
            const err23 = { instancePath: instancePath + "/credit/currency", schemaPath: "#/properties/credit/properties/currency/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err23];
            } else {
              vErrors.push(err23);
            }
            errors++;
          }
          if ("EUR" !== data6) {
            const err24 = { instancePath: instancePath + "/credit/currency", schemaPath: "#/properties/credit/properties/currency/const", keyword: "const", params: { allowedValue: "EUR" }, message: "must be equal to constant" };
            if (vErrors === null) {
              vErrors = [err24];
            } else {
              vErrors.push(err24);
            }
            errors++;
          }
        }
        if (data5.credit !== void 0) {
          let data7 = data5.credit;
          if (!(typeof data7 == "number" && (!(data7 % 1) && !isNaN(data7)) && isFinite(data7))) {
            const err25 = { instancePath: instancePath + "/credit/credit", schemaPath: "#/properties/credit/properties/credit/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
            if (vErrors === null) {
              vErrors = [err25];
            } else {
              vErrors.push(err25);
            }
            errors++;
          }
          if (typeof data7 == "number" && isFinite(data7)) {
            if (data7 > 9007199254740991 || isNaN(data7)) {
              const err26 = { instancePath: instancePath + "/credit/credit", schemaPath: "#/properties/credit/properties/credit/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
              if (vErrors === null) {
                vErrors = [err26];
              } else {
                vErrors.push(err26);
              }
              errors++;
            }
            if (data7 < 0 || isNaN(data7)) {
              const err27 = { instancePath: instancePath + "/credit/credit", schemaPath: "#/properties/credit/properties/credit/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
              if (vErrors === null) {
                vErrors = [err27];
              } else {
                vErrors.push(err27);
              }
              errors++;
            }
          }
        }
        if (data5.spent !== void 0) {
          let data8 = data5.spent;
          if (!(typeof data8 == "number" && (!(data8 % 1) && !isNaN(data8)) && isFinite(data8))) {
            const err28 = { instancePath: instancePath + "/credit/spent", schemaPath: "#/properties/credit/properties/spent/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
            if (vErrors === null) {
              vErrors = [err28];
            } else {
              vErrors.push(err28);
            }
            errors++;
          }
          if (typeof data8 == "number" && isFinite(data8)) {
            if (data8 > 9007199254740991 || isNaN(data8)) {
              const err29 = { instancePath: instancePath + "/credit/spent", schemaPath: "#/properties/credit/properties/spent/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
              if (vErrors === null) {
                vErrors = [err29];
              } else {
                vErrors.push(err29);
              }
              errors++;
            }
            if (data8 < 0 || isNaN(data8)) {
              const err30 = { instancePath: instancePath + "/credit/spent", schemaPath: "#/properties/credit/properties/spent/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
              if (vErrors === null) {
                vErrors = [err30];
              } else {
                vErrors.push(err30);
              }
              errors++;
            }
          }
        }
        if (data5.remaining !== void 0) {
          let data9 = data5.remaining;
          if (!(typeof data9 == "number" && (!(data9 % 1) && !isNaN(data9)) && isFinite(data9))) {
            const err31 = { instancePath: instancePath + "/credit/remaining", schemaPath: "#/properties/credit/properties/remaining/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
            if (vErrors === null) {
              vErrors = [err31];
            } else {
              vErrors.push(err31);
            }
            errors++;
          }
          if (typeof data9 == "number" && isFinite(data9)) {
            if (data9 > 9007199254740991 || isNaN(data9)) {
              const err32 = { instancePath: instancePath + "/credit/remaining", schemaPath: "#/properties/credit/properties/remaining/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
              if (vErrors === null) {
                vErrors = [err32];
              } else {
                vErrors.push(err32);
              }
              errors++;
            }
            if (data9 < 0 || isNaN(data9)) {
              const err33 = { instancePath: instancePath + "/credit/remaining", schemaPath: "#/properties/credit/properties/remaining/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
              if (vErrors === null) {
                vErrors = [err33];
              } else {
                vErrors.push(err33);
              }
              errors++;
            }
          }
        }
      } else {
        const err34 = { instancePath: instancePath + "/credit", schemaPath: "#/properties/credit/type", keyword: "type", params: { type: "object" }, message: "must be object" };
        if (vErrors === null) {
          vErrors = [err34];
        } else {
          vErrors.push(err34);
        }
        errors++;
      }
    }
  } else {
    const err35 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err35];
    } else {
      vErrors.push(err35);
    }
    errors++;
  }
  validate21.errors = vErrors;
  return errors === 0;
}
var validateInput6 = validate22;
function validate22(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    for (const key0 in data) {
      const err0 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
  } else {
    const err1 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  validate22.errors = vErrors;
  return errors === 0;
}
var validateOutput6 = validate23;
var formats24 = require_formats().fullFormats.date;
var pattern10 = new RegExp("^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))$", "u");
function validate23(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.object === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "object" }, message: "must have required property 'object'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.currency === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "currency" }, message: "must have required property 'currency'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.days === void 0) {
      const err2 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "days" }, message: "must have required property 'days'" };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    for (const key0 in data) {
      if (!(key0 === "object" || key0 === "currency" || key0 === "days")) {
        const err3 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.object !== void 0) {
      let data0 = data.object;
      if (typeof data0 !== "string") {
        const err4 = { instancePath: instancePath + "/object", schemaPath: "#/properties/object/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
      if ("usage" !== data0) {
        const err5 = { instancePath: instancePath + "/object", schemaPath: "#/properties/object/const", keyword: "const", params: { allowedValue: "usage" }, message: "must be equal to constant" };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
    }
    if (data.currency !== void 0) {
      let data1 = data.currency;
      if (typeof data1 !== "string") {
        const err6 = { instancePath: instancePath + "/currency", schemaPath: "#/properties/currency/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
      if ("EUR" !== data1) {
        const err7 = { instancePath: instancePath + "/currency", schemaPath: "#/properties/currency/const", keyword: "const", params: { allowedValue: "EUR" }, message: "must be equal to constant" };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
    }
    if (data.days !== void 0) {
      let data2 = data.days;
      if (Array.isArray(data2)) {
        const len0 = data2.length;
        for (let i0 = 0; i0 < len0; i0++) {
          let data3 = data2[i0];
          if (data3 && typeof data3 == "object" && !Array.isArray(data3)) {
            if (data3.date === void 0) {
              const err8 = { instancePath: instancePath + "/days/" + i0, schemaPath: "#/properties/days/items/required", keyword: "required", params: { missingProperty: "date" }, message: "must have required property 'date'" };
              if (vErrors === null) {
                vErrors = [err8];
              } else {
                vErrors.push(err8);
              }
              errors++;
            }
            if (data3.spent === void 0) {
              const err9 = { instancePath: instancePath + "/days/" + i0, schemaPath: "#/properties/days/items/required", keyword: "required", params: { missingProperty: "spent" }, message: "must have required property 'spent'" };
              if (vErrors === null) {
                vErrors = [err9];
              } else {
                vErrors.push(err9);
              }
              errors++;
            }
            for (const key1 in data3) {
              if (!(key1 === "date" || key1 === "spent")) {
                const err10 = { instancePath: instancePath + "/days/" + i0, schemaPath: "#/properties/days/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
                if (vErrors === null) {
                  vErrors = [err10];
                } else {
                  vErrors.push(err10);
                }
                errors++;
              }
            }
            if (data3.date !== void 0) {
              let data4 = data3.date;
              if (typeof data4 === "string") {
                if (!pattern10.test(data4)) {
                  const err11 = { instancePath: instancePath + "/days/" + i0 + "/date", schemaPath: "#/properties/days/items/properties/date/pattern", keyword: "pattern", params: { pattern: "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))$" }, message: 'must match pattern "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))$"' };
                  if (vErrors === null) {
                    vErrors = [err11];
                  } else {
                    vErrors.push(err11);
                  }
                  errors++;
                }
                if (!formats24.validate(data4)) {
                  const err12 = { instancePath: instancePath + "/days/" + i0 + "/date", schemaPath: "#/properties/days/items/properties/date/format", keyword: "format", params: { format: "date" }, message: 'must match format "date"' };
                  if (vErrors === null) {
                    vErrors = [err12];
                  } else {
                    vErrors.push(err12);
                  }
                  errors++;
                }
              } else {
                const err13 = { instancePath: instancePath + "/days/" + i0 + "/date", schemaPath: "#/properties/days/items/properties/date/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err13];
                } else {
                  vErrors.push(err13);
                }
                errors++;
              }
            }
            if (data3.spent !== void 0) {
              let data5 = data3.spent;
              if (!(typeof data5 == "number" && (!(data5 % 1) && !isNaN(data5)) && isFinite(data5))) {
                const err14 = { instancePath: instancePath + "/days/" + i0 + "/spent", schemaPath: "#/properties/days/items/properties/spent/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                if (vErrors === null) {
                  vErrors = [err14];
                } else {
                  vErrors.push(err14);
                }
                errors++;
              }
              if (typeof data5 == "number" && isFinite(data5)) {
                if (data5 > 9007199254740991 || isNaN(data5)) {
                  const err15 = { instancePath: instancePath + "/days/" + i0 + "/spent", schemaPath: "#/properties/days/items/properties/spent/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err15];
                  } else {
                    vErrors.push(err15);
                  }
                  errors++;
                }
                if (data5 < 0 || isNaN(data5)) {
                  const err16 = { instancePath: instancePath + "/days/" + i0 + "/spent", schemaPath: "#/properties/days/items/properties/spent/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
                  if (vErrors === null) {
                    vErrors = [err16];
                  } else {
                    vErrors.push(err16);
                  }
                  errors++;
                }
              }
            }
          } else {
            const err17 = { instancePath: instancePath + "/days/" + i0, schemaPath: "#/properties/days/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
              vErrors = [err17];
            } else {
              vErrors.push(err17);
            }
            errors++;
          }
        }
      } else {
        const err18 = { instancePath: instancePath + "/days", schemaPath: "#/properties/days/type", keyword: "type", params: { type: "array" }, message: "must be array" };
        if (vErrors === null) {
          vErrors = [err18];
        } else {
          vErrors.push(err18);
        }
        errors++;
      }
    }
  } else {
    const err19 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err19];
    } else {
      vErrors.push(err19);
    }
    errors++;
  }
  validate23.errors = vErrors;
  return errors === 0;
}
var validateInput7 = validate24;
function validate24(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.query === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "query" }, message: "must have required property 'query'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    for (const key0 in data) {
      if (!(key0 === "query" || key0 === "phrase" || key0 === "source" || key0 === "after" || key0 === "limit" || key0 === "maxChars" || key0 === "cursor")) {
        const err1 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
    }
    if (data.query !== void 0) {
      let data0 = data.query;
      if (typeof data0 === "string") {
        if (func2(data0) < 1) {
          const err2 = { instancePath: instancePath + "/query", schemaPath: "#/properties/query/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
          if (vErrors === null) {
            vErrors = [err2];
          } else {
            vErrors.push(err2);
          }
          errors++;
        }
      } else {
        const err3 = { instancePath: instancePath + "/query", schemaPath: "#/properties/query/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.phrase !== void 0) {
      if (typeof data.phrase !== "string") {
        const err4 = { instancePath: instancePath + "/phrase", schemaPath: "#/properties/phrase/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
    if (data.source !== void 0) {
      if (typeof data.source !== "string") {
        const err5 = { instancePath: instancePath + "/source", schemaPath: "#/properties/source/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
    }
    if (data.after !== void 0) {
      let data3 = data.after;
      if (typeof data3 === "string") {
        if (!pattern10.test(data3)) {
          const err6 = { instancePath: instancePath + "/after", schemaPath: "#/properties/after/pattern", keyword: "pattern", params: { pattern: "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))$" }, message: 'must match pattern "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))$"' };
          if (vErrors === null) {
            vErrors = [err6];
          } else {
            vErrors.push(err6);
          }
          errors++;
        }
        if (!formats24.validate(data3)) {
          const err7 = { instancePath: instancePath + "/after", schemaPath: "#/properties/after/format", keyword: "format", params: { format: "date" }, message: 'must match format "date"' };
          if (vErrors === null) {
            vErrors = [err7];
          } else {
            vErrors.push(err7);
          }
          errors++;
        }
      } else {
        const err8 = { instancePath: instancePath + "/after", schemaPath: "#/properties/after/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
    }
    if (data.limit !== void 0) {
      let data4 = data.limit;
      if (!(typeof data4 == "number" && (!(data4 % 1) && !isNaN(data4)) && isFinite(data4))) {
        const err9 = { instancePath: instancePath + "/limit", schemaPath: "#/properties/limit/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
      if (typeof data4 == "number" && isFinite(data4)) {
        if (data4 > 20 || isNaN(data4)) {
          const err10 = { instancePath: instancePath + "/limit", schemaPath: "#/properties/limit/maximum", keyword: "maximum", params: { comparison: "<=", limit: 20 }, message: "must be <= 20" };
          if (vErrors === null) {
            vErrors = [err10];
          } else {
            vErrors.push(err10);
          }
          errors++;
        }
        if (data4 < 1 || isNaN(data4)) {
          const err11 = { instancePath: instancePath + "/limit", schemaPath: "#/properties/limit/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" };
          if (vErrors === null) {
            vErrors = [err11];
          } else {
            vErrors.push(err11);
          }
          errors++;
        }
      }
    }
    if (data.maxChars !== void 0) {
      let data5 = data.maxChars;
      if (!(typeof data5 == "number" && (!(data5 % 1) && !isNaN(data5)) && isFinite(data5))) {
        const err12 = { instancePath: instancePath + "/maxChars", schemaPath: "#/properties/maxChars/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
        if (vErrors === null) {
          vErrors = [err12];
        } else {
          vErrors.push(err12);
        }
        errors++;
      }
      if (typeof data5 == "number" && isFinite(data5)) {
        if (data5 > 4e3 || isNaN(data5)) {
          const err13 = { instancePath: instancePath + "/maxChars", schemaPath: "#/properties/maxChars/maximum", keyword: "maximum", params: { comparison: "<=", limit: 4e3 }, message: "must be <= 4000" };
          if (vErrors === null) {
            vErrors = [err13];
          } else {
            vErrors.push(err13);
          }
          errors++;
        }
        if (data5 < 100 || isNaN(data5)) {
          const err14 = { instancePath: instancePath + "/maxChars", schemaPath: "#/properties/maxChars/minimum", keyword: "minimum", params: { comparison: ">=", limit: 100 }, message: "must be >= 100" };
          if (vErrors === null) {
            vErrors = [err14];
          } else {
            vErrors.push(err14);
          }
          errors++;
        }
      }
    }
    if (data.cursor !== void 0) {
      if (typeof data.cursor !== "string") {
        const err15 = { instancePath: instancePath + "/cursor", schemaPath: "#/properties/cursor/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err15];
        } else {
          vErrors.push(err15);
        }
        errors++;
      }
    }
  } else {
    const err16 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err16];
    } else {
      vErrors.push(err16);
    }
    errors++;
  }
  validate24.errors = vErrors;
  return errors === 0;
}
var validateOutput7 = validate25;
var schema28 = { "type": "object", "properties": { "object": { "type": "string", "const": "search_hit" }, "chunkId": { "type": "string", "description": "The passage; retrieve it with GET /api/search/documents/{id}, cite it as /sources/{chunkId}." }, "docId": { "type": "string", "description": "The document the passage is part of." }, "heading": { "type": "string" }, "title": { "type": "string" }, "url": { "type": "string", "format": "uri", "description": "The page or file the text was taken from." }, "source": { "type": "string", "description": "The corpus source, e.g. goz-kommentar." }, "fetchedAt": { "type": "string", "format": "date-time", "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$", "description": "When the text was taken from the url." }, "score": { "type": "number", "description": "BM25; higher is better, comparable only within one result." }, "text": { "type": "string", "description": "The passage, verbatim, cut to maxChars." } }, "required": ["object", "chunkId", "docId", "heading", "title", "url", "source", "fetchedAt", "score", "text"], "additionalProperties": false };
function validate25(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.object === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "object" }, message: "must have required property 'object'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.data === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "data" }, message: "must have required property 'data'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.nextCursor === void 0) {
      const err2 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "nextCursor" }, message: "must have required property 'nextCursor'" };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    for (const key0 in data) {
      if (!(key0 === "object" || key0 === "data" || key0 === "nextCursor")) {
        const err3 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.object !== void 0) {
      let data0 = data.object;
      if (typeof data0 !== "string") {
        const err4 = { instancePath: instancePath + "/object", schemaPath: "#/properties/object/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
      if ("search_result" !== data0) {
        const err5 = { instancePath: instancePath + "/object", schemaPath: "#/properties/object/const", keyword: "const", params: { allowedValue: "search_result" }, message: "must be equal to constant" };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
    }
    if (data.data !== void 0) {
      let data1 = data.data;
      if (Array.isArray(data1)) {
        const len0 = data1.length;
        for (let i0 = 0; i0 < len0; i0++) {
          let data2 = data1[i0];
          if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
            if (data2.object === void 0) {
              const err6 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/definitions/SearchHit/required", keyword: "required", params: { missingProperty: "object" }, message: "must have required property 'object'" };
              if (vErrors === null) {
                vErrors = [err6];
              } else {
                vErrors.push(err6);
              }
              errors++;
            }
            if (data2.chunkId === void 0) {
              const err7 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/definitions/SearchHit/required", keyword: "required", params: { missingProperty: "chunkId" }, message: "must have required property 'chunkId'" };
              if (vErrors === null) {
                vErrors = [err7];
              } else {
                vErrors.push(err7);
              }
              errors++;
            }
            if (data2.docId === void 0) {
              const err8 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/definitions/SearchHit/required", keyword: "required", params: { missingProperty: "docId" }, message: "must have required property 'docId'" };
              if (vErrors === null) {
                vErrors = [err8];
              } else {
                vErrors.push(err8);
              }
              errors++;
            }
            if (data2.heading === void 0) {
              const err9 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/definitions/SearchHit/required", keyword: "required", params: { missingProperty: "heading" }, message: "must have required property 'heading'" };
              if (vErrors === null) {
                vErrors = [err9];
              } else {
                vErrors.push(err9);
              }
              errors++;
            }
            if (data2.title === void 0) {
              const err10 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/definitions/SearchHit/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
              if (vErrors === null) {
                vErrors = [err10];
              } else {
                vErrors.push(err10);
              }
              errors++;
            }
            if (data2.url === void 0) {
              const err11 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/definitions/SearchHit/required", keyword: "required", params: { missingProperty: "url" }, message: "must have required property 'url'" };
              if (vErrors === null) {
                vErrors = [err11];
              } else {
                vErrors.push(err11);
              }
              errors++;
            }
            if (data2.source === void 0) {
              const err12 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/definitions/SearchHit/required", keyword: "required", params: { missingProperty: "source" }, message: "must have required property 'source'" };
              if (vErrors === null) {
                vErrors = [err12];
              } else {
                vErrors.push(err12);
              }
              errors++;
            }
            if (data2.fetchedAt === void 0) {
              const err13 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/definitions/SearchHit/required", keyword: "required", params: { missingProperty: "fetchedAt" }, message: "must have required property 'fetchedAt'" };
              if (vErrors === null) {
                vErrors = [err13];
              } else {
                vErrors.push(err13);
              }
              errors++;
            }
            if (data2.score === void 0) {
              const err14 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/definitions/SearchHit/required", keyword: "required", params: { missingProperty: "score" }, message: "must have required property 'score'" };
              if (vErrors === null) {
                vErrors = [err14];
              } else {
                vErrors.push(err14);
              }
              errors++;
            }
            if (data2.text === void 0) {
              const err15 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/definitions/SearchHit/required", keyword: "required", params: { missingProperty: "text" }, message: "must have required property 'text'" };
              if (vErrors === null) {
                vErrors = [err15];
              } else {
                vErrors.push(err15);
              }
              errors++;
            }
            for (const key1 in data2) {
              if (!func6.call(schema28.properties, key1)) {
                const err16 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/definitions/SearchHit/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
                if (vErrors === null) {
                  vErrors = [err16];
                } else {
                  vErrors.push(err16);
                }
                errors++;
              }
            }
            if (data2.object !== void 0) {
              let data3 = data2.object;
              if (typeof data3 !== "string") {
                const err17 = { instancePath: instancePath + "/data/" + i0 + "/object", schemaPath: "#/definitions/SearchHit/properties/object/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err17];
                } else {
                  vErrors.push(err17);
                }
                errors++;
              }
              if ("search_hit" !== data3) {
                const err18 = { instancePath: instancePath + "/data/" + i0 + "/object", schemaPath: "#/definitions/SearchHit/properties/object/const", keyword: "const", params: { allowedValue: "search_hit" }, message: "must be equal to constant" };
                if (vErrors === null) {
                  vErrors = [err18];
                } else {
                  vErrors.push(err18);
                }
                errors++;
              }
            }
            if (data2.chunkId !== void 0) {
              if (typeof data2.chunkId !== "string") {
                const err19 = { instancePath: instancePath + "/data/" + i0 + "/chunkId", schemaPath: "#/definitions/SearchHit/properties/chunkId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err19];
                } else {
                  vErrors.push(err19);
                }
                errors++;
              }
            }
            if (data2.docId !== void 0) {
              if (typeof data2.docId !== "string") {
                const err20 = { instancePath: instancePath + "/data/" + i0 + "/docId", schemaPath: "#/definitions/SearchHit/properties/docId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err20];
                } else {
                  vErrors.push(err20);
                }
                errors++;
              }
            }
            if (data2.heading !== void 0) {
              if (typeof data2.heading !== "string") {
                const err21 = { instancePath: instancePath + "/data/" + i0 + "/heading", schemaPath: "#/definitions/SearchHit/properties/heading/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err21];
                } else {
                  vErrors.push(err21);
                }
                errors++;
              }
            }
            if (data2.title !== void 0) {
              if (typeof data2.title !== "string") {
                const err22 = { instancePath: instancePath + "/data/" + i0 + "/title", schemaPath: "#/definitions/SearchHit/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err22];
                } else {
                  vErrors.push(err22);
                }
                errors++;
              }
            }
            if (data2.url !== void 0) {
              let data8 = data2.url;
              if (typeof data8 === "string") {
                if (!formats18(data8)) {
                  const err23 = { instancePath: instancePath + "/data/" + i0 + "/url", schemaPath: "#/definitions/SearchHit/properties/url/format", keyword: "format", params: { format: "uri" }, message: 'must match format "uri"' };
                  if (vErrors === null) {
                    vErrors = [err23];
                  } else {
                    vErrors.push(err23);
                  }
                  errors++;
                }
              } else {
                const err24 = { instancePath: instancePath + "/data/" + i0 + "/url", schemaPath: "#/definitions/SearchHit/properties/url/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err24];
                } else {
                  vErrors.push(err24);
                }
                errors++;
              }
            }
            if (data2.source !== void 0) {
              if (typeof data2.source !== "string") {
                const err25 = { instancePath: instancePath + "/data/" + i0 + "/source", schemaPath: "#/definitions/SearchHit/properties/source/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err25];
                } else {
                  vErrors.push(err25);
                }
                errors++;
              }
            }
            if (data2.fetchedAt !== void 0) {
              let data10 = data2.fetchedAt;
              if (typeof data10 === "string") {
                if (!pattern0.test(data10)) {
                  const err26 = { instancePath: instancePath + "/data/" + i0 + "/fetchedAt", schemaPath: "#/definitions/SearchHit/properties/fetchedAt/pattern", keyword: "pattern", params: { pattern: "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, message: 'must match pattern "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"' };
                  if (vErrors === null) {
                    vErrors = [err26];
                  } else {
                    vErrors.push(err26);
                  }
                  errors++;
                }
                if (!formats0.validate(data10)) {
                  const err27 = { instancePath: instancePath + "/data/" + i0 + "/fetchedAt", schemaPath: "#/definitions/SearchHit/properties/fetchedAt/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' };
                  if (vErrors === null) {
                    vErrors = [err27];
                  } else {
                    vErrors.push(err27);
                  }
                  errors++;
                }
              } else {
                const err28 = { instancePath: instancePath + "/data/" + i0 + "/fetchedAt", schemaPath: "#/definitions/SearchHit/properties/fetchedAt/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err28];
                } else {
                  vErrors.push(err28);
                }
                errors++;
              }
            }
            if (data2.score !== void 0) {
              let data11 = data2.score;
              if (!(typeof data11 == "number" && isFinite(data11))) {
                const err29 = { instancePath: instancePath + "/data/" + i0 + "/score", schemaPath: "#/definitions/SearchHit/properties/score/type", keyword: "type", params: { type: "number" }, message: "must be number" };
                if (vErrors === null) {
                  vErrors = [err29];
                } else {
                  vErrors.push(err29);
                }
                errors++;
              }
            }
            if (data2.text !== void 0) {
              if (typeof data2.text !== "string") {
                const err30 = { instancePath: instancePath + "/data/" + i0 + "/text", schemaPath: "#/definitions/SearchHit/properties/text/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err30];
                } else {
                  vErrors.push(err30);
                }
                errors++;
              }
            }
          } else {
            const err31 = { instancePath: instancePath + "/data/" + i0, schemaPath: "#/definitions/SearchHit/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
              vErrors = [err31];
            } else {
              vErrors.push(err31);
            }
            errors++;
          }
        }
      } else {
        const err32 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/type", keyword: "type", params: { type: "array" }, message: "must be array" };
        if (vErrors === null) {
          vErrors = [err32];
        } else {
          vErrors.push(err32);
        }
        errors++;
      }
    }
    if (data.nextCursor !== void 0) {
      let data13 = data.nextCursor;
      const _errs31 = errors;
      let valid5 = false;
      const _errs32 = errors;
      if (typeof data13 !== "string") {
        const err33 = { instancePath: instancePath + "/nextCursor", schemaPath: "#/properties/nextCursor/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err33];
        } else {
          vErrors.push(err33);
        }
        errors++;
      }
      var _valid0 = _errs32 === errors;
      valid5 = valid5 || _valid0;
      if (!valid5) {
        const _errs34 = errors;
        if (data13 !== null) {
          const err34 = { instancePath: instancePath + "/nextCursor", schemaPath: "#/properties/nextCursor/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
          if (vErrors === null) {
            vErrors = [err34];
          } else {
            vErrors.push(err34);
          }
          errors++;
        }
        var _valid0 = _errs34 === errors;
        valid5 = valid5 || _valid0;
      }
      if (!valid5) {
        const err35 = { instancePath: instancePath + "/nextCursor", schemaPath: "#/properties/nextCursor/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
        if (vErrors === null) {
          vErrors = [err35];
        } else {
          vErrors.push(err35);
        }
        errors++;
      } else {
        errors = _errs31;
        if (vErrors !== null) {
          if (_errs31) {
            vErrors.length = _errs31;
          } else {
            vErrors = null;
          }
        }
      }
    }
  } else {
    const err36 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err36];
    } else {
      vErrors.push(err36);
    }
    errors++;
  }
  validate25.errors = vErrors;
  return errors === 0;
}
var validateInput8 = validate26;
function validate26(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.id === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property 'id'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    for (const key0 in data) {
      if (!(key0 === "id" || key0 === "from" || key0 === "to")) {
        const err1 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
    }
    if (data.id !== void 0) {
      let data0 = data.id;
      if (typeof data0 === "string") {
        if (func2(data0) < 1) {
          const err2 = { instancePath: instancePath + "/id", schemaPath: "#/properties/id/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
          if (vErrors === null) {
            vErrors = [err2];
          } else {
            vErrors.push(err2);
          }
          errors++;
        }
      } else {
        const err3 = { instancePath: instancePath + "/id", schemaPath: "#/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.from !== void 0) {
      let data1 = data.from;
      if (!(typeof data1 == "number" && (!(data1 % 1) && !isNaN(data1)) && isFinite(data1))) {
        const err4 = { instancePath: instancePath + "/from", schemaPath: "#/properties/from/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
      if (typeof data1 == "number" && isFinite(data1)) {
        if (data1 > 9007199254740991 || isNaN(data1)) {
          const err5 = { instancePath: instancePath + "/from", schemaPath: "#/properties/from/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
          if (vErrors === null) {
            vErrors = [err5];
          } else {
            vErrors.push(err5);
          }
          errors++;
        }
        if (data1 < 0 || isNaN(data1)) {
          const err6 = { instancePath: instancePath + "/from", schemaPath: "#/properties/from/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
          if (vErrors === null) {
            vErrors = [err6];
          } else {
            vErrors.push(err6);
          }
          errors++;
        }
      }
    }
    if (data.to !== void 0) {
      let data2 = data.to;
      if (!(typeof data2 == "number" && (!(data2 % 1) && !isNaN(data2)) && isFinite(data2))) {
        const err7 = { instancePath: instancePath + "/to", schemaPath: "#/properties/to/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
      if (typeof data2 == "number" && isFinite(data2)) {
        if (data2 > 9007199254740991 || isNaN(data2)) {
          const err8 = { instancePath: instancePath + "/to", schemaPath: "#/properties/to/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
          if (vErrors === null) {
            vErrors = [err8];
          } else {
            vErrors.push(err8);
          }
          errors++;
        }
        if (data2 < 0 || isNaN(data2)) {
          const err9 = { instancePath: instancePath + "/to", schemaPath: "#/properties/to/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
          if (vErrors === null) {
            vErrors = [err9];
          } else {
            vErrors.push(err9);
          }
          errors++;
        }
      }
    }
  } else {
    const err10 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err10];
    } else {
      vErrors.push(err10);
    }
    errors++;
  }
  validate26.errors = vErrors;
  return errors === 0;
}
var validateOutput8 = validate27;
var schema31 = { "type": "object", "properties": { "object": { "type": "string", "const": "search_document" }, "id": { "type": "string" }, "title": { "type": "string" }, "url": { "type": "string", "format": "uri", "description": "The page or file the text was taken from." }, "source": { "type": "string", "description": "The corpus source, e.g. goz-kommentar." }, "fetchedAt": { "type": "string", "format": "date-time", "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$", "description": "When the text was taken from the url." }, "date": { "description": "The date the document states, if any (ISO 8601).", "type": "string" }, "chunkCount": { "type": "integer", "minimum": 0, "maximum": 9007199254740991, "description": "How many chunks the document has." }, "chunks": { "type": "array", "items": { "type": "object", "properties": { "id": { "type": "string" }, "position": { "type": "integer", "minimum": 0, "maximum": 9007199254740991 }, "heading": { "type": "string" }, "text": { "type": "string" } }, "required": ["id", "position", "heading", "text"], "additionalProperties": false }, "description": "The chunks returned, in document order." } }, "required": ["object", "id", "title", "url", "source", "fetchedAt", "chunkCount", "chunks"], "additionalProperties": false };
function validate27(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.object === void 0) {
      const err0 = { instancePath, schemaPath: "#/definitions/SearchDocument/required", keyword: "required", params: { missingProperty: "object" }, message: "must have required property 'object'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.id === void 0) {
      const err1 = { instancePath, schemaPath: "#/definitions/SearchDocument/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property 'id'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.title === void 0) {
      const err2 = { instancePath, schemaPath: "#/definitions/SearchDocument/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.url === void 0) {
      const err3 = { instancePath, schemaPath: "#/definitions/SearchDocument/required", keyword: "required", params: { missingProperty: "url" }, message: "must have required property 'url'" };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.source === void 0) {
      const err4 = { instancePath, schemaPath: "#/definitions/SearchDocument/required", keyword: "required", params: { missingProperty: "source" }, message: "must have required property 'source'" };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
    if (data.fetchedAt === void 0) {
      const err5 = { instancePath, schemaPath: "#/definitions/SearchDocument/required", keyword: "required", params: { missingProperty: "fetchedAt" }, message: "must have required property 'fetchedAt'" };
      if (vErrors === null) {
        vErrors = [err5];
      } else {
        vErrors.push(err5);
      }
      errors++;
    }
    if (data.chunkCount === void 0) {
      const err6 = { instancePath, schemaPath: "#/definitions/SearchDocument/required", keyword: "required", params: { missingProperty: "chunkCount" }, message: "must have required property 'chunkCount'" };
      if (vErrors === null) {
        vErrors = [err6];
      } else {
        vErrors.push(err6);
      }
      errors++;
    }
    if (data.chunks === void 0) {
      const err7 = { instancePath, schemaPath: "#/definitions/SearchDocument/required", keyword: "required", params: { missingProperty: "chunks" }, message: "must have required property 'chunks'" };
      if (vErrors === null) {
        vErrors = [err7];
      } else {
        vErrors.push(err7);
      }
      errors++;
    }
    for (const key0 in data) {
      if (!func6.call(schema31.properties, key0)) {
        const err8 = { instancePath, schemaPath: "#/definitions/SearchDocument/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
    }
    if (data.object !== void 0) {
      let data0 = data.object;
      if (typeof data0 !== "string") {
        const err9 = { instancePath: instancePath + "/object", schemaPath: "#/definitions/SearchDocument/properties/object/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
      if ("search_document" !== data0) {
        const err10 = { instancePath: instancePath + "/object", schemaPath: "#/definitions/SearchDocument/properties/object/const", keyword: "const", params: { allowedValue: "search_document" }, message: "must be equal to constant" };
        if (vErrors === null) {
          vErrors = [err10];
        } else {
          vErrors.push(err10);
        }
        errors++;
      }
    }
    if (data.id !== void 0) {
      if (typeof data.id !== "string") {
        const err11 = { instancePath: instancePath + "/id", schemaPath: "#/definitions/SearchDocument/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err11];
        } else {
          vErrors.push(err11);
        }
        errors++;
      }
    }
    if (data.title !== void 0) {
      if (typeof data.title !== "string") {
        const err12 = { instancePath: instancePath + "/title", schemaPath: "#/definitions/SearchDocument/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err12];
        } else {
          vErrors.push(err12);
        }
        errors++;
      }
    }
    if (data.url !== void 0) {
      let data3 = data.url;
      if (typeof data3 === "string") {
        if (!formats18(data3)) {
          const err13 = { instancePath: instancePath + "/url", schemaPath: "#/definitions/SearchDocument/properties/url/format", keyword: "format", params: { format: "uri" }, message: 'must match format "uri"' };
          if (vErrors === null) {
            vErrors = [err13];
          } else {
            vErrors.push(err13);
          }
          errors++;
        }
      } else {
        const err14 = { instancePath: instancePath + "/url", schemaPath: "#/definitions/SearchDocument/properties/url/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err14];
        } else {
          vErrors.push(err14);
        }
        errors++;
      }
    }
    if (data.source !== void 0) {
      if (typeof data.source !== "string") {
        const err15 = { instancePath: instancePath + "/source", schemaPath: "#/definitions/SearchDocument/properties/source/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err15];
        } else {
          vErrors.push(err15);
        }
        errors++;
      }
    }
    if (data.fetchedAt !== void 0) {
      let data5 = data.fetchedAt;
      if (typeof data5 === "string") {
        if (!pattern0.test(data5)) {
          const err16 = { instancePath: instancePath + "/fetchedAt", schemaPath: "#/definitions/SearchDocument/properties/fetchedAt/pattern", keyword: "pattern", params: { pattern: "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, message: 'must match pattern "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"' };
          if (vErrors === null) {
            vErrors = [err16];
          } else {
            vErrors.push(err16);
          }
          errors++;
        }
        if (!formats0.validate(data5)) {
          const err17 = { instancePath: instancePath + "/fetchedAt", schemaPath: "#/definitions/SearchDocument/properties/fetchedAt/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' };
          if (vErrors === null) {
            vErrors = [err17];
          } else {
            vErrors.push(err17);
          }
          errors++;
        }
      } else {
        const err18 = { instancePath: instancePath + "/fetchedAt", schemaPath: "#/definitions/SearchDocument/properties/fetchedAt/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err18];
        } else {
          vErrors.push(err18);
        }
        errors++;
      }
    }
    if (data.date !== void 0) {
      if (typeof data.date !== "string") {
        const err19 = { instancePath: instancePath + "/date", schemaPath: "#/definitions/SearchDocument/properties/date/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err19];
        } else {
          vErrors.push(err19);
        }
        errors++;
      }
    }
    if (data.chunkCount !== void 0) {
      let data7 = data.chunkCount;
      if (!(typeof data7 == "number" && (!(data7 % 1) && !isNaN(data7)) && isFinite(data7))) {
        const err20 = { instancePath: instancePath + "/chunkCount", schemaPath: "#/definitions/SearchDocument/properties/chunkCount/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
        if (vErrors === null) {
          vErrors = [err20];
        } else {
          vErrors.push(err20);
        }
        errors++;
      }
      if (typeof data7 == "number" && isFinite(data7)) {
        if (data7 > 9007199254740991 || isNaN(data7)) {
          const err21 = { instancePath: instancePath + "/chunkCount", schemaPath: "#/definitions/SearchDocument/properties/chunkCount/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
          if (vErrors === null) {
            vErrors = [err21];
          } else {
            vErrors.push(err21);
          }
          errors++;
        }
        if (data7 < 0 || isNaN(data7)) {
          const err22 = { instancePath: instancePath + "/chunkCount", schemaPath: "#/definitions/SearchDocument/properties/chunkCount/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
          if (vErrors === null) {
            vErrors = [err22];
          } else {
            vErrors.push(err22);
          }
          errors++;
        }
      }
    }
    if (data.chunks !== void 0) {
      let data8 = data.chunks;
      if (Array.isArray(data8)) {
        const len0 = data8.length;
        for (let i0 = 0; i0 < len0; i0++) {
          let data9 = data8[i0];
          if (data9 && typeof data9 == "object" && !Array.isArray(data9)) {
            if (data9.id === void 0) {
              const err23 = { instancePath: instancePath + "/chunks/" + i0, schemaPath: "#/definitions/SearchDocument/properties/chunks/items/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property 'id'" };
              if (vErrors === null) {
                vErrors = [err23];
              } else {
                vErrors.push(err23);
              }
              errors++;
            }
            if (data9.position === void 0) {
              const err24 = { instancePath: instancePath + "/chunks/" + i0, schemaPath: "#/definitions/SearchDocument/properties/chunks/items/required", keyword: "required", params: { missingProperty: "position" }, message: "must have required property 'position'" };
              if (vErrors === null) {
                vErrors = [err24];
              } else {
                vErrors.push(err24);
              }
              errors++;
            }
            if (data9.heading === void 0) {
              const err25 = { instancePath: instancePath + "/chunks/" + i0, schemaPath: "#/definitions/SearchDocument/properties/chunks/items/required", keyword: "required", params: { missingProperty: "heading" }, message: "must have required property 'heading'" };
              if (vErrors === null) {
                vErrors = [err25];
              } else {
                vErrors.push(err25);
              }
              errors++;
            }
            if (data9.text === void 0) {
              const err26 = { instancePath: instancePath + "/chunks/" + i0, schemaPath: "#/definitions/SearchDocument/properties/chunks/items/required", keyword: "required", params: { missingProperty: "text" }, message: "must have required property 'text'" };
              if (vErrors === null) {
                vErrors = [err26];
              } else {
                vErrors.push(err26);
              }
              errors++;
            }
            for (const key1 in data9) {
              if (!(key1 === "id" || key1 === "position" || key1 === "heading" || key1 === "text")) {
                const err27 = { instancePath: instancePath + "/chunks/" + i0, schemaPath: "#/definitions/SearchDocument/properties/chunks/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
                if (vErrors === null) {
                  vErrors = [err27];
                } else {
                  vErrors.push(err27);
                }
                errors++;
              }
            }
            if (data9.id !== void 0) {
              if (typeof data9.id !== "string") {
                const err28 = { instancePath: instancePath + "/chunks/" + i0 + "/id", schemaPath: "#/definitions/SearchDocument/properties/chunks/items/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err28];
                } else {
                  vErrors.push(err28);
                }
                errors++;
              }
            }
            if (data9.position !== void 0) {
              let data11 = data9.position;
              if (!(typeof data11 == "number" && (!(data11 % 1) && !isNaN(data11)) && isFinite(data11))) {
                const err29 = { instancePath: instancePath + "/chunks/" + i0 + "/position", schemaPath: "#/definitions/SearchDocument/properties/chunks/items/properties/position/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                if (vErrors === null) {
                  vErrors = [err29];
                } else {
                  vErrors.push(err29);
                }
                errors++;
              }
              if (typeof data11 == "number" && isFinite(data11)) {
                if (data11 > 9007199254740991 || isNaN(data11)) {
                  const err30 = { instancePath: instancePath + "/chunks/" + i0 + "/position", schemaPath: "#/definitions/SearchDocument/properties/chunks/items/properties/position/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err30];
                  } else {
                    vErrors.push(err30);
                  }
                  errors++;
                }
                if (data11 < 0 || isNaN(data11)) {
                  const err31 = { instancePath: instancePath + "/chunks/" + i0 + "/position", schemaPath: "#/definitions/SearchDocument/properties/chunks/items/properties/position/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
                  if (vErrors === null) {
                    vErrors = [err31];
                  } else {
                    vErrors.push(err31);
                  }
                  errors++;
                }
              }
            }
            if (data9.heading !== void 0) {
              if (typeof data9.heading !== "string") {
                const err32 = { instancePath: instancePath + "/chunks/" + i0 + "/heading", schemaPath: "#/definitions/SearchDocument/properties/chunks/items/properties/heading/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err32];
                } else {
                  vErrors.push(err32);
                }
                errors++;
              }
            }
            if (data9.text !== void 0) {
              if (typeof data9.text !== "string") {
                const err33 = { instancePath: instancePath + "/chunks/" + i0 + "/text", schemaPath: "#/definitions/SearchDocument/properties/chunks/items/properties/text/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err33];
                } else {
                  vErrors.push(err33);
                }
                errors++;
              }
            }
          } else {
            const err34 = { instancePath: instancePath + "/chunks/" + i0, schemaPath: "#/definitions/SearchDocument/properties/chunks/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
              vErrors = [err34];
            } else {
              vErrors.push(err34);
            }
            errors++;
          }
        }
      } else {
        const err35 = { instancePath: instancePath + "/chunks", schemaPath: "#/definitions/SearchDocument/properties/chunks/type", keyword: "type", params: { type: "array" }, message: "must be array" };
        if (vErrors === null) {
          vErrors = [err35];
        } else {
          vErrors.push(err35);
        }
        errors++;
      }
    }
  } else {
    const err36 = { instancePath, schemaPath: "#/definitions/SearchDocument/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err36];
    } else {
      vErrors.push(err36);
    }
    errors++;
  }
  validate27.errors = vErrors;
  return errors === 0;
}
var validateInput9 = validate28;
function validate28(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.conversationId === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "conversationId" }, message: "must have required property 'conversationId'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    for (const key0 in data) {
      if (!(key0 === "conversationId")) {
        const err1 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
    }
    if (data.conversationId !== void 0) {
      let data0 = data.conversationId;
      if (typeof data0 === "string") {
        if (func2(data0) < 1) {
          const err2 = { instancePath: instancePath + "/conversationId", schemaPath: "#/properties/conversationId/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
          if (vErrors === null) {
            vErrors = [err2];
          } else {
            vErrors.push(err2);
          }
          errors++;
        }
      } else {
        const err3 = { instancePath: instancePath + "/conversationId", schemaPath: "#/properties/conversationId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
  } else {
    const err4 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err4];
    } else {
      vErrors.push(err4);
    }
    errors++;
  }
  validate28.errors = vErrors;
  return errors === 0;
}
var validateOutput9 = validate29;
var schema34 = { "type": "object", "properties": { "object": { "type": "string", "const": "verification_case" }, "conversationId": { "type": "string" }, "teeth": { "type": "array", "items": { "type": "object", "properties": { "fdi": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "findings": { "type": "array", "items": { "type": "object", "properties": { "fact": { "type": "string", "enum": ["fehlt", "erhaltungswuerdig", "krone", "endodontisch_behandelt", "stiftaufbau", "brueckenanker", "disparallel", "wiederherstellung", "geplant", "lueckensituation_i"], "description": "A finding, by name: at a tooth, or at a jaw (lueckensituation_i)." }, "value": { "anyOf": [{ "type": "boolean" }, { "type": "string" }] }, "status": { "type": "string", "enum": ["proposed", "confirmed"], "description": "Proposed by the agent, or confirmed by the dentist. Rules read only confirmed ones." }, "quote": { "description": "The dentist's words a proposal was read from.", "type": "string" }, "statedIn": { "description": "The statement a confirmed finding rests on.", "type": "string" } }, "required": ["fact", "value", "status"], "additionalProperties": false } } }, "required": ["fdi", "findings"], "additionalProperties": false } }, "jaws": { "type": "array", "items": { "type": "object", "properties": { "jaw": { "type": "string", "enum": ["OK", "UK"], "description": "The jaw: OK upper, UK lower." }, "findings": { "type": "array", "items": { "type": "object", "properties": { "fact": { "type": "string", "enum": ["fehlt", "erhaltungswuerdig", "krone", "endodontisch_behandelt", "stiftaufbau", "brueckenanker", "disparallel", "wiederherstellung", "geplant", "lueckensituation_i"], "description": "A finding, by name: at a tooth, or at a jaw (lueckensituation_i)." }, "value": { "anyOf": [{ "type": "boolean" }, { "type": "string" }] }, "status": { "type": "string", "enum": ["proposed", "confirmed"], "description": "Proposed by the agent, or confirmed by the dentist. Rules read only confirmed ones." }, "quote": { "description": "The dentist's words a proposal was read from.", "type": "string" }, "statedIn": { "description": "The statement a confirmed finding rests on.", "type": "string" } }, "required": ["fact", "value", "status"], "additionalProperties": false } } }, "required": ["jaw", "findings"], "additionalProperties": false }, "description": "Findings at a jaw: whether it is in L\xFCckensituation I." }, "statements": { "type": "array", "items": { "type": "object", "properties": { "id": { "type": "string" }, "at": { "type": "string", "format": "date-time", "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" } }, "required": ["id", "at"], "additionalProperties": false } }, "counts": { "type": "array", "items": { "type": "object", "properties": { "at": { "type": "string", "description": `Where the line is billed, as the costs list it: a tooth's number ("12"), a gap's id ("UK:45-47"), a jaw, or "patient".` }, "nr": { "type": "string", "description": "The BEMA number, e.g. 20b." }, "value": { "type": "integer", "minimum": 1, "maximum": 99, "description": "How often it goes on the HKP." }, "statedIn": { "type": "string" } }, "required": ["at", "nr", "value", "statedIn"], "additionalProperties": false }, "description": "The dentist's counts for BEMA lines no source counts; the costs bill these." }, "bonus": { "description": "The patient's subsidy level, once the dentist states it.", "type": "object", "properties": { "value": { "type": "string", "enum": ["prozent60", "prozent70", "prozent75", "prozent100"], "description": "The Festzuschuss level from the patient's Bonusheft: 60 % without bonus, 70 % and 75 % with, 100 % for hardship." }, "statedIn": { "type": "string" } }, "required": ["value", "statedIn"], "additionalProperties": false }, "kostentraeger": { "description": "Who pays, once the dentist confirms it; assumed until then.", "type": "object", "properties": { "value": { "type": "string", "enum": ["gkv_kzv_bw"], "description": "Who pays: statutory insurance, billed at the KZV Baden-W\xFCrttemberg's prices, the only one the rules cover." }, "statedIn": { "type": "string" } }, "required": ["value", "statedIn"], "additionalProperties": false } }, "required": ["object", "conversationId", "teeth", "jaws", "statements", "counts"], "additionalProperties": false };
function validate29(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.object === void 0) {
      const err0 = { instancePath, schemaPath: "#/definitions/VerificationCase/required", keyword: "required", params: { missingProperty: "object" }, message: "must have required property 'object'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.conversationId === void 0) {
      const err1 = { instancePath, schemaPath: "#/definitions/VerificationCase/required", keyword: "required", params: { missingProperty: "conversationId" }, message: "must have required property 'conversationId'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.teeth === void 0) {
      const err2 = { instancePath, schemaPath: "#/definitions/VerificationCase/required", keyword: "required", params: { missingProperty: "teeth" }, message: "must have required property 'teeth'" };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.jaws === void 0) {
      const err3 = { instancePath, schemaPath: "#/definitions/VerificationCase/required", keyword: "required", params: { missingProperty: "jaws" }, message: "must have required property 'jaws'" };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.statements === void 0) {
      const err4 = { instancePath, schemaPath: "#/definitions/VerificationCase/required", keyword: "required", params: { missingProperty: "statements" }, message: "must have required property 'statements'" };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
    if (data.counts === void 0) {
      const err5 = { instancePath, schemaPath: "#/definitions/VerificationCase/required", keyword: "required", params: { missingProperty: "counts" }, message: "must have required property 'counts'" };
      if (vErrors === null) {
        vErrors = [err5];
      } else {
        vErrors.push(err5);
      }
      errors++;
    }
    for (const key0 in data) {
      if (!(key0 === "object" || key0 === "conversationId" || key0 === "teeth" || key0 === "jaws" || key0 === "statements" || key0 === "counts" || key0 === "bonus" || key0 === "kostentraeger")) {
        const err6 = { instancePath, schemaPath: "#/definitions/VerificationCase/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
    }
    if (data.object !== void 0) {
      let data0 = data.object;
      if (typeof data0 !== "string") {
        const err7 = { instancePath: instancePath + "/object", schemaPath: "#/definitions/VerificationCase/properties/object/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
      if ("verification_case" !== data0) {
        const err8 = { instancePath: instancePath + "/object", schemaPath: "#/definitions/VerificationCase/properties/object/const", keyword: "const", params: { allowedValue: "verification_case" }, message: "must be equal to constant" };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
    }
    if (data.conversationId !== void 0) {
      if (typeof data.conversationId !== "string") {
        const err9 = { instancePath: instancePath + "/conversationId", schemaPath: "#/definitions/VerificationCase/properties/conversationId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
    }
    if (data.teeth !== void 0) {
      let data2 = data.teeth;
      if (Array.isArray(data2)) {
        const len0 = data2.length;
        for (let i0 = 0; i0 < len0; i0++) {
          let data3 = data2[i0];
          if (data3 && typeof data3 == "object" && !Array.isArray(data3)) {
            if (data3.fdi === void 0) {
              const err10 = { instancePath: instancePath + "/teeth/" + i0, schemaPath: "#/definitions/VerificationCase/properties/teeth/items/required", keyword: "required", params: { missingProperty: "fdi" }, message: "must have required property 'fdi'" };
              if (vErrors === null) {
                vErrors = [err10];
              } else {
                vErrors.push(err10);
              }
              errors++;
            }
            if (data3.findings === void 0) {
              const err11 = { instancePath: instancePath + "/teeth/" + i0, schemaPath: "#/definitions/VerificationCase/properties/teeth/items/required", keyword: "required", params: { missingProperty: "findings" }, message: "must have required property 'findings'" };
              if (vErrors === null) {
                vErrors = [err11];
              } else {
                vErrors.push(err11);
              }
              errors++;
            }
            for (const key1 in data3) {
              if (!(key1 === "fdi" || key1 === "findings")) {
                const err12 = { instancePath: instancePath + "/teeth/" + i0, schemaPath: "#/definitions/VerificationCase/properties/teeth/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
                if (vErrors === null) {
                  vErrors = [err12];
                } else {
                  vErrors.push(err12);
                }
                errors++;
              }
            }
            if (data3.fdi !== void 0) {
              let data4 = data3.fdi;
              if (!(typeof data4 == "number" && (!(data4 % 1) && !isNaN(data4)) && isFinite(data4))) {
                const err13 = { instancePath: instancePath + "/teeth/" + i0 + "/fdi", schemaPath: "#/definitions/VerificationCase/properties/teeth/items/properties/fdi/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                if (vErrors === null) {
                  vErrors = [err13];
                } else {
                  vErrors.push(err13);
                }
                errors++;
              }
              if (typeof data4 == "number" && isFinite(data4)) {
                if (data4 > 9007199254740991 || isNaN(data4)) {
                  const err14 = { instancePath: instancePath + "/teeth/" + i0 + "/fdi", schemaPath: "#/definitions/VerificationCase/properties/teeth/items/properties/fdi/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err14];
                  } else {
                    vErrors.push(err14);
                  }
                  errors++;
                }
                if (data4 < -9007199254740991 || isNaN(data4)) {
                  const err15 = { instancePath: instancePath + "/teeth/" + i0 + "/fdi", schemaPath: "#/definitions/VerificationCase/properties/teeth/items/properties/fdi/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err15];
                  } else {
                    vErrors.push(err15);
                  }
                  errors++;
                }
              }
            }
            if (data3.findings !== void 0) {
              let data5 = data3.findings;
              if (Array.isArray(data5)) {
                const len1 = data5.length;
                for (let i1 = 0; i1 < len1; i1++) {
                  let data6 = data5[i1];
                  if (data6 && typeof data6 == "object" && !Array.isArray(data6)) {
                    if (data6.fact === void 0) {
                      const err16 = { instancePath: instancePath + "/teeth/" + i0 + "/findings/" + i1, schemaPath: "#/definitions/VerificationCase/properties/teeth/items/properties/findings/items/required", keyword: "required", params: { missingProperty: "fact" }, message: "must have required property 'fact'" };
                      if (vErrors === null) {
                        vErrors = [err16];
                      } else {
                        vErrors.push(err16);
                      }
                      errors++;
                    }
                    if (data6.value === void 0) {
                      const err17 = { instancePath: instancePath + "/teeth/" + i0 + "/findings/" + i1, schemaPath: "#/definitions/VerificationCase/properties/teeth/items/properties/findings/items/required", keyword: "required", params: { missingProperty: "value" }, message: "must have required property 'value'" };
                      if (vErrors === null) {
                        vErrors = [err17];
                      } else {
                        vErrors.push(err17);
                      }
                      errors++;
                    }
                    if (data6.status === void 0) {
                      const err18 = { instancePath: instancePath + "/teeth/" + i0 + "/findings/" + i1, schemaPath: "#/definitions/VerificationCase/properties/teeth/items/properties/findings/items/required", keyword: "required", params: { missingProperty: "status" }, message: "must have required property 'status'" };
                      if (vErrors === null) {
                        vErrors = [err18];
                      } else {
                        vErrors.push(err18);
                      }
                      errors++;
                    }
                    for (const key2 in data6) {
                      if (!(key2 === "fact" || key2 === "value" || key2 === "status" || key2 === "quote" || key2 === "statedIn")) {
                        const err19 = { instancePath: instancePath + "/teeth/" + i0 + "/findings/" + i1, schemaPath: "#/definitions/VerificationCase/properties/teeth/items/properties/findings/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key2 }, message: "must NOT have additional properties" };
                        if (vErrors === null) {
                          vErrors = [err19];
                        } else {
                          vErrors.push(err19);
                        }
                        errors++;
                      }
                    }
                    if (data6.fact !== void 0) {
                      let data7 = data6.fact;
                      if (typeof data7 !== "string") {
                        const err20 = { instancePath: instancePath + "/teeth/" + i0 + "/findings/" + i1 + "/fact", schemaPath: "#/definitions/VerificationCase/properties/teeth/items/properties/findings/items/properties/fact/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err20];
                        } else {
                          vErrors.push(err20);
                        }
                        errors++;
                      }
                      if (!(data7 === "fehlt" || data7 === "erhaltungswuerdig" || data7 === "krone" || data7 === "endodontisch_behandelt" || data7 === "stiftaufbau" || data7 === "brueckenanker" || data7 === "disparallel" || data7 === "wiederherstellung" || data7 === "geplant" || data7 === "lueckensituation_i")) {
                        const err21 = { instancePath: instancePath + "/teeth/" + i0 + "/findings/" + i1 + "/fact", schemaPath: "#/definitions/VerificationCase/properties/teeth/items/properties/findings/items/properties/fact/enum", keyword: "enum", params: { allowedValues: schema34.properties.teeth.items.properties.findings.items.properties.fact.enum }, message: "must be equal to one of the allowed values" };
                        if (vErrors === null) {
                          vErrors = [err21];
                        } else {
                          vErrors.push(err21);
                        }
                        errors++;
                      }
                    }
                    if (data6.value !== void 0) {
                      let data8 = data6.value;
                      const _errs22 = errors;
                      let valid8 = false;
                      const _errs23 = errors;
                      if (typeof data8 !== "boolean") {
                        const err22 = { instancePath: instancePath + "/teeth/" + i0 + "/findings/" + i1 + "/value", schemaPath: "#/definitions/VerificationCase/properties/teeth/items/properties/findings/items/properties/value/anyOf/0/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                        if (vErrors === null) {
                          vErrors = [err22];
                        } else {
                          vErrors.push(err22);
                        }
                        errors++;
                      }
                      var _valid0 = _errs23 === errors;
                      valid8 = valid8 || _valid0;
                      if (!valid8) {
                        const _errs25 = errors;
                        if (typeof data8 !== "string") {
                          const err23 = { instancePath: instancePath + "/teeth/" + i0 + "/findings/" + i1 + "/value", schemaPath: "#/definitions/VerificationCase/properties/teeth/items/properties/findings/items/properties/value/anyOf/1/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                          if (vErrors === null) {
                            vErrors = [err23];
                          } else {
                            vErrors.push(err23);
                          }
                          errors++;
                        }
                        var _valid0 = _errs25 === errors;
                        valid8 = valid8 || _valid0;
                      }
                      if (!valid8) {
                        const err24 = { instancePath: instancePath + "/teeth/" + i0 + "/findings/" + i1 + "/value", schemaPath: "#/definitions/VerificationCase/properties/teeth/items/properties/findings/items/properties/value/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                        if (vErrors === null) {
                          vErrors = [err24];
                        } else {
                          vErrors.push(err24);
                        }
                        errors++;
                      } else {
                        errors = _errs22;
                        if (vErrors !== null) {
                          if (_errs22) {
                            vErrors.length = _errs22;
                          } else {
                            vErrors = null;
                          }
                        }
                      }
                    }
                    if (data6.status !== void 0) {
                      let data9 = data6.status;
                      if (typeof data9 !== "string") {
                        const err25 = { instancePath: instancePath + "/teeth/" + i0 + "/findings/" + i1 + "/status", schemaPath: "#/definitions/VerificationCase/properties/teeth/items/properties/findings/items/properties/status/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err25];
                        } else {
                          vErrors.push(err25);
                        }
                        errors++;
                      }
                      if (!(data9 === "proposed" || data9 === "confirmed")) {
                        const err26 = { instancePath: instancePath + "/teeth/" + i0 + "/findings/" + i1 + "/status", schemaPath: "#/definitions/VerificationCase/properties/teeth/items/properties/findings/items/properties/status/enum", keyword: "enum", params: { allowedValues: schema34.properties.teeth.items.properties.findings.items.properties.status.enum }, message: "must be equal to one of the allowed values" };
                        if (vErrors === null) {
                          vErrors = [err26];
                        } else {
                          vErrors.push(err26);
                        }
                        errors++;
                      }
                    }
                    if (data6.quote !== void 0) {
                      if (typeof data6.quote !== "string") {
                        const err27 = { instancePath: instancePath + "/teeth/" + i0 + "/findings/" + i1 + "/quote", schemaPath: "#/definitions/VerificationCase/properties/teeth/items/properties/findings/items/properties/quote/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err27];
                        } else {
                          vErrors.push(err27);
                        }
                        errors++;
                      }
                    }
                    if (data6.statedIn !== void 0) {
                      if (typeof data6.statedIn !== "string") {
                        const err28 = { instancePath: instancePath + "/teeth/" + i0 + "/findings/" + i1 + "/statedIn", schemaPath: "#/definitions/VerificationCase/properties/teeth/items/properties/findings/items/properties/statedIn/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err28];
                        } else {
                          vErrors.push(err28);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err29 = { instancePath: instancePath + "/teeth/" + i0 + "/findings/" + i1, schemaPath: "#/definitions/VerificationCase/properties/teeth/items/properties/findings/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                    if (vErrors === null) {
                      vErrors = [err29];
                    } else {
                      vErrors.push(err29);
                    }
                    errors++;
                  }
                }
              } else {
                const err30 = { instancePath: instancePath + "/teeth/" + i0 + "/findings", schemaPath: "#/definitions/VerificationCase/properties/teeth/items/properties/findings/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                if (vErrors === null) {
                  vErrors = [err30];
                } else {
                  vErrors.push(err30);
                }
                errors++;
              }
            }
          } else {
            const err31 = { instancePath: instancePath + "/teeth/" + i0, schemaPath: "#/definitions/VerificationCase/properties/teeth/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
              vErrors = [err31];
            } else {
              vErrors.push(err31);
            }
            errors++;
          }
        }
      } else {
        const err32 = { instancePath: instancePath + "/teeth", schemaPath: "#/definitions/VerificationCase/properties/teeth/type", keyword: "type", params: { type: "array" }, message: "must be array" };
        if (vErrors === null) {
          vErrors = [err32];
        } else {
          vErrors.push(err32);
        }
        errors++;
      }
    }
    if (data.jaws !== void 0) {
      let data12 = data.jaws;
      if (Array.isArray(data12)) {
        const len2 = data12.length;
        for (let i2 = 0; i2 < len2; i2++) {
          let data13 = data12[i2];
          if (data13 && typeof data13 == "object" && !Array.isArray(data13)) {
            if (data13.jaw === void 0) {
              const err33 = { instancePath: instancePath + "/jaws/" + i2, schemaPath: "#/definitions/VerificationCase/properties/jaws/items/required", keyword: "required", params: { missingProperty: "jaw" }, message: "must have required property 'jaw'" };
              if (vErrors === null) {
                vErrors = [err33];
              } else {
                vErrors.push(err33);
              }
              errors++;
            }
            if (data13.findings === void 0) {
              const err34 = { instancePath: instancePath + "/jaws/" + i2, schemaPath: "#/definitions/VerificationCase/properties/jaws/items/required", keyword: "required", params: { missingProperty: "findings" }, message: "must have required property 'findings'" };
              if (vErrors === null) {
                vErrors = [err34];
              } else {
                vErrors.push(err34);
              }
              errors++;
            }
            for (const key3 in data13) {
              if (!(key3 === "jaw" || key3 === "findings")) {
                const err35 = { instancePath: instancePath + "/jaws/" + i2, schemaPath: "#/definitions/VerificationCase/properties/jaws/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key3 }, message: "must NOT have additional properties" };
                if (vErrors === null) {
                  vErrors = [err35];
                } else {
                  vErrors.push(err35);
                }
                errors++;
              }
            }
            if (data13.jaw !== void 0) {
              let data14 = data13.jaw;
              if (typeof data14 !== "string") {
                const err36 = { instancePath: instancePath + "/jaws/" + i2 + "/jaw", schemaPath: "#/definitions/VerificationCase/properties/jaws/items/properties/jaw/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err36];
                } else {
                  vErrors.push(err36);
                }
                errors++;
              }
              if (!(data14 === "OK" || data14 === "UK")) {
                const err37 = { instancePath: instancePath + "/jaws/" + i2 + "/jaw", schemaPath: "#/definitions/VerificationCase/properties/jaws/items/properties/jaw/enum", keyword: "enum", params: { allowedValues: schema34.properties.jaws.items.properties.jaw.enum }, message: "must be equal to one of the allowed values" };
                if (vErrors === null) {
                  vErrors = [err37];
                } else {
                  vErrors.push(err37);
                }
                errors++;
              }
            }
            if (data13.findings !== void 0) {
              let data15 = data13.findings;
              if (Array.isArray(data15)) {
                const len3 = data15.length;
                for (let i3 = 0; i3 < len3; i3++) {
                  let data16 = data15[i3];
                  if (data16 && typeof data16 == "object" && !Array.isArray(data16)) {
                    if (data16.fact === void 0) {
                      const err38 = { instancePath: instancePath + "/jaws/" + i2 + "/findings/" + i3, schemaPath: "#/definitions/VerificationCase/properties/jaws/items/properties/findings/items/required", keyword: "required", params: { missingProperty: "fact" }, message: "must have required property 'fact'" };
                      if (vErrors === null) {
                        vErrors = [err38];
                      } else {
                        vErrors.push(err38);
                      }
                      errors++;
                    }
                    if (data16.value === void 0) {
                      const err39 = { instancePath: instancePath + "/jaws/" + i2 + "/findings/" + i3, schemaPath: "#/definitions/VerificationCase/properties/jaws/items/properties/findings/items/required", keyword: "required", params: { missingProperty: "value" }, message: "must have required property 'value'" };
                      if (vErrors === null) {
                        vErrors = [err39];
                      } else {
                        vErrors.push(err39);
                      }
                      errors++;
                    }
                    if (data16.status === void 0) {
                      const err40 = { instancePath: instancePath + "/jaws/" + i2 + "/findings/" + i3, schemaPath: "#/definitions/VerificationCase/properties/jaws/items/properties/findings/items/required", keyword: "required", params: { missingProperty: "status" }, message: "must have required property 'status'" };
                      if (vErrors === null) {
                        vErrors = [err40];
                      } else {
                        vErrors.push(err40);
                      }
                      errors++;
                    }
                    for (const key4 in data16) {
                      if (!(key4 === "fact" || key4 === "value" || key4 === "status" || key4 === "quote" || key4 === "statedIn")) {
                        const err41 = { instancePath: instancePath + "/jaws/" + i2 + "/findings/" + i3, schemaPath: "#/definitions/VerificationCase/properties/jaws/items/properties/findings/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key4 }, message: "must NOT have additional properties" };
                        if (vErrors === null) {
                          vErrors = [err41];
                        } else {
                          vErrors.push(err41);
                        }
                        errors++;
                      }
                    }
                    if (data16.fact !== void 0) {
                      let data17 = data16.fact;
                      if (typeof data17 !== "string") {
                        const err42 = { instancePath: instancePath + "/jaws/" + i2 + "/findings/" + i3 + "/fact", schemaPath: "#/definitions/VerificationCase/properties/jaws/items/properties/findings/items/properties/fact/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err42];
                        } else {
                          vErrors.push(err42);
                        }
                        errors++;
                      }
                      if (!(data17 === "fehlt" || data17 === "erhaltungswuerdig" || data17 === "krone" || data17 === "endodontisch_behandelt" || data17 === "stiftaufbau" || data17 === "brueckenanker" || data17 === "disparallel" || data17 === "wiederherstellung" || data17 === "geplant" || data17 === "lueckensituation_i")) {
                        const err43 = { instancePath: instancePath + "/jaws/" + i2 + "/findings/" + i3 + "/fact", schemaPath: "#/definitions/VerificationCase/properties/jaws/items/properties/findings/items/properties/fact/enum", keyword: "enum", params: { allowedValues: schema34.properties.jaws.items.properties.findings.items.properties.fact.enum }, message: "must be equal to one of the allowed values" };
                        if (vErrors === null) {
                          vErrors = [err43];
                        } else {
                          vErrors.push(err43);
                        }
                        errors++;
                      }
                    }
                    if (data16.value !== void 0) {
                      let data18 = data16.value;
                      const _errs48 = errors;
                      let valid15 = false;
                      const _errs49 = errors;
                      if (typeof data18 !== "boolean") {
                        const err44 = { instancePath: instancePath + "/jaws/" + i2 + "/findings/" + i3 + "/value", schemaPath: "#/definitions/VerificationCase/properties/jaws/items/properties/findings/items/properties/value/anyOf/0/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                        if (vErrors === null) {
                          vErrors = [err44];
                        } else {
                          vErrors.push(err44);
                        }
                        errors++;
                      }
                      var _valid1 = _errs49 === errors;
                      valid15 = valid15 || _valid1;
                      if (!valid15) {
                        const _errs51 = errors;
                        if (typeof data18 !== "string") {
                          const err45 = { instancePath: instancePath + "/jaws/" + i2 + "/findings/" + i3 + "/value", schemaPath: "#/definitions/VerificationCase/properties/jaws/items/properties/findings/items/properties/value/anyOf/1/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                          if (vErrors === null) {
                            vErrors = [err45];
                          } else {
                            vErrors.push(err45);
                          }
                          errors++;
                        }
                        var _valid1 = _errs51 === errors;
                        valid15 = valid15 || _valid1;
                      }
                      if (!valid15) {
                        const err46 = { instancePath: instancePath + "/jaws/" + i2 + "/findings/" + i3 + "/value", schemaPath: "#/definitions/VerificationCase/properties/jaws/items/properties/findings/items/properties/value/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                        if (vErrors === null) {
                          vErrors = [err46];
                        } else {
                          vErrors.push(err46);
                        }
                        errors++;
                      } else {
                        errors = _errs48;
                        if (vErrors !== null) {
                          if (_errs48) {
                            vErrors.length = _errs48;
                          } else {
                            vErrors = null;
                          }
                        }
                      }
                    }
                    if (data16.status !== void 0) {
                      let data19 = data16.status;
                      if (typeof data19 !== "string") {
                        const err47 = { instancePath: instancePath + "/jaws/" + i2 + "/findings/" + i3 + "/status", schemaPath: "#/definitions/VerificationCase/properties/jaws/items/properties/findings/items/properties/status/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err47];
                        } else {
                          vErrors.push(err47);
                        }
                        errors++;
                      }
                      if (!(data19 === "proposed" || data19 === "confirmed")) {
                        const err48 = { instancePath: instancePath + "/jaws/" + i2 + "/findings/" + i3 + "/status", schemaPath: "#/definitions/VerificationCase/properties/jaws/items/properties/findings/items/properties/status/enum", keyword: "enum", params: { allowedValues: schema34.properties.jaws.items.properties.findings.items.properties.status.enum }, message: "must be equal to one of the allowed values" };
                        if (vErrors === null) {
                          vErrors = [err48];
                        } else {
                          vErrors.push(err48);
                        }
                        errors++;
                      }
                    }
                    if (data16.quote !== void 0) {
                      if (typeof data16.quote !== "string") {
                        const err49 = { instancePath: instancePath + "/jaws/" + i2 + "/findings/" + i3 + "/quote", schemaPath: "#/definitions/VerificationCase/properties/jaws/items/properties/findings/items/properties/quote/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err49];
                        } else {
                          vErrors.push(err49);
                        }
                        errors++;
                      }
                    }
                    if (data16.statedIn !== void 0) {
                      if (typeof data16.statedIn !== "string") {
                        const err50 = { instancePath: instancePath + "/jaws/" + i2 + "/findings/" + i3 + "/statedIn", schemaPath: "#/definitions/VerificationCase/properties/jaws/items/properties/findings/items/properties/statedIn/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err50];
                        } else {
                          vErrors.push(err50);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err51 = { instancePath: instancePath + "/jaws/" + i2 + "/findings/" + i3, schemaPath: "#/definitions/VerificationCase/properties/jaws/items/properties/findings/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                    if (vErrors === null) {
                      vErrors = [err51];
                    } else {
                      vErrors.push(err51);
                    }
                    errors++;
                  }
                }
              } else {
                const err52 = { instancePath: instancePath + "/jaws/" + i2 + "/findings", schemaPath: "#/definitions/VerificationCase/properties/jaws/items/properties/findings/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                if (vErrors === null) {
                  vErrors = [err52];
                } else {
                  vErrors.push(err52);
                }
                errors++;
              }
            }
          } else {
            const err53 = { instancePath: instancePath + "/jaws/" + i2, schemaPath: "#/definitions/VerificationCase/properties/jaws/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
              vErrors = [err53];
            } else {
              vErrors.push(err53);
            }
            errors++;
          }
        }
      } else {
        const err54 = { instancePath: instancePath + "/jaws", schemaPath: "#/definitions/VerificationCase/properties/jaws/type", keyword: "type", params: { type: "array" }, message: "must be array" };
        if (vErrors === null) {
          vErrors = [err54];
        } else {
          vErrors.push(err54);
        }
        errors++;
      }
    }
    if (data.statements !== void 0) {
      let data22 = data.statements;
      if (Array.isArray(data22)) {
        const len4 = data22.length;
        for (let i4 = 0; i4 < len4; i4++) {
          let data23 = data22[i4];
          if (data23 && typeof data23 == "object" && !Array.isArray(data23)) {
            if (data23.id === void 0) {
              const err55 = { instancePath: instancePath + "/statements/" + i4, schemaPath: "#/definitions/VerificationCase/properties/statements/items/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property 'id'" };
              if (vErrors === null) {
                vErrors = [err55];
              } else {
                vErrors.push(err55);
              }
              errors++;
            }
            if (data23.at === void 0) {
              const err56 = { instancePath: instancePath + "/statements/" + i4, schemaPath: "#/definitions/VerificationCase/properties/statements/items/required", keyword: "required", params: { missingProperty: "at" }, message: "must have required property 'at'" };
              if (vErrors === null) {
                vErrors = [err56];
              } else {
                vErrors.push(err56);
              }
              errors++;
            }
            for (const key5 in data23) {
              if (!(key5 === "id" || key5 === "at")) {
                const err57 = { instancePath: instancePath + "/statements/" + i4, schemaPath: "#/definitions/VerificationCase/properties/statements/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key5 }, message: "must NOT have additional properties" };
                if (vErrors === null) {
                  vErrors = [err57];
                } else {
                  vErrors.push(err57);
                }
                errors++;
              }
            }
            if (data23.id !== void 0) {
              if (typeof data23.id !== "string") {
                const err58 = { instancePath: instancePath + "/statements/" + i4 + "/id", schemaPath: "#/definitions/VerificationCase/properties/statements/items/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err58];
                } else {
                  vErrors.push(err58);
                }
                errors++;
              }
            }
            if (data23.at !== void 0) {
              let data25 = data23.at;
              if (typeof data25 === "string") {
                if (!pattern0.test(data25)) {
                  const err59 = { instancePath: instancePath + "/statements/" + i4 + "/at", schemaPath: "#/definitions/VerificationCase/properties/statements/items/properties/at/pattern", keyword: "pattern", params: { pattern: "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, message: 'must match pattern "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"' };
                  if (vErrors === null) {
                    vErrors = [err59];
                  } else {
                    vErrors.push(err59);
                  }
                  errors++;
                }
                if (!formats0.validate(data25)) {
                  const err60 = { instancePath: instancePath + "/statements/" + i4 + "/at", schemaPath: "#/definitions/VerificationCase/properties/statements/items/properties/at/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' };
                  if (vErrors === null) {
                    vErrors = [err60];
                  } else {
                    vErrors.push(err60);
                  }
                  errors++;
                }
              } else {
                const err61 = { instancePath: instancePath + "/statements/" + i4 + "/at", schemaPath: "#/definitions/VerificationCase/properties/statements/items/properties/at/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err61];
                } else {
                  vErrors.push(err61);
                }
                errors++;
              }
            }
          } else {
            const err62 = { instancePath: instancePath + "/statements/" + i4, schemaPath: "#/definitions/VerificationCase/properties/statements/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
              vErrors = [err62];
            } else {
              vErrors.push(err62);
            }
            errors++;
          }
        }
      } else {
        const err63 = { instancePath: instancePath + "/statements", schemaPath: "#/definitions/VerificationCase/properties/statements/type", keyword: "type", params: { type: "array" }, message: "must be array" };
        if (vErrors === null) {
          vErrors = [err63];
        } else {
          vErrors.push(err63);
        }
        errors++;
      }
    }
    if (data.counts !== void 0) {
      let data26 = data.counts;
      if (Array.isArray(data26)) {
        const len5 = data26.length;
        for (let i5 = 0; i5 < len5; i5++) {
          let data27 = data26[i5];
          if (data27 && typeof data27 == "object" && !Array.isArray(data27)) {
            if (data27.at === void 0) {
              const err64 = { instancePath: instancePath + "/counts/" + i5, schemaPath: "#/definitions/VerificationCase/properties/counts/items/required", keyword: "required", params: { missingProperty: "at" }, message: "must have required property 'at'" };
              if (vErrors === null) {
                vErrors = [err64];
              } else {
                vErrors.push(err64);
              }
              errors++;
            }
            if (data27.nr === void 0) {
              const err65 = { instancePath: instancePath + "/counts/" + i5, schemaPath: "#/definitions/VerificationCase/properties/counts/items/required", keyword: "required", params: { missingProperty: "nr" }, message: "must have required property 'nr'" };
              if (vErrors === null) {
                vErrors = [err65];
              } else {
                vErrors.push(err65);
              }
              errors++;
            }
            if (data27.value === void 0) {
              const err66 = { instancePath: instancePath + "/counts/" + i5, schemaPath: "#/definitions/VerificationCase/properties/counts/items/required", keyword: "required", params: { missingProperty: "value" }, message: "must have required property 'value'" };
              if (vErrors === null) {
                vErrors = [err66];
              } else {
                vErrors.push(err66);
              }
              errors++;
            }
            if (data27.statedIn === void 0) {
              const err67 = { instancePath: instancePath + "/counts/" + i5, schemaPath: "#/definitions/VerificationCase/properties/counts/items/required", keyword: "required", params: { missingProperty: "statedIn" }, message: "must have required property 'statedIn'" };
              if (vErrors === null) {
                vErrors = [err67];
              } else {
                vErrors.push(err67);
              }
              errors++;
            }
            for (const key6 in data27) {
              if (!(key6 === "at" || key6 === "nr" || key6 === "value" || key6 === "statedIn")) {
                const err68 = { instancePath: instancePath + "/counts/" + i5, schemaPath: "#/definitions/VerificationCase/properties/counts/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key6 }, message: "must NOT have additional properties" };
                if (vErrors === null) {
                  vErrors = [err68];
                } else {
                  vErrors.push(err68);
                }
                errors++;
              }
            }
            if (data27.at !== void 0) {
              if (typeof data27.at !== "string") {
                const err69 = { instancePath: instancePath + "/counts/" + i5 + "/at", schemaPath: "#/definitions/VerificationCase/properties/counts/items/properties/at/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err69];
                } else {
                  vErrors.push(err69);
                }
                errors++;
              }
            }
            if (data27.nr !== void 0) {
              if (typeof data27.nr !== "string") {
                const err70 = { instancePath: instancePath + "/counts/" + i5 + "/nr", schemaPath: "#/definitions/VerificationCase/properties/counts/items/properties/nr/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err70];
                } else {
                  vErrors.push(err70);
                }
                errors++;
              }
            }
            if (data27.value !== void 0) {
              let data30 = data27.value;
              if (!(typeof data30 == "number" && (!(data30 % 1) && !isNaN(data30)) && isFinite(data30))) {
                const err71 = { instancePath: instancePath + "/counts/" + i5 + "/value", schemaPath: "#/definitions/VerificationCase/properties/counts/items/properties/value/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                if (vErrors === null) {
                  vErrors = [err71];
                } else {
                  vErrors.push(err71);
                }
                errors++;
              }
              if (typeof data30 == "number" && isFinite(data30)) {
                if (data30 > 99 || isNaN(data30)) {
                  const err72 = { instancePath: instancePath + "/counts/" + i5 + "/value", schemaPath: "#/definitions/VerificationCase/properties/counts/items/properties/value/maximum", keyword: "maximum", params: { comparison: "<=", limit: 99 }, message: "must be <= 99" };
                  if (vErrors === null) {
                    vErrors = [err72];
                  } else {
                    vErrors.push(err72);
                  }
                  errors++;
                }
                if (data30 < 1 || isNaN(data30)) {
                  const err73 = { instancePath: instancePath + "/counts/" + i5 + "/value", schemaPath: "#/definitions/VerificationCase/properties/counts/items/properties/value/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" };
                  if (vErrors === null) {
                    vErrors = [err73];
                  } else {
                    vErrors.push(err73);
                  }
                  errors++;
                }
              }
            }
            if (data27.statedIn !== void 0) {
              if (typeof data27.statedIn !== "string") {
                const err74 = { instancePath: instancePath + "/counts/" + i5 + "/statedIn", schemaPath: "#/definitions/VerificationCase/properties/counts/items/properties/statedIn/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err74];
                } else {
                  vErrors.push(err74);
                }
                errors++;
              }
            }
          } else {
            const err75 = { instancePath: instancePath + "/counts/" + i5, schemaPath: "#/definitions/VerificationCase/properties/counts/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
              vErrors = [err75];
            } else {
              vErrors.push(err75);
            }
            errors++;
          }
        }
      } else {
        const err76 = { instancePath: instancePath + "/counts", schemaPath: "#/definitions/VerificationCase/properties/counts/type", keyword: "type", params: { type: "array" }, message: "must be array" };
        if (vErrors === null) {
          vErrors = [err76];
        } else {
          vErrors.push(err76);
        }
        errors++;
      }
    }
    if (data.bonus !== void 0) {
      let data32 = data.bonus;
      if (data32 && typeof data32 == "object" && !Array.isArray(data32)) {
        if (data32.value === void 0) {
          const err77 = { instancePath: instancePath + "/bonus", schemaPath: "#/definitions/VerificationCase/properties/bonus/required", keyword: "required", params: { missingProperty: "value" }, message: "must have required property 'value'" };
          if (vErrors === null) {
            vErrors = [err77];
          } else {
            vErrors.push(err77);
          }
          errors++;
        }
        if (data32.statedIn === void 0) {
          const err78 = { instancePath: instancePath + "/bonus", schemaPath: "#/definitions/VerificationCase/properties/bonus/required", keyword: "required", params: { missingProperty: "statedIn" }, message: "must have required property 'statedIn'" };
          if (vErrors === null) {
            vErrors = [err78];
          } else {
            vErrors.push(err78);
          }
          errors++;
        }
        for (const key7 in data32) {
          if (!(key7 === "value" || key7 === "statedIn")) {
            const err79 = { instancePath: instancePath + "/bonus", schemaPath: "#/definitions/VerificationCase/properties/bonus/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key7 }, message: "must NOT have additional properties" };
            if (vErrors === null) {
              vErrors = [err79];
            } else {
              vErrors.push(err79);
            }
            errors++;
          }
        }
        if (data32.value !== void 0) {
          let data33 = data32.value;
          if (typeof data33 !== "string") {
            const err80 = { instancePath: instancePath + "/bonus/value", schemaPath: "#/definitions/VerificationCase/properties/bonus/properties/value/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err80];
            } else {
              vErrors.push(err80);
            }
            errors++;
          }
          if (!(data33 === "prozent60" || data33 === "prozent70" || data33 === "prozent75" || data33 === "prozent100")) {
            const err81 = { instancePath: instancePath + "/bonus/value", schemaPath: "#/definitions/VerificationCase/properties/bonus/properties/value/enum", keyword: "enum", params: { allowedValues: schema34.properties.bonus.properties.value.enum }, message: "must be equal to one of the allowed values" };
            if (vErrors === null) {
              vErrors = [err81];
            } else {
              vErrors.push(err81);
            }
            errors++;
          }
        }
        if (data32.statedIn !== void 0) {
          if (typeof data32.statedIn !== "string") {
            const err82 = { instancePath: instancePath + "/bonus/statedIn", schemaPath: "#/definitions/VerificationCase/properties/bonus/properties/statedIn/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err82];
            } else {
              vErrors.push(err82);
            }
            errors++;
          }
        }
      } else {
        const err83 = { instancePath: instancePath + "/bonus", schemaPath: "#/definitions/VerificationCase/properties/bonus/type", keyword: "type", params: { type: "object" }, message: "must be object" };
        if (vErrors === null) {
          vErrors = [err83];
        } else {
          vErrors.push(err83);
        }
        errors++;
      }
    }
    if (data.kostentraeger !== void 0) {
      let data35 = data.kostentraeger;
      if (data35 && typeof data35 == "object" && !Array.isArray(data35)) {
        if (data35.value === void 0) {
          const err84 = { instancePath: instancePath + "/kostentraeger", schemaPath: "#/definitions/VerificationCase/properties/kostentraeger/required", keyword: "required", params: { missingProperty: "value" }, message: "must have required property 'value'" };
          if (vErrors === null) {
            vErrors = [err84];
          } else {
            vErrors.push(err84);
          }
          errors++;
        }
        if (data35.statedIn === void 0) {
          const err85 = { instancePath: instancePath + "/kostentraeger", schemaPath: "#/definitions/VerificationCase/properties/kostentraeger/required", keyword: "required", params: { missingProperty: "statedIn" }, message: "must have required property 'statedIn'" };
          if (vErrors === null) {
            vErrors = [err85];
          } else {
            vErrors.push(err85);
          }
          errors++;
        }
        for (const key8 in data35) {
          if (!(key8 === "value" || key8 === "statedIn")) {
            const err86 = { instancePath: instancePath + "/kostentraeger", schemaPath: "#/definitions/VerificationCase/properties/kostentraeger/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key8 }, message: "must NOT have additional properties" };
            if (vErrors === null) {
              vErrors = [err86];
            } else {
              vErrors.push(err86);
            }
            errors++;
          }
        }
        if (data35.value !== void 0) {
          let data36 = data35.value;
          if (typeof data36 !== "string") {
            const err87 = { instancePath: instancePath + "/kostentraeger/value", schemaPath: "#/definitions/VerificationCase/properties/kostentraeger/properties/value/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err87];
            } else {
              vErrors.push(err87);
            }
            errors++;
          }
          if (!(data36 === "gkv_kzv_bw")) {
            const err88 = { instancePath: instancePath + "/kostentraeger/value", schemaPath: "#/definitions/VerificationCase/properties/kostentraeger/properties/value/enum", keyword: "enum", params: { allowedValues: schema34.properties.kostentraeger.properties.value.enum }, message: "must be equal to one of the allowed values" };
            if (vErrors === null) {
              vErrors = [err88];
            } else {
              vErrors.push(err88);
            }
            errors++;
          }
        }
        if (data35.statedIn !== void 0) {
          if (typeof data35.statedIn !== "string") {
            const err89 = { instancePath: instancePath + "/kostentraeger/statedIn", schemaPath: "#/definitions/VerificationCase/properties/kostentraeger/properties/statedIn/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err89];
            } else {
              vErrors.push(err89);
            }
            errors++;
          }
        }
      } else {
        const err90 = { instancePath: instancePath + "/kostentraeger", schemaPath: "#/definitions/VerificationCase/properties/kostentraeger/type", keyword: "type", params: { type: "object" }, message: "must be object" };
        if (vErrors === null) {
          vErrors = [err90];
        } else {
          vErrors.push(err90);
        }
        errors++;
      }
    }
  } else {
    const err91 = { instancePath, schemaPath: "#/definitions/VerificationCase/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err91];
    } else {
      vErrors.push(err91);
    }
    errors++;
  }
  validate29.errors = vErrors;
  return errors === 0;
}
var validateInput10 = validate30;
function validate30(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.conversationId === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "conversationId" }, message: "must have required property 'conversationId'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    for (const key0 in data) {
      if (!(key0 === "conversationId")) {
        const err1 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
    }
    if (data.conversationId !== void 0) {
      let data0 = data.conversationId;
      if (typeof data0 === "string") {
        if (func2(data0) < 1) {
          const err2 = { instancePath: instancePath + "/conversationId", schemaPath: "#/properties/conversationId/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
          if (vErrors === null) {
            vErrors = [err2];
          } else {
            vErrors.push(err2);
          }
          errors++;
        }
      } else {
        const err3 = { instancePath: instancePath + "/conversationId", schemaPath: "#/properties/conversationId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
  } else {
    const err4 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err4];
    } else {
      vErrors.push(err4);
    }
    errors++;
  }
  validate30.errors = vErrors;
  return errors === 0;
}
var validateOutput10 = validate31;
var schema37 = { "type": "object", "properties": { "object": { "type": "string", "const": "verification_evaluation" }, "conversationId": { "type": "string" }, "draft": { "type": "array", "items": { "type": "object", "properties": { "rule": { "type": "string" }, "befund": { "type": "string", "description": "The finding of the Festzuschuss-Richtlinie, e.g. 1.1 or 2.1." }, "title": { "type": "string", "description": "The finding as the guideline words it." }, "fdi": { "description": "The tooth, for a Befund of class 1.", "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "luecke": { "description": "The gap, for a Befund of class 2: one per gap.", "type": "object", "properties": { "id": { "type": "string", "description": "The gap as a place: its jaw and the teeth bounding it, e.g. UK:45-47." }, "jaw": { "type": "string", "enum": ["OK", "UK"], "description": "The jaw: OK upper, UK lower." }, "anker": { "type": "array", "items": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "description": "The teeth bounding it: the bridge's abutments." }, "fehlend": { "type": "array", "items": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "description": "The teeth missing in it: the bridge's pontics." } }, "required": ["id", "jaw", "anker", "fehlend"], "additionalProperties": false }, "zaehne": { "description": "For a Befund given per tooth of a gap (2.7, je Verblendung): those teeth, the HKP's Anz.; its Festzuschuss is for all of them.", "type": "array", "items": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 } }, "festzuschuss": { "type": "object", "properties": { "zahnaerztlich": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "zahntechnisch": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "prozent60": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "prozent70": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "prozent75": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "prozent100": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 } }, "required": ["zahnaerztlich", "zahntechnisch", "prozent60", "prozent70", "prozent75", "prozent100"], "additionalProperties": false, "description": "In cents: the dental and the technical share, and the Festzuschuss at 60 % (no bonus), 70 % (bonus 1), 75 % (bonus 2) and 100 % (hardship)." }, "used": { "type": "array", "items": { "type": "string" }, "description": "The dentist's statements it rests on; `assumed` for a proposal not confirmed yet." }, "citations": { "type": "array", "items": { "type": "object", "properties": { "chunkId": { "type": "string", "description": "Link the passage as /sources/{chunkId}." }, "title": { "type": "string" }, "url": { "type": "string" }, "page": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "quote": { "type": "string", "description": "Verbatim from the passage; checked against the index." } }, "required": ["chunkId", "title", "url", "quote"], "additionalProperties": false } } }, "required": ["rule", "befund", "title", "festzuschuss", "used", "citations"], "additionalProperties": false }, "description": "What the confirmed findings give, one line per Befund and tooth or gap." }, "projection": { "type": "array", "items": { "type": "object", "properties": { "rule": { "type": "string" }, "befund": { "type": "string", "description": "The finding of the Festzuschuss-Richtlinie, e.g. 1.1 or 2.1." }, "title": { "type": "string", "description": "The finding as the guideline words it." }, "fdi": { "description": "The tooth, for a Befund of class 1.", "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "luecke": { "description": "The gap, for a Befund of class 2: one per gap.", "type": "object", "properties": { "id": { "type": "string", "description": "The gap as a place: its jaw and the teeth bounding it, e.g. UK:45-47." }, "jaw": { "type": "string", "enum": ["OK", "UK"], "description": "The jaw: OK upper, UK lower." }, "anker": { "type": "array", "items": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "description": "The teeth bounding it: the bridge's abutments." }, "fehlend": { "type": "array", "items": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "description": "The teeth missing in it: the bridge's pontics." } }, "required": ["id", "jaw", "anker", "fehlend"], "additionalProperties": false }, "zaehne": { "description": "For a Befund given per tooth of a gap (2.7, je Verblendung): those teeth, the HKP's Anz.; its Festzuschuss is for all of them.", "type": "array", "items": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 } }, "festzuschuss": { "type": "object", "properties": { "zahnaerztlich": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "zahntechnisch": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "prozent60": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "prozent70": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "prozent75": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "prozent100": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 } }, "required": ["zahnaerztlich", "zahntechnisch", "prozent60", "prozent70", "prozent75", "prozent100"], "additionalProperties": false, "description": "In cents: the dental and the technical share, and the Festzuschuss at 60 % (no bonus), 70 % (bonus 1), 75 % (bonus 2) and 100 % (hardship)." }, "used": { "type": "array", "items": { "type": "string" }, "description": "The dentist's statements it rests on; `assumed` for a proposal not confirmed yet." }, "citations": { "type": "array", "items": { "type": "object", "properties": { "chunkId": { "type": "string", "description": "Link the passage as /sources/{chunkId}." }, "title": { "type": "string" }, "url": { "type": "string" }, "page": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "quote": { "type": "string", "description": "Verbatim from the passage; checked against the index." } }, "required": ["chunkId", "title", "url", "quote"], "additionalProperties": false } } }, "required": ["rule", "befund", "title", "festzuschuss", "used", "citations"], "additionalProperties": false }, "description": "What the confirmed findings and every open proposal give together: the draft once the dentist confirms the proposals. Empty while nothing is proposed." }, "costs": { "type": "object", "properties": { "teeth": { "type": "array", "items": { "type": "object", "properties": { "fdi": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "bema": { "type": "array", "items": { "type": "object", "properties": { "befund": { "type": "string", "description": "The Befund listing it; several, comma-separated, for a line billed once at a jaw or the case." }, "nr": { "type": "string" }, "text": { "type": "string" }, "points": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "part": { "type": "string", "description": "The BEMA part: Teil 5, or Teil 2 for 7b, which is billed at the Zahnersatz point value too (its provision 5)." }, "minus": { "type": "boolean", "description": "Listed after \u201Eabz\xFCglich\u201C: subtracted, as 1.3 does with 20a." }, "quantity": { "anyOf": [{ "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, { "type": "null" }], "description": "How often it goes on the HKP; null where no source says and the dentist has not counted it (placeholder `anzahl`), or where it is excluded." }, "counted": { "description": "The count is the dentist's, confirmed in the case's `counts`.", "type": "boolean", "const": true }, "cents": { "description": "The line's fee in cents: points \xD7 the KZV's point value \xD7 the count, a count no source or dentist sets taken as 1; negative for a minus line. Absent while the point value is missing, and for an excluded line.", "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "excluded": { "description": "Why it does not go on the HKP, quoting the BEMA provision; \u201Ein der Regel\u201C ones leave an exception to the dentist.", "type": "string" }, "source": { "type": "object", "properties": { "chunkId": { "type": "string" }, "title": { "type": "string" }, "url": { "type": "string" }, "page": { "description": "Absent for a norm indexed by section, as the GOZ.", "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 } }, "required": ["chunkId", "title", "url"], "additionalProperties": false } }, "required": ["befund", "nr", "text", "points", "part", "minus", "quantity"], "additionalProperties": false } }, "hkp": { "type": "array", "items": { "type": "object", "properties": { "nr": { "type": "string" }, "text": { "type": "string" }, "befunde": { "type": "string", "description": "The Befunde listing it, comma-separated." }, "quantity": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "counted": { "type": "string", "enum": ["bema", "dentist", "assumed"], "description": "Who set the count: a BEMA provision, the dentist (the case's `counts`), or nobody, so taken as 1 until the dentist confirms it." }, "cents": { "description": "Absent while the point value is missing.", "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "source": { "type": "object", "properties": { "chunkId": { "type": "string" }, "title": { "type": "string" }, "url": { "type": "string" }, "page": { "description": "Absent for a norm indexed by section, as the GOZ.", "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 } }, "required": ["chunkId", "title", "url"], "additionalProperties": false } }, "required": ["nr", "text", "befunde", "quantity", "counted"], "additionalProperties": false }, "description": "The BEMA positions as they go on the HKP, one per number: the Befunde's own arithmetic netted (1.1's 20a less 1.3's \u201Eabz\xFCglich 20a\u201C is none), a service two Befunde list counted once, excluded lines left out. What the dentist checks; `bema` is how each Befund lists them." }, "bel": { "type": "array", "items": { "type": "object", "properties": { "befund": { "type": "string" }, "nr": { "type": "string" }, "text": { "type": "string" }, "minus": { "type": "boolean" }, "source": { "type": "object", "properties": { "chunkId": { "type": "string" }, "title": { "type": "string" }, "url": { "type": "string" }, "page": { "description": "Absent for a norm indexed by section, as the GOZ.", "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 } }, "required": ["chunkId", "title", "url"], "additionalProperties": false } }, "required": ["befund", "nr", "text", "minus"], "additionalProperties": false } }, "materials": { "type": "array", "items": { "type": "object", "properties": { "befund": { "type": "string" }, "name": { "type": "string" }, "source": { "type": "object", "properties": { "chunkId": { "type": "string" }, "title": { "type": "string" }, "url": { "type": "string" }, "page": { "description": "Absent for a norm indexed by section, as the GOZ.", "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 } }, "required": ["chunkId", "title", "url"], "additionalProperties": false } }, "required": ["befund", "name"], "additionalProperties": false } }, "labor": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991, "description": "Lab costs in cents, as a guide: the FZ-RL's technical share of the Befunde there, from federal average prices. The lab's bill decides." }, "versorgung": { "description": "Absent at a tooth with no crown in its Regelversorgung, or until `geplant` is confirmed.", "type": "object", "properties": { "geplant": { "type": "string", "description": "The crown the patient chose, as `geplant` names it." }, "klasse": { "type": "string", "enum": ["regelversorgung", "gleichartig"], "description": "Gleichartig: the crown goes beyond the Regelversorgung and is billed under the GOZ; its BEMA crown lines are excluded, the provisional stays BEMA (BMV-Z Anlage 2 Nr. 4)." } }, "required": ["geplant", "klasse"], "additionalProperties": false }, "goz": { "type": "array", "items": { "type": "object", "properties": { "nr": { "type": "string" }, "title": { "type": "string" }, "points": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "faktor": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991, "description": "The GOZ factor in tenths: 23 is 2,3, the Regelsatz, assumed (placeholder `faktor`)." }, "cents": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991, "description": "Points \xD7 the GOZ point value (5,62421 Cent) \xD7 the factor, rounded once." }, "excluded": { "description": "Why it is not billable beside another GOZ line, quoting the provision.", "type": "string" }, "source": { "type": "object", "properties": { "chunkId": { "type": "string" }, "title": { "type": "string" }, "url": { "type": "string" }, "page": { "description": "Absent for a norm indexed by section, as the GOZ.", "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 } }, "required": ["chunkId", "title", "url"], "additionalProperties": false } }, "required": ["nr", "title", "points", "faktor", "cents"], "additionalProperties": false }, "description": "The GOZ lines of a gleichartige crown; empty under the Regelversorgung." } }, "required": ["fdi", "bema", "hkp", "bel", "materials", "labor", "goz"], "additionalProperties": false } }, "luecken": { "type": "array", "items": { "type": "object", "properties": { "luecke": { "type": "object", "properties": { "id": { "type": "string", "description": "The gap as a place: its jaw and the teeth bounding it, e.g. UK:45-47." }, "jaw": { "type": "string", "enum": ["OK", "UK"], "description": "The jaw: OK upper, UK lower." }, "anker": { "type": "array", "items": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "description": "The teeth bounding it: the bridge's abutments." }, "fehlend": { "type": "array", "items": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "description": "The teeth missing in it: the bridge's pontics." } }, "required": ["id", "jaw", "anker", "fehlend"], "additionalProperties": false, "description": "A gap between two present teeth, for a Befund of class 2." }, "bema": { "type": "array", "items": { "type": "object", "properties": { "befund": { "type": "string", "description": "The Befund listing it; several, comma-separated, for a line billed once at a jaw or the case." }, "nr": { "type": "string" }, "text": { "type": "string" }, "points": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "part": { "type": "string", "description": "The BEMA part: Teil 5, or Teil 2 for 7b, which is billed at the Zahnersatz point value too (its provision 5)." }, "minus": { "type": "boolean", "description": "Listed after \u201Eabz\xFCglich\u201C: subtracted, as 1.3 does with 20a." }, "quantity": { "anyOf": [{ "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, { "type": "null" }], "description": "How often it goes on the HKP; null where no source says and the dentist has not counted it (placeholder `anzahl`), or where it is excluded." }, "counted": { "description": "The count is the dentist's, confirmed in the case's `counts`.", "type": "boolean", "const": true }, "cents": { "description": "The line's fee in cents: points \xD7 the KZV's point value \xD7 the count, a count no source or dentist sets taken as 1; negative for a minus line. Absent while the point value is missing, and for an excluded line.", "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "excluded": { "description": "Why it does not go on the HKP, quoting the BEMA provision; \u201Ein der Regel\u201C ones leave an exception to the dentist.", "type": "string" }, "source": { "type": "object", "properties": { "chunkId": { "type": "string" }, "title": { "type": "string" }, "url": { "type": "string" }, "page": { "description": "Absent for a norm indexed by section, as the GOZ.", "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 } }, "required": ["chunkId", "title", "url"], "additionalProperties": false } }, "required": ["befund", "nr", "text", "points", "part", "minus", "quantity"], "additionalProperties": false } }, "hkp": { "type": "array", "items": { "type": "object", "properties": { "nr": { "type": "string" }, "text": { "type": "string" }, "befunde": { "type": "string", "description": "The Befunde listing it, comma-separated." }, "quantity": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "counted": { "type": "string", "enum": ["bema", "dentist", "assumed"], "description": "Who set the count: a BEMA provision, the dentist (the case's `counts`), or nobody, so taken as 1 until the dentist confirms it." }, "cents": { "description": "Absent while the point value is missing.", "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "source": { "type": "object", "properties": { "chunkId": { "type": "string" }, "title": { "type": "string" }, "url": { "type": "string" }, "page": { "description": "Absent for a norm indexed by section, as the GOZ.", "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 } }, "required": ["chunkId", "title", "url"], "additionalProperties": false } }, "required": ["nr", "text", "befunde", "quantity", "counted"], "additionalProperties": false }, "description": "The BEMA positions as they go on the HKP, one per number: the Befunde's own arithmetic netted (1.1's 20a less 1.3's \u201Eabz\xFCglich 20a\u201C is none), a service two Befunde list counted once, excluded lines left out. What the dentist checks; `bema` is how each Befund lists them." }, "bel": { "type": "array", "items": { "type": "object", "properties": { "befund": { "type": "string" }, "nr": { "type": "string" }, "text": { "type": "string" }, "minus": { "type": "boolean" }, "source": { "type": "object", "properties": { "chunkId": { "type": "string" }, "title": { "type": "string" }, "url": { "type": "string" }, "page": { "description": "Absent for a norm indexed by section, as the GOZ.", "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 } }, "required": ["chunkId", "title", "url"], "additionalProperties": false } }, "required": ["befund", "nr", "text", "minus"], "additionalProperties": false } }, "materials": { "type": "array", "items": { "type": "object", "properties": { "befund": { "type": "string" }, "name": { "type": "string" }, "source": { "type": "object", "properties": { "chunkId": { "type": "string" }, "title": { "type": "string" }, "url": { "type": "string" }, "page": { "description": "Absent for a norm indexed by section, as the GOZ.", "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 } }, "required": ["chunkId", "title", "url"], "additionalProperties": false } }, "required": ["befund", "name"], "additionalProperties": false } }, "labor": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991, "description": "Lab costs in cents, as a guide: the FZ-RL's technical share of the Befunde there, from federal average prices. The lab's bill decides." } }, "required": ["luecke", "bema", "hkp", "bel", "materials", "labor"], "additionalProperties": false }, "description": "Per gap with a Befund of class 2, its bridge: anchor crowns (91a or 91c per abutment, as planned), the span (92), the provisional per tooth of the bridge (19), its removal (95d); the adhesive bridge (93a, 93b) shown excluded." }, "places": { "type": "array", "items": { "type": "object", "properties": { "place": { "type": "string", "enum": ["OK", "UK", "patient"], "description": "OK or UK for a jaw, patient for the whole case." }, "bema": { "type": "array", "items": { "type": "object", "properties": { "befund": { "type": "string", "description": "The Befund listing it; several, comma-separated, for a line billed once at a jaw or the case." }, "nr": { "type": "string" }, "text": { "type": "string" }, "points": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "part": { "type": "string", "description": "The BEMA part: Teil 5, or Teil 2 for 7b, which is billed at the Zahnersatz point value too (its provision 5)." }, "minus": { "type": "boolean", "description": "Listed after \u201Eabz\xFCglich\u201C: subtracted, as 1.3 does with 20a." }, "quantity": { "anyOf": [{ "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, { "type": "null" }], "description": "How often it goes on the HKP; null where no source says and the dentist has not counted it (placeholder `anzahl`), or where it is excluded." }, "counted": { "description": "The count is the dentist's, confirmed in the case's `counts`.", "type": "boolean", "const": true }, "cents": { "description": "The line's fee in cents: points \xD7 the KZV's point value \xD7 the count, a count no source or dentist sets taken as 1; negative for a minus line. Absent while the point value is missing, and for an excluded line.", "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "excluded": { "description": "Why it does not go on the HKP, quoting the BEMA provision; \u201Ein der Regel\u201C ones leave an exception to the dentist.", "type": "string" }, "source": { "type": "object", "properties": { "chunkId": { "type": "string" }, "title": { "type": "string" }, "url": { "type": "string" }, "page": { "description": "Absent for a norm indexed by section, as the GOZ.", "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 } }, "required": ["chunkId", "title", "url"], "additionalProperties": false } }, "required": ["befund", "nr", "text", "points", "part", "minus", "quantity"], "additionalProperties": false } }, "hkp": { "type": "array", "items": { "type": "object", "properties": { "nr": { "type": "string" }, "text": { "type": "string" }, "befunde": { "type": "string", "description": "The Befunde listing it, comma-separated." }, "quantity": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "counted": { "type": "string", "enum": ["bema", "dentist", "assumed"], "description": "Who set the count: a BEMA provision, the dentist (the case's `counts`), or nobody, so taken as 1 until the dentist confirms it." }, "cents": { "description": "Absent while the point value is missing.", "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "source": { "type": "object", "properties": { "chunkId": { "type": "string" }, "title": { "type": "string" }, "url": { "type": "string" }, "page": { "description": "Absent for a norm indexed by section, as the GOZ.", "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 } }, "required": ["chunkId", "title", "url"], "additionalProperties": false } }, "required": ["nr", "text", "befunde", "quantity", "counted"], "additionalProperties": false }, "description": "The BEMA positions as they go on the HKP, one per number: the Befunde's own arithmetic netted (1.1's 20a less 1.3's \u201Eabz\xFCglich 20a\u201C is none), a service two Befunde list counted once, excluded lines left out. What the dentist checks; `bema` is how each Befund lists them." } }, "required": ["place", "bema", "hkp"], "additionalProperties": false }, "description": "BEMA lines the BEMA bills once for several teeth: 98a per jaw, 7b and 89 per case. Not repeated per tooth or gap." }, "punktwert": { "description": "The KZV Baden-W\xFCrttemberg's point value for Zahnersatz; absent where its table gives none for the case.", "type": "object", "properties": { "ze": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991, "description": "In ten-thousandths of a euro: 11844 is 1,1844 \u20AC." }, "source": { "type": "object", "properties": { "chunkId": { "type": "string" }, "title": { "type": "string" }, "url": { "type": "string" }, "page": { "description": "Absent for a norm indexed by section, as the GOZ.", "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 } }, "required": ["chunkId", "title", "url"], "additionalProperties": false } }, "required": ["ze"], "additionalProperties": false }, "totals": { "description": "In cents, once nothing is open, every rule is current and the point value is known.", "type": "object", "properties": { "honorar": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991, "description": "The BEMA lines' fees, in cents." }, "goz": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991, "description": "The GOZ lines' fees, in cents; 0 without a gleichartige crown." }, "labor": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991, "description": "The teeth's lab costs as a guide, in cents." }, "gesamt": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991, "description": "Honorar, GOZ and Labor, without materials." }, "festzuschuss": { "type": "object", "properties": { "prozent60": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "prozent70": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "prozent75": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "prozent100": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 } }, "required": ["prozent60", "prozent70", "prozent75", "prozent100"], "additionalProperties": false }, "eigenanteil": { "type": "object", "properties": { "prozent60": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "prozent70": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "prozent75": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "prozent100": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 } }, "required": ["prozent60", "prozent70", "prozent75", "prozent100"], "additionalProperties": false, "description": "What the patient pays at each subsidy level: the total less the Festzuschuss, at least 0." } }, "required": ["honorar", "goz", "labor", "gesamt", "festzuschuss", "eigenanteil"], "additionalProperties": false }, "waiting": { "type": "array", "items": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "description": "Teeth whose Regelversorgung, or whose bridge's, waits until the open questions there are answered: one could still change it (a post replaces 19 with 21, an anchor's type 91a with 91c)." }, "placeholders": { "type": "array", "items": { "type": "object", "properties": { "id": { "type": "string", "enum": ["punktwert", "labor", "materialPreise", "anzahl", "faktor", "laborGleichartig", "eigenanteil"] }, "text": { "type": "string" } }, "required": ["id", "text"], "additionalProperties": false }, "description": "What the costs need and the sources do not hold: say each where a number would be, never estimate it." } }, "required": ["teeth", "luecken", "places", "waiting", "placeholders"], "additionalProperties": false, "description": "The Regelversorgung of the Befunde per tooth and per gap: BEMA positions with points and fees, BEL positions and materials, lab costs as a guide; per crowned tooth the crown chosen and, where it is gleichartig, its GOZ lines; the totals and the patient's share once the case is complete." }, "projectedCosts": { "type": "object", "properties": { "teeth": { "type": "array", "items": { "type": "object", "properties": { "fdi": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "bema": { "type": "array", "items": { "type": "object", "properties": { "befund": { "type": "string", "description": "The Befund listing it; several, comma-separated, for a line billed once at a jaw or the case." }, "nr": { "type": "string" }, "text": { "type": "string" }, "points": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "part": { "type": "string", "description": "The BEMA part: Teil 5, or Teil 2 for 7b, which is billed at the Zahnersatz point value too (its provision 5)." }, "minus": { "type": "boolean", "description": "Listed after \u201Eabz\xFCglich\u201C: subtracted, as 1.3 does with 20a." }, "quantity": { "anyOf": [{ "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, { "type": "null" }], "description": "How often it goes on the HKP; null where no source says and the dentist has not counted it (placeholder `anzahl`), or where it is excluded." }, "counted": { "description": "The count is the dentist's, confirmed in the case's `counts`.", "type": "boolean", "const": true }, "cents": { "description": "The line's fee in cents: points \xD7 the KZV's point value \xD7 the count, a count no source or dentist sets taken as 1; negative for a minus line. Absent while the point value is missing, and for an excluded line.", "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "excluded": { "description": "Why it does not go on the HKP, quoting the BEMA provision; \u201Ein der Regel\u201C ones leave an exception to the dentist.", "type": "string" }, "source": { "type": "object", "properties": { "chunkId": { "type": "string" }, "title": { "type": "string" }, "url": { "type": "string" }, "page": { "description": "Absent for a norm indexed by section, as the GOZ.", "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 } }, "required": ["chunkId", "title", "url"], "additionalProperties": false } }, "required": ["befund", "nr", "text", "points", "part", "minus", "quantity"], "additionalProperties": false } }, "hkp": { "type": "array", "items": { "type": "object", "properties": { "nr": { "type": "string" }, "text": { "type": "string" }, "befunde": { "type": "string", "description": "The Befunde listing it, comma-separated." }, "quantity": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "counted": { "type": "string", "enum": ["bema", "dentist", "assumed"], "description": "Who set the count: a BEMA provision, the dentist (the case's `counts`), or nobody, so taken as 1 until the dentist confirms it." }, "cents": { "description": "Absent while the point value is missing.", "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "source": { "type": "object", "properties": { "chunkId": { "type": "string" }, "title": { "type": "string" }, "url": { "type": "string" }, "page": { "description": "Absent for a norm indexed by section, as the GOZ.", "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 } }, "required": ["chunkId", "title", "url"], "additionalProperties": false } }, "required": ["nr", "text", "befunde", "quantity", "counted"], "additionalProperties": false }, "description": "The BEMA positions as they go on the HKP, one per number: the Befunde's own arithmetic netted (1.1's 20a less 1.3's \u201Eabz\xFCglich 20a\u201C is none), a service two Befunde list counted once, excluded lines left out. What the dentist checks; `bema` is how each Befund lists them." }, "bel": { "type": "array", "items": { "type": "object", "properties": { "befund": { "type": "string" }, "nr": { "type": "string" }, "text": { "type": "string" }, "minus": { "type": "boolean" }, "source": { "type": "object", "properties": { "chunkId": { "type": "string" }, "title": { "type": "string" }, "url": { "type": "string" }, "page": { "description": "Absent for a norm indexed by section, as the GOZ.", "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 } }, "required": ["chunkId", "title", "url"], "additionalProperties": false } }, "required": ["befund", "nr", "text", "minus"], "additionalProperties": false } }, "materials": { "type": "array", "items": { "type": "object", "properties": { "befund": { "type": "string" }, "name": { "type": "string" }, "source": { "type": "object", "properties": { "chunkId": { "type": "string" }, "title": { "type": "string" }, "url": { "type": "string" }, "page": { "description": "Absent for a norm indexed by section, as the GOZ.", "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 } }, "required": ["chunkId", "title", "url"], "additionalProperties": false } }, "required": ["befund", "name"], "additionalProperties": false } }, "labor": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991, "description": "Lab costs in cents, as a guide: the FZ-RL's technical share of the Befunde there, from federal average prices. The lab's bill decides." }, "versorgung": { "description": "Absent at a tooth with no crown in its Regelversorgung, or until `geplant` is confirmed.", "type": "object", "properties": { "geplant": { "type": "string", "description": "The crown the patient chose, as `geplant` names it." }, "klasse": { "type": "string", "enum": ["regelversorgung", "gleichartig"], "description": "Gleichartig: the crown goes beyond the Regelversorgung and is billed under the GOZ; its BEMA crown lines are excluded, the provisional stays BEMA (BMV-Z Anlage 2 Nr. 4)." } }, "required": ["geplant", "klasse"], "additionalProperties": false }, "goz": { "type": "array", "items": { "type": "object", "properties": { "nr": { "type": "string" }, "title": { "type": "string" }, "points": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "faktor": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991, "description": "The GOZ factor in tenths: 23 is 2,3, the Regelsatz, assumed (placeholder `faktor`)." }, "cents": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991, "description": "Points \xD7 the GOZ point value (5,62421 Cent) \xD7 the factor, rounded once." }, "excluded": { "description": "Why it is not billable beside another GOZ line, quoting the provision.", "type": "string" }, "source": { "type": "object", "properties": { "chunkId": { "type": "string" }, "title": { "type": "string" }, "url": { "type": "string" }, "page": { "description": "Absent for a norm indexed by section, as the GOZ.", "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 } }, "required": ["chunkId", "title", "url"], "additionalProperties": false } }, "required": ["nr", "title", "points", "faktor", "cents"], "additionalProperties": false }, "description": "The GOZ lines of a gleichartige crown; empty under the Regelversorgung." } }, "required": ["fdi", "bema", "hkp", "bel", "materials", "labor", "goz"], "additionalProperties": false } }, "luecken": { "type": "array", "items": { "type": "object", "properties": { "luecke": { "type": "object", "properties": { "id": { "type": "string", "description": "The gap as a place: its jaw and the teeth bounding it, e.g. UK:45-47." }, "jaw": { "type": "string", "enum": ["OK", "UK"], "description": "The jaw: OK upper, UK lower." }, "anker": { "type": "array", "items": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "description": "The teeth bounding it: the bridge's abutments." }, "fehlend": { "type": "array", "items": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "description": "The teeth missing in it: the bridge's pontics." } }, "required": ["id", "jaw", "anker", "fehlend"], "additionalProperties": false, "description": "A gap between two present teeth, for a Befund of class 2." }, "bema": { "type": "array", "items": { "type": "object", "properties": { "befund": { "type": "string", "description": "The Befund listing it; several, comma-separated, for a line billed once at a jaw or the case." }, "nr": { "type": "string" }, "text": { "type": "string" }, "points": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "part": { "type": "string", "description": "The BEMA part: Teil 5, or Teil 2 for 7b, which is billed at the Zahnersatz point value too (its provision 5)." }, "minus": { "type": "boolean", "description": "Listed after \u201Eabz\xFCglich\u201C: subtracted, as 1.3 does with 20a." }, "quantity": { "anyOf": [{ "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, { "type": "null" }], "description": "How often it goes on the HKP; null where no source says and the dentist has not counted it (placeholder `anzahl`), or where it is excluded." }, "counted": { "description": "The count is the dentist's, confirmed in the case's `counts`.", "type": "boolean", "const": true }, "cents": { "description": "The line's fee in cents: points \xD7 the KZV's point value \xD7 the count, a count no source or dentist sets taken as 1; negative for a minus line. Absent while the point value is missing, and for an excluded line.", "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "excluded": { "description": "Why it does not go on the HKP, quoting the BEMA provision; \u201Ein der Regel\u201C ones leave an exception to the dentist.", "type": "string" }, "source": { "type": "object", "properties": { "chunkId": { "type": "string" }, "title": { "type": "string" }, "url": { "type": "string" }, "page": { "description": "Absent for a norm indexed by section, as the GOZ.", "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 } }, "required": ["chunkId", "title", "url"], "additionalProperties": false } }, "required": ["befund", "nr", "text", "points", "part", "minus", "quantity"], "additionalProperties": false } }, "hkp": { "type": "array", "items": { "type": "object", "properties": { "nr": { "type": "string" }, "text": { "type": "string" }, "befunde": { "type": "string", "description": "The Befunde listing it, comma-separated." }, "quantity": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "counted": { "type": "string", "enum": ["bema", "dentist", "assumed"], "description": "Who set the count: a BEMA provision, the dentist (the case's `counts`), or nobody, so taken as 1 until the dentist confirms it." }, "cents": { "description": "Absent while the point value is missing.", "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "source": { "type": "object", "properties": { "chunkId": { "type": "string" }, "title": { "type": "string" }, "url": { "type": "string" }, "page": { "description": "Absent for a norm indexed by section, as the GOZ.", "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 } }, "required": ["chunkId", "title", "url"], "additionalProperties": false } }, "required": ["nr", "text", "befunde", "quantity", "counted"], "additionalProperties": false }, "description": "The BEMA positions as they go on the HKP, one per number: the Befunde's own arithmetic netted (1.1's 20a less 1.3's \u201Eabz\xFCglich 20a\u201C is none), a service two Befunde list counted once, excluded lines left out. What the dentist checks; `bema` is how each Befund lists them." }, "bel": { "type": "array", "items": { "type": "object", "properties": { "befund": { "type": "string" }, "nr": { "type": "string" }, "text": { "type": "string" }, "minus": { "type": "boolean" }, "source": { "type": "object", "properties": { "chunkId": { "type": "string" }, "title": { "type": "string" }, "url": { "type": "string" }, "page": { "description": "Absent for a norm indexed by section, as the GOZ.", "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 } }, "required": ["chunkId", "title", "url"], "additionalProperties": false } }, "required": ["befund", "nr", "text", "minus"], "additionalProperties": false } }, "materials": { "type": "array", "items": { "type": "object", "properties": { "befund": { "type": "string" }, "name": { "type": "string" }, "source": { "type": "object", "properties": { "chunkId": { "type": "string" }, "title": { "type": "string" }, "url": { "type": "string" }, "page": { "description": "Absent for a norm indexed by section, as the GOZ.", "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 } }, "required": ["chunkId", "title", "url"], "additionalProperties": false } }, "required": ["befund", "name"], "additionalProperties": false } }, "labor": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991, "description": "Lab costs in cents, as a guide: the FZ-RL's technical share of the Befunde there, from federal average prices. The lab's bill decides." } }, "required": ["luecke", "bema", "hkp", "bel", "materials", "labor"], "additionalProperties": false }, "description": "Per gap with a Befund of class 2, its bridge: anchor crowns (91a or 91c per abutment, as planned), the span (92), the provisional per tooth of the bridge (19), its removal (95d); the adhesive bridge (93a, 93b) shown excluded." }, "places": { "type": "array", "items": { "type": "object", "properties": { "place": { "type": "string", "enum": ["OK", "UK", "patient"], "description": "OK or UK for a jaw, patient for the whole case." }, "bema": { "type": "array", "items": { "type": "object", "properties": { "befund": { "type": "string", "description": "The Befund listing it; several, comma-separated, for a line billed once at a jaw or the case." }, "nr": { "type": "string" }, "text": { "type": "string" }, "points": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "part": { "type": "string", "description": "The BEMA part: Teil 5, or Teil 2 for 7b, which is billed at the Zahnersatz point value too (its provision 5)." }, "minus": { "type": "boolean", "description": "Listed after \u201Eabz\xFCglich\u201C: subtracted, as 1.3 does with 20a." }, "quantity": { "anyOf": [{ "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, { "type": "null" }], "description": "How often it goes on the HKP; null where no source says and the dentist has not counted it (placeholder `anzahl`), or where it is excluded." }, "counted": { "description": "The count is the dentist's, confirmed in the case's `counts`.", "type": "boolean", "const": true }, "cents": { "description": "The line's fee in cents: points \xD7 the KZV's point value \xD7 the count, a count no source or dentist sets taken as 1; negative for a minus line. Absent while the point value is missing, and for an excluded line.", "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "excluded": { "description": "Why it does not go on the HKP, quoting the BEMA provision; \u201Ein der Regel\u201C ones leave an exception to the dentist.", "type": "string" }, "source": { "type": "object", "properties": { "chunkId": { "type": "string" }, "title": { "type": "string" }, "url": { "type": "string" }, "page": { "description": "Absent for a norm indexed by section, as the GOZ.", "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 } }, "required": ["chunkId", "title", "url"], "additionalProperties": false } }, "required": ["befund", "nr", "text", "points", "part", "minus", "quantity"], "additionalProperties": false } }, "hkp": { "type": "array", "items": { "type": "object", "properties": { "nr": { "type": "string" }, "text": { "type": "string" }, "befunde": { "type": "string", "description": "The Befunde listing it, comma-separated." }, "quantity": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "counted": { "type": "string", "enum": ["bema", "dentist", "assumed"], "description": "Who set the count: a BEMA provision, the dentist (the case's `counts`), or nobody, so taken as 1 until the dentist confirms it." }, "cents": { "description": "Absent while the point value is missing.", "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "source": { "type": "object", "properties": { "chunkId": { "type": "string" }, "title": { "type": "string" }, "url": { "type": "string" }, "page": { "description": "Absent for a norm indexed by section, as the GOZ.", "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 } }, "required": ["chunkId", "title", "url"], "additionalProperties": false } }, "required": ["nr", "text", "befunde", "quantity", "counted"], "additionalProperties": false }, "description": "The BEMA positions as they go on the HKP, one per number: the Befunde's own arithmetic netted (1.1's 20a less 1.3's \u201Eabz\xFCglich 20a\u201C is none), a service two Befunde list counted once, excluded lines left out. What the dentist checks; `bema` is how each Befund lists them." } }, "required": ["place", "bema", "hkp"], "additionalProperties": false }, "description": "BEMA lines the BEMA bills once for several teeth: 98a per jaw, 7b and 89 per case. Not repeated per tooth or gap." }, "punktwert": { "description": "The KZV Baden-W\xFCrttemberg's point value for Zahnersatz; absent where its table gives none for the case.", "type": "object", "properties": { "ze": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991, "description": "In ten-thousandths of a euro: 11844 is 1,1844 \u20AC." }, "source": { "type": "object", "properties": { "chunkId": { "type": "string" }, "title": { "type": "string" }, "url": { "type": "string" }, "page": { "description": "Absent for a norm indexed by section, as the GOZ.", "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 } }, "required": ["chunkId", "title", "url"], "additionalProperties": false } }, "required": ["ze"], "additionalProperties": false }, "totals": { "description": "In cents, once nothing is open, every rule is current and the point value is known.", "type": "object", "properties": { "honorar": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991, "description": "The BEMA lines' fees, in cents." }, "goz": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991, "description": "The GOZ lines' fees, in cents; 0 without a gleichartige crown." }, "labor": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991, "description": "The teeth's lab costs as a guide, in cents." }, "gesamt": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991, "description": "Honorar, GOZ and Labor, without materials." }, "festzuschuss": { "type": "object", "properties": { "prozent60": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "prozent70": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "prozent75": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "prozent100": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 } }, "required": ["prozent60", "prozent70", "prozent75", "prozent100"], "additionalProperties": false }, "eigenanteil": { "type": "object", "properties": { "prozent60": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "prozent70": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "prozent75": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "prozent100": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 } }, "required": ["prozent60", "prozent70", "prozent75", "prozent100"], "additionalProperties": false, "description": "What the patient pays at each subsidy level: the total less the Festzuschuss, at least 0." } }, "required": ["honorar", "goz", "labor", "gesamt", "festzuschuss", "eigenanteil"], "additionalProperties": false }, "waiting": { "type": "array", "items": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "description": "Teeth whose Regelversorgung, or whose bridge's, waits until the open questions there are answered: one could still change it (a post replaces 19 with 21, an anchor's type 91a with 91c)." }, "placeholders": { "type": "array", "items": { "type": "object", "properties": { "id": { "type": "string", "enum": ["punktwert", "labor", "materialPreise", "anzahl", "faktor", "laborGleichartig", "eigenanteil"] }, "text": { "type": "string" } }, "required": ["id", "text"], "additionalProperties": false }, "description": "What the costs need and the sources do not hold: say each where a number would be, never estimate it." } }, "required": ["teeth", "luecken", "places", "waiting", "placeholders"], "additionalProperties": false, "description": "The costs once the dentist confirms every open proposal, like `projection`. Empty teeth while nothing is proposed." }, "unterlagen": { "description": "The documents the case needs before treatment, from `bmv-z/unterlagen`; absent until it decides.", "type": "object", "properties": { "patienteninformation": { "type": "string", "enum": ["3c", "3d"], "description": "The patient information to sign (BMV-Z Anlage 14a): 3d once a crown of the case is gleichartig, else 3c." }, "bewilligung": { "type": "string", "enum": ["vorher", "ohne", "ohne_ausser_haertefall"], "description": "Whether the Krankenkasse approves the HKP before treatment: `vorher`; `ohne` where every Befund may be treated without (BMV-Z Anlage 6 \xA7 1 Abs. 2) and the patient is no H\xE4rtefall; `ohne_ausser_haertefall` while the bonus level is not stated." }, "passages": { "type": "object", "properties": { "aufklaerung": { "type": "object", "properties": { "chunkId": { "type": "string", "description": "Link the passage as /sources/{chunkId}." }, "title": { "type": "string" }, "url": { "type": "string" }, "page": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "quote": { "type": "string", "description": "Verbatim from the passage; checked against the index." } }, "required": ["chunkId", "title", "url", "quote"], "additionalProperties": false }, "bonus": { "type": "object", "properties": { "chunkId": { "type": "string", "description": "Link the passage as /sources/{chunkId}." }, "title": { "type": "string" }, "url": { "type": "string" }, "page": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "quote": { "type": "string", "description": "Verbatim from the passage; checked against the index." } }, "required": ["chunkId", "title", "url", "quote"], "additionalProperties": false }, "patienteninformation": { "type": "object", "properties": { "chunkId": { "type": "string", "description": "Link the passage as /sources/{chunkId}." }, "title": { "type": "string" }, "url": { "type": "string" }, "page": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "quote": { "type": "string", "description": "Verbatim from the passage; checked against the index." } }, "required": ["chunkId", "title", "url", "quote"], "additionalProperties": false }, "unterschrift": { "type": "object", "properties": { "chunkId": { "type": "string", "description": "Link the passage as /sources/{chunkId}." }, "title": { "type": "string" }, "url": { "type": "string" }, "page": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "quote": { "type": "string", "description": "Verbatim from the passage; checked against the index." } }, "required": ["chunkId", "title", "url", "quote"], "additionalProperties": false }, "genehmigung": { "type": "object", "properties": { "chunkId": { "type": "string", "description": "Link the passage as /sources/{chunkId}." }, "title": { "type": "string" }, "url": { "type": "string" }, "page": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "quote": { "type": "string", "description": "Verbatim from the passage; checked against the index." } }, "required": ["chunkId", "title", "url", "quote"], "additionalProperties": false }, "eingliederung": { "type": "object", "properties": { "chunkId": { "type": "string", "description": "Link the passage as /sources/{chunkId}." }, "title": { "type": "string" }, "url": { "type": "string" }, "page": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "quote": { "type": "string", "description": "Verbatim from the passage; checked against the index." } }, "required": ["chunkId", "title", "url", "quote"], "additionalProperties": false }, "wiederherstellungen": { "type": "object", "properties": { "chunkId": { "type": "string", "description": "Link the passage as /sources/{chunkId}." }, "title": { "type": "string" }, "url": { "type": "string" }, "page": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "quote": { "type": "string", "description": "Verbatim from the passage; checked against the index." } }, "required": ["chunkId", "title", "url", "quote"], "additionalProperties": false }, "ohneBewilligung": { "type": "object", "properties": { "chunkId": { "type": "string", "description": "Link the passage as /sources/{chunkId}." }, "title": { "type": "string" }, "url": { "type": "string" }, "page": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "quote": { "type": "string", "description": "Verbatim from the passage; checked against the index." } }, "required": ["chunkId", "title", "url", "quote"], "additionalProperties": false }, "stiftaufbauten": { "type": "object", "properties": { "chunkId": { "type": "string", "description": "Link the passage as /sources/{chunkId}." }, "title": { "type": "string" }, "url": { "type": "string" }, "page": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "quote": { "type": "string", "description": "Verbatim from the passage; checked against the index." } }, "required": ["chunkId", "title", "url", "quote"], "additionalProperties": false }, "haertefall": { "type": "object", "properties": { "chunkId": { "type": "string", "description": "Link the passage as /sources/{chunkId}." }, "title": { "type": "string" }, "url": { "type": "string" }, "page": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "quote": { "type": "string", "description": "Verbatim from the passage; checked against the index." } }, "required": ["chunkId", "title", "url", "quote"], "additionalProperties": false } }, "required": ["aufklaerung", "bonus", "patienteninformation", "unterschrift", "genehmigung", "eingliederung", "wiederherstellungen", "ohneBewilligung", "stiftaufbauten", "haertefall"], "additionalProperties": false, "description": "The passages the rule reads, by what each says, for the summary to link." } }, "required": ["patienteninformation", "bewilligung", "passages"], "additionalProperties": false }, "alternative": { "description": "The case once more with its crowns the other way, for the consultation: nothing stored, the rules' numbers. Only for a finished case with a crown.", "type": "object", "properties": { "geplant": { "type": "string", "enum": ["regelversorgung", "vollkeramik"], "description": "What every crown was assumed as: the Regelversorgung where a crown of the case is gleichartig, else vollkeramisch." }, "totals": { "type": "object", "properties": { "honorar": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991, "description": "The BEMA lines' fees, in cents." }, "goz": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991, "description": "The GOZ lines' fees, in cents; 0 without a gleichartige crown." }, "labor": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991, "description": "The teeth's lab costs as a guide, in cents." }, "gesamt": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991, "description": "Honorar, GOZ and Labor, without materials." }, "festzuschuss": { "type": "object", "properties": { "prozent60": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "prozent70": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "prozent75": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "prozent100": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 } }, "required": ["prozent60", "prozent70", "prozent75", "prozent100"], "additionalProperties": false }, "eigenanteil": { "type": "object", "properties": { "prozent60": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "prozent70": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "prozent75": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "prozent100": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 } }, "required": ["prozent60", "prozent70", "prozent75", "prozent100"], "additionalProperties": false, "description": "What the patient pays at each subsidy level: the total less the Festzuschuss, at least 0." } }, "required": ["honorar", "goz", "labor", "gesamt", "festzuschuss", "eigenanteil"], "additionalProperties": false }, "placeholders": { "type": "array", "items": { "type": "object", "properties": { "id": { "type": "string", "enum": ["punktwert", "labor", "materialPreise", "anzahl", "faktor", "laborGleichartig", "eigenanteil"] }, "text": { "type": "string" } }, "required": ["id", "text"], "additionalProperties": false }, "description": "What the costs need and the sources do not hold: say each where a number would be, never estimate it." } }, "required": ["geplant", "totals", "placeholders"], "additionalProperties": false }, "superseded": { "type": "array", "items": { "type": "object", "properties": { "rule": { "type": "string" }, "befund": { "type": "string" }, "title": { "type": "string" }, "fdi": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "by": { "type": "string", "description": "The rule that rules it out: the teeth bounding a gap." }, "citations": { "type": "array", "items": { "type": "object", "properties": { "chunkId": { "type": "string", "description": "Link the passage as /sources/{chunkId}." }, "title": { "type": "string" }, "url": { "type": "string" }, "page": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "quote": { "type": "string", "description": "Verbatim from the passage; checked against the index." } }, "required": ["chunkId", "title", "url", "quote"], "additionalProperties": false }, "description": "The passages of the rule that rules it out." } }, "required": ["rule", "befund", "title", "fdi", "by", "citations"], "additionalProperties": false }, "description": "Befunde the findings would give but the guideline rules out where they are: 1.1 to 1.3 at a tooth bounding a gap of class 2 (FZ-RL p. 10). Not in the draft or the costs." }, "decisions": { "type": "array", "items": { "type": "object", "properties": { "rule": { "type": "string", "description": "The rule, by id; its title and passages are in `rules`." }, "at": { "type": "string", "description": `Where it decided: a tooth's number ("36"), a gap's id ("UK:45-47"), a jaw, or "patient".` }, "kind": { "type": "string", "enum": ["result", "notApplicable", "superseded", "needs", "pending"], "description": "Applied; did not apply; applied but ruled out by `by`; needs findings no one has confirmed (`missing`); waits on an earlier rule (`missing`)." }, "facts": { "type": "array", "items": { "type": "object", "properties": { "fdi": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991, "description": "The tooth, by FDI number (11\u201348)." }, "jaw": { "type": "string", "enum": ["OK", "UK"], "description": "The jaw: OK upper, UK lower." }, "fact": { "type": "string", "enum": ["fehlt", "erhaltungswuerdig", "krone", "endodontisch_behandelt", "stiftaufbau", "brueckenanker", "disparallel", "wiederherstellung", "geplant", "lueckensituation_i"], "description": "A finding, by name: at a tooth, or at a jaw (lueckensituation_i)." }, "value": { "anyOf": [{ "type": "boolean" }, { "type": "string" }] }, "statedIn": { "type": "string" } }, "required": ["fact", "value", "statedIn"], "additionalProperties": false }, "description": "The dentist's findings the rule read, each where it is stated: what decided it. Empty for one that needs or waits, and for one not applicable because no answer to its missing findings could make it apply." }, "counts": { "type": "array", "items": { "type": "object", "properties": { "nr": { "type": "string" }, "value": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "statedIn": { "type": "string" } }, "required": ["nr", "value", "statedIn"], "additionalProperties": false }, "description": "The dentist's counts it read, for BEMA lines at its place no source counts." }, "from": { "type": "array", "items": { "type": "object", "properties": { "rule": { "type": "string" }, "at": { "type": "string" } }, "required": ["rule", "at"], "additionalProperties": false }, "description": "The earlier decisions whose results it read, by rule and place." }, "by": { "description": "For `superseded`: the rule whose result rules it out.", "type": "string" }, "missing": { "description": "For `needs` and `pending`: the findings or results it lacks, as `{at}.{name}`.", "type": "array", "items": { "type": "string" } } }, "required": ["rule", "at", "kind", "facts", "counts", "from"], "additionalProperties": false, "description": "One rule at one place, and what decided it." }, "description": "Every rule at every place it applies to, in the order the engine ran them: what the draft, the costs and the questions rest on, including the rules that did not apply." }, "rules": { "type": "array", "items": { "type": "object", "properties": { "id": { "type": "string" }, "title": { "type": "string" }, "citations": { "type": "array", "items": { "type": "object", "properties": { "chunkId": { "type": "string", "description": "Link the passage as /sources/{chunkId}." }, "title": { "type": "string" }, "url": { "type": "string" }, "page": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "quote": { "type": "string", "description": "Verbatim from the passage; checked against the index." } }, "required": ["chunkId", "title", "url", "quote"], "additionalProperties": false }, "description": "Its passages, resolved in the index." }, "ours": { "type": "array", "items": { "type": "string" }, "description": "Where it reads its sources in a way their text leaves room for, one sentence each: what the billing review checks." } }, "required": ["id", "title", "citations", "ours"], "additionalProperties": false }, "description": "The rules `decisions` names, once each." }, "grid": { "type": "array", "items": { "type": "object", "properties": { "place": { "type": "string", "description": `A tooth's number ("36"), a gap's id ("UK:45-47"), a jaw, or "patient".` }, "stage": { "type": "string", "enum": ["kostentraeger", "befund", "regelversorgung", "planung", "versorgungsform", "positionen"], "description": "The question the cell answers: who pays, which Befund, its Regelversorgung, what is planned, which class of care, which numbers." }, "state": { "type": "string", "enum": ["decided", "assumed", "open", "waiting", "notApplicable", "superseded"], "description": "Decided; assumed with nothing deciding it yet; open, a finding here is to be confirmed; waiting on an earlier cell, a stale rule or the proposals; no rule applies; every result ruled out." }, "owner": { "type": "string", "enum": ["rule", "dentist", "patient", "assumed"], "description": "Whose the answer is: the rules', the dentist's or the patient's (confirmed by the dentist), or an assumption." }, "answer": { "type": "string", "description": "The answer, worded for the dentist." }, "decisions": { "type": "array", "items": { "type": "object", "properties": { "rule": { "type": "string" }, "at": { "type": "string" } }, "required": ["rule", "at"], "additionalProperties": false }, "description": "The decisions behind it, by rule and place, as `decisions` lists them." }, "facts": { "type": "array", "items": { "type": "object", "properties": { "fdi": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991, "description": "The tooth, by FDI number (11\u201348)." }, "jaw": { "type": "string", "enum": ["OK", "UK"], "description": "The jaw: OK upper, UK lower." }, "fact": { "type": "string", "enum": ["fehlt", "erhaltungswuerdig", "krone", "endodontisch_behandelt", "stiftaufbau", "brueckenanker", "disparallel", "wiederherstellung", "geplant", "lueckensituation_i"], "description": "A finding, by name: at a tooth, or at a jaw (lueckensituation_i)." }, "value": { "anyOf": [{ "type": "boolean" }, { "type": "string" }] }, "statedIn": { "type": "string" }, "owner": { "type": "string", "enum": ["dentist", "patient"] } }, "required": ["fact", "value", "statedIn", "owner"], "additionalProperties": false }, "description": "The confirmed findings it rests on, each where it is stated and whose it is." }, "counts": { "type": "array", "items": { "type": "object", "properties": { "nr": { "type": "string" }, "value": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "statedIn": { "type": "string" } }, "required": ["nr", "value", "statedIn"], "additionalProperties": false }, "description": "The dentist's counts it rests on." }, "proposed": { "description": "What the cell would be once every open proposal is confirmed, where that differs. A cell only the proposals give waits on them.", "type": "object", "properties": { "state": { "type": "string", "enum": ["decided", "assumed", "open", "waiting", "notApplicable", "superseded"], "description": "Decided; assumed with nothing deciding it yet; open, a finding here is to be confirmed; waiting on an earlier cell, a stale rule or the proposals; no rule applies; every result ruled out." }, "answer": { "type": "string", "description": "The answer, worded for the dentist." }, "decisions": { "type": "array", "items": { "type": "object", "properties": { "rule": { "type": "string" }, "at": { "type": "string" } }, "required": ["rule", "at"], "additionalProperties": false }, "description": "The decisions behind it, by rule and place, as `decisions` lists them." } }, "required": ["state", "answer", "decisions"], "additionalProperties": false } }, "required": ["place", "stage", "state", "owner", "answer", "decisions", "facts", "counts"], "additionalProperties": false, "description": "One place at one stage: what is decided there, by whom, and on what." }, "description": "The decisions as places \xD7 stages, ordered by place (case, jaws, gaps, teeth), then stage; a cell only where something is decided, asked or assumed." }, "questions": { "type": "array", "items": { "type": "object", "properties": { "fdi": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991, "description": "The tooth, by FDI number (11\u201348)." }, "jaw": { "type": "string", "enum": ["OK", "UK"], "description": "The jaw: OK upper, UK lower." }, "fact": { "type": "string", "enum": ["fehlt", "erhaltungswuerdig", "krone", "endodontisch_behandelt", "stiftaufbau", "brueckenanker", "disparallel", "wiederherstellung", "geplant", "lueckensituation_i"], "description": "A finding, by name: at a tooth, or at a jaw (lueckensituation_i)." }, "description": { "type": "string" }, "proposed": { "description": "The agent's proposal, if any: the dentist has to confirm or correct it.", "anyOf": [{ "type": "boolean" }, { "type": "string" }] }, "openAfterProposals": { "type": "boolean", "description": "Whether the rules still ask it once every open proposal is confirmed: false for a proposed one, and for one a proposal makes moot (a post once \u201Enot root-treated\u201C is confirmed)." }, "rules": { "type": "array", "items": { "type": "string" } }, "answers": { "type": "array", "items": { "type": "object", "properties": { "value": { "anyOf": [{ "type": "boolean" }, { "type": "string" }] }, "befunde": { "type": "array", "items": { "type": "object", "properties": { "befund": { "type": "string" }, "title": { "type": "string" }, "festzuschuss": { "type": "object", "properties": { "zahnaerztlich": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "zahntechnisch": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "prozent60": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "prozent70": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "prozent75": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "prozent100": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 } }, "required": ["zahnaerztlich", "zahntechnisch", "prozent60", "prozent70", "prozent75", "prozent100"], "additionalProperties": false, "description": "In cents: the dental and the technical share, and the Festzuschuss at 60 % (no bonus), 70 % (bonus 1), 75 % (bonus 2) and 100 % (hardship)." } }, "required": ["befund", "title", "festzuschuss"], "additionalProperties": false }, "description": "The Befunde this answer adds, at its tooth or at a gap it makes or bounds." }, "settles": { "type": "boolean", "description": "Nothing is left to ask at the tooth or jaw after it." } }, "required": ["value", "befunde", "settles"], "additionalProperties": false }, "description": "Each value the finding takes, and what the rules give if it is confirmed." } }, "required": ["fact", "description", "openAfterProposals", "rules", "answers"], "additionalProperties": false }, "description": "Findings the rules need and no one has confirmed. A finding no answer could make count is not asked." }, "ask": { "type": "array", "items": { "type": "object", "properties": { "fdi": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991, "description": "The tooth, by FDI number (11\u201348)." }, "jaw": { "type": "string", "enum": ["OK", "UK"], "description": "The jaw: OK upper, UK lower." }, "fact": { "type": "string", "enum": ["fehlt", "erhaltungswuerdig", "krone", "endodontisch_behandelt", "stiftaufbau", "brueckenanker", "disparallel", "wiederherstellung", "geplant", "lueckensituation_i"], "description": "A finding, by name: at a tooth, or at a jaw (lueckensituation_i)." } }, "required": ["fact"], "additionalProperties": false }, "description": "What the dentist is asked now, in order: every open question, those the agent chose first." }, "noBefund": { "type": "array", "items": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "description": "Teeth with nothing left to ask whose confirmed findings give no Befund the rules cover (class 1, 2.1 to 2.7 for a gap, 6.8 to 6.9 for a repair): a tooth not worth keeping, one in a lateral gap of four or outside L\xFCckensituation I, or a facet to renew outside the Verblendbereich." }, "stale": { "type": "array", "items": { "type": "object", "properties": { "rule": { "type": "string" }, "title": { "type": "string" } }, "required": ["rule", "title"], "additionalProperties": false }, "description": "Rules whose source changed in the index: not applied until reviewed." }, "paths": { "type": "array", "items": { "type": "object", "properties": { "id": { "type": "string", "enum": ["entscheidungen", "zuordnung", "goz-details", "planpflicht", "pruefkommentar"] }, "title": { "type": "string" }, "question": { "type": "string" }, "rules": { "type": "array", "items": { "type": "object", "properties": { "id": { "type": "string" }, "title": { "type": "string" } }, "required": ["id", "title"], "additionalProperties": false }, "description": "The rules giving what the path shows; empty where no rule covers it yet." }, "notCovered": { "type": "string", "description": "What the path does not check yet, for the dentist." }, "unbuilt": { "type": "array", "items": { "type": "object", "properties": { "befund": { "type": "string" }, "title": { "type": "string" }, "pages": { "type": "array", "items": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 } } }, "required": ["befund", "title", "pages"], "additionalProperties": false }, "description": "The Befunde of the Festzuschuss-Richtlinie the index lists and no rule gives yet; empty but for Entscheidungen. A case needing one has no Befund for it and no total covering it." } }, "required": ["id", "title", "question", "rules", "notCovered", "unbuilt"], "additionalProperties": false }, "description": "The page below the agent's reply, in its order: each question a billing check answers, the rules covering it, and what they do not cover yet." }, "vocabulary": { "type": "array", "items": { "type": "object", "properties": { "fact": { "type": "string", "enum": ["fehlt", "erhaltungswuerdig", "krone", "endodontisch_behandelt", "stiftaufbau", "brueckenanker", "disparallel", "wiederherstellung", "geplant", "lueckensituation_i"], "description": "A finding, by name: at a tooth, or at a jaw (lueckensituation_i)." }, "place": { "type": "string", "enum": ["tooth", "jaw"], "description": "Where the finding is stated." }, "stage": { "type": "string", "enum": ["befund", "planung"], "description": "The stage whose cell asks it: the Befund, or what is planned." }, "owner": { "type": "string", "enum": ["dentist", "patient"], "description": "Whose it is: the dentist's judgement, or the patient's choice the dentist reports." }, "label": { "type": "string" }, "description": { "type": "string" }, "values": { "type": "array", "items": { "type": "object", "properties": { "value": { "anyOf": [{ "type": "boolean" }, { "type": "string" }] }, "label": { "type": "string" } }, "required": ["value", "label"], "additionalProperties": false } }, "schema": { "type": "object", "properties": { "type": { "type": "string", "enum": ["boolean", "string"] }, "enum": { "type": "array", "items": { "type": "string" } }, "title": { "type": "string" }, "description": { "type": "string" }, "labels": { "type": "array", "items": { "type": "object", "properties": { "value": { "anyOf": [{ "type": "boolean" }, { "type": "string" }] }, "label": { "type": "string" } }, "required": ["value", "label"], "additionalProperties": false }, "description": "Each value's name, in the order the card offers them." } }, "required": ["type", "title", "description", "labels"], "additionalProperties": false } }, "required": ["fact", "place", "stage", "owner", "label", "description", "values", "schema"], "additionalProperties": false }, "description": "Every finding, with the values it takes and how to name them." } }, "required": ["object", "conversationId", "draft", "projection", "costs", "projectedCosts", "superseded", "decisions", "rules", "grid", "questions", "ask", "noBefund", "stale", "paths", "vocabulary"], "additionalProperties": false };
function validate31(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.object === void 0) {
      const err0 = { instancePath, schemaPath: "#/definitions/VerificationEvaluation/required", keyword: "required", params: { missingProperty: "object" }, message: "must have required property 'object'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.conversationId === void 0) {
      const err1 = { instancePath, schemaPath: "#/definitions/VerificationEvaluation/required", keyword: "required", params: { missingProperty: "conversationId" }, message: "must have required property 'conversationId'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.draft === void 0) {
      const err2 = { instancePath, schemaPath: "#/definitions/VerificationEvaluation/required", keyword: "required", params: { missingProperty: "draft" }, message: "must have required property 'draft'" };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.projection === void 0) {
      const err3 = { instancePath, schemaPath: "#/definitions/VerificationEvaluation/required", keyword: "required", params: { missingProperty: "projection" }, message: "must have required property 'projection'" };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.costs === void 0) {
      const err4 = { instancePath, schemaPath: "#/definitions/VerificationEvaluation/required", keyword: "required", params: { missingProperty: "costs" }, message: "must have required property 'costs'" };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
    if (data.projectedCosts === void 0) {
      const err5 = { instancePath, schemaPath: "#/definitions/VerificationEvaluation/required", keyword: "required", params: { missingProperty: "projectedCosts" }, message: "must have required property 'projectedCosts'" };
      if (vErrors === null) {
        vErrors = [err5];
      } else {
        vErrors.push(err5);
      }
      errors++;
    }
    if (data.superseded === void 0) {
      const err6 = { instancePath, schemaPath: "#/definitions/VerificationEvaluation/required", keyword: "required", params: { missingProperty: "superseded" }, message: "must have required property 'superseded'" };
      if (vErrors === null) {
        vErrors = [err6];
      } else {
        vErrors.push(err6);
      }
      errors++;
    }
    if (data.decisions === void 0) {
      const err7 = { instancePath, schemaPath: "#/definitions/VerificationEvaluation/required", keyword: "required", params: { missingProperty: "decisions" }, message: "must have required property 'decisions'" };
      if (vErrors === null) {
        vErrors = [err7];
      } else {
        vErrors.push(err7);
      }
      errors++;
    }
    if (data.rules === void 0) {
      const err8 = { instancePath, schemaPath: "#/definitions/VerificationEvaluation/required", keyword: "required", params: { missingProperty: "rules" }, message: "must have required property 'rules'" };
      if (vErrors === null) {
        vErrors = [err8];
      } else {
        vErrors.push(err8);
      }
      errors++;
    }
    if (data.grid === void 0) {
      const err9 = { instancePath, schemaPath: "#/definitions/VerificationEvaluation/required", keyword: "required", params: { missingProperty: "grid" }, message: "must have required property 'grid'" };
      if (vErrors === null) {
        vErrors = [err9];
      } else {
        vErrors.push(err9);
      }
      errors++;
    }
    if (data.questions === void 0) {
      const err10 = { instancePath, schemaPath: "#/definitions/VerificationEvaluation/required", keyword: "required", params: { missingProperty: "questions" }, message: "must have required property 'questions'" };
      if (vErrors === null) {
        vErrors = [err10];
      } else {
        vErrors.push(err10);
      }
      errors++;
    }
    if (data.ask === void 0) {
      const err11 = { instancePath, schemaPath: "#/definitions/VerificationEvaluation/required", keyword: "required", params: { missingProperty: "ask" }, message: "must have required property 'ask'" };
      if (vErrors === null) {
        vErrors = [err11];
      } else {
        vErrors.push(err11);
      }
      errors++;
    }
    if (data.noBefund === void 0) {
      const err12 = { instancePath, schemaPath: "#/definitions/VerificationEvaluation/required", keyword: "required", params: { missingProperty: "noBefund" }, message: "must have required property 'noBefund'" };
      if (vErrors === null) {
        vErrors = [err12];
      } else {
        vErrors.push(err12);
      }
      errors++;
    }
    if (data.stale === void 0) {
      const err13 = { instancePath, schemaPath: "#/definitions/VerificationEvaluation/required", keyword: "required", params: { missingProperty: "stale" }, message: "must have required property 'stale'" };
      if (vErrors === null) {
        vErrors = [err13];
      } else {
        vErrors.push(err13);
      }
      errors++;
    }
    if (data.paths === void 0) {
      const err14 = { instancePath, schemaPath: "#/definitions/VerificationEvaluation/required", keyword: "required", params: { missingProperty: "paths" }, message: "must have required property 'paths'" };
      if (vErrors === null) {
        vErrors = [err14];
      } else {
        vErrors.push(err14);
      }
      errors++;
    }
    if (data.vocabulary === void 0) {
      const err15 = { instancePath, schemaPath: "#/definitions/VerificationEvaluation/required", keyword: "required", params: { missingProperty: "vocabulary" }, message: "must have required property 'vocabulary'" };
      if (vErrors === null) {
        vErrors = [err15];
      } else {
        vErrors.push(err15);
      }
      errors++;
    }
    for (const key0 in data) {
      if (!func6.call(schema37.properties, key0)) {
        const err16 = { instancePath, schemaPath: "#/definitions/VerificationEvaluation/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err16];
        } else {
          vErrors.push(err16);
        }
        errors++;
      }
    }
    if (data.object !== void 0) {
      let data0 = data.object;
      if (typeof data0 !== "string") {
        const err17 = { instancePath: instancePath + "/object", schemaPath: "#/definitions/VerificationEvaluation/properties/object/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err17];
        } else {
          vErrors.push(err17);
        }
        errors++;
      }
      if ("verification_evaluation" !== data0) {
        const err18 = { instancePath: instancePath + "/object", schemaPath: "#/definitions/VerificationEvaluation/properties/object/const", keyword: "const", params: { allowedValue: "verification_evaluation" }, message: "must be equal to constant" };
        if (vErrors === null) {
          vErrors = [err18];
        } else {
          vErrors.push(err18);
        }
        errors++;
      }
    }
    if (data.conversationId !== void 0) {
      if (typeof data.conversationId !== "string") {
        const err19 = { instancePath: instancePath + "/conversationId", schemaPath: "#/definitions/VerificationEvaluation/properties/conversationId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err19];
        } else {
          vErrors.push(err19);
        }
        errors++;
      }
    }
    if (data.draft !== void 0) {
      let data2 = data.draft;
      if (Array.isArray(data2)) {
        const len0 = data2.length;
        for (let i0 = 0; i0 < len0; i0++) {
          let data3 = data2[i0];
          if (data3 && typeof data3 == "object" && !Array.isArray(data3)) {
            if (data3.rule === void 0) {
              const err20 = { instancePath: instancePath + "/draft/" + i0, schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/required", keyword: "required", params: { missingProperty: "rule" }, message: "must have required property 'rule'" };
              if (vErrors === null) {
                vErrors = [err20];
              } else {
                vErrors.push(err20);
              }
              errors++;
            }
            if (data3.befund === void 0) {
              const err21 = { instancePath: instancePath + "/draft/" + i0, schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/required", keyword: "required", params: { missingProperty: "befund" }, message: "must have required property 'befund'" };
              if (vErrors === null) {
                vErrors = [err21];
              } else {
                vErrors.push(err21);
              }
              errors++;
            }
            if (data3.title === void 0) {
              const err22 = { instancePath: instancePath + "/draft/" + i0, schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
              if (vErrors === null) {
                vErrors = [err22];
              } else {
                vErrors.push(err22);
              }
              errors++;
            }
            if (data3.festzuschuss === void 0) {
              const err23 = { instancePath: instancePath + "/draft/" + i0, schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/required", keyword: "required", params: { missingProperty: "festzuschuss" }, message: "must have required property 'festzuschuss'" };
              if (vErrors === null) {
                vErrors = [err23];
              } else {
                vErrors.push(err23);
              }
              errors++;
            }
            if (data3.used === void 0) {
              const err24 = { instancePath: instancePath + "/draft/" + i0, schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/required", keyword: "required", params: { missingProperty: "used" }, message: "must have required property 'used'" };
              if (vErrors === null) {
                vErrors = [err24];
              } else {
                vErrors.push(err24);
              }
              errors++;
            }
            if (data3.citations === void 0) {
              const err25 = { instancePath: instancePath + "/draft/" + i0, schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/required", keyword: "required", params: { missingProperty: "citations" }, message: "must have required property 'citations'" };
              if (vErrors === null) {
                vErrors = [err25];
              } else {
                vErrors.push(err25);
              }
              errors++;
            }
            for (const key1 in data3) {
              if (!func6.call(schema37.properties.draft.items.properties, key1)) {
                const err26 = { instancePath: instancePath + "/draft/" + i0, schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
                if (vErrors === null) {
                  vErrors = [err26];
                } else {
                  vErrors.push(err26);
                }
                errors++;
              }
            }
            if (data3.rule !== void 0) {
              if (typeof data3.rule !== "string") {
                const err27 = { instancePath: instancePath + "/draft/" + i0 + "/rule", schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/rule/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err27];
                } else {
                  vErrors.push(err27);
                }
                errors++;
              }
            }
            if (data3.befund !== void 0) {
              if (typeof data3.befund !== "string") {
                const err28 = { instancePath: instancePath + "/draft/" + i0 + "/befund", schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/befund/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err28];
                } else {
                  vErrors.push(err28);
                }
                errors++;
              }
            }
            if (data3.title !== void 0) {
              if (typeof data3.title !== "string") {
                const err29 = { instancePath: instancePath + "/draft/" + i0 + "/title", schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err29];
                } else {
                  vErrors.push(err29);
                }
                errors++;
              }
            }
            if (data3.fdi !== void 0) {
              let data7 = data3.fdi;
              if (!(typeof data7 == "number" && (!(data7 % 1) && !isNaN(data7)) && isFinite(data7))) {
                const err30 = { instancePath: instancePath + "/draft/" + i0 + "/fdi", schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/fdi/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                if (vErrors === null) {
                  vErrors = [err30];
                } else {
                  vErrors.push(err30);
                }
                errors++;
              }
              if (typeof data7 == "number" && isFinite(data7)) {
                if (data7 > 9007199254740991 || isNaN(data7)) {
                  const err31 = { instancePath: instancePath + "/draft/" + i0 + "/fdi", schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/fdi/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err31];
                  } else {
                    vErrors.push(err31);
                  }
                  errors++;
                }
                if (data7 < -9007199254740991 || isNaN(data7)) {
                  const err32 = { instancePath: instancePath + "/draft/" + i0 + "/fdi", schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/fdi/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err32];
                  } else {
                    vErrors.push(err32);
                  }
                  errors++;
                }
              }
            }
            if (data3.luecke !== void 0) {
              let data8 = data3.luecke;
              if (data8 && typeof data8 == "object" && !Array.isArray(data8)) {
                if (data8.id === void 0) {
                  const err33 = { instancePath: instancePath + "/draft/" + i0 + "/luecke", schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/luecke/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property 'id'" };
                  if (vErrors === null) {
                    vErrors = [err33];
                  } else {
                    vErrors.push(err33);
                  }
                  errors++;
                }
                if (data8.jaw === void 0) {
                  const err34 = { instancePath: instancePath + "/draft/" + i0 + "/luecke", schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/luecke/required", keyword: "required", params: { missingProperty: "jaw" }, message: "must have required property 'jaw'" };
                  if (vErrors === null) {
                    vErrors = [err34];
                  } else {
                    vErrors.push(err34);
                  }
                  errors++;
                }
                if (data8.anker === void 0) {
                  const err35 = { instancePath: instancePath + "/draft/" + i0 + "/luecke", schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/luecke/required", keyword: "required", params: { missingProperty: "anker" }, message: "must have required property 'anker'" };
                  if (vErrors === null) {
                    vErrors = [err35];
                  } else {
                    vErrors.push(err35);
                  }
                  errors++;
                }
                if (data8.fehlend === void 0) {
                  const err36 = { instancePath: instancePath + "/draft/" + i0 + "/luecke", schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/luecke/required", keyword: "required", params: { missingProperty: "fehlend" }, message: "must have required property 'fehlend'" };
                  if (vErrors === null) {
                    vErrors = [err36];
                  } else {
                    vErrors.push(err36);
                  }
                  errors++;
                }
                for (const key2 in data8) {
                  if (!(key2 === "id" || key2 === "jaw" || key2 === "anker" || key2 === "fehlend")) {
                    const err37 = { instancePath: instancePath + "/draft/" + i0 + "/luecke", schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/luecke/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key2 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                      vErrors = [err37];
                    } else {
                      vErrors.push(err37);
                    }
                    errors++;
                  }
                }
                if (data8.id !== void 0) {
                  if (typeof data8.id !== "string") {
                    const err38 = { instancePath: instancePath + "/draft/" + i0 + "/luecke/id", schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/luecke/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err38];
                    } else {
                      vErrors.push(err38);
                    }
                    errors++;
                  }
                }
                if (data8.jaw !== void 0) {
                  let data10 = data8.jaw;
                  if (typeof data10 !== "string") {
                    const err39 = { instancePath: instancePath + "/draft/" + i0 + "/luecke/jaw", schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/luecke/properties/jaw/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err39];
                    } else {
                      vErrors.push(err39);
                    }
                    errors++;
                  }
                  if (!(data10 === "OK" || data10 === "UK")) {
                    const err40 = { instancePath: instancePath + "/draft/" + i0 + "/luecke/jaw", schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/luecke/properties/jaw/enum", keyword: "enum", params: { allowedValues: schema37.properties.draft.items.properties.luecke.properties.jaw.enum }, message: "must be equal to one of the allowed values" };
                    if (vErrors === null) {
                      vErrors = [err40];
                    } else {
                      vErrors.push(err40);
                    }
                    errors++;
                  }
                }
                if (data8.anker !== void 0) {
                  let data11 = data8.anker;
                  if (Array.isArray(data11)) {
                    const len1 = data11.length;
                    for (let i1 = 0; i1 < len1; i1++) {
                      let data12 = data11[i1];
                      if (!(typeof data12 == "number" && (!(data12 % 1) && !isNaN(data12)) && isFinite(data12))) {
                        const err41 = { instancePath: instancePath + "/draft/" + i0 + "/luecke/anker/" + i1, schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/luecke/properties/anker/items/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                        if (vErrors === null) {
                          vErrors = [err41];
                        } else {
                          vErrors.push(err41);
                        }
                        errors++;
                      }
                      if (typeof data12 == "number" && isFinite(data12)) {
                        if (data12 > 9007199254740991 || isNaN(data12)) {
                          const err42 = { instancePath: instancePath + "/draft/" + i0 + "/luecke/anker/" + i1, schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/luecke/properties/anker/items/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                          if (vErrors === null) {
                            vErrors = [err42];
                          } else {
                            vErrors.push(err42);
                          }
                          errors++;
                        }
                        if (data12 < -9007199254740991 || isNaN(data12)) {
                          const err43 = { instancePath: instancePath + "/draft/" + i0 + "/luecke/anker/" + i1, schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/luecke/properties/anker/items/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                          if (vErrors === null) {
                            vErrors = [err43];
                          } else {
                            vErrors.push(err43);
                          }
                          errors++;
                        }
                      }
                    }
                  } else {
                    const err44 = { instancePath: instancePath + "/draft/" + i0 + "/luecke/anker", schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/luecke/properties/anker/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                      vErrors = [err44];
                    } else {
                      vErrors.push(err44);
                    }
                    errors++;
                  }
                }
                if (data8.fehlend !== void 0) {
                  let data13 = data8.fehlend;
                  if (Array.isArray(data13)) {
                    const len2 = data13.length;
                    for (let i2 = 0; i2 < len2; i2++) {
                      let data14 = data13[i2];
                      if (!(typeof data14 == "number" && (!(data14 % 1) && !isNaN(data14)) && isFinite(data14))) {
                        const err45 = { instancePath: instancePath + "/draft/" + i0 + "/luecke/fehlend/" + i2, schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/luecke/properties/fehlend/items/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                        if (vErrors === null) {
                          vErrors = [err45];
                        } else {
                          vErrors.push(err45);
                        }
                        errors++;
                      }
                      if (typeof data14 == "number" && isFinite(data14)) {
                        if (data14 > 9007199254740991 || isNaN(data14)) {
                          const err46 = { instancePath: instancePath + "/draft/" + i0 + "/luecke/fehlend/" + i2, schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/luecke/properties/fehlend/items/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                          if (vErrors === null) {
                            vErrors = [err46];
                          } else {
                            vErrors.push(err46);
                          }
                          errors++;
                        }
                        if (data14 < -9007199254740991 || isNaN(data14)) {
                          const err47 = { instancePath: instancePath + "/draft/" + i0 + "/luecke/fehlend/" + i2, schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/luecke/properties/fehlend/items/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                          if (vErrors === null) {
                            vErrors = [err47];
                          } else {
                            vErrors.push(err47);
                          }
                          errors++;
                        }
                      }
                    }
                  } else {
                    const err48 = { instancePath: instancePath + "/draft/" + i0 + "/luecke/fehlend", schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/luecke/properties/fehlend/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                      vErrors = [err48];
                    } else {
                      vErrors.push(err48);
                    }
                    errors++;
                  }
                }
              } else {
                const err49 = { instancePath: instancePath + "/draft/" + i0 + "/luecke", schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/luecke/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                if (vErrors === null) {
                  vErrors = [err49];
                } else {
                  vErrors.push(err49);
                }
                errors++;
              }
            }
            if (data3.zaehne !== void 0) {
              let data15 = data3.zaehne;
              if (Array.isArray(data15)) {
                const len3 = data15.length;
                for (let i3 = 0; i3 < len3; i3++) {
                  let data16 = data15[i3];
                  if (!(typeof data16 == "number" && (!(data16 % 1) && !isNaN(data16)) && isFinite(data16))) {
                    const err50 = { instancePath: instancePath + "/draft/" + i0 + "/zaehne/" + i3, schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/zaehne/items/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err50];
                    } else {
                      vErrors.push(err50);
                    }
                    errors++;
                  }
                  if (typeof data16 == "number" && isFinite(data16)) {
                    if (data16 > 9007199254740991 || isNaN(data16)) {
                      const err51 = { instancePath: instancePath + "/draft/" + i0 + "/zaehne/" + i3, schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/zaehne/items/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err51];
                      } else {
                        vErrors.push(err51);
                      }
                      errors++;
                    }
                    if (data16 < -9007199254740991 || isNaN(data16)) {
                      const err52 = { instancePath: instancePath + "/draft/" + i0 + "/zaehne/" + i3, schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/zaehne/items/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err52];
                      } else {
                        vErrors.push(err52);
                      }
                      errors++;
                    }
                  }
                }
              } else {
                const err53 = { instancePath: instancePath + "/draft/" + i0 + "/zaehne", schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/zaehne/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                if (vErrors === null) {
                  vErrors = [err53];
                } else {
                  vErrors.push(err53);
                }
                errors++;
              }
            }
            if (data3.festzuschuss !== void 0) {
              let data17 = data3.festzuschuss;
              if (data17 && typeof data17 == "object" && !Array.isArray(data17)) {
                if (data17.zahnaerztlich === void 0) {
                  const err54 = { instancePath: instancePath + "/draft/" + i0 + "/festzuschuss", schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/festzuschuss/required", keyword: "required", params: { missingProperty: "zahnaerztlich" }, message: "must have required property 'zahnaerztlich'" };
                  if (vErrors === null) {
                    vErrors = [err54];
                  } else {
                    vErrors.push(err54);
                  }
                  errors++;
                }
                if (data17.zahntechnisch === void 0) {
                  const err55 = { instancePath: instancePath + "/draft/" + i0 + "/festzuschuss", schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/festzuschuss/required", keyword: "required", params: { missingProperty: "zahntechnisch" }, message: "must have required property 'zahntechnisch'" };
                  if (vErrors === null) {
                    vErrors = [err55];
                  } else {
                    vErrors.push(err55);
                  }
                  errors++;
                }
                if (data17.prozent60 === void 0) {
                  const err56 = { instancePath: instancePath + "/draft/" + i0 + "/festzuschuss", schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/festzuschuss/required", keyword: "required", params: { missingProperty: "prozent60" }, message: "must have required property 'prozent60'" };
                  if (vErrors === null) {
                    vErrors = [err56];
                  } else {
                    vErrors.push(err56);
                  }
                  errors++;
                }
                if (data17.prozent70 === void 0) {
                  const err57 = { instancePath: instancePath + "/draft/" + i0 + "/festzuschuss", schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/festzuschuss/required", keyword: "required", params: { missingProperty: "prozent70" }, message: "must have required property 'prozent70'" };
                  if (vErrors === null) {
                    vErrors = [err57];
                  } else {
                    vErrors.push(err57);
                  }
                  errors++;
                }
                if (data17.prozent75 === void 0) {
                  const err58 = { instancePath: instancePath + "/draft/" + i0 + "/festzuschuss", schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/festzuschuss/required", keyword: "required", params: { missingProperty: "prozent75" }, message: "must have required property 'prozent75'" };
                  if (vErrors === null) {
                    vErrors = [err58];
                  } else {
                    vErrors.push(err58);
                  }
                  errors++;
                }
                if (data17.prozent100 === void 0) {
                  const err59 = { instancePath: instancePath + "/draft/" + i0 + "/festzuschuss", schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/festzuschuss/required", keyword: "required", params: { missingProperty: "prozent100" }, message: "must have required property 'prozent100'" };
                  if (vErrors === null) {
                    vErrors = [err59];
                  } else {
                    vErrors.push(err59);
                  }
                  errors++;
                }
                for (const key3 in data17) {
                  if (!(key3 === "zahnaerztlich" || key3 === "zahntechnisch" || key3 === "prozent60" || key3 === "prozent70" || key3 === "prozent75" || key3 === "prozent100")) {
                    const err60 = { instancePath: instancePath + "/draft/" + i0 + "/festzuschuss", schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/festzuschuss/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key3 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                      vErrors = [err60];
                    } else {
                      vErrors.push(err60);
                    }
                    errors++;
                  }
                }
                if (data17.zahnaerztlich !== void 0) {
                  let data18 = data17.zahnaerztlich;
                  if (!(typeof data18 == "number" && (!(data18 % 1) && !isNaN(data18)) && isFinite(data18))) {
                    const err61 = { instancePath: instancePath + "/draft/" + i0 + "/festzuschuss/zahnaerztlich", schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/festzuschuss/properties/zahnaerztlich/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err61];
                    } else {
                      vErrors.push(err61);
                    }
                    errors++;
                  }
                  if (typeof data18 == "number" && isFinite(data18)) {
                    if (data18 > 9007199254740991 || isNaN(data18)) {
                      const err62 = { instancePath: instancePath + "/draft/" + i0 + "/festzuschuss/zahnaerztlich", schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/festzuschuss/properties/zahnaerztlich/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err62];
                      } else {
                        vErrors.push(err62);
                      }
                      errors++;
                    }
                    if (data18 < -9007199254740991 || isNaN(data18)) {
                      const err63 = { instancePath: instancePath + "/draft/" + i0 + "/festzuschuss/zahnaerztlich", schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/festzuschuss/properties/zahnaerztlich/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err63];
                      } else {
                        vErrors.push(err63);
                      }
                      errors++;
                    }
                  }
                }
                if (data17.zahntechnisch !== void 0) {
                  let data19 = data17.zahntechnisch;
                  if (!(typeof data19 == "number" && (!(data19 % 1) && !isNaN(data19)) && isFinite(data19))) {
                    const err64 = { instancePath: instancePath + "/draft/" + i0 + "/festzuschuss/zahntechnisch", schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/festzuschuss/properties/zahntechnisch/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err64];
                    } else {
                      vErrors.push(err64);
                    }
                    errors++;
                  }
                  if (typeof data19 == "number" && isFinite(data19)) {
                    if (data19 > 9007199254740991 || isNaN(data19)) {
                      const err65 = { instancePath: instancePath + "/draft/" + i0 + "/festzuschuss/zahntechnisch", schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/festzuschuss/properties/zahntechnisch/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err65];
                      } else {
                        vErrors.push(err65);
                      }
                      errors++;
                    }
                    if (data19 < -9007199254740991 || isNaN(data19)) {
                      const err66 = { instancePath: instancePath + "/draft/" + i0 + "/festzuschuss/zahntechnisch", schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/festzuschuss/properties/zahntechnisch/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err66];
                      } else {
                        vErrors.push(err66);
                      }
                      errors++;
                    }
                  }
                }
                if (data17.prozent60 !== void 0) {
                  let data20 = data17.prozent60;
                  if (!(typeof data20 == "number" && (!(data20 % 1) && !isNaN(data20)) && isFinite(data20))) {
                    const err67 = { instancePath: instancePath + "/draft/" + i0 + "/festzuschuss/prozent60", schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/festzuschuss/properties/prozent60/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err67];
                    } else {
                      vErrors.push(err67);
                    }
                    errors++;
                  }
                  if (typeof data20 == "number" && isFinite(data20)) {
                    if (data20 > 9007199254740991 || isNaN(data20)) {
                      const err68 = { instancePath: instancePath + "/draft/" + i0 + "/festzuschuss/prozent60", schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/festzuschuss/properties/prozent60/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err68];
                      } else {
                        vErrors.push(err68);
                      }
                      errors++;
                    }
                    if (data20 < -9007199254740991 || isNaN(data20)) {
                      const err69 = { instancePath: instancePath + "/draft/" + i0 + "/festzuschuss/prozent60", schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/festzuschuss/properties/prozent60/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err69];
                      } else {
                        vErrors.push(err69);
                      }
                      errors++;
                    }
                  }
                }
                if (data17.prozent70 !== void 0) {
                  let data21 = data17.prozent70;
                  if (!(typeof data21 == "number" && (!(data21 % 1) && !isNaN(data21)) && isFinite(data21))) {
                    const err70 = { instancePath: instancePath + "/draft/" + i0 + "/festzuschuss/prozent70", schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/festzuschuss/properties/prozent70/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err70];
                    } else {
                      vErrors.push(err70);
                    }
                    errors++;
                  }
                  if (typeof data21 == "number" && isFinite(data21)) {
                    if (data21 > 9007199254740991 || isNaN(data21)) {
                      const err71 = { instancePath: instancePath + "/draft/" + i0 + "/festzuschuss/prozent70", schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/festzuschuss/properties/prozent70/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err71];
                      } else {
                        vErrors.push(err71);
                      }
                      errors++;
                    }
                    if (data21 < -9007199254740991 || isNaN(data21)) {
                      const err72 = { instancePath: instancePath + "/draft/" + i0 + "/festzuschuss/prozent70", schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/festzuschuss/properties/prozent70/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err72];
                      } else {
                        vErrors.push(err72);
                      }
                      errors++;
                    }
                  }
                }
                if (data17.prozent75 !== void 0) {
                  let data22 = data17.prozent75;
                  if (!(typeof data22 == "number" && (!(data22 % 1) && !isNaN(data22)) && isFinite(data22))) {
                    const err73 = { instancePath: instancePath + "/draft/" + i0 + "/festzuschuss/prozent75", schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/festzuschuss/properties/prozent75/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err73];
                    } else {
                      vErrors.push(err73);
                    }
                    errors++;
                  }
                  if (typeof data22 == "number" && isFinite(data22)) {
                    if (data22 > 9007199254740991 || isNaN(data22)) {
                      const err74 = { instancePath: instancePath + "/draft/" + i0 + "/festzuschuss/prozent75", schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/festzuschuss/properties/prozent75/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err74];
                      } else {
                        vErrors.push(err74);
                      }
                      errors++;
                    }
                    if (data22 < -9007199254740991 || isNaN(data22)) {
                      const err75 = { instancePath: instancePath + "/draft/" + i0 + "/festzuschuss/prozent75", schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/festzuschuss/properties/prozent75/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err75];
                      } else {
                        vErrors.push(err75);
                      }
                      errors++;
                    }
                  }
                }
                if (data17.prozent100 !== void 0) {
                  let data23 = data17.prozent100;
                  if (!(typeof data23 == "number" && (!(data23 % 1) && !isNaN(data23)) && isFinite(data23))) {
                    const err76 = { instancePath: instancePath + "/draft/" + i0 + "/festzuschuss/prozent100", schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/festzuschuss/properties/prozent100/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err76];
                    } else {
                      vErrors.push(err76);
                    }
                    errors++;
                  }
                  if (typeof data23 == "number" && isFinite(data23)) {
                    if (data23 > 9007199254740991 || isNaN(data23)) {
                      const err77 = { instancePath: instancePath + "/draft/" + i0 + "/festzuschuss/prozent100", schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/festzuschuss/properties/prozent100/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err77];
                      } else {
                        vErrors.push(err77);
                      }
                      errors++;
                    }
                    if (data23 < -9007199254740991 || isNaN(data23)) {
                      const err78 = { instancePath: instancePath + "/draft/" + i0 + "/festzuschuss/prozent100", schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/festzuschuss/properties/prozent100/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err78];
                      } else {
                        vErrors.push(err78);
                      }
                      errors++;
                    }
                  }
                }
              } else {
                const err79 = { instancePath: instancePath + "/draft/" + i0 + "/festzuschuss", schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/festzuschuss/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                if (vErrors === null) {
                  vErrors = [err79];
                } else {
                  vErrors.push(err79);
                }
                errors++;
              }
            }
            if (data3.used !== void 0) {
              let data24 = data3.used;
              if (Array.isArray(data24)) {
                const len4 = data24.length;
                for (let i4 = 0; i4 < len4; i4++) {
                  if (typeof data24[i4] !== "string") {
                    const err80 = { instancePath: instancePath + "/draft/" + i0 + "/used/" + i4, schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/used/items/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err80];
                    } else {
                      vErrors.push(err80);
                    }
                    errors++;
                  }
                }
              } else {
                const err81 = { instancePath: instancePath + "/draft/" + i0 + "/used", schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/used/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                if (vErrors === null) {
                  vErrors = [err81];
                } else {
                  vErrors.push(err81);
                }
                errors++;
              }
            }
            if (data3.citations !== void 0) {
              let data26 = data3.citations;
              if (Array.isArray(data26)) {
                const len5 = data26.length;
                for (let i5 = 0; i5 < len5; i5++) {
                  let data27 = data26[i5];
                  if (data27 && typeof data27 == "object" && !Array.isArray(data27)) {
                    if (data27.chunkId === void 0) {
                      const err82 = { instancePath: instancePath + "/draft/" + i0 + "/citations/" + i5, schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/citations/items/required", keyword: "required", params: { missingProperty: "chunkId" }, message: "must have required property 'chunkId'" };
                      if (vErrors === null) {
                        vErrors = [err82];
                      } else {
                        vErrors.push(err82);
                      }
                      errors++;
                    }
                    if (data27.title === void 0) {
                      const err83 = { instancePath: instancePath + "/draft/" + i0 + "/citations/" + i5, schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/citations/items/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
                      if (vErrors === null) {
                        vErrors = [err83];
                      } else {
                        vErrors.push(err83);
                      }
                      errors++;
                    }
                    if (data27.url === void 0) {
                      const err84 = { instancePath: instancePath + "/draft/" + i0 + "/citations/" + i5, schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/citations/items/required", keyword: "required", params: { missingProperty: "url" }, message: "must have required property 'url'" };
                      if (vErrors === null) {
                        vErrors = [err84];
                      } else {
                        vErrors.push(err84);
                      }
                      errors++;
                    }
                    if (data27.quote === void 0) {
                      const err85 = { instancePath: instancePath + "/draft/" + i0 + "/citations/" + i5, schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/citations/items/required", keyword: "required", params: { missingProperty: "quote" }, message: "must have required property 'quote'" };
                      if (vErrors === null) {
                        vErrors = [err85];
                      } else {
                        vErrors.push(err85);
                      }
                      errors++;
                    }
                    for (const key4 in data27) {
                      if (!(key4 === "chunkId" || key4 === "title" || key4 === "url" || key4 === "page" || key4 === "quote")) {
                        const err86 = { instancePath: instancePath + "/draft/" + i0 + "/citations/" + i5, schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/citations/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key4 }, message: "must NOT have additional properties" };
                        if (vErrors === null) {
                          vErrors = [err86];
                        } else {
                          vErrors.push(err86);
                        }
                        errors++;
                      }
                    }
                    if (data27.chunkId !== void 0) {
                      if (typeof data27.chunkId !== "string") {
                        const err87 = { instancePath: instancePath + "/draft/" + i0 + "/citations/" + i5 + "/chunkId", schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/citations/items/properties/chunkId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err87];
                        } else {
                          vErrors.push(err87);
                        }
                        errors++;
                      }
                    }
                    if (data27.title !== void 0) {
                      if (typeof data27.title !== "string") {
                        const err88 = { instancePath: instancePath + "/draft/" + i0 + "/citations/" + i5 + "/title", schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/citations/items/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err88];
                        } else {
                          vErrors.push(err88);
                        }
                        errors++;
                      }
                    }
                    if (data27.url !== void 0) {
                      if (typeof data27.url !== "string") {
                        const err89 = { instancePath: instancePath + "/draft/" + i0 + "/citations/" + i5 + "/url", schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/citations/items/properties/url/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err89];
                        } else {
                          vErrors.push(err89);
                        }
                        errors++;
                      }
                    }
                    if (data27.page !== void 0) {
                      let data31 = data27.page;
                      if (!(typeof data31 == "number" && (!(data31 % 1) && !isNaN(data31)) && isFinite(data31))) {
                        const err90 = { instancePath: instancePath + "/draft/" + i0 + "/citations/" + i5 + "/page", schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/citations/items/properties/page/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                        if (vErrors === null) {
                          vErrors = [err90];
                        } else {
                          vErrors.push(err90);
                        }
                        errors++;
                      }
                      if (typeof data31 == "number" && isFinite(data31)) {
                        if (data31 > 9007199254740991 || isNaN(data31)) {
                          const err91 = { instancePath: instancePath + "/draft/" + i0 + "/citations/" + i5 + "/page", schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/citations/items/properties/page/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                          if (vErrors === null) {
                            vErrors = [err91];
                          } else {
                            vErrors.push(err91);
                          }
                          errors++;
                        }
                        if (data31 < -9007199254740991 || isNaN(data31)) {
                          const err92 = { instancePath: instancePath + "/draft/" + i0 + "/citations/" + i5 + "/page", schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/citations/items/properties/page/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                          if (vErrors === null) {
                            vErrors = [err92];
                          } else {
                            vErrors.push(err92);
                          }
                          errors++;
                        }
                      }
                    }
                    if (data27.quote !== void 0) {
                      if (typeof data27.quote !== "string") {
                        const err93 = { instancePath: instancePath + "/draft/" + i0 + "/citations/" + i5 + "/quote", schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/citations/items/properties/quote/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err93];
                        } else {
                          vErrors.push(err93);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err94 = { instancePath: instancePath + "/draft/" + i0 + "/citations/" + i5, schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/citations/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                    if (vErrors === null) {
                      vErrors = [err94];
                    } else {
                      vErrors.push(err94);
                    }
                    errors++;
                  }
                }
              } else {
                const err95 = { instancePath: instancePath + "/draft/" + i0 + "/citations", schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/properties/citations/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                if (vErrors === null) {
                  vErrors = [err95];
                } else {
                  vErrors.push(err95);
                }
                errors++;
              }
            }
          } else {
            const err96 = { instancePath: instancePath + "/draft/" + i0, schemaPath: "#/definitions/VerificationEvaluation/properties/draft/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
              vErrors = [err96];
            } else {
              vErrors.push(err96);
            }
            errors++;
          }
        }
      } else {
        const err97 = { instancePath: instancePath + "/draft", schemaPath: "#/definitions/VerificationEvaluation/properties/draft/type", keyword: "type", params: { type: "array" }, message: "must be array" };
        if (vErrors === null) {
          vErrors = [err97];
        } else {
          vErrors.push(err97);
        }
        errors++;
      }
    }
    if (data.projection !== void 0) {
      let data33 = data.projection;
      if (Array.isArray(data33)) {
        const len6 = data33.length;
        for (let i6 = 0; i6 < len6; i6++) {
          let data34 = data33[i6];
          if (data34 && typeof data34 == "object" && !Array.isArray(data34)) {
            if (data34.rule === void 0) {
              const err98 = { instancePath: instancePath + "/projection/" + i6, schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/required", keyword: "required", params: { missingProperty: "rule" }, message: "must have required property 'rule'" };
              if (vErrors === null) {
                vErrors = [err98];
              } else {
                vErrors.push(err98);
              }
              errors++;
            }
            if (data34.befund === void 0) {
              const err99 = { instancePath: instancePath + "/projection/" + i6, schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/required", keyword: "required", params: { missingProperty: "befund" }, message: "must have required property 'befund'" };
              if (vErrors === null) {
                vErrors = [err99];
              } else {
                vErrors.push(err99);
              }
              errors++;
            }
            if (data34.title === void 0) {
              const err100 = { instancePath: instancePath + "/projection/" + i6, schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
              if (vErrors === null) {
                vErrors = [err100];
              } else {
                vErrors.push(err100);
              }
              errors++;
            }
            if (data34.festzuschuss === void 0) {
              const err101 = { instancePath: instancePath + "/projection/" + i6, schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/required", keyword: "required", params: { missingProperty: "festzuschuss" }, message: "must have required property 'festzuschuss'" };
              if (vErrors === null) {
                vErrors = [err101];
              } else {
                vErrors.push(err101);
              }
              errors++;
            }
            if (data34.used === void 0) {
              const err102 = { instancePath: instancePath + "/projection/" + i6, schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/required", keyword: "required", params: { missingProperty: "used" }, message: "must have required property 'used'" };
              if (vErrors === null) {
                vErrors = [err102];
              } else {
                vErrors.push(err102);
              }
              errors++;
            }
            if (data34.citations === void 0) {
              const err103 = { instancePath: instancePath + "/projection/" + i6, schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/required", keyword: "required", params: { missingProperty: "citations" }, message: "must have required property 'citations'" };
              if (vErrors === null) {
                vErrors = [err103];
              } else {
                vErrors.push(err103);
              }
              errors++;
            }
            for (const key5 in data34) {
              if (!func6.call(schema37.properties.projection.items.properties, key5)) {
                const err104 = { instancePath: instancePath + "/projection/" + i6, schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key5 }, message: "must NOT have additional properties" };
                if (vErrors === null) {
                  vErrors = [err104];
                } else {
                  vErrors.push(err104);
                }
                errors++;
              }
            }
            if (data34.rule !== void 0) {
              if (typeof data34.rule !== "string") {
                const err105 = { instancePath: instancePath + "/projection/" + i6 + "/rule", schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/rule/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err105];
                } else {
                  vErrors.push(err105);
                }
                errors++;
              }
            }
            if (data34.befund !== void 0) {
              if (typeof data34.befund !== "string") {
                const err106 = { instancePath: instancePath + "/projection/" + i6 + "/befund", schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/befund/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err106];
                } else {
                  vErrors.push(err106);
                }
                errors++;
              }
            }
            if (data34.title !== void 0) {
              if (typeof data34.title !== "string") {
                const err107 = { instancePath: instancePath + "/projection/" + i6 + "/title", schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err107];
                } else {
                  vErrors.push(err107);
                }
                errors++;
              }
            }
            if (data34.fdi !== void 0) {
              let data38 = data34.fdi;
              if (!(typeof data38 == "number" && (!(data38 % 1) && !isNaN(data38)) && isFinite(data38))) {
                const err108 = { instancePath: instancePath + "/projection/" + i6 + "/fdi", schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/fdi/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                if (vErrors === null) {
                  vErrors = [err108];
                } else {
                  vErrors.push(err108);
                }
                errors++;
              }
              if (typeof data38 == "number" && isFinite(data38)) {
                if (data38 > 9007199254740991 || isNaN(data38)) {
                  const err109 = { instancePath: instancePath + "/projection/" + i6 + "/fdi", schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/fdi/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err109];
                  } else {
                    vErrors.push(err109);
                  }
                  errors++;
                }
                if (data38 < -9007199254740991 || isNaN(data38)) {
                  const err110 = { instancePath: instancePath + "/projection/" + i6 + "/fdi", schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/fdi/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err110];
                  } else {
                    vErrors.push(err110);
                  }
                  errors++;
                }
              }
            }
            if (data34.luecke !== void 0) {
              let data39 = data34.luecke;
              if (data39 && typeof data39 == "object" && !Array.isArray(data39)) {
                if (data39.id === void 0) {
                  const err111 = { instancePath: instancePath + "/projection/" + i6 + "/luecke", schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/luecke/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property 'id'" };
                  if (vErrors === null) {
                    vErrors = [err111];
                  } else {
                    vErrors.push(err111);
                  }
                  errors++;
                }
                if (data39.jaw === void 0) {
                  const err112 = { instancePath: instancePath + "/projection/" + i6 + "/luecke", schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/luecke/required", keyword: "required", params: { missingProperty: "jaw" }, message: "must have required property 'jaw'" };
                  if (vErrors === null) {
                    vErrors = [err112];
                  } else {
                    vErrors.push(err112);
                  }
                  errors++;
                }
                if (data39.anker === void 0) {
                  const err113 = { instancePath: instancePath + "/projection/" + i6 + "/luecke", schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/luecke/required", keyword: "required", params: { missingProperty: "anker" }, message: "must have required property 'anker'" };
                  if (vErrors === null) {
                    vErrors = [err113];
                  } else {
                    vErrors.push(err113);
                  }
                  errors++;
                }
                if (data39.fehlend === void 0) {
                  const err114 = { instancePath: instancePath + "/projection/" + i6 + "/luecke", schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/luecke/required", keyword: "required", params: { missingProperty: "fehlend" }, message: "must have required property 'fehlend'" };
                  if (vErrors === null) {
                    vErrors = [err114];
                  } else {
                    vErrors.push(err114);
                  }
                  errors++;
                }
                for (const key6 in data39) {
                  if (!(key6 === "id" || key6 === "jaw" || key6 === "anker" || key6 === "fehlend")) {
                    const err115 = { instancePath: instancePath + "/projection/" + i6 + "/luecke", schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/luecke/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key6 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                      vErrors = [err115];
                    } else {
                      vErrors.push(err115);
                    }
                    errors++;
                  }
                }
                if (data39.id !== void 0) {
                  if (typeof data39.id !== "string") {
                    const err116 = { instancePath: instancePath + "/projection/" + i6 + "/luecke/id", schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/luecke/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err116];
                    } else {
                      vErrors.push(err116);
                    }
                    errors++;
                  }
                }
                if (data39.jaw !== void 0) {
                  let data41 = data39.jaw;
                  if (typeof data41 !== "string") {
                    const err117 = { instancePath: instancePath + "/projection/" + i6 + "/luecke/jaw", schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/luecke/properties/jaw/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err117];
                    } else {
                      vErrors.push(err117);
                    }
                    errors++;
                  }
                  if (!(data41 === "OK" || data41 === "UK")) {
                    const err118 = { instancePath: instancePath + "/projection/" + i6 + "/luecke/jaw", schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/luecke/properties/jaw/enum", keyword: "enum", params: { allowedValues: schema37.properties.projection.items.properties.luecke.properties.jaw.enum }, message: "must be equal to one of the allowed values" };
                    if (vErrors === null) {
                      vErrors = [err118];
                    } else {
                      vErrors.push(err118);
                    }
                    errors++;
                  }
                }
                if (data39.anker !== void 0) {
                  let data42 = data39.anker;
                  if (Array.isArray(data42)) {
                    const len7 = data42.length;
                    for (let i7 = 0; i7 < len7; i7++) {
                      let data43 = data42[i7];
                      if (!(typeof data43 == "number" && (!(data43 % 1) && !isNaN(data43)) && isFinite(data43))) {
                        const err119 = { instancePath: instancePath + "/projection/" + i6 + "/luecke/anker/" + i7, schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/luecke/properties/anker/items/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                        if (vErrors === null) {
                          vErrors = [err119];
                        } else {
                          vErrors.push(err119);
                        }
                        errors++;
                      }
                      if (typeof data43 == "number" && isFinite(data43)) {
                        if (data43 > 9007199254740991 || isNaN(data43)) {
                          const err120 = { instancePath: instancePath + "/projection/" + i6 + "/luecke/anker/" + i7, schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/luecke/properties/anker/items/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                          if (vErrors === null) {
                            vErrors = [err120];
                          } else {
                            vErrors.push(err120);
                          }
                          errors++;
                        }
                        if (data43 < -9007199254740991 || isNaN(data43)) {
                          const err121 = { instancePath: instancePath + "/projection/" + i6 + "/luecke/anker/" + i7, schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/luecke/properties/anker/items/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                          if (vErrors === null) {
                            vErrors = [err121];
                          } else {
                            vErrors.push(err121);
                          }
                          errors++;
                        }
                      }
                    }
                  } else {
                    const err122 = { instancePath: instancePath + "/projection/" + i6 + "/luecke/anker", schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/luecke/properties/anker/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                      vErrors = [err122];
                    } else {
                      vErrors.push(err122);
                    }
                    errors++;
                  }
                }
                if (data39.fehlend !== void 0) {
                  let data44 = data39.fehlend;
                  if (Array.isArray(data44)) {
                    const len8 = data44.length;
                    for (let i8 = 0; i8 < len8; i8++) {
                      let data45 = data44[i8];
                      if (!(typeof data45 == "number" && (!(data45 % 1) && !isNaN(data45)) && isFinite(data45))) {
                        const err123 = { instancePath: instancePath + "/projection/" + i6 + "/luecke/fehlend/" + i8, schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/luecke/properties/fehlend/items/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                        if (vErrors === null) {
                          vErrors = [err123];
                        } else {
                          vErrors.push(err123);
                        }
                        errors++;
                      }
                      if (typeof data45 == "number" && isFinite(data45)) {
                        if (data45 > 9007199254740991 || isNaN(data45)) {
                          const err124 = { instancePath: instancePath + "/projection/" + i6 + "/luecke/fehlend/" + i8, schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/luecke/properties/fehlend/items/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                          if (vErrors === null) {
                            vErrors = [err124];
                          } else {
                            vErrors.push(err124);
                          }
                          errors++;
                        }
                        if (data45 < -9007199254740991 || isNaN(data45)) {
                          const err125 = { instancePath: instancePath + "/projection/" + i6 + "/luecke/fehlend/" + i8, schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/luecke/properties/fehlend/items/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                          if (vErrors === null) {
                            vErrors = [err125];
                          } else {
                            vErrors.push(err125);
                          }
                          errors++;
                        }
                      }
                    }
                  } else {
                    const err126 = { instancePath: instancePath + "/projection/" + i6 + "/luecke/fehlend", schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/luecke/properties/fehlend/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                      vErrors = [err126];
                    } else {
                      vErrors.push(err126);
                    }
                    errors++;
                  }
                }
              } else {
                const err127 = { instancePath: instancePath + "/projection/" + i6 + "/luecke", schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/luecke/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                if (vErrors === null) {
                  vErrors = [err127];
                } else {
                  vErrors.push(err127);
                }
                errors++;
              }
            }
            if (data34.zaehne !== void 0) {
              let data46 = data34.zaehne;
              if (Array.isArray(data46)) {
                const len9 = data46.length;
                for (let i9 = 0; i9 < len9; i9++) {
                  let data47 = data46[i9];
                  if (!(typeof data47 == "number" && (!(data47 % 1) && !isNaN(data47)) && isFinite(data47))) {
                    const err128 = { instancePath: instancePath + "/projection/" + i6 + "/zaehne/" + i9, schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/zaehne/items/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err128];
                    } else {
                      vErrors.push(err128);
                    }
                    errors++;
                  }
                  if (typeof data47 == "number" && isFinite(data47)) {
                    if (data47 > 9007199254740991 || isNaN(data47)) {
                      const err129 = { instancePath: instancePath + "/projection/" + i6 + "/zaehne/" + i9, schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/zaehne/items/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err129];
                      } else {
                        vErrors.push(err129);
                      }
                      errors++;
                    }
                    if (data47 < -9007199254740991 || isNaN(data47)) {
                      const err130 = { instancePath: instancePath + "/projection/" + i6 + "/zaehne/" + i9, schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/zaehne/items/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err130];
                      } else {
                        vErrors.push(err130);
                      }
                      errors++;
                    }
                  }
                }
              } else {
                const err131 = { instancePath: instancePath + "/projection/" + i6 + "/zaehne", schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/zaehne/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                if (vErrors === null) {
                  vErrors = [err131];
                } else {
                  vErrors.push(err131);
                }
                errors++;
              }
            }
            if (data34.festzuschuss !== void 0) {
              let data48 = data34.festzuschuss;
              if (data48 && typeof data48 == "object" && !Array.isArray(data48)) {
                if (data48.zahnaerztlich === void 0) {
                  const err132 = { instancePath: instancePath + "/projection/" + i6 + "/festzuschuss", schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/festzuschuss/required", keyword: "required", params: { missingProperty: "zahnaerztlich" }, message: "must have required property 'zahnaerztlich'" };
                  if (vErrors === null) {
                    vErrors = [err132];
                  } else {
                    vErrors.push(err132);
                  }
                  errors++;
                }
                if (data48.zahntechnisch === void 0) {
                  const err133 = { instancePath: instancePath + "/projection/" + i6 + "/festzuschuss", schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/festzuschuss/required", keyword: "required", params: { missingProperty: "zahntechnisch" }, message: "must have required property 'zahntechnisch'" };
                  if (vErrors === null) {
                    vErrors = [err133];
                  } else {
                    vErrors.push(err133);
                  }
                  errors++;
                }
                if (data48.prozent60 === void 0) {
                  const err134 = { instancePath: instancePath + "/projection/" + i6 + "/festzuschuss", schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/festzuschuss/required", keyword: "required", params: { missingProperty: "prozent60" }, message: "must have required property 'prozent60'" };
                  if (vErrors === null) {
                    vErrors = [err134];
                  } else {
                    vErrors.push(err134);
                  }
                  errors++;
                }
                if (data48.prozent70 === void 0) {
                  const err135 = { instancePath: instancePath + "/projection/" + i6 + "/festzuschuss", schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/festzuschuss/required", keyword: "required", params: { missingProperty: "prozent70" }, message: "must have required property 'prozent70'" };
                  if (vErrors === null) {
                    vErrors = [err135];
                  } else {
                    vErrors.push(err135);
                  }
                  errors++;
                }
                if (data48.prozent75 === void 0) {
                  const err136 = { instancePath: instancePath + "/projection/" + i6 + "/festzuschuss", schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/festzuschuss/required", keyword: "required", params: { missingProperty: "prozent75" }, message: "must have required property 'prozent75'" };
                  if (vErrors === null) {
                    vErrors = [err136];
                  } else {
                    vErrors.push(err136);
                  }
                  errors++;
                }
                if (data48.prozent100 === void 0) {
                  const err137 = { instancePath: instancePath + "/projection/" + i6 + "/festzuschuss", schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/festzuschuss/required", keyword: "required", params: { missingProperty: "prozent100" }, message: "must have required property 'prozent100'" };
                  if (vErrors === null) {
                    vErrors = [err137];
                  } else {
                    vErrors.push(err137);
                  }
                  errors++;
                }
                for (const key7 in data48) {
                  if (!(key7 === "zahnaerztlich" || key7 === "zahntechnisch" || key7 === "prozent60" || key7 === "prozent70" || key7 === "prozent75" || key7 === "prozent100")) {
                    const err138 = { instancePath: instancePath + "/projection/" + i6 + "/festzuschuss", schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/festzuschuss/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key7 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                      vErrors = [err138];
                    } else {
                      vErrors.push(err138);
                    }
                    errors++;
                  }
                }
                if (data48.zahnaerztlich !== void 0) {
                  let data49 = data48.zahnaerztlich;
                  if (!(typeof data49 == "number" && (!(data49 % 1) && !isNaN(data49)) && isFinite(data49))) {
                    const err139 = { instancePath: instancePath + "/projection/" + i6 + "/festzuschuss/zahnaerztlich", schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/festzuschuss/properties/zahnaerztlich/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err139];
                    } else {
                      vErrors.push(err139);
                    }
                    errors++;
                  }
                  if (typeof data49 == "number" && isFinite(data49)) {
                    if (data49 > 9007199254740991 || isNaN(data49)) {
                      const err140 = { instancePath: instancePath + "/projection/" + i6 + "/festzuschuss/zahnaerztlich", schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/festzuschuss/properties/zahnaerztlich/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err140];
                      } else {
                        vErrors.push(err140);
                      }
                      errors++;
                    }
                    if (data49 < -9007199254740991 || isNaN(data49)) {
                      const err141 = { instancePath: instancePath + "/projection/" + i6 + "/festzuschuss/zahnaerztlich", schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/festzuschuss/properties/zahnaerztlich/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err141];
                      } else {
                        vErrors.push(err141);
                      }
                      errors++;
                    }
                  }
                }
                if (data48.zahntechnisch !== void 0) {
                  let data50 = data48.zahntechnisch;
                  if (!(typeof data50 == "number" && (!(data50 % 1) && !isNaN(data50)) && isFinite(data50))) {
                    const err142 = { instancePath: instancePath + "/projection/" + i6 + "/festzuschuss/zahntechnisch", schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/festzuschuss/properties/zahntechnisch/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err142];
                    } else {
                      vErrors.push(err142);
                    }
                    errors++;
                  }
                  if (typeof data50 == "number" && isFinite(data50)) {
                    if (data50 > 9007199254740991 || isNaN(data50)) {
                      const err143 = { instancePath: instancePath + "/projection/" + i6 + "/festzuschuss/zahntechnisch", schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/festzuschuss/properties/zahntechnisch/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err143];
                      } else {
                        vErrors.push(err143);
                      }
                      errors++;
                    }
                    if (data50 < -9007199254740991 || isNaN(data50)) {
                      const err144 = { instancePath: instancePath + "/projection/" + i6 + "/festzuschuss/zahntechnisch", schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/festzuschuss/properties/zahntechnisch/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err144];
                      } else {
                        vErrors.push(err144);
                      }
                      errors++;
                    }
                  }
                }
                if (data48.prozent60 !== void 0) {
                  let data51 = data48.prozent60;
                  if (!(typeof data51 == "number" && (!(data51 % 1) && !isNaN(data51)) && isFinite(data51))) {
                    const err145 = { instancePath: instancePath + "/projection/" + i6 + "/festzuschuss/prozent60", schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/festzuschuss/properties/prozent60/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err145];
                    } else {
                      vErrors.push(err145);
                    }
                    errors++;
                  }
                  if (typeof data51 == "number" && isFinite(data51)) {
                    if (data51 > 9007199254740991 || isNaN(data51)) {
                      const err146 = { instancePath: instancePath + "/projection/" + i6 + "/festzuschuss/prozent60", schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/festzuschuss/properties/prozent60/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err146];
                      } else {
                        vErrors.push(err146);
                      }
                      errors++;
                    }
                    if (data51 < -9007199254740991 || isNaN(data51)) {
                      const err147 = { instancePath: instancePath + "/projection/" + i6 + "/festzuschuss/prozent60", schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/festzuschuss/properties/prozent60/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err147];
                      } else {
                        vErrors.push(err147);
                      }
                      errors++;
                    }
                  }
                }
                if (data48.prozent70 !== void 0) {
                  let data52 = data48.prozent70;
                  if (!(typeof data52 == "number" && (!(data52 % 1) && !isNaN(data52)) && isFinite(data52))) {
                    const err148 = { instancePath: instancePath + "/projection/" + i6 + "/festzuschuss/prozent70", schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/festzuschuss/properties/prozent70/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err148];
                    } else {
                      vErrors.push(err148);
                    }
                    errors++;
                  }
                  if (typeof data52 == "number" && isFinite(data52)) {
                    if (data52 > 9007199254740991 || isNaN(data52)) {
                      const err149 = { instancePath: instancePath + "/projection/" + i6 + "/festzuschuss/prozent70", schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/festzuschuss/properties/prozent70/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err149];
                      } else {
                        vErrors.push(err149);
                      }
                      errors++;
                    }
                    if (data52 < -9007199254740991 || isNaN(data52)) {
                      const err150 = { instancePath: instancePath + "/projection/" + i6 + "/festzuschuss/prozent70", schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/festzuschuss/properties/prozent70/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err150];
                      } else {
                        vErrors.push(err150);
                      }
                      errors++;
                    }
                  }
                }
                if (data48.prozent75 !== void 0) {
                  let data53 = data48.prozent75;
                  if (!(typeof data53 == "number" && (!(data53 % 1) && !isNaN(data53)) && isFinite(data53))) {
                    const err151 = { instancePath: instancePath + "/projection/" + i6 + "/festzuschuss/prozent75", schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/festzuschuss/properties/prozent75/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err151];
                    } else {
                      vErrors.push(err151);
                    }
                    errors++;
                  }
                  if (typeof data53 == "number" && isFinite(data53)) {
                    if (data53 > 9007199254740991 || isNaN(data53)) {
                      const err152 = { instancePath: instancePath + "/projection/" + i6 + "/festzuschuss/prozent75", schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/festzuschuss/properties/prozent75/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err152];
                      } else {
                        vErrors.push(err152);
                      }
                      errors++;
                    }
                    if (data53 < -9007199254740991 || isNaN(data53)) {
                      const err153 = { instancePath: instancePath + "/projection/" + i6 + "/festzuschuss/prozent75", schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/festzuschuss/properties/prozent75/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err153];
                      } else {
                        vErrors.push(err153);
                      }
                      errors++;
                    }
                  }
                }
                if (data48.prozent100 !== void 0) {
                  let data54 = data48.prozent100;
                  if (!(typeof data54 == "number" && (!(data54 % 1) && !isNaN(data54)) && isFinite(data54))) {
                    const err154 = { instancePath: instancePath + "/projection/" + i6 + "/festzuschuss/prozent100", schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/festzuschuss/properties/prozent100/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err154];
                    } else {
                      vErrors.push(err154);
                    }
                    errors++;
                  }
                  if (typeof data54 == "number" && isFinite(data54)) {
                    if (data54 > 9007199254740991 || isNaN(data54)) {
                      const err155 = { instancePath: instancePath + "/projection/" + i6 + "/festzuschuss/prozent100", schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/festzuschuss/properties/prozent100/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err155];
                      } else {
                        vErrors.push(err155);
                      }
                      errors++;
                    }
                    if (data54 < -9007199254740991 || isNaN(data54)) {
                      const err156 = { instancePath: instancePath + "/projection/" + i6 + "/festzuschuss/prozent100", schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/festzuschuss/properties/prozent100/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err156];
                      } else {
                        vErrors.push(err156);
                      }
                      errors++;
                    }
                  }
                }
              } else {
                const err157 = { instancePath: instancePath + "/projection/" + i6 + "/festzuschuss", schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/festzuschuss/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                if (vErrors === null) {
                  vErrors = [err157];
                } else {
                  vErrors.push(err157);
                }
                errors++;
              }
            }
            if (data34.used !== void 0) {
              let data55 = data34.used;
              if (Array.isArray(data55)) {
                const len10 = data55.length;
                for (let i10 = 0; i10 < len10; i10++) {
                  if (typeof data55[i10] !== "string") {
                    const err158 = { instancePath: instancePath + "/projection/" + i6 + "/used/" + i10, schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/used/items/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err158];
                    } else {
                      vErrors.push(err158);
                    }
                    errors++;
                  }
                }
              } else {
                const err159 = { instancePath: instancePath + "/projection/" + i6 + "/used", schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/used/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                if (vErrors === null) {
                  vErrors = [err159];
                } else {
                  vErrors.push(err159);
                }
                errors++;
              }
            }
            if (data34.citations !== void 0) {
              let data57 = data34.citations;
              if (Array.isArray(data57)) {
                const len11 = data57.length;
                for (let i11 = 0; i11 < len11; i11++) {
                  let data58 = data57[i11];
                  if (data58 && typeof data58 == "object" && !Array.isArray(data58)) {
                    if (data58.chunkId === void 0) {
                      const err160 = { instancePath: instancePath + "/projection/" + i6 + "/citations/" + i11, schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/citations/items/required", keyword: "required", params: { missingProperty: "chunkId" }, message: "must have required property 'chunkId'" };
                      if (vErrors === null) {
                        vErrors = [err160];
                      } else {
                        vErrors.push(err160);
                      }
                      errors++;
                    }
                    if (data58.title === void 0) {
                      const err161 = { instancePath: instancePath + "/projection/" + i6 + "/citations/" + i11, schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/citations/items/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
                      if (vErrors === null) {
                        vErrors = [err161];
                      } else {
                        vErrors.push(err161);
                      }
                      errors++;
                    }
                    if (data58.url === void 0) {
                      const err162 = { instancePath: instancePath + "/projection/" + i6 + "/citations/" + i11, schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/citations/items/required", keyword: "required", params: { missingProperty: "url" }, message: "must have required property 'url'" };
                      if (vErrors === null) {
                        vErrors = [err162];
                      } else {
                        vErrors.push(err162);
                      }
                      errors++;
                    }
                    if (data58.quote === void 0) {
                      const err163 = { instancePath: instancePath + "/projection/" + i6 + "/citations/" + i11, schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/citations/items/required", keyword: "required", params: { missingProperty: "quote" }, message: "must have required property 'quote'" };
                      if (vErrors === null) {
                        vErrors = [err163];
                      } else {
                        vErrors.push(err163);
                      }
                      errors++;
                    }
                    for (const key8 in data58) {
                      if (!(key8 === "chunkId" || key8 === "title" || key8 === "url" || key8 === "page" || key8 === "quote")) {
                        const err164 = { instancePath: instancePath + "/projection/" + i6 + "/citations/" + i11, schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/citations/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key8 }, message: "must NOT have additional properties" };
                        if (vErrors === null) {
                          vErrors = [err164];
                        } else {
                          vErrors.push(err164);
                        }
                        errors++;
                      }
                    }
                    if (data58.chunkId !== void 0) {
                      if (typeof data58.chunkId !== "string") {
                        const err165 = { instancePath: instancePath + "/projection/" + i6 + "/citations/" + i11 + "/chunkId", schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/citations/items/properties/chunkId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err165];
                        } else {
                          vErrors.push(err165);
                        }
                        errors++;
                      }
                    }
                    if (data58.title !== void 0) {
                      if (typeof data58.title !== "string") {
                        const err166 = { instancePath: instancePath + "/projection/" + i6 + "/citations/" + i11 + "/title", schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/citations/items/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err166];
                        } else {
                          vErrors.push(err166);
                        }
                        errors++;
                      }
                    }
                    if (data58.url !== void 0) {
                      if (typeof data58.url !== "string") {
                        const err167 = { instancePath: instancePath + "/projection/" + i6 + "/citations/" + i11 + "/url", schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/citations/items/properties/url/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err167];
                        } else {
                          vErrors.push(err167);
                        }
                        errors++;
                      }
                    }
                    if (data58.page !== void 0) {
                      let data62 = data58.page;
                      if (!(typeof data62 == "number" && (!(data62 % 1) && !isNaN(data62)) && isFinite(data62))) {
                        const err168 = { instancePath: instancePath + "/projection/" + i6 + "/citations/" + i11 + "/page", schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/citations/items/properties/page/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                        if (vErrors === null) {
                          vErrors = [err168];
                        } else {
                          vErrors.push(err168);
                        }
                        errors++;
                      }
                      if (typeof data62 == "number" && isFinite(data62)) {
                        if (data62 > 9007199254740991 || isNaN(data62)) {
                          const err169 = { instancePath: instancePath + "/projection/" + i6 + "/citations/" + i11 + "/page", schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/citations/items/properties/page/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                          if (vErrors === null) {
                            vErrors = [err169];
                          } else {
                            vErrors.push(err169);
                          }
                          errors++;
                        }
                        if (data62 < -9007199254740991 || isNaN(data62)) {
                          const err170 = { instancePath: instancePath + "/projection/" + i6 + "/citations/" + i11 + "/page", schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/citations/items/properties/page/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                          if (vErrors === null) {
                            vErrors = [err170];
                          } else {
                            vErrors.push(err170);
                          }
                          errors++;
                        }
                      }
                    }
                    if (data58.quote !== void 0) {
                      if (typeof data58.quote !== "string") {
                        const err171 = { instancePath: instancePath + "/projection/" + i6 + "/citations/" + i11 + "/quote", schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/citations/items/properties/quote/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err171];
                        } else {
                          vErrors.push(err171);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err172 = { instancePath: instancePath + "/projection/" + i6 + "/citations/" + i11, schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/citations/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                    if (vErrors === null) {
                      vErrors = [err172];
                    } else {
                      vErrors.push(err172);
                    }
                    errors++;
                  }
                }
              } else {
                const err173 = { instancePath: instancePath + "/projection/" + i6 + "/citations", schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/properties/citations/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                if (vErrors === null) {
                  vErrors = [err173];
                } else {
                  vErrors.push(err173);
                }
                errors++;
              }
            }
          } else {
            const err174 = { instancePath: instancePath + "/projection/" + i6, schemaPath: "#/definitions/VerificationEvaluation/properties/projection/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
              vErrors = [err174];
            } else {
              vErrors.push(err174);
            }
            errors++;
          }
        }
      } else {
        const err175 = { instancePath: instancePath + "/projection", schemaPath: "#/definitions/VerificationEvaluation/properties/projection/type", keyword: "type", params: { type: "array" }, message: "must be array" };
        if (vErrors === null) {
          vErrors = [err175];
        } else {
          vErrors.push(err175);
        }
        errors++;
      }
    }
    if (data.costs !== void 0) {
      let data64 = data.costs;
      if (data64 && typeof data64 == "object" && !Array.isArray(data64)) {
        if (data64.teeth === void 0) {
          const err176 = { instancePath: instancePath + "/costs", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/required", keyword: "required", params: { missingProperty: "teeth" }, message: "must have required property 'teeth'" };
          if (vErrors === null) {
            vErrors = [err176];
          } else {
            vErrors.push(err176);
          }
          errors++;
        }
        if (data64.luecken === void 0) {
          const err177 = { instancePath: instancePath + "/costs", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/required", keyword: "required", params: { missingProperty: "luecken" }, message: "must have required property 'luecken'" };
          if (vErrors === null) {
            vErrors = [err177];
          } else {
            vErrors.push(err177);
          }
          errors++;
        }
        if (data64.places === void 0) {
          const err178 = { instancePath: instancePath + "/costs", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/required", keyword: "required", params: { missingProperty: "places" }, message: "must have required property 'places'" };
          if (vErrors === null) {
            vErrors = [err178];
          } else {
            vErrors.push(err178);
          }
          errors++;
        }
        if (data64.waiting === void 0) {
          const err179 = { instancePath: instancePath + "/costs", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/required", keyword: "required", params: { missingProperty: "waiting" }, message: "must have required property 'waiting'" };
          if (vErrors === null) {
            vErrors = [err179];
          } else {
            vErrors.push(err179);
          }
          errors++;
        }
        if (data64.placeholders === void 0) {
          const err180 = { instancePath: instancePath + "/costs", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/required", keyword: "required", params: { missingProperty: "placeholders" }, message: "must have required property 'placeholders'" };
          if (vErrors === null) {
            vErrors = [err180];
          } else {
            vErrors.push(err180);
          }
          errors++;
        }
        for (const key9 in data64) {
          if (!(key9 === "teeth" || key9 === "luecken" || key9 === "places" || key9 === "punktwert" || key9 === "totals" || key9 === "waiting" || key9 === "placeholders")) {
            const err181 = { instancePath: instancePath + "/costs", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key9 }, message: "must NOT have additional properties" };
            if (vErrors === null) {
              vErrors = [err181];
            } else {
              vErrors.push(err181);
            }
            errors++;
          }
        }
        if (data64.teeth !== void 0) {
          let data65 = data64.teeth;
          if (Array.isArray(data65)) {
            const len12 = data65.length;
            for (let i12 = 0; i12 < len12; i12++) {
              let data66 = data65[i12];
              if (data66 && typeof data66 == "object" && !Array.isArray(data66)) {
                if (data66.fdi === void 0) {
                  const err182 = { instancePath: instancePath + "/costs/teeth/" + i12, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/required", keyword: "required", params: { missingProperty: "fdi" }, message: "must have required property 'fdi'" };
                  if (vErrors === null) {
                    vErrors = [err182];
                  } else {
                    vErrors.push(err182);
                  }
                  errors++;
                }
                if (data66.bema === void 0) {
                  const err183 = { instancePath: instancePath + "/costs/teeth/" + i12, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/required", keyword: "required", params: { missingProperty: "bema" }, message: "must have required property 'bema'" };
                  if (vErrors === null) {
                    vErrors = [err183];
                  } else {
                    vErrors.push(err183);
                  }
                  errors++;
                }
                if (data66.hkp === void 0) {
                  const err184 = { instancePath: instancePath + "/costs/teeth/" + i12, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/required", keyword: "required", params: { missingProperty: "hkp" }, message: "must have required property 'hkp'" };
                  if (vErrors === null) {
                    vErrors = [err184];
                  } else {
                    vErrors.push(err184);
                  }
                  errors++;
                }
                if (data66.bel === void 0) {
                  const err185 = { instancePath: instancePath + "/costs/teeth/" + i12, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/required", keyword: "required", params: { missingProperty: "bel" }, message: "must have required property 'bel'" };
                  if (vErrors === null) {
                    vErrors = [err185];
                  } else {
                    vErrors.push(err185);
                  }
                  errors++;
                }
                if (data66.materials === void 0) {
                  const err186 = { instancePath: instancePath + "/costs/teeth/" + i12, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/required", keyword: "required", params: { missingProperty: "materials" }, message: "must have required property 'materials'" };
                  if (vErrors === null) {
                    vErrors = [err186];
                  } else {
                    vErrors.push(err186);
                  }
                  errors++;
                }
                if (data66.labor === void 0) {
                  const err187 = { instancePath: instancePath + "/costs/teeth/" + i12, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/required", keyword: "required", params: { missingProperty: "labor" }, message: "must have required property 'labor'" };
                  if (vErrors === null) {
                    vErrors = [err187];
                  } else {
                    vErrors.push(err187);
                  }
                  errors++;
                }
                if (data66.goz === void 0) {
                  const err188 = { instancePath: instancePath + "/costs/teeth/" + i12, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/required", keyword: "required", params: { missingProperty: "goz" }, message: "must have required property 'goz'" };
                  if (vErrors === null) {
                    vErrors = [err188];
                  } else {
                    vErrors.push(err188);
                  }
                  errors++;
                }
                for (const key10 in data66) {
                  if (!(key10 === "fdi" || key10 === "bema" || key10 === "hkp" || key10 === "bel" || key10 === "materials" || key10 === "labor" || key10 === "versorgung" || key10 === "goz")) {
                    const err189 = { instancePath: instancePath + "/costs/teeth/" + i12, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key10 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                      vErrors = [err189];
                    } else {
                      vErrors.push(err189);
                    }
                    errors++;
                  }
                }
                if (data66.fdi !== void 0) {
                  let data67 = data66.fdi;
                  if (!(typeof data67 == "number" && (!(data67 % 1) && !isNaN(data67)) && isFinite(data67))) {
                    const err190 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/fdi", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/fdi/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err190];
                    } else {
                      vErrors.push(err190);
                    }
                    errors++;
                  }
                  if (typeof data67 == "number" && isFinite(data67)) {
                    if (data67 > 9007199254740991 || isNaN(data67)) {
                      const err191 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/fdi", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/fdi/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err191];
                      } else {
                        vErrors.push(err191);
                      }
                      errors++;
                    }
                    if (data67 < -9007199254740991 || isNaN(data67)) {
                      const err192 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/fdi", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/fdi/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err192];
                      } else {
                        vErrors.push(err192);
                      }
                      errors++;
                    }
                  }
                }
                if (data66.bema !== void 0) {
                  let data68 = data66.bema;
                  if (Array.isArray(data68)) {
                    const len13 = data68.length;
                    for (let i13 = 0; i13 < len13; i13++) {
                      let data69 = data68[i13];
                      if (data69 && typeof data69 == "object" && !Array.isArray(data69)) {
                        if (data69.befund === void 0) {
                          const err193 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bema/" + i13, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bema/items/required", keyword: "required", params: { missingProperty: "befund" }, message: "must have required property 'befund'" };
                          if (vErrors === null) {
                            vErrors = [err193];
                          } else {
                            vErrors.push(err193);
                          }
                          errors++;
                        }
                        if (data69.nr === void 0) {
                          const err194 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bema/" + i13, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bema/items/required", keyword: "required", params: { missingProperty: "nr" }, message: "must have required property 'nr'" };
                          if (vErrors === null) {
                            vErrors = [err194];
                          } else {
                            vErrors.push(err194);
                          }
                          errors++;
                        }
                        if (data69.text === void 0) {
                          const err195 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bema/" + i13, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bema/items/required", keyword: "required", params: { missingProperty: "text" }, message: "must have required property 'text'" };
                          if (vErrors === null) {
                            vErrors = [err195];
                          } else {
                            vErrors.push(err195);
                          }
                          errors++;
                        }
                        if (data69.points === void 0) {
                          const err196 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bema/" + i13, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bema/items/required", keyword: "required", params: { missingProperty: "points" }, message: "must have required property 'points'" };
                          if (vErrors === null) {
                            vErrors = [err196];
                          } else {
                            vErrors.push(err196);
                          }
                          errors++;
                        }
                        if (data69.part === void 0) {
                          const err197 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bema/" + i13, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bema/items/required", keyword: "required", params: { missingProperty: "part" }, message: "must have required property 'part'" };
                          if (vErrors === null) {
                            vErrors = [err197];
                          } else {
                            vErrors.push(err197);
                          }
                          errors++;
                        }
                        if (data69.minus === void 0) {
                          const err198 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bema/" + i13, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bema/items/required", keyword: "required", params: { missingProperty: "minus" }, message: "must have required property 'minus'" };
                          if (vErrors === null) {
                            vErrors = [err198];
                          } else {
                            vErrors.push(err198);
                          }
                          errors++;
                        }
                        if (data69.quantity === void 0) {
                          const err199 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bema/" + i13, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bema/items/required", keyword: "required", params: { missingProperty: "quantity" }, message: "must have required property 'quantity'" };
                          if (vErrors === null) {
                            vErrors = [err199];
                          } else {
                            vErrors.push(err199);
                          }
                          errors++;
                        }
                        for (const key11 in data69) {
                          if (!func6.call(schema37.properties.costs.properties.teeth.items.properties.bema.items.properties, key11)) {
                            const err200 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bema/" + i13, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bema/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key11 }, message: "must NOT have additional properties" };
                            if (vErrors === null) {
                              vErrors = [err200];
                            } else {
                              vErrors.push(err200);
                            }
                            errors++;
                          }
                        }
                        if (data69.befund !== void 0) {
                          if (typeof data69.befund !== "string") {
                            const err201 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bema/" + i13 + "/befund", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bema/items/properties/befund/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err201];
                            } else {
                              vErrors.push(err201);
                            }
                            errors++;
                          }
                        }
                        if (data69.nr !== void 0) {
                          if (typeof data69.nr !== "string") {
                            const err202 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bema/" + i13 + "/nr", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bema/items/properties/nr/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err202];
                            } else {
                              vErrors.push(err202);
                            }
                            errors++;
                          }
                        }
                        if (data69.text !== void 0) {
                          if (typeof data69.text !== "string") {
                            const err203 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bema/" + i13 + "/text", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bema/items/properties/text/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err203];
                            } else {
                              vErrors.push(err203);
                            }
                            errors++;
                          }
                        }
                        if (data69.points !== void 0) {
                          let data73 = data69.points;
                          if (!(typeof data73 == "number" && (!(data73 % 1) && !isNaN(data73)) && isFinite(data73))) {
                            const err204 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bema/" + i13 + "/points", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bema/items/properties/points/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                            if (vErrors === null) {
                              vErrors = [err204];
                            } else {
                              vErrors.push(err204);
                            }
                            errors++;
                          }
                          if (typeof data73 == "number" && isFinite(data73)) {
                            if (data73 > 9007199254740991 || isNaN(data73)) {
                              const err205 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bema/" + i13 + "/points", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bema/items/properties/points/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err205];
                              } else {
                                vErrors.push(err205);
                              }
                              errors++;
                            }
                            if (data73 < -9007199254740991 || isNaN(data73)) {
                              const err206 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bema/" + i13 + "/points", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bema/items/properties/points/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err206];
                              } else {
                                vErrors.push(err206);
                              }
                              errors++;
                            }
                          }
                        }
                        if (data69.part !== void 0) {
                          if (typeof data69.part !== "string") {
                            const err207 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bema/" + i13 + "/part", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bema/items/properties/part/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err207];
                            } else {
                              vErrors.push(err207);
                            }
                            errors++;
                          }
                        }
                        if (data69.minus !== void 0) {
                          if (typeof data69.minus !== "boolean") {
                            const err208 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bema/" + i13 + "/minus", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bema/items/properties/minus/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                            if (vErrors === null) {
                              vErrors = [err208];
                            } else {
                              vErrors.push(err208);
                            }
                            errors++;
                          }
                        }
                        if (data69.quantity !== void 0) {
                          let data76 = data69.quantity;
                          const _errs167 = errors;
                          let valid41 = false;
                          const _errs168 = errors;
                          if (!(typeof data76 == "number" && (!(data76 % 1) && !isNaN(data76)) && isFinite(data76))) {
                            const err209 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bema/" + i13 + "/quantity", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bema/items/properties/quantity/anyOf/0/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                            if (vErrors === null) {
                              vErrors = [err209];
                            } else {
                              vErrors.push(err209);
                            }
                            errors++;
                          }
                          if (typeof data76 == "number" && isFinite(data76)) {
                            if (data76 > 9007199254740991 || isNaN(data76)) {
                              const err210 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bema/" + i13 + "/quantity", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bema/items/properties/quantity/anyOf/0/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err210];
                              } else {
                                vErrors.push(err210);
                              }
                              errors++;
                            }
                            if (data76 < -9007199254740991 || isNaN(data76)) {
                              const err211 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bema/" + i13 + "/quantity", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bema/items/properties/quantity/anyOf/0/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err211];
                              } else {
                                vErrors.push(err211);
                              }
                              errors++;
                            }
                          }
                          var _valid0 = _errs168 === errors;
                          valid41 = valid41 || _valid0;
                          if (!valid41) {
                            const _errs170 = errors;
                            if (data76 !== null) {
                              const err212 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bema/" + i13 + "/quantity", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bema/items/properties/quantity/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                              if (vErrors === null) {
                                vErrors = [err212];
                              } else {
                                vErrors.push(err212);
                              }
                              errors++;
                            }
                            var _valid0 = _errs170 === errors;
                            valid41 = valid41 || _valid0;
                          }
                          if (!valid41) {
                            const err213 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bema/" + i13 + "/quantity", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bema/items/properties/quantity/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                            if (vErrors === null) {
                              vErrors = [err213];
                            } else {
                              vErrors.push(err213);
                            }
                            errors++;
                          } else {
                            errors = _errs167;
                            if (vErrors !== null) {
                              if (_errs167) {
                                vErrors.length = _errs167;
                              } else {
                                vErrors = null;
                              }
                            }
                          }
                        }
                        if (data69.counted !== void 0) {
                          let data77 = data69.counted;
                          if (typeof data77 !== "boolean") {
                            const err214 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bema/" + i13 + "/counted", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bema/items/properties/counted/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                            if (vErrors === null) {
                              vErrors = [err214];
                            } else {
                              vErrors.push(err214);
                            }
                            errors++;
                          }
                          if (true !== data77) {
                            const err215 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bema/" + i13 + "/counted", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bema/items/properties/counted/const", keyword: "const", params: { allowedValue: true }, message: "must be equal to constant" };
                            if (vErrors === null) {
                              vErrors = [err215];
                            } else {
                              vErrors.push(err215);
                            }
                            errors++;
                          }
                        }
                        if (data69.cents !== void 0) {
                          let data78 = data69.cents;
                          if (!(typeof data78 == "number" && (!(data78 % 1) && !isNaN(data78)) && isFinite(data78))) {
                            const err216 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bema/" + i13 + "/cents", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bema/items/properties/cents/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                            if (vErrors === null) {
                              vErrors = [err216];
                            } else {
                              vErrors.push(err216);
                            }
                            errors++;
                          }
                          if (typeof data78 == "number" && isFinite(data78)) {
                            if (data78 > 9007199254740991 || isNaN(data78)) {
                              const err217 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bema/" + i13 + "/cents", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bema/items/properties/cents/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err217];
                              } else {
                                vErrors.push(err217);
                              }
                              errors++;
                            }
                            if (data78 < -9007199254740991 || isNaN(data78)) {
                              const err218 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bema/" + i13 + "/cents", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bema/items/properties/cents/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err218];
                              } else {
                                vErrors.push(err218);
                              }
                              errors++;
                            }
                          }
                        }
                        if (data69.excluded !== void 0) {
                          if (typeof data69.excluded !== "string") {
                            const err219 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bema/" + i13 + "/excluded", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bema/items/properties/excluded/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err219];
                            } else {
                              vErrors.push(err219);
                            }
                            errors++;
                          }
                        }
                        if (data69.source !== void 0) {
                          let data80 = data69.source;
                          if (data80 && typeof data80 == "object" && !Array.isArray(data80)) {
                            if (data80.chunkId === void 0) {
                              const err220 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bema/" + i13 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bema/items/properties/source/required", keyword: "required", params: { missingProperty: "chunkId" }, message: "must have required property 'chunkId'" };
                              if (vErrors === null) {
                                vErrors = [err220];
                              } else {
                                vErrors.push(err220);
                              }
                              errors++;
                            }
                            if (data80.title === void 0) {
                              const err221 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bema/" + i13 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bema/items/properties/source/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
                              if (vErrors === null) {
                                vErrors = [err221];
                              } else {
                                vErrors.push(err221);
                              }
                              errors++;
                            }
                            if (data80.url === void 0) {
                              const err222 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bema/" + i13 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bema/items/properties/source/required", keyword: "required", params: { missingProperty: "url" }, message: "must have required property 'url'" };
                              if (vErrors === null) {
                                vErrors = [err222];
                              } else {
                                vErrors.push(err222);
                              }
                              errors++;
                            }
                            for (const key12 in data80) {
                              if (!(key12 === "chunkId" || key12 === "title" || key12 === "url" || key12 === "page")) {
                                const err223 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bema/" + i13 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bema/items/properties/source/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key12 }, message: "must NOT have additional properties" };
                                if (vErrors === null) {
                                  vErrors = [err223];
                                } else {
                                  vErrors.push(err223);
                                }
                                errors++;
                              }
                            }
                            if (data80.chunkId !== void 0) {
                              if (typeof data80.chunkId !== "string") {
                                const err224 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bema/" + i13 + "/source/chunkId", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bema/items/properties/source/properties/chunkId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err224];
                                } else {
                                  vErrors.push(err224);
                                }
                                errors++;
                              }
                            }
                            if (data80.title !== void 0) {
                              if (typeof data80.title !== "string") {
                                const err225 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bema/" + i13 + "/source/title", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bema/items/properties/source/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err225];
                                } else {
                                  vErrors.push(err225);
                                }
                                errors++;
                              }
                            }
                            if (data80.url !== void 0) {
                              if (typeof data80.url !== "string") {
                                const err226 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bema/" + i13 + "/source/url", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bema/items/properties/source/properties/url/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err226];
                                } else {
                                  vErrors.push(err226);
                                }
                                errors++;
                              }
                            }
                            if (data80.page !== void 0) {
                              let data84 = data80.page;
                              if (!(typeof data84 == "number" && (!(data84 % 1) && !isNaN(data84)) && isFinite(data84))) {
                                const err227 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bema/" + i13 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bema/items/properties/source/properties/page/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                if (vErrors === null) {
                                  vErrors = [err227];
                                } else {
                                  vErrors.push(err227);
                                }
                                errors++;
                              }
                              if (typeof data84 == "number" && isFinite(data84)) {
                                if (data84 > 9007199254740991 || isNaN(data84)) {
                                  const err228 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bema/" + i13 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bema/items/properties/source/properties/page/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                                  if (vErrors === null) {
                                    vErrors = [err228];
                                  } else {
                                    vErrors.push(err228);
                                  }
                                  errors++;
                                }
                                if (data84 < -9007199254740991 || isNaN(data84)) {
                                  const err229 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bema/" + i13 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bema/items/properties/source/properties/page/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                                  if (vErrors === null) {
                                    vErrors = [err229];
                                  } else {
                                    vErrors.push(err229);
                                  }
                                  errors++;
                                }
                              }
                            }
                          } else {
                            const err230 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bema/" + i13 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bema/items/properties/source/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                            if (vErrors === null) {
                              vErrors = [err230];
                            } else {
                              vErrors.push(err230);
                            }
                            errors++;
                          }
                        }
                      } else {
                        const err231 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bema/" + i13, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bema/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                        if (vErrors === null) {
                          vErrors = [err231];
                        } else {
                          vErrors.push(err231);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err232 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bema", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bema/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                      vErrors = [err232];
                    } else {
                      vErrors.push(err232);
                    }
                    errors++;
                  }
                }
                if (data66.hkp !== void 0) {
                  let data85 = data66.hkp;
                  if (Array.isArray(data85)) {
                    const len14 = data85.length;
                    for (let i14 = 0; i14 < len14; i14++) {
                      let data86 = data85[i14];
                      if (data86 && typeof data86 == "object" && !Array.isArray(data86)) {
                        if (data86.nr === void 0) {
                          const err233 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/hkp/" + i14, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/hkp/items/required", keyword: "required", params: { missingProperty: "nr" }, message: "must have required property 'nr'" };
                          if (vErrors === null) {
                            vErrors = [err233];
                          } else {
                            vErrors.push(err233);
                          }
                          errors++;
                        }
                        if (data86.text === void 0) {
                          const err234 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/hkp/" + i14, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/hkp/items/required", keyword: "required", params: { missingProperty: "text" }, message: "must have required property 'text'" };
                          if (vErrors === null) {
                            vErrors = [err234];
                          } else {
                            vErrors.push(err234);
                          }
                          errors++;
                        }
                        if (data86.befunde === void 0) {
                          const err235 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/hkp/" + i14, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/hkp/items/required", keyword: "required", params: { missingProperty: "befunde" }, message: "must have required property 'befunde'" };
                          if (vErrors === null) {
                            vErrors = [err235];
                          } else {
                            vErrors.push(err235);
                          }
                          errors++;
                        }
                        if (data86.quantity === void 0) {
                          const err236 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/hkp/" + i14, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/hkp/items/required", keyword: "required", params: { missingProperty: "quantity" }, message: "must have required property 'quantity'" };
                          if (vErrors === null) {
                            vErrors = [err236];
                          } else {
                            vErrors.push(err236);
                          }
                          errors++;
                        }
                        if (data86.counted === void 0) {
                          const err237 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/hkp/" + i14, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/hkp/items/required", keyword: "required", params: { missingProperty: "counted" }, message: "must have required property 'counted'" };
                          if (vErrors === null) {
                            vErrors = [err237];
                          } else {
                            vErrors.push(err237);
                          }
                          errors++;
                        }
                        for (const key13 in data86) {
                          if (!(key13 === "nr" || key13 === "text" || key13 === "befunde" || key13 === "quantity" || key13 === "counted" || key13 === "cents" || key13 === "source")) {
                            const err238 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/hkp/" + i14, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/hkp/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key13 }, message: "must NOT have additional properties" };
                            if (vErrors === null) {
                              vErrors = [err238];
                            } else {
                              vErrors.push(err238);
                            }
                            errors++;
                          }
                        }
                        if (data86.nr !== void 0) {
                          if (typeof data86.nr !== "string") {
                            const err239 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/hkp/" + i14 + "/nr", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/hkp/items/properties/nr/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err239];
                            } else {
                              vErrors.push(err239);
                            }
                            errors++;
                          }
                        }
                        if (data86.text !== void 0) {
                          if (typeof data86.text !== "string") {
                            const err240 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/hkp/" + i14 + "/text", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/hkp/items/properties/text/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err240];
                            } else {
                              vErrors.push(err240);
                            }
                            errors++;
                          }
                        }
                        if (data86.befunde !== void 0) {
                          if (typeof data86.befunde !== "string") {
                            const err241 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/hkp/" + i14 + "/befunde", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/hkp/items/properties/befunde/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err241];
                            } else {
                              vErrors.push(err241);
                            }
                            errors++;
                          }
                        }
                        if (data86.quantity !== void 0) {
                          let data90 = data86.quantity;
                          if (!(typeof data90 == "number" && (!(data90 % 1) && !isNaN(data90)) && isFinite(data90))) {
                            const err242 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/hkp/" + i14 + "/quantity", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/hkp/items/properties/quantity/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                            if (vErrors === null) {
                              vErrors = [err242];
                            } else {
                              vErrors.push(err242);
                            }
                            errors++;
                          }
                          if (typeof data90 == "number" && isFinite(data90)) {
                            if (data90 > 9007199254740991 || isNaN(data90)) {
                              const err243 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/hkp/" + i14 + "/quantity", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/hkp/items/properties/quantity/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err243];
                              } else {
                                vErrors.push(err243);
                              }
                              errors++;
                            }
                            if (data90 < -9007199254740991 || isNaN(data90)) {
                              const err244 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/hkp/" + i14 + "/quantity", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/hkp/items/properties/quantity/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err244];
                              } else {
                                vErrors.push(err244);
                              }
                              errors++;
                            }
                          }
                        }
                        if (data86.counted !== void 0) {
                          let data91 = data86.counted;
                          if (typeof data91 !== "string") {
                            const err245 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/hkp/" + i14 + "/counted", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/hkp/items/properties/counted/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err245];
                            } else {
                              vErrors.push(err245);
                            }
                            errors++;
                          }
                          if (!(data91 === "bema" || data91 === "dentist" || data91 === "assumed")) {
                            const err246 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/hkp/" + i14 + "/counted", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/hkp/items/properties/counted/enum", keyword: "enum", params: { allowedValues: schema37.properties.costs.properties.teeth.items.properties.hkp.items.properties.counted.enum }, message: "must be equal to one of the allowed values" };
                            if (vErrors === null) {
                              vErrors = [err246];
                            } else {
                              vErrors.push(err246);
                            }
                            errors++;
                          }
                        }
                        if (data86.cents !== void 0) {
                          let data92 = data86.cents;
                          if (!(typeof data92 == "number" && (!(data92 % 1) && !isNaN(data92)) && isFinite(data92))) {
                            const err247 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/hkp/" + i14 + "/cents", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/hkp/items/properties/cents/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                            if (vErrors === null) {
                              vErrors = [err247];
                            } else {
                              vErrors.push(err247);
                            }
                            errors++;
                          }
                          if (typeof data92 == "number" && isFinite(data92)) {
                            if (data92 > 9007199254740991 || isNaN(data92)) {
                              const err248 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/hkp/" + i14 + "/cents", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/hkp/items/properties/cents/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err248];
                              } else {
                                vErrors.push(err248);
                              }
                              errors++;
                            }
                            if (data92 < -9007199254740991 || isNaN(data92)) {
                              const err249 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/hkp/" + i14 + "/cents", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/hkp/items/properties/cents/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err249];
                              } else {
                                vErrors.push(err249);
                              }
                              errors++;
                            }
                          }
                        }
                        if (data86.source !== void 0) {
                          let data93 = data86.source;
                          if (data93 && typeof data93 == "object" && !Array.isArray(data93)) {
                            if (data93.chunkId === void 0) {
                              const err250 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/hkp/" + i14 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/hkp/items/properties/source/required", keyword: "required", params: { missingProperty: "chunkId" }, message: "must have required property 'chunkId'" };
                              if (vErrors === null) {
                                vErrors = [err250];
                              } else {
                                vErrors.push(err250);
                              }
                              errors++;
                            }
                            if (data93.title === void 0) {
                              const err251 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/hkp/" + i14 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/hkp/items/properties/source/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
                              if (vErrors === null) {
                                vErrors = [err251];
                              } else {
                                vErrors.push(err251);
                              }
                              errors++;
                            }
                            if (data93.url === void 0) {
                              const err252 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/hkp/" + i14 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/hkp/items/properties/source/required", keyword: "required", params: { missingProperty: "url" }, message: "must have required property 'url'" };
                              if (vErrors === null) {
                                vErrors = [err252];
                              } else {
                                vErrors.push(err252);
                              }
                              errors++;
                            }
                            for (const key14 in data93) {
                              if (!(key14 === "chunkId" || key14 === "title" || key14 === "url" || key14 === "page")) {
                                const err253 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/hkp/" + i14 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/hkp/items/properties/source/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key14 }, message: "must NOT have additional properties" };
                                if (vErrors === null) {
                                  vErrors = [err253];
                                } else {
                                  vErrors.push(err253);
                                }
                                errors++;
                              }
                            }
                            if (data93.chunkId !== void 0) {
                              if (typeof data93.chunkId !== "string") {
                                const err254 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/hkp/" + i14 + "/source/chunkId", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/hkp/items/properties/source/properties/chunkId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err254];
                                } else {
                                  vErrors.push(err254);
                                }
                                errors++;
                              }
                            }
                            if (data93.title !== void 0) {
                              if (typeof data93.title !== "string") {
                                const err255 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/hkp/" + i14 + "/source/title", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/hkp/items/properties/source/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err255];
                                } else {
                                  vErrors.push(err255);
                                }
                                errors++;
                              }
                            }
                            if (data93.url !== void 0) {
                              if (typeof data93.url !== "string") {
                                const err256 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/hkp/" + i14 + "/source/url", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/hkp/items/properties/source/properties/url/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err256];
                                } else {
                                  vErrors.push(err256);
                                }
                                errors++;
                              }
                            }
                            if (data93.page !== void 0) {
                              let data97 = data93.page;
                              if (!(typeof data97 == "number" && (!(data97 % 1) && !isNaN(data97)) && isFinite(data97))) {
                                const err257 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/hkp/" + i14 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/hkp/items/properties/source/properties/page/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                if (vErrors === null) {
                                  vErrors = [err257];
                                } else {
                                  vErrors.push(err257);
                                }
                                errors++;
                              }
                              if (typeof data97 == "number" && isFinite(data97)) {
                                if (data97 > 9007199254740991 || isNaN(data97)) {
                                  const err258 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/hkp/" + i14 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/hkp/items/properties/source/properties/page/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                                  if (vErrors === null) {
                                    vErrors = [err258];
                                  } else {
                                    vErrors.push(err258);
                                  }
                                  errors++;
                                }
                                if (data97 < -9007199254740991 || isNaN(data97)) {
                                  const err259 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/hkp/" + i14 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/hkp/items/properties/source/properties/page/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                                  if (vErrors === null) {
                                    vErrors = [err259];
                                  } else {
                                    vErrors.push(err259);
                                  }
                                  errors++;
                                }
                              }
                            }
                          } else {
                            const err260 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/hkp/" + i14 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/hkp/items/properties/source/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                            if (vErrors === null) {
                              vErrors = [err260];
                            } else {
                              vErrors.push(err260);
                            }
                            errors++;
                          }
                        }
                      } else {
                        const err261 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/hkp/" + i14, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/hkp/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                        if (vErrors === null) {
                          vErrors = [err261];
                        } else {
                          vErrors.push(err261);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err262 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/hkp", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/hkp/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                      vErrors = [err262];
                    } else {
                      vErrors.push(err262);
                    }
                    errors++;
                  }
                }
                if (data66.bel !== void 0) {
                  let data98 = data66.bel;
                  if (Array.isArray(data98)) {
                    const len15 = data98.length;
                    for (let i15 = 0; i15 < len15; i15++) {
                      let data99 = data98[i15];
                      if (data99 && typeof data99 == "object" && !Array.isArray(data99)) {
                        if (data99.befund === void 0) {
                          const err263 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bel/" + i15, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bel/items/required", keyword: "required", params: { missingProperty: "befund" }, message: "must have required property 'befund'" };
                          if (vErrors === null) {
                            vErrors = [err263];
                          } else {
                            vErrors.push(err263);
                          }
                          errors++;
                        }
                        if (data99.nr === void 0) {
                          const err264 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bel/" + i15, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bel/items/required", keyword: "required", params: { missingProperty: "nr" }, message: "must have required property 'nr'" };
                          if (vErrors === null) {
                            vErrors = [err264];
                          } else {
                            vErrors.push(err264);
                          }
                          errors++;
                        }
                        if (data99.text === void 0) {
                          const err265 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bel/" + i15, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bel/items/required", keyword: "required", params: { missingProperty: "text" }, message: "must have required property 'text'" };
                          if (vErrors === null) {
                            vErrors = [err265];
                          } else {
                            vErrors.push(err265);
                          }
                          errors++;
                        }
                        if (data99.minus === void 0) {
                          const err266 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bel/" + i15, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bel/items/required", keyword: "required", params: { missingProperty: "minus" }, message: "must have required property 'minus'" };
                          if (vErrors === null) {
                            vErrors = [err266];
                          } else {
                            vErrors.push(err266);
                          }
                          errors++;
                        }
                        for (const key15 in data99) {
                          if (!(key15 === "befund" || key15 === "nr" || key15 === "text" || key15 === "minus" || key15 === "source")) {
                            const err267 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bel/" + i15, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bel/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key15 }, message: "must NOT have additional properties" };
                            if (vErrors === null) {
                              vErrors = [err267];
                            } else {
                              vErrors.push(err267);
                            }
                            errors++;
                          }
                        }
                        if (data99.befund !== void 0) {
                          if (typeof data99.befund !== "string") {
                            const err268 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bel/" + i15 + "/befund", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bel/items/properties/befund/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err268];
                            } else {
                              vErrors.push(err268);
                            }
                            errors++;
                          }
                        }
                        if (data99.nr !== void 0) {
                          if (typeof data99.nr !== "string") {
                            const err269 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bel/" + i15 + "/nr", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bel/items/properties/nr/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err269];
                            } else {
                              vErrors.push(err269);
                            }
                            errors++;
                          }
                        }
                        if (data99.text !== void 0) {
                          if (typeof data99.text !== "string") {
                            const err270 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bel/" + i15 + "/text", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bel/items/properties/text/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err270];
                            } else {
                              vErrors.push(err270);
                            }
                            errors++;
                          }
                        }
                        if (data99.minus !== void 0) {
                          if (typeof data99.minus !== "boolean") {
                            const err271 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bel/" + i15 + "/minus", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bel/items/properties/minus/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                            if (vErrors === null) {
                              vErrors = [err271];
                            } else {
                              vErrors.push(err271);
                            }
                            errors++;
                          }
                        }
                        if (data99.source !== void 0) {
                          let data104 = data99.source;
                          if (data104 && typeof data104 == "object" && !Array.isArray(data104)) {
                            if (data104.chunkId === void 0) {
                              const err272 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bel/" + i15 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bel/items/properties/source/required", keyword: "required", params: { missingProperty: "chunkId" }, message: "must have required property 'chunkId'" };
                              if (vErrors === null) {
                                vErrors = [err272];
                              } else {
                                vErrors.push(err272);
                              }
                              errors++;
                            }
                            if (data104.title === void 0) {
                              const err273 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bel/" + i15 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bel/items/properties/source/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
                              if (vErrors === null) {
                                vErrors = [err273];
                              } else {
                                vErrors.push(err273);
                              }
                              errors++;
                            }
                            if (data104.url === void 0) {
                              const err274 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bel/" + i15 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bel/items/properties/source/required", keyword: "required", params: { missingProperty: "url" }, message: "must have required property 'url'" };
                              if (vErrors === null) {
                                vErrors = [err274];
                              } else {
                                vErrors.push(err274);
                              }
                              errors++;
                            }
                            for (const key16 in data104) {
                              if (!(key16 === "chunkId" || key16 === "title" || key16 === "url" || key16 === "page")) {
                                const err275 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bel/" + i15 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bel/items/properties/source/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key16 }, message: "must NOT have additional properties" };
                                if (vErrors === null) {
                                  vErrors = [err275];
                                } else {
                                  vErrors.push(err275);
                                }
                                errors++;
                              }
                            }
                            if (data104.chunkId !== void 0) {
                              if (typeof data104.chunkId !== "string") {
                                const err276 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bel/" + i15 + "/source/chunkId", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bel/items/properties/source/properties/chunkId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err276];
                                } else {
                                  vErrors.push(err276);
                                }
                                errors++;
                              }
                            }
                            if (data104.title !== void 0) {
                              if (typeof data104.title !== "string") {
                                const err277 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bel/" + i15 + "/source/title", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bel/items/properties/source/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err277];
                                } else {
                                  vErrors.push(err277);
                                }
                                errors++;
                              }
                            }
                            if (data104.url !== void 0) {
                              if (typeof data104.url !== "string") {
                                const err278 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bel/" + i15 + "/source/url", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bel/items/properties/source/properties/url/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err278];
                                } else {
                                  vErrors.push(err278);
                                }
                                errors++;
                              }
                            }
                            if (data104.page !== void 0) {
                              let data108 = data104.page;
                              if (!(typeof data108 == "number" && (!(data108 % 1) && !isNaN(data108)) && isFinite(data108))) {
                                const err279 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bel/" + i15 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bel/items/properties/source/properties/page/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                if (vErrors === null) {
                                  vErrors = [err279];
                                } else {
                                  vErrors.push(err279);
                                }
                                errors++;
                              }
                              if (typeof data108 == "number" && isFinite(data108)) {
                                if (data108 > 9007199254740991 || isNaN(data108)) {
                                  const err280 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bel/" + i15 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bel/items/properties/source/properties/page/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                                  if (vErrors === null) {
                                    vErrors = [err280];
                                  } else {
                                    vErrors.push(err280);
                                  }
                                  errors++;
                                }
                                if (data108 < -9007199254740991 || isNaN(data108)) {
                                  const err281 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bel/" + i15 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bel/items/properties/source/properties/page/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                                  if (vErrors === null) {
                                    vErrors = [err281];
                                  } else {
                                    vErrors.push(err281);
                                  }
                                  errors++;
                                }
                              }
                            }
                          } else {
                            const err282 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bel/" + i15 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bel/items/properties/source/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                            if (vErrors === null) {
                              vErrors = [err282];
                            } else {
                              vErrors.push(err282);
                            }
                            errors++;
                          }
                        }
                      } else {
                        const err283 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bel/" + i15, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bel/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                        if (vErrors === null) {
                          vErrors = [err283];
                        } else {
                          vErrors.push(err283);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err284 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/bel", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/bel/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                      vErrors = [err284];
                    } else {
                      vErrors.push(err284);
                    }
                    errors++;
                  }
                }
                if (data66.materials !== void 0) {
                  let data109 = data66.materials;
                  if (Array.isArray(data109)) {
                    const len16 = data109.length;
                    for (let i16 = 0; i16 < len16; i16++) {
                      let data110 = data109[i16];
                      if (data110 && typeof data110 == "object" && !Array.isArray(data110)) {
                        if (data110.befund === void 0) {
                          const err285 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/materials/" + i16, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/materials/items/required", keyword: "required", params: { missingProperty: "befund" }, message: "must have required property 'befund'" };
                          if (vErrors === null) {
                            vErrors = [err285];
                          } else {
                            vErrors.push(err285);
                          }
                          errors++;
                        }
                        if (data110.name === void 0) {
                          const err286 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/materials/" + i16, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/materials/items/required", keyword: "required", params: { missingProperty: "name" }, message: "must have required property 'name'" };
                          if (vErrors === null) {
                            vErrors = [err286];
                          } else {
                            vErrors.push(err286);
                          }
                          errors++;
                        }
                        for (const key17 in data110) {
                          if (!(key17 === "befund" || key17 === "name" || key17 === "source")) {
                            const err287 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/materials/" + i16, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/materials/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key17 }, message: "must NOT have additional properties" };
                            if (vErrors === null) {
                              vErrors = [err287];
                            } else {
                              vErrors.push(err287);
                            }
                            errors++;
                          }
                        }
                        if (data110.befund !== void 0) {
                          if (typeof data110.befund !== "string") {
                            const err288 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/materials/" + i16 + "/befund", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/materials/items/properties/befund/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err288];
                            } else {
                              vErrors.push(err288);
                            }
                            errors++;
                          }
                        }
                        if (data110.name !== void 0) {
                          if (typeof data110.name !== "string") {
                            const err289 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/materials/" + i16 + "/name", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/materials/items/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err289];
                            } else {
                              vErrors.push(err289);
                            }
                            errors++;
                          }
                        }
                        if (data110.source !== void 0) {
                          let data113 = data110.source;
                          if (data113 && typeof data113 == "object" && !Array.isArray(data113)) {
                            if (data113.chunkId === void 0) {
                              const err290 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/materials/" + i16 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/materials/items/properties/source/required", keyword: "required", params: { missingProperty: "chunkId" }, message: "must have required property 'chunkId'" };
                              if (vErrors === null) {
                                vErrors = [err290];
                              } else {
                                vErrors.push(err290);
                              }
                              errors++;
                            }
                            if (data113.title === void 0) {
                              const err291 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/materials/" + i16 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/materials/items/properties/source/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
                              if (vErrors === null) {
                                vErrors = [err291];
                              } else {
                                vErrors.push(err291);
                              }
                              errors++;
                            }
                            if (data113.url === void 0) {
                              const err292 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/materials/" + i16 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/materials/items/properties/source/required", keyword: "required", params: { missingProperty: "url" }, message: "must have required property 'url'" };
                              if (vErrors === null) {
                                vErrors = [err292];
                              } else {
                                vErrors.push(err292);
                              }
                              errors++;
                            }
                            for (const key18 in data113) {
                              if (!(key18 === "chunkId" || key18 === "title" || key18 === "url" || key18 === "page")) {
                                const err293 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/materials/" + i16 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/materials/items/properties/source/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key18 }, message: "must NOT have additional properties" };
                                if (vErrors === null) {
                                  vErrors = [err293];
                                } else {
                                  vErrors.push(err293);
                                }
                                errors++;
                              }
                            }
                            if (data113.chunkId !== void 0) {
                              if (typeof data113.chunkId !== "string") {
                                const err294 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/materials/" + i16 + "/source/chunkId", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/materials/items/properties/source/properties/chunkId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err294];
                                } else {
                                  vErrors.push(err294);
                                }
                                errors++;
                              }
                            }
                            if (data113.title !== void 0) {
                              if (typeof data113.title !== "string") {
                                const err295 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/materials/" + i16 + "/source/title", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/materials/items/properties/source/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err295];
                                } else {
                                  vErrors.push(err295);
                                }
                                errors++;
                              }
                            }
                            if (data113.url !== void 0) {
                              if (typeof data113.url !== "string") {
                                const err296 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/materials/" + i16 + "/source/url", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/materials/items/properties/source/properties/url/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err296];
                                } else {
                                  vErrors.push(err296);
                                }
                                errors++;
                              }
                            }
                            if (data113.page !== void 0) {
                              let data117 = data113.page;
                              if (!(typeof data117 == "number" && (!(data117 % 1) && !isNaN(data117)) && isFinite(data117))) {
                                const err297 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/materials/" + i16 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/materials/items/properties/source/properties/page/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                if (vErrors === null) {
                                  vErrors = [err297];
                                } else {
                                  vErrors.push(err297);
                                }
                                errors++;
                              }
                              if (typeof data117 == "number" && isFinite(data117)) {
                                if (data117 > 9007199254740991 || isNaN(data117)) {
                                  const err298 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/materials/" + i16 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/materials/items/properties/source/properties/page/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                                  if (vErrors === null) {
                                    vErrors = [err298];
                                  } else {
                                    vErrors.push(err298);
                                  }
                                  errors++;
                                }
                                if (data117 < -9007199254740991 || isNaN(data117)) {
                                  const err299 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/materials/" + i16 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/materials/items/properties/source/properties/page/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                                  if (vErrors === null) {
                                    vErrors = [err299];
                                  } else {
                                    vErrors.push(err299);
                                  }
                                  errors++;
                                }
                              }
                            }
                          } else {
                            const err300 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/materials/" + i16 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/materials/items/properties/source/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                            if (vErrors === null) {
                              vErrors = [err300];
                            } else {
                              vErrors.push(err300);
                            }
                            errors++;
                          }
                        }
                      } else {
                        const err301 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/materials/" + i16, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/materials/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                        if (vErrors === null) {
                          vErrors = [err301];
                        } else {
                          vErrors.push(err301);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err302 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/materials", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/materials/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                      vErrors = [err302];
                    } else {
                      vErrors.push(err302);
                    }
                    errors++;
                  }
                }
                if (data66.labor !== void 0) {
                  let data118 = data66.labor;
                  if (!(typeof data118 == "number" && (!(data118 % 1) && !isNaN(data118)) && isFinite(data118))) {
                    const err303 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/labor", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/labor/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err303];
                    } else {
                      vErrors.push(err303);
                    }
                    errors++;
                  }
                  if (typeof data118 == "number" && isFinite(data118)) {
                    if (data118 > 9007199254740991 || isNaN(data118)) {
                      const err304 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/labor", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/labor/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err304];
                      } else {
                        vErrors.push(err304);
                      }
                      errors++;
                    }
                    if (data118 < -9007199254740991 || isNaN(data118)) {
                      const err305 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/labor", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/labor/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err305];
                      } else {
                        vErrors.push(err305);
                      }
                      errors++;
                    }
                  }
                }
                if (data66.versorgung !== void 0) {
                  let data119 = data66.versorgung;
                  if (data119 && typeof data119 == "object" && !Array.isArray(data119)) {
                    if (data119.geplant === void 0) {
                      const err306 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/versorgung", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/versorgung/required", keyword: "required", params: { missingProperty: "geplant" }, message: "must have required property 'geplant'" };
                      if (vErrors === null) {
                        vErrors = [err306];
                      } else {
                        vErrors.push(err306);
                      }
                      errors++;
                    }
                    if (data119.klasse === void 0) {
                      const err307 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/versorgung", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/versorgung/required", keyword: "required", params: { missingProperty: "klasse" }, message: "must have required property 'klasse'" };
                      if (vErrors === null) {
                        vErrors = [err307];
                      } else {
                        vErrors.push(err307);
                      }
                      errors++;
                    }
                    for (const key19 in data119) {
                      if (!(key19 === "geplant" || key19 === "klasse")) {
                        const err308 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/versorgung", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/versorgung/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key19 }, message: "must NOT have additional properties" };
                        if (vErrors === null) {
                          vErrors = [err308];
                        } else {
                          vErrors.push(err308);
                        }
                        errors++;
                      }
                    }
                    if (data119.geplant !== void 0) {
                      if (typeof data119.geplant !== "string") {
                        const err309 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/versorgung/geplant", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/versorgung/properties/geplant/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err309];
                        } else {
                          vErrors.push(err309);
                        }
                        errors++;
                      }
                    }
                    if (data119.klasse !== void 0) {
                      let data121 = data119.klasse;
                      if (typeof data121 !== "string") {
                        const err310 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/versorgung/klasse", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/versorgung/properties/klasse/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err310];
                        } else {
                          vErrors.push(err310);
                        }
                        errors++;
                      }
                      if (!(data121 === "regelversorgung" || data121 === "gleichartig")) {
                        const err311 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/versorgung/klasse", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/versorgung/properties/klasse/enum", keyword: "enum", params: { allowedValues: schema37.properties.costs.properties.teeth.items.properties.versorgung.properties.klasse.enum }, message: "must be equal to one of the allowed values" };
                        if (vErrors === null) {
                          vErrors = [err311];
                        } else {
                          vErrors.push(err311);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err312 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/versorgung", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/versorgung/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                    if (vErrors === null) {
                      vErrors = [err312];
                    } else {
                      vErrors.push(err312);
                    }
                    errors++;
                  }
                }
                if (data66.goz !== void 0) {
                  let data122 = data66.goz;
                  if (Array.isArray(data122)) {
                    const len17 = data122.length;
                    for (let i17 = 0; i17 < len17; i17++) {
                      let data123 = data122[i17];
                      if (data123 && typeof data123 == "object" && !Array.isArray(data123)) {
                        if (data123.nr === void 0) {
                          const err313 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/goz/" + i17, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/goz/items/required", keyword: "required", params: { missingProperty: "nr" }, message: "must have required property 'nr'" };
                          if (vErrors === null) {
                            vErrors = [err313];
                          } else {
                            vErrors.push(err313);
                          }
                          errors++;
                        }
                        if (data123.title === void 0) {
                          const err314 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/goz/" + i17, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/goz/items/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
                          if (vErrors === null) {
                            vErrors = [err314];
                          } else {
                            vErrors.push(err314);
                          }
                          errors++;
                        }
                        if (data123.points === void 0) {
                          const err315 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/goz/" + i17, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/goz/items/required", keyword: "required", params: { missingProperty: "points" }, message: "must have required property 'points'" };
                          if (vErrors === null) {
                            vErrors = [err315];
                          } else {
                            vErrors.push(err315);
                          }
                          errors++;
                        }
                        if (data123.faktor === void 0) {
                          const err316 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/goz/" + i17, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/goz/items/required", keyword: "required", params: { missingProperty: "faktor" }, message: "must have required property 'faktor'" };
                          if (vErrors === null) {
                            vErrors = [err316];
                          } else {
                            vErrors.push(err316);
                          }
                          errors++;
                        }
                        if (data123.cents === void 0) {
                          const err317 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/goz/" + i17, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/goz/items/required", keyword: "required", params: { missingProperty: "cents" }, message: "must have required property 'cents'" };
                          if (vErrors === null) {
                            vErrors = [err317];
                          } else {
                            vErrors.push(err317);
                          }
                          errors++;
                        }
                        for (const key20 in data123) {
                          if (!(key20 === "nr" || key20 === "title" || key20 === "points" || key20 === "faktor" || key20 === "cents" || key20 === "excluded" || key20 === "source")) {
                            const err318 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/goz/" + i17, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/goz/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key20 }, message: "must NOT have additional properties" };
                            if (vErrors === null) {
                              vErrors = [err318];
                            } else {
                              vErrors.push(err318);
                            }
                            errors++;
                          }
                        }
                        if (data123.nr !== void 0) {
                          if (typeof data123.nr !== "string") {
                            const err319 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/goz/" + i17 + "/nr", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/goz/items/properties/nr/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err319];
                            } else {
                              vErrors.push(err319);
                            }
                            errors++;
                          }
                        }
                        if (data123.title !== void 0) {
                          if (typeof data123.title !== "string") {
                            const err320 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/goz/" + i17 + "/title", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/goz/items/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err320];
                            } else {
                              vErrors.push(err320);
                            }
                            errors++;
                          }
                        }
                        if (data123.points !== void 0) {
                          let data126 = data123.points;
                          if (!(typeof data126 == "number" && (!(data126 % 1) && !isNaN(data126)) && isFinite(data126))) {
                            const err321 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/goz/" + i17 + "/points", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/goz/items/properties/points/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                            if (vErrors === null) {
                              vErrors = [err321];
                            } else {
                              vErrors.push(err321);
                            }
                            errors++;
                          }
                          if (typeof data126 == "number" && isFinite(data126)) {
                            if (data126 > 9007199254740991 || isNaN(data126)) {
                              const err322 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/goz/" + i17 + "/points", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/goz/items/properties/points/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err322];
                              } else {
                                vErrors.push(err322);
                              }
                              errors++;
                            }
                            if (data126 < -9007199254740991 || isNaN(data126)) {
                              const err323 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/goz/" + i17 + "/points", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/goz/items/properties/points/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err323];
                              } else {
                                vErrors.push(err323);
                              }
                              errors++;
                            }
                          }
                        }
                        if (data123.faktor !== void 0) {
                          let data127 = data123.faktor;
                          if (!(typeof data127 == "number" && (!(data127 % 1) && !isNaN(data127)) && isFinite(data127))) {
                            const err324 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/goz/" + i17 + "/faktor", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/goz/items/properties/faktor/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                            if (vErrors === null) {
                              vErrors = [err324];
                            } else {
                              vErrors.push(err324);
                            }
                            errors++;
                          }
                          if (typeof data127 == "number" && isFinite(data127)) {
                            if (data127 > 9007199254740991 || isNaN(data127)) {
                              const err325 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/goz/" + i17 + "/faktor", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/goz/items/properties/faktor/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err325];
                              } else {
                                vErrors.push(err325);
                              }
                              errors++;
                            }
                            if (data127 < -9007199254740991 || isNaN(data127)) {
                              const err326 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/goz/" + i17 + "/faktor", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/goz/items/properties/faktor/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err326];
                              } else {
                                vErrors.push(err326);
                              }
                              errors++;
                            }
                          }
                        }
                        if (data123.cents !== void 0) {
                          let data128 = data123.cents;
                          if (!(typeof data128 == "number" && (!(data128 % 1) && !isNaN(data128)) && isFinite(data128))) {
                            const err327 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/goz/" + i17 + "/cents", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/goz/items/properties/cents/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                            if (vErrors === null) {
                              vErrors = [err327];
                            } else {
                              vErrors.push(err327);
                            }
                            errors++;
                          }
                          if (typeof data128 == "number" && isFinite(data128)) {
                            if (data128 > 9007199254740991 || isNaN(data128)) {
                              const err328 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/goz/" + i17 + "/cents", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/goz/items/properties/cents/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err328];
                              } else {
                                vErrors.push(err328);
                              }
                              errors++;
                            }
                            if (data128 < -9007199254740991 || isNaN(data128)) {
                              const err329 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/goz/" + i17 + "/cents", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/goz/items/properties/cents/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err329];
                              } else {
                                vErrors.push(err329);
                              }
                              errors++;
                            }
                          }
                        }
                        if (data123.excluded !== void 0) {
                          if (typeof data123.excluded !== "string") {
                            const err330 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/goz/" + i17 + "/excluded", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/goz/items/properties/excluded/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err330];
                            } else {
                              vErrors.push(err330);
                            }
                            errors++;
                          }
                        }
                        if (data123.source !== void 0) {
                          let data130 = data123.source;
                          if (data130 && typeof data130 == "object" && !Array.isArray(data130)) {
                            if (data130.chunkId === void 0) {
                              const err331 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/goz/" + i17 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/goz/items/properties/source/required", keyword: "required", params: { missingProperty: "chunkId" }, message: "must have required property 'chunkId'" };
                              if (vErrors === null) {
                                vErrors = [err331];
                              } else {
                                vErrors.push(err331);
                              }
                              errors++;
                            }
                            if (data130.title === void 0) {
                              const err332 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/goz/" + i17 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/goz/items/properties/source/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
                              if (vErrors === null) {
                                vErrors = [err332];
                              } else {
                                vErrors.push(err332);
                              }
                              errors++;
                            }
                            if (data130.url === void 0) {
                              const err333 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/goz/" + i17 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/goz/items/properties/source/required", keyword: "required", params: { missingProperty: "url" }, message: "must have required property 'url'" };
                              if (vErrors === null) {
                                vErrors = [err333];
                              } else {
                                vErrors.push(err333);
                              }
                              errors++;
                            }
                            for (const key21 in data130) {
                              if (!(key21 === "chunkId" || key21 === "title" || key21 === "url" || key21 === "page")) {
                                const err334 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/goz/" + i17 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/goz/items/properties/source/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key21 }, message: "must NOT have additional properties" };
                                if (vErrors === null) {
                                  vErrors = [err334];
                                } else {
                                  vErrors.push(err334);
                                }
                                errors++;
                              }
                            }
                            if (data130.chunkId !== void 0) {
                              if (typeof data130.chunkId !== "string") {
                                const err335 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/goz/" + i17 + "/source/chunkId", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/goz/items/properties/source/properties/chunkId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err335];
                                } else {
                                  vErrors.push(err335);
                                }
                                errors++;
                              }
                            }
                            if (data130.title !== void 0) {
                              if (typeof data130.title !== "string") {
                                const err336 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/goz/" + i17 + "/source/title", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/goz/items/properties/source/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err336];
                                } else {
                                  vErrors.push(err336);
                                }
                                errors++;
                              }
                            }
                            if (data130.url !== void 0) {
                              if (typeof data130.url !== "string") {
                                const err337 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/goz/" + i17 + "/source/url", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/goz/items/properties/source/properties/url/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err337];
                                } else {
                                  vErrors.push(err337);
                                }
                                errors++;
                              }
                            }
                            if (data130.page !== void 0) {
                              let data134 = data130.page;
                              if (!(typeof data134 == "number" && (!(data134 % 1) && !isNaN(data134)) && isFinite(data134))) {
                                const err338 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/goz/" + i17 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/goz/items/properties/source/properties/page/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                if (vErrors === null) {
                                  vErrors = [err338];
                                } else {
                                  vErrors.push(err338);
                                }
                                errors++;
                              }
                              if (typeof data134 == "number" && isFinite(data134)) {
                                if (data134 > 9007199254740991 || isNaN(data134)) {
                                  const err339 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/goz/" + i17 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/goz/items/properties/source/properties/page/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                                  if (vErrors === null) {
                                    vErrors = [err339];
                                  } else {
                                    vErrors.push(err339);
                                  }
                                  errors++;
                                }
                                if (data134 < -9007199254740991 || isNaN(data134)) {
                                  const err340 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/goz/" + i17 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/goz/items/properties/source/properties/page/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                                  if (vErrors === null) {
                                    vErrors = [err340];
                                  } else {
                                    vErrors.push(err340);
                                  }
                                  errors++;
                                }
                              }
                            }
                          } else {
                            const err341 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/goz/" + i17 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/goz/items/properties/source/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                            if (vErrors === null) {
                              vErrors = [err341];
                            } else {
                              vErrors.push(err341);
                            }
                            errors++;
                          }
                        }
                      } else {
                        const err342 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/goz/" + i17, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/goz/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                        if (vErrors === null) {
                          vErrors = [err342];
                        } else {
                          vErrors.push(err342);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err343 = { instancePath: instancePath + "/costs/teeth/" + i12 + "/goz", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/properties/goz/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                      vErrors = [err343];
                    } else {
                      vErrors.push(err343);
                    }
                    errors++;
                  }
                }
              } else {
                const err344 = { instancePath: instancePath + "/costs/teeth/" + i12, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                if (vErrors === null) {
                  vErrors = [err344];
                } else {
                  vErrors.push(err344);
                }
                errors++;
              }
            }
          } else {
            const err345 = { instancePath: instancePath + "/costs/teeth", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/teeth/type", keyword: "type", params: { type: "array" }, message: "must be array" };
            if (vErrors === null) {
              vErrors = [err345];
            } else {
              vErrors.push(err345);
            }
            errors++;
          }
        }
        if (data64.luecken !== void 0) {
          let data135 = data64.luecken;
          if (Array.isArray(data135)) {
            const len18 = data135.length;
            for (let i18 = 0; i18 < len18; i18++) {
              let data136 = data135[i18];
              if (data136 && typeof data136 == "object" && !Array.isArray(data136)) {
                if (data136.luecke === void 0) {
                  const err346 = { instancePath: instancePath + "/costs/luecken/" + i18, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/required", keyword: "required", params: { missingProperty: "luecke" }, message: "must have required property 'luecke'" };
                  if (vErrors === null) {
                    vErrors = [err346];
                  } else {
                    vErrors.push(err346);
                  }
                  errors++;
                }
                if (data136.bema === void 0) {
                  const err347 = { instancePath: instancePath + "/costs/luecken/" + i18, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/required", keyword: "required", params: { missingProperty: "bema" }, message: "must have required property 'bema'" };
                  if (vErrors === null) {
                    vErrors = [err347];
                  } else {
                    vErrors.push(err347);
                  }
                  errors++;
                }
                if (data136.hkp === void 0) {
                  const err348 = { instancePath: instancePath + "/costs/luecken/" + i18, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/required", keyword: "required", params: { missingProperty: "hkp" }, message: "must have required property 'hkp'" };
                  if (vErrors === null) {
                    vErrors = [err348];
                  } else {
                    vErrors.push(err348);
                  }
                  errors++;
                }
                if (data136.bel === void 0) {
                  const err349 = { instancePath: instancePath + "/costs/luecken/" + i18, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/required", keyword: "required", params: { missingProperty: "bel" }, message: "must have required property 'bel'" };
                  if (vErrors === null) {
                    vErrors = [err349];
                  } else {
                    vErrors.push(err349);
                  }
                  errors++;
                }
                if (data136.materials === void 0) {
                  const err350 = { instancePath: instancePath + "/costs/luecken/" + i18, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/required", keyword: "required", params: { missingProperty: "materials" }, message: "must have required property 'materials'" };
                  if (vErrors === null) {
                    vErrors = [err350];
                  } else {
                    vErrors.push(err350);
                  }
                  errors++;
                }
                if (data136.labor === void 0) {
                  const err351 = { instancePath: instancePath + "/costs/luecken/" + i18, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/required", keyword: "required", params: { missingProperty: "labor" }, message: "must have required property 'labor'" };
                  if (vErrors === null) {
                    vErrors = [err351];
                  } else {
                    vErrors.push(err351);
                  }
                  errors++;
                }
                for (const key22 in data136) {
                  if (!(key22 === "luecke" || key22 === "bema" || key22 === "hkp" || key22 === "bel" || key22 === "materials" || key22 === "labor")) {
                    const err352 = { instancePath: instancePath + "/costs/luecken/" + i18, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key22 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                      vErrors = [err352];
                    } else {
                      vErrors.push(err352);
                    }
                    errors++;
                  }
                }
                if (data136.luecke !== void 0) {
                  let data137 = data136.luecke;
                  if (data137 && typeof data137 == "object" && !Array.isArray(data137)) {
                    if (data137.id === void 0) {
                      const err353 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/luecke", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/luecke/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property 'id'" };
                      if (vErrors === null) {
                        vErrors = [err353];
                      } else {
                        vErrors.push(err353);
                      }
                      errors++;
                    }
                    if (data137.jaw === void 0) {
                      const err354 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/luecke", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/luecke/required", keyword: "required", params: { missingProperty: "jaw" }, message: "must have required property 'jaw'" };
                      if (vErrors === null) {
                        vErrors = [err354];
                      } else {
                        vErrors.push(err354);
                      }
                      errors++;
                    }
                    if (data137.anker === void 0) {
                      const err355 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/luecke", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/luecke/required", keyword: "required", params: { missingProperty: "anker" }, message: "must have required property 'anker'" };
                      if (vErrors === null) {
                        vErrors = [err355];
                      } else {
                        vErrors.push(err355);
                      }
                      errors++;
                    }
                    if (data137.fehlend === void 0) {
                      const err356 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/luecke", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/luecke/required", keyword: "required", params: { missingProperty: "fehlend" }, message: "must have required property 'fehlend'" };
                      if (vErrors === null) {
                        vErrors = [err356];
                      } else {
                        vErrors.push(err356);
                      }
                      errors++;
                    }
                    for (const key23 in data137) {
                      if (!(key23 === "id" || key23 === "jaw" || key23 === "anker" || key23 === "fehlend")) {
                        const err357 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/luecke", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/luecke/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key23 }, message: "must NOT have additional properties" };
                        if (vErrors === null) {
                          vErrors = [err357];
                        } else {
                          vErrors.push(err357);
                        }
                        errors++;
                      }
                    }
                    if (data137.id !== void 0) {
                      if (typeof data137.id !== "string") {
                        const err358 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/luecke/id", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/luecke/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err358];
                        } else {
                          vErrors.push(err358);
                        }
                        errors++;
                      }
                    }
                    if (data137.jaw !== void 0) {
                      let data139 = data137.jaw;
                      if (typeof data139 !== "string") {
                        const err359 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/luecke/jaw", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/luecke/properties/jaw/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err359];
                        } else {
                          vErrors.push(err359);
                        }
                        errors++;
                      }
                      if (!(data139 === "OK" || data139 === "UK")) {
                        const err360 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/luecke/jaw", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/luecke/properties/jaw/enum", keyword: "enum", params: { allowedValues: schema37.properties.costs.properties.luecken.items.properties.luecke.properties.jaw.enum }, message: "must be equal to one of the allowed values" };
                        if (vErrors === null) {
                          vErrors = [err360];
                        } else {
                          vErrors.push(err360);
                        }
                        errors++;
                      }
                    }
                    if (data137.anker !== void 0) {
                      let data140 = data137.anker;
                      if (Array.isArray(data140)) {
                        const len19 = data140.length;
                        for (let i19 = 0; i19 < len19; i19++) {
                          let data141 = data140[i19];
                          if (!(typeof data141 == "number" && (!(data141 % 1) && !isNaN(data141)) && isFinite(data141))) {
                            const err361 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/luecke/anker/" + i19, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/luecke/properties/anker/items/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                            if (vErrors === null) {
                              vErrors = [err361];
                            } else {
                              vErrors.push(err361);
                            }
                            errors++;
                          }
                          if (typeof data141 == "number" && isFinite(data141)) {
                            if (data141 > 9007199254740991 || isNaN(data141)) {
                              const err362 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/luecke/anker/" + i19, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/luecke/properties/anker/items/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err362];
                              } else {
                                vErrors.push(err362);
                              }
                              errors++;
                            }
                            if (data141 < -9007199254740991 || isNaN(data141)) {
                              const err363 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/luecke/anker/" + i19, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/luecke/properties/anker/items/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err363];
                              } else {
                                vErrors.push(err363);
                              }
                              errors++;
                            }
                          }
                        }
                      } else {
                        const err364 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/luecke/anker", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/luecke/properties/anker/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                        if (vErrors === null) {
                          vErrors = [err364];
                        } else {
                          vErrors.push(err364);
                        }
                        errors++;
                      }
                    }
                    if (data137.fehlend !== void 0) {
                      let data142 = data137.fehlend;
                      if (Array.isArray(data142)) {
                        const len20 = data142.length;
                        for (let i20 = 0; i20 < len20; i20++) {
                          let data143 = data142[i20];
                          if (!(typeof data143 == "number" && (!(data143 % 1) && !isNaN(data143)) && isFinite(data143))) {
                            const err365 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/luecke/fehlend/" + i20, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/luecke/properties/fehlend/items/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                            if (vErrors === null) {
                              vErrors = [err365];
                            } else {
                              vErrors.push(err365);
                            }
                            errors++;
                          }
                          if (typeof data143 == "number" && isFinite(data143)) {
                            if (data143 > 9007199254740991 || isNaN(data143)) {
                              const err366 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/luecke/fehlend/" + i20, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/luecke/properties/fehlend/items/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err366];
                              } else {
                                vErrors.push(err366);
                              }
                              errors++;
                            }
                            if (data143 < -9007199254740991 || isNaN(data143)) {
                              const err367 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/luecke/fehlend/" + i20, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/luecke/properties/fehlend/items/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err367];
                              } else {
                                vErrors.push(err367);
                              }
                              errors++;
                            }
                          }
                        }
                      } else {
                        const err368 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/luecke/fehlend", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/luecke/properties/fehlend/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                        if (vErrors === null) {
                          vErrors = [err368];
                        } else {
                          vErrors.push(err368);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err369 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/luecke", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/luecke/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                    if (vErrors === null) {
                      vErrors = [err369];
                    } else {
                      vErrors.push(err369);
                    }
                    errors++;
                  }
                }
                if (data136.bema !== void 0) {
                  let data144 = data136.bema;
                  if (Array.isArray(data144)) {
                    const len21 = data144.length;
                    for (let i21 = 0; i21 < len21; i21++) {
                      let data145 = data144[i21];
                      if (data145 && typeof data145 == "object" && !Array.isArray(data145)) {
                        if (data145.befund === void 0) {
                          const err370 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bema/" + i21, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bema/items/required", keyword: "required", params: { missingProperty: "befund" }, message: "must have required property 'befund'" };
                          if (vErrors === null) {
                            vErrors = [err370];
                          } else {
                            vErrors.push(err370);
                          }
                          errors++;
                        }
                        if (data145.nr === void 0) {
                          const err371 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bema/" + i21, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bema/items/required", keyword: "required", params: { missingProperty: "nr" }, message: "must have required property 'nr'" };
                          if (vErrors === null) {
                            vErrors = [err371];
                          } else {
                            vErrors.push(err371);
                          }
                          errors++;
                        }
                        if (data145.text === void 0) {
                          const err372 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bema/" + i21, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bema/items/required", keyword: "required", params: { missingProperty: "text" }, message: "must have required property 'text'" };
                          if (vErrors === null) {
                            vErrors = [err372];
                          } else {
                            vErrors.push(err372);
                          }
                          errors++;
                        }
                        if (data145.points === void 0) {
                          const err373 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bema/" + i21, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bema/items/required", keyword: "required", params: { missingProperty: "points" }, message: "must have required property 'points'" };
                          if (vErrors === null) {
                            vErrors = [err373];
                          } else {
                            vErrors.push(err373);
                          }
                          errors++;
                        }
                        if (data145.part === void 0) {
                          const err374 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bema/" + i21, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bema/items/required", keyword: "required", params: { missingProperty: "part" }, message: "must have required property 'part'" };
                          if (vErrors === null) {
                            vErrors = [err374];
                          } else {
                            vErrors.push(err374);
                          }
                          errors++;
                        }
                        if (data145.minus === void 0) {
                          const err375 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bema/" + i21, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bema/items/required", keyword: "required", params: { missingProperty: "minus" }, message: "must have required property 'minus'" };
                          if (vErrors === null) {
                            vErrors = [err375];
                          } else {
                            vErrors.push(err375);
                          }
                          errors++;
                        }
                        if (data145.quantity === void 0) {
                          const err376 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bema/" + i21, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bema/items/required", keyword: "required", params: { missingProperty: "quantity" }, message: "must have required property 'quantity'" };
                          if (vErrors === null) {
                            vErrors = [err376];
                          } else {
                            vErrors.push(err376);
                          }
                          errors++;
                        }
                        for (const key24 in data145) {
                          if (!func6.call(schema37.properties.costs.properties.luecken.items.properties.bema.items.properties, key24)) {
                            const err377 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bema/" + i21, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bema/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key24 }, message: "must NOT have additional properties" };
                            if (vErrors === null) {
                              vErrors = [err377];
                            } else {
                              vErrors.push(err377);
                            }
                            errors++;
                          }
                        }
                        if (data145.befund !== void 0) {
                          if (typeof data145.befund !== "string") {
                            const err378 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bema/" + i21 + "/befund", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bema/items/properties/befund/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err378];
                            } else {
                              vErrors.push(err378);
                            }
                            errors++;
                          }
                        }
                        if (data145.nr !== void 0) {
                          if (typeof data145.nr !== "string") {
                            const err379 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bema/" + i21 + "/nr", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bema/items/properties/nr/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err379];
                            } else {
                              vErrors.push(err379);
                            }
                            errors++;
                          }
                        }
                        if (data145.text !== void 0) {
                          if (typeof data145.text !== "string") {
                            const err380 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bema/" + i21 + "/text", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bema/items/properties/text/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err380];
                            } else {
                              vErrors.push(err380);
                            }
                            errors++;
                          }
                        }
                        if (data145.points !== void 0) {
                          let data149 = data145.points;
                          if (!(typeof data149 == "number" && (!(data149 % 1) && !isNaN(data149)) && isFinite(data149))) {
                            const err381 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bema/" + i21 + "/points", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bema/items/properties/points/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                            if (vErrors === null) {
                              vErrors = [err381];
                            } else {
                              vErrors.push(err381);
                            }
                            errors++;
                          }
                          if (typeof data149 == "number" && isFinite(data149)) {
                            if (data149 > 9007199254740991 || isNaN(data149)) {
                              const err382 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bema/" + i21 + "/points", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bema/items/properties/points/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err382];
                              } else {
                                vErrors.push(err382);
                              }
                              errors++;
                            }
                            if (data149 < -9007199254740991 || isNaN(data149)) {
                              const err383 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bema/" + i21 + "/points", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bema/items/properties/points/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err383];
                              } else {
                                vErrors.push(err383);
                              }
                              errors++;
                            }
                          }
                        }
                        if (data145.part !== void 0) {
                          if (typeof data145.part !== "string") {
                            const err384 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bema/" + i21 + "/part", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bema/items/properties/part/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err384];
                            } else {
                              vErrors.push(err384);
                            }
                            errors++;
                          }
                        }
                        if (data145.minus !== void 0) {
                          if (typeof data145.minus !== "boolean") {
                            const err385 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bema/" + i21 + "/minus", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bema/items/properties/minus/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                            if (vErrors === null) {
                              vErrors = [err385];
                            } else {
                              vErrors.push(err385);
                            }
                            errors++;
                          }
                        }
                        if (data145.quantity !== void 0) {
                          let data152 = data145.quantity;
                          const _errs336 = errors;
                          let valid71 = false;
                          const _errs337 = errors;
                          if (!(typeof data152 == "number" && (!(data152 % 1) && !isNaN(data152)) && isFinite(data152))) {
                            const err386 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bema/" + i21 + "/quantity", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bema/items/properties/quantity/anyOf/0/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                            if (vErrors === null) {
                              vErrors = [err386];
                            } else {
                              vErrors.push(err386);
                            }
                            errors++;
                          }
                          if (typeof data152 == "number" && isFinite(data152)) {
                            if (data152 > 9007199254740991 || isNaN(data152)) {
                              const err387 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bema/" + i21 + "/quantity", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bema/items/properties/quantity/anyOf/0/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err387];
                              } else {
                                vErrors.push(err387);
                              }
                              errors++;
                            }
                            if (data152 < -9007199254740991 || isNaN(data152)) {
                              const err388 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bema/" + i21 + "/quantity", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bema/items/properties/quantity/anyOf/0/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err388];
                              } else {
                                vErrors.push(err388);
                              }
                              errors++;
                            }
                          }
                          var _valid1 = _errs337 === errors;
                          valid71 = valid71 || _valid1;
                          if (!valid71) {
                            const _errs339 = errors;
                            if (data152 !== null) {
                              const err389 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bema/" + i21 + "/quantity", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bema/items/properties/quantity/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                              if (vErrors === null) {
                                vErrors = [err389];
                              } else {
                                vErrors.push(err389);
                              }
                              errors++;
                            }
                            var _valid1 = _errs339 === errors;
                            valid71 = valid71 || _valid1;
                          }
                          if (!valid71) {
                            const err390 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bema/" + i21 + "/quantity", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bema/items/properties/quantity/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                            if (vErrors === null) {
                              vErrors = [err390];
                            } else {
                              vErrors.push(err390);
                            }
                            errors++;
                          } else {
                            errors = _errs336;
                            if (vErrors !== null) {
                              if (_errs336) {
                                vErrors.length = _errs336;
                              } else {
                                vErrors = null;
                              }
                            }
                          }
                        }
                        if (data145.counted !== void 0) {
                          let data153 = data145.counted;
                          if (typeof data153 !== "boolean") {
                            const err391 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bema/" + i21 + "/counted", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bema/items/properties/counted/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                            if (vErrors === null) {
                              vErrors = [err391];
                            } else {
                              vErrors.push(err391);
                            }
                            errors++;
                          }
                          if (true !== data153) {
                            const err392 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bema/" + i21 + "/counted", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bema/items/properties/counted/const", keyword: "const", params: { allowedValue: true }, message: "must be equal to constant" };
                            if (vErrors === null) {
                              vErrors = [err392];
                            } else {
                              vErrors.push(err392);
                            }
                            errors++;
                          }
                        }
                        if (data145.cents !== void 0) {
                          let data154 = data145.cents;
                          if (!(typeof data154 == "number" && (!(data154 % 1) && !isNaN(data154)) && isFinite(data154))) {
                            const err393 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bema/" + i21 + "/cents", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bema/items/properties/cents/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                            if (vErrors === null) {
                              vErrors = [err393];
                            } else {
                              vErrors.push(err393);
                            }
                            errors++;
                          }
                          if (typeof data154 == "number" && isFinite(data154)) {
                            if (data154 > 9007199254740991 || isNaN(data154)) {
                              const err394 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bema/" + i21 + "/cents", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bema/items/properties/cents/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err394];
                              } else {
                                vErrors.push(err394);
                              }
                              errors++;
                            }
                            if (data154 < -9007199254740991 || isNaN(data154)) {
                              const err395 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bema/" + i21 + "/cents", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bema/items/properties/cents/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err395];
                              } else {
                                vErrors.push(err395);
                              }
                              errors++;
                            }
                          }
                        }
                        if (data145.excluded !== void 0) {
                          if (typeof data145.excluded !== "string") {
                            const err396 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bema/" + i21 + "/excluded", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bema/items/properties/excluded/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err396];
                            } else {
                              vErrors.push(err396);
                            }
                            errors++;
                          }
                        }
                        if (data145.source !== void 0) {
                          let data156 = data145.source;
                          if (data156 && typeof data156 == "object" && !Array.isArray(data156)) {
                            if (data156.chunkId === void 0) {
                              const err397 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bema/" + i21 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bema/items/properties/source/required", keyword: "required", params: { missingProperty: "chunkId" }, message: "must have required property 'chunkId'" };
                              if (vErrors === null) {
                                vErrors = [err397];
                              } else {
                                vErrors.push(err397);
                              }
                              errors++;
                            }
                            if (data156.title === void 0) {
                              const err398 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bema/" + i21 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bema/items/properties/source/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
                              if (vErrors === null) {
                                vErrors = [err398];
                              } else {
                                vErrors.push(err398);
                              }
                              errors++;
                            }
                            if (data156.url === void 0) {
                              const err399 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bema/" + i21 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bema/items/properties/source/required", keyword: "required", params: { missingProperty: "url" }, message: "must have required property 'url'" };
                              if (vErrors === null) {
                                vErrors = [err399];
                              } else {
                                vErrors.push(err399);
                              }
                              errors++;
                            }
                            for (const key25 in data156) {
                              if (!(key25 === "chunkId" || key25 === "title" || key25 === "url" || key25 === "page")) {
                                const err400 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bema/" + i21 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bema/items/properties/source/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key25 }, message: "must NOT have additional properties" };
                                if (vErrors === null) {
                                  vErrors = [err400];
                                } else {
                                  vErrors.push(err400);
                                }
                                errors++;
                              }
                            }
                            if (data156.chunkId !== void 0) {
                              if (typeof data156.chunkId !== "string") {
                                const err401 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bema/" + i21 + "/source/chunkId", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bema/items/properties/source/properties/chunkId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err401];
                                } else {
                                  vErrors.push(err401);
                                }
                                errors++;
                              }
                            }
                            if (data156.title !== void 0) {
                              if (typeof data156.title !== "string") {
                                const err402 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bema/" + i21 + "/source/title", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bema/items/properties/source/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err402];
                                } else {
                                  vErrors.push(err402);
                                }
                                errors++;
                              }
                            }
                            if (data156.url !== void 0) {
                              if (typeof data156.url !== "string") {
                                const err403 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bema/" + i21 + "/source/url", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bema/items/properties/source/properties/url/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err403];
                                } else {
                                  vErrors.push(err403);
                                }
                                errors++;
                              }
                            }
                            if (data156.page !== void 0) {
                              let data160 = data156.page;
                              if (!(typeof data160 == "number" && (!(data160 % 1) && !isNaN(data160)) && isFinite(data160))) {
                                const err404 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bema/" + i21 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bema/items/properties/source/properties/page/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                if (vErrors === null) {
                                  vErrors = [err404];
                                } else {
                                  vErrors.push(err404);
                                }
                                errors++;
                              }
                              if (typeof data160 == "number" && isFinite(data160)) {
                                if (data160 > 9007199254740991 || isNaN(data160)) {
                                  const err405 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bema/" + i21 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bema/items/properties/source/properties/page/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                                  if (vErrors === null) {
                                    vErrors = [err405];
                                  } else {
                                    vErrors.push(err405);
                                  }
                                  errors++;
                                }
                                if (data160 < -9007199254740991 || isNaN(data160)) {
                                  const err406 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bema/" + i21 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bema/items/properties/source/properties/page/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                                  if (vErrors === null) {
                                    vErrors = [err406];
                                  } else {
                                    vErrors.push(err406);
                                  }
                                  errors++;
                                }
                              }
                            }
                          } else {
                            const err407 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bema/" + i21 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bema/items/properties/source/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                            if (vErrors === null) {
                              vErrors = [err407];
                            } else {
                              vErrors.push(err407);
                            }
                            errors++;
                          }
                        }
                      } else {
                        const err408 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bema/" + i21, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bema/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                        if (vErrors === null) {
                          vErrors = [err408];
                        } else {
                          vErrors.push(err408);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err409 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bema", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bema/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                      vErrors = [err409];
                    } else {
                      vErrors.push(err409);
                    }
                    errors++;
                  }
                }
                if (data136.hkp !== void 0) {
                  let data161 = data136.hkp;
                  if (Array.isArray(data161)) {
                    const len22 = data161.length;
                    for (let i22 = 0; i22 < len22; i22++) {
                      let data162 = data161[i22];
                      if (data162 && typeof data162 == "object" && !Array.isArray(data162)) {
                        if (data162.nr === void 0) {
                          const err410 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/hkp/" + i22, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/hkp/items/required", keyword: "required", params: { missingProperty: "nr" }, message: "must have required property 'nr'" };
                          if (vErrors === null) {
                            vErrors = [err410];
                          } else {
                            vErrors.push(err410);
                          }
                          errors++;
                        }
                        if (data162.text === void 0) {
                          const err411 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/hkp/" + i22, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/hkp/items/required", keyword: "required", params: { missingProperty: "text" }, message: "must have required property 'text'" };
                          if (vErrors === null) {
                            vErrors = [err411];
                          } else {
                            vErrors.push(err411);
                          }
                          errors++;
                        }
                        if (data162.befunde === void 0) {
                          const err412 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/hkp/" + i22, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/hkp/items/required", keyword: "required", params: { missingProperty: "befunde" }, message: "must have required property 'befunde'" };
                          if (vErrors === null) {
                            vErrors = [err412];
                          } else {
                            vErrors.push(err412);
                          }
                          errors++;
                        }
                        if (data162.quantity === void 0) {
                          const err413 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/hkp/" + i22, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/hkp/items/required", keyword: "required", params: { missingProperty: "quantity" }, message: "must have required property 'quantity'" };
                          if (vErrors === null) {
                            vErrors = [err413];
                          } else {
                            vErrors.push(err413);
                          }
                          errors++;
                        }
                        if (data162.counted === void 0) {
                          const err414 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/hkp/" + i22, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/hkp/items/required", keyword: "required", params: { missingProperty: "counted" }, message: "must have required property 'counted'" };
                          if (vErrors === null) {
                            vErrors = [err414];
                          } else {
                            vErrors.push(err414);
                          }
                          errors++;
                        }
                        for (const key26 in data162) {
                          if (!(key26 === "nr" || key26 === "text" || key26 === "befunde" || key26 === "quantity" || key26 === "counted" || key26 === "cents" || key26 === "source")) {
                            const err415 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/hkp/" + i22, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/hkp/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key26 }, message: "must NOT have additional properties" };
                            if (vErrors === null) {
                              vErrors = [err415];
                            } else {
                              vErrors.push(err415);
                            }
                            errors++;
                          }
                        }
                        if (data162.nr !== void 0) {
                          if (typeof data162.nr !== "string") {
                            const err416 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/hkp/" + i22 + "/nr", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/hkp/items/properties/nr/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err416];
                            } else {
                              vErrors.push(err416);
                            }
                            errors++;
                          }
                        }
                        if (data162.text !== void 0) {
                          if (typeof data162.text !== "string") {
                            const err417 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/hkp/" + i22 + "/text", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/hkp/items/properties/text/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err417];
                            } else {
                              vErrors.push(err417);
                            }
                            errors++;
                          }
                        }
                        if (data162.befunde !== void 0) {
                          if (typeof data162.befunde !== "string") {
                            const err418 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/hkp/" + i22 + "/befunde", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/hkp/items/properties/befunde/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err418];
                            } else {
                              vErrors.push(err418);
                            }
                            errors++;
                          }
                        }
                        if (data162.quantity !== void 0) {
                          let data166 = data162.quantity;
                          if (!(typeof data166 == "number" && (!(data166 % 1) && !isNaN(data166)) && isFinite(data166))) {
                            const err419 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/hkp/" + i22 + "/quantity", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/hkp/items/properties/quantity/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                            if (vErrors === null) {
                              vErrors = [err419];
                            } else {
                              vErrors.push(err419);
                            }
                            errors++;
                          }
                          if (typeof data166 == "number" && isFinite(data166)) {
                            if (data166 > 9007199254740991 || isNaN(data166)) {
                              const err420 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/hkp/" + i22 + "/quantity", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/hkp/items/properties/quantity/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err420];
                              } else {
                                vErrors.push(err420);
                              }
                              errors++;
                            }
                            if (data166 < -9007199254740991 || isNaN(data166)) {
                              const err421 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/hkp/" + i22 + "/quantity", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/hkp/items/properties/quantity/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err421];
                              } else {
                                vErrors.push(err421);
                              }
                              errors++;
                            }
                          }
                        }
                        if (data162.counted !== void 0) {
                          let data167 = data162.counted;
                          if (typeof data167 !== "string") {
                            const err422 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/hkp/" + i22 + "/counted", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/hkp/items/properties/counted/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err422];
                            } else {
                              vErrors.push(err422);
                            }
                            errors++;
                          }
                          if (!(data167 === "bema" || data167 === "dentist" || data167 === "assumed")) {
                            const err423 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/hkp/" + i22 + "/counted", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/hkp/items/properties/counted/enum", keyword: "enum", params: { allowedValues: schema37.properties.costs.properties.luecken.items.properties.hkp.items.properties.counted.enum }, message: "must be equal to one of the allowed values" };
                            if (vErrors === null) {
                              vErrors = [err423];
                            } else {
                              vErrors.push(err423);
                            }
                            errors++;
                          }
                        }
                        if (data162.cents !== void 0) {
                          let data168 = data162.cents;
                          if (!(typeof data168 == "number" && (!(data168 % 1) && !isNaN(data168)) && isFinite(data168))) {
                            const err424 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/hkp/" + i22 + "/cents", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/hkp/items/properties/cents/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                            if (vErrors === null) {
                              vErrors = [err424];
                            } else {
                              vErrors.push(err424);
                            }
                            errors++;
                          }
                          if (typeof data168 == "number" && isFinite(data168)) {
                            if (data168 > 9007199254740991 || isNaN(data168)) {
                              const err425 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/hkp/" + i22 + "/cents", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/hkp/items/properties/cents/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err425];
                              } else {
                                vErrors.push(err425);
                              }
                              errors++;
                            }
                            if (data168 < -9007199254740991 || isNaN(data168)) {
                              const err426 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/hkp/" + i22 + "/cents", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/hkp/items/properties/cents/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err426];
                              } else {
                                vErrors.push(err426);
                              }
                              errors++;
                            }
                          }
                        }
                        if (data162.source !== void 0) {
                          let data169 = data162.source;
                          if (data169 && typeof data169 == "object" && !Array.isArray(data169)) {
                            if (data169.chunkId === void 0) {
                              const err427 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/hkp/" + i22 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/hkp/items/properties/source/required", keyword: "required", params: { missingProperty: "chunkId" }, message: "must have required property 'chunkId'" };
                              if (vErrors === null) {
                                vErrors = [err427];
                              } else {
                                vErrors.push(err427);
                              }
                              errors++;
                            }
                            if (data169.title === void 0) {
                              const err428 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/hkp/" + i22 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/hkp/items/properties/source/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
                              if (vErrors === null) {
                                vErrors = [err428];
                              } else {
                                vErrors.push(err428);
                              }
                              errors++;
                            }
                            if (data169.url === void 0) {
                              const err429 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/hkp/" + i22 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/hkp/items/properties/source/required", keyword: "required", params: { missingProperty: "url" }, message: "must have required property 'url'" };
                              if (vErrors === null) {
                                vErrors = [err429];
                              } else {
                                vErrors.push(err429);
                              }
                              errors++;
                            }
                            for (const key27 in data169) {
                              if (!(key27 === "chunkId" || key27 === "title" || key27 === "url" || key27 === "page")) {
                                const err430 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/hkp/" + i22 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/hkp/items/properties/source/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key27 }, message: "must NOT have additional properties" };
                                if (vErrors === null) {
                                  vErrors = [err430];
                                } else {
                                  vErrors.push(err430);
                                }
                                errors++;
                              }
                            }
                            if (data169.chunkId !== void 0) {
                              if (typeof data169.chunkId !== "string") {
                                const err431 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/hkp/" + i22 + "/source/chunkId", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/hkp/items/properties/source/properties/chunkId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err431];
                                } else {
                                  vErrors.push(err431);
                                }
                                errors++;
                              }
                            }
                            if (data169.title !== void 0) {
                              if (typeof data169.title !== "string") {
                                const err432 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/hkp/" + i22 + "/source/title", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/hkp/items/properties/source/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err432];
                                } else {
                                  vErrors.push(err432);
                                }
                                errors++;
                              }
                            }
                            if (data169.url !== void 0) {
                              if (typeof data169.url !== "string") {
                                const err433 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/hkp/" + i22 + "/source/url", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/hkp/items/properties/source/properties/url/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err433];
                                } else {
                                  vErrors.push(err433);
                                }
                                errors++;
                              }
                            }
                            if (data169.page !== void 0) {
                              let data173 = data169.page;
                              if (!(typeof data173 == "number" && (!(data173 % 1) && !isNaN(data173)) && isFinite(data173))) {
                                const err434 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/hkp/" + i22 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/hkp/items/properties/source/properties/page/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                if (vErrors === null) {
                                  vErrors = [err434];
                                } else {
                                  vErrors.push(err434);
                                }
                                errors++;
                              }
                              if (typeof data173 == "number" && isFinite(data173)) {
                                if (data173 > 9007199254740991 || isNaN(data173)) {
                                  const err435 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/hkp/" + i22 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/hkp/items/properties/source/properties/page/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                                  if (vErrors === null) {
                                    vErrors = [err435];
                                  } else {
                                    vErrors.push(err435);
                                  }
                                  errors++;
                                }
                                if (data173 < -9007199254740991 || isNaN(data173)) {
                                  const err436 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/hkp/" + i22 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/hkp/items/properties/source/properties/page/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                                  if (vErrors === null) {
                                    vErrors = [err436];
                                  } else {
                                    vErrors.push(err436);
                                  }
                                  errors++;
                                }
                              }
                            }
                          } else {
                            const err437 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/hkp/" + i22 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/hkp/items/properties/source/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                            if (vErrors === null) {
                              vErrors = [err437];
                            } else {
                              vErrors.push(err437);
                            }
                            errors++;
                          }
                        }
                      } else {
                        const err438 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/hkp/" + i22, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/hkp/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                        if (vErrors === null) {
                          vErrors = [err438];
                        } else {
                          vErrors.push(err438);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err439 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/hkp", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/hkp/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                      vErrors = [err439];
                    } else {
                      vErrors.push(err439);
                    }
                    errors++;
                  }
                }
                if (data136.bel !== void 0) {
                  let data174 = data136.bel;
                  if (Array.isArray(data174)) {
                    const len23 = data174.length;
                    for (let i23 = 0; i23 < len23; i23++) {
                      let data175 = data174[i23];
                      if (data175 && typeof data175 == "object" && !Array.isArray(data175)) {
                        if (data175.befund === void 0) {
                          const err440 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bel/" + i23, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bel/items/required", keyword: "required", params: { missingProperty: "befund" }, message: "must have required property 'befund'" };
                          if (vErrors === null) {
                            vErrors = [err440];
                          } else {
                            vErrors.push(err440);
                          }
                          errors++;
                        }
                        if (data175.nr === void 0) {
                          const err441 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bel/" + i23, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bel/items/required", keyword: "required", params: { missingProperty: "nr" }, message: "must have required property 'nr'" };
                          if (vErrors === null) {
                            vErrors = [err441];
                          } else {
                            vErrors.push(err441);
                          }
                          errors++;
                        }
                        if (data175.text === void 0) {
                          const err442 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bel/" + i23, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bel/items/required", keyword: "required", params: { missingProperty: "text" }, message: "must have required property 'text'" };
                          if (vErrors === null) {
                            vErrors = [err442];
                          } else {
                            vErrors.push(err442);
                          }
                          errors++;
                        }
                        if (data175.minus === void 0) {
                          const err443 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bel/" + i23, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bel/items/required", keyword: "required", params: { missingProperty: "minus" }, message: "must have required property 'minus'" };
                          if (vErrors === null) {
                            vErrors = [err443];
                          } else {
                            vErrors.push(err443);
                          }
                          errors++;
                        }
                        for (const key28 in data175) {
                          if (!(key28 === "befund" || key28 === "nr" || key28 === "text" || key28 === "minus" || key28 === "source")) {
                            const err444 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bel/" + i23, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bel/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key28 }, message: "must NOT have additional properties" };
                            if (vErrors === null) {
                              vErrors = [err444];
                            } else {
                              vErrors.push(err444);
                            }
                            errors++;
                          }
                        }
                        if (data175.befund !== void 0) {
                          if (typeof data175.befund !== "string") {
                            const err445 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bel/" + i23 + "/befund", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bel/items/properties/befund/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err445];
                            } else {
                              vErrors.push(err445);
                            }
                            errors++;
                          }
                        }
                        if (data175.nr !== void 0) {
                          if (typeof data175.nr !== "string") {
                            const err446 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bel/" + i23 + "/nr", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bel/items/properties/nr/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err446];
                            } else {
                              vErrors.push(err446);
                            }
                            errors++;
                          }
                        }
                        if (data175.text !== void 0) {
                          if (typeof data175.text !== "string") {
                            const err447 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bel/" + i23 + "/text", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bel/items/properties/text/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err447];
                            } else {
                              vErrors.push(err447);
                            }
                            errors++;
                          }
                        }
                        if (data175.minus !== void 0) {
                          if (typeof data175.minus !== "boolean") {
                            const err448 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bel/" + i23 + "/minus", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bel/items/properties/minus/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                            if (vErrors === null) {
                              vErrors = [err448];
                            } else {
                              vErrors.push(err448);
                            }
                            errors++;
                          }
                        }
                        if (data175.source !== void 0) {
                          let data180 = data175.source;
                          if (data180 && typeof data180 == "object" && !Array.isArray(data180)) {
                            if (data180.chunkId === void 0) {
                              const err449 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bel/" + i23 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bel/items/properties/source/required", keyword: "required", params: { missingProperty: "chunkId" }, message: "must have required property 'chunkId'" };
                              if (vErrors === null) {
                                vErrors = [err449];
                              } else {
                                vErrors.push(err449);
                              }
                              errors++;
                            }
                            if (data180.title === void 0) {
                              const err450 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bel/" + i23 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bel/items/properties/source/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
                              if (vErrors === null) {
                                vErrors = [err450];
                              } else {
                                vErrors.push(err450);
                              }
                              errors++;
                            }
                            if (data180.url === void 0) {
                              const err451 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bel/" + i23 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bel/items/properties/source/required", keyword: "required", params: { missingProperty: "url" }, message: "must have required property 'url'" };
                              if (vErrors === null) {
                                vErrors = [err451];
                              } else {
                                vErrors.push(err451);
                              }
                              errors++;
                            }
                            for (const key29 in data180) {
                              if (!(key29 === "chunkId" || key29 === "title" || key29 === "url" || key29 === "page")) {
                                const err452 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bel/" + i23 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bel/items/properties/source/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key29 }, message: "must NOT have additional properties" };
                                if (vErrors === null) {
                                  vErrors = [err452];
                                } else {
                                  vErrors.push(err452);
                                }
                                errors++;
                              }
                            }
                            if (data180.chunkId !== void 0) {
                              if (typeof data180.chunkId !== "string") {
                                const err453 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bel/" + i23 + "/source/chunkId", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bel/items/properties/source/properties/chunkId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err453];
                                } else {
                                  vErrors.push(err453);
                                }
                                errors++;
                              }
                            }
                            if (data180.title !== void 0) {
                              if (typeof data180.title !== "string") {
                                const err454 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bel/" + i23 + "/source/title", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bel/items/properties/source/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err454];
                                } else {
                                  vErrors.push(err454);
                                }
                                errors++;
                              }
                            }
                            if (data180.url !== void 0) {
                              if (typeof data180.url !== "string") {
                                const err455 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bel/" + i23 + "/source/url", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bel/items/properties/source/properties/url/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err455];
                                } else {
                                  vErrors.push(err455);
                                }
                                errors++;
                              }
                            }
                            if (data180.page !== void 0) {
                              let data184 = data180.page;
                              if (!(typeof data184 == "number" && (!(data184 % 1) && !isNaN(data184)) && isFinite(data184))) {
                                const err456 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bel/" + i23 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bel/items/properties/source/properties/page/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                if (vErrors === null) {
                                  vErrors = [err456];
                                } else {
                                  vErrors.push(err456);
                                }
                                errors++;
                              }
                              if (typeof data184 == "number" && isFinite(data184)) {
                                if (data184 > 9007199254740991 || isNaN(data184)) {
                                  const err457 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bel/" + i23 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bel/items/properties/source/properties/page/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                                  if (vErrors === null) {
                                    vErrors = [err457];
                                  } else {
                                    vErrors.push(err457);
                                  }
                                  errors++;
                                }
                                if (data184 < -9007199254740991 || isNaN(data184)) {
                                  const err458 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bel/" + i23 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bel/items/properties/source/properties/page/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                                  if (vErrors === null) {
                                    vErrors = [err458];
                                  } else {
                                    vErrors.push(err458);
                                  }
                                  errors++;
                                }
                              }
                            }
                          } else {
                            const err459 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bel/" + i23 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bel/items/properties/source/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                            if (vErrors === null) {
                              vErrors = [err459];
                            } else {
                              vErrors.push(err459);
                            }
                            errors++;
                          }
                        }
                      } else {
                        const err460 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bel/" + i23, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bel/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                        if (vErrors === null) {
                          vErrors = [err460];
                        } else {
                          vErrors.push(err460);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err461 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/bel", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/bel/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                      vErrors = [err461];
                    } else {
                      vErrors.push(err461);
                    }
                    errors++;
                  }
                }
                if (data136.materials !== void 0) {
                  let data185 = data136.materials;
                  if (Array.isArray(data185)) {
                    const len24 = data185.length;
                    for (let i24 = 0; i24 < len24; i24++) {
                      let data186 = data185[i24];
                      if (data186 && typeof data186 == "object" && !Array.isArray(data186)) {
                        if (data186.befund === void 0) {
                          const err462 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/materials/" + i24, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/materials/items/required", keyword: "required", params: { missingProperty: "befund" }, message: "must have required property 'befund'" };
                          if (vErrors === null) {
                            vErrors = [err462];
                          } else {
                            vErrors.push(err462);
                          }
                          errors++;
                        }
                        if (data186.name === void 0) {
                          const err463 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/materials/" + i24, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/materials/items/required", keyword: "required", params: { missingProperty: "name" }, message: "must have required property 'name'" };
                          if (vErrors === null) {
                            vErrors = [err463];
                          } else {
                            vErrors.push(err463);
                          }
                          errors++;
                        }
                        for (const key30 in data186) {
                          if (!(key30 === "befund" || key30 === "name" || key30 === "source")) {
                            const err464 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/materials/" + i24, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/materials/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key30 }, message: "must NOT have additional properties" };
                            if (vErrors === null) {
                              vErrors = [err464];
                            } else {
                              vErrors.push(err464);
                            }
                            errors++;
                          }
                        }
                        if (data186.befund !== void 0) {
                          if (typeof data186.befund !== "string") {
                            const err465 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/materials/" + i24 + "/befund", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/materials/items/properties/befund/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err465];
                            } else {
                              vErrors.push(err465);
                            }
                            errors++;
                          }
                        }
                        if (data186.name !== void 0) {
                          if (typeof data186.name !== "string") {
                            const err466 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/materials/" + i24 + "/name", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/materials/items/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err466];
                            } else {
                              vErrors.push(err466);
                            }
                            errors++;
                          }
                        }
                        if (data186.source !== void 0) {
                          let data189 = data186.source;
                          if (data189 && typeof data189 == "object" && !Array.isArray(data189)) {
                            if (data189.chunkId === void 0) {
                              const err467 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/materials/" + i24 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/materials/items/properties/source/required", keyword: "required", params: { missingProperty: "chunkId" }, message: "must have required property 'chunkId'" };
                              if (vErrors === null) {
                                vErrors = [err467];
                              } else {
                                vErrors.push(err467);
                              }
                              errors++;
                            }
                            if (data189.title === void 0) {
                              const err468 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/materials/" + i24 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/materials/items/properties/source/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
                              if (vErrors === null) {
                                vErrors = [err468];
                              } else {
                                vErrors.push(err468);
                              }
                              errors++;
                            }
                            if (data189.url === void 0) {
                              const err469 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/materials/" + i24 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/materials/items/properties/source/required", keyword: "required", params: { missingProperty: "url" }, message: "must have required property 'url'" };
                              if (vErrors === null) {
                                vErrors = [err469];
                              } else {
                                vErrors.push(err469);
                              }
                              errors++;
                            }
                            for (const key31 in data189) {
                              if (!(key31 === "chunkId" || key31 === "title" || key31 === "url" || key31 === "page")) {
                                const err470 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/materials/" + i24 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/materials/items/properties/source/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key31 }, message: "must NOT have additional properties" };
                                if (vErrors === null) {
                                  vErrors = [err470];
                                } else {
                                  vErrors.push(err470);
                                }
                                errors++;
                              }
                            }
                            if (data189.chunkId !== void 0) {
                              if (typeof data189.chunkId !== "string") {
                                const err471 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/materials/" + i24 + "/source/chunkId", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/materials/items/properties/source/properties/chunkId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err471];
                                } else {
                                  vErrors.push(err471);
                                }
                                errors++;
                              }
                            }
                            if (data189.title !== void 0) {
                              if (typeof data189.title !== "string") {
                                const err472 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/materials/" + i24 + "/source/title", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/materials/items/properties/source/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err472];
                                } else {
                                  vErrors.push(err472);
                                }
                                errors++;
                              }
                            }
                            if (data189.url !== void 0) {
                              if (typeof data189.url !== "string") {
                                const err473 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/materials/" + i24 + "/source/url", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/materials/items/properties/source/properties/url/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err473];
                                } else {
                                  vErrors.push(err473);
                                }
                                errors++;
                              }
                            }
                            if (data189.page !== void 0) {
                              let data193 = data189.page;
                              if (!(typeof data193 == "number" && (!(data193 % 1) && !isNaN(data193)) && isFinite(data193))) {
                                const err474 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/materials/" + i24 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/materials/items/properties/source/properties/page/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                if (vErrors === null) {
                                  vErrors = [err474];
                                } else {
                                  vErrors.push(err474);
                                }
                                errors++;
                              }
                              if (typeof data193 == "number" && isFinite(data193)) {
                                if (data193 > 9007199254740991 || isNaN(data193)) {
                                  const err475 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/materials/" + i24 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/materials/items/properties/source/properties/page/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                                  if (vErrors === null) {
                                    vErrors = [err475];
                                  } else {
                                    vErrors.push(err475);
                                  }
                                  errors++;
                                }
                                if (data193 < -9007199254740991 || isNaN(data193)) {
                                  const err476 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/materials/" + i24 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/materials/items/properties/source/properties/page/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                                  if (vErrors === null) {
                                    vErrors = [err476];
                                  } else {
                                    vErrors.push(err476);
                                  }
                                  errors++;
                                }
                              }
                            }
                          } else {
                            const err477 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/materials/" + i24 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/materials/items/properties/source/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                            if (vErrors === null) {
                              vErrors = [err477];
                            } else {
                              vErrors.push(err477);
                            }
                            errors++;
                          }
                        }
                      } else {
                        const err478 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/materials/" + i24, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/materials/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                        if (vErrors === null) {
                          vErrors = [err478];
                        } else {
                          vErrors.push(err478);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err479 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/materials", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/materials/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                      vErrors = [err479];
                    } else {
                      vErrors.push(err479);
                    }
                    errors++;
                  }
                }
                if (data136.labor !== void 0) {
                  let data194 = data136.labor;
                  if (!(typeof data194 == "number" && (!(data194 % 1) && !isNaN(data194)) && isFinite(data194))) {
                    const err480 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/labor", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/labor/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err480];
                    } else {
                      vErrors.push(err480);
                    }
                    errors++;
                  }
                  if (typeof data194 == "number" && isFinite(data194)) {
                    if (data194 > 9007199254740991 || isNaN(data194)) {
                      const err481 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/labor", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/labor/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err481];
                      } else {
                        vErrors.push(err481);
                      }
                      errors++;
                    }
                    if (data194 < -9007199254740991 || isNaN(data194)) {
                      const err482 = { instancePath: instancePath + "/costs/luecken/" + i18 + "/labor", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/properties/labor/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err482];
                      } else {
                        vErrors.push(err482);
                      }
                      errors++;
                    }
                  }
                }
              } else {
                const err483 = { instancePath: instancePath + "/costs/luecken/" + i18, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                if (vErrors === null) {
                  vErrors = [err483];
                } else {
                  vErrors.push(err483);
                }
                errors++;
              }
            }
          } else {
            const err484 = { instancePath: instancePath + "/costs/luecken", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/luecken/type", keyword: "type", params: { type: "array" }, message: "must be array" };
            if (vErrors === null) {
              vErrors = [err484];
            } else {
              vErrors.push(err484);
            }
            errors++;
          }
        }
        if (data64.places !== void 0) {
          let data195 = data64.places;
          if (Array.isArray(data195)) {
            const len25 = data195.length;
            for (let i25 = 0; i25 < len25; i25++) {
              let data196 = data195[i25];
              if (data196 && typeof data196 == "object" && !Array.isArray(data196)) {
                if (data196.place === void 0) {
                  const err485 = { instancePath: instancePath + "/costs/places/" + i25, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/required", keyword: "required", params: { missingProperty: "place" }, message: "must have required property 'place'" };
                  if (vErrors === null) {
                    vErrors = [err485];
                  } else {
                    vErrors.push(err485);
                  }
                  errors++;
                }
                if (data196.bema === void 0) {
                  const err486 = { instancePath: instancePath + "/costs/places/" + i25, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/required", keyword: "required", params: { missingProperty: "bema" }, message: "must have required property 'bema'" };
                  if (vErrors === null) {
                    vErrors = [err486];
                  } else {
                    vErrors.push(err486);
                  }
                  errors++;
                }
                if (data196.hkp === void 0) {
                  const err487 = { instancePath: instancePath + "/costs/places/" + i25, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/required", keyword: "required", params: { missingProperty: "hkp" }, message: "must have required property 'hkp'" };
                  if (vErrors === null) {
                    vErrors = [err487];
                  } else {
                    vErrors.push(err487);
                  }
                  errors++;
                }
                for (const key32 in data196) {
                  if (!(key32 === "place" || key32 === "bema" || key32 === "hkp")) {
                    const err488 = { instancePath: instancePath + "/costs/places/" + i25, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key32 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                      vErrors = [err488];
                    } else {
                      vErrors.push(err488);
                    }
                    errors++;
                  }
                }
                if (data196.place !== void 0) {
                  let data197 = data196.place;
                  if (typeof data197 !== "string") {
                    const err489 = { instancePath: instancePath + "/costs/places/" + i25 + "/place", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/place/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err489];
                    } else {
                      vErrors.push(err489);
                    }
                    errors++;
                  }
                  if (!(data197 === "OK" || data197 === "UK" || data197 === "patient")) {
                    const err490 = { instancePath: instancePath + "/costs/places/" + i25 + "/place", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/place/enum", keyword: "enum", params: { allowedValues: schema37.properties.costs.properties.places.items.properties.place.enum }, message: "must be equal to one of the allowed values" };
                    if (vErrors === null) {
                      vErrors = [err490];
                    } else {
                      vErrors.push(err490);
                    }
                    errors++;
                  }
                }
                if (data196.bema !== void 0) {
                  let data198 = data196.bema;
                  if (Array.isArray(data198)) {
                    const len26 = data198.length;
                    for (let i26 = 0; i26 < len26; i26++) {
                      let data199 = data198[i26];
                      if (data199 && typeof data199 == "object" && !Array.isArray(data199)) {
                        if (data199.befund === void 0) {
                          const err491 = { instancePath: instancePath + "/costs/places/" + i25 + "/bema/" + i26, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/bema/items/required", keyword: "required", params: { missingProperty: "befund" }, message: "must have required property 'befund'" };
                          if (vErrors === null) {
                            vErrors = [err491];
                          } else {
                            vErrors.push(err491);
                          }
                          errors++;
                        }
                        if (data199.nr === void 0) {
                          const err492 = { instancePath: instancePath + "/costs/places/" + i25 + "/bema/" + i26, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/bema/items/required", keyword: "required", params: { missingProperty: "nr" }, message: "must have required property 'nr'" };
                          if (vErrors === null) {
                            vErrors = [err492];
                          } else {
                            vErrors.push(err492);
                          }
                          errors++;
                        }
                        if (data199.text === void 0) {
                          const err493 = { instancePath: instancePath + "/costs/places/" + i25 + "/bema/" + i26, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/bema/items/required", keyword: "required", params: { missingProperty: "text" }, message: "must have required property 'text'" };
                          if (vErrors === null) {
                            vErrors = [err493];
                          } else {
                            vErrors.push(err493);
                          }
                          errors++;
                        }
                        if (data199.points === void 0) {
                          const err494 = { instancePath: instancePath + "/costs/places/" + i25 + "/bema/" + i26, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/bema/items/required", keyword: "required", params: { missingProperty: "points" }, message: "must have required property 'points'" };
                          if (vErrors === null) {
                            vErrors = [err494];
                          } else {
                            vErrors.push(err494);
                          }
                          errors++;
                        }
                        if (data199.part === void 0) {
                          const err495 = { instancePath: instancePath + "/costs/places/" + i25 + "/bema/" + i26, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/bema/items/required", keyword: "required", params: { missingProperty: "part" }, message: "must have required property 'part'" };
                          if (vErrors === null) {
                            vErrors = [err495];
                          } else {
                            vErrors.push(err495);
                          }
                          errors++;
                        }
                        if (data199.minus === void 0) {
                          const err496 = { instancePath: instancePath + "/costs/places/" + i25 + "/bema/" + i26, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/bema/items/required", keyword: "required", params: { missingProperty: "minus" }, message: "must have required property 'minus'" };
                          if (vErrors === null) {
                            vErrors = [err496];
                          } else {
                            vErrors.push(err496);
                          }
                          errors++;
                        }
                        if (data199.quantity === void 0) {
                          const err497 = { instancePath: instancePath + "/costs/places/" + i25 + "/bema/" + i26, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/bema/items/required", keyword: "required", params: { missingProperty: "quantity" }, message: "must have required property 'quantity'" };
                          if (vErrors === null) {
                            vErrors = [err497];
                          } else {
                            vErrors.push(err497);
                          }
                          errors++;
                        }
                        for (const key33 in data199) {
                          if (!func6.call(schema37.properties.costs.properties.places.items.properties.bema.items.properties, key33)) {
                            const err498 = { instancePath: instancePath + "/costs/places/" + i25 + "/bema/" + i26, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/bema/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key33 }, message: "must NOT have additional properties" };
                            if (vErrors === null) {
                              vErrors = [err498];
                            } else {
                              vErrors.push(err498);
                            }
                            errors++;
                          }
                        }
                        if (data199.befund !== void 0) {
                          if (typeof data199.befund !== "string") {
                            const err499 = { instancePath: instancePath + "/costs/places/" + i25 + "/bema/" + i26 + "/befund", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/bema/items/properties/befund/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err499];
                            } else {
                              vErrors.push(err499);
                            }
                            errors++;
                          }
                        }
                        if (data199.nr !== void 0) {
                          if (typeof data199.nr !== "string") {
                            const err500 = { instancePath: instancePath + "/costs/places/" + i25 + "/bema/" + i26 + "/nr", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/bema/items/properties/nr/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err500];
                            } else {
                              vErrors.push(err500);
                            }
                            errors++;
                          }
                        }
                        if (data199.text !== void 0) {
                          if (typeof data199.text !== "string") {
                            const err501 = { instancePath: instancePath + "/costs/places/" + i25 + "/bema/" + i26 + "/text", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/bema/items/properties/text/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err501];
                            } else {
                              vErrors.push(err501);
                            }
                            errors++;
                          }
                        }
                        if (data199.points !== void 0) {
                          let data203 = data199.points;
                          if (!(typeof data203 == "number" && (!(data203 % 1) && !isNaN(data203)) && isFinite(data203))) {
                            const err502 = { instancePath: instancePath + "/costs/places/" + i25 + "/bema/" + i26 + "/points", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/bema/items/properties/points/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                            if (vErrors === null) {
                              vErrors = [err502];
                            } else {
                              vErrors.push(err502);
                            }
                            errors++;
                          }
                          if (typeof data203 == "number" && isFinite(data203)) {
                            if (data203 > 9007199254740991 || isNaN(data203)) {
                              const err503 = { instancePath: instancePath + "/costs/places/" + i25 + "/bema/" + i26 + "/points", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/bema/items/properties/points/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err503];
                              } else {
                                vErrors.push(err503);
                              }
                              errors++;
                            }
                            if (data203 < -9007199254740991 || isNaN(data203)) {
                              const err504 = { instancePath: instancePath + "/costs/places/" + i25 + "/bema/" + i26 + "/points", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/bema/items/properties/points/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err504];
                              } else {
                                vErrors.push(err504);
                              }
                              errors++;
                            }
                          }
                        }
                        if (data199.part !== void 0) {
                          if (typeof data199.part !== "string") {
                            const err505 = { instancePath: instancePath + "/costs/places/" + i25 + "/bema/" + i26 + "/part", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/bema/items/properties/part/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err505];
                            } else {
                              vErrors.push(err505);
                            }
                            errors++;
                          }
                        }
                        if (data199.minus !== void 0) {
                          if (typeof data199.minus !== "boolean") {
                            const err506 = { instancePath: instancePath + "/costs/places/" + i25 + "/bema/" + i26 + "/minus", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/bema/items/properties/minus/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                            if (vErrors === null) {
                              vErrors = [err506];
                            } else {
                              vErrors.push(err506);
                            }
                            errors++;
                          }
                        }
                        if (data199.quantity !== void 0) {
                          let data206 = data199.quantity;
                          const _errs457 = errors;
                          let valid91 = false;
                          const _errs458 = errors;
                          if (!(typeof data206 == "number" && (!(data206 % 1) && !isNaN(data206)) && isFinite(data206))) {
                            const err507 = { instancePath: instancePath + "/costs/places/" + i25 + "/bema/" + i26 + "/quantity", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/bema/items/properties/quantity/anyOf/0/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                            if (vErrors === null) {
                              vErrors = [err507];
                            } else {
                              vErrors.push(err507);
                            }
                            errors++;
                          }
                          if (typeof data206 == "number" && isFinite(data206)) {
                            if (data206 > 9007199254740991 || isNaN(data206)) {
                              const err508 = { instancePath: instancePath + "/costs/places/" + i25 + "/bema/" + i26 + "/quantity", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/bema/items/properties/quantity/anyOf/0/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err508];
                              } else {
                                vErrors.push(err508);
                              }
                              errors++;
                            }
                            if (data206 < -9007199254740991 || isNaN(data206)) {
                              const err509 = { instancePath: instancePath + "/costs/places/" + i25 + "/bema/" + i26 + "/quantity", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/bema/items/properties/quantity/anyOf/0/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err509];
                              } else {
                                vErrors.push(err509);
                              }
                              errors++;
                            }
                          }
                          var _valid2 = _errs458 === errors;
                          valid91 = valid91 || _valid2;
                          if (!valid91) {
                            const _errs460 = errors;
                            if (data206 !== null) {
                              const err510 = { instancePath: instancePath + "/costs/places/" + i25 + "/bema/" + i26 + "/quantity", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/bema/items/properties/quantity/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                              if (vErrors === null) {
                                vErrors = [err510];
                              } else {
                                vErrors.push(err510);
                              }
                              errors++;
                            }
                            var _valid2 = _errs460 === errors;
                            valid91 = valid91 || _valid2;
                          }
                          if (!valid91) {
                            const err511 = { instancePath: instancePath + "/costs/places/" + i25 + "/bema/" + i26 + "/quantity", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/bema/items/properties/quantity/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                            if (vErrors === null) {
                              vErrors = [err511];
                            } else {
                              vErrors.push(err511);
                            }
                            errors++;
                          } else {
                            errors = _errs457;
                            if (vErrors !== null) {
                              if (_errs457) {
                                vErrors.length = _errs457;
                              } else {
                                vErrors = null;
                              }
                            }
                          }
                        }
                        if (data199.counted !== void 0) {
                          let data207 = data199.counted;
                          if (typeof data207 !== "boolean") {
                            const err512 = { instancePath: instancePath + "/costs/places/" + i25 + "/bema/" + i26 + "/counted", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/bema/items/properties/counted/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                            if (vErrors === null) {
                              vErrors = [err512];
                            } else {
                              vErrors.push(err512);
                            }
                            errors++;
                          }
                          if (true !== data207) {
                            const err513 = { instancePath: instancePath + "/costs/places/" + i25 + "/bema/" + i26 + "/counted", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/bema/items/properties/counted/const", keyword: "const", params: { allowedValue: true }, message: "must be equal to constant" };
                            if (vErrors === null) {
                              vErrors = [err513];
                            } else {
                              vErrors.push(err513);
                            }
                            errors++;
                          }
                        }
                        if (data199.cents !== void 0) {
                          let data208 = data199.cents;
                          if (!(typeof data208 == "number" && (!(data208 % 1) && !isNaN(data208)) && isFinite(data208))) {
                            const err514 = { instancePath: instancePath + "/costs/places/" + i25 + "/bema/" + i26 + "/cents", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/bema/items/properties/cents/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                            if (vErrors === null) {
                              vErrors = [err514];
                            } else {
                              vErrors.push(err514);
                            }
                            errors++;
                          }
                          if (typeof data208 == "number" && isFinite(data208)) {
                            if (data208 > 9007199254740991 || isNaN(data208)) {
                              const err515 = { instancePath: instancePath + "/costs/places/" + i25 + "/bema/" + i26 + "/cents", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/bema/items/properties/cents/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err515];
                              } else {
                                vErrors.push(err515);
                              }
                              errors++;
                            }
                            if (data208 < -9007199254740991 || isNaN(data208)) {
                              const err516 = { instancePath: instancePath + "/costs/places/" + i25 + "/bema/" + i26 + "/cents", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/bema/items/properties/cents/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err516];
                              } else {
                                vErrors.push(err516);
                              }
                              errors++;
                            }
                          }
                        }
                        if (data199.excluded !== void 0) {
                          if (typeof data199.excluded !== "string") {
                            const err517 = { instancePath: instancePath + "/costs/places/" + i25 + "/bema/" + i26 + "/excluded", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/bema/items/properties/excluded/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err517];
                            } else {
                              vErrors.push(err517);
                            }
                            errors++;
                          }
                        }
                        if (data199.source !== void 0) {
                          let data210 = data199.source;
                          if (data210 && typeof data210 == "object" && !Array.isArray(data210)) {
                            if (data210.chunkId === void 0) {
                              const err518 = { instancePath: instancePath + "/costs/places/" + i25 + "/bema/" + i26 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/bema/items/properties/source/required", keyword: "required", params: { missingProperty: "chunkId" }, message: "must have required property 'chunkId'" };
                              if (vErrors === null) {
                                vErrors = [err518];
                              } else {
                                vErrors.push(err518);
                              }
                              errors++;
                            }
                            if (data210.title === void 0) {
                              const err519 = { instancePath: instancePath + "/costs/places/" + i25 + "/bema/" + i26 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/bema/items/properties/source/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
                              if (vErrors === null) {
                                vErrors = [err519];
                              } else {
                                vErrors.push(err519);
                              }
                              errors++;
                            }
                            if (data210.url === void 0) {
                              const err520 = { instancePath: instancePath + "/costs/places/" + i25 + "/bema/" + i26 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/bema/items/properties/source/required", keyword: "required", params: { missingProperty: "url" }, message: "must have required property 'url'" };
                              if (vErrors === null) {
                                vErrors = [err520];
                              } else {
                                vErrors.push(err520);
                              }
                              errors++;
                            }
                            for (const key34 in data210) {
                              if (!(key34 === "chunkId" || key34 === "title" || key34 === "url" || key34 === "page")) {
                                const err521 = { instancePath: instancePath + "/costs/places/" + i25 + "/bema/" + i26 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/bema/items/properties/source/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key34 }, message: "must NOT have additional properties" };
                                if (vErrors === null) {
                                  vErrors = [err521];
                                } else {
                                  vErrors.push(err521);
                                }
                                errors++;
                              }
                            }
                            if (data210.chunkId !== void 0) {
                              if (typeof data210.chunkId !== "string") {
                                const err522 = { instancePath: instancePath + "/costs/places/" + i25 + "/bema/" + i26 + "/source/chunkId", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/bema/items/properties/source/properties/chunkId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err522];
                                } else {
                                  vErrors.push(err522);
                                }
                                errors++;
                              }
                            }
                            if (data210.title !== void 0) {
                              if (typeof data210.title !== "string") {
                                const err523 = { instancePath: instancePath + "/costs/places/" + i25 + "/bema/" + i26 + "/source/title", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/bema/items/properties/source/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err523];
                                } else {
                                  vErrors.push(err523);
                                }
                                errors++;
                              }
                            }
                            if (data210.url !== void 0) {
                              if (typeof data210.url !== "string") {
                                const err524 = { instancePath: instancePath + "/costs/places/" + i25 + "/bema/" + i26 + "/source/url", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/bema/items/properties/source/properties/url/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err524];
                                } else {
                                  vErrors.push(err524);
                                }
                                errors++;
                              }
                            }
                            if (data210.page !== void 0) {
                              let data214 = data210.page;
                              if (!(typeof data214 == "number" && (!(data214 % 1) && !isNaN(data214)) && isFinite(data214))) {
                                const err525 = { instancePath: instancePath + "/costs/places/" + i25 + "/bema/" + i26 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/bema/items/properties/source/properties/page/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                if (vErrors === null) {
                                  vErrors = [err525];
                                } else {
                                  vErrors.push(err525);
                                }
                                errors++;
                              }
                              if (typeof data214 == "number" && isFinite(data214)) {
                                if (data214 > 9007199254740991 || isNaN(data214)) {
                                  const err526 = { instancePath: instancePath + "/costs/places/" + i25 + "/bema/" + i26 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/bema/items/properties/source/properties/page/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                                  if (vErrors === null) {
                                    vErrors = [err526];
                                  } else {
                                    vErrors.push(err526);
                                  }
                                  errors++;
                                }
                                if (data214 < -9007199254740991 || isNaN(data214)) {
                                  const err527 = { instancePath: instancePath + "/costs/places/" + i25 + "/bema/" + i26 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/bema/items/properties/source/properties/page/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                                  if (vErrors === null) {
                                    vErrors = [err527];
                                  } else {
                                    vErrors.push(err527);
                                  }
                                  errors++;
                                }
                              }
                            }
                          } else {
                            const err528 = { instancePath: instancePath + "/costs/places/" + i25 + "/bema/" + i26 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/bema/items/properties/source/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                            if (vErrors === null) {
                              vErrors = [err528];
                            } else {
                              vErrors.push(err528);
                            }
                            errors++;
                          }
                        }
                      } else {
                        const err529 = { instancePath: instancePath + "/costs/places/" + i25 + "/bema/" + i26, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/bema/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                        if (vErrors === null) {
                          vErrors = [err529];
                        } else {
                          vErrors.push(err529);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err530 = { instancePath: instancePath + "/costs/places/" + i25 + "/bema", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/bema/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                      vErrors = [err530];
                    } else {
                      vErrors.push(err530);
                    }
                    errors++;
                  }
                }
                if (data196.hkp !== void 0) {
                  let data215 = data196.hkp;
                  if (Array.isArray(data215)) {
                    const len27 = data215.length;
                    for (let i27 = 0; i27 < len27; i27++) {
                      let data216 = data215[i27];
                      if (data216 && typeof data216 == "object" && !Array.isArray(data216)) {
                        if (data216.nr === void 0) {
                          const err531 = { instancePath: instancePath + "/costs/places/" + i25 + "/hkp/" + i27, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/hkp/items/required", keyword: "required", params: { missingProperty: "nr" }, message: "must have required property 'nr'" };
                          if (vErrors === null) {
                            vErrors = [err531];
                          } else {
                            vErrors.push(err531);
                          }
                          errors++;
                        }
                        if (data216.text === void 0) {
                          const err532 = { instancePath: instancePath + "/costs/places/" + i25 + "/hkp/" + i27, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/hkp/items/required", keyword: "required", params: { missingProperty: "text" }, message: "must have required property 'text'" };
                          if (vErrors === null) {
                            vErrors = [err532];
                          } else {
                            vErrors.push(err532);
                          }
                          errors++;
                        }
                        if (data216.befunde === void 0) {
                          const err533 = { instancePath: instancePath + "/costs/places/" + i25 + "/hkp/" + i27, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/hkp/items/required", keyword: "required", params: { missingProperty: "befunde" }, message: "must have required property 'befunde'" };
                          if (vErrors === null) {
                            vErrors = [err533];
                          } else {
                            vErrors.push(err533);
                          }
                          errors++;
                        }
                        if (data216.quantity === void 0) {
                          const err534 = { instancePath: instancePath + "/costs/places/" + i25 + "/hkp/" + i27, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/hkp/items/required", keyword: "required", params: { missingProperty: "quantity" }, message: "must have required property 'quantity'" };
                          if (vErrors === null) {
                            vErrors = [err534];
                          } else {
                            vErrors.push(err534);
                          }
                          errors++;
                        }
                        if (data216.counted === void 0) {
                          const err535 = { instancePath: instancePath + "/costs/places/" + i25 + "/hkp/" + i27, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/hkp/items/required", keyword: "required", params: { missingProperty: "counted" }, message: "must have required property 'counted'" };
                          if (vErrors === null) {
                            vErrors = [err535];
                          } else {
                            vErrors.push(err535);
                          }
                          errors++;
                        }
                        for (const key35 in data216) {
                          if (!(key35 === "nr" || key35 === "text" || key35 === "befunde" || key35 === "quantity" || key35 === "counted" || key35 === "cents" || key35 === "source")) {
                            const err536 = { instancePath: instancePath + "/costs/places/" + i25 + "/hkp/" + i27, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/hkp/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key35 }, message: "must NOT have additional properties" };
                            if (vErrors === null) {
                              vErrors = [err536];
                            } else {
                              vErrors.push(err536);
                            }
                            errors++;
                          }
                        }
                        if (data216.nr !== void 0) {
                          if (typeof data216.nr !== "string") {
                            const err537 = { instancePath: instancePath + "/costs/places/" + i25 + "/hkp/" + i27 + "/nr", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/hkp/items/properties/nr/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err537];
                            } else {
                              vErrors.push(err537);
                            }
                            errors++;
                          }
                        }
                        if (data216.text !== void 0) {
                          if (typeof data216.text !== "string") {
                            const err538 = { instancePath: instancePath + "/costs/places/" + i25 + "/hkp/" + i27 + "/text", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/hkp/items/properties/text/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err538];
                            } else {
                              vErrors.push(err538);
                            }
                            errors++;
                          }
                        }
                        if (data216.befunde !== void 0) {
                          if (typeof data216.befunde !== "string") {
                            const err539 = { instancePath: instancePath + "/costs/places/" + i25 + "/hkp/" + i27 + "/befunde", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/hkp/items/properties/befunde/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err539];
                            } else {
                              vErrors.push(err539);
                            }
                            errors++;
                          }
                        }
                        if (data216.quantity !== void 0) {
                          let data220 = data216.quantity;
                          if (!(typeof data220 == "number" && (!(data220 % 1) && !isNaN(data220)) && isFinite(data220))) {
                            const err540 = { instancePath: instancePath + "/costs/places/" + i25 + "/hkp/" + i27 + "/quantity", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/hkp/items/properties/quantity/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                            if (vErrors === null) {
                              vErrors = [err540];
                            } else {
                              vErrors.push(err540);
                            }
                            errors++;
                          }
                          if (typeof data220 == "number" && isFinite(data220)) {
                            if (data220 > 9007199254740991 || isNaN(data220)) {
                              const err541 = { instancePath: instancePath + "/costs/places/" + i25 + "/hkp/" + i27 + "/quantity", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/hkp/items/properties/quantity/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err541];
                              } else {
                                vErrors.push(err541);
                              }
                              errors++;
                            }
                            if (data220 < -9007199254740991 || isNaN(data220)) {
                              const err542 = { instancePath: instancePath + "/costs/places/" + i25 + "/hkp/" + i27 + "/quantity", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/hkp/items/properties/quantity/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err542];
                              } else {
                                vErrors.push(err542);
                              }
                              errors++;
                            }
                          }
                        }
                        if (data216.counted !== void 0) {
                          let data221 = data216.counted;
                          if (typeof data221 !== "string") {
                            const err543 = { instancePath: instancePath + "/costs/places/" + i25 + "/hkp/" + i27 + "/counted", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/hkp/items/properties/counted/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err543];
                            } else {
                              vErrors.push(err543);
                            }
                            errors++;
                          }
                          if (!(data221 === "bema" || data221 === "dentist" || data221 === "assumed")) {
                            const err544 = { instancePath: instancePath + "/costs/places/" + i25 + "/hkp/" + i27 + "/counted", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/hkp/items/properties/counted/enum", keyword: "enum", params: { allowedValues: schema37.properties.costs.properties.places.items.properties.hkp.items.properties.counted.enum }, message: "must be equal to one of the allowed values" };
                            if (vErrors === null) {
                              vErrors = [err544];
                            } else {
                              vErrors.push(err544);
                            }
                            errors++;
                          }
                        }
                        if (data216.cents !== void 0) {
                          let data222 = data216.cents;
                          if (!(typeof data222 == "number" && (!(data222 % 1) && !isNaN(data222)) && isFinite(data222))) {
                            const err545 = { instancePath: instancePath + "/costs/places/" + i25 + "/hkp/" + i27 + "/cents", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/hkp/items/properties/cents/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                            if (vErrors === null) {
                              vErrors = [err545];
                            } else {
                              vErrors.push(err545);
                            }
                            errors++;
                          }
                          if (typeof data222 == "number" && isFinite(data222)) {
                            if (data222 > 9007199254740991 || isNaN(data222)) {
                              const err546 = { instancePath: instancePath + "/costs/places/" + i25 + "/hkp/" + i27 + "/cents", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/hkp/items/properties/cents/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err546];
                              } else {
                                vErrors.push(err546);
                              }
                              errors++;
                            }
                            if (data222 < -9007199254740991 || isNaN(data222)) {
                              const err547 = { instancePath: instancePath + "/costs/places/" + i25 + "/hkp/" + i27 + "/cents", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/hkp/items/properties/cents/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err547];
                              } else {
                                vErrors.push(err547);
                              }
                              errors++;
                            }
                          }
                        }
                        if (data216.source !== void 0) {
                          let data223 = data216.source;
                          if (data223 && typeof data223 == "object" && !Array.isArray(data223)) {
                            if (data223.chunkId === void 0) {
                              const err548 = { instancePath: instancePath + "/costs/places/" + i25 + "/hkp/" + i27 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/hkp/items/properties/source/required", keyword: "required", params: { missingProperty: "chunkId" }, message: "must have required property 'chunkId'" };
                              if (vErrors === null) {
                                vErrors = [err548];
                              } else {
                                vErrors.push(err548);
                              }
                              errors++;
                            }
                            if (data223.title === void 0) {
                              const err549 = { instancePath: instancePath + "/costs/places/" + i25 + "/hkp/" + i27 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/hkp/items/properties/source/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
                              if (vErrors === null) {
                                vErrors = [err549];
                              } else {
                                vErrors.push(err549);
                              }
                              errors++;
                            }
                            if (data223.url === void 0) {
                              const err550 = { instancePath: instancePath + "/costs/places/" + i25 + "/hkp/" + i27 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/hkp/items/properties/source/required", keyword: "required", params: { missingProperty: "url" }, message: "must have required property 'url'" };
                              if (vErrors === null) {
                                vErrors = [err550];
                              } else {
                                vErrors.push(err550);
                              }
                              errors++;
                            }
                            for (const key36 in data223) {
                              if (!(key36 === "chunkId" || key36 === "title" || key36 === "url" || key36 === "page")) {
                                const err551 = { instancePath: instancePath + "/costs/places/" + i25 + "/hkp/" + i27 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/hkp/items/properties/source/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key36 }, message: "must NOT have additional properties" };
                                if (vErrors === null) {
                                  vErrors = [err551];
                                } else {
                                  vErrors.push(err551);
                                }
                                errors++;
                              }
                            }
                            if (data223.chunkId !== void 0) {
                              if (typeof data223.chunkId !== "string") {
                                const err552 = { instancePath: instancePath + "/costs/places/" + i25 + "/hkp/" + i27 + "/source/chunkId", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/hkp/items/properties/source/properties/chunkId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err552];
                                } else {
                                  vErrors.push(err552);
                                }
                                errors++;
                              }
                            }
                            if (data223.title !== void 0) {
                              if (typeof data223.title !== "string") {
                                const err553 = { instancePath: instancePath + "/costs/places/" + i25 + "/hkp/" + i27 + "/source/title", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/hkp/items/properties/source/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err553];
                                } else {
                                  vErrors.push(err553);
                                }
                                errors++;
                              }
                            }
                            if (data223.url !== void 0) {
                              if (typeof data223.url !== "string") {
                                const err554 = { instancePath: instancePath + "/costs/places/" + i25 + "/hkp/" + i27 + "/source/url", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/hkp/items/properties/source/properties/url/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err554];
                                } else {
                                  vErrors.push(err554);
                                }
                                errors++;
                              }
                            }
                            if (data223.page !== void 0) {
                              let data227 = data223.page;
                              if (!(typeof data227 == "number" && (!(data227 % 1) && !isNaN(data227)) && isFinite(data227))) {
                                const err555 = { instancePath: instancePath + "/costs/places/" + i25 + "/hkp/" + i27 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/hkp/items/properties/source/properties/page/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                if (vErrors === null) {
                                  vErrors = [err555];
                                } else {
                                  vErrors.push(err555);
                                }
                                errors++;
                              }
                              if (typeof data227 == "number" && isFinite(data227)) {
                                if (data227 > 9007199254740991 || isNaN(data227)) {
                                  const err556 = { instancePath: instancePath + "/costs/places/" + i25 + "/hkp/" + i27 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/hkp/items/properties/source/properties/page/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                                  if (vErrors === null) {
                                    vErrors = [err556];
                                  } else {
                                    vErrors.push(err556);
                                  }
                                  errors++;
                                }
                                if (data227 < -9007199254740991 || isNaN(data227)) {
                                  const err557 = { instancePath: instancePath + "/costs/places/" + i25 + "/hkp/" + i27 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/hkp/items/properties/source/properties/page/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                                  if (vErrors === null) {
                                    vErrors = [err557];
                                  } else {
                                    vErrors.push(err557);
                                  }
                                  errors++;
                                }
                              }
                            }
                          } else {
                            const err558 = { instancePath: instancePath + "/costs/places/" + i25 + "/hkp/" + i27 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/hkp/items/properties/source/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                            if (vErrors === null) {
                              vErrors = [err558];
                            } else {
                              vErrors.push(err558);
                            }
                            errors++;
                          }
                        }
                      } else {
                        const err559 = { instancePath: instancePath + "/costs/places/" + i25 + "/hkp/" + i27, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/hkp/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                        if (vErrors === null) {
                          vErrors = [err559];
                        } else {
                          vErrors.push(err559);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err560 = { instancePath: instancePath + "/costs/places/" + i25 + "/hkp", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/properties/hkp/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                      vErrors = [err560];
                    } else {
                      vErrors.push(err560);
                    }
                    errors++;
                  }
                }
              } else {
                const err561 = { instancePath: instancePath + "/costs/places/" + i25, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                if (vErrors === null) {
                  vErrors = [err561];
                } else {
                  vErrors.push(err561);
                }
                errors++;
              }
            }
          } else {
            const err562 = { instancePath: instancePath + "/costs/places", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/places/type", keyword: "type", params: { type: "array" }, message: "must be array" };
            if (vErrors === null) {
              vErrors = [err562];
            } else {
              vErrors.push(err562);
            }
            errors++;
          }
        }
        if (data64.punktwert !== void 0) {
          let data228 = data64.punktwert;
          if (data228 && typeof data228 == "object" && !Array.isArray(data228)) {
            if (data228.ze === void 0) {
              const err563 = { instancePath: instancePath + "/costs/punktwert", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/punktwert/required", keyword: "required", params: { missingProperty: "ze" }, message: "must have required property 'ze'" };
              if (vErrors === null) {
                vErrors = [err563];
              } else {
                vErrors.push(err563);
              }
              errors++;
            }
            for (const key37 in data228) {
              if (!(key37 === "ze" || key37 === "source")) {
                const err564 = { instancePath: instancePath + "/costs/punktwert", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/punktwert/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key37 }, message: "must NOT have additional properties" };
                if (vErrors === null) {
                  vErrors = [err564];
                } else {
                  vErrors.push(err564);
                }
                errors++;
              }
            }
            if (data228.ze !== void 0) {
              let data229 = data228.ze;
              if (!(typeof data229 == "number" && (!(data229 % 1) && !isNaN(data229)) && isFinite(data229))) {
                const err565 = { instancePath: instancePath + "/costs/punktwert/ze", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/punktwert/properties/ze/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                if (vErrors === null) {
                  vErrors = [err565];
                } else {
                  vErrors.push(err565);
                }
                errors++;
              }
              if (typeof data229 == "number" && isFinite(data229)) {
                if (data229 > 9007199254740991 || isNaN(data229)) {
                  const err566 = { instancePath: instancePath + "/costs/punktwert/ze", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/punktwert/properties/ze/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err566];
                  } else {
                    vErrors.push(err566);
                  }
                  errors++;
                }
                if (data229 < -9007199254740991 || isNaN(data229)) {
                  const err567 = { instancePath: instancePath + "/costs/punktwert/ze", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/punktwert/properties/ze/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err567];
                  } else {
                    vErrors.push(err567);
                  }
                  errors++;
                }
              }
            }
            if (data228.source !== void 0) {
              let data230 = data228.source;
              if (data230 && typeof data230 == "object" && !Array.isArray(data230)) {
                if (data230.chunkId === void 0) {
                  const err568 = { instancePath: instancePath + "/costs/punktwert/source", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/punktwert/properties/source/required", keyword: "required", params: { missingProperty: "chunkId" }, message: "must have required property 'chunkId'" };
                  if (vErrors === null) {
                    vErrors = [err568];
                  } else {
                    vErrors.push(err568);
                  }
                  errors++;
                }
                if (data230.title === void 0) {
                  const err569 = { instancePath: instancePath + "/costs/punktwert/source", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/punktwert/properties/source/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
                  if (vErrors === null) {
                    vErrors = [err569];
                  } else {
                    vErrors.push(err569);
                  }
                  errors++;
                }
                if (data230.url === void 0) {
                  const err570 = { instancePath: instancePath + "/costs/punktwert/source", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/punktwert/properties/source/required", keyword: "required", params: { missingProperty: "url" }, message: "must have required property 'url'" };
                  if (vErrors === null) {
                    vErrors = [err570];
                  } else {
                    vErrors.push(err570);
                  }
                  errors++;
                }
                for (const key38 in data230) {
                  if (!(key38 === "chunkId" || key38 === "title" || key38 === "url" || key38 === "page")) {
                    const err571 = { instancePath: instancePath + "/costs/punktwert/source", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/punktwert/properties/source/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key38 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                      vErrors = [err571];
                    } else {
                      vErrors.push(err571);
                    }
                    errors++;
                  }
                }
                if (data230.chunkId !== void 0) {
                  if (typeof data230.chunkId !== "string") {
                    const err572 = { instancePath: instancePath + "/costs/punktwert/source/chunkId", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/punktwert/properties/source/properties/chunkId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err572];
                    } else {
                      vErrors.push(err572);
                    }
                    errors++;
                  }
                }
                if (data230.title !== void 0) {
                  if (typeof data230.title !== "string") {
                    const err573 = { instancePath: instancePath + "/costs/punktwert/source/title", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/punktwert/properties/source/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err573];
                    } else {
                      vErrors.push(err573);
                    }
                    errors++;
                  }
                }
                if (data230.url !== void 0) {
                  if (typeof data230.url !== "string") {
                    const err574 = { instancePath: instancePath + "/costs/punktwert/source/url", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/punktwert/properties/source/properties/url/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err574];
                    } else {
                      vErrors.push(err574);
                    }
                    errors++;
                  }
                }
                if (data230.page !== void 0) {
                  let data234 = data230.page;
                  if (!(typeof data234 == "number" && (!(data234 % 1) && !isNaN(data234)) && isFinite(data234))) {
                    const err575 = { instancePath: instancePath + "/costs/punktwert/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/punktwert/properties/source/properties/page/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err575];
                    } else {
                      vErrors.push(err575);
                    }
                    errors++;
                  }
                  if (typeof data234 == "number" && isFinite(data234)) {
                    if (data234 > 9007199254740991 || isNaN(data234)) {
                      const err576 = { instancePath: instancePath + "/costs/punktwert/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/punktwert/properties/source/properties/page/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err576];
                      } else {
                        vErrors.push(err576);
                      }
                      errors++;
                    }
                    if (data234 < -9007199254740991 || isNaN(data234)) {
                      const err577 = { instancePath: instancePath + "/costs/punktwert/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/punktwert/properties/source/properties/page/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err577];
                      } else {
                        vErrors.push(err577);
                      }
                      errors++;
                    }
                  }
                }
              } else {
                const err578 = { instancePath: instancePath + "/costs/punktwert/source", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/punktwert/properties/source/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                if (vErrors === null) {
                  vErrors = [err578];
                } else {
                  vErrors.push(err578);
                }
                errors++;
              }
            }
          } else {
            const err579 = { instancePath: instancePath + "/costs/punktwert", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/punktwert/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
              vErrors = [err579];
            } else {
              vErrors.push(err579);
            }
            errors++;
          }
        }
        if (data64.totals !== void 0) {
          let data235 = data64.totals;
          if (data235 && typeof data235 == "object" && !Array.isArray(data235)) {
            if (data235.honorar === void 0) {
              const err580 = { instancePath: instancePath + "/costs/totals", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/totals/required", keyword: "required", params: { missingProperty: "honorar" }, message: "must have required property 'honorar'" };
              if (vErrors === null) {
                vErrors = [err580];
              } else {
                vErrors.push(err580);
              }
              errors++;
            }
            if (data235.goz === void 0) {
              const err581 = { instancePath: instancePath + "/costs/totals", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/totals/required", keyword: "required", params: { missingProperty: "goz" }, message: "must have required property 'goz'" };
              if (vErrors === null) {
                vErrors = [err581];
              } else {
                vErrors.push(err581);
              }
              errors++;
            }
            if (data235.labor === void 0) {
              const err582 = { instancePath: instancePath + "/costs/totals", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/totals/required", keyword: "required", params: { missingProperty: "labor" }, message: "must have required property 'labor'" };
              if (vErrors === null) {
                vErrors = [err582];
              } else {
                vErrors.push(err582);
              }
              errors++;
            }
            if (data235.gesamt === void 0) {
              const err583 = { instancePath: instancePath + "/costs/totals", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/totals/required", keyword: "required", params: { missingProperty: "gesamt" }, message: "must have required property 'gesamt'" };
              if (vErrors === null) {
                vErrors = [err583];
              } else {
                vErrors.push(err583);
              }
              errors++;
            }
            if (data235.festzuschuss === void 0) {
              const err584 = { instancePath: instancePath + "/costs/totals", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/totals/required", keyword: "required", params: { missingProperty: "festzuschuss" }, message: "must have required property 'festzuschuss'" };
              if (vErrors === null) {
                vErrors = [err584];
              } else {
                vErrors.push(err584);
              }
              errors++;
            }
            if (data235.eigenanteil === void 0) {
              const err585 = { instancePath: instancePath + "/costs/totals", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/totals/required", keyword: "required", params: { missingProperty: "eigenanteil" }, message: "must have required property 'eigenanteil'" };
              if (vErrors === null) {
                vErrors = [err585];
              } else {
                vErrors.push(err585);
              }
              errors++;
            }
            for (const key39 in data235) {
              if (!(key39 === "honorar" || key39 === "goz" || key39 === "labor" || key39 === "gesamt" || key39 === "festzuschuss" || key39 === "eigenanteil")) {
                const err586 = { instancePath: instancePath + "/costs/totals", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/totals/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key39 }, message: "must NOT have additional properties" };
                if (vErrors === null) {
                  vErrors = [err586];
                } else {
                  vErrors.push(err586);
                }
                errors++;
              }
            }
            if (data235.honorar !== void 0) {
              let data236 = data235.honorar;
              if (!(typeof data236 == "number" && (!(data236 % 1) && !isNaN(data236)) && isFinite(data236))) {
                const err587 = { instancePath: instancePath + "/costs/totals/honorar", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/totals/properties/honorar/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                if (vErrors === null) {
                  vErrors = [err587];
                } else {
                  vErrors.push(err587);
                }
                errors++;
              }
              if (typeof data236 == "number" && isFinite(data236)) {
                if (data236 > 9007199254740991 || isNaN(data236)) {
                  const err588 = { instancePath: instancePath + "/costs/totals/honorar", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/totals/properties/honorar/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err588];
                  } else {
                    vErrors.push(err588);
                  }
                  errors++;
                }
                if (data236 < -9007199254740991 || isNaN(data236)) {
                  const err589 = { instancePath: instancePath + "/costs/totals/honorar", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/totals/properties/honorar/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err589];
                  } else {
                    vErrors.push(err589);
                  }
                  errors++;
                }
              }
            }
            if (data235.goz !== void 0) {
              let data237 = data235.goz;
              if (!(typeof data237 == "number" && (!(data237 % 1) && !isNaN(data237)) && isFinite(data237))) {
                const err590 = { instancePath: instancePath + "/costs/totals/goz", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/totals/properties/goz/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                if (vErrors === null) {
                  vErrors = [err590];
                } else {
                  vErrors.push(err590);
                }
                errors++;
              }
              if (typeof data237 == "number" && isFinite(data237)) {
                if (data237 > 9007199254740991 || isNaN(data237)) {
                  const err591 = { instancePath: instancePath + "/costs/totals/goz", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/totals/properties/goz/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err591];
                  } else {
                    vErrors.push(err591);
                  }
                  errors++;
                }
                if (data237 < -9007199254740991 || isNaN(data237)) {
                  const err592 = { instancePath: instancePath + "/costs/totals/goz", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/totals/properties/goz/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err592];
                  } else {
                    vErrors.push(err592);
                  }
                  errors++;
                }
              }
            }
            if (data235.labor !== void 0) {
              let data238 = data235.labor;
              if (!(typeof data238 == "number" && (!(data238 % 1) && !isNaN(data238)) && isFinite(data238))) {
                const err593 = { instancePath: instancePath + "/costs/totals/labor", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/totals/properties/labor/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                if (vErrors === null) {
                  vErrors = [err593];
                } else {
                  vErrors.push(err593);
                }
                errors++;
              }
              if (typeof data238 == "number" && isFinite(data238)) {
                if (data238 > 9007199254740991 || isNaN(data238)) {
                  const err594 = { instancePath: instancePath + "/costs/totals/labor", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/totals/properties/labor/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err594];
                  } else {
                    vErrors.push(err594);
                  }
                  errors++;
                }
                if (data238 < -9007199254740991 || isNaN(data238)) {
                  const err595 = { instancePath: instancePath + "/costs/totals/labor", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/totals/properties/labor/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err595];
                  } else {
                    vErrors.push(err595);
                  }
                  errors++;
                }
              }
            }
            if (data235.gesamt !== void 0) {
              let data239 = data235.gesamt;
              if (!(typeof data239 == "number" && (!(data239 % 1) && !isNaN(data239)) && isFinite(data239))) {
                const err596 = { instancePath: instancePath + "/costs/totals/gesamt", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/totals/properties/gesamt/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                if (vErrors === null) {
                  vErrors = [err596];
                } else {
                  vErrors.push(err596);
                }
                errors++;
              }
              if (typeof data239 == "number" && isFinite(data239)) {
                if (data239 > 9007199254740991 || isNaN(data239)) {
                  const err597 = { instancePath: instancePath + "/costs/totals/gesamt", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/totals/properties/gesamt/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err597];
                  } else {
                    vErrors.push(err597);
                  }
                  errors++;
                }
                if (data239 < -9007199254740991 || isNaN(data239)) {
                  const err598 = { instancePath: instancePath + "/costs/totals/gesamt", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/totals/properties/gesamt/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err598];
                  } else {
                    vErrors.push(err598);
                  }
                  errors++;
                }
              }
            }
            if (data235.festzuschuss !== void 0) {
              let data240 = data235.festzuschuss;
              if (data240 && typeof data240 == "object" && !Array.isArray(data240)) {
                if (data240.prozent60 === void 0) {
                  const err599 = { instancePath: instancePath + "/costs/totals/festzuschuss", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/totals/properties/festzuschuss/required", keyword: "required", params: { missingProperty: "prozent60" }, message: "must have required property 'prozent60'" };
                  if (vErrors === null) {
                    vErrors = [err599];
                  } else {
                    vErrors.push(err599);
                  }
                  errors++;
                }
                if (data240.prozent70 === void 0) {
                  const err600 = { instancePath: instancePath + "/costs/totals/festzuschuss", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/totals/properties/festzuschuss/required", keyword: "required", params: { missingProperty: "prozent70" }, message: "must have required property 'prozent70'" };
                  if (vErrors === null) {
                    vErrors = [err600];
                  } else {
                    vErrors.push(err600);
                  }
                  errors++;
                }
                if (data240.prozent75 === void 0) {
                  const err601 = { instancePath: instancePath + "/costs/totals/festzuschuss", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/totals/properties/festzuschuss/required", keyword: "required", params: { missingProperty: "prozent75" }, message: "must have required property 'prozent75'" };
                  if (vErrors === null) {
                    vErrors = [err601];
                  } else {
                    vErrors.push(err601);
                  }
                  errors++;
                }
                if (data240.prozent100 === void 0) {
                  const err602 = { instancePath: instancePath + "/costs/totals/festzuschuss", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/totals/properties/festzuschuss/required", keyword: "required", params: { missingProperty: "prozent100" }, message: "must have required property 'prozent100'" };
                  if (vErrors === null) {
                    vErrors = [err602];
                  } else {
                    vErrors.push(err602);
                  }
                  errors++;
                }
                for (const key40 in data240) {
                  if (!(key40 === "prozent60" || key40 === "prozent70" || key40 === "prozent75" || key40 === "prozent100")) {
                    const err603 = { instancePath: instancePath + "/costs/totals/festzuschuss", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/totals/properties/festzuschuss/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key40 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                      vErrors = [err603];
                    } else {
                      vErrors.push(err603);
                    }
                    errors++;
                  }
                }
                if (data240.prozent60 !== void 0) {
                  let data241 = data240.prozent60;
                  if (!(typeof data241 == "number" && (!(data241 % 1) && !isNaN(data241)) && isFinite(data241))) {
                    const err604 = { instancePath: instancePath + "/costs/totals/festzuschuss/prozent60", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/totals/properties/festzuschuss/properties/prozent60/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err604];
                    } else {
                      vErrors.push(err604);
                    }
                    errors++;
                  }
                  if (typeof data241 == "number" && isFinite(data241)) {
                    if (data241 > 9007199254740991 || isNaN(data241)) {
                      const err605 = { instancePath: instancePath + "/costs/totals/festzuschuss/prozent60", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/totals/properties/festzuschuss/properties/prozent60/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err605];
                      } else {
                        vErrors.push(err605);
                      }
                      errors++;
                    }
                    if (data241 < -9007199254740991 || isNaN(data241)) {
                      const err606 = { instancePath: instancePath + "/costs/totals/festzuschuss/prozent60", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/totals/properties/festzuschuss/properties/prozent60/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err606];
                      } else {
                        vErrors.push(err606);
                      }
                      errors++;
                    }
                  }
                }
                if (data240.prozent70 !== void 0) {
                  let data242 = data240.prozent70;
                  if (!(typeof data242 == "number" && (!(data242 % 1) && !isNaN(data242)) && isFinite(data242))) {
                    const err607 = { instancePath: instancePath + "/costs/totals/festzuschuss/prozent70", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/totals/properties/festzuschuss/properties/prozent70/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err607];
                    } else {
                      vErrors.push(err607);
                    }
                    errors++;
                  }
                  if (typeof data242 == "number" && isFinite(data242)) {
                    if (data242 > 9007199254740991 || isNaN(data242)) {
                      const err608 = { instancePath: instancePath + "/costs/totals/festzuschuss/prozent70", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/totals/properties/festzuschuss/properties/prozent70/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err608];
                      } else {
                        vErrors.push(err608);
                      }
                      errors++;
                    }
                    if (data242 < -9007199254740991 || isNaN(data242)) {
                      const err609 = { instancePath: instancePath + "/costs/totals/festzuschuss/prozent70", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/totals/properties/festzuschuss/properties/prozent70/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err609];
                      } else {
                        vErrors.push(err609);
                      }
                      errors++;
                    }
                  }
                }
                if (data240.prozent75 !== void 0) {
                  let data243 = data240.prozent75;
                  if (!(typeof data243 == "number" && (!(data243 % 1) && !isNaN(data243)) && isFinite(data243))) {
                    const err610 = { instancePath: instancePath + "/costs/totals/festzuschuss/prozent75", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/totals/properties/festzuschuss/properties/prozent75/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err610];
                    } else {
                      vErrors.push(err610);
                    }
                    errors++;
                  }
                  if (typeof data243 == "number" && isFinite(data243)) {
                    if (data243 > 9007199254740991 || isNaN(data243)) {
                      const err611 = { instancePath: instancePath + "/costs/totals/festzuschuss/prozent75", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/totals/properties/festzuschuss/properties/prozent75/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err611];
                      } else {
                        vErrors.push(err611);
                      }
                      errors++;
                    }
                    if (data243 < -9007199254740991 || isNaN(data243)) {
                      const err612 = { instancePath: instancePath + "/costs/totals/festzuschuss/prozent75", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/totals/properties/festzuschuss/properties/prozent75/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err612];
                      } else {
                        vErrors.push(err612);
                      }
                      errors++;
                    }
                  }
                }
                if (data240.prozent100 !== void 0) {
                  let data244 = data240.prozent100;
                  if (!(typeof data244 == "number" && (!(data244 % 1) && !isNaN(data244)) && isFinite(data244))) {
                    const err613 = { instancePath: instancePath + "/costs/totals/festzuschuss/prozent100", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/totals/properties/festzuschuss/properties/prozent100/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err613];
                    } else {
                      vErrors.push(err613);
                    }
                    errors++;
                  }
                  if (typeof data244 == "number" && isFinite(data244)) {
                    if (data244 > 9007199254740991 || isNaN(data244)) {
                      const err614 = { instancePath: instancePath + "/costs/totals/festzuschuss/prozent100", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/totals/properties/festzuschuss/properties/prozent100/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err614];
                      } else {
                        vErrors.push(err614);
                      }
                      errors++;
                    }
                    if (data244 < -9007199254740991 || isNaN(data244)) {
                      const err615 = { instancePath: instancePath + "/costs/totals/festzuschuss/prozent100", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/totals/properties/festzuschuss/properties/prozent100/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err615];
                      } else {
                        vErrors.push(err615);
                      }
                      errors++;
                    }
                  }
                }
              } else {
                const err616 = { instancePath: instancePath + "/costs/totals/festzuschuss", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/totals/properties/festzuschuss/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                if (vErrors === null) {
                  vErrors = [err616];
                } else {
                  vErrors.push(err616);
                }
                errors++;
              }
            }
            if (data235.eigenanteil !== void 0) {
              let data245 = data235.eigenanteil;
              if (data245 && typeof data245 == "object" && !Array.isArray(data245)) {
                if (data245.prozent60 === void 0) {
                  const err617 = { instancePath: instancePath + "/costs/totals/eigenanteil", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/totals/properties/eigenanteil/required", keyword: "required", params: { missingProperty: "prozent60" }, message: "must have required property 'prozent60'" };
                  if (vErrors === null) {
                    vErrors = [err617];
                  } else {
                    vErrors.push(err617);
                  }
                  errors++;
                }
                if (data245.prozent70 === void 0) {
                  const err618 = { instancePath: instancePath + "/costs/totals/eigenanteil", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/totals/properties/eigenanteil/required", keyword: "required", params: { missingProperty: "prozent70" }, message: "must have required property 'prozent70'" };
                  if (vErrors === null) {
                    vErrors = [err618];
                  } else {
                    vErrors.push(err618);
                  }
                  errors++;
                }
                if (data245.prozent75 === void 0) {
                  const err619 = { instancePath: instancePath + "/costs/totals/eigenanteil", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/totals/properties/eigenanteil/required", keyword: "required", params: { missingProperty: "prozent75" }, message: "must have required property 'prozent75'" };
                  if (vErrors === null) {
                    vErrors = [err619];
                  } else {
                    vErrors.push(err619);
                  }
                  errors++;
                }
                if (data245.prozent100 === void 0) {
                  const err620 = { instancePath: instancePath + "/costs/totals/eigenanteil", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/totals/properties/eigenanteil/required", keyword: "required", params: { missingProperty: "prozent100" }, message: "must have required property 'prozent100'" };
                  if (vErrors === null) {
                    vErrors = [err620];
                  } else {
                    vErrors.push(err620);
                  }
                  errors++;
                }
                for (const key41 in data245) {
                  if (!(key41 === "prozent60" || key41 === "prozent70" || key41 === "prozent75" || key41 === "prozent100")) {
                    const err621 = { instancePath: instancePath + "/costs/totals/eigenanteil", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/totals/properties/eigenanteil/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key41 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                      vErrors = [err621];
                    } else {
                      vErrors.push(err621);
                    }
                    errors++;
                  }
                }
                if (data245.prozent60 !== void 0) {
                  let data246 = data245.prozent60;
                  if (!(typeof data246 == "number" && (!(data246 % 1) && !isNaN(data246)) && isFinite(data246))) {
                    const err622 = { instancePath: instancePath + "/costs/totals/eigenanteil/prozent60", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/totals/properties/eigenanteil/properties/prozent60/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err622];
                    } else {
                      vErrors.push(err622);
                    }
                    errors++;
                  }
                  if (typeof data246 == "number" && isFinite(data246)) {
                    if (data246 > 9007199254740991 || isNaN(data246)) {
                      const err623 = { instancePath: instancePath + "/costs/totals/eigenanteil/prozent60", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/totals/properties/eigenanteil/properties/prozent60/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err623];
                      } else {
                        vErrors.push(err623);
                      }
                      errors++;
                    }
                    if (data246 < -9007199254740991 || isNaN(data246)) {
                      const err624 = { instancePath: instancePath + "/costs/totals/eigenanteil/prozent60", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/totals/properties/eigenanteil/properties/prozent60/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err624];
                      } else {
                        vErrors.push(err624);
                      }
                      errors++;
                    }
                  }
                }
                if (data245.prozent70 !== void 0) {
                  let data247 = data245.prozent70;
                  if (!(typeof data247 == "number" && (!(data247 % 1) && !isNaN(data247)) && isFinite(data247))) {
                    const err625 = { instancePath: instancePath + "/costs/totals/eigenanteil/prozent70", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/totals/properties/eigenanteil/properties/prozent70/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err625];
                    } else {
                      vErrors.push(err625);
                    }
                    errors++;
                  }
                  if (typeof data247 == "number" && isFinite(data247)) {
                    if (data247 > 9007199254740991 || isNaN(data247)) {
                      const err626 = { instancePath: instancePath + "/costs/totals/eigenanteil/prozent70", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/totals/properties/eigenanteil/properties/prozent70/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err626];
                      } else {
                        vErrors.push(err626);
                      }
                      errors++;
                    }
                    if (data247 < -9007199254740991 || isNaN(data247)) {
                      const err627 = { instancePath: instancePath + "/costs/totals/eigenanteil/prozent70", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/totals/properties/eigenanteil/properties/prozent70/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err627];
                      } else {
                        vErrors.push(err627);
                      }
                      errors++;
                    }
                  }
                }
                if (data245.prozent75 !== void 0) {
                  let data248 = data245.prozent75;
                  if (!(typeof data248 == "number" && (!(data248 % 1) && !isNaN(data248)) && isFinite(data248))) {
                    const err628 = { instancePath: instancePath + "/costs/totals/eigenanteil/prozent75", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/totals/properties/eigenanteil/properties/prozent75/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err628];
                    } else {
                      vErrors.push(err628);
                    }
                    errors++;
                  }
                  if (typeof data248 == "number" && isFinite(data248)) {
                    if (data248 > 9007199254740991 || isNaN(data248)) {
                      const err629 = { instancePath: instancePath + "/costs/totals/eigenanteil/prozent75", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/totals/properties/eigenanteil/properties/prozent75/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err629];
                      } else {
                        vErrors.push(err629);
                      }
                      errors++;
                    }
                    if (data248 < -9007199254740991 || isNaN(data248)) {
                      const err630 = { instancePath: instancePath + "/costs/totals/eigenanteil/prozent75", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/totals/properties/eigenanteil/properties/prozent75/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err630];
                      } else {
                        vErrors.push(err630);
                      }
                      errors++;
                    }
                  }
                }
                if (data245.prozent100 !== void 0) {
                  let data249 = data245.prozent100;
                  if (!(typeof data249 == "number" && (!(data249 % 1) && !isNaN(data249)) && isFinite(data249))) {
                    const err631 = { instancePath: instancePath + "/costs/totals/eigenanteil/prozent100", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/totals/properties/eigenanteil/properties/prozent100/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err631];
                    } else {
                      vErrors.push(err631);
                    }
                    errors++;
                  }
                  if (typeof data249 == "number" && isFinite(data249)) {
                    if (data249 > 9007199254740991 || isNaN(data249)) {
                      const err632 = { instancePath: instancePath + "/costs/totals/eigenanteil/prozent100", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/totals/properties/eigenanteil/properties/prozent100/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err632];
                      } else {
                        vErrors.push(err632);
                      }
                      errors++;
                    }
                    if (data249 < -9007199254740991 || isNaN(data249)) {
                      const err633 = { instancePath: instancePath + "/costs/totals/eigenanteil/prozent100", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/totals/properties/eigenanteil/properties/prozent100/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err633];
                      } else {
                        vErrors.push(err633);
                      }
                      errors++;
                    }
                  }
                }
              } else {
                const err634 = { instancePath: instancePath + "/costs/totals/eigenanteil", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/totals/properties/eigenanteil/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                if (vErrors === null) {
                  vErrors = [err634];
                } else {
                  vErrors.push(err634);
                }
                errors++;
              }
            }
          } else {
            const err635 = { instancePath: instancePath + "/costs/totals", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/totals/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
              vErrors = [err635];
            } else {
              vErrors.push(err635);
            }
            errors++;
          }
        }
        if (data64.waiting !== void 0) {
          let data250 = data64.waiting;
          if (Array.isArray(data250)) {
            const len28 = data250.length;
            for (let i28 = 0; i28 < len28; i28++) {
              let data251 = data250[i28];
              if (!(typeof data251 == "number" && (!(data251 % 1) && !isNaN(data251)) && isFinite(data251))) {
                const err636 = { instancePath: instancePath + "/costs/waiting/" + i28, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/waiting/items/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                if (vErrors === null) {
                  vErrors = [err636];
                } else {
                  vErrors.push(err636);
                }
                errors++;
              }
              if (typeof data251 == "number" && isFinite(data251)) {
                if (data251 > 9007199254740991 || isNaN(data251)) {
                  const err637 = { instancePath: instancePath + "/costs/waiting/" + i28, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/waiting/items/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err637];
                  } else {
                    vErrors.push(err637);
                  }
                  errors++;
                }
                if (data251 < -9007199254740991 || isNaN(data251)) {
                  const err638 = { instancePath: instancePath + "/costs/waiting/" + i28, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/waiting/items/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err638];
                  } else {
                    vErrors.push(err638);
                  }
                  errors++;
                }
              }
            }
          } else {
            const err639 = { instancePath: instancePath + "/costs/waiting", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/waiting/type", keyword: "type", params: { type: "array" }, message: "must be array" };
            if (vErrors === null) {
              vErrors = [err639];
            } else {
              vErrors.push(err639);
            }
            errors++;
          }
        }
        if (data64.placeholders !== void 0) {
          let data252 = data64.placeholders;
          if (Array.isArray(data252)) {
            const len29 = data252.length;
            for (let i29 = 0; i29 < len29; i29++) {
              let data253 = data252[i29];
              if (data253 && typeof data253 == "object" && !Array.isArray(data253)) {
                if (data253.id === void 0) {
                  const err640 = { instancePath: instancePath + "/costs/placeholders/" + i29, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/placeholders/items/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property 'id'" };
                  if (vErrors === null) {
                    vErrors = [err640];
                  } else {
                    vErrors.push(err640);
                  }
                  errors++;
                }
                if (data253.text === void 0) {
                  const err641 = { instancePath: instancePath + "/costs/placeholders/" + i29, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/placeholders/items/required", keyword: "required", params: { missingProperty: "text" }, message: "must have required property 'text'" };
                  if (vErrors === null) {
                    vErrors = [err641];
                  } else {
                    vErrors.push(err641);
                  }
                  errors++;
                }
                for (const key42 in data253) {
                  if (!(key42 === "id" || key42 === "text")) {
                    const err642 = { instancePath: instancePath + "/costs/placeholders/" + i29, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/placeholders/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key42 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                      vErrors = [err642];
                    } else {
                      vErrors.push(err642);
                    }
                    errors++;
                  }
                }
                if (data253.id !== void 0) {
                  let data254 = data253.id;
                  if (typeof data254 !== "string") {
                    const err643 = { instancePath: instancePath + "/costs/placeholders/" + i29 + "/id", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/placeholders/items/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err643];
                    } else {
                      vErrors.push(err643);
                    }
                    errors++;
                  }
                  if (!(data254 === "punktwert" || data254 === "labor" || data254 === "materialPreise" || data254 === "anzahl" || data254 === "faktor" || data254 === "laborGleichartig" || data254 === "eigenanteil")) {
                    const err644 = { instancePath: instancePath + "/costs/placeholders/" + i29 + "/id", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/placeholders/items/properties/id/enum", keyword: "enum", params: { allowedValues: schema37.properties.costs.properties.placeholders.items.properties.id.enum }, message: "must be equal to one of the allowed values" };
                    if (vErrors === null) {
                      vErrors = [err644];
                    } else {
                      vErrors.push(err644);
                    }
                    errors++;
                  }
                }
                if (data253.text !== void 0) {
                  if (typeof data253.text !== "string") {
                    const err645 = { instancePath: instancePath + "/costs/placeholders/" + i29 + "/text", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/placeholders/items/properties/text/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err645];
                    } else {
                      vErrors.push(err645);
                    }
                    errors++;
                  }
                }
              } else {
                const err646 = { instancePath: instancePath + "/costs/placeholders/" + i29, schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/placeholders/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                if (vErrors === null) {
                  vErrors = [err646];
                } else {
                  vErrors.push(err646);
                }
                errors++;
              }
            }
          } else {
            const err647 = { instancePath: instancePath + "/costs/placeholders", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/properties/placeholders/type", keyword: "type", params: { type: "array" }, message: "must be array" };
            if (vErrors === null) {
              vErrors = [err647];
            } else {
              vErrors.push(err647);
            }
            errors++;
          }
        }
      } else {
        const err648 = { instancePath: instancePath + "/costs", schemaPath: "#/definitions/VerificationEvaluation/properties/costs/type", keyword: "type", params: { type: "object" }, message: "must be object" };
        if (vErrors === null) {
          vErrors = [err648];
        } else {
          vErrors.push(err648);
        }
        errors++;
      }
    }
    if (data.projectedCosts !== void 0) {
      let data256 = data.projectedCosts;
      if (data256 && typeof data256 == "object" && !Array.isArray(data256)) {
        if (data256.teeth === void 0) {
          const err649 = { instancePath: instancePath + "/projectedCosts", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/required", keyword: "required", params: { missingProperty: "teeth" }, message: "must have required property 'teeth'" };
          if (vErrors === null) {
            vErrors = [err649];
          } else {
            vErrors.push(err649);
          }
          errors++;
        }
        if (data256.luecken === void 0) {
          const err650 = { instancePath: instancePath + "/projectedCosts", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/required", keyword: "required", params: { missingProperty: "luecken" }, message: "must have required property 'luecken'" };
          if (vErrors === null) {
            vErrors = [err650];
          } else {
            vErrors.push(err650);
          }
          errors++;
        }
        if (data256.places === void 0) {
          const err651 = { instancePath: instancePath + "/projectedCosts", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/required", keyword: "required", params: { missingProperty: "places" }, message: "must have required property 'places'" };
          if (vErrors === null) {
            vErrors = [err651];
          } else {
            vErrors.push(err651);
          }
          errors++;
        }
        if (data256.waiting === void 0) {
          const err652 = { instancePath: instancePath + "/projectedCosts", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/required", keyword: "required", params: { missingProperty: "waiting" }, message: "must have required property 'waiting'" };
          if (vErrors === null) {
            vErrors = [err652];
          } else {
            vErrors.push(err652);
          }
          errors++;
        }
        if (data256.placeholders === void 0) {
          const err653 = { instancePath: instancePath + "/projectedCosts", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/required", keyword: "required", params: { missingProperty: "placeholders" }, message: "must have required property 'placeholders'" };
          if (vErrors === null) {
            vErrors = [err653];
          } else {
            vErrors.push(err653);
          }
          errors++;
        }
        for (const key43 in data256) {
          if (!(key43 === "teeth" || key43 === "luecken" || key43 === "places" || key43 === "punktwert" || key43 === "totals" || key43 === "waiting" || key43 === "placeholders")) {
            const err654 = { instancePath: instancePath + "/projectedCosts", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key43 }, message: "must NOT have additional properties" };
            if (vErrors === null) {
              vErrors = [err654];
            } else {
              vErrors.push(err654);
            }
            errors++;
          }
        }
        if (data256.teeth !== void 0) {
          let data257 = data256.teeth;
          if (Array.isArray(data257)) {
            const len30 = data257.length;
            for (let i30 = 0; i30 < len30; i30++) {
              let data258 = data257[i30];
              if (data258 && typeof data258 == "object" && !Array.isArray(data258)) {
                if (data258.fdi === void 0) {
                  const err655 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/required", keyword: "required", params: { missingProperty: "fdi" }, message: "must have required property 'fdi'" };
                  if (vErrors === null) {
                    vErrors = [err655];
                  } else {
                    vErrors.push(err655);
                  }
                  errors++;
                }
                if (data258.bema === void 0) {
                  const err656 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/required", keyword: "required", params: { missingProperty: "bema" }, message: "must have required property 'bema'" };
                  if (vErrors === null) {
                    vErrors = [err656];
                  } else {
                    vErrors.push(err656);
                  }
                  errors++;
                }
                if (data258.hkp === void 0) {
                  const err657 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/required", keyword: "required", params: { missingProperty: "hkp" }, message: "must have required property 'hkp'" };
                  if (vErrors === null) {
                    vErrors = [err657];
                  } else {
                    vErrors.push(err657);
                  }
                  errors++;
                }
                if (data258.bel === void 0) {
                  const err658 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/required", keyword: "required", params: { missingProperty: "bel" }, message: "must have required property 'bel'" };
                  if (vErrors === null) {
                    vErrors = [err658];
                  } else {
                    vErrors.push(err658);
                  }
                  errors++;
                }
                if (data258.materials === void 0) {
                  const err659 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/required", keyword: "required", params: { missingProperty: "materials" }, message: "must have required property 'materials'" };
                  if (vErrors === null) {
                    vErrors = [err659];
                  } else {
                    vErrors.push(err659);
                  }
                  errors++;
                }
                if (data258.labor === void 0) {
                  const err660 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/required", keyword: "required", params: { missingProperty: "labor" }, message: "must have required property 'labor'" };
                  if (vErrors === null) {
                    vErrors = [err660];
                  } else {
                    vErrors.push(err660);
                  }
                  errors++;
                }
                if (data258.goz === void 0) {
                  const err661 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/required", keyword: "required", params: { missingProperty: "goz" }, message: "must have required property 'goz'" };
                  if (vErrors === null) {
                    vErrors = [err661];
                  } else {
                    vErrors.push(err661);
                  }
                  errors++;
                }
                for (const key44 in data258) {
                  if (!(key44 === "fdi" || key44 === "bema" || key44 === "hkp" || key44 === "bel" || key44 === "materials" || key44 === "labor" || key44 === "versorgung" || key44 === "goz")) {
                    const err662 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key44 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                      vErrors = [err662];
                    } else {
                      vErrors.push(err662);
                    }
                    errors++;
                  }
                }
                if (data258.fdi !== void 0) {
                  let data259 = data258.fdi;
                  if (!(typeof data259 == "number" && (!(data259 % 1) && !isNaN(data259)) && isFinite(data259))) {
                    const err663 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/fdi", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/fdi/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err663];
                    } else {
                      vErrors.push(err663);
                    }
                    errors++;
                  }
                  if (typeof data259 == "number" && isFinite(data259)) {
                    if (data259 > 9007199254740991 || isNaN(data259)) {
                      const err664 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/fdi", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/fdi/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err664];
                      } else {
                        vErrors.push(err664);
                      }
                      errors++;
                    }
                    if (data259 < -9007199254740991 || isNaN(data259)) {
                      const err665 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/fdi", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/fdi/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err665];
                      } else {
                        vErrors.push(err665);
                      }
                      errors++;
                    }
                  }
                }
                if (data258.bema !== void 0) {
                  let data260 = data258.bema;
                  if (Array.isArray(data260)) {
                    const len31 = data260.length;
                    for (let i31 = 0; i31 < len31; i31++) {
                      let data261 = data260[i31];
                      if (data261 && typeof data261 == "object" && !Array.isArray(data261)) {
                        if (data261.befund === void 0) {
                          const err666 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bema/" + i31, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bema/items/required", keyword: "required", params: { missingProperty: "befund" }, message: "must have required property 'befund'" };
                          if (vErrors === null) {
                            vErrors = [err666];
                          } else {
                            vErrors.push(err666);
                          }
                          errors++;
                        }
                        if (data261.nr === void 0) {
                          const err667 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bema/" + i31, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bema/items/required", keyword: "required", params: { missingProperty: "nr" }, message: "must have required property 'nr'" };
                          if (vErrors === null) {
                            vErrors = [err667];
                          } else {
                            vErrors.push(err667);
                          }
                          errors++;
                        }
                        if (data261.text === void 0) {
                          const err668 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bema/" + i31, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bema/items/required", keyword: "required", params: { missingProperty: "text" }, message: "must have required property 'text'" };
                          if (vErrors === null) {
                            vErrors = [err668];
                          } else {
                            vErrors.push(err668);
                          }
                          errors++;
                        }
                        if (data261.points === void 0) {
                          const err669 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bema/" + i31, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bema/items/required", keyword: "required", params: { missingProperty: "points" }, message: "must have required property 'points'" };
                          if (vErrors === null) {
                            vErrors = [err669];
                          } else {
                            vErrors.push(err669);
                          }
                          errors++;
                        }
                        if (data261.part === void 0) {
                          const err670 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bema/" + i31, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bema/items/required", keyword: "required", params: { missingProperty: "part" }, message: "must have required property 'part'" };
                          if (vErrors === null) {
                            vErrors = [err670];
                          } else {
                            vErrors.push(err670);
                          }
                          errors++;
                        }
                        if (data261.minus === void 0) {
                          const err671 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bema/" + i31, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bema/items/required", keyword: "required", params: { missingProperty: "minus" }, message: "must have required property 'minus'" };
                          if (vErrors === null) {
                            vErrors = [err671];
                          } else {
                            vErrors.push(err671);
                          }
                          errors++;
                        }
                        if (data261.quantity === void 0) {
                          const err672 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bema/" + i31, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bema/items/required", keyword: "required", params: { missingProperty: "quantity" }, message: "must have required property 'quantity'" };
                          if (vErrors === null) {
                            vErrors = [err672];
                          } else {
                            vErrors.push(err672);
                          }
                          errors++;
                        }
                        for (const key45 in data261) {
                          if (!func6.call(schema37.properties.projectedCosts.properties.teeth.items.properties.bema.items.properties, key45)) {
                            const err673 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bema/" + i31, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bema/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key45 }, message: "must NOT have additional properties" };
                            if (vErrors === null) {
                              vErrors = [err673];
                            } else {
                              vErrors.push(err673);
                            }
                            errors++;
                          }
                        }
                        if (data261.befund !== void 0) {
                          if (typeof data261.befund !== "string") {
                            const err674 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bema/" + i31 + "/befund", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bema/items/properties/befund/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err674];
                            } else {
                              vErrors.push(err674);
                            }
                            errors++;
                          }
                        }
                        if (data261.nr !== void 0) {
                          if (typeof data261.nr !== "string") {
                            const err675 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bema/" + i31 + "/nr", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bema/items/properties/nr/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err675];
                            } else {
                              vErrors.push(err675);
                            }
                            errors++;
                          }
                        }
                        if (data261.text !== void 0) {
                          if (typeof data261.text !== "string") {
                            const err676 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bema/" + i31 + "/text", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bema/items/properties/text/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err676];
                            } else {
                              vErrors.push(err676);
                            }
                            errors++;
                          }
                        }
                        if (data261.points !== void 0) {
                          let data265 = data261.points;
                          if (!(typeof data265 == "number" && (!(data265 % 1) && !isNaN(data265)) && isFinite(data265))) {
                            const err677 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bema/" + i31 + "/points", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bema/items/properties/points/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                            if (vErrors === null) {
                              vErrors = [err677];
                            } else {
                              vErrors.push(err677);
                            }
                            errors++;
                          }
                          if (typeof data265 == "number" && isFinite(data265)) {
                            if (data265 > 9007199254740991 || isNaN(data265)) {
                              const err678 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bema/" + i31 + "/points", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bema/items/properties/points/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err678];
                              } else {
                                vErrors.push(err678);
                              }
                              errors++;
                            }
                            if (data265 < -9007199254740991 || isNaN(data265)) {
                              const err679 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bema/" + i31 + "/points", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bema/items/properties/points/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err679];
                              } else {
                                vErrors.push(err679);
                              }
                              errors++;
                            }
                          }
                        }
                        if (data261.part !== void 0) {
                          if (typeof data261.part !== "string") {
                            const err680 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bema/" + i31 + "/part", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bema/items/properties/part/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err680];
                            } else {
                              vErrors.push(err680);
                            }
                            errors++;
                          }
                        }
                        if (data261.minus !== void 0) {
                          if (typeof data261.minus !== "boolean") {
                            const err681 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bema/" + i31 + "/minus", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bema/items/properties/minus/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                            if (vErrors === null) {
                              vErrors = [err681];
                            } else {
                              vErrors.push(err681);
                            }
                            errors++;
                          }
                        }
                        if (data261.quantity !== void 0) {
                          let data268 = data261.quantity;
                          const _errs597 = errors;
                          let valid114 = false;
                          const _errs598 = errors;
                          if (!(typeof data268 == "number" && (!(data268 % 1) && !isNaN(data268)) && isFinite(data268))) {
                            const err682 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bema/" + i31 + "/quantity", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bema/items/properties/quantity/anyOf/0/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                            if (vErrors === null) {
                              vErrors = [err682];
                            } else {
                              vErrors.push(err682);
                            }
                            errors++;
                          }
                          if (typeof data268 == "number" && isFinite(data268)) {
                            if (data268 > 9007199254740991 || isNaN(data268)) {
                              const err683 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bema/" + i31 + "/quantity", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bema/items/properties/quantity/anyOf/0/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err683];
                              } else {
                                vErrors.push(err683);
                              }
                              errors++;
                            }
                            if (data268 < -9007199254740991 || isNaN(data268)) {
                              const err684 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bema/" + i31 + "/quantity", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bema/items/properties/quantity/anyOf/0/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err684];
                              } else {
                                vErrors.push(err684);
                              }
                              errors++;
                            }
                          }
                          var _valid3 = _errs598 === errors;
                          valid114 = valid114 || _valid3;
                          if (!valid114) {
                            const _errs600 = errors;
                            if (data268 !== null) {
                              const err685 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bema/" + i31 + "/quantity", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bema/items/properties/quantity/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                              if (vErrors === null) {
                                vErrors = [err685];
                              } else {
                                vErrors.push(err685);
                              }
                              errors++;
                            }
                            var _valid3 = _errs600 === errors;
                            valid114 = valid114 || _valid3;
                          }
                          if (!valid114) {
                            const err686 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bema/" + i31 + "/quantity", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bema/items/properties/quantity/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                            if (vErrors === null) {
                              vErrors = [err686];
                            } else {
                              vErrors.push(err686);
                            }
                            errors++;
                          } else {
                            errors = _errs597;
                            if (vErrors !== null) {
                              if (_errs597) {
                                vErrors.length = _errs597;
                              } else {
                                vErrors = null;
                              }
                            }
                          }
                        }
                        if (data261.counted !== void 0) {
                          let data269 = data261.counted;
                          if (typeof data269 !== "boolean") {
                            const err687 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bema/" + i31 + "/counted", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bema/items/properties/counted/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                            if (vErrors === null) {
                              vErrors = [err687];
                            } else {
                              vErrors.push(err687);
                            }
                            errors++;
                          }
                          if (true !== data269) {
                            const err688 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bema/" + i31 + "/counted", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bema/items/properties/counted/const", keyword: "const", params: { allowedValue: true }, message: "must be equal to constant" };
                            if (vErrors === null) {
                              vErrors = [err688];
                            } else {
                              vErrors.push(err688);
                            }
                            errors++;
                          }
                        }
                        if (data261.cents !== void 0) {
                          let data270 = data261.cents;
                          if (!(typeof data270 == "number" && (!(data270 % 1) && !isNaN(data270)) && isFinite(data270))) {
                            const err689 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bema/" + i31 + "/cents", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bema/items/properties/cents/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                            if (vErrors === null) {
                              vErrors = [err689];
                            } else {
                              vErrors.push(err689);
                            }
                            errors++;
                          }
                          if (typeof data270 == "number" && isFinite(data270)) {
                            if (data270 > 9007199254740991 || isNaN(data270)) {
                              const err690 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bema/" + i31 + "/cents", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bema/items/properties/cents/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err690];
                              } else {
                                vErrors.push(err690);
                              }
                              errors++;
                            }
                            if (data270 < -9007199254740991 || isNaN(data270)) {
                              const err691 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bema/" + i31 + "/cents", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bema/items/properties/cents/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err691];
                              } else {
                                vErrors.push(err691);
                              }
                              errors++;
                            }
                          }
                        }
                        if (data261.excluded !== void 0) {
                          if (typeof data261.excluded !== "string") {
                            const err692 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bema/" + i31 + "/excluded", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bema/items/properties/excluded/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err692];
                            } else {
                              vErrors.push(err692);
                            }
                            errors++;
                          }
                        }
                        if (data261.source !== void 0) {
                          let data272 = data261.source;
                          if (data272 && typeof data272 == "object" && !Array.isArray(data272)) {
                            if (data272.chunkId === void 0) {
                              const err693 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bema/" + i31 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bema/items/properties/source/required", keyword: "required", params: { missingProperty: "chunkId" }, message: "must have required property 'chunkId'" };
                              if (vErrors === null) {
                                vErrors = [err693];
                              } else {
                                vErrors.push(err693);
                              }
                              errors++;
                            }
                            if (data272.title === void 0) {
                              const err694 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bema/" + i31 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bema/items/properties/source/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
                              if (vErrors === null) {
                                vErrors = [err694];
                              } else {
                                vErrors.push(err694);
                              }
                              errors++;
                            }
                            if (data272.url === void 0) {
                              const err695 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bema/" + i31 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bema/items/properties/source/required", keyword: "required", params: { missingProperty: "url" }, message: "must have required property 'url'" };
                              if (vErrors === null) {
                                vErrors = [err695];
                              } else {
                                vErrors.push(err695);
                              }
                              errors++;
                            }
                            for (const key46 in data272) {
                              if (!(key46 === "chunkId" || key46 === "title" || key46 === "url" || key46 === "page")) {
                                const err696 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bema/" + i31 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bema/items/properties/source/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key46 }, message: "must NOT have additional properties" };
                                if (vErrors === null) {
                                  vErrors = [err696];
                                } else {
                                  vErrors.push(err696);
                                }
                                errors++;
                              }
                            }
                            if (data272.chunkId !== void 0) {
                              if (typeof data272.chunkId !== "string") {
                                const err697 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bema/" + i31 + "/source/chunkId", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bema/items/properties/source/properties/chunkId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err697];
                                } else {
                                  vErrors.push(err697);
                                }
                                errors++;
                              }
                            }
                            if (data272.title !== void 0) {
                              if (typeof data272.title !== "string") {
                                const err698 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bema/" + i31 + "/source/title", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bema/items/properties/source/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err698];
                                } else {
                                  vErrors.push(err698);
                                }
                                errors++;
                              }
                            }
                            if (data272.url !== void 0) {
                              if (typeof data272.url !== "string") {
                                const err699 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bema/" + i31 + "/source/url", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bema/items/properties/source/properties/url/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err699];
                                } else {
                                  vErrors.push(err699);
                                }
                                errors++;
                              }
                            }
                            if (data272.page !== void 0) {
                              let data276 = data272.page;
                              if (!(typeof data276 == "number" && (!(data276 % 1) && !isNaN(data276)) && isFinite(data276))) {
                                const err700 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bema/" + i31 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bema/items/properties/source/properties/page/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                if (vErrors === null) {
                                  vErrors = [err700];
                                } else {
                                  vErrors.push(err700);
                                }
                                errors++;
                              }
                              if (typeof data276 == "number" && isFinite(data276)) {
                                if (data276 > 9007199254740991 || isNaN(data276)) {
                                  const err701 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bema/" + i31 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bema/items/properties/source/properties/page/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                                  if (vErrors === null) {
                                    vErrors = [err701];
                                  } else {
                                    vErrors.push(err701);
                                  }
                                  errors++;
                                }
                                if (data276 < -9007199254740991 || isNaN(data276)) {
                                  const err702 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bema/" + i31 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bema/items/properties/source/properties/page/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                                  if (vErrors === null) {
                                    vErrors = [err702];
                                  } else {
                                    vErrors.push(err702);
                                  }
                                  errors++;
                                }
                              }
                            }
                          } else {
                            const err703 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bema/" + i31 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bema/items/properties/source/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                            if (vErrors === null) {
                              vErrors = [err703];
                            } else {
                              vErrors.push(err703);
                            }
                            errors++;
                          }
                        }
                      } else {
                        const err704 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bema/" + i31, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bema/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                        if (vErrors === null) {
                          vErrors = [err704];
                        } else {
                          vErrors.push(err704);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err705 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bema", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bema/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                      vErrors = [err705];
                    } else {
                      vErrors.push(err705);
                    }
                    errors++;
                  }
                }
                if (data258.hkp !== void 0) {
                  let data277 = data258.hkp;
                  if (Array.isArray(data277)) {
                    const len32 = data277.length;
                    for (let i32 = 0; i32 < len32; i32++) {
                      let data278 = data277[i32];
                      if (data278 && typeof data278 == "object" && !Array.isArray(data278)) {
                        if (data278.nr === void 0) {
                          const err706 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/hkp/" + i32, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/hkp/items/required", keyword: "required", params: { missingProperty: "nr" }, message: "must have required property 'nr'" };
                          if (vErrors === null) {
                            vErrors = [err706];
                          } else {
                            vErrors.push(err706);
                          }
                          errors++;
                        }
                        if (data278.text === void 0) {
                          const err707 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/hkp/" + i32, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/hkp/items/required", keyword: "required", params: { missingProperty: "text" }, message: "must have required property 'text'" };
                          if (vErrors === null) {
                            vErrors = [err707];
                          } else {
                            vErrors.push(err707);
                          }
                          errors++;
                        }
                        if (data278.befunde === void 0) {
                          const err708 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/hkp/" + i32, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/hkp/items/required", keyword: "required", params: { missingProperty: "befunde" }, message: "must have required property 'befunde'" };
                          if (vErrors === null) {
                            vErrors = [err708];
                          } else {
                            vErrors.push(err708);
                          }
                          errors++;
                        }
                        if (data278.quantity === void 0) {
                          const err709 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/hkp/" + i32, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/hkp/items/required", keyword: "required", params: { missingProperty: "quantity" }, message: "must have required property 'quantity'" };
                          if (vErrors === null) {
                            vErrors = [err709];
                          } else {
                            vErrors.push(err709);
                          }
                          errors++;
                        }
                        if (data278.counted === void 0) {
                          const err710 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/hkp/" + i32, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/hkp/items/required", keyword: "required", params: { missingProperty: "counted" }, message: "must have required property 'counted'" };
                          if (vErrors === null) {
                            vErrors = [err710];
                          } else {
                            vErrors.push(err710);
                          }
                          errors++;
                        }
                        for (const key47 in data278) {
                          if (!(key47 === "nr" || key47 === "text" || key47 === "befunde" || key47 === "quantity" || key47 === "counted" || key47 === "cents" || key47 === "source")) {
                            const err711 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/hkp/" + i32, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/hkp/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key47 }, message: "must NOT have additional properties" };
                            if (vErrors === null) {
                              vErrors = [err711];
                            } else {
                              vErrors.push(err711);
                            }
                            errors++;
                          }
                        }
                        if (data278.nr !== void 0) {
                          if (typeof data278.nr !== "string") {
                            const err712 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/hkp/" + i32 + "/nr", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/hkp/items/properties/nr/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err712];
                            } else {
                              vErrors.push(err712);
                            }
                            errors++;
                          }
                        }
                        if (data278.text !== void 0) {
                          if (typeof data278.text !== "string") {
                            const err713 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/hkp/" + i32 + "/text", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/hkp/items/properties/text/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err713];
                            } else {
                              vErrors.push(err713);
                            }
                            errors++;
                          }
                        }
                        if (data278.befunde !== void 0) {
                          if (typeof data278.befunde !== "string") {
                            const err714 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/hkp/" + i32 + "/befunde", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/hkp/items/properties/befunde/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err714];
                            } else {
                              vErrors.push(err714);
                            }
                            errors++;
                          }
                        }
                        if (data278.quantity !== void 0) {
                          let data282 = data278.quantity;
                          if (!(typeof data282 == "number" && (!(data282 % 1) && !isNaN(data282)) && isFinite(data282))) {
                            const err715 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/hkp/" + i32 + "/quantity", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/hkp/items/properties/quantity/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                            if (vErrors === null) {
                              vErrors = [err715];
                            } else {
                              vErrors.push(err715);
                            }
                            errors++;
                          }
                          if (typeof data282 == "number" && isFinite(data282)) {
                            if (data282 > 9007199254740991 || isNaN(data282)) {
                              const err716 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/hkp/" + i32 + "/quantity", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/hkp/items/properties/quantity/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err716];
                              } else {
                                vErrors.push(err716);
                              }
                              errors++;
                            }
                            if (data282 < -9007199254740991 || isNaN(data282)) {
                              const err717 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/hkp/" + i32 + "/quantity", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/hkp/items/properties/quantity/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err717];
                              } else {
                                vErrors.push(err717);
                              }
                              errors++;
                            }
                          }
                        }
                        if (data278.counted !== void 0) {
                          let data283 = data278.counted;
                          if (typeof data283 !== "string") {
                            const err718 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/hkp/" + i32 + "/counted", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/hkp/items/properties/counted/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err718];
                            } else {
                              vErrors.push(err718);
                            }
                            errors++;
                          }
                          if (!(data283 === "bema" || data283 === "dentist" || data283 === "assumed")) {
                            const err719 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/hkp/" + i32 + "/counted", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/hkp/items/properties/counted/enum", keyword: "enum", params: { allowedValues: schema37.properties.projectedCosts.properties.teeth.items.properties.hkp.items.properties.counted.enum }, message: "must be equal to one of the allowed values" };
                            if (vErrors === null) {
                              vErrors = [err719];
                            } else {
                              vErrors.push(err719);
                            }
                            errors++;
                          }
                        }
                        if (data278.cents !== void 0) {
                          let data284 = data278.cents;
                          if (!(typeof data284 == "number" && (!(data284 % 1) && !isNaN(data284)) && isFinite(data284))) {
                            const err720 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/hkp/" + i32 + "/cents", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/hkp/items/properties/cents/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                            if (vErrors === null) {
                              vErrors = [err720];
                            } else {
                              vErrors.push(err720);
                            }
                            errors++;
                          }
                          if (typeof data284 == "number" && isFinite(data284)) {
                            if (data284 > 9007199254740991 || isNaN(data284)) {
                              const err721 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/hkp/" + i32 + "/cents", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/hkp/items/properties/cents/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err721];
                              } else {
                                vErrors.push(err721);
                              }
                              errors++;
                            }
                            if (data284 < -9007199254740991 || isNaN(data284)) {
                              const err722 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/hkp/" + i32 + "/cents", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/hkp/items/properties/cents/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err722];
                              } else {
                                vErrors.push(err722);
                              }
                              errors++;
                            }
                          }
                        }
                        if (data278.source !== void 0) {
                          let data285 = data278.source;
                          if (data285 && typeof data285 == "object" && !Array.isArray(data285)) {
                            if (data285.chunkId === void 0) {
                              const err723 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/hkp/" + i32 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/hkp/items/properties/source/required", keyword: "required", params: { missingProperty: "chunkId" }, message: "must have required property 'chunkId'" };
                              if (vErrors === null) {
                                vErrors = [err723];
                              } else {
                                vErrors.push(err723);
                              }
                              errors++;
                            }
                            if (data285.title === void 0) {
                              const err724 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/hkp/" + i32 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/hkp/items/properties/source/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
                              if (vErrors === null) {
                                vErrors = [err724];
                              } else {
                                vErrors.push(err724);
                              }
                              errors++;
                            }
                            if (data285.url === void 0) {
                              const err725 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/hkp/" + i32 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/hkp/items/properties/source/required", keyword: "required", params: { missingProperty: "url" }, message: "must have required property 'url'" };
                              if (vErrors === null) {
                                vErrors = [err725];
                              } else {
                                vErrors.push(err725);
                              }
                              errors++;
                            }
                            for (const key48 in data285) {
                              if (!(key48 === "chunkId" || key48 === "title" || key48 === "url" || key48 === "page")) {
                                const err726 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/hkp/" + i32 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/hkp/items/properties/source/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key48 }, message: "must NOT have additional properties" };
                                if (vErrors === null) {
                                  vErrors = [err726];
                                } else {
                                  vErrors.push(err726);
                                }
                                errors++;
                              }
                            }
                            if (data285.chunkId !== void 0) {
                              if (typeof data285.chunkId !== "string") {
                                const err727 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/hkp/" + i32 + "/source/chunkId", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/hkp/items/properties/source/properties/chunkId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err727];
                                } else {
                                  vErrors.push(err727);
                                }
                                errors++;
                              }
                            }
                            if (data285.title !== void 0) {
                              if (typeof data285.title !== "string") {
                                const err728 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/hkp/" + i32 + "/source/title", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/hkp/items/properties/source/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err728];
                                } else {
                                  vErrors.push(err728);
                                }
                                errors++;
                              }
                            }
                            if (data285.url !== void 0) {
                              if (typeof data285.url !== "string") {
                                const err729 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/hkp/" + i32 + "/source/url", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/hkp/items/properties/source/properties/url/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err729];
                                } else {
                                  vErrors.push(err729);
                                }
                                errors++;
                              }
                            }
                            if (data285.page !== void 0) {
                              let data289 = data285.page;
                              if (!(typeof data289 == "number" && (!(data289 % 1) && !isNaN(data289)) && isFinite(data289))) {
                                const err730 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/hkp/" + i32 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/hkp/items/properties/source/properties/page/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                if (vErrors === null) {
                                  vErrors = [err730];
                                } else {
                                  vErrors.push(err730);
                                }
                                errors++;
                              }
                              if (typeof data289 == "number" && isFinite(data289)) {
                                if (data289 > 9007199254740991 || isNaN(data289)) {
                                  const err731 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/hkp/" + i32 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/hkp/items/properties/source/properties/page/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                                  if (vErrors === null) {
                                    vErrors = [err731];
                                  } else {
                                    vErrors.push(err731);
                                  }
                                  errors++;
                                }
                                if (data289 < -9007199254740991 || isNaN(data289)) {
                                  const err732 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/hkp/" + i32 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/hkp/items/properties/source/properties/page/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                                  if (vErrors === null) {
                                    vErrors = [err732];
                                  } else {
                                    vErrors.push(err732);
                                  }
                                  errors++;
                                }
                              }
                            }
                          } else {
                            const err733 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/hkp/" + i32 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/hkp/items/properties/source/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                            if (vErrors === null) {
                              vErrors = [err733];
                            } else {
                              vErrors.push(err733);
                            }
                            errors++;
                          }
                        }
                      } else {
                        const err734 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/hkp/" + i32, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/hkp/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                        if (vErrors === null) {
                          vErrors = [err734];
                        } else {
                          vErrors.push(err734);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err735 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/hkp", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/hkp/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                      vErrors = [err735];
                    } else {
                      vErrors.push(err735);
                    }
                    errors++;
                  }
                }
                if (data258.bel !== void 0) {
                  let data290 = data258.bel;
                  if (Array.isArray(data290)) {
                    const len33 = data290.length;
                    for (let i33 = 0; i33 < len33; i33++) {
                      let data291 = data290[i33];
                      if (data291 && typeof data291 == "object" && !Array.isArray(data291)) {
                        if (data291.befund === void 0) {
                          const err736 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bel/" + i33, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bel/items/required", keyword: "required", params: { missingProperty: "befund" }, message: "must have required property 'befund'" };
                          if (vErrors === null) {
                            vErrors = [err736];
                          } else {
                            vErrors.push(err736);
                          }
                          errors++;
                        }
                        if (data291.nr === void 0) {
                          const err737 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bel/" + i33, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bel/items/required", keyword: "required", params: { missingProperty: "nr" }, message: "must have required property 'nr'" };
                          if (vErrors === null) {
                            vErrors = [err737];
                          } else {
                            vErrors.push(err737);
                          }
                          errors++;
                        }
                        if (data291.text === void 0) {
                          const err738 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bel/" + i33, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bel/items/required", keyword: "required", params: { missingProperty: "text" }, message: "must have required property 'text'" };
                          if (vErrors === null) {
                            vErrors = [err738];
                          } else {
                            vErrors.push(err738);
                          }
                          errors++;
                        }
                        if (data291.minus === void 0) {
                          const err739 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bel/" + i33, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bel/items/required", keyword: "required", params: { missingProperty: "minus" }, message: "must have required property 'minus'" };
                          if (vErrors === null) {
                            vErrors = [err739];
                          } else {
                            vErrors.push(err739);
                          }
                          errors++;
                        }
                        for (const key49 in data291) {
                          if (!(key49 === "befund" || key49 === "nr" || key49 === "text" || key49 === "minus" || key49 === "source")) {
                            const err740 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bel/" + i33, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bel/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key49 }, message: "must NOT have additional properties" };
                            if (vErrors === null) {
                              vErrors = [err740];
                            } else {
                              vErrors.push(err740);
                            }
                            errors++;
                          }
                        }
                        if (data291.befund !== void 0) {
                          if (typeof data291.befund !== "string") {
                            const err741 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bel/" + i33 + "/befund", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bel/items/properties/befund/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err741];
                            } else {
                              vErrors.push(err741);
                            }
                            errors++;
                          }
                        }
                        if (data291.nr !== void 0) {
                          if (typeof data291.nr !== "string") {
                            const err742 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bel/" + i33 + "/nr", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bel/items/properties/nr/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err742];
                            } else {
                              vErrors.push(err742);
                            }
                            errors++;
                          }
                        }
                        if (data291.text !== void 0) {
                          if (typeof data291.text !== "string") {
                            const err743 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bel/" + i33 + "/text", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bel/items/properties/text/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err743];
                            } else {
                              vErrors.push(err743);
                            }
                            errors++;
                          }
                        }
                        if (data291.minus !== void 0) {
                          if (typeof data291.minus !== "boolean") {
                            const err744 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bel/" + i33 + "/minus", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bel/items/properties/minus/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                            if (vErrors === null) {
                              vErrors = [err744];
                            } else {
                              vErrors.push(err744);
                            }
                            errors++;
                          }
                        }
                        if (data291.source !== void 0) {
                          let data296 = data291.source;
                          if (data296 && typeof data296 == "object" && !Array.isArray(data296)) {
                            if (data296.chunkId === void 0) {
                              const err745 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bel/" + i33 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bel/items/properties/source/required", keyword: "required", params: { missingProperty: "chunkId" }, message: "must have required property 'chunkId'" };
                              if (vErrors === null) {
                                vErrors = [err745];
                              } else {
                                vErrors.push(err745);
                              }
                              errors++;
                            }
                            if (data296.title === void 0) {
                              const err746 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bel/" + i33 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bel/items/properties/source/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
                              if (vErrors === null) {
                                vErrors = [err746];
                              } else {
                                vErrors.push(err746);
                              }
                              errors++;
                            }
                            if (data296.url === void 0) {
                              const err747 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bel/" + i33 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bel/items/properties/source/required", keyword: "required", params: { missingProperty: "url" }, message: "must have required property 'url'" };
                              if (vErrors === null) {
                                vErrors = [err747];
                              } else {
                                vErrors.push(err747);
                              }
                              errors++;
                            }
                            for (const key50 in data296) {
                              if (!(key50 === "chunkId" || key50 === "title" || key50 === "url" || key50 === "page")) {
                                const err748 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bel/" + i33 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bel/items/properties/source/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key50 }, message: "must NOT have additional properties" };
                                if (vErrors === null) {
                                  vErrors = [err748];
                                } else {
                                  vErrors.push(err748);
                                }
                                errors++;
                              }
                            }
                            if (data296.chunkId !== void 0) {
                              if (typeof data296.chunkId !== "string") {
                                const err749 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bel/" + i33 + "/source/chunkId", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bel/items/properties/source/properties/chunkId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err749];
                                } else {
                                  vErrors.push(err749);
                                }
                                errors++;
                              }
                            }
                            if (data296.title !== void 0) {
                              if (typeof data296.title !== "string") {
                                const err750 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bel/" + i33 + "/source/title", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bel/items/properties/source/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err750];
                                } else {
                                  vErrors.push(err750);
                                }
                                errors++;
                              }
                            }
                            if (data296.url !== void 0) {
                              if (typeof data296.url !== "string") {
                                const err751 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bel/" + i33 + "/source/url", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bel/items/properties/source/properties/url/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err751];
                                } else {
                                  vErrors.push(err751);
                                }
                                errors++;
                              }
                            }
                            if (data296.page !== void 0) {
                              let data300 = data296.page;
                              if (!(typeof data300 == "number" && (!(data300 % 1) && !isNaN(data300)) && isFinite(data300))) {
                                const err752 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bel/" + i33 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bel/items/properties/source/properties/page/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                if (vErrors === null) {
                                  vErrors = [err752];
                                } else {
                                  vErrors.push(err752);
                                }
                                errors++;
                              }
                              if (typeof data300 == "number" && isFinite(data300)) {
                                if (data300 > 9007199254740991 || isNaN(data300)) {
                                  const err753 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bel/" + i33 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bel/items/properties/source/properties/page/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                                  if (vErrors === null) {
                                    vErrors = [err753];
                                  } else {
                                    vErrors.push(err753);
                                  }
                                  errors++;
                                }
                                if (data300 < -9007199254740991 || isNaN(data300)) {
                                  const err754 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bel/" + i33 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bel/items/properties/source/properties/page/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                                  if (vErrors === null) {
                                    vErrors = [err754];
                                  } else {
                                    vErrors.push(err754);
                                  }
                                  errors++;
                                }
                              }
                            }
                          } else {
                            const err755 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bel/" + i33 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bel/items/properties/source/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                            if (vErrors === null) {
                              vErrors = [err755];
                            } else {
                              vErrors.push(err755);
                            }
                            errors++;
                          }
                        }
                      } else {
                        const err756 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bel/" + i33, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bel/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                        if (vErrors === null) {
                          vErrors = [err756];
                        } else {
                          vErrors.push(err756);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err757 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/bel", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/bel/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                      vErrors = [err757];
                    } else {
                      vErrors.push(err757);
                    }
                    errors++;
                  }
                }
                if (data258.materials !== void 0) {
                  let data301 = data258.materials;
                  if (Array.isArray(data301)) {
                    const len34 = data301.length;
                    for (let i34 = 0; i34 < len34; i34++) {
                      let data302 = data301[i34];
                      if (data302 && typeof data302 == "object" && !Array.isArray(data302)) {
                        if (data302.befund === void 0) {
                          const err758 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/materials/" + i34, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/materials/items/required", keyword: "required", params: { missingProperty: "befund" }, message: "must have required property 'befund'" };
                          if (vErrors === null) {
                            vErrors = [err758];
                          } else {
                            vErrors.push(err758);
                          }
                          errors++;
                        }
                        if (data302.name === void 0) {
                          const err759 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/materials/" + i34, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/materials/items/required", keyword: "required", params: { missingProperty: "name" }, message: "must have required property 'name'" };
                          if (vErrors === null) {
                            vErrors = [err759];
                          } else {
                            vErrors.push(err759);
                          }
                          errors++;
                        }
                        for (const key51 in data302) {
                          if (!(key51 === "befund" || key51 === "name" || key51 === "source")) {
                            const err760 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/materials/" + i34, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/materials/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key51 }, message: "must NOT have additional properties" };
                            if (vErrors === null) {
                              vErrors = [err760];
                            } else {
                              vErrors.push(err760);
                            }
                            errors++;
                          }
                        }
                        if (data302.befund !== void 0) {
                          if (typeof data302.befund !== "string") {
                            const err761 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/materials/" + i34 + "/befund", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/materials/items/properties/befund/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err761];
                            } else {
                              vErrors.push(err761);
                            }
                            errors++;
                          }
                        }
                        if (data302.name !== void 0) {
                          if (typeof data302.name !== "string") {
                            const err762 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/materials/" + i34 + "/name", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/materials/items/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err762];
                            } else {
                              vErrors.push(err762);
                            }
                            errors++;
                          }
                        }
                        if (data302.source !== void 0) {
                          let data305 = data302.source;
                          if (data305 && typeof data305 == "object" && !Array.isArray(data305)) {
                            if (data305.chunkId === void 0) {
                              const err763 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/materials/" + i34 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/materials/items/properties/source/required", keyword: "required", params: { missingProperty: "chunkId" }, message: "must have required property 'chunkId'" };
                              if (vErrors === null) {
                                vErrors = [err763];
                              } else {
                                vErrors.push(err763);
                              }
                              errors++;
                            }
                            if (data305.title === void 0) {
                              const err764 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/materials/" + i34 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/materials/items/properties/source/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
                              if (vErrors === null) {
                                vErrors = [err764];
                              } else {
                                vErrors.push(err764);
                              }
                              errors++;
                            }
                            if (data305.url === void 0) {
                              const err765 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/materials/" + i34 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/materials/items/properties/source/required", keyword: "required", params: { missingProperty: "url" }, message: "must have required property 'url'" };
                              if (vErrors === null) {
                                vErrors = [err765];
                              } else {
                                vErrors.push(err765);
                              }
                              errors++;
                            }
                            for (const key52 in data305) {
                              if (!(key52 === "chunkId" || key52 === "title" || key52 === "url" || key52 === "page")) {
                                const err766 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/materials/" + i34 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/materials/items/properties/source/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key52 }, message: "must NOT have additional properties" };
                                if (vErrors === null) {
                                  vErrors = [err766];
                                } else {
                                  vErrors.push(err766);
                                }
                                errors++;
                              }
                            }
                            if (data305.chunkId !== void 0) {
                              if (typeof data305.chunkId !== "string") {
                                const err767 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/materials/" + i34 + "/source/chunkId", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/materials/items/properties/source/properties/chunkId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err767];
                                } else {
                                  vErrors.push(err767);
                                }
                                errors++;
                              }
                            }
                            if (data305.title !== void 0) {
                              if (typeof data305.title !== "string") {
                                const err768 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/materials/" + i34 + "/source/title", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/materials/items/properties/source/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err768];
                                } else {
                                  vErrors.push(err768);
                                }
                                errors++;
                              }
                            }
                            if (data305.url !== void 0) {
                              if (typeof data305.url !== "string") {
                                const err769 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/materials/" + i34 + "/source/url", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/materials/items/properties/source/properties/url/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err769];
                                } else {
                                  vErrors.push(err769);
                                }
                                errors++;
                              }
                            }
                            if (data305.page !== void 0) {
                              let data309 = data305.page;
                              if (!(typeof data309 == "number" && (!(data309 % 1) && !isNaN(data309)) && isFinite(data309))) {
                                const err770 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/materials/" + i34 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/materials/items/properties/source/properties/page/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                if (vErrors === null) {
                                  vErrors = [err770];
                                } else {
                                  vErrors.push(err770);
                                }
                                errors++;
                              }
                              if (typeof data309 == "number" && isFinite(data309)) {
                                if (data309 > 9007199254740991 || isNaN(data309)) {
                                  const err771 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/materials/" + i34 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/materials/items/properties/source/properties/page/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                                  if (vErrors === null) {
                                    vErrors = [err771];
                                  } else {
                                    vErrors.push(err771);
                                  }
                                  errors++;
                                }
                                if (data309 < -9007199254740991 || isNaN(data309)) {
                                  const err772 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/materials/" + i34 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/materials/items/properties/source/properties/page/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                                  if (vErrors === null) {
                                    vErrors = [err772];
                                  } else {
                                    vErrors.push(err772);
                                  }
                                  errors++;
                                }
                              }
                            }
                          } else {
                            const err773 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/materials/" + i34 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/materials/items/properties/source/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                            if (vErrors === null) {
                              vErrors = [err773];
                            } else {
                              vErrors.push(err773);
                            }
                            errors++;
                          }
                        }
                      } else {
                        const err774 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/materials/" + i34, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/materials/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                        if (vErrors === null) {
                          vErrors = [err774];
                        } else {
                          vErrors.push(err774);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err775 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/materials", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/materials/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                      vErrors = [err775];
                    } else {
                      vErrors.push(err775);
                    }
                    errors++;
                  }
                }
                if (data258.labor !== void 0) {
                  let data310 = data258.labor;
                  if (!(typeof data310 == "number" && (!(data310 % 1) && !isNaN(data310)) && isFinite(data310))) {
                    const err776 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/labor", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/labor/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err776];
                    } else {
                      vErrors.push(err776);
                    }
                    errors++;
                  }
                  if (typeof data310 == "number" && isFinite(data310)) {
                    if (data310 > 9007199254740991 || isNaN(data310)) {
                      const err777 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/labor", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/labor/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err777];
                      } else {
                        vErrors.push(err777);
                      }
                      errors++;
                    }
                    if (data310 < -9007199254740991 || isNaN(data310)) {
                      const err778 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/labor", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/labor/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err778];
                      } else {
                        vErrors.push(err778);
                      }
                      errors++;
                    }
                  }
                }
                if (data258.versorgung !== void 0) {
                  let data311 = data258.versorgung;
                  if (data311 && typeof data311 == "object" && !Array.isArray(data311)) {
                    if (data311.geplant === void 0) {
                      const err779 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/versorgung", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/versorgung/required", keyword: "required", params: { missingProperty: "geplant" }, message: "must have required property 'geplant'" };
                      if (vErrors === null) {
                        vErrors = [err779];
                      } else {
                        vErrors.push(err779);
                      }
                      errors++;
                    }
                    if (data311.klasse === void 0) {
                      const err780 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/versorgung", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/versorgung/required", keyword: "required", params: { missingProperty: "klasse" }, message: "must have required property 'klasse'" };
                      if (vErrors === null) {
                        vErrors = [err780];
                      } else {
                        vErrors.push(err780);
                      }
                      errors++;
                    }
                    for (const key53 in data311) {
                      if (!(key53 === "geplant" || key53 === "klasse")) {
                        const err781 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/versorgung", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/versorgung/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key53 }, message: "must NOT have additional properties" };
                        if (vErrors === null) {
                          vErrors = [err781];
                        } else {
                          vErrors.push(err781);
                        }
                        errors++;
                      }
                    }
                    if (data311.geplant !== void 0) {
                      if (typeof data311.geplant !== "string") {
                        const err782 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/versorgung/geplant", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/versorgung/properties/geplant/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err782];
                        } else {
                          vErrors.push(err782);
                        }
                        errors++;
                      }
                    }
                    if (data311.klasse !== void 0) {
                      let data313 = data311.klasse;
                      if (typeof data313 !== "string") {
                        const err783 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/versorgung/klasse", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/versorgung/properties/klasse/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err783];
                        } else {
                          vErrors.push(err783);
                        }
                        errors++;
                      }
                      if (!(data313 === "regelversorgung" || data313 === "gleichartig")) {
                        const err784 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/versorgung/klasse", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/versorgung/properties/klasse/enum", keyword: "enum", params: { allowedValues: schema37.properties.projectedCosts.properties.teeth.items.properties.versorgung.properties.klasse.enum }, message: "must be equal to one of the allowed values" };
                        if (vErrors === null) {
                          vErrors = [err784];
                        } else {
                          vErrors.push(err784);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err785 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/versorgung", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/versorgung/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                    if (vErrors === null) {
                      vErrors = [err785];
                    } else {
                      vErrors.push(err785);
                    }
                    errors++;
                  }
                }
                if (data258.goz !== void 0) {
                  let data314 = data258.goz;
                  if (Array.isArray(data314)) {
                    const len35 = data314.length;
                    for (let i35 = 0; i35 < len35; i35++) {
                      let data315 = data314[i35];
                      if (data315 && typeof data315 == "object" && !Array.isArray(data315)) {
                        if (data315.nr === void 0) {
                          const err786 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/goz/" + i35, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/goz/items/required", keyword: "required", params: { missingProperty: "nr" }, message: "must have required property 'nr'" };
                          if (vErrors === null) {
                            vErrors = [err786];
                          } else {
                            vErrors.push(err786);
                          }
                          errors++;
                        }
                        if (data315.title === void 0) {
                          const err787 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/goz/" + i35, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/goz/items/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
                          if (vErrors === null) {
                            vErrors = [err787];
                          } else {
                            vErrors.push(err787);
                          }
                          errors++;
                        }
                        if (data315.points === void 0) {
                          const err788 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/goz/" + i35, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/goz/items/required", keyword: "required", params: { missingProperty: "points" }, message: "must have required property 'points'" };
                          if (vErrors === null) {
                            vErrors = [err788];
                          } else {
                            vErrors.push(err788);
                          }
                          errors++;
                        }
                        if (data315.faktor === void 0) {
                          const err789 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/goz/" + i35, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/goz/items/required", keyword: "required", params: { missingProperty: "faktor" }, message: "must have required property 'faktor'" };
                          if (vErrors === null) {
                            vErrors = [err789];
                          } else {
                            vErrors.push(err789);
                          }
                          errors++;
                        }
                        if (data315.cents === void 0) {
                          const err790 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/goz/" + i35, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/goz/items/required", keyword: "required", params: { missingProperty: "cents" }, message: "must have required property 'cents'" };
                          if (vErrors === null) {
                            vErrors = [err790];
                          } else {
                            vErrors.push(err790);
                          }
                          errors++;
                        }
                        for (const key54 in data315) {
                          if (!(key54 === "nr" || key54 === "title" || key54 === "points" || key54 === "faktor" || key54 === "cents" || key54 === "excluded" || key54 === "source")) {
                            const err791 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/goz/" + i35, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/goz/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key54 }, message: "must NOT have additional properties" };
                            if (vErrors === null) {
                              vErrors = [err791];
                            } else {
                              vErrors.push(err791);
                            }
                            errors++;
                          }
                        }
                        if (data315.nr !== void 0) {
                          if (typeof data315.nr !== "string") {
                            const err792 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/goz/" + i35 + "/nr", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/goz/items/properties/nr/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err792];
                            } else {
                              vErrors.push(err792);
                            }
                            errors++;
                          }
                        }
                        if (data315.title !== void 0) {
                          if (typeof data315.title !== "string") {
                            const err793 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/goz/" + i35 + "/title", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/goz/items/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err793];
                            } else {
                              vErrors.push(err793);
                            }
                            errors++;
                          }
                        }
                        if (data315.points !== void 0) {
                          let data318 = data315.points;
                          if (!(typeof data318 == "number" && (!(data318 % 1) && !isNaN(data318)) && isFinite(data318))) {
                            const err794 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/goz/" + i35 + "/points", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/goz/items/properties/points/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                            if (vErrors === null) {
                              vErrors = [err794];
                            } else {
                              vErrors.push(err794);
                            }
                            errors++;
                          }
                          if (typeof data318 == "number" && isFinite(data318)) {
                            if (data318 > 9007199254740991 || isNaN(data318)) {
                              const err795 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/goz/" + i35 + "/points", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/goz/items/properties/points/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err795];
                              } else {
                                vErrors.push(err795);
                              }
                              errors++;
                            }
                            if (data318 < -9007199254740991 || isNaN(data318)) {
                              const err796 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/goz/" + i35 + "/points", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/goz/items/properties/points/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err796];
                              } else {
                                vErrors.push(err796);
                              }
                              errors++;
                            }
                          }
                        }
                        if (data315.faktor !== void 0) {
                          let data319 = data315.faktor;
                          if (!(typeof data319 == "number" && (!(data319 % 1) && !isNaN(data319)) && isFinite(data319))) {
                            const err797 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/goz/" + i35 + "/faktor", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/goz/items/properties/faktor/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                            if (vErrors === null) {
                              vErrors = [err797];
                            } else {
                              vErrors.push(err797);
                            }
                            errors++;
                          }
                          if (typeof data319 == "number" && isFinite(data319)) {
                            if (data319 > 9007199254740991 || isNaN(data319)) {
                              const err798 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/goz/" + i35 + "/faktor", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/goz/items/properties/faktor/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err798];
                              } else {
                                vErrors.push(err798);
                              }
                              errors++;
                            }
                            if (data319 < -9007199254740991 || isNaN(data319)) {
                              const err799 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/goz/" + i35 + "/faktor", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/goz/items/properties/faktor/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err799];
                              } else {
                                vErrors.push(err799);
                              }
                              errors++;
                            }
                          }
                        }
                        if (data315.cents !== void 0) {
                          let data320 = data315.cents;
                          if (!(typeof data320 == "number" && (!(data320 % 1) && !isNaN(data320)) && isFinite(data320))) {
                            const err800 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/goz/" + i35 + "/cents", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/goz/items/properties/cents/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                            if (vErrors === null) {
                              vErrors = [err800];
                            } else {
                              vErrors.push(err800);
                            }
                            errors++;
                          }
                          if (typeof data320 == "number" && isFinite(data320)) {
                            if (data320 > 9007199254740991 || isNaN(data320)) {
                              const err801 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/goz/" + i35 + "/cents", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/goz/items/properties/cents/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err801];
                              } else {
                                vErrors.push(err801);
                              }
                              errors++;
                            }
                            if (data320 < -9007199254740991 || isNaN(data320)) {
                              const err802 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/goz/" + i35 + "/cents", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/goz/items/properties/cents/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err802];
                              } else {
                                vErrors.push(err802);
                              }
                              errors++;
                            }
                          }
                        }
                        if (data315.excluded !== void 0) {
                          if (typeof data315.excluded !== "string") {
                            const err803 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/goz/" + i35 + "/excluded", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/goz/items/properties/excluded/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err803];
                            } else {
                              vErrors.push(err803);
                            }
                            errors++;
                          }
                        }
                        if (data315.source !== void 0) {
                          let data322 = data315.source;
                          if (data322 && typeof data322 == "object" && !Array.isArray(data322)) {
                            if (data322.chunkId === void 0) {
                              const err804 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/goz/" + i35 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/goz/items/properties/source/required", keyword: "required", params: { missingProperty: "chunkId" }, message: "must have required property 'chunkId'" };
                              if (vErrors === null) {
                                vErrors = [err804];
                              } else {
                                vErrors.push(err804);
                              }
                              errors++;
                            }
                            if (data322.title === void 0) {
                              const err805 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/goz/" + i35 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/goz/items/properties/source/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
                              if (vErrors === null) {
                                vErrors = [err805];
                              } else {
                                vErrors.push(err805);
                              }
                              errors++;
                            }
                            if (data322.url === void 0) {
                              const err806 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/goz/" + i35 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/goz/items/properties/source/required", keyword: "required", params: { missingProperty: "url" }, message: "must have required property 'url'" };
                              if (vErrors === null) {
                                vErrors = [err806];
                              } else {
                                vErrors.push(err806);
                              }
                              errors++;
                            }
                            for (const key55 in data322) {
                              if (!(key55 === "chunkId" || key55 === "title" || key55 === "url" || key55 === "page")) {
                                const err807 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/goz/" + i35 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/goz/items/properties/source/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key55 }, message: "must NOT have additional properties" };
                                if (vErrors === null) {
                                  vErrors = [err807];
                                } else {
                                  vErrors.push(err807);
                                }
                                errors++;
                              }
                            }
                            if (data322.chunkId !== void 0) {
                              if (typeof data322.chunkId !== "string") {
                                const err808 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/goz/" + i35 + "/source/chunkId", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/goz/items/properties/source/properties/chunkId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err808];
                                } else {
                                  vErrors.push(err808);
                                }
                                errors++;
                              }
                            }
                            if (data322.title !== void 0) {
                              if (typeof data322.title !== "string") {
                                const err809 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/goz/" + i35 + "/source/title", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/goz/items/properties/source/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err809];
                                } else {
                                  vErrors.push(err809);
                                }
                                errors++;
                              }
                            }
                            if (data322.url !== void 0) {
                              if (typeof data322.url !== "string") {
                                const err810 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/goz/" + i35 + "/source/url", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/goz/items/properties/source/properties/url/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err810];
                                } else {
                                  vErrors.push(err810);
                                }
                                errors++;
                              }
                            }
                            if (data322.page !== void 0) {
                              let data326 = data322.page;
                              if (!(typeof data326 == "number" && (!(data326 % 1) && !isNaN(data326)) && isFinite(data326))) {
                                const err811 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/goz/" + i35 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/goz/items/properties/source/properties/page/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                if (vErrors === null) {
                                  vErrors = [err811];
                                } else {
                                  vErrors.push(err811);
                                }
                                errors++;
                              }
                              if (typeof data326 == "number" && isFinite(data326)) {
                                if (data326 > 9007199254740991 || isNaN(data326)) {
                                  const err812 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/goz/" + i35 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/goz/items/properties/source/properties/page/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                                  if (vErrors === null) {
                                    vErrors = [err812];
                                  } else {
                                    vErrors.push(err812);
                                  }
                                  errors++;
                                }
                                if (data326 < -9007199254740991 || isNaN(data326)) {
                                  const err813 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/goz/" + i35 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/goz/items/properties/source/properties/page/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                                  if (vErrors === null) {
                                    vErrors = [err813];
                                  } else {
                                    vErrors.push(err813);
                                  }
                                  errors++;
                                }
                              }
                            }
                          } else {
                            const err814 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/goz/" + i35 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/goz/items/properties/source/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                            if (vErrors === null) {
                              vErrors = [err814];
                            } else {
                              vErrors.push(err814);
                            }
                            errors++;
                          }
                        }
                      } else {
                        const err815 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/goz/" + i35, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/goz/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                        if (vErrors === null) {
                          vErrors = [err815];
                        } else {
                          vErrors.push(err815);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err816 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30 + "/goz", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/properties/goz/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                      vErrors = [err816];
                    } else {
                      vErrors.push(err816);
                    }
                    errors++;
                  }
                }
              } else {
                const err817 = { instancePath: instancePath + "/projectedCosts/teeth/" + i30, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                if (vErrors === null) {
                  vErrors = [err817];
                } else {
                  vErrors.push(err817);
                }
                errors++;
              }
            }
          } else {
            const err818 = { instancePath: instancePath + "/projectedCosts/teeth", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/teeth/type", keyword: "type", params: { type: "array" }, message: "must be array" };
            if (vErrors === null) {
              vErrors = [err818];
            } else {
              vErrors.push(err818);
            }
            errors++;
          }
        }
        if (data256.luecken !== void 0) {
          let data327 = data256.luecken;
          if (Array.isArray(data327)) {
            const len36 = data327.length;
            for (let i36 = 0; i36 < len36; i36++) {
              let data328 = data327[i36];
              if (data328 && typeof data328 == "object" && !Array.isArray(data328)) {
                if (data328.luecke === void 0) {
                  const err819 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/required", keyword: "required", params: { missingProperty: "luecke" }, message: "must have required property 'luecke'" };
                  if (vErrors === null) {
                    vErrors = [err819];
                  } else {
                    vErrors.push(err819);
                  }
                  errors++;
                }
                if (data328.bema === void 0) {
                  const err820 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/required", keyword: "required", params: { missingProperty: "bema" }, message: "must have required property 'bema'" };
                  if (vErrors === null) {
                    vErrors = [err820];
                  } else {
                    vErrors.push(err820);
                  }
                  errors++;
                }
                if (data328.hkp === void 0) {
                  const err821 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/required", keyword: "required", params: { missingProperty: "hkp" }, message: "must have required property 'hkp'" };
                  if (vErrors === null) {
                    vErrors = [err821];
                  } else {
                    vErrors.push(err821);
                  }
                  errors++;
                }
                if (data328.bel === void 0) {
                  const err822 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/required", keyword: "required", params: { missingProperty: "bel" }, message: "must have required property 'bel'" };
                  if (vErrors === null) {
                    vErrors = [err822];
                  } else {
                    vErrors.push(err822);
                  }
                  errors++;
                }
                if (data328.materials === void 0) {
                  const err823 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/required", keyword: "required", params: { missingProperty: "materials" }, message: "must have required property 'materials'" };
                  if (vErrors === null) {
                    vErrors = [err823];
                  } else {
                    vErrors.push(err823);
                  }
                  errors++;
                }
                if (data328.labor === void 0) {
                  const err824 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/required", keyword: "required", params: { missingProperty: "labor" }, message: "must have required property 'labor'" };
                  if (vErrors === null) {
                    vErrors = [err824];
                  } else {
                    vErrors.push(err824);
                  }
                  errors++;
                }
                for (const key56 in data328) {
                  if (!(key56 === "luecke" || key56 === "bema" || key56 === "hkp" || key56 === "bel" || key56 === "materials" || key56 === "labor")) {
                    const err825 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key56 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                      vErrors = [err825];
                    } else {
                      vErrors.push(err825);
                    }
                    errors++;
                  }
                }
                if (data328.luecke !== void 0) {
                  let data329 = data328.luecke;
                  if (data329 && typeof data329 == "object" && !Array.isArray(data329)) {
                    if (data329.id === void 0) {
                      const err826 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/luecke", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/luecke/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property 'id'" };
                      if (vErrors === null) {
                        vErrors = [err826];
                      } else {
                        vErrors.push(err826);
                      }
                      errors++;
                    }
                    if (data329.jaw === void 0) {
                      const err827 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/luecke", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/luecke/required", keyword: "required", params: { missingProperty: "jaw" }, message: "must have required property 'jaw'" };
                      if (vErrors === null) {
                        vErrors = [err827];
                      } else {
                        vErrors.push(err827);
                      }
                      errors++;
                    }
                    if (data329.anker === void 0) {
                      const err828 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/luecke", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/luecke/required", keyword: "required", params: { missingProperty: "anker" }, message: "must have required property 'anker'" };
                      if (vErrors === null) {
                        vErrors = [err828];
                      } else {
                        vErrors.push(err828);
                      }
                      errors++;
                    }
                    if (data329.fehlend === void 0) {
                      const err829 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/luecke", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/luecke/required", keyword: "required", params: { missingProperty: "fehlend" }, message: "must have required property 'fehlend'" };
                      if (vErrors === null) {
                        vErrors = [err829];
                      } else {
                        vErrors.push(err829);
                      }
                      errors++;
                    }
                    for (const key57 in data329) {
                      if (!(key57 === "id" || key57 === "jaw" || key57 === "anker" || key57 === "fehlend")) {
                        const err830 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/luecke", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/luecke/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key57 }, message: "must NOT have additional properties" };
                        if (vErrors === null) {
                          vErrors = [err830];
                        } else {
                          vErrors.push(err830);
                        }
                        errors++;
                      }
                    }
                    if (data329.id !== void 0) {
                      if (typeof data329.id !== "string") {
                        const err831 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/luecke/id", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/luecke/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err831];
                        } else {
                          vErrors.push(err831);
                        }
                        errors++;
                      }
                    }
                    if (data329.jaw !== void 0) {
                      let data331 = data329.jaw;
                      if (typeof data331 !== "string") {
                        const err832 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/luecke/jaw", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/luecke/properties/jaw/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err832];
                        } else {
                          vErrors.push(err832);
                        }
                        errors++;
                      }
                      if (!(data331 === "OK" || data331 === "UK")) {
                        const err833 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/luecke/jaw", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/luecke/properties/jaw/enum", keyword: "enum", params: { allowedValues: schema37.properties.projectedCosts.properties.luecken.items.properties.luecke.properties.jaw.enum }, message: "must be equal to one of the allowed values" };
                        if (vErrors === null) {
                          vErrors = [err833];
                        } else {
                          vErrors.push(err833);
                        }
                        errors++;
                      }
                    }
                    if (data329.anker !== void 0) {
                      let data332 = data329.anker;
                      if (Array.isArray(data332)) {
                        const len37 = data332.length;
                        for (let i37 = 0; i37 < len37; i37++) {
                          let data333 = data332[i37];
                          if (!(typeof data333 == "number" && (!(data333 % 1) && !isNaN(data333)) && isFinite(data333))) {
                            const err834 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/luecke/anker/" + i37, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/luecke/properties/anker/items/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                            if (vErrors === null) {
                              vErrors = [err834];
                            } else {
                              vErrors.push(err834);
                            }
                            errors++;
                          }
                          if (typeof data333 == "number" && isFinite(data333)) {
                            if (data333 > 9007199254740991 || isNaN(data333)) {
                              const err835 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/luecke/anker/" + i37, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/luecke/properties/anker/items/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err835];
                              } else {
                                vErrors.push(err835);
                              }
                              errors++;
                            }
                            if (data333 < -9007199254740991 || isNaN(data333)) {
                              const err836 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/luecke/anker/" + i37, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/luecke/properties/anker/items/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err836];
                              } else {
                                vErrors.push(err836);
                              }
                              errors++;
                            }
                          }
                        }
                      } else {
                        const err837 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/luecke/anker", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/luecke/properties/anker/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                        if (vErrors === null) {
                          vErrors = [err837];
                        } else {
                          vErrors.push(err837);
                        }
                        errors++;
                      }
                    }
                    if (data329.fehlend !== void 0) {
                      let data334 = data329.fehlend;
                      if (Array.isArray(data334)) {
                        const len38 = data334.length;
                        for (let i38 = 0; i38 < len38; i38++) {
                          let data335 = data334[i38];
                          if (!(typeof data335 == "number" && (!(data335 % 1) && !isNaN(data335)) && isFinite(data335))) {
                            const err838 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/luecke/fehlend/" + i38, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/luecke/properties/fehlend/items/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                            if (vErrors === null) {
                              vErrors = [err838];
                            } else {
                              vErrors.push(err838);
                            }
                            errors++;
                          }
                          if (typeof data335 == "number" && isFinite(data335)) {
                            if (data335 > 9007199254740991 || isNaN(data335)) {
                              const err839 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/luecke/fehlend/" + i38, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/luecke/properties/fehlend/items/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err839];
                              } else {
                                vErrors.push(err839);
                              }
                              errors++;
                            }
                            if (data335 < -9007199254740991 || isNaN(data335)) {
                              const err840 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/luecke/fehlend/" + i38, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/luecke/properties/fehlend/items/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err840];
                              } else {
                                vErrors.push(err840);
                              }
                              errors++;
                            }
                          }
                        }
                      } else {
                        const err841 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/luecke/fehlend", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/luecke/properties/fehlend/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                        if (vErrors === null) {
                          vErrors = [err841];
                        } else {
                          vErrors.push(err841);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err842 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/luecke", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/luecke/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                    if (vErrors === null) {
                      vErrors = [err842];
                    } else {
                      vErrors.push(err842);
                    }
                    errors++;
                  }
                }
                if (data328.bema !== void 0) {
                  let data336 = data328.bema;
                  if (Array.isArray(data336)) {
                    const len39 = data336.length;
                    for (let i39 = 0; i39 < len39; i39++) {
                      let data337 = data336[i39];
                      if (data337 && typeof data337 == "object" && !Array.isArray(data337)) {
                        if (data337.befund === void 0) {
                          const err843 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bema/" + i39, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bema/items/required", keyword: "required", params: { missingProperty: "befund" }, message: "must have required property 'befund'" };
                          if (vErrors === null) {
                            vErrors = [err843];
                          } else {
                            vErrors.push(err843);
                          }
                          errors++;
                        }
                        if (data337.nr === void 0) {
                          const err844 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bema/" + i39, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bema/items/required", keyword: "required", params: { missingProperty: "nr" }, message: "must have required property 'nr'" };
                          if (vErrors === null) {
                            vErrors = [err844];
                          } else {
                            vErrors.push(err844);
                          }
                          errors++;
                        }
                        if (data337.text === void 0) {
                          const err845 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bema/" + i39, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bema/items/required", keyword: "required", params: { missingProperty: "text" }, message: "must have required property 'text'" };
                          if (vErrors === null) {
                            vErrors = [err845];
                          } else {
                            vErrors.push(err845);
                          }
                          errors++;
                        }
                        if (data337.points === void 0) {
                          const err846 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bema/" + i39, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bema/items/required", keyword: "required", params: { missingProperty: "points" }, message: "must have required property 'points'" };
                          if (vErrors === null) {
                            vErrors = [err846];
                          } else {
                            vErrors.push(err846);
                          }
                          errors++;
                        }
                        if (data337.part === void 0) {
                          const err847 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bema/" + i39, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bema/items/required", keyword: "required", params: { missingProperty: "part" }, message: "must have required property 'part'" };
                          if (vErrors === null) {
                            vErrors = [err847];
                          } else {
                            vErrors.push(err847);
                          }
                          errors++;
                        }
                        if (data337.minus === void 0) {
                          const err848 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bema/" + i39, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bema/items/required", keyword: "required", params: { missingProperty: "minus" }, message: "must have required property 'minus'" };
                          if (vErrors === null) {
                            vErrors = [err848];
                          } else {
                            vErrors.push(err848);
                          }
                          errors++;
                        }
                        if (data337.quantity === void 0) {
                          const err849 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bema/" + i39, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bema/items/required", keyword: "required", params: { missingProperty: "quantity" }, message: "must have required property 'quantity'" };
                          if (vErrors === null) {
                            vErrors = [err849];
                          } else {
                            vErrors.push(err849);
                          }
                          errors++;
                        }
                        for (const key58 in data337) {
                          if (!func6.call(schema37.properties.projectedCosts.properties.luecken.items.properties.bema.items.properties, key58)) {
                            const err850 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bema/" + i39, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bema/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key58 }, message: "must NOT have additional properties" };
                            if (vErrors === null) {
                              vErrors = [err850];
                            } else {
                              vErrors.push(err850);
                            }
                            errors++;
                          }
                        }
                        if (data337.befund !== void 0) {
                          if (typeof data337.befund !== "string") {
                            const err851 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bema/" + i39 + "/befund", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bema/items/properties/befund/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err851];
                            } else {
                              vErrors.push(err851);
                            }
                            errors++;
                          }
                        }
                        if (data337.nr !== void 0) {
                          if (typeof data337.nr !== "string") {
                            const err852 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bema/" + i39 + "/nr", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bema/items/properties/nr/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err852];
                            } else {
                              vErrors.push(err852);
                            }
                            errors++;
                          }
                        }
                        if (data337.text !== void 0) {
                          if (typeof data337.text !== "string") {
                            const err853 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bema/" + i39 + "/text", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bema/items/properties/text/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err853];
                            } else {
                              vErrors.push(err853);
                            }
                            errors++;
                          }
                        }
                        if (data337.points !== void 0) {
                          let data341 = data337.points;
                          if (!(typeof data341 == "number" && (!(data341 % 1) && !isNaN(data341)) && isFinite(data341))) {
                            const err854 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bema/" + i39 + "/points", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bema/items/properties/points/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                            if (vErrors === null) {
                              vErrors = [err854];
                            } else {
                              vErrors.push(err854);
                            }
                            errors++;
                          }
                          if (typeof data341 == "number" && isFinite(data341)) {
                            if (data341 > 9007199254740991 || isNaN(data341)) {
                              const err855 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bema/" + i39 + "/points", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bema/items/properties/points/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err855];
                              } else {
                                vErrors.push(err855);
                              }
                              errors++;
                            }
                            if (data341 < -9007199254740991 || isNaN(data341)) {
                              const err856 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bema/" + i39 + "/points", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bema/items/properties/points/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err856];
                              } else {
                                vErrors.push(err856);
                              }
                              errors++;
                            }
                          }
                        }
                        if (data337.part !== void 0) {
                          if (typeof data337.part !== "string") {
                            const err857 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bema/" + i39 + "/part", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bema/items/properties/part/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err857];
                            } else {
                              vErrors.push(err857);
                            }
                            errors++;
                          }
                        }
                        if (data337.minus !== void 0) {
                          if (typeof data337.minus !== "boolean") {
                            const err858 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bema/" + i39 + "/minus", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bema/items/properties/minus/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                            if (vErrors === null) {
                              vErrors = [err858];
                            } else {
                              vErrors.push(err858);
                            }
                            errors++;
                          }
                        }
                        if (data337.quantity !== void 0) {
                          let data344 = data337.quantity;
                          const _errs766 = errors;
                          let valid144 = false;
                          const _errs767 = errors;
                          if (!(typeof data344 == "number" && (!(data344 % 1) && !isNaN(data344)) && isFinite(data344))) {
                            const err859 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bema/" + i39 + "/quantity", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bema/items/properties/quantity/anyOf/0/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                            if (vErrors === null) {
                              vErrors = [err859];
                            } else {
                              vErrors.push(err859);
                            }
                            errors++;
                          }
                          if (typeof data344 == "number" && isFinite(data344)) {
                            if (data344 > 9007199254740991 || isNaN(data344)) {
                              const err860 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bema/" + i39 + "/quantity", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bema/items/properties/quantity/anyOf/0/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err860];
                              } else {
                                vErrors.push(err860);
                              }
                              errors++;
                            }
                            if (data344 < -9007199254740991 || isNaN(data344)) {
                              const err861 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bema/" + i39 + "/quantity", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bema/items/properties/quantity/anyOf/0/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err861];
                              } else {
                                vErrors.push(err861);
                              }
                              errors++;
                            }
                          }
                          var _valid4 = _errs767 === errors;
                          valid144 = valid144 || _valid4;
                          if (!valid144) {
                            const _errs769 = errors;
                            if (data344 !== null) {
                              const err862 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bema/" + i39 + "/quantity", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bema/items/properties/quantity/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                              if (vErrors === null) {
                                vErrors = [err862];
                              } else {
                                vErrors.push(err862);
                              }
                              errors++;
                            }
                            var _valid4 = _errs769 === errors;
                            valid144 = valid144 || _valid4;
                          }
                          if (!valid144) {
                            const err863 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bema/" + i39 + "/quantity", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bema/items/properties/quantity/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                            if (vErrors === null) {
                              vErrors = [err863];
                            } else {
                              vErrors.push(err863);
                            }
                            errors++;
                          } else {
                            errors = _errs766;
                            if (vErrors !== null) {
                              if (_errs766) {
                                vErrors.length = _errs766;
                              } else {
                                vErrors = null;
                              }
                            }
                          }
                        }
                        if (data337.counted !== void 0) {
                          let data345 = data337.counted;
                          if (typeof data345 !== "boolean") {
                            const err864 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bema/" + i39 + "/counted", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bema/items/properties/counted/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                            if (vErrors === null) {
                              vErrors = [err864];
                            } else {
                              vErrors.push(err864);
                            }
                            errors++;
                          }
                          if (true !== data345) {
                            const err865 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bema/" + i39 + "/counted", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bema/items/properties/counted/const", keyword: "const", params: { allowedValue: true }, message: "must be equal to constant" };
                            if (vErrors === null) {
                              vErrors = [err865];
                            } else {
                              vErrors.push(err865);
                            }
                            errors++;
                          }
                        }
                        if (data337.cents !== void 0) {
                          let data346 = data337.cents;
                          if (!(typeof data346 == "number" && (!(data346 % 1) && !isNaN(data346)) && isFinite(data346))) {
                            const err866 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bema/" + i39 + "/cents", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bema/items/properties/cents/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                            if (vErrors === null) {
                              vErrors = [err866];
                            } else {
                              vErrors.push(err866);
                            }
                            errors++;
                          }
                          if (typeof data346 == "number" && isFinite(data346)) {
                            if (data346 > 9007199254740991 || isNaN(data346)) {
                              const err867 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bema/" + i39 + "/cents", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bema/items/properties/cents/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err867];
                              } else {
                                vErrors.push(err867);
                              }
                              errors++;
                            }
                            if (data346 < -9007199254740991 || isNaN(data346)) {
                              const err868 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bema/" + i39 + "/cents", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bema/items/properties/cents/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err868];
                              } else {
                                vErrors.push(err868);
                              }
                              errors++;
                            }
                          }
                        }
                        if (data337.excluded !== void 0) {
                          if (typeof data337.excluded !== "string") {
                            const err869 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bema/" + i39 + "/excluded", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bema/items/properties/excluded/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err869];
                            } else {
                              vErrors.push(err869);
                            }
                            errors++;
                          }
                        }
                        if (data337.source !== void 0) {
                          let data348 = data337.source;
                          if (data348 && typeof data348 == "object" && !Array.isArray(data348)) {
                            if (data348.chunkId === void 0) {
                              const err870 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bema/" + i39 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bema/items/properties/source/required", keyword: "required", params: { missingProperty: "chunkId" }, message: "must have required property 'chunkId'" };
                              if (vErrors === null) {
                                vErrors = [err870];
                              } else {
                                vErrors.push(err870);
                              }
                              errors++;
                            }
                            if (data348.title === void 0) {
                              const err871 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bema/" + i39 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bema/items/properties/source/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
                              if (vErrors === null) {
                                vErrors = [err871];
                              } else {
                                vErrors.push(err871);
                              }
                              errors++;
                            }
                            if (data348.url === void 0) {
                              const err872 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bema/" + i39 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bema/items/properties/source/required", keyword: "required", params: { missingProperty: "url" }, message: "must have required property 'url'" };
                              if (vErrors === null) {
                                vErrors = [err872];
                              } else {
                                vErrors.push(err872);
                              }
                              errors++;
                            }
                            for (const key59 in data348) {
                              if (!(key59 === "chunkId" || key59 === "title" || key59 === "url" || key59 === "page")) {
                                const err873 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bema/" + i39 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bema/items/properties/source/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key59 }, message: "must NOT have additional properties" };
                                if (vErrors === null) {
                                  vErrors = [err873];
                                } else {
                                  vErrors.push(err873);
                                }
                                errors++;
                              }
                            }
                            if (data348.chunkId !== void 0) {
                              if (typeof data348.chunkId !== "string") {
                                const err874 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bema/" + i39 + "/source/chunkId", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bema/items/properties/source/properties/chunkId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err874];
                                } else {
                                  vErrors.push(err874);
                                }
                                errors++;
                              }
                            }
                            if (data348.title !== void 0) {
                              if (typeof data348.title !== "string") {
                                const err875 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bema/" + i39 + "/source/title", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bema/items/properties/source/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err875];
                                } else {
                                  vErrors.push(err875);
                                }
                                errors++;
                              }
                            }
                            if (data348.url !== void 0) {
                              if (typeof data348.url !== "string") {
                                const err876 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bema/" + i39 + "/source/url", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bema/items/properties/source/properties/url/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err876];
                                } else {
                                  vErrors.push(err876);
                                }
                                errors++;
                              }
                            }
                            if (data348.page !== void 0) {
                              let data352 = data348.page;
                              if (!(typeof data352 == "number" && (!(data352 % 1) && !isNaN(data352)) && isFinite(data352))) {
                                const err877 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bema/" + i39 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bema/items/properties/source/properties/page/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                if (vErrors === null) {
                                  vErrors = [err877];
                                } else {
                                  vErrors.push(err877);
                                }
                                errors++;
                              }
                              if (typeof data352 == "number" && isFinite(data352)) {
                                if (data352 > 9007199254740991 || isNaN(data352)) {
                                  const err878 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bema/" + i39 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bema/items/properties/source/properties/page/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                                  if (vErrors === null) {
                                    vErrors = [err878];
                                  } else {
                                    vErrors.push(err878);
                                  }
                                  errors++;
                                }
                                if (data352 < -9007199254740991 || isNaN(data352)) {
                                  const err879 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bema/" + i39 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bema/items/properties/source/properties/page/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                                  if (vErrors === null) {
                                    vErrors = [err879];
                                  } else {
                                    vErrors.push(err879);
                                  }
                                  errors++;
                                }
                              }
                            }
                          } else {
                            const err880 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bema/" + i39 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bema/items/properties/source/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                            if (vErrors === null) {
                              vErrors = [err880];
                            } else {
                              vErrors.push(err880);
                            }
                            errors++;
                          }
                        }
                      } else {
                        const err881 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bema/" + i39, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bema/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                        if (vErrors === null) {
                          vErrors = [err881];
                        } else {
                          vErrors.push(err881);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err882 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bema", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bema/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                      vErrors = [err882];
                    } else {
                      vErrors.push(err882);
                    }
                    errors++;
                  }
                }
                if (data328.hkp !== void 0) {
                  let data353 = data328.hkp;
                  if (Array.isArray(data353)) {
                    const len40 = data353.length;
                    for (let i40 = 0; i40 < len40; i40++) {
                      let data354 = data353[i40];
                      if (data354 && typeof data354 == "object" && !Array.isArray(data354)) {
                        if (data354.nr === void 0) {
                          const err883 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/hkp/" + i40, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/hkp/items/required", keyword: "required", params: { missingProperty: "nr" }, message: "must have required property 'nr'" };
                          if (vErrors === null) {
                            vErrors = [err883];
                          } else {
                            vErrors.push(err883);
                          }
                          errors++;
                        }
                        if (data354.text === void 0) {
                          const err884 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/hkp/" + i40, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/hkp/items/required", keyword: "required", params: { missingProperty: "text" }, message: "must have required property 'text'" };
                          if (vErrors === null) {
                            vErrors = [err884];
                          } else {
                            vErrors.push(err884);
                          }
                          errors++;
                        }
                        if (data354.befunde === void 0) {
                          const err885 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/hkp/" + i40, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/hkp/items/required", keyword: "required", params: { missingProperty: "befunde" }, message: "must have required property 'befunde'" };
                          if (vErrors === null) {
                            vErrors = [err885];
                          } else {
                            vErrors.push(err885);
                          }
                          errors++;
                        }
                        if (data354.quantity === void 0) {
                          const err886 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/hkp/" + i40, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/hkp/items/required", keyword: "required", params: { missingProperty: "quantity" }, message: "must have required property 'quantity'" };
                          if (vErrors === null) {
                            vErrors = [err886];
                          } else {
                            vErrors.push(err886);
                          }
                          errors++;
                        }
                        if (data354.counted === void 0) {
                          const err887 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/hkp/" + i40, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/hkp/items/required", keyword: "required", params: { missingProperty: "counted" }, message: "must have required property 'counted'" };
                          if (vErrors === null) {
                            vErrors = [err887];
                          } else {
                            vErrors.push(err887);
                          }
                          errors++;
                        }
                        for (const key60 in data354) {
                          if (!(key60 === "nr" || key60 === "text" || key60 === "befunde" || key60 === "quantity" || key60 === "counted" || key60 === "cents" || key60 === "source")) {
                            const err888 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/hkp/" + i40, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/hkp/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key60 }, message: "must NOT have additional properties" };
                            if (vErrors === null) {
                              vErrors = [err888];
                            } else {
                              vErrors.push(err888);
                            }
                            errors++;
                          }
                        }
                        if (data354.nr !== void 0) {
                          if (typeof data354.nr !== "string") {
                            const err889 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/hkp/" + i40 + "/nr", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/hkp/items/properties/nr/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err889];
                            } else {
                              vErrors.push(err889);
                            }
                            errors++;
                          }
                        }
                        if (data354.text !== void 0) {
                          if (typeof data354.text !== "string") {
                            const err890 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/hkp/" + i40 + "/text", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/hkp/items/properties/text/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err890];
                            } else {
                              vErrors.push(err890);
                            }
                            errors++;
                          }
                        }
                        if (data354.befunde !== void 0) {
                          if (typeof data354.befunde !== "string") {
                            const err891 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/hkp/" + i40 + "/befunde", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/hkp/items/properties/befunde/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err891];
                            } else {
                              vErrors.push(err891);
                            }
                            errors++;
                          }
                        }
                        if (data354.quantity !== void 0) {
                          let data358 = data354.quantity;
                          if (!(typeof data358 == "number" && (!(data358 % 1) && !isNaN(data358)) && isFinite(data358))) {
                            const err892 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/hkp/" + i40 + "/quantity", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/hkp/items/properties/quantity/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                            if (vErrors === null) {
                              vErrors = [err892];
                            } else {
                              vErrors.push(err892);
                            }
                            errors++;
                          }
                          if (typeof data358 == "number" && isFinite(data358)) {
                            if (data358 > 9007199254740991 || isNaN(data358)) {
                              const err893 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/hkp/" + i40 + "/quantity", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/hkp/items/properties/quantity/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err893];
                              } else {
                                vErrors.push(err893);
                              }
                              errors++;
                            }
                            if (data358 < -9007199254740991 || isNaN(data358)) {
                              const err894 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/hkp/" + i40 + "/quantity", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/hkp/items/properties/quantity/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err894];
                              } else {
                                vErrors.push(err894);
                              }
                              errors++;
                            }
                          }
                        }
                        if (data354.counted !== void 0) {
                          let data359 = data354.counted;
                          if (typeof data359 !== "string") {
                            const err895 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/hkp/" + i40 + "/counted", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/hkp/items/properties/counted/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err895];
                            } else {
                              vErrors.push(err895);
                            }
                            errors++;
                          }
                          if (!(data359 === "bema" || data359 === "dentist" || data359 === "assumed")) {
                            const err896 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/hkp/" + i40 + "/counted", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/hkp/items/properties/counted/enum", keyword: "enum", params: { allowedValues: schema37.properties.projectedCosts.properties.luecken.items.properties.hkp.items.properties.counted.enum }, message: "must be equal to one of the allowed values" };
                            if (vErrors === null) {
                              vErrors = [err896];
                            } else {
                              vErrors.push(err896);
                            }
                            errors++;
                          }
                        }
                        if (data354.cents !== void 0) {
                          let data360 = data354.cents;
                          if (!(typeof data360 == "number" && (!(data360 % 1) && !isNaN(data360)) && isFinite(data360))) {
                            const err897 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/hkp/" + i40 + "/cents", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/hkp/items/properties/cents/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                            if (vErrors === null) {
                              vErrors = [err897];
                            } else {
                              vErrors.push(err897);
                            }
                            errors++;
                          }
                          if (typeof data360 == "number" && isFinite(data360)) {
                            if (data360 > 9007199254740991 || isNaN(data360)) {
                              const err898 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/hkp/" + i40 + "/cents", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/hkp/items/properties/cents/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err898];
                              } else {
                                vErrors.push(err898);
                              }
                              errors++;
                            }
                            if (data360 < -9007199254740991 || isNaN(data360)) {
                              const err899 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/hkp/" + i40 + "/cents", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/hkp/items/properties/cents/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err899];
                              } else {
                                vErrors.push(err899);
                              }
                              errors++;
                            }
                          }
                        }
                        if (data354.source !== void 0) {
                          let data361 = data354.source;
                          if (data361 && typeof data361 == "object" && !Array.isArray(data361)) {
                            if (data361.chunkId === void 0) {
                              const err900 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/hkp/" + i40 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/hkp/items/properties/source/required", keyword: "required", params: { missingProperty: "chunkId" }, message: "must have required property 'chunkId'" };
                              if (vErrors === null) {
                                vErrors = [err900];
                              } else {
                                vErrors.push(err900);
                              }
                              errors++;
                            }
                            if (data361.title === void 0) {
                              const err901 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/hkp/" + i40 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/hkp/items/properties/source/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
                              if (vErrors === null) {
                                vErrors = [err901];
                              } else {
                                vErrors.push(err901);
                              }
                              errors++;
                            }
                            if (data361.url === void 0) {
                              const err902 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/hkp/" + i40 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/hkp/items/properties/source/required", keyword: "required", params: { missingProperty: "url" }, message: "must have required property 'url'" };
                              if (vErrors === null) {
                                vErrors = [err902];
                              } else {
                                vErrors.push(err902);
                              }
                              errors++;
                            }
                            for (const key61 in data361) {
                              if (!(key61 === "chunkId" || key61 === "title" || key61 === "url" || key61 === "page")) {
                                const err903 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/hkp/" + i40 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/hkp/items/properties/source/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key61 }, message: "must NOT have additional properties" };
                                if (vErrors === null) {
                                  vErrors = [err903];
                                } else {
                                  vErrors.push(err903);
                                }
                                errors++;
                              }
                            }
                            if (data361.chunkId !== void 0) {
                              if (typeof data361.chunkId !== "string") {
                                const err904 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/hkp/" + i40 + "/source/chunkId", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/hkp/items/properties/source/properties/chunkId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err904];
                                } else {
                                  vErrors.push(err904);
                                }
                                errors++;
                              }
                            }
                            if (data361.title !== void 0) {
                              if (typeof data361.title !== "string") {
                                const err905 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/hkp/" + i40 + "/source/title", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/hkp/items/properties/source/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err905];
                                } else {
                                  vErrors.push(err905);
                                }
                                errors++;
                              }
                            }
                            if (data361.url !== void 0) {
                              if (typeof data361.url !== "string") {
                                const err906 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/hkp/" + i40 + "/source/url", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/hkp/items/properties/source/properties/url/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err906];
                                } else {
                                  vErrors.push(err906);
                                }
                                errors++;
                              }
                            }
                            if (data361.page !== void 0) {
                              let data365 = data361.page;
                              if (!(typeof data365 == "number" && (!(data365 % 1) && !isNaN(data365)) && isFinite(data365))) {
                                const err907 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/hkp/" + i40 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/hkp/items/properties/source/properties/page/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                if (vErrors === null) {
                                  vErrors = [err907];
                                } else {
                                  vErrors.push(err907);
                                }
                                errors++;
                              }
                              if (typeof data365 == "number" && isFinite(data365)) {
                                if (data365 > 9007199254740991 || isNaN(data365)) {
                                  const err908 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/hkp/" + i40 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/hkp/items/properties/source/properties/page/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                                  if (vErrors === null) {
                                    vErrors = [err908];
                                  } else {
                                    vErrors.push(err908);
                                  }
                                  errors++;
                                }
                                if (data365 < -9007199254740991 || isNaN(data365)) {
                                  const err909 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/hkp/" + i40 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/hkp/items/properties/source/properties/page/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                                  if (vErrors === null) {
                                    vErrors = [err909];
                                  } else {
                                    vErrors.push(err909);
                                  }
                                  errors++;
                                }
                              }
                            }
                          } else {
                            const err910 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/hkp/" + i40 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/hkp/items/properties/source/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                            if (vErrors === null) {
                              vErrors = [err910];
                            } else {
                              vErrors.push(err910);
                            }
                            errors++;
                          }
                        }
                      } else {
                        const err911 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/hkp/" + i40, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/hkp/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                        if (vErrors === null) {
                          vErrors = [err911];
                        } else {
                          vErrors.push(err911);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err912 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/hkp", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/hkp/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                      vErrors = [err912];
                    } else {
                      vErrors.push(err912);
                    }
                    errors++;
                  }
                }
                if (data328.bel !== void 0) {
                  let data366 = data328.bel;
                  if (Array.isArray(data366)) {
                    const len41 = data366.length;
                    for (let i41 = 0; i41 < len41; i41++) {
                      let data367 = data366[i41];
                      if (data367 && typeof data367 == "object" && !Array.isArray(data367)) {
                        if (data367.befund === void 0) {
                          const err913 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bel/" + i41, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bel/items/required", keyword: "required", params: { missingProperty: "befund" }, message: "must have required property 'befund'" };
                          if (vErrors === null) {
                            vErrors = [err913];
                          } else {
                            vErrors.push(err913);
                          }
                          errors++;
                        }
                        if (data367.nr === void 0) {
                          const err914 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bel/" + i41, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bel/items/required", keyword: "required", params: { missingProperty: "nr" }, message: "must have required property 'nr'" };
                          if (vErrors === null) {
                            vErrors = [err914];
                          } else {
                            vErrors.push(err914);
                          }
                          errors++;
                        }
                        if (data367.text === void 0) {
                          const err915 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bel/" + i41, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bel/items/required", keyword: "required", params: { missingProperty: "text" }, message: "must have required property 'text'" };
                          if (vErrors === null) {
                            vErrors = [err915];
                          } else {
                            vErrors.push(err915);
                          }
                          errors++;
                        }
                        if (data367.minus === void 0) {
                          const err916 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bel/" + i41, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bel/items/required", keyword: "required", params: { missingProperty: "minus" }, message: "must have required property 'minus'" };
                          if (vErrors === null) {
                            vErrors = [err916];
                          } else {
                            vErrors.push(err916);
                          }
                          errors++;
                        }
                        for (const key62 in data367) {
                          if (!(key62 === "befund" || key62 === "nr" || key62 === "text" || key62 === "minus" || key62 === "source")) {
                            const err917 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bel/" + i41, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bel/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key62 }, message: "must NOT have additional properties" };
                            if (vErrors === null) {
                              vErrors = [err917];
                            } else {
                              vErrors.push(err917);
                            }
                            errors++;
                          }
                        }
                        if (data367.befund !== void 0) {
                          if (typeof data367.befund !== "string") {
                            const err918 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bel/" + i41 + "/befund", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bel/items/properties/befund/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err918];
                            } else {
                              vErrors.push(err918);
                            }
                            errors++;
                          }
                        }
                        if (data367.nr !== void 0) {
                          if (typeof data367.nr !== "string") {
                            const err919 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bel/" + i41 + "/nr", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bel/items/properties/nr/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err919];
                            } else {
                              vErrors.push(err919);
                            }
                            errors++;
                          }
                        }
                        if (data367.text !== void 0) {
                          if (typeof data367.text !== "string") {
                            const err920 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bel/" + i41 + "/text", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bel/items/properties/text/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err920];
                            } else {
                              vErrors.push(err920);
                            }
                            errors++;
                          }
                        }
                        if (data367.minus !== void 0) {
                          if (typeof data367.minus !== "boolean") {
                            const err921 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bel/" + i41 + "/minus", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bel/items/properties/minus/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                            if (vErrors === null) {
                              vErrors = [err921];
                            } else {
                              vErrors.push(err921);
                            }
                            errors++;
                          }
                        }
                        if (data367.source !== void 0) {
                          let data372 = data367.source;
                          if (data372 && typeof data372 == "object" && !Array.isArray(data372)) {
                            if (data372.chunkId === void 0) {
                              const err922 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bel/" + i41 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bel/items/properties/source/required", keyword: "required", params: { missingProperty: "chunkId" }, message: "must have required property 'chunkId'" };
                              if (vErrors === null) {
                                vErrors = [err922];
                              } else {
                                vErrors.push(err922);
                              }
                              errors++;
                            }
                            if (data372.title === void 0) {
                              const err923 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bel/" + i41 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bel/items/properties/source/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
                              if (vErrors === null) {
                                vErrors = [err923];
                              } else {
                                vErrors.push(err923);
                              }
                              errors++;
                            }
                            if (data372.url === void 0) {
                              const err924 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bel/" + i41 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bel/items/properties/source/required", keyword: "required", params: { missingProperty: "url" }, message: "must have required property 'url'" };
                              if (vErrors === null) {
                                vErrors = [err924];
                              } else {
                                vErrors.push(err924);
                              }
                              errors++;
                            }
                            for (const key63 in data372) {
                              if (!(key63 === "chunkId" || key63 === "title" || key63 === "url" || key63 === "page")) {
                                const err925 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bel/" + i41 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bel/items/properties/source/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key63 }, message: "must NOT have additional properties" };
                                if (vErrors === null) {
                                  vErrors = [err925];
                                } else {
                                  vErrors.push(err925);
                                }
                                errors++;
                              }
                            }
                            if (data372.chunkId !== void 0) {
                              if (typeof data372.chunkId !== "string") {
                                const err926 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bel/" + i41 + "/source/chunkId", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bel/items/properties/source/properties/chunkId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err926];
                                } else {
                                  vErrors.push(err926);
                                }
                                errors++;
                              }
                            }
                            if (data372.title !== void 0) {
                              if (typeof data372.title !== "string") {
                                const err927 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bel/" + i41 + "/source/title", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bel/items/properties/source/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err927];
                                } else {
                                  vErrors.push(err927);
                                }
                                errors++;
                              }
                            }
                            if (data372.url !== void 0) {
                              if (typeof data372.url !== "string") {
                                const err928 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bel/" + i41 + "/source/url", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bel/items/properties/source/properties/url/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err928];
                                } else {
                                  vErrors.push(err928);
                                }
                                errors++;
                              }
                            }
                            if (data372.page !== void 0) {
                              let data376 = data372.page;
                              if (!(typeof data376 == "number" && (!(data376 % 1) && !isNaN(data376)) && isFinite(data376))) {
                                const err929 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bel/" + i41 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bel/items/properties/source/properties/page/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                if (vErrors === null) {
                                  vErrors = [err929];
                                } else {
                                  vErrors.push(err929);
                                }
                                errors++;
                              }
                              if (typeof data376 == "number" && isFinite(data376)) {
                                if (data376 > 9007199254740991 || isNaN(data376)) {
                                  const err930 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bel/" + i41 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bel/items/properties/source/properties/page/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                                  if (vErrors === null) {
                                    vErrors = [err930];
                                  } else {
                                    vErrors.push(err930);
                                  }
                                  errors++;
                                }
                                if (data376 < -9007199254740991 || isNaN(data376)) {
                                  const err931 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bel/" + i41 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bel/items/properties/source/properties/page/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                                  if (vErrors === null) {
                                    vErrors = [err931];
                                  } else {
                                    vErrors.push(err931);
                                  }
                                  errors++;
                                }
                              }
                            }
                          } else {
                            const err932 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bel/" + i41 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bel/items/properties/source/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                            if (vErrors === null) {
                              vErrors = [err932];
                            } else {
                              vErrors.push(err932);
                            }
                            errors++;
                          }
                        }
                      } else {
                        const err933 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bel/" + i41, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bel/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                        if (vErrors === null) {
                          vErrors = [err933];
                        } else {
                          vErrors.push(err933);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err934 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/bel", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/bel/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                      vErrors = [err934];
                    } else {
                      vErrors.push(err934);
                    }
                    errors++;
                  }
                }
                if (data328.materials !== void 0) {
                  let data377 = data328.materials;
                  if (Array.isArray(data377)) {
                    const len42 = data377.length;
                    for (let i42 = 0; i42 < len42; i42++) {
                      let data378 = data377[i42];
                      if (data378 && typeof data378 == "object" && !Array.isArray(data378)) {
                        if (data378.befund === void 0) {
                          const err935 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/materials/" + i42, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/materials/items/required", keyword: "required", params: { missingProperty: "befund" }, message: "must have required property 'befund'" };
                          if (vErrors === null) {
                            vErrors = [err935];
                          } else {
                            vErrors.push(err935);
                          }
                          errors++;
                        }
                        if (data378.name === void 0) {
                          const err936 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/materials/" + i42, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/materials/items/required", keyword: "required", params: { missingProperty: "name" }, message: "must have required property 'name'" };
                          if (vErrors === null) {
                            vErrors = [err936];
                          } else {
                            vErrors.push(err936);
                          }
                          errors++;
                        }
                        for (const key64 in data378) {
                          if (!(key64 === "befund" || key64 === "name" || key64 === "source")) {
                            const err937 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/materials/" + i42, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/materials/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key64 }, message: "must NOT have additional properties" };
                            if (vErrors === null) {
                              vErrors = [err937];
                            } else {
                              vErrors.push(err937);
                            }
                            errors++;
                          }
                        }
                        if (data378.befund !== void 0) {
                          if (typeof data378.befund !== "string") {
                            const err938 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/materials/" + i42 + "/befund", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/materials/items/properties/befund/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err938];
                            } else {
                              vErrors.push(err938);
                            }
                            errors++;
                          }
                        }
                        if (data378.name !== void 0) {
                          if (typeof data378.name !== "string") {
                            const err939 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/materials/" + i42 + "/name", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/materials/items/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err939];
                            } else {
                              vErrors.push(err939);
                            }
                            errors++;
                          }
                        }
                        if (data378.source !== void 0) {
                          let data381 = data378.source;
                          if (data381 && typeof data381 == "object" && !Array.isArray(data381)) {
                            if (data381.chunkId === void 0) {
                              const err940 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/materials/" + i42 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/materials/items/properties/source/required", keyword: "required", params: { missingProperty: "chunkId" }, message: "must have required property 'chunkId'" };
                              if (vErrors === null) {
                                vErrors = [err940];
                              } else {
                                vErrors.push(err940);
                              }
                              errors++;
                            }
                            if (data381.title === void 0) {
                              const err941 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/materials/" + i42 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/materials/items/properties/source/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
                              if (vErrors === null) {
                                vErrors = [err941];
                              } else {
                                vErrors.push(err941);
                              }
                              errors++;
                            }
                            if (data381.url === void 0) {
                              const err942 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/materials/" + i42 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/materials/items/properties/source/required", keyword: "required", params: { missingProperty: "url" }, message: "must have required property 'url'" };
                              if (vErrors === null) {
                                vErrors = [err942];
                              } else {
                                vErrors.push(err942);
                              }
                              errors++;
                            }
                            for (const key65 in data381) {
                              if (!(key65 === "chunkId" || key65 === "title" || key65 === "url" || key65 === "page")) {
                                const err943 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/materials/" + i42 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/materials/items/properties/source/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key65 }, message: "must NOT have additional properties" };
                                if (vErrors === null) {
                                  vErrors = [err943];
                                } else {
                                  vErrors.push(err943);
                                }
                                errors++;
                              }
                            }
                            if (data381.chunkId !== void 0) {
                              if (typeof data381.chunkId !== "string") {
                                const err944 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/materials/" + i42 + "/source/chunkId", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/materials/items/properties/source/properties/chunkId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err944];
                                } else {
                                  vErrors.push(err944);
                                }
                                errors++;
                              }
                            }
                            if (data381.title !== void 0) {
                              if (typeof data381.title !== "string") {
                                const err945 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/materials/" + i42 + "/source/title", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/materials/items/properties/source/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err945];
                                } else {
                                  vErrors.push(err945);
                                }
                                errors++;
                              }
                            }
                            if (data381.url !== void 0) {
                              if (typeof data381.url !== "string") {
                                const err946 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/materials/" + i42 + "/source/url", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/materials/items/properties/source/properties/url/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err946];
                                } else {
                                  vErrors.push(err946);
                                }
                                errors++;
                              }
                            }
                            if (data381.page !== void 0) {
                              let data385 = data381.page;
                              if (!(typeof data385 == "number" && (!(data385 % 1) && !isNaN(data385)) && isFinite(data385))) {
                                const err947 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/materials/" + i42 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/materials/items/properties/source/properties/page/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                if (vErrors === null) {
                                  vErrors = [err947];
                                } else {
                                  vErrors.push(err947);
                                }
                                errors++;
                              }
                              if (typeof data385 == "number" && isFinite(data385)) {
                                if (data385 > 9007199254740991 || isNaN(data385)) {
                                  const err948 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/materials/" + i42 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/materials/items/properties/source/properties/page/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                                  if (vErrors === null) {
                                    vErrors = [err948];
                                  } else {
                                    vErrors.push(err948);
                                  }
                                  errors++;
                                }
                                if (data385 < -9007199254740991 || isNaN(data385)) {
                                  const err949 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/materials/" + i42 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/materials/items/properties/source/properties/page/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                                  if (vErrors === null) {
                                    vErrors = [err949];
                                  } else {
                                    vErrors.push(err949);
                                  }
                                  errors++;
                                }
                              }
                            }
                          } else {
                            const err950 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/materials/" + i42 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/materials/items/properties/source/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                            if (vErrors === null) {
                              vErrors = [err950];
                            } else {
                              vErrors.push(err950);
                            }
                            errors++;
                          }
                        }
                      } else {
                        const err951 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/materials/" + i42, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/materials/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                        if (vErrors === null) {
                          vErrors = [err951];
                        } else {
                          vErrors.push(err951);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err952 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/materials", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/materials/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                      vErrors = [err952];
                    } else {
                      vErrors.push(err952);
                    }
                    errors++;
                  }
                }
                if (data328.labor !== void 0) {
                  let data386 = data328.labor;
                  if (!(typeof data386 == "number" && (!(data386 % 1) && !isNaN(data386)) && isFinite(data386))) {
                    const err953 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/labor", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/labor/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err953];
                    } else {
                      vErrors.push(err953);
                    }
                    errors++;
                  }
                  if (typeof data386 == "number" && isFinite(data386)) {
                    if (data386 > 9007199254740991 || isNaN(data386)) {
                      const err954 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/labor", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/labor/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err954];
                      } else {
                        vErrors.push(err954);
                      }
                      errors++;
                    }
                    if (data386 < -9007199254740991 || isNaN(data386)) {
                      const err955 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36 + "/labor", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/properties/labor/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err955];
                      } else {
                        vErrors.push(err955);
                      }
                      errors++;
                    }
                  }
                }
              } else {
                const err956 = { instancePath: instancePath + "/projectedCosts/luecken/" + i36, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                if (vErrors === null) {
                  vErrors = [err956];
                } else {
                  vErrors.push(err956);
                }
                errors++;
              }
            }
          } else {
            const err957 = { instancePath: instancePath + "/projectedCosts/luecken", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/luecken/type", keyword: "type", params: { type: "array" }, message: "must be array" };
            if (vErrors === null) {
              vErrors = [err957];
            } else {
              vErrors.push(err957);
            }
            errors++;
          }
        }
        if (data256.places !== void 0) {
          let data387 = data256.places;
          if (Array.isArray(data387)) {
            const len43 = data387.length;
            for (let i43 = 0; i43 < len43; i43++) {
              let data388 = data387[i43];
              if (data388 && typeof data388 == "object" && !Array.isArray(data388)) {
                if (data388.place === void 0) {
                  const err958 = { instancePath: instancePath + "/projectedCosts/places/" + i43, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/required", keyword: "required", params: { missingProperty: "place" }, message: "must have required property 'place'" };
                  if (vErrors === null) {
                    vErrors = [err958];
                  } else {
                    vErrors.push(err958);
                  }
                  errors++;
                }
                if (data388.bema === void 0) {
                  const err959 = { instancePath: instancePath + "/projectedCosts/places/" + i43, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/required", keyword: "required", params: { missingProperty: "bema" }, message: "must have required property 'bema'" };
                  if (vErrors === null) {
                    vErrors = [err959];
                  } else {
                    vErrors.push(err959);
                  }
                  errors++;
                }
                if (data388.hkp === void 0) {
                  const err960 = { instancePath: instancePath + "/projectedCosts/places/" + i43, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/required", keyword: "required", params: { missingProperty: "hkp" }, message: "must have required property 'hkp'" };
                  if (vErrors === null) {
                    vErrors = [err960];
                  } else {
                    vErrors.push(err960);
                  }
                  errors++;
                }
                for (const key66 in data388) {
                  if (!(key66 === "place" || key66 === "bema" || key66 === "hkp")) {
                    const err961 = { instancePath: instancePath + "/projectedCosts/places/" + i43, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key66 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                      vErrors = [err961];
                    } else {
                      vErrors.push(err961);
                    }
                    errors++;
                  }
                }
                if (data388.place !== void 0) {
                  let data389 = data388.place;
                  if (typeof data389 !== "string") {
                    const err962 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/place", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/place/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err962];
                    } else {
                      vErrors.push(err962);
                    }
                    errors++;
                  }
                  if (!(data389 === "OK" || data389 === "UK" || data389 === "patient")) {
                    const err963 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/place", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/place/enum", keyword: "enum", params: { allowedValues: schema37.properties.projectedCosts.properties.places.items.properties.place.enum }, message: "must be equal to one of the allowed values" };
                    if (vErrors === null) {
                      vErrors = [err963];
                    } else {
                      vErrors.push(err963);
                    }
                    errors++;
                  }
                }
                if (data388.bema !== void 0) {
                  let data390 = data388.bema;
                  if (Array.isArray(data390)) {
                    const len44 = data390.length;
                    for (let i44 = 0; i44 < len44; i44++) {
                      let data391 = data390[i44];
                      if (data391 && typeof data391 == "object" && !Array.isArray(data391)) {
                        if (data391.befund === void 0) {
                          const err964 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/bema/" + i44, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/bema/items/required", keyword: "required", params: { missingProperty: "befund" }, message: "must have required property 'befund'" };
                          if (vErrors === null) {
                            vErrors = [err964];
                          } else {
                            vErrors.push(err964);
                          }
                          errors++;
                        }
                        if (data391.nr === void 0) {
                          const err965 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/bema/" + i44, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/bema/items/required", keyword: "required", params: { missingProperty: "nr" }, message: "must have required property 'nr'" };
                          if (vErrors === null) {
                            vErrors = [err965];
                          } else {
                            vErrors.push(err965);
                          }
                          errors++;
                        }
                        if (data391.text === void 0) {
                          const err966 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/bema/" + i44, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/bema/items/required", keyword: "required", params: { missingProperty: "text" }, message: "must have required property 'text'" };
                          if (vErrors === null) {
                            vErrors = [err966];
                          } else {
                            vErrors.push(err966);
                          }
                          errors++;
                        }
                        if (data391.points === void 0) {
                          const err967 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/bema/" + i44, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/bema/items/required", keyword: "required", params: { missingProperty: "points" }, message: "must have required property 'points'" };
                          if (vErrors === null) {
                            vErrors = [err967];
                          } else {
                            vErrors.push(err967);
                          }
                          errors++;
                        }
                        if (data391.part === void 0) {
                          const err968 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/bema/" + i44, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/bema/items/required", keyword: "required", params: { missingProperty: "part" }, message: "must have required property 'part'" };
                          if (vErrors === null) {
                            vErrors = [err968];
                          } else {
                            vErrors.push(err968);
                          }
                          errors++;
                        }
                        if (data391.minus === void 0) {
                          const err969 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/bema/" + i44, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/bema/items/required", keyword: "required", params: { missingProperty: "minus" }, message: "must have required property 'minus'" };
                          if (vErrors === null) {
                            vErrors = [err969];
                          } else {
                            vErrors.push(err969);
                          }
                          errors++;
                        }
                        if (data391.quantity === void 0) {
                          const err970 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/bema/" + i44, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/bema/items/required", keyword: "required", params: { missingProperty: "quantity" }, message: "must have required property 'quantity'" };
                          if (vErrors === null) {
                            vErrors = [err970];
                          } else {
                            vErrors.push(err970);
                          }
                          errors++;
                        }
                        for (const key67 in data391) {
                          if (!func6.call(schema37.properties.projectedCosts.properties.places.items.properties.bema.items.properties, key67)) {
                            const err971 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/bema/" + i44, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/bema/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key67 }, message: "must NOT have additional properties" };
                            if (vErrors === null) {
                              vErrors = [err971];
                            } else {
                              vErrors.push(err971);
                            }
                            errors++;
                          }
                        }
                        if (data391.befund !== void 0) {
                          if (typeof data391.befund !== "string") {
                            const err972 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/bema/" + i44 + "/befund", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/bema/items/properties/befund/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err972];
                            } else {
                              vErrors.push(err972);
                            }
                            errors++;
                          }
                        }
                        if (data391.nr !== void 0) {
                          if (typeof data391.nr !== "string") {
                            const err973 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/bema/" + i44 + "/nr", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/bema/items/properties/nr/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err973];
                            } else {
                              vErrors.push(err973);
                            }
                            errors++;
                          }
                        }
                        if (data391.text !== void 0) {
                          if (typeof data391.text !== "string") {
                            const err974 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/bema/" + i44 + "/text", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/bema/items/properties/text/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err974];
                            } else {
                              vErrors.push(err974);
                            }
                            errors++;
                          }
                        }
                        if (data391.points !== void 0) {
                          let data395 = data391.points;
                          if (!(typeof data395 == "number" && (!(data395 % 1) && !isNaN(data395)) && isFinite(data395))) {
                            const err975 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/bema/" + i44 + "/points", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/bema/items/properties/points/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                            if (vErrors === null) {
                              vErrors = [err975];
                            } else {
                              vErrors.push(err975);
                            }
                            errors++;
                          }
                          if (typeof data395 == "number" && isFinite(data395)) {
                            if (data395 > 9007199254740991 || isNaN(data395)) {
                              const err976 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/bema/" + i44 + "/points", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/bema/items/properties/points/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err976];
                              } else {
                                vErrors.push(err976);
                              }
                              errors++;
                            }
                            if (data395 < -9007199254740991 || isNaN(data395)) {
                              const err977 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/bema/" + i44 + "/points", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/bema/items/properties/points/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err977];
                              } else {
                                vErrors.push(err977);
                              }
                              errors++;
                            }
                          }
                        }
                        if (data391.part !== void 0) {
                          if (typeof data391.part !== "string") {
                            const err978 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/bema/" + i44 + "/part", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/bema/items/properties/part/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err978];
                            } else {
                              vErrors.push(err978);
                            }
                            errors++;
                          }
                        }
                        if (data391.minus !== void 0) {
                          if (typeof data391.minus !== "boolean") {
                            const err979 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/bema/" + i44 + "/minus", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/bema/items/properties/minus/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                            if (vErrors === null) {
                              vErrors = [err979];
                            } else {
                              vErrors.push(err979);
                            }
                            errors++;
                          }
                        }
                        if (data391.quantity !== void 0) {
                          let data398 = data391.quantity;
                          const _errs887 = errors;
                          let valid164 = false;
                          const _errs888 = errors;
                          if (!(typeof data398 == "number" && (!(data398 % 1) && !isNaN(data398)) && isFinite(data398))) {
                            const err980 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/bema/" + i44 + "/quantity", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/bema/items/properties/quantity/anyOf/0/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                            if (vErrors === null) {
                              vErrors = [err980];
                            } else {
                              vErrors.push(err980);
                            }
                            errors++;
                          }
                          if (typeof data398 == "number" && isFinite(data398)) {
                            if (data398 > 9007199254740991 || isNaN(data398)) {
                              const err981 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/bema/" + i44 + "/quantity", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/bema/items/properties/quantity/anyOf/0/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err981];
                              } else {
                                vErrors.push(err981);
                              }
                              errors++;
                            }
                            if (data398 < -9007199254740991 || isNaN(data398)) {
                              const err982 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/bema/" + i44 + "/quantity", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/bema/items/properties/quantity/anyOf/0/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err982];
                              } else {
                                vErrors.push(err982);
                              }
                              errors++;
                            }
                          }
                          var _valid5 = _errs888 === errors;
                          valid164 = valid164 || _valid5;
                          if (!valid164) {
                            const _errs890 = errors;
                            if (data398 !== null) {
                              const err983 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/bema/" + i44 + "/quantity", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/bema/items/properties/quantity/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                              if (vErrors === null) {
                                vErrors = [err983];
                              } else {
                                vErrors.push(err983);
                              }
                              errors++;
                            }
                            var _valid5 = _errs890 === errors;
                            valid164 = valid164 || _valid5;
                          }
                          if (!valid164) {
                            const err984 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/bema/" + i44 + "/quantity", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/bema/items/properties/quantity/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                            if (vErrors === null) {
                              vErrors = [err984];
                            } else {
                              vErrors.push(err984);
                            }
                            errors++;
                          } else {
                            errors = _errs887;
                            if (vErrors !== null) {
                              if (_errs887) {
                                vErrors.length = _errs887;
                              } else {
                                vErrors = null;
                              }
                            }
                          }
                        }
                        if (data391.counted !== void 0) {
                          let data399 = data391.counted;
                          if (typeof data399 !== "boolean") {
                            const err985 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/bema/" + i44 + "/counted", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/bema/items/properties/counted/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                            if (vErrors === null) {
                              vErrors = [err985];
                            } else {
                              vErrors.push(err985);
                            }
                            errors++;
                          }
                          if (true !== data399) {
                            const err986 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/bema/" + i44 + "/counted", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/bema/items/properties/counted/const", keyword: "const", params: { allowedValue: true }, message: "must be equal to constant" };
                            if (vErrors === null) {
                              vErrors = [err986];
                            } else {
                              vErrors.push(err986);
                            }
                            errors++;
                          }
                        }
                        if (data391.cents !== void 0) {
                          let data400 = data391.cents;
                          if (!(typeof data400 == "number" && (!(data400 % 1) && !isNaN(data400)) && isFinite(data400))) {
                            const err987 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/bema/" + i44 + "/cents", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/bema/items/properties/cents/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                            if (vErrors === null) {
                              vErrors = [err987];
                            } else {
                              vErrors.push(err987);
                            }
                            errors++;
                          }
                          if (typeof data400 == "number" && isFinite(data400)) {
                            if (data400 > 9007199254740991 || isNaN(data400)) {
                              const err988 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/bema/" + i44 + "/cents", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/bema/items/properties/cents/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err988];
                              } else {
                                vErrors.push(err988);
                              }
                              errors++;
                            }
                            if (data400 < -9007199254740991 || isNaN(data400)) {
                              const err989 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/bema/" + i44 + "/cents", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/bema/items/properties/cents/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err989];
                              } else {
                                vErrors.push(err989);
                              }
                              errors++;
                            }
                          }
                        }
                        if (data391.excluded !== void 0) {
                          if (typeof data391.excluded !== "string") {
                            const err990 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/bema/" + i44 + "/excluded", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/bema/items/properties/excluded/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err990];
                            } else {
                              vErrors.push(err990);
                            }
                            errors++;
                          }
                        }
                        if (data391.source !== void 0) {
                          let data402 = data391.source;
                          if (data402 && typeof data402 == "object" && !Array.isArray(data402)) {
                            if (data402.chunkId === void 0) {
                              const err991 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/bema/" + i44 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/bema/items/properties/source/required", keyword: "required", params: { missingProperty: "chunkId" }, message: "must have required property 'chunkId'" };
                              if (vErrors === null) {
                                vErrors = [err991];
                              } else {
                                vErrors.push(err991);
                              }
                              errors++;
                            }
                            if (data402.title === void 0) {
                              const err992 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/bema/" + i44 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/bema/items/properties/source/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
                              if (vErrors === null) {
                                vErrors = [err992];
                              } else {
                                vErrors.push(err992);
                              }
                              errors++;
                            }
                            if (data402.url === void 0) {
                              const err993 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/bema/" + i44 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/bema/items/properties/source/required", keyword: "required", params: { missingProperty: "url" }, message: "must have required property 'url'" };
                              if (vErrors === null) {
                                vErrors = [err993];
                              } else {
                                vErrors.push(err993);
                              }
                              errors++;
                            }
                            for (const key68 in data402) {
                              if (!(key68 === "chunkId" || key68 === "title" || key68 === "url" || key68 === "page")) {
                                const err994 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/bema/" + i44 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/bema/items/properties/source/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key68 }, message: "must NOT have additional properties" };
                                if (vErrors === null) {
                                  vErrors = [err994];
                                } else {
                                  vErrors.push(err994);
                                }
                                errors++;
                              }
                            }
                            if (data402.chunkId !== void 0) {
                              if (typeof data402.chunkId !== "string") {
                                const err995 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/bema/" + i44 + "/source/chunkId", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/bema/items/properties/source/properties/chunkId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err995];
                                } else {
                                  vErrors.push(err995);
                                }
                                errors++;
                              }
                            }
                            if (data402.title !== void 0) {
                              if (typeof data402.title !== "string") {
                                const err996 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/bema/" + i44 + "/source/title", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/bema/items/properties/source/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err996];
                                } else {
                                  vErrors.push(err996);
                                }
                                errors++;
                              }
                            }
                            if (data402.url !== void 0) {
                              if (typeof data402.url !== "string") {
                                const err997 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/bema/" + i44 + "/source/url", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/bema/items/properties/source/properties/url/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err997];
                                } else {
                                  vErrors.push(err997);
                                }
                                errors++;
                              }
                            }
                            if (data402.page !== void 0) {
                              let data406 = data402.page;
                              if (!(typeof data406 == "number" && (!(data406 % 1) && !isNaN(data406)) && isFinite(data406))) {
                                const err998 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/bema/" + i44 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/bema/items/properties/source/properties/page/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                if (vErrors === null) {
                                  vErrors = [err998];
                                } else {
                                  vErrors.push(err998);
                                }
                                errors++;
                              }
                              if (typeof data406 == "number" && isFinite(data406)) {
                                if (data406 > 9007199254740991 || isNaN(data406)) {
                                  const err999 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/bema/" + i44 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/bema/items/properties/source/properties/page/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                                  if (vErrors === null) {
                                    vErrors = [err999];
                                  } else {
                                    vErrors.push(err999);
                                  }
                                  errors++;
                                }
                                if (data406 < -9007199254740991 || isNaN(data406)) {
                                  const err1000 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/bema/" + i44 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/bema/items/properties/source/properties/page/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                                  if (vErrors === null) {
                                    vErrors = [err1000];
                                  } else {
                                    vErrors.push(err1000);
                                  }
                                  errors++;
                                }
                              }
                            }
                          } else {
                            const err1001 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/bema/" + i44 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/bema/items/properties/source/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                            if (vErrors === null) {
                              vErrors = [err1001];
                            } else {
                              vErrors.push(err1001);
                            }
                            errors++;
                          }
                        }
                      } else {
                        const err1002 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/bema/" + i44, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/bema/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                        if (vErrors === null) {
                          vErrors = [err1002];
                        } else {
                          vErrors.push(err1002);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err1003 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/bema", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/bema/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                      vErrors = [err1003];
                    } else {
                      vErrors.push(err1003);
                    }
                    errors++;
                  }
                }
                if (data388.hkp !== void 0) {
                  let data407 = data388.hkp;
                  if (Array.isArray(data407)) {
                    const len45 = data407.length;
                    for (let i45 = 0; i45 < len45; i45++) {
                      let data408 = data407[i45];
                      if (data408 && typeof data408 == "object" && !Array.isArray(data408)) {
                        if (data408.nr === void 0) {
                          const err1004 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/hkp/" + i45, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/hkp/items/required", keyword: "required", params: { missingProperty: "nr" }, message: "must have required property 'nr'" };
                          if (vErrors === null) {
                            vErrors = [err1004];
                          } else {
                            vErrors.push(err1004);
                          }
                          errors++;
                        }
                        if (data408.text === void 0) {
                          const err1005 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/hkp/" + i45, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/hkp/items/required", keyword: "required", params: { missingProperty: "text" }, message: "must have required property 'text'" };
                          if (vErrors === null) {
                            vErrors = [err1005];
                          } else {
                            vErrors.push(err1005);
                          }
                          errors++;
                        }
                        if (data408.befunde === void 0) {
                          const err1006 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/hkp/" + i45, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/hkp/items/required", keyword: "required", params: { missingProperty: "befunde" }, message: "must have required property 'befunde'" };
                          if (vErrors === null) {
                            vErrors = [err1006];
                          } else {
                            vErrors.push(err1006);
                          }
                          errors++;
                        }
                        if (data408.quantity === void 0) {
                          const err1007 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/hkp/" + i45, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/hkp/items/required", keyword: "required", params: { missingProperty: "quantity" }, message: "must have required property 'quantity'" };
                          if (vErrors === null) {
                            vErrors = [err1007];
                          } else {
                            vErrors.push(err1007);
                          }
                          errors++;
                        }
                        if (data408.counted === void 0) {
                          const err1008 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/hkp/" + i45, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/hkp/items/required", keyword: "required", params: { missingProperty: "counted" }, message: "must have required property 'counted'" };
                          if (vErrors === null) {
                            vErrors = [err1008];
                          } else {
                            vErrors.push(err1008);
                          }
                          errors++;
                        }
                        for (const key69 in data408) {
                          if (!(key69 === "nr" || key69 === "text" || key69 === "befunde" || key69 === "quantity" || key69 === "counted" || key69 === "cents" || key69 === "source")) {
                            const err1009 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/hkp/" + i45, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/hkp/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key69 }, message: "must NOT have additional properties" };
                            if (vErrors === null) {
                              vErrors = [err1009];
                            } else {
                              vErrors.push(err1009);
                            }
                            errors++;
                          }
                        }
                        if (data408.nr !== void 0) {
                          if (typeof data408.nr !== "string") {
                            const err1010 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/hkp/" + i45 + "/nr", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/hkp/items/properties/nr/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err1010];
                            } else {
                              vErrors.push(err1010);
                            }
                            errors++;
                          }
                        }
                        if (data408.text !== void 0) {
                          if (typeof data408.text !== "string") {
                            const err1011 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/hkp/" + i45 + "/text", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/hkp/items/properties/text/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err1011];
                            } else {
                              vErrors.push(err1011);
                            }
                            errors++;
                          }
                        }
                        if (data408.befunde !== void 0) {
                          if (typeof data408.befunde !== "string") {
                            const err1012 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/hkp/" + i45 + "/befunde", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/hkp/items/properties/befunde/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err1012];
                            } else {
                              vErrors.push(err1012);
                            }
                            errors++;
                          }
                        }
                        if (data408.quantity !== void 0) {
                          let data412 = data408.quantity;
                          if (!(typeof data412 == "number" && (!(data412 % 1) && !isNaN(data412)) && isFinite(data412))) {
                            const err1013 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/hkp/" + i45 + "/quantity", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/hkp/items/properties/quantity/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                            if (vErrors === null) {
                              vErrors = [err1013];
                            } else {
                              vErrors.push(err1013);
                            }
                            errors++;
                          }
                          if (typeof data412 == "number" && isFinite(data412)) {
                            if (data412 > 9007199254740991 || isNaN(data412)) {
                              const err1014 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/hkp/" + i45 + "/quantity", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/hkp/items/properties/quantity/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err1014];
                              } else {
                                vErrors.push(err1014);
                              }
                              errors++;
                            }
                            if (data412 < -9007199254740991 || isNaN(data412)) {
                              const err1015 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/hkp/" + i45 + "/quantity", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/hkp/items/properties/quantity/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err1015];
                              } else {
                                vErrors.push(err1015);
                              }
                              errors++;
                            }
                          }
                        }
                        if (data408.counted !== void 0) {
                          let data413 = data408.counted;
                          if (typeof data413 !== "string") {
                            const err1016 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/hkp/" + i45 + "/counted", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/hkp/items/properties/counted/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err1016];
                            } else {
                              vErrors.push(err1016);
                            }
                            errors++;
                          }
                          if (!(data413 === "bema" || data413 === "dentist" || data413 === "assumed")) {
                            const err1017 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/hkp/" + i45 + "/counted", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/hkp/items/properties/counted/enum", keyword: "enum", params: { allowedValues: schema37.properties.projectedCosts.properties.places.items.properties.hkp.items.properties.counted.enum }, message: "must be equal to one of the allowed values" };
                            if (vErrors === null) {
                              vErrors = [err1017];
                            } else {
                              vErrors.push(err1017);
                            }
                            errors++;
                          }
                        }
                        if (data408.cents !== void 0) {
                          let data414 = data408.cents;
                          if (!(typeof data414 == "number" && (!(data414 % 1) && !isNaN(data414)) && isFinite(data414))) {
                            const err1018 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/hkp/" + i45 + "/cents", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/hkp/items/properties/cents/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                            if (vErrors === null) {
                              vErrors = [err1018];
                            } else {
                              vErrors.push(err1018);
                            }
                            errors++;
                          }
                          if (typeof data414 == "number" && isFinite(data414)) {
                            if (data414 > 9007199254740991 || isNaN(data414)) {
                              const err1019 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/hkp/" + i45 + "/cents", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/hkp/items/properties/cents/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err1019];
                              } else {
                                vErrors.push(err1019);
                              }
                              errors++;
                            }
                            if (data414 < -9007199254740991 || isNaN(data414)) {
                              const err1020 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/hkp/" + i45 + "/cents", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/hkp/items/properties/cents/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err1020];
                              } else {
                                vErrors.push(err1020);
                              }
                              errors++;
                            }
                          }
                        }
                        if (data408.source !== void 0) {
                          let data415 = data408.source;
                          if (data415 && typeof data415 == "object" && !Array.isArray(data415)) {
                            if (data415.chunkId === void 0) {
                              const err1021 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/hkp/" + i45 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/hkp/items/properties/source/required", keyword: "required", params: { missingProperty: "chunkId" }, message: "must have required property 'chunkId'" };
                              if (vErrors === null) {
                                vErrors = [err1021];
                              } else {
                                vErrors.push(err1021);
                              }
                              errors++;
                            }
                            if (data415.title === void 0) {
                              const err1022 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/hkp/" + i45 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/hkp/items/properties/source/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
                              if (vErrors === null) {
                                vErrors = [err1022];
                              } else {
                                vErrors.push(err1022);
                              }
                              errors++;
                            }
                            if (data415.url === void 0) {
                              const err1023 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/hkp/" + i45 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/hkp/items/properties/source/required", keyword: "required", params: { missingProperty: "url" }, message: "must have required property 'url'" };
                              if (vErrors === null) {
                                vErrors = [err1023];
                              } else {
                                vErrors.push(err1023);
                              }
                              errors++;
                            }
                            for (const key70 in data415) {
                              if (!(key70 === "chunkId" || key70 === "title" || key70 === "url" || key70 === "page")) {
                                const err1024 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/hkp/" + i45 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/hkp/items/properties/source/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key70 }, message: "must NOT have additional properties" };
                                if (vErrors === null) {
                                  vErrors = [err1024];
                                } else {
                                  vErrors.push(err1024);
                                }
                                errors++;
                              }
                            }
                            if (data415.chunkId !== void 0) {
                              if (typeof data415.chunkId !== "string") {
                                const err1025 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/hkp/" + i45 + "/source/chunkId", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/hkp/items/properties/source/properties/chunkId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err1025];
                                } else {
                                  vErrors.push(err1025);
                                }
                                errors++;
                              }
                            }
                            if (data415.title !== void 0) {
                              if (typeof data415.title !== "string") {
                                const err1026 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/hkp/" + i45 + "/source/title", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/hkp/items/properties/source/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err1026];
                                } else {
                                  vErrors.push(err1026);
                                }
                                errors++;
                              }
                            }
                            if (data415.url !== void 0) {
                              if (typeof data415.url !== "string") {
                                const err1027 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/hkp/" + i45 + "/source/url", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/hkp/items/properties/source/properties/url/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err1027];
                                } else {
                                  vErrors.push(err1027);
                                }
                                errors++;
                              }
                            }
                            if (data415.page !== void 0) {
                              let data419 = data415.page;
                              if (!(typeof data419 == "number" && (!(data419 % 1) && !isNaN(data419)) && isFinite(data419))) {
                                const err1028 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/hkp/" + i45 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/hkp/items/properties/source/properties/page/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                if (vErrors === null) {
                                  vErrors = [err1028];
                                } else {
                                  vErrors.push(err1028);
                                }
                                errors++;
                              }
                              if (typeof data419 == "number" && isFinite(data419)) {
                                if (data419 > 9007199254740991 || isNaN(data419)) {
                                  const err1029 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/hkp/" + i45 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/hkp/items/properties/source/properties/page/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                                  if (vErrors === null) {
                                    vErrors = [err1029];
                                  } else {
                                    vErrors.push(err1029);
                                  }
                                  errors++;
                                }
                                if (data419 < -9007199254740991 || isNaN(data419)) {
                                  const err1030 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/hkp/" + i45 + "/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/hkp/items/properties/source/properties/page/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                                  if (vErrors === null) {
                                    vErrors = [err1030];
                                  } else {
                                    vErrors.push(err1030);
                                  }
                                  errors++;
                                }
                              }
                            }
                          } else {
                            const err1031 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/hkp/" + i45 + "/source", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/hkp/items/properties/source/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                            if (vErrors === null) {
                              vErrors = [err1031];
                            } else {
                              vErrors.push(err1031);
                            }
                            errors++;
                          }
                        }
                      } else {
                        const err1032 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/hkp/" + i45, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/hkp/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                        if (vErrors === null) {
                          vErrors = [err1032];
                        } else {
                          vErrors.push(err1032);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err1033 = { instancePath: instancePath + "/projectedCosts/places/" + i43 + "/hkp", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/properties/hkp/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                      vErrors = [err1033];
                    } else {
                      vErrors.push(err1033);
                    }
                    errors++;
                  }
                }
              } else {
                const err1034 = { instancePath: instancePath + "/projectedCosts/places/" + i43, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                if (vErrors === null) {
                  vErrors = [err1034];
                } else {
                  vErrors.push(err1034);
                }
                errors++;
              }
            }
          } else {
            const err1035 = { instancePath: instancePath + "/projectedCosts/places", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/places/type", keyword: "type", params: { type: "array" }, message: "must be array" };
            if (vErrors === null) {
              vErrors = [err1035];
            } else {
              vErrors.push(err1035);
            }
            errors++;
          }
        }
        if (data256.punktwert !== void 0) {
          let data420 = data256.punktwert;
          if (data420 && typeof data420 == "object" && !Array.isArray(data420)) {
            if (data420.ze === void 0) {
              const err1036 = { instancePath: instancePath + "/projectedCosts/punktwert", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/punktwert/required", keyword: "required", params: { missingProperty: "ze" }, message: "must have required property 'ze'" };
              if (vErrors === null) {
                vErrors = [err1036];
              } else {
                vErrors.push(err1036);
              }
              errors++;
            }
            for (const key71 in data420) {
              if (!(key71 === "ze" || key71 === "source")) {
                const err1037 = { instancePath: instancePath + "/projectedCosts/punktwert", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/punktwert/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key71 }, message: "must NOT have additional properties" };
                if (vErrors === null) {
                  vErrors = [err1037];
                } else {
                  vErrors.push(err1037);
                }
                errors++;
              }
            }
            if (data420.ze !== void 0) {
              let data421 = data420.ze;
              if (!(typeof data421 == "number" && (!(data421 % 1) && !isNaN(data421)) && isFinite(data421))) {
                const err1038 = { instancePath: instancePath + "/projectedCosts/punktwert/ze", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/punktwert/properties/ze/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                if (vErrors === null) {
                  vErrors = [err1038];
                } else {
                  vErrors.push(err1038);
                }
                errors++;
              }
              if (typeof data421 == "number" && isFinite(data421)) {
                if (data421 > 9007199254740991 || isNaN(data421)) {
                  const err1039 = { instancePath: instancePath + "/projectedCosts/punktwert/ze", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/punktwert/properties/ze/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err1039];
                  } else {
                    vErrors.push(err1039);
                  }
                  errors++;
                }
                if (data421 < -9007199254740991 || isNaN(data421)) {
                  const err1040 = { instancePath: instancePath + "/projectedCosts/punktwert/ze", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/punktwert/properties/ze/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err1040];
                  } else {
                    vErrors.push(err1040);
                  }
                  errors++;
                }
              }
            }
            if (data420.source !== void 0) {
              let data422 = data420.source;
              if (data422 && typeof data422 == "object" && !Array.isArray(data422)) {
                if (data422.chunkId === void 0) {
                  const err1041 = { instancePath: instancePath + "/projectedCosts/punktwert/source", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/punktwert/properties/source/required", keyword: "required", params: { missingProperty: "chunkId" }, message: "must have required property 'chunkId'" };
                  if (vErrors === null) {
                    vErrors = [err1041];
                  } else {
                    vErrors.push(err1041);
                  }
                  errors++;
                }
                if (data422.title === void 0) {
                  const err1042 = { instancePath: instancePath + "/projectedCosts/punktwert/source", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/punktwert/properties/source/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
                  if (vErrors === null) {
                    vErrors = [err1042];
                  } else {
                    vErrors.push(err1042);
                  }
                  errors++;
                }
                if (data422.url === void 0) {
                  const err1043 = { instancePath: instancePath + "/projectedCosts/punktwert/source", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/punktwert/properties/source/required", keyword: "required", params: { missingProperty: "url" }, message: "must have required property 'url'" };
                  if (vErrors === null) {
                    vErrors = [err1043];
                  } else {
                    vErrors.push(err1043);
                  }
                  errors++;
                }
                for (const key72 in data422) {
                  if (!(key72 === "chunkId" || key72 === "title" || key72 === "url" || key72 === "page")) {
                    const err1044 = { instancePath: instancePath + "/projectedCosts/punktwert/source", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/punktwert/properties/source/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key72 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                      vErrors = [err1044];
                    } else {
                      vErrors.push(err1044);
                    }
                    errors++;
                  }
                }
                if (data422.chunkId !== void 0) {
                  if (typeof data422.chunkId !== "string") {
                    const err1045 = { instancePath: instancePath + "/projectedCosts/punktwert/source/chunkId", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/punktwert/properties/source/properties/chunkId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err1045];
                    } else {
                      vErrors.push(err1045);
                    }
                    errors++;
                  }
                }
                if (data422.title !== void 0) {
                  if (typeof data422.title !== "string") {
                    const err1046 = { instancePath: instancePath + "/projectedCosts/punktwert/source/title", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/punktwert/properties/source/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err1046];
                    } else {
                      vErrors.push(err1046);
                    }
                    errors++;
                  }
                }
                if (data422.url !== void 0) {
                  if (typeof data422.url !== "string") {
                    const err1047 = { instancePath: instancePath + "/projectedCosts/punktwert/source/url", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/punktwert/properties/source/properties/url/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err1047];
                    } else {
                      vErrors.push(err1047);
                    }
                    errors++;
                  }
                }
                if (data422.page !== void 0) {
                  let data426 = data422.page;
                  if (!(typeof data426 == "number" && (!(data426 % 1) && !isNaN(data426)) && isFinite(data426))) {
                    const err1048 = { instancePath: instancePath + "/projectedCosts/punktwert/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/punktwert/properties/source/properties/page/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err1048];
                    } else {
                      vErrors.push(err1048);
                    }
                    errors++;
                  }
                  if (typeof data426 == "number" && isFinite(data426)) {
                    if (data426 > 9007199254740991 || isNaN(data426)) {
                      const err1049 = { instancePath: instancePath + "/projectedCosts/punktwert/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/punktwert/properties/source/properties/page/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err1049];
                      } else {
                        vErrors.push(err1049);
                      }
                      errors++;
                    }
                    if (data426 < -9007199254740991 || isNaN(data426)) {
                      const err1050 = { instancePath: instancePath + "/projectedCosts/punktwert/source/page", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/punktwert/properties/source/properties/page/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err1050];
                      } else {
                        vErrors.push(err1050);
                      }
                      errors++;
                    }
                  }
                }
              } else {
                const err1051 = { instancePath: instancePath + "/projectedCosts/punktwert/source", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/punktwert/properties/source/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                if (vErrors === null) {
                  vErrors = [err1051];
                } else {
                  vErrors.push(err1051);
                }
                errors++;
              }
            }
          } else {
            const err1052 = { instancePath: instancePath + "/projectedCosts/punktwert", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/punktwert/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
              vErrors = [err1052];
            } else {
              vErrors.push(err1052);
            }
            errors++;
          }
        }
        if (data256.totals !== void 0) {
          let data427 = data256.totals;
          if (data427 && typeof data427 == "object" && !Array.isArray(data427)) {
            if (data427.honorar === void 0) {
              const err1053 = { instancePath: instancePath + "/projectedCosts/totals", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/totals/required", keyword: "required", params: { missingProperty: "honorar" }, message: "must have required property 'honorar'" };
              if (vErrors === null) {
                vErrors = [err1053];
              } else {
                vErrors.push(err1053);
              }
              errors++;
            }
            if (data427.goz === void 0) {
              const err1054 = { instancePath: instancePath + "/projectedCosts/totals", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/totals/required", keyword: "required", params: { missingProperty: "goz" }, message: "must have required property 'goz'" };
              if (vErrors === null) {
                vErrors = [err1054];
              } else {
                vErrors.push(err1054);
              }
              errors++;
            }
            if (data427.labor === void 0) {
              const err1055 = { instancePath: instancePath + "/projectedCosts/totals", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/totals/required", keyword: "required", params: { missingProperty: "labor" }, message: "must have required property 'labor'" };
              if (vErrors === null) {
                vErrors = [err1055];
              } else {
                vErrors.push(err1055);
              }
              errors++;
            }
            if (data427.gesamt === void 0) {
              const err1056 = { instancePath: instancePath + "/projectedCosts/totals", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/totals/required", keyword: "required", params: { missingProperty: "gesamt" }, message: "must have required property 'gesamt'" };
              if (vErrors === null) {
                vErrors = [err1056];
              } else {
                vErrors.push(err1056);
              }
              errors++;
            }
            if (data427.festzuschuss === void 0) {
              const err1057 = { instancePath: instancePath + "/projectedCosts/totals", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/totals/required", keyword: "required", params: { missingProperty: "festzuschuss" }, message: "must have required property 'festzuschuss'" };
              if (vErrors === null) {
                vErrors = [err1057];
              } else {
                vErrors.push(err1057);
              }
              errors++;
            }
            if (data427.eigenanteil === void 0) {
              const err1058 = { instancePath: instancePath + "/projectedCosts/totals", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/totals/required", keyword: "required", params: { missingProperty: "eigenanteil" }, message: "must have required property 'eigenanteil'" };
              if (vErrors === null) {
                vErrors = [err1058];
              } else {
                vErrors.push(err1058);
              }
              errors++;
            }
            for (const key73 in data427) {
              if (!(key73 === "honorar" || key73 === "goz" || key73 === "labor" || key73 === "gesamt" || key73 === "festzuschuss" || key73 === "eigenanteil")) {
                const err1059 = { instancePath: instancePath + "/projectedCosts/totals", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/totals/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key73 }, message: "must NOT have additional properties" };
                if (vErrors === null) {
                  vErrors = [err1059];
                } else {
                  vErrors.push(err1059);
                }
                errors++;
              }
            }
            if (data427.honorar !== void 0) {
              let data428 = data427.honorar;
              if (!(typeof data428 == "number" && (!(data428 % 1) && !isNaN(data428)) && isFinite(data428))) {
                const err1060 = { instancePath: instancePath + "/projectedCosts/totals/honorar", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/totals/properties/honorar/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                if (vErrors === null) {
                  vErrors = [err1060];
                } else {
                  vErrors.push(err1060);
                }
                errors++;
              }
              if (typeof data428 == "number" && isFinite(data428)) {
                if (data428 > 9007199254740991 || isNaN(data428)) {
                  const err1061 = { instancePath: instancePath + "/projectedCosts/totals/honorar", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/totals/properties/honorar/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err1061];
                  } else {
                    vErrors.push(err1061);
                  }
                  errors++;
                }
                if (data428 < -9007199254740991 || isNaN(data428)) {
                  const err1062 = { instancePath: instancePath + "/projectedCosts/totals/honorar", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/totals/properties/honorar/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err1062];
                  } else {
                    vErrors.push(err1062);
                  }
                  errors++;
                }
              }
            }
            if (data427.goz !== void 0) {
              let data429 = data427.goz;
              if (!(typeof data429 == "number" && (!(data429 % 1) && !isNaN(data429)) && isFinite(data429))) {
                const err1063 = { instancePath: instancePath + "/projectedCosts/totals/goz", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/totals/properties/goz/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                if (vErrors === null) {
                  vErrors = [err1063];
                } else {
                  vErrors.push(err1063);
                }
                errors++;
              }
              if (typeof data429 == "number" && isFinite(data429)) {
                if (data429 > 9007199254740991 || isNaN(data429)) {
                  const err1064 = { instancePath: instancePath + "/projectedCosts/totals/goz", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/totals/properties/goz/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err1064];
                  } else {
                    vErrors.push(err1064);
                  }
                  errors++;
                }
                if (data429 < -9007199254740991 || isNaN(data429)) {
                  const err1065 = { instancePath: instancePath + "/projectedCosts/totals/goz", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/totals/properties/goz/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err1065];
                  } else {
                    vErrors.push(err1065);
                  }
                  errors++;
                }
              }
            }
            if (data427.labor !== void 0) {
              let data430 = data427.labor;
              if (!(typeof data430 == "number" && (!(data430 % 1) && !isNaN(data430)) && isFinite(data430))) {
                const err1066 = { instancePath: instancePath + "/projectedCosts/totals/labor", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/totals/properties/labor/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                if (vErrors === null) {
                  vErrors = [err1066];
                } else {
                  vErrors.push(err1066);
                }
                errors++;
              }
              if (typeof data430 == "number" && isFinite(data430)) {
                if (data430 > 9007199254740991 || isNaN(data430)) {
                  const err1067 = { instancePath: instancePath + "/projectedCosts/totals/labor", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/totals/properties/labor/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err1067];
                  } else {
                    vErrors.push(err1067);
                  }
                  errors++;
                }
                if (data430 < -9007199254740991 || isNaN(data430)) {
                  const err1068 = { instancePath: instancePath + "/projectedCosts/totals/labor", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/totals/properties/labor/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err1068];
                  } else {
                    vErrors.push(err1068);
                  }
                  errors++;
                }
              }
            }
            if (data427.gesamt !== void 0) {
              let data431 = data427.gesamt;
              if (!(typeof data431 == "number" && (!(data431 % 1) && !isNaN(data431)) && isFinite(data431))) {
                const err1069 = { instancePath: instancePath + "/projectedCosts/totals/gesamt", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/totals/properties/gesamt/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                if (vErrors === null) {
                  vErrors = [err1069];
                } else {
                  vErrors.push(err1069);
                }
                errors++;
              }
              if (typeof data431 == "number" && isFinite(data431)) {
                if (data431 > 9007199254740991 || isNaN(data431)) {
                  const err1070 = { instancePath: instancePath + "/projectedCosts/totals/gesamt", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/totals/properties/gesamt/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err1070];
                  } else {
                    vErrors.push(err1070);
                  }
                  errors++;
                }
                if (data431 < -9007199254740991 || isNaN(data431)) {
                  const err1071 = { instancePath: instancePath + "/projectedCosts/totals/gesamt", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/totals/properties/gesamt/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err1071];
                  } else {
                    vErrors.push(err1071);
                  }
                  errors++;
                }
              }
            }
            if (data427.festzuschuss !== void 0) {
              let data432 = data427.festzuschuss;
              if (data432 && typeof data432 == "object" && !Array.isArray(data432)) {
                if (data432.prozent60 === void 0) {
                  const err1072 = { instancePath: instancePath + "/projectedCosts/totals/festzuschuss", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/totals/properties/festzuschuss/required", keyword: "required", params: { missingProperty: "prozent60" }, message: "must have required property 'prozent60'" };
                  if (vErrors === null) {
                    vErrors = [err1072];
                  } else {
                    vErrors.push(err1072);
                  }
                  errors++;
                }
                if (data432.prozent70 === void 0) {
                  const err1073 = { instancePath: instancePath + "/projectedCosts/totals/festzuschuss", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/totals/properties/festzuschuss/required", keyword: "required", params: { missingProperty: "prozent70" }, message: "must have required property 'prozent70'" };
                  if (vErrors === null) {
                    vErrors = [err1073];
                  } else {
                    vErrors.push(err1073);
                  }
                  errors++;
                }
                if (data432.prozent75 === void 0) {
                  const err1074 = { instancePath: instancePath + "/projectedCosts/totals/festzuschuss", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/totals/properties/festzuschuss/required", keyword: "required", params: { missingProperty: "prozent75" }, message: "must have required property 'prozent75'" };
                  if (vErrors === null) {
                    vErrors = [err1074];
                  } else {
                    vErrors.push(err1074);
                  }
                  errors++;
                }
                if (data432.prozent100 === void 0) {
                  const err1075 = { instancePath: instancePath + "/projectedCosts/totals/festzuschuss", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/totals/properties/festzuschuss/required", keyword: "required", params: { missingProperty: "prozent100" }, message: "must have required property 'prozent100'" };
                  if (vErrors === null) {
                    vErrors = [err1075];
                  } else {
                    vErrors.push(err1075);
                  }
                  errors++;
                }
                for (const key74 in data432) {
                  if (!(key74 === "prozent60" || key74 === "prozent70" || key74 === "prozent75" || key74 === "prozent100")) {
                    const err1076 = { instancePath: instancePath + "/projectedCosts/totals/festzuschuss", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/totals/properties/festzuschuss/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key74 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                      vErrors = [err1076];
                    } else {
                      vErrors.push(err1076);
                    }
                    errors++;
                  }
                }
                if (data432.prozent60 !== void 0) {
                  let data433 = data432.prozent60;
                  if (!(typeof data433 == "number" && (!(data433 % 1) && !isNaN(data433)) && isFinite(data433))) {
                    const err1077 = { instancePath: instancePath + "/projectedCosts/totals/festzuschuss/prozent60", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/totals/properties/festzuschuss/properties/prozent60/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err1077];
                    } else {
                      vErrors.push(err1077);
                    }
                    errors++;
                  }
                  if (typeof data433 == "number" && isFinite(data433)) {
                    if (data433 > 9007199254740991 || isNaN(data433)) {
                      const err1078 = { instancePath: instancePath + "/projectedCosts/totals/festzuschuss/prozent60", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/totals/properties/festzuschuss/properties/prozent60/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err1078];
                      } else {
                        vErrors.push(err1078);
                      }
                      errors++;
                    }
                    if (data433 < -9007199254740991 || isNaN(data433)) {
                      const err1079 = { instancePath: instancePath + "/projectedCosts/totals/festzuschuss/prozent60", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/totals/properties/festzuschuss/properties/prozent60/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err1079];
                      } else {
                        vErrors.push(err1079);
                      }
                      errors++;
                    }
                  }
                }
                if (data432.prozent70 !== void 0) {
                  let data434 = data432.prozent70;
                  if (!(typeof data434 == "number" && (!(data434 % 1) && !isNaN(data434)) && isFinite(data434))) {
                    const err1080 = { instancePath: instancePath + "/projectedCosts/totals/festzuschuss/prozent70", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/totals/properties/festzuschuss/properties/prozent70/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err1080];
                    } else {
                      vErrors.push(err1080);
                    }
                    errors++;
                  }
                  if (typeof data434 == "number" && isFinite(data434)) {
                    if (data434 > 9007199254740991 || isNaN(data434)) {
                      const err1081 = { instancePath: instancePath + "/projectedCosts/totals/festzuschuss/prozent70", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/totals/properties/festzuschuss/properties/prozent70/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err1081];
                      } else {
                        vErrors.push(err1081);
                      }
                      errors++;
                    }
                    if (data434 < -9007199254740991 || isNaN(data434)) {
                      const err1082 = { instancePath: instancePath + "/projectedCosts/totals/festzuschuss/prozent70", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/totals/properties/festzuschuss/properties/prozent70/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err1082];
                      } else {
                        vErrors.push(err1082);
                      }
                      errors++;
                    }
                  }
                }
                if (data432.prozent75 !== void 0) {
                  let data435 = data432.prozent75;
                  if (!(typeof data435 == "number" && (!(data435 % 1) && !isNaN(data435)) && isFinite(data435))) {
                    const err1083 = { instancePath: instancePath + "/projectedCosts/totals/festzuschuss/prozent75", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/totals/properties/festzuschuss/properties/prozent75/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err1083];
                    } else {
                      vErrors.push(err1083);
                    }
                    errors++;
                  }
                  if (typeof data435 == "number" && isFinite(data435)) {
                    if (data435 > 9007199254740991 || isNaN(data435)) {
                      const err1084 = { instancePath: instancePath + "/projectedCosts/totals/festzuschuss/prozent75", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/totals/properties/festzuschuss/properties/prozent75/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err1084];
                      } else {
                        vErrors.push(err1084);
                      }
                      errors++;
                    }
                    if (data435 < -9007199254740991 || isNaN(data435)) {
                      const err1085 = { instancePath: instancePath + "/projectedCosts/totals/festzuschuss/prozent75", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/totals/properties/festzuschuss/properties/prozent75/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err1085];
                      } else {
                        vErrors.push(err1085);
                      }
                      errors++;
                    }
                  }
                }
                if (data432.prozent100 !== void 0) {
                  let data436 = data432.prozent100;
                  if (!(typeof data436 == "number" && (!(data436 % 1) && !isNaN(data436)) && isFinite(data436))) {
                    const err1086 = { instancePath: instancePath + "/projectedCosts/totals/festzuschuss/prozent100", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/totals/properties/festzuschuss/properties/prozent100/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err1086];
                    } else {
                      vErrors.push(err1086);
                    }
                    errors++;
                  }
                  if (typeof data436 == "number" && isFinite(data436)) {
                    if (data436 > 9007199254740991 || isNaN(data436)) {
                      const err1087 = { instancePath: instancePath + "/projectedCosts/totals/festzuschuss/prozent100", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/totals/properties/festzuschuss/properties/prozent100/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err1087];
                      } else {
                        vErrors.push(err1087);
                      }
                      errors++;
                    }
                    if (data436 < -9007199254740991 || isNaN(data436)) {
                      const err1088 = { instancePath: instancePath + "/projectedCosts/totals/festzuschuss/prozent100", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/totals/properties/festzuschuss/properties/prozent100/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err1088];
                      } else {
                        vErrors.push(err1088);
                      }
                      errors++;
                    }
                  }
                }
              } else {
                const err1089 = { instancePath: instancePath + "/projectedCosts/totals/festzuschuss", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/totals/properties/festzuschuss/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                if (vErrors === null) {
                  vErrors = [err1089];
                } else {
                  vErrors.push(err1089);
                }
                errors++;
              }
            }
            if (data427.eigenanteil !== void 0) {
              let data437 = data427.eigenanteil;
              if (data437 && typeof data437 == "object" && !Array.isArray(data437)) {
                if (data437.prozent60 === void 0) {
                  const err1090 = { instancePath: instancePath + "/projectedCosts/totals/eigenanteil", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/totals/properties/eigenanteil/required", keyword: "required", params: { missingProperty: "prozent60" }, message: "must have required property 'prozent60'" };
                  if (vErrors === null) {
                    vErrors = [err1090];
                  } else {
                    vErrors.push(err1090);
                  }
                  errors++;
                }
                if (data437.prozent70 === void 0) {
                  const err1091 = { instancePath: instancePath + "/projectedCosts/totals/eigenanteil", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/totals/properties/eigenanteil/required", keyword: "required", params: { missingProperty: "prozent70" }, message: "must have required property 'prozent70'" };
                  if (vErrors === null) {
                    vErrors = [err1091];
                  } else {
                    vErrors.push(err1091);
                  }
                  errors++;
                }
                if (data437.prozent75 === void 0) {
                  const err1092 = { instancePath: instancePath + "/projectedCosts/totals/eigenanteil", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/totals/properties/eigenanteil/required", keyword: "required", params: { missingProperty: "prozent75" }, message: "must have required property 'prozent75'" };
                  if (vErrors === null) {
                    vErrors = [err1092];
                  } else {
                    vErrors.push(err1092);
                  }
                  errors++;
                }
                if (data437.prozent100 === void 0) {
                  const err1093 = { instancePath: instancePath + "/projectedCosts/totals/eigenanteil", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/totals/properties/eigenanteil/required", keyword: "required", params: { missingProperty: "prozent100" }, message: "must have required property 'prozent100'" };
                  if (vErrors === null) {
                    vErrors = [err1093];
                  } else {
                    vErrors.push(err1093);
                  }
                  errors++;
                }
                for (const key75 in data437) {
                  if (!(key75 === "prozent60" || key75 === "prozent70" || key75 === "prozent75" || key75 === "prozent100")) {
                    const err1094 = { instancePath: instancePath + "/projectedCosts/totals/eigenanteil", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/totals/properties/eigenanteil/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key75 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                      vErrors = [err1094];
                    } else {
                      vErrors.push(err1094);
                    }
                    errors++;
                  }
                }
                if (data437.prozent60 !== void 0) {
                  let data438 = data437.prozent60;
                  if (!(typeof data438 == "number" && (!(data438 % 1) && !isNaN(data438)) && isFinite(data438))) {
                    const err1095 = { instancePath: instancePath + "/projectedCosts/totals/eigenanteil/prozent60", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/totals/properties/eigenanteil/properties/prozent60/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err1095];
                    } else {
                      vErrors.push(err1095);
                    }
                    errors++;
                  }
                  if (typeof data438 == "number" && isFinite(data438)) {
                    if (data438 > 9007199254740991 || isNaN(data438)) {
                      const err1096 = { instancePath: instancePath + "/projectedCosts/totals/eigenanteil/prozent60", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/totals/properties/eigenanteil/properties/prozent60/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err1096];
                      } else {
                        vErrors.push(err1096);
                      }
                      errors++;
                    }
                    if (data438 < -9007199254740991 || isNaN(data438)) {
                      const err1097 = { instancePath: instancePath + "/projectedCosts/totals/eigenanteil/prozent60", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/totals/properties/eigenanteil/properties/prozent60/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err1097];
                      } else {
                        vErrors.push(err1097);
                      }
                      errors++;
                    }
                  }
                }
                if (data437.prozent70 !== void 0) {
                  let data439 = data437.prozent70;
                  if (!(typeof data439 == "number" && (!(data439 % 1) && !isNaN(data439)) && isFinite(data439))) {
                    const err1098 = { instancePath: instancePath + "/projectedCosts/totals/eigenanteil/prozent70", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/totals/properties/eigenanteil/properties/prozent70/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err1098];
                    } else {
                      vErrors.push(err1098);
                    }
                    errors++;
                  }
                  if (typeof data439 == "number" && isFinite(data439)) {
                    if (data439 > 9007199254740991 || isNaN(data439)) {
                      const err1099 = { instancePath: instancePath + "/projectedCosts/totals/eigenanteil/prozent70", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/totals/properties/eigenanteil/properties/prozent70/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err1099];
                      } else {
                        vErrors.push(err1099);
                      }
                      errors++;
                    }
                    if (data439 < -9007199254740991 || isNaN(data439)) {
                      const err1100 = { instancePath: instancePath + "/projectedCosts/totals/eigenanteil/prozent70", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/totals/properties/eigenanteil/properties/prozent70/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err1100];
                      } else {
                        vErrors.push(err1100);
                      }
                      errors++;
                    }
                  }
                }
                if (data437.prozent75 !== void 0) {
                  let data440 = data437.prozent75;
                  if (!(typeof data440 == "number" && (!(data440 % 1) && !isNaN(data440)) && isFinite(data440))) {
                    const err1101 = { instancePath: instancePath + "/projectedCosts/totals/eigenanteil/prozent75", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/totals/properties/eigenanteil/properties/prozent75/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err1101];
                    } else {
                      vErrors.push(err1101);
                    }
                    errors++;
                  }
                  if (typeof data440 == "number" && isFinite(data440)) {
                    if (data440 > 9007199254740991 || isNaN(data440)) {
                      const err1102 = { instancePath: instancePath + "/projectedCosts/totals/eigenanteil/prozent75", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/totals/properties/eigenanteil/properties/prozent75/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err1102];
                      } else {
                        vErrors.push(err1102);
                      }
                      errors++;
                    }
                    if (data440 < -9007199254740991 || isNaN(data440)) {
                      const err1103 = { instancePath: instancePath + "/projectedCosts/totals/eigenanteil/prozent75", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/totals/properties/eigenanteil/properties/prozent75/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err1103];
                      } else {
                        vErrors.push(err1103);
                      }
                      errors++;
                    }
                  }
                }
                if (data437.prozent100 !== void 0) {
                  let data441 = data437.prozent100;
                  if (!(typeof data441 == "number" && (!(data441 % 1) && !isNaN(data441)) && isFinite(data441))) {
                    const err1104 = { instancePath: instancePath + "/projectedCosts/totals/eigenanteil/prozent100", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/totals/properties/eigenanteil/properties/prozent100/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err1104];
                    } else {
                      vErrors.push(err1104);
                    }
                    errors++;
                  }
                  if (typeof data441 == "number" && isFinite(data441)) {
                    if (data441 > 9007199254740991 || isNaN(data441)) {
                      const err1105 = { instancePath: instancePath + "/projectedCosts/totals/eigenanteil/prozent100", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/totals/properties/eigenanteil/properties/prozent100/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err1105];
                      } else {
                        vErrors.push(err1105);
                      }
                      errors++;
                    }
                    if (data441 < -9007199254740991 || isNaN(data441)) {
                      const err1106 = { instancePath: instancePath + "/projectedCosts/totals/eigenanteil/prozent100", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/totals/properties/eigenanteil/properties/prozent100/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err1106];
                      } else {
                        vErrors.push(err1106);
                      }
                      errors++;
                    }
                  }
                }
              } else {
                const err1107 = { instancePath: instancePath + "/projectedCosts/totals/eigenanteil", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/totals/properties/eigenanteil/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                if (vErrors === null) {
                  vErrors = [err1107];
                } else {
                  vErrors.push(err1107);
                }
                errors++;
              }
            }
          } else {
            const err1108 = { instancePath: instancePath + "/projectedCosts/totals", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/totals/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
              vErrors = [err1108];
            } else {
              vErrors.push(err1108);
            }
            errors++;
          }
        }
        if (data256.waiting !== void 0) {
          let data442 = data256.waiting;
          if (Array.isArray(data442)) {
            const len46 = data442.length;
            for (let i46 = 0; i46 < len46; i46++) {
              let data443 = data442[i46];
              if (!(typeof data443 == "number" && (!(data443 % 1) && !isNaN(data443)) && isFinite(data443))) {
                const err1109 = { instancePath: instancePath + "/projectedCosts/waiting/" + i46, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/waiting/items/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                if (vErrors === null) {
                  vErrors = [err1109];
                } else {
                  vErrors.push(err1109);
                }
                errors++;
              }
              if (typeof data443 == "number" && isFinite(data443)) {
                if (data443 > 9007199254740991 || isNaN(data443)) {
                  const err1110 = { instancePath: instancePath + "/projectedCosts/waiting/" + i46, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/waiting/items/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err1110];
                  } else {
                    vErrors.push(err1110);
                  }
                  errors++;
                }
                if (data443 < -9007199254740991 || isNaN(data443)) {
                  const err1111 = { instancePath: instancePath + "/projectedCosts/waiting/" + i46, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/waiting/items/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err1111];
                  } else {
                    vErrors.push(err1111);
                  }
                  errors++;
                }
              }
            }
          } else {
            const err1112 = { instancePath: instancePath + "/projectedCosts/waiting", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/waiting/type", keyword: "type", params: { type: "array" }, message: "must be array" };
            if (vErrors === null) {
              vErrors = [err1112];
            } else {
              vErrors.push(err1112);
            }
            errors++;
          }
        }
        if (data256.placeholders !== void 0) {
          let data444 = data256.placeholders;
          if (Array.isArray(data444)) {
            const len47 = data444.length;
            for (let i47 = 0; i47 < len47; i47++) {
              let data445 = data444[i47];
              if (data445 && typeof data445 == "object" && !Array.isArray(data445)) {
                if (data445.id === void 0) {
                  const err1113 = { instancePath: instancePath + "/projectedCosts/placeholders/" + i47, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/placeholders/items/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property 'id'" };
                  if (vErrors === null) {
                    vErrors = [err1113];
                  } else {
                    vErrors.push(err1113);
                  }
                  errors++;
                }
                if (data445.text === void 0) {
                  const err1114 = { instancePath: instancePath + "/projectedCosts/placeholders/" + i47, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/placeholders/items/required", keyword: "required", params: { missingProperty: "text" }, message: "must have required property 'text'" };
                  if (vErrors === null) {
                    vErrors = [err1114];
                  } else {
                    vErrors.push(err1114);
                  }
                  errors++;
                }
                for (const key76 in data445) {
                  if (!(key76 === "id" || key76 === "text")) {
                    const err1115 = { instancePath: instancePath + "/projectedCosts/placeholders/" + i47, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/placeholders/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key76 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                      vErrors = [err1115];
                    } else {
                      vErrors.push(err1115);
                    }
                    errors++;
                  }
                }
                if (data445.id !== void 0) {
                  let data446 = data445.id;
                  if (typeof data446 !== "string") {
                    const err1116 = { instancePath: instancePath + "/projectedCosts/placeholders/" + i47 + "/id", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/placeholders/items/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err1116];
                    } else {
                      vErrors.push(err1116);
                    }
                    errors++;
                  }
                  if (!(data446 === "punktwert" || data446 === "labor" || data446 === "materialPreise" || data446 === "anzahl" || data446 === "faktor" || data446 === "laborGleichartig" || data446 === "eigenanteil")) {
                    const err1117 = { instancePath: instancePath + "/projectedCosts/placeholders/" + i47 + "/id", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/placeholders/items/properties/id/enum", keyword: "enum", params: { allowedValues: schema37.properties.projectedCosts.properties.placeholders.items.properties.id.enum }, message: "must be equal to one of the allowed values" };
                    if (vErrors === null) {
                      vErrors = [err1117];
                    } else {
                      vErrors.push(err1117);
                    }
                    errors++;
                  }
                }
                if (data445.text !== void 0) {
                  if (typeof data445.text !== "string") {
                    const err1118 = { instancePath: instancePath + "/projectedCosts/placeholders/" + i47 + "/text", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/placeholders/items/properties/text/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err1118];
                    } else {
                      vErrors.push(err1118);
                    }
                    errors++;
                  }
                }
              } else {
                const err1119 = { instancePath: instancePath + "/projectedCosts/placeholders/" + i47, schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/placeholders/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                if (vErrors === null) {
                  vErrors = [err1119];
                } else {
                  vErrors.push(err1119);
                }
                errors++;
              }
            }
          } else {
            const err1120 = { instancePath: instancePath + "/projectedCosts/placeholders", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/properties/placeholders/type", keyword: "type", params: { type: "array" }, message: "must be array" };
            if (vErrors === null) {
              vErrors = [err1120];
            } else {
              vErrors.push(err1120);
            }
            errors++;
          }
        }
      } else {
        const err1121 = { instancePath: instancePath + "/projectedCosts", schemaPath: "#/definitions/VerificationEvaluation/properties/projectedCosts/type", keyword: "type", params: { type: "object" }, message: "must be object" };
        if (vErrors === null) {
          vErrors = [err1121];
        } else {
          vErrors.push(err1121);
        }
        errors++;
      }
    }
    if (data.unterlagen !== void 0) {
      let data448 = data.unterlagen;
      if (data448 && typeof data448 == "object" && !Array.isArray(data448)) {
        if (data448.patienteninformation === void 0) {
          const err1122 = { instancePath: instancePath + "/unterlagen", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/required", keyword: "required", params: { missingProperty: "patienteninformation" }, message: "must have required property 'patienteninformation'" };
          if (vErrors === null) {
            vErrors = [err1122];
          } else {
            vErrors.push(err1122);
          }
          errors++;
        }
        if (data448.bewilligung === void 0) {
          const err1123 = { instancePath: instancePath + "/unterlagen", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/required", keyword: "required", params: { missingProperty: "bewilligung" }, message: "must have required property 'bewilligung'" };
          if (vErrors === null) {
            vErrors = [err1123];
          } else {
            vErrors.push(err1123);
          }
          errors++;
        }
        if (data448.passages === void 0) {
          const err1124 = { instancePath: instancePath + "/unterlagen", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/required", keyword: "required", params: { missingProperty: "passages" }, message: "must have required property 'passages'" };
          if (vErrors === null) {
            vErrors = [err1124];
          } else {
            vErrors.push(err1124);
          }
          errors++;
        }
        for (const key77 in data448) {
          if (!(key77 === "patienteninformation" || key77 === "bewilligung" || key77 === "passages")) {
            const err1125 = { instancePath: instancePath + "/unterlagen", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key77 }, message: "must NOT have additional properties" };
            if (vErrors === null) {
              vErrors = [err1125];
            } else {
              vErrors.push(err1125);
            }
            errors++;
          }
        }
        if (data448.patienteninformation !== void 0) {
          let data449 = data448.patienteninformation;
          if (typeof data449 !== "string") {
            const err1126 = { instancePath: instancePath + "/unterlagen/patienteninformation", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/patienteninformation/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err1126];
            } else {
              vErrors.push(err1126);
            }
            errors++;
          }
          if (!(data449 === "3c" || data449 === "3d")) {
            const err1127 = { instancePath: instancePath + "/unterlagen/patienteninformation", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/patienteninformation/enum", keyword: "enum", params: { allowedValues: schema37.properties.unterlagen.properties.patienteninformation.enum }, message: "must be equal to one of the allowed values" };
            if (vErrors === null) {
              vErrors = [err1127];
            } else {
              vErrors.push(err1127);
            }
            errors++;
          }
        }
        if (data448.bewilligung !== void 0) {
          let data450 = data448.bewilligung;
          if (typeof data450 !== "string") {
            const err1128 = { instancePath: instancePath + "/unterlagen/bewilligung", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/bewilligung/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err1128];
            } else {
              vErrors.push(err1128);
            }
            errors++;
          }
          if (!(data450 === "vorher" || data450 === "ohne" || data450 === "ohne_ausser_haertefall")) {
            const err1129 = { instancePath: instancePath + "/unterlagen/bewilligung", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/bewilligung/enum", keyword: "enum", params: { allowedValues: schema37.properties.unterlagen.properties.bewilligung.enum }, message: "must be equal to one of the allowed values" };
            if (vErrors === null) {
              vErrors = [err1129];
            } else {
              vErrors.push(err1129);
            }
            errors++;
          }
        }
        if (data448.passages !== void 0) {
          let data451 = data448.passages;
          if (data451 && typeof data451 == "object" && !Array.isArray(data451)) {
            if (data451.aufklaerung === void 0) {
              const err1130 = { instancePath: instancePath + "/unterlagen/passages", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/required", keyword: "required", params: { missingProperty: "aufklaerung" }, message: "must have required property 'aufklaerung'" };
              if (vErrors === null) {
                vErrors = [err1130];
              } else {
                vErrors.push(err1130);
              }
              errors++;
            }
            if (data451.bonus === void 0) {
              const err1131 = { instancePath: instancePath + "/unterlagen/passages", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/required", keyword: "required", params: { missingProperty: "bonus" }, message: "must have required property 'bonus'" };
              if (vErrors === null) {
                vErrors = [err1131];
              } else {
                vErrors.push(err1131);
              }
              errors++;
            }
            if (data451.patienteninformation === void 0) {
              const err1132 = { instancePath: instancePath + "/unterlagen/passages", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/required", keyword: "required", params: { missingProperty: "patienteninformation" }, message: "must have required property 'patienteninformation'" };
              if (vErrors === null) {
                vErrors = [err1132];
              } else {
                vErrors.push(err1132);
              }
              errors++;
            }
            if (data451.unterschrift === void 0) {
              const err1133 = { instancePath: instancePath + "/unterlagen/passages", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/required", keyword: "required", params: { missingProperty: "unterschrift" }, message: "must have required property 'unterschrift'" };
              if (vErrors === null) {
                vErrors = [err1133];
              } else {
                vErrors.push(err1133);
              }
              errors++;
            }
            if (data451.genehmigung === void 0) {
              const err1134 = { instancePath: instancePath + "/unterlagen/passages", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/required", keyword: "required", params: { missingProperty: "genehmigung" }, message: "must have required property 'genehmigung'" };
              if (vErrors === null) {
                vErrors = [err1134];
              } else {
                vErrors.push(err1134);
              }
              errors++;
            }
            if (data451.eingliederung === void 0) {
              const err1135 = { instancePath: instancePath + "/unterlagen/passages", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/required", keyword: "required", params: { missingProperty: "eingliederung" }, message: "must have required property 'eingliederung'" };
              if (vErrors === null) {
                vErrors = [err1135];
              } else {
                vErrors.push(err1135);
              }
              errors++;
            }
            if (data451.wiederherstellungen === void 0) {
              const err1136 = { instancePath: instancePath + "/unterlagen/passages", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/required", keyword: "required", params: { missingProperty: "wiederherstellungen" }, message: "must have required property 'wiederherstellungen'" };
              if (vErrors === null) {
                vErrors = [err1136];
              } else {
                vErrors.push(err1136);
              }
              errors++;
            }
            if (data451.ohneBewilligung === void 0) {
              const err1137 = { instancePath: instancePath + "/unterlagen/passages", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/required", keyword: "required", params: { missingProperty: "ohneBewilligung" }, message: "must have required property 'ohneBewilligung'" };
              if (vErrors === null) {
                vErrors = [err1137];
              } else {
                vErrors.push(err1137);
              }
              errors++;
            }
            if (data451.stiftaufbauten === void 0) {
              const err1138 = { instancePath: instancePath + "/unterlagen/passages", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/required", keyword: "required", params: { missingProperty: "stiftaufbauten" }, message: "must have required property 'stiftaufbauten'" };
              if (vErrors === null) {
                vErrors = [err1138];
              } else {
                vErrors.push(err1138);
              }
              errors++;
            }
            if (data451.haertefall === void 0) {
              const err1139 = { instancePath: instancePath + "/unterlagen/passages", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/required", keyword: "required", params: { missingProperty: "haertefall" }, message: "must have required property 'haertefall'" };
              if (vErrors === null) {
                vErrors = [err1139];
              } else {
                vErrors.push(err1139);
              }
              errors++;
            }
            for (const key78 in data451) {
              if (!func6.call(schema37.properties.unterlagen.properties.passages.properties, key78)) {
                const err1140 = { instancePath: instancePath + "/unterlagen/passages", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key78 }, message: "must NOT have additional properties" };
                if (vErrors === null) {
                  vErrors = [err1140];
                } else {
                  vErrors.push(err1140);
                }
                errors++;
              }
            }
            if (data451.aufklaerung !== void 0) {
              let data452 = data451.aufklaerung;
              if (data452 && typeof data452 == "object" && !Array.isArray(data452)) {
                if (data452.chunkId === void 0) {
                  const err1141 = { instancePath: instancePath + "/unterlagen/passages/aufklaerung", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/aufklaerung/required", keyword: "required", params: { missingProperty: "chunkId" }, message: "must have required property 'chunkId'" };
                  if (vErrors === null) {
                    vErrors = [err1141];
                  } else {
                    vErrors.push(err1141);
                  }
                  errors++;
                }
                if (data452.title === void 0) {
                  const err1142 = { instancePath: instancePath + "/unterlagen/passages/aufklaerung", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/aufklaerung/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
                  if (vErrors === null) {
                    vErrors = [err1142];
                  } else {
                    vErrors.push(err1142);
                  }
                  errors++;
                }
                if (data452.url === void 0) {
                  const err1143 = { instancePath: instancePath + "/unterlagen/passages/aufklaerung", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/aufklaerung/required", keyword: "required", params: { missingProperty: "url" }, message: "must have required property 'url'" };
                  if (vErrors === null) {
                    vErrors = [err1143];
                  } else {
                    vErrors.push(err1143);
                  }
                  errors++;
                }
                if (data452.quote === void 0) {
                  const err1144 = { instancePath: instancePath + "/unterlagen/passages/aufklaerung", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/aufklaerung/required", keyword: "required", params: { missingProperty: "quote" }, message: "must have required property 'quote'" };
                  if (vErrors === null) {
                    vErrors = [err1144];
                  } else {
                    vErrors.push(err1144);
                  }
                  errors++;
                }
                for (const key79 in data452) {
                  if (!(key79 === "chunkId" || key79 === "title" || key79 === "url" || key79 === "page" || key79 === "quote")) {
                    const err1145 = { instancePath: instancePath + "/unterlagen/passages/aufklaerung", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/aufklaerung/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key79 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                      vErrors = [err1145];
                    } else {
                      vErrors.push(err1145);
                    }
                    errors++;
                  }
                }
                if (data452.chunkId !== void 0) {
                  if (typeof data452.chunkId !== "string") {
                    const err1146 = { instancePath: instancePath + "/unterlagen/passages/aufklaerung/chunkId", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/aufklaerung/properties/chunkId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err1146];
                    } else {
                      vErrors.push(err1146);
                    }
                    errors++;
                  }
                }
                if (data452.title !== void 0) {
                  if (typeof data452.title !== "string") {
                    const err1147 = { instancePath: instancePath + "/unterlagen/passages/aufklaerung/title", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/aufklaerung/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err1147];
                    } else {
                      vErrors.push(err1147);
                    }
                    errors++;
                  }
                }
                if (data452.url !== void 0) {
                  if (typeof data452.url !== "string") {
                    const err1148 = { instancePath: instancePath + "/unterlagen/passages/aufklaerung/url", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/aufklaerung/properties/url/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err1148];
                    } else {
                      vErrors.push(err1148);
                    }
                    errors++;
                  }
                }
                if (data452.page !== void 0) {
                  let data456 = data452.page;
                  if (!(typeof data456 == "number" && (!(data456 % 1) && !isNaN(data456)) && isFinite(data456))) {
                    const err1149 = { instancePath: instancePath + "/unterlagen/passages/aufklaerung/page", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/aufklaerung/properties/page/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err1149];
                    } else {
                      vErrors.push(err1149);
                    }
                    errors++;
                  }
                  if (typeof data456 == "number" && isFinite(data456)) {
                    if (data456 > 9007199254740991 || isNaN(data456)) {
                      const err1150 = { instancePath: instancePath + "/unterlagen/passages/aufklaerung/page", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/aufklaerung/properties/page/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err1150];
                      } else {
                        vErrors.push(err1150);
                      }
                      errors++;
                    }
                    if (data456 < -9007199254740991 || isNaN(data456)) {
                      const err1151 = { instancePath: instancePath + "/unterlagen/passages/aufklaerung/page", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/aufklaerung/properties/page/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err1151];
                      } else {
                        vErrors.push(err1151);
                      }
                      errors++;
                    }
                  }
                }
                if (data452.quote !== void 0) {
                  if (typeof data452.quote !== "string") {
                    const err1152 = { instancePath: instancePath + "/unterlagen/passages/aufklaerung/quote", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/aufklaerung/properties/quote/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err1152];
                    } else {
                      vErrors.push(err1152);
                    }
                    errors++;
                  }
                }
              } else {
                const err1153 = { instancePath: instancePath + "/unterlagen/passages/aufklaerung", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/aufklaerung/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                if (vErrors === null) {
                  vErrors = [err1153];
                } else {
                  vErrors.push(err1153);
                }
                errors++;
              }
            }
            if (data451.bonus !== void 0) {
              let data458 = data451.bonus;
              if (data458 && typeof data458 == "object" && !Array.isArray(data458)) {
                if (data458.chunkId === void 0) {
                  const err1154 = { instancePath: instancePath + "/unterlagen/passages/bonus", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/bonus/required", keyword: "required", params: { missingProperty: "chunkId" }, message: "must have required property 'chunkId'" };
                  if (vErrors === null) {
                    vErrors = [err1154];
                  } else {
                    vErrors.push(err1154);
                  }
                  errors++;
                }
                if (data458.title === void 0) {
                  const err1155 = { instancePath: instancePath + "/unterlagen/passages/bonus", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/bonus/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
                  if (vErrors === null) {
                    vErrors = [err1155];
                  } else {
                    vErrors.push(err1155);
                  }
                  errors++;
                }
                if (data458.url === void 0) {
                  const err1156 = { instancePath: instancePath + "/unterlagen/passages/bonus", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/bonus/required", keyword: "required", params: { missingProperty: "url" }, message: "must have required property 'url'" };
                  if (vErrors === null) {
                    vErrors = [err1156];
                  } else {
                    vErrors.push(err1156);
                  }
                  errors++;
                }
                if (data458.quote === void 0) {
                  const err1157 = { instancePath: instancePath + "/unterlagen/passages/bonus", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/bonus/required", keyword: "required", params: { missingProperty: "quote" }, message: "must have required property 'quote'" };
                  if (vErrors === null) {
                    vErrors = [err1157];
                  } else {
                    vErrors.push(err1157);
                  }
                  errors++;
                }
                for (const key80 in data458) {
                  if (!(key80 === "chunkId" || key80 === "title" || key80 === "url" || key80 === "page" || key80 === "quote")) {
                    const err1158 = { instancePath: instancePath + "/unterlagen/passages/bonus", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/bonus/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key80 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                      vErrors = [err1158];
                    } else {
                      vErrors.push(err1158);
                    }
                    errors++;
                  }
                }
                if (data458.chunkId !== void 0) {
                  if (typeof data458.chunkId !== "string") {
                    const err1159 = { instancePath: instancePath + "/unterlagen/passages/bonus/chunkId", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/bonus/properties/chunkId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err1159];
                    } else {
                      vErrors.push(err1159);
                    }
                    errors++;
                  }
                }
                if (data458.title !== void 0) {
                  if (typeof data458.title !== "string") {
                    const err1160 = { instancePath: instancePath + "/unterlagen/passages/bonus/title", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/bonus/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err1160];
                    } else {
                      vErrors.push(err1160);
                    }
                    errors++;
                  }
                }
                if (data458.url !== void 0) {
                  if (typeof data458.url !== "string") {
                    const err1161 = { instancePath: instancePath + "/unterlagen/passages/bonus/url", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/bonus/properties/url/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err1161];
                    } else {
                      vErrors.push(err1161);
                    }
                    errors++;
                  }
                }
                if (data458.page !== void 0) {
                  let data462 = data458.page;
                  if (!(typeof data462 == "number" && (!(data462 % 1) && !isNaN(data462)) && isFinite(data462))) {
                    const err1162 = { instancePath: instancePath + "/unterlagen/passages/bonus/page", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/bonus/properties/page/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err1162];
                    } else {
                      vErrors.push(err1162);
                    }
                    errors++;
                  }
                  if (typeof data462 == "number" && isFinite(data462)) {
                    if (data462 > 9007199254740991 || isNaN(data462)) {
                      const err1163 = { instancePath: instancePath + "/unterlagen/passages/bonus/page", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/bonus/properties/page/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err1163];
                      } else {
                        vErrors.push(err1163);
                      }
                      errors++;
                    }
                    if (data462 < -9007199254740991 || isNaN(data462)) {
                      const err1164 = { instancePath: instancePath + "/unterlagen/passages/bonus/page", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/bonus/properties/page/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err1164];
                      } else {
                        vErrors.push(err1164);
                      }
                      errors++;
                    }
                  }
                }
                if (data458.quote !== void 0) {
                  if (typeof data458.quote !== "string") {
                    const err1165 = { instancePath: instancePath + "/unterlagen/passages/bonus/quote", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/bonus/properties/quote/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err1165];
                    } else {
                      vErrors.push(err1165);
                    }
                    errors++;
                  }
                }
              } else {
                const err1166 = { instancePath: instancePath + "/unterlagen/passages/bonus", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/bonus/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                if (vErrors === null) {
                  vErrors = [err1166];
                } else {
                  vErrors.push(err1166);
                }
                errors++;
              }
            }
            if (data451.patienteninformation !== void 0) {
              let data464 = data451.patienteninformation;
              if (data464 && typeof data464 == "object" && !Array.isArray(data464)) {
                if (data464.chunkId === void 0) {
                  const err1167 = { instancePath: instancePath + "/unterlagen/passages/patienteninformation", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/patienteninformation/required", keyword: "required", params: { missingProperty: "chunkId" }, message: "must have required property 'chunkId'" };
                  if (vErrors === null) {
                    vErrors = [err1167];
                  } else {
                    vErrors.push(err1167);
                  }
                  errors++;
                }
                if (data464.title === void 0) {
                  const err1168 = { instancePath: instancePath + "/unterlagen/passages/patienteninformation", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/patienteninformation/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
                  if (vErrors === null) {
                    vErrors = [err1168];
                  } else {
                    vErrors.push(err1168);
                  }
                  errors++;
                }
                if (data464.url === void 0) {
                  const err1169 = { instancePath: instancePath + "/unterlagen/passages/patienteninformation", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/patienteninformation/required", keyword: "required", params: { missingProperty: "url" }, message: "must have required property 'url'" };
                  if (vErrors === null) {
                    vErrors = [err1169];
                  } else {
                    vErrors.push(err1169);
                  }
                  errors++;
                }
                if (data464.quote === void 0) {
                  const err1170 = { instancePath: instancePath + "/unterlagen/passages/patienteninformation", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/patienteninformation/required", keyword: "required", params: { missingProperty: "quote" }, message: "must have required property 'quote'" };
                  if (vErrors === null) {
                    vErrors = [err1170];
                  } else {
                    vErrors.push(err1170);
                  }
                  errors++;
                }
                for (const key81 in data464) {
                  if (!(key81 === "chunkId" || key81 === "title" || key81 === "url" || key81 === "page" || key81 === "quote")) {
                    const err1171 = { instancePath: instancePath + "/unterlagen/passages/patienteninformation", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/patienteninformation/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key81 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                      vErrors = [err1171];
                    } else {
                      vErrors.push(err1171);
                    }
                    errors++;
                  }
                }
                if (data464.chunkId !== void 0) {
                  if (typeof data464.chunkId !== "string") {
                    const err1172 = { instancePath: instancePath + "/unterlagen/passages/patienteninformation/chunkId", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/patienteninformation/properties/chunkId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err1172];
                    } else {
                      vErrors.push(err1172);
                    }
                    errors++;
                  }
                }
                if (data464.title !== void 0) {
                  if (typeof data464.title !== "string") {
                    const err1173 = { instancePath: instancePath + "/unterlagen/passages/patienteninformation/title", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/patienteninformation/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err1173];
                    } else {
                      vErrors.push(err1173);
                    }
                    errors++;
                  }
                }
                if (data464.url !== void 0) {
                  if (typeof data464.url !== "string") {
                    const err1174 = { instancePath: instancePath + "/unterlagen/passages/patienteninformation/url", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/patienteninformation/properties/url/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err1174];
                    } else {
                      vErrors.push(err1174);
                    }
                    errors++;
                  }
                }
                if (data464.page !== void 0) {
                  let data468 = data464.page;
                  if (!(typeof data468 == "number" && (!(data468 % 1) && !isNaN(data468)) && isFinite(data468))) {
                    const err1175 = { instancePath: instancePath + "/unterlagen/passages/patienteninformation/page", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/patienteninformation/properties/page/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err1175];
                    } else {
                      vErrors.push(err1175);
                    }
                    errors++;
                  }
                  if (typeof data468 == "number" && isFinite(data468)) {
                    if (data468 > 9007199254740991 || isNaN(data468)) {
                      const err1176 = { instancePath: instancePath + "/unterlagen/passages/patienteninformation/page", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/patienteninformation/properties/page/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err1176];
                      } else {
                        vErrors.push(err1176);
                      }
                      errors++;
                    }
                    if (data468 < -9007199254740991 || isNaN(data468)) {
                      const err1177 = { instancePath: instancePath + "/unterlagen/passages/patienteninformation/page", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/patienteninformation/properties/page/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err1177];
                      } else {
                        vErrors.push(err1177);
                      }
                      errors++;
                    }
                  }
                }
                if (data464.quote !== void 0) {
                  if (typeof data464.quote !== "string") {
                    const err1178 = { instancePath: instancePath + "/unterlagen/passages/patienteninformation/quote", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/patienteninformation/properties/quote/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err1178];
                    } else {
                      vErrors.push(err1178);
                    }
                    errors++;
                  }
                }
              } else {
                const err1179 = { instancePath: instancePath + "/unterlagen/passages/patienteninformation", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/patienteninformation/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                if (vErrors === null) {
                  vErrors = [err1179];
                } else {
                  vErrors.push(err1179);
                }
                errors++;
              }
            }
            if (data451.unterschrift !== void 0) {
              let data470 = data451.unterschrift;
              if (data470 && typeof data470 == "object" && !Array.isArray(data470)) {
                if (data470.chunkId === void 0) {
                  const err1180 = { instancePath: instancePath + "/unterlagen/passages/unterschrift", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/unterschrift/required", keyword: "required", params: { missingProperty: "chunkId" }, message: "must have required property 'chunkId'" };
                  if (vErrors === null) {
                    vErrors = [err1180];
                  } else {
                    vErrors.push(err1180);
                  }
                  errors++;
                }
                if (data470.title === void 0) {
                  const err1181 = { instancePath: instancePath + "/unterlagen/passages/unterschrift", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/unterschrift/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
                  if (vErrors === null) {
                    vErrors = [err1181];
                  } else {
                    vErrors.push(err1181);
                  }
                  errors++;
                }
                if (data470.url === void 0) {
                  const err1182 = { instancePath: instancePath + "/unterlagen/passages/unterschrift", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/unterschrift/required", keyword: "required", params: { missingProperty: "url" }, message: "must have required property 'url'" };
                  if (vErrors === null) {
                    vErrors = [err1182];
                  } else {
                    vErrors.push(err1182);
                  }
                  errors++;
                }
                if (data470.quote === void 0) {
                  const err1183 = { instancePath: instancePath + "/unterlagen/passages/unterschrift", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/unterschrift/required", keyword: "required", params: { missingProperty: "quote" }, message: "must have required property 'quote'" };
                  if (vErrors === null) {
                    vErrors = [err1183];
                  } else {
                    vErrors.push(err1183);
                  }
                  errors++;
                }
                for (const key82 in data470) {
                  if (!(key82 === "chunkId" || key82 === "title" || key82 === "url" || key82 === "page" || key82 === "quote")) {
                    const err1184 = { instancePath: instancePath + "/unterlagen/passages/unterschrift", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/unterschrift/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key82 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                      vErrors = [err1184];
                    } else {
                      vErrors.push(err1184);
                    }
                    errors++;
                  }
                }
                if (data470.chunkId !== void 0) {
                  if (typeof data470.chunkId !== "string") {
                    const err1185 = { instancePath: instancePath + "/unterlagen/passages/unterschrift/chunkId", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/unterschrift/properties/chunkId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err1185];
                    } else {
                      vErrors.push(err1185);
                    }
                    errors++;
                  }
                }
                if (data470.title !== void 0) {
                  if (typeof data470.title !== "string") {
                    const err1186 = { instancePath: instancePath + "/unterlagen/passages/unterschrift/title", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/unterschrift/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err1186];
                    } else {
                      vErrors.push(err1186);
                    }
                    errors++;
                  }
                }
                if (data470.url !== void 0) {
                  if (typeof data470.url !== "string") {
                    const err1187 = { instancePath: instancePath + "/unterlagen/passages/unterschrift/url", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/unterschrift/properties/url/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err1187];
                    } else {
                      vErrors.push(err1187);
                    }
                    errors++;
                  }
                }
                if (data470.page !== void 0) {
                  let data474 = data470.page;
                  if (!(typeof data474 == "number" && (!(data474 % 1) && !isNaN(data474)) && isFinite(data474))) {
                    const err1188 = { instancePath: instancePath + "/unterlagen/passages/unterschrift/page", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/unterschrift/properties/page/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err1188];
                    } else {
                      vErrors.push(err1188);
                    }
                    errors++;
                  }
                  if (typeof data474 == "number" && isFinite(data474)) {
                    if (data474 > 9007199254740991 || isNaN(data474)) {
                      const err1189 = { instancePath: instancePath + "/unterlagen/passages/unterschrift/page", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/unterschrift/properties/page/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err1189];
                      } else {
                        vErrors.push(err1189);
                      }
                      errors++;
                    }
                    if (data474 < -9007199254740991 || isNaN(data474)) {
                      const err1190 = { instancePath: instancePath + "/unterlagen/passages/unterschrift/page", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/unterschrift/properties/page/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err1190];
                      } else {
                        vErrors.push(err1190);
                      }
                      errors++;
                    }
                  }
                }
                if (data470.quote !== void 0) {
                  if (typeof data470.quote !== "string") {
                    const err1191 = { instancePath: instancePath + "/unterlagen/passages/unterschrift/quote", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/unterschrift/properties/quote/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err1191];
                    } else {
                      vErrors.push(err1191);
                    }
                    errors++;
                  }
                }
              } else {
                const err1192 = { instancePath: instancePath + "/unterlagen/passages/unterschrift", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/unterschrift/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                if (vErrors === null) {
                  vErrors = [err1192];
                } else {
                  vErrors.push(err1192);
                }
                errors++;
              }
            }
            if (data451.genehmigung !== void 0) {
              let data476 = data451.genehmigung;
              if (data476 && typeof data476 == "object" && !Array.isArray(data476)) {
                if (data476.chunkId === void 0) {
                  const err1193 = { instancePath: instancePath + "/unterlagen/passages/genehmigung", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/genehmigung/required", keyword: "required", params: { missingProperty: "chunkId" }, message: "must have required property 'chunkId'" };
                  if (vErrors === null) {
                    vErrors = [err1193];
                  } else {
                    vErrors.push(err1193);
                  }
                  errors++;
                }
                if (data476.title === void 0) {
                  const err1194 = { instancePath: instancePath + "/unterlagen/passages/genehmigung", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/genehmigung/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
                  if (vErrors === null) {
                    vErrors = [err1194];
                  } else {
                    vErrors.push(err1194);
                  }
                  errors++;
                }
                if (data476.url === void 0) {
                  const err1195 = { instancePath: instancePath + "/unterlagen/passages/genehmigung", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/genehmigung/required", keyword: "required", params: { missingProperty: "url" }, message: "must have required property 'url'" };
                  if (vErrors === null) {
                    vErrors = [err1195];
                  } else {
                    vErrors.push(err1195);
                  }
                  errors++;
                }
                if (data476.quote === void 0) {
                  const err1196 = { instancePath: instancePath + "/unterlagen/passages/genehmigung", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/genehmigung/required", keyword: "required", params: { missingProperty: "quote" }, message: "must have required property 'quote'" };
                  if (vErrors === null) {
                    vErrors = [err1196];
                  } else {
                    vErrors.push(err1196);
                  }
                  errors++;
                }
                for (const key83 in data476) {
                  if (!(key83 === "chunkId" || key83 === "title" || key83 === "url" || key83 === "page" || key83 === "quote")) {
                    const err1197 = { instancePath: instancePath + "/unterlagen/passages/genehmigung", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/genehmigung/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key83 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                      vErrors = [err1197];
                    } else {
                      vErrors.push(err1197);
                    }
                    errors++;
                  }
                }
                if (data476.chunkId !== void 0) {
                  if (typeof data476.chunkId !== "string") {
                    const err1198 = { instancePath: instancePath + "/unterlagen/passages/genehmigung/chunkId", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/genehmigung/properties/chunkId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err1198];
                    } else {
                      vErrors.push(err1198);
                    }
                    errors++;
                  }
                }
                if (data476.title !== void 0) {
                  if (typeof data476.title !== "string") {
                    const err1199 = { instancePath: instancePath + "/unterlagen/passages/genehmigung/title", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/genehmigung/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err1199];
                    } else {
                      vErrors.push(err1199);
                    }
                    errors++;
                  }
                }
                if (data476.url !== void 0) {
                  if (typeof data476.url !== "string") {
                    const err1200 = { instancePath: instancePath + "/unterlagen/passages/genehmigung/url", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/genehmigung/properties/url/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err1200];
                    } else {
                      vErrors.push(err1200);
                    }
                    errors++;
                  }
                }
                if (data476.page !== void 0) {
                  let data480 = data476.page;
                  if (!(typeof data480 == "number" && (!(data480 % 1) && !isNaN(data480)) && isFinite(data480))) {
                    const err1201 = { instancePath: instancePath + "/unterlagen/passages/genehmigung/page", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/genehmigung/properties/page/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err1201];
                    } else {
                      vErrors.push(err1201);
                    }
                    errors++;
                  }
                  if (typeof data480 == "number" && isFinite(data480)) {
                    if (data480 > 9007199254740991 || isNaN(data480)) {
                      const err1202 = { instancePath: instancePath + "/unterlagen/passages/genehmigung/page", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/genehmigung/properties/page/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err1202];
                      } else {
                        vErrors.push(err1202);
                      }
                      errors++;
                    }
                    if (data480 < -9007199254740991 || isNaN(data480)) {
                      const err1203 = { instancePath: instancePath + "/unterlagen/passages/genehmigung/page", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/genehmigung/properties/page/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err1203];
                      } else {
                        vErrors.push(err1203);
                      }
                      errors++;
                    }
                  }
                }
                if (data476.quote !== void 0) {
                  if (typeof data476.quote !== "string") {
                    const err1204 = { instancePath: instancePath + "/unterlagen/passages/genehmigung/quote", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/genehmigung/properties/quote/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err1204];
                    } else {
                      vErrors.push(err1204);
                    }
                    errors++;
                  }
                }
              } else {
                const err1205 = { instancePath: instancePath + "/unterlagen/passages/genehmigung", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/genehmigung/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                if (vErrors === null) {
                  vErrors = [err1205];
                } else {
                  vErrors.push(err1205);
                }
                errors++;
              }
            }
            if (data451.eingliederung !== void 0) {
              let data482 = data451.eingliederung;
              if (data482 && typeof data482 == "object" && !Array.isArray(data482)) {
                if (data482.chunkId === void 0) {
                  const err1206 = { instancePath: instancePath + "/unterlagen/passages/eingliederung", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/eingliederung/required", keyword: "required", params: { missingProperty: "chunkId" }, message: "must have required property 'chunkId'" };
                  if (vErrors === null) {
                    vErrors = [err1206];
                  } else {
                    vErrors.push(err1206);
                  }
                  errors++;
                }
                if (data482.title === void 0) {
                  const err1207 = { instancePath: instancePath + "/unterlagen/passages/eingliederung", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/eingliederung/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
                  if (vErrors === null) {
                    vErrors = [err1207];
                  } else {
                    vErrors.push(err1207);
                  }
                  errors++;
                }
                if (data482.url === void 0) {
                  const err1208 = { instancePath: instancePath + "/unterlagen/passages/eingliederung", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/eingliederung/required", keyword: "required", params: { missingProperty: "url" }, message: "must have required property 'url'" };
                  if (vErrors === null) {
                    vErrors = [err1208];
                  } else {
                    vErrors.push(err1208);
                  }
                  errors++;
                }
                if (data482.quote === void 0) {
                  const err1209 = { instancePath: instancePath + "/unterlagen/passages/eingliederung", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/eingliederung/required", keyword: "required", params: { missingProperty: "quote" }, message: "must have required property 'quote'" };
                  if (vErrors === null) {
                    vErrors = [err1209];
                  } else {
                    vErrors.push(err1209);
                  }
                  errors++;
                }
                for (const key84 in data482) {
                  if (!(key84 === "chunkId" || key84 === "title" || key84 === "url" || key84 === "page" || key84 === "quote")) {
                    const err1210 = { instancePath: instancePath + "/unterlagen/passages/eingliederung", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/eingliederung/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key84 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                      vErrors = [err1210];
                    } else {
                      vErrors.push(err1210);
                    }
                    errors++;
                  }
                }
                if (data482.chunkId !== void 0) {
                  if (typeof data482.chunkId !== "string") {
                    const err1211 = { instancePath: instancePath + "/unterlagen/passages/eingliederung/chunkId", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/eingliederung/properties/chunkId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err1211];
                    } else {
                      vErrors.push(err1211);
                    }
                    errors++;
                  }
                }
                if (data482.title !== void 0) {
                  if (typeof data482.title !== "string") {
                    const err1212 = { instancePath: instancePath + "/unterlagen/passages/eingliederung/title", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/eingliederung/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err1212];
                    } else {
                      vErrors.push(err1212);
                    }
                    errors++;
                  }
                }
                if (data482.url !== void 0) {
                  if (typeof data482.url !== "string") {
                    const err1213 = { instancePath: instancePath + "/unterlagen/passages/eingliederung/url", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/eingliederung/properties/url/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err1213];
                    } else {
                      vErrors.push(err1213);
                    }
                    errors++;
                  }
                }
                if (data482.page !== void 0) {
                  let data486 = data482.page;
                  if (!(typeof data486 == "number" && (!(data486 % 1) && !isNaN(data486)) && isFinite(data486))) {
                    const err1214 = { instancePath: instancePath + "/unterlagen/passages/eingliederung/page", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/eingliederung/properties/page/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err1214];
                    } else {
                      vErrors.push(err1214);
                    }
                    errors++;
                  }
                  if (typeof data486 == "number" && isFinite(data486)) {
                    if (data486 > 9007199254740991 || isNaN(data486)) {
                      const err1215 = { instancePath: instancePath + "/unterlagen/passages/eingliederung/page", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/eingliederung/properties/page/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err1215];
                      } else {
                        vErrors.push(err1215);
                      }
                      errors++;
                    }
                    if (data486 < -9007199254740991 || isNaN(data486)) {
                      const err1216 = { instancePath: instancePath + "/unterlagen/passages/eingliederung/page", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/eingliederung/properties/page/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err1216];
                      } else {
                        vErrors.push(err1216);
                      }
                      errors++;
                    }
                  }
                }
                if (data482.quote !== void 0) {
                  if (typeof data482.quote !== "string") {
                    const err1217 = { instancePath: instancePath + "/unterlagen/passages/eingliederung/quote", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/eingliederung/properties/quote/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err1217];
                    } else {
                      vErrors.push(err1217);
                    }
                    errors++;
                  }
                }
              } else {
                const err1218 = { instancePath: instancePath + "/unterlagen/passages/eingliederung", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/eingliederung/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                if (vErrors === null) {
                  vErrors = [err1218];
                } else {
                  vErrors.push(err1218);
                }
                errors++;
              }
            }
            if (data451.wiederherstellungen !== void 0) {
              let data488 = data451.wiederherstellungen;
              if (data488 && typeof data488 == "object" && !Array.isArray(data488)) {
                if (data488.chunkId === void 0) {
                  const err1219 = { instancePath: instancePath + "/unterlagen/passages/wiederherstellungen", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/wiederherstellungen/required", keyword: "required", params: { missingProperty: "chunkId" }, message: "must have required property 'chunkId'" };
                  if (vErrors === null) {
                    vErrors = [err1219];
                  } else {
                    vErrors.push(err1219);
                  }
                  errors++;
                }
                if (data488.title === void 0) {
                  const err1220 = { instancePath: instancePath + "/unterlagen/passages/wiederherstellungen", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/wiederherstellungen/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
                  if (vErrors === null) {
                    vErrors = [err1220];
                  } else {
                    vErrors.push(err1220);
                  }
                  errors++;
                }
                if (data488.url === void 0) {
                  const err1221 = { instancePath: instancePath + "/unterlagen/passages/wiederherstellungen", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/wiederherstellungen/required", keyword: "required", params: { missingProperty: "url" }, message: "must have required property 'url'" };
                  if (vErrors === null) {
                    vErrors = [err1221];
                  } else {
                    vErrors.push(err1221);
                  }
                  errors++;
                }
                if (data488.quote === void 0) {
                  const err1222 = { instancePath: instancePath + "/unterlagen/passages/wiederherstellungen", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/wiederherstellungen/required", keyword: "required", params: { missingProperty: "quote" }, message: "must have required property 'quote'" };
                  if (vErrors === null) {
                    vErrors = [err1222];
                  } else {
                    vErrors.push(err1222);
                  }
                  errors++;
                }
                for (const key85 in data488) {
                  if (!(key85 === "chunkId" || key85 === "title" || key85 === "url" || key85 === "page" || key85 === "quote")) {
                    const err1223 = { instancePath: instancePath + "/unterlagen/passages/wiederherstellungen", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/wiederherstellungen/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key85 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                      vErrors = [err1223];
                    } else {
                      vErrors.push(err1223);
                    }
                    errors++;
                  }
                }
                if (data488.chunkId !== void 0) {
                  if (typeof data488.chunkId !== "string") {
                    const err1224 = { instancePath: instancePath + "/unterlagen/passages/wiederherstellungen/chunkId", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/wiederherstellungen/properties/chunkId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err1224];
                    } else {
                      vErrors.push(err1224);
                    }
                    errors++;
                  }
                }
                if (data488.title !== void 0) {
                  if (typeof data488.title !== "string") {
                    const err1225 = { instancePath: instancePath + "/unterlagen/passages/wiederherstellungen/title", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/wiederherstellungen/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err1225];
                    } else {
                      vErrors.push(err1225);
                    }
                    errors++;
                  }
                }
                if (data488.url !== void 0) {
                  if (typeof data488.url !== "string") {
                    const err1226 = { instancePath: instancePath + "/unterlagen/passages/wiederherstellungen/url", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/wiederherstellungen/properties/url/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err1226];
                    } else {
                      vErrors.push(err1226);
                    }
                    errors++;
                  }
                }
                if (data488.page !== void 0) {
                  let data492 = data488.page;
                  if (!(typeof data492 == "number" && (!(data492 % 1) && !isNaN(data492)) && isFinite(data492))) {
                    const err1227 = { instancePath: instancePath + "/unterlagen/passages/wiederherstellungen/page", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/wiederherstellungen/properties/page/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err1227];
                    } else {
                      vErrors.push(err1227);
                    }
                    errors++;
                  }
                  if (typeof data492 == "number" && isFinite(data492)) {
                    if (data492 > 9007199254740991 || isNaN(data492)) {
                      const err1228 = { instancePath: instancePath + "/unterlagen/passages/wiederherstellungen/page", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/wiederherstellungen/properties/page/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err1228];
                      } else {
                        vErrors.push(err1228);
                      }
                      errors++;
                    }
                    if (data492 < -9007199254740991 || isNaN(data492)) {
                      const err1229 = { instancePath: instancePath + "/unterlagen/passages/wiederherstellungen/page", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/wiederherstellungen/properties/page/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err1229];
                      } else {
                        vErrors.push(err1229);
                      }
                      errors++;
                    }
                  }
                }
                if (data488.quote !== void 0) {
                  if (typeof data488.quote !== "string") {
                    const err1230 = { instancePath: instancePath + "/unterlagen/passages/wiederherstellungen/quote", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/wiederherstellungen/properties/quote/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err1230];
                    } else {
                      vErrors.push(err1230);
                    }
                    errors++;
                  }
                }
              } else {
                const err1231 = { instancePath: instancePath + "/unterlagen/passages/wiederherstellungen", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/wiederherstellungen/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                if (vErrors === null) {
                  vErrors = [err1231];
                } else {
                  vErrors.push(err1231);
                }
                errors++;
              }
            }
            if (data451.ohneBewilligung !== void 0) {
              let data494 = data451.ohneBewilligung;
              if (data494 && typeof data494 == "object" && !Array.isArray(data494)) {
                if (data494.chunkId === void 0) {
                  const err1232 = { instancePath: instancePath + "/unterlagen/passages/ohneBewilligung", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/ohneBewilligung/required", keyword: "required", params: { missingProperty: "chunkId" }, message: "must have required property 'chunkId'" };
                  if (vErrors === null) {
                    vErrors = [err1232];
                  } else {
                    vErrors.push(err1232);
                  }
                  errors++;
                }
                if (data494.title === void 0) {
                  const err1233 = { instancePath: instancePath + "/unterlagen/passages/ohneBewilligung", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/ohneBewilligung/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
                  if (vErrors === null) {
                    vErrors = [err1233];
                  } else {
                    vErrors.push(err1233);
                  }
                  errors++;
                }
                if (data494.url === void 0) {
                  const err1234 = { instancePath: instancePath + "/unterlagen/passages/ohneBewilligung", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/ohneBewilligung/required", keyword: "required", params: { missingProperty: "url" }, message: "must have required property 'url'" };
                  if (vErrors === null) {
                    vErrors = [err1234];
                  } else {
                    vErrors.push(err1234);
                  }
                  errors++;
                }
                if (data494.quote === void 0) {
                  const err1235 = { instancePath: instancePath + "/unterlagen/passages/ohneBewilligung", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/ohneBewilligung/required", keyword: "required", params: { missingProperty: "quote" }, message: "must have required property 'quote'" };
                  if (vErrors === null) {
                    vErrors = [err1235];
                  } else {
                    vErrors.push(err1235);
                  }
                  errors++;
                }
                for (const key86 in data494) {
                  if (!(key86 === "chunkId" || key86 === "title" || key86 === "url" || key86 === "page" || key86 === "quote")) {
                    const err1236 = { instancePath: instancePath + "/unterlagen/passages/ohneBewilligung", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/ohneBewilligung/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key86 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                      vErrors = [err1236];
                    } else {
                      vErrors.push(err1236);
                    }
                    errors++;
                  }
                }
                if (data494.chunkId !== void 0) {
                  if (typeof data494.chunkId !== "string") {
                    const err1237 = { instancePath: instancePath + "/unterlagen/passages/ohneBewilligung/chunkId", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/ohneBewilligung/properties/chunkId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err1237];
                    } else {
                      vErrors.push(err1237);
                    }
                    errors++;
                  }
                }
                if (data494.title !== void 0) {
                  if (typeof data494.title !== "string") {
                    const err1238 = { instancePath: instancePath + "/unterlagen/passages/ohneBewilligung/title", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/ohneBewilligung/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err1238];
                    } else {
                      vErrors.push(err1238);
                    }
                    errors++;
                  }
                }
                if (data494.url !== void 0) {
                  if (typeof data494.url !== "string") {
                    const err1239 = { instancePath: instancePath + "/unterlagen/passages/ohneBewilligung/url", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/ohneBewilligung/properties/url/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err1239];
                    } else {
                      vErrors.push(err1239);
                    }
                    errors++;
                  }
                }
                if (data494.page !== void 0) {
                  let data498 = data494.page;
                  if (!(typeof data498 == "number" && (!(data498 % 1) && !isNaN(data498)) && isFinite(data498))) {
                    const err1240 = { instancePath: instancePath + "/unterlagen/passages/ohneBewilligung/page", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/ohneBewilligung/properties/page/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err1240];
                    } else {
                      vErrors.push(err1240);
                    }
                    errors++;
                  }
                  if (typeof data498 == "number" && isFinite(data498)) {
                    if (data498 > 9007199254740991 || isNaN(data498)) {
                      const err1241 = { instancePath: instancePath + "/unterlagen/passages/ohneBewilligung/page", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/ohneBewilligung/properties/page/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err1241];
                      } else {
                        vErrors.push(err1241);
                      }
                      errors++;
                    }
                    if (data498 < -9007199254740991 || isNaN(data498)) {
                      const err1242 = { instancePath: instancePath + "/unterlagen/passages/ohneBewilligung/page", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/ohneBewilligung/properties/page/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err1242];
                      } else {
                        vErrors.push(err1242);
                      }
                      errors++;
                    }
                  }
                }
                if (data494.quote !== void 0) {
                  if (typeof data494.quote !== "string") {
                    const err1243 = { instancePath: instancePath + "/unterlagen/passages/ohneBewilligung/quote", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/ohneBewilligung/properties/quote/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err1243];
                    } else {
                      vErrors.push(err1243);
                    }
                    errors++;
                  }
                }
              } else {
                const err1244 = { instancePath: instancePath + "/unterlagen/passages/ohneBewilligung", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/ohneBewilligung/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                if (vErrors === null) {
                  vErrors = [err1244];
                } else {
                  vErrors.push(err1244);
                }
                errors++;
              }
            }
            if (data451.stiftaufbauten !== void 0) {
              let data500 = data451.stiftaufbauten;
              if (data500 && typeof data500 == "object" && !Array.isArray(data500)) {
                if (data500.chunkId === void 0) {
                  const err1245 = { instancePath: instancePath + "/unterlagen/passages/stiftaufbauten", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/stiftaufbauten/required", keyword: "required", params: { missingProperty: "chunkId" }, message: "must have required property 'chunkId'" };
                  if (vErrors === null) {
                    vErrors = [err1245];
                  } else {
                    vErrors.push(err1245);
                  }
                  errors++;
                }
                if (data500.title === void 0) {
                  const err1246 = { instancePath: instancePath + "/unterlagen/passages/stiftaufbauten", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/stiftaufbauten/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
                  if (vErrors === null) {
                    vErrors = [err1246];
                  } else {
                    vErrors.push(err1246);
                  }
                  errors++;
                }
                if (data500.url === void 0) {
                  const err1247 = { instancePath: instancePath + "/unterlagen/passages/stiftaufbauten", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/stiftaufbauten/required", keyword: "required", params: { missingProperty: "url" }, message: "must have required property 'url'" };
                  if (vErrors === null) {
                    vErrors = [err1247];
                  } else {
                    vErrors.push(err1247);
                  }
                  errors++;
                }
                if (data500.quote === void 0) {
                  const err1248 = { instancePath: instancePath + "/unterlagen/passages/stiftaufbauten", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/stiftaufbauten/required", keyword: "required", params: { missingProperty: "quote" }, message: "must have required property 'quote'" };
                  if (vErrors === null) {
                    vErrors = [err1248];
                  } else {
                    vErrors.push(err1248);
                  }
                  errors++;
                }
                for (const key87 in data500) {
                  if (!(key87 === "chunkId" || key87 === "title" || key87 === "url" || key87 === "page" || key87 === "quote")) {
                    const err1249 = { instancePath: instancePath + "/unterlagen/passages/stiftaufbauten", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/stiftaufbauten/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key87 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                      vErrors = [err1249];
                    } else {
                      vErrors.push(err1249);
                    }
                    errors++;
                  }
                }
                if (data500.chunkId !== void 0) {
                  if (typeof data500.chunkId !== "string") {
                    const err1250 = { instancePath: instancePath + "/unterlagen/passages/stiftaufbauten/chunkId", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/stiftaufbauten/properties/chunkId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err1250];
                    } else {
                      vErrors.push(err1250);
                    }
                    errors++;
                  }
                }
                if (data500.title !== void 0) {
                  if (typeof data500.title !== "string") {
                    const err1251 = { instancePath: instancePath + "/unterlagen/passages/stiftaufbauten/title", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/stiftaufbauten/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err1251];
                    } else {
                      vErrors.push(err1251);
                    }
                    errors++;
                  }
                }
                if (data500.url !== void 0) {
                  if (typeof data500.url !== "string") {
                    const err1252 = { instancePath: instancePath + "/unterlagen/passages/stiftaufbauten/url", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/stiftaufbauten/properties/url/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err1252];
                    } else {
                      vErrors.push(err1252);
                    }
                    errors++;
                  }
                }
                if (data500.page !== void 0) {
                  let data504 = data500.page;
                  if (!(typeof data504 == "number" && (!(data504 % 1) && !isNaN(data504)) && isFinite(data504))) {
                    const err1253 = { instancePath: instancePath + "/unterlagen/passages/stiftaufbauten/page", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/stiftaufbauten/properties/page/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err1253];
                    } else {
                      vErrors.push(err1253);
                    }
                    errors++;
                  }
                  if (typeof data504 == "number" && isFinite(data504)) {
                    if (data504 > 9007199254740991 || isNaN(data504)) {
                      const err1254 = { instancePath: instancePath + "/unterlagen/passages/stiftaufbauten/page", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/stiftaufbauten/properties/page/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err1254];
                      } else {
                        vErrors.push(err1254);
                      }
                      errors++;
                    }
                    if (data504 < -9007199254740991 || isNaN(data504)) {
                      const err1255 = { instancePath: instancePath + "/unterlagen/passages/stiftaufbauten/page", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/stiftaufbauten/properties/page/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err1255];
                      } else {
                        vErrors.push(err1255);
                      }
                      errors++;
                    }
                  }
                }
                if (data500.quote !== void 0) {
                  if (typeof data500.quote !== "string") {
                    const err1256 = { instancePath: instancePath + "/unterlagen/passages/stiftaufbauten/quote", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/stiftaufbauten/properties/quote/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err1256];
                    } else {
                      vErrors.push(err1256);
                    }
                    errors++;
                  }
                }
              } else {
                const err1257 = { instancePath: instancePath + "/unterlagen/passages/stiftaufbauten", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/stiftaufbauten/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                if (vErrors === null) {
                  vErrors = [err1257];
                } else {
                  vErrors.push(err1257);
                }
                errors++;
              }
            }
            if (data451.haertefall !== void 0) {
              let data506 = data451.haertefall;
              if (data506 && typeof data506 == "object" && !Array.isArray(data506)) {
                if (data506.chunkId === void 0) {
                  const err1258 = { instancePath: instancePath + "/unterlagen/passages/haertefall", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/haertefall/required", keyword: "required", params: { missingProperty: "chunkId" }, message: "must have required property 'chunkId'" };
                  if (vErrors === null) {
                    vErrors = [err1258];
                  } else {
                    vErrors.push(err1258);
                  }
                  errors++;
                }
                if (data506.title === void 0) {
                  const err1259 = { instancePath: instancePath + "/unterlagen/passages/haertefall", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/haertefall/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
                  if (vErrors === null) {
                    vErrors = [err1259];
                  } else {
                    vErrors.push(err1259);
                  }
                  errors++;
                }
                if (data506.url === void 0) {
                  const err1260 = { instancePath: instancePath + "/unterlagen/passages/haertefall", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/haertefall/required", keyword: "required", params: { missingProperty: "url" }, message: "must have required property 'url'" };
                  if (vErrors === null) {
                    vErrors = [err1260];
                  } else {
                    vErrors.push(err1260);
                  }
                  errors++;
                }
                if (data506.quote === void 0) {
                  const err1261 = { instancePath: instancePath + "/unterlagen/passages/haertefall", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/haertefall/required", keyword: "required", params: { missingProperty: "quote" }, message: "must have required property 'quote'" };
                  if (vErrors === null) {
                    vErrors = [err1261];
                  } else {
                    vErrors.push(err1261);
                  }
                  errors++;
                }
                for (const key88 in data506) {
                  if (!(key88 === "chunkId" || key88 === "title" || key88 === "url" || key88 === "page" || key88 === "quote")) {
                    const err1262 = { instancePath: instancePath + "/unterlagen/passages/haertefall", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/haertefall/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key88 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                      vErrors = [err1262];
                    } else {
                      vErrors.push(err1262);
                    }
                    errors++;
                  }
                }
                if (data506.chunkId !== void 0) {
                  if (typeof data506.chunkId !== "string") {
                    const err1263 = { instancePath: instancePath + "/unterlagen/passages/haertefall/chunkId", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/haertefall/properties/chunkId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err1263];
                    } else {
                      vErrors.push(err1263);
                    }
                    errors++;
                  }
                }
                if (data506.title !== void 0) {
                  if (typeof data506.title !== "string") {
                    const err1264 = { instancePath: instancePath + "/unterlagen/passages/haertefall/title", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/haertefall/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err1264];
                    } else {
                      vErrors.push(err1264);
                    }
                    errors++;
                  }
                }
                if (data506.url !== void 0) {
                  if (typeof data506.url !== "string") {
                    const err1265 = { instancePath: instancePath + "/unterlagen/passages/haertefall/url", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/haertefall/properties/url/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err1265];
                    } else {
                      vErrors.push(err1265);
                    }
                    errors++;
                  }
                }
                if (data506.page !== void 0) {
                  let data510 = data506.page;
                  if (!(typeof data510 == "number" && (!(data510 % 1) && !isNaN(data510)) && isFinite(data510))) {
                    const err1266 = { instancePath: instancePath + "/unterlagen/passages/haertefall/page", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/haertefall/properties/page/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err1266];
                    } else {
                      vErrors.push(err1266);
                    }
                    errors++;
                  }
                  if (typeof data510 == "number" && isFinite(data510)) {
                    if (data510 > 9007199254740991 || isNaN(data510)) {
                      const err1267 = { instancePath: instancePath + "/unterlagen/passages/haertefall/page", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/haertefall/properties/page/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err1267];
                      } else {
                        vErrors.push(err1267);
                      }
                      errors++;
                    }
                    if (data510 < -9007199254740991 || isNaN(data510)) {
                      const err1268 = { instancePath: instancePath + "/unterlagen/passages/haertefall/page", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/haertefall/properties/page/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err1268];
                      } else {
                        vErrors.push(err1268);
                      }
                      errors++;
                    }
                  }
                }
                if (data506.quote !== void 0) {
                  if (typeof data506.quote !== "string") {
                    const err1269 = { instancePath: instancePath + "/unterlagen/passages/haertefall/quote", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/haertefall/properties/quote/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err1269];
                    } else {
                      vErrors.push(err1269);
                    }
                    errors++;
                  }
                }
              } else {
                const err1270 = { instancePath: instancePath + "/unterlagen/passages/haertefall", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/properties/haertefall/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                if (vErrors === null) {
                  vErrors = [err1270];
                } else {
                  vErrors.push(err1270);
                }
                errors++;
              }
            }
          } else {
            const err1271 = { instancePath: instancePath + "/unterlagen/passages", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/properties/passages/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
              vErrors = [err1271];
            } else {
              vErrors.push(err1271);
            }
            errors++;
          }
        }
      } else {
        const err1272 = { instancePath: instancePath + "/unterlagen", schemaPath: "#/definitions/VerificationEvaluation/properties/unterlagen/type", keyword: "type", params: { type: "object" }, message: "must be object" };
        if (vErrors === null) {
          vErrors = [err1272];
        } else {
          vErrors.push(err1272);
        }
        errors++;
      }
    }
    if (data.alternative !== void 0) {
      let data512 = data.alternative;
      if (data512 && typeof data512 == "object" && !Array.isArray(data512)) {
        if (data512.geplant === void 0) {
          const err1273 = { instancePath: instancePath + "/alternative", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/required", keyword: "required", params: { missingProperty: "geplant" }, message: "must have required property 'geplant'" };
          if (vErrors === null) {
            vErrors = [err1273];
          } else {
            vErrors.push(err1273);
          }
          errors++;
        }
        if (data512.totals === void 0) {
          const err1274 = { instancePath: instancePath + "/alternative", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/required", keyword: "required", params: { missingProperty: "totals" }, message: "must have required property 'totals'" };
          if (vErrors === null) {
            vErrors = [err1274];
          } else {
            vErrors.push(err1274);
          }
          errors++;
        }
        if (data512.placeholders === void 0) {
          const err1275 = { instancePath: instancePath + "/alternative", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/required", keyword: "required", params: { missingProperty: "placeholders" }, message: "must have required property 'placeholders'" };
          if (vErrors === null) {
            vErrors = [err1275];
          } else {
            vErrors.push(err1275);
          }
          errors++;
        }
        for (const key89 in data512) {
          if (!(key89 === "geplant" || key89 === "totals" || key89 === "placeholders")) {
            const err1276 = { instancePath: instancePath + "/alternative", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key89 }, message: "must NOT have additional properties" };
            if (vErrors === null) {
              vErrors = [err1276];
            } else {
              vErrors.push(err1276);
            }
            errors++;
          }
        }
        if (data512.geplant !== void 0) {
          let data513 = data512.geplant;
          if (typeof data513 !== "string") {
            const err1277 = { instancePath: instancePath + "/alternative/geplant", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/geplant/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err1277];
            } else {
              vErrors.push(err1277);
            }
            errors++;
          }
          if (!(data513 === "regelversorgung" || data513 === "vollkeramik")) {
            const err1278 = { instancePath: instancePath + "/alternative/geplant", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/geplant/enum", keyword: "enum", params: { allowedValues: schema37.properties.alternative.properties.geplant.enum }, message: "must be equal to one of the allowed values" };
            if (vErrors === null) {
              vErrors = [err1278];
            } else {
              vErrors.push(err1278);
            }
            errors++;
          }
        }
        if (data512.totals !== void 0) {
          let data514 = data512.totals;
          if (data514 && typeof data514 == "object" && !Array.isArray(data514)) {
            if (data514.honorar === void 0) {
              const err1279 = { instancePath: instancePath + "/alternative/totals", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/totals/required", keyword: "required", params: { missingProperty: "honorar" }, message: "must have required property 'honorar'" };
              if (vErrors === null) {
                vErrors = [err1279];
              } else {
                vErrors.push(err1279);
              }
              errors++;
            }
            if (data514.goz === void 0) {
              const err1280 = { instancePath: instancePath + "/alternative/totals", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/totals/required", keyword: "required", params: { missingProperty: "goz" }, message: "must have required property 'goz'" };
              if (vErrors === null) {
                vErrors = [err1280];
              } else {
                vErrors.push(err1280);
              }
              errors++;
            }
            if (data514.labor === void 0) {
              const err1281 = { instancePath: instancePath + "/alternative/totals", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/totals/required", keyword: "required", params: { missingProperty: "labor" }, message: "must have required property 'labor'" };
              if (vErrors === null) {
                vErrors = [err1281];
              } else {
                vErrors.push(err1281);
              }
              errors++;
            }
            if (data514.gesamt === void 0) {
              const err1282 = { instancePath: instancePath + "/alternative/totals", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/totals/required", keyword: "required", params: { missingProperty: "gesamt" }, message: "must have required property 'gesamt'" };
              if (vErrors === null) {
                vErrors = [err1282];
              } else {
                vErrors.push(err1282);
              }
              errors++;
            }
            if (data514.festzuschuss === void 0) {
              const err1283 = { instancePath: instancePath + "/alternative/totals", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/totals/required", keyword: "required", params: { missingProperty: "festzuschuss" }, message: "must have required property 'festzuschuss'" };
              if (vErrors === null) {
                vErrors = [err1283];
              } else {
                vErrors.push(err1283);
              }
              errors++;
            }
            if (data514.eigenanteil === void 0) {
              const err1284 = { instancePath: instancePath + "/alternative/totals", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/totals/required", keyword: "required", params: { missingProperty: "eigenanteil" }, message: "must have required property 'eigenanteil'" };
              if (vErrors === null) {
                vErrors = [err1284];
              } else {
                vErrors.push(err1284);
              }
              errors++;
            }
            for (const key90 in data514) {
              if (!(key90 === "honorar" || key90 === "goz" || key90 === "labor" || key90 === "gesamt" || key90 === "festzuschuss" || key90 === "eigenanteil")) {
                const err1285 = { instancePath: instancePath + "/alternative/totals", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/totals/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key90 }, message: "must NOT have additional properties" };
                if (vErrors === null) {
                  vErrors = [err1285];
                } else {
                  vErrors.push(err1285);
                }
                errors++;
              }
            }
            if (data514.honorar !== void 0) {
              let data515 = data514.honorar;
              if (!(typeof data515 == "number" && (!(data515 % 1) && !isNaN(data515)) && isFinite(data515))) {
                const err1286 = { instancePath: instancePath + "/alternative/totals/honorar", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/totals/properties/honorar/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                if (vErrors === null) {
                  vErrors = [err1286];
                } else {
                  vErrors.push(err1286);
                }
                errors++;
              }
              if (typeof data515 == "number" && isFinite(data515)) {
                if (data515 > 9007199254740991 || isNaN(data515)) {
                  const err1287 = { instancePath: instancePath + "/alternative/totals/honorar", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/totals/properties/honorar/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err1287];
                  } else {
                    vErrors.push(err1287);
                  }
                  errors++;
                }
                if (data515 < -9007199254740991 || isNaN(data515)) {
                  const err1288 = { instancePath: instancePath + "/alternative/totals/honorar", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/totals/properties/honorar/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err1288];
                  } else {
                    vErrors.push(err1288);
                  }
                  errors++;
                }
              }
            }
            if (data514.goz !== void 0) {
              let data516 = data514.goz;
              if (!(typeof data516 == "number" && (!(data516 % 1) && !isNaN(data516)) && isFinite(data516))) {
                const err1289 = { instancePath: instancePath + "/alternative/totals/goz", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/totals/properties/goz/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                if (vErrors === null) {
                  vErrors = [err1289];
                } else {
                  vErrors.push(err1289);
                }
                errors++;
              }
              if (typeof data516 == "number" && isFinite(data516)) {
                if (data516 > 9007199254740991 || isNaN(data516)) {
                  const err1290 = { instancePath: instancePath + "/alternative/totals/goz", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/totals/properties/goz/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err1290];
                  } else {
                    vErrors.push(err1290);
                  }
                  errors++;
                }
                if (data516 < -9007199254740991 || isNaN(data516)) {
                  const err1291 = { instancePath: instancePath + "/alternative/totals/goz", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/totals/properties/goz/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err1291];
                  } else {
                    vErrors.push(err1291);
                  }
                  errors++;
                }
              }
            }
            if (data514.labor !== void 0) {
              let data517 = data514.labor;
              if (!(typeof data517 == "number" && (!(data517 % 1) && !isNaN(data517)) && isFinite(data517))) {
                const err1292 = { instancePath: instancePath + "/alternative/totals/labor", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/totals/properties/labor/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                if (vErrors === null) {
                  vErrors = [err1292];
                } else {
                  vErrors.push(err1292);
                }
                errors++;
              }
              if (typeof data517 == "number" && isFinite(data517)) {
                if (data517 > 9007199254740991 || isNaN(data517)) {
                  const err1293 = { instancePath: instancePath + "/alternative/totals/labor", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/totals/properties/labor/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err1293];
                  } else {
                    vErrors.push(err1293);
                  }
                  errors++;
                }
                if (data517 < -9007199254740991 || isNaN(data517)) {
                  const err1294 = { instancePath: instancePath + "/alternative/totals/labor", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/totals/properties/labor/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err1294];
                  } else {
                    vErrors.push(err1294);
                  }
                  errors++;
                }
              }
            }
            if (data514.gesamt !== void 0) {
              let data518 = data514.gesamt;
              if (!(typeof data518 == "number" && (!(data518 % 1) && !isNaN(data518)) && isFinite(data518))) {
                const err1295 = { instancePath: instancePath + "/alternative/totals/gesamt", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/totals/properties/gesamt/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                if (vErrors === null) {
                  vErrors = [err1295];
                } else {
                  vErrors.push(err1295);
                }
                errors++;
              }
              if (typeof data518 == "number" && isFinite(data518)) {
                if (data518 > 9007199254740991 || isNaN(data518)) {
                  const err1296 = { instancePath: instancePath + "/alternative/totals/gesamt", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/totals/properties/gesamt/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err1296];
                  } else {
                    vErrors.push(err1296);
                  }
                  errors++;
                }
                if (data518 < -9007199254740991 || isNaN(data518)) {
                  const err1297 = { instancePath: instancePath + "/alternative/totals/gesamt", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/totals/properties/gesamt/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err1297];
                  } else {
                    vErrors.push(err1297);
                  }
                  errors++;
                }
              }
            }
            if (data514.festzuschuss !== void 0) {
              let data519 = data514.festzuschuss;
              if (data519 && typeof data519 == "object" && !Array.isArray(data519)) {
                if (data519.prozent60 === void 0) {
                  const err1298 = { instancePath: instancePath + "/alternative/totals/festzuschuss", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/totals/properties/festzuschuss/required", keyword: "required", params: { missingProperty: "prozent60" }, message: "must have required property 'prozent60'" };
                  if (vErrors === null) {
                    vErrors = [err1298];
                  } else {
                    vErrors.push(err1298);
                  }
                  errors++;
                }
                if (data519.prozent70 === void 0) {
                  const err1299 = { instancePath: instancePath + "/alternative/totals/festzuschuss", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/totals/properties/festzuschuss/required", keyword: "required", params: { missingProperty: "prozent70" }, message: "must have required property 'prozent70'" };
                  if (vErrors === null) {
                    vErrors = [err1299];
                  } else {
                    vErrors.push(err1299);
                  }
                  errors++;
                }
                if (data519.prozent75 === void 0) {
                  const err1300 = { instancePath: instancePath + "/alternative/totals/festzuschuss", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/totals/properties/festzuschuss/required", keyword: "required", params: { missingProperty: "prozent75" }, message: "must have required property 'prozent75'" };
                  if (vErrors === null) {
                    vErrors = [err1300];
                  } else {
                    vErrors.push(err1300);
                  }
                  errors++;
                }
                if (data519.prozent100 === void 0) {
                  const err1301 = { instancePath: instancePath + "/alternative/totals/festzuschuss", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/totals/properties/festzuschuss/required", keyword: "required", params: { missingProperty: "prozent100" }, message: "must have required property 'prozent100'" };
                  if (vErrors === null) {
                    vErrors = [err1301];
                  } else {
                    vErrors.push(err1301);
                  }
                  errors++;
                }
                for (const key91 in data519) {
                  if (!(key91 === "prozent60" || key91 === "prozent70" || key91 === "prozent75" || key91 === "prozent100")) {
                    const err1302 = { instancePath: instancePath + "/alternative/totals/festzuschuss", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/totals/properties/festzuschuss/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key91 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                      vErrors = [err1302];
                    } else {
                      vErrors.push(err1302);
                    }
                    errors++;
                  }
                }
                if (data519.prozent60 !== void 0) {
                  let data520 = data519.prozent60;
                  if (!(typeof data520 == "number" && (!(data520 % 1) && !isNaN(data520)) && isFinite(data520))) {
                    const err1303 = { instancePath: instancePath + "/alternative/totals/festzuschuss/prozent60", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/totals/properties/festzuschuss/properties/prozent60/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err1303];
                    } else {
                      vErrors.push(err1303);
                    }
                    errors++;
                  }
                  if (typeof data520 == "number" && isFinite(data520)) {
                    if (data520 > 9007199254740991 || isNaN(data520)) {
                      const err1304 = { instancePath: instancePath + "/alternative/totals/festzuschuss/prozent60", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/totals/properties/festzuschuss/properties/prozent60/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err1304];
                      } else {
                        vErrors.push(err1304);
                      }
                      errors++;
                    }
                    if (data520 < -9007199254740991 || isNaN(data520)) {
                      const err1305 = { instancePath: instancePath + "/alternative/totals/festzuschuss/prozent60", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/totals/properties/festzuschuss/properties/prozent60/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err1305];
                      } else {
                        vErrors.push(err1305);
                      }
                      errors++;
                    }
                  }
                }
                if (data519.prozent70 !== void 0) {
                  let data521 = data519.prozent70;
                  if (!(typeof data521 == "number" && (!(data521 % 1) && !isNaN(data521)) && isFinite(data521))) {
                    const err1306 = { instancePath: instancePath + "/alternative/totals/festzuschuss/prozent70", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/totals/properties/festzuschuss/properties/prozent70/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err1306];
                    } else {
                      vErrors.push(err1306);
                    }
                    errors++;
                  }
                  if (typeof data521 == "number" && isFinite(data521)) {
                    if (data521 > 9007199254740991 || isNaN(data521)) {
                      const err1307 = { instancePath: instancePath + "/alternative/totals/festzuschuss/prozent70", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/totals/properties/festzuschuss/properties/prozent70/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err1307];
                      } else {
                        vErrors.push(err1307);
                      }
                      errors++;
                    }
                    if (data521 < -9007199254740991 || isNaN(data521)) {
                      const err1308 = { instancePath: instancePath + "/alternative/totals/festzuschuss/prozent70", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/totals/properties/festzuschuss/properties/prozent70/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err1308];
                      } else {
                        vErrors.push(err1308);
                      }
                      errors++;
                    }
                  }
                }
                if (data519.prozent75 !== void 0) {
                  let data522 = data519.prozent75;
                  if (!(typeof data522 == "number" && (!(data522 % 1) && !isNaN(data522)) && isFinite(data522))) {
                    const err1309 = { instancePath: instancePath + "/alternative/totals/festzuschuss/prozent75", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/totals/properties/festzuschuss/properties/prozent75/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err1309];
                    } else {
                      vErrors.push(err1309);
                    }
                    errors++;
                  }
                  if (typeof data522 == "number" && isFinite(data522)) {
                    if (data522 > 9007199254740991 || isNaN(data522)) {
                      const err1310 = { instancePath: instancePath + "/alternative/totals/festzuschuss/prozent75", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/totals/properties/festzuschuss/properties/prozent75/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err1310];
                      } else {
                        vErrors.push(err1310);
                      }
                      errors++;
                    }
                    if (data522 < -9007199254740991 || isNaN(data522)) {
                      const err1311 = { instancePath: instancePath + "/alternative/totals/festzuschuss/prozent75", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/totals/properties/festzuschuss/properties/prozent75/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err1311];
                      } else {
                        vErrors.push(err1311);
                      }
                      errors++;
                    }
                  }
                }
                if (data519.prozent100 !== void 0) {
                  let data523 = data519.prozent100;
                  if (!(typeof data523 == "number" && (!(data523 % 1) && !isNaN(data523)) && isFinite(data523))) {
                    const err1312 = { instancePath: instancePath + "/alternative/totals/festzuschuss/prozent100", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/totals/properties/festzuschuss/properties/prozent100/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err1312];
                    } else {
                      vErrors.push(err1312);
                    }
                    errors++;
                  }
                  if (typeof data523 == "number" && isFinite(data523)) {
                    if (data523 > 9007199254740991 || isNaN(data523)) {
                      const err1313 = { instancePath: instancePath + "/alternative/totals/festzuschuss/prozent100", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/totals/properties/festzuschuss/properties/prozent100/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err1313];
                      } else {
                        vErrors.push(err1313);
                      }
                      errors++;
                    }
                    if (data523 < -9007199254740991 || isNaN(data523)) {
                      const err1314 = { instancePath: instancePath + "/alternative/totals/festzuschuss/prozent100", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/totals/properties/festzuschuss/properties/prozent100/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err1314];
                      } else {
                        vErrors.push(err1314);
                      }
                      errors++;
                    }
                  }
                }
              } else {
                const err1315 = { instancePath: instancePath + "/alternative/totals/festzuschuss", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/totals/properties/festzuschuss/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                if (vErrors === null) {
                  vErrors = [err1315];
                } else {
                  vErrors.push(err1315);
                }
                errors++;
              }
            }
            if (data514.eigenanteil !== void 0) {
              let data524 = data514.eigenanteil;
              if (data524 && typeof data524 == "object" && !Array.isArray(data524)) {
                if (data524.prozent60 === void 0) {
                  const err1316 = { instancePath: instancePath + "/alternative/totals/eigenanteil", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/totals/properties/eigenanteil/required", keyword: "required", params: { missingProperty: "prozent60" }, message: "must have required property 'prozent60'" };
                  if (vErrors === null) {
                    vErrors = [err1316];
                  } else {
                    vErrors.push(err1316);
                  }
                  errors++;
                }
                if (data524.prozent70 === void 0) {
                  const err1317 = { instancePath: instancePath + "/alternative/totals/eigenanteil", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/totals/properties/eigenanteil/required", keyword: "required", params: { missingProperty: "prozent70" }, message: "must have required property 'prozent70'" };
                  if (vErrors === null) {
                    vErrors = [err1317];
                  } else {
                    vErrors.push(err1317);
                  }
                  errors++;
                }
                if (data524.prozent75 === void 0) {
                  const err1318 = { instancePath: instancePath + "/alternative/totals/eigenanteil", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/totals/properties/eigenanteil/required", keyword: "required", params: { missingProperty: "prozent75" }, message: "must have required property 'prozent75'" };
                  if (vErrors === null) {
                    vErrors = [err1318];
                  } else {
                    vErrors.push(err1318);
                  }
                  errors++;
                }
                if (data524.prozent100 === void 0) {
                  const err1319 = { instancePath: instancePath + "/alternative/totals/eigenanteil", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/totals/properties/eigenanteil/required", keyword: "required", params: { missingProperty: "prozent100" }, message: "must have required property 'prozent100'" };
                  if (vErrors === null) {
                    vErrors = [err1319];
                  } else {
                    vErrors.push(err1319);
                  }
                  errors++;
                }
                for (const key92 in data524) {
                  if (!(key92 === "prozent60" || key92 === "prozent70" || key92 === "prozent75" || key92 === "prozent100")) {
                    const err1320 = { instancePath: instancePath + "/alternative/totals/eigenanteil", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/totals/properties/eigenanteil/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key92 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                      vErrors = [err1320];
                    } else {
                      vErrors.push(err1320);
                    }
                    errors++;
                  }
                }
                if (data524.prozent60 !== void 0) {
                  let data525 = data524.prozent60;
                  if (!(typeof data525 == "number" && (!(data525 % 1) && !isNaN(data525)) && isFinite(data525))) {
                    const err1321 = { instancePath: instancePath + "/alternative/totals/eigenanteil/prozent60", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/totals/properties/eigenanteil/properties/prozent60/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err1321];
                    } else {
                      vErrors.push(err1321);
                    }
                    errors++;
                  }
                  if (typeof data525 == "number" && isFinite(data525)) {
                    if (data525 > 9007199254740991 || isNaN(data525)) {
                      const err1322 = { instancePath: instancePath + "/alternative/totals/eigenanteil/prozent60", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/totals/properties/eigenanteil/properties/prozent60/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err1322];
                      } else {
                        vErrors.push(err1322);
                      }
                      errors++;
                    }
                    if (data525 < -9007199254740991 || isNaN(data525)) {
                      const err1323 = { instancePath: instancePath + "/alternative/totals/eigenanteil/prozent60", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/totals/properties/eigenanteil/properties/prozent60/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err1323];
                      } else {
                        vErrors.push(err1323);
                      }
                      errors++;
                    }
                  }
                }
                if (data524.prozent70 !== void 0) {
                  let data526 = data524.prozent70;
                  if (!(typeof data526 == "number" && (!(data526 % 1) && !isNaN(data526)) && isFinite(data526))) {
                    const err1324 = { instancePath: instancePath + "/alternative/totals/eigenanteil/prozent70", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/totals/properties/eigenanteil/properties/prozent70/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err1324];
                    } else {
                      vErrors.push(err1324);
                    }
                    errors++;
                  }
                  if (typeof data526 == "number" && isFinite(data526)) {
                    if (data526 > 9007199254740991 || isNaN(data526)) {
                      const err1325 = { instancePath: instancePath + "/alternative/totals/eigenanteil/prozent70", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/totals/properties/eigenanteil/properties/prozent70/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err1325];
                      } else {
                        vErrors.push(err1325);
                      }
                      errors++;
                    }
                    if (data526 < -9007199254740991 || isNaN(data526)) {
                      const err1326 = { instancePath: instancePath + "/alternative/totals/eigenanteil/prozent70", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/totals/properties/eigenanteil/properties/prozent70/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err1326];
                      } else {
                        vErrors.push(err1326);
                      }
                      errors++;
                    }
                  }
                }
                if (data524.prozent75 !== void 0) {
                  let data527 = data524.prozent75;
                  if (!(typeof data527 == "number" && (!(data527 % 1) && !isNaN(data527)) && isFinite(data527))) {
                    const err1327 = { instancePath: instancePath + "/alternative/totals/eigenanteil/prozent75", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/totals/properties/eigenanteil/properties/prozent75/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err1327];
                    } else {
                      vErrors.push(err1327);
                    }
                    errors++;
                  }
                  if (typeof data527 == "number" && isFinite(data527)) {
                    if (data527 > 9007199254740991 || isNaN(data527)) {
                      const err1328 = { instancePath: instancePath + "/alternative/totals/eigenanteil/prozent75", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/totals/properties/eigenanteil/properties/prozent75/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err1328];
                      } else {
                        vErrors.push(err1328);
                      }
                      errors++;
                    }
                    if (data527 < -9007199254740991 || isNaN(data527)) {
                      const err1329 = { instancePath: instancePath + "/alternative/totals/eigenanteil/prozent75", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/totals/properties/eigenanteil/properties/prozent75/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err1329];
                      } else {
                        vErrors.push(err1329);
                      }
                      errors++;
                    }
                  }
                }
                if (data524.prozent100 !== void 0) {
                  let data528 = data524.prozent100;
                  if (!(typeof data528 == "number" && (!(data528 % 1) && !isNaN(data528)) && isFinite(data528))) {
                    const err1330 = { instancePath: instancePath + "/alternative/totals/eigenanteil/prozent100", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/totals/properties/eigenanteil/properties/prozent100/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err1330];
                    } else {
                      vErrors.push(err1330);
                    }
                    errors++;
                  }
                  if (typeof data528 == "number" && isFinite(data528)) {
                    if (data528 > 9007199254740991 || isNaN(data528)) {
                      const err1331 = { instancePath: instancePath + "/alternative/totals/eigenanteil/prozent100", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/totals/properties/eigenanteil/properties/prozent100/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err1331];
                      } else {
                        vErrors.push(err1331);
                      }
                      errors++;
                    }
                    if (data528 < -9007199254740991 || isNaN(data528)) {
                      const err1332 = { instancePath: instancePath + "/alternative/totals/eigenanteil/prozent100", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/totals/properties/eigenanteil/properties/prozent100/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err1332];
                      } else {
                        vErrors.push(err1332);
                      }
                      errors++;
                    }
                  }
                }
              } else {
                const err1333 = { instancePath: instancePath + "/alternative/totals/eigenanteil", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/totals/properties/eigenanteil/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                if (vErrors === null) {
                  vErrors = [err1333];
                } else {
                  vErrors.push(err1333);
                }
                errors++;
              }
            }
          } else {
            const err1334 = { instancePath: instancePath + "/alternative/totals", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/totals/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
              vErrors = [err1334];
            } else {
              vErrors.push(err1334);
            }
            errors++;
          }
        }
        if (data512.placeholders !== void 0) {
          let data529 = data512.placeholders;
          if (Array.isArray(data529)) {
            const len48 = data529.length;
            for (let i48 = 0; i48 < len48; i48++) {
              let data530 = data529[i48];
              if (data530 && typeof data530 == "object" && !Array.isArray(data530)) {
                if (data530.id === void 0) {
                  const err1335 = { instancePath: instancePath + "/alternative/placeholders/" + i48, schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/placeholders/items/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property 'id'" };
                  if (vErrors === null) {
                    vErrors = [err1335];
                  } else {
                    vErrors.push(err1335);
                  }
                  errors++;
                }
                if (data530.text === void 0) {
                  const err1336 = { instancePath: instancePath + "/alternative/placeholders/" + i48, schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/placeholders/items/required", keyword: "required", params: { missingProperty: "text" }, message: "must have required property 'text'" };
                  if (vErrors === null) {
                    vErrors = [err1336];
                  } else {
                    vErrors.push(err1336);
                  }
                  errors++;
                }
                for (const key93 in data530) {
                  if (!(key93 === "id" || key93 === "text")) {
                    const err1337 = { instancePath: instancePath + "/alternative/placeholders/" + i48, schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/placeholders/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key93 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                      vErrors = [err1337];
                    } else {
                      vErrors.push(err1337);
                    }
                    errors++;
                  }
                }
                if (data530.id !== void 0) {
                  let data531 = data530.id;
                  if (typeof data531 !== "string") {
                    const err1338 = { instancePath: instancePath + "/alternative/placeholders/" + i48 + "/id", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/placeholders/items/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err1338];
                    } else {
                      vErrors.push(err1338);
                    }
                    errors++;
                  }
                  if (!(data531 === "punktwert" || data531 === "labor" || data531 === "materialPreise" || data531 === "anzahl" || data531 === "faktor" || data531 === "laborGleichartig" || data531 === "eigenanteil")) {
                    const err1339 = { instancePath: instancePath + "/alternative/placeholders/" + i48 + "/id", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/placeholders/items/properties/id/enum", keyword: "enum", params: { allowedValues: schema37.properties.alternative.properties.placeholders.items.properties.id.enum }, message: "must be equal to one of the allowed values" };
                    if (vErrors === null) {
                      vErrors = [err1339];
                    } else {
                      vErrors.push(err1339);
                    }
                    errors++;
                  }
                }
                if (data530.text !== void 0) {
                  if (typeof data530.text !== "string") {
                    const err1340 = { instancePath: instancePath + "/alternative/placeholders/" + i48 + "/text", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/placeholders/items/properties/text/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err1340];
                    } else {
                      vErrors.push(err1340);
                    }
                    errors++;
                  }
                }
              } else {
                const err1341 = { instancePath: instancePath + "/alternative/placeholders/" + i48, schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/placeholders/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                if (vErrors === null) {
                  vErrors = [err1341];
                } else {
                  vErrors.push(err1341);
                }
                errors++;
              }
            }
          } else {
            const err1342 = { instancePath: instancePath + "/alternative/placeholders", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/properties/placeholders/type", keyword: "type", params: { type: "array" }, message: "must be array" };
            if (vErrors === null) {
              vErrors = [err1342];
            } else {
              vErrors.push(err1342);
            }
            errors++;
          }
        }
      } else {
        const err1343 = { instancePath: instancePath + "/alternative", schemaPath: "#/definitions/VerificationEvaluation/properties/alternative/type", keyword: "type", params: { type: "object" }, message: "must be object" };
        if (vErrors === null) {
          vErrors = [err1343];
        } else {
          vErrors.push(err1343);
        }
        errors++;
      }
    }
    if (data.superseded !== void 0) {
      let data533 = data.superseded;
      if (Array.isArray(data533)) {
        const len49 = data533.length;
        for (let i49 = 0; i49 < len49; i49++) {
          let data534 = data533[i49];
          if (data534 && typeof data534 == "object" && !Array.isArray(data534)) {
            if (data534.rule === void 0) {
              const err1344 = { instancePath: instancePath + "/superseded/" + i49, schemaPath: "#/definitions/VerificationEvaluation/properties/superseded/items/required", keyword: "required", params: { missingProperty: "rule" }, message: "must have required property 'rule'" };
              if (vErrors === null) {
                vErrors = [err1344];
              } else {
                vErrors.push(err1344);
              }
              errors++;
            }
            if (data534.befund === void 0) {
              const err1345 = { instancePath: instancePath + "/superseded/" + i49, schemaPath: "#/definitions/VerificationEvaluation/properties/superseded/items/required", keyword: "required", params: { missingProperty: "befund" }, message: "must have required property 'befund'" };
              if (vErrors === null) {
                vErrors = [err1345];
              } else {
                vErrors.push(err1345);
              }
              errors++;
            }
            if (data534.title === void 0) {
              const err1346 = { instancePath: instancePath + "/superseded/" + i49, schemaPath: "#/definitions/VerificationEvaluation/properties/superseded/items/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
              if (vErrors === null) {
                vErrors = [err1346];
              } else {
                vErrors.push(err1346);
              }
              errors++;
            }
            if (data534.fdi === void 0) {
              const err1347 = { instancePath: instancePath + "/superseded/" + i49, schemaPath: "#/definitions/VerificationEvaluation/properties/superseded/items/required", keyword: "required", params: { missingProperty: "fdi" }, message: "must have required property 'fdi'" };
              if (vErrors === null) {
                vErrors = [err1347];
              } else {
                vErrors.push(err1347);
              }
              errors++;
            }
            if (data534.by === void 0) {
              const err1348 = { instancePath: instancePath + "/superseded/" + i49, schemaPath: "#/definitions/VerificationEvaluation/properties/superseded/items/required", keyword: "required", params: { missingProperty: "by" }, message: "must have required property 'by'" };
              if (vErrors === null) {
                vErrors = [err1348];
              } else {
                vErrors.push(err1348);
              }
              errors++;
            }
            if (data534.citations === void 0) {
              const err1349 = { instancePath: instancePath + "/superseded/" + i49, schemaPath: "#/definitions/VerificationEvaluation/properties/superseded/items/required", keyword: "required", params: { missingProperty: "citations" }, message: "must have required property 'citations'" };
              if (vErrors === null) {
                vErrors = [err1349];
              } else {
                vErrors.push(err1349);
              }
              errors++;
            }
            for (const key94 in data534) {
              if (!(key94 === "rule" || key94 === "befund" || key94 === "title" || key94 === "fdi" || key94 === "by" || key94 === "citations")) {
                const err1350 = { instancePath: instancePath + "/superseded/" + i49, schemaPath: "#/definitions/VerificationEvaluation/properties/superseded/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key94 }, message: "must NOT have additional properties" };
                if (vErrors === null) {
                  vErrors = [err1350];
                } else {
                  vErrors.push(err1350);
                }
                errors++;
              }
            }
            if (data534.rule !== void 0) {
              if (typeof data534.rule !== "string") {
                const err1351 = { instancePath: instancePath + "/superseded/" + i49 + "/rule", schemaPath: "#/definitions/VerificationEvaluation/properties/superseded/items/properties/rule/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err1351];
                } else {
                  vErrors.push(err1351);
                }
                errors++;
              }
            }
            if (data534.befund !== void 0) {
              if (typeof data534.befund !== "string") {
                const err1352 = { instancePath: instancePath + "/superseded/" + i49 + "/befund", schemaPath: "#/definitions/VerificationEvaluation/properties/superseded/items/properties/befund/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err1352];
                } else {
                  vErrors.push(err1352);
                }
                errors++;
              }
            }
            if (data534.title !== void 0) {
              if (typeof data534.title !== "string") {
                const err1353 = { instancePath: instancePath + "/superseded/" + i49 + "/title", schemaPath: "#/definitions/VerificationEvaluation/properties/superseded/items/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err1353];
                } else {
                  vErrors.push(err1353);
                }
                errors++;
              }
            }
            if (data534.fdi !== void 0) {
              let data538 = data534.fdi;
              if (!(typeof data538 == "number" && (!(data538 % 1) && !isNaN(data538)) && isFinite(data538))) {
                const err1354 = { instancePath: instancePath + "/superseded/" + i49 + "/fdi", schemaPath: "#/definitions/VerificationEvaluation/properties/superseded/items/properties/fdi/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                if (vErrors === null) {
                  vErrors = [err1354];
                } else {
                  vErrors.push(err1354);
                }
                errors++;
              }
              if (typeof data538 == "number" && isFinite(data538)) {
                if (data538 > 9007199254740991 || isNaN(data538)) {
                  const err1355 = { instancePath: instancePath + "/superseded/" + i49 + "/fdi", schemaPath: "#/definitions/VerificationEvaluation/properties/superseded/items/properties/fdi/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err1355];
                  } else {
                    vErrors.push(err1355);
                  }
                  errors++;
                }
                if (data538 < -9007199254740991 || isNaN(data538)) {
                  const err1356 = { instancePath: instancePath + "/superseded/" + i49 + "/fdi", schemaPath: "#/definitions/VerificationEvaluation/properties/superseded/items/properties/fdi/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err1356];
                  } else {
                    vErrors.push(err1356);
                  }
                  errors++;
                }
              }
            }
            if (data534.by !== void 0) {
              if (typeof data534.by !== "string") {
                const err1357 = { instancePath: instancePath + "/superseded/" + i49 + "/by", schemaPath: "#/definitions/VerificationEvaluation/properties/superseded/items/properties/by/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err1357];
                } else {
                  vErrors.push(err1357);
                }
                errors++;
              }
            }
            if (data534.citations !== void 0) {
              let data540 = data534.citations;
              if (Array.isArray(data540)) {
                const len50 = data540.length;
                for (let i50 = 0; i50 < len50; i50++) {
                  let data541 = data540[i50];
                  if (data541 && typeof data541 == "object" && !Array.isArray(data541)) {
                    if (data541.chunkId === void 0) {
                      const err1358 = { instancePath: instancePath + "/superseded/" + i49 + "/citations/" + i50, schemaPath: "#/definitions/VerificationEvaluation/properties/superseded/items/properties/citations/items/required", keyword: "required", params: { missingProperty: "chunkId" }, message: "must have required property 'chunkId'" };
                      if (vErrors === null) {
                        vErrors = [err1358];
                      } else {
                        vErrors.push(err1358);
                      }
                      errors++;
                    }
                    if (data541.title === void 0) {
                      const err1359 = { instancePath: instancePath + "/superseded/" + i49 + "/citations/" + i50, schemaPath: "#/definitions/VerificationEvaluation/properties/superseded/items/properties/citations/items/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
                      if (vErrors === null) {
                        vErrors = [err1359];
                      } else {
                        vErrors.push(err1359);
                      }
                      errors++;
                    }
                    if (data541.url === void 0) {
                      const err1360 = { instancePath: instancePath + "/superseded/" + i49 + "/citations/" + i50, schemaPath: "#/definitions/VerificationEvaluation/properties/superseded/items/properties/citations/items/required", keyword: "required", params: { missingProperty: "url" }, message: "must have required property 'url'" };
                      if (vErrors === null) {
                        vErrors = [err1360];
                      } else {
                        vErrors.push(err1360);
                      }
                      errors++;
                    }
                    if (data541.quote === void 0) {
                      const err1361 = { instancePath: instancePath + "/superseded/" + i49 + "/citations/" + i50, schemaPath: "#/definitions/VerificationEvaluation/properties/superseded/items/properties/citations/items/required", keyword: "required", params: { missingProperty: "quote" }, message: "must have required property 'quote'" };
                      if (vErrors === null) {
                        vErrors = [err1361];
                      } else {
                        vErrors.push(err1361);
                      }
                      errors++;
                    }
                    for (const key95 in data541) {
                      if (!(key95 === "chunkId" || key95 === "title" || key95 === "url" || key95 === "page" || key95 === "quote")) {
                        const err1362 = { instancePath: instancePath + "/superseded/" + i49 + "/citations/" + i50, schemaPath: "#/definitions/VerificationEvaluation/properties/superseded/items/properties/citations/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key95 }, message: "must NOT have additional properties" };
                        if (vErrors === null) {
                          vErrors = [err1362];
                        } else {
                          vErrors.push(err1362);
                        }
                        errors++;
                      }
                    }
                    if (data541.chunkId !== void 0) {
                      if (typeof data541.chunkId !== "string") {
                        const err1363 = { instancePath: instancePath + "/superseded/" + i49 + "/citations/" + i50 + "/chunkId", schemaPath: "#/definitions/VerificationEvaluation/properties/superseded/items/properties/citations/items/properties/chunkId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err1363];
                        } else {
                          vErrors.push(err1363);
                        }
                        errors++;
                      }
                    }
                    if (data541.title !== void 0) {
                      if (typeof data541.title !== "string") {
                        const err1364 = { instancePath: instancePath + "/superseded/" + i49 + "/citations/" + i50 + "/title", schemaPath: "#/definitions/VerificationEvaluation/properties/superseded/items/properties/citations/items/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err1364];
                        } else {
                          vErrors.push(err1364);
                        }
                        errors++;
                      }
                    }
                    if (data541.url !== void 0) {
                      if (typeof data541.url !== "string") {
                        const err1365 = { instancePath: instancePath + "/superseded/" + i49 + "/citations/" + i50 + "/url", schemaPath: "#/definitions/VerificationEvaluation/properties/superseded/items/properties/citations/items/properties/url/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err1365];
                        } else {
                          vErrors.push(err1365);
                        }
                        errors++;
                      }
                    }
                    if (data541.page !== void 0) {
                      let data545 = data541.page;
                      if (!(typeof data545 == "number" && (!(data545 % 1) && !isNaN(data545)) && isFinite(data545))) {
                        const err1366 = { instancePath: instancePath + "/superseded/" + i49 + "/citations/" + i50 + "/page", schemaPath: "#/definitions/VerificationEvaluation/properties/superseded/items/properties/citations/items/properties/page/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                        if (vErrors === null) {
                          vErrors = [err1366];
                        } else {
                          vErrors.push(err1366);
                        }
                        errors++;
                      }
                      if (typeof data545 == "number" && isFinite(data545)) {
                        if (data545 > 9007199254740991 || isNaN(data545)) {
                          const err1367 = { instancePath: instancePath + "/superseded/" + i49 + "/citations/" + i50 + "/page", schemaPath: "#/definitions/VerificationEvaluation/properties/superseded/items/properties/citations/items/properties/page/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                          if (vErrors === null) {
                            vErrors = [err1367];
                          } else {
                            vErrors.push(err1367);
                          }
                          errors++;
                        }
                        if (data545 < -9007199254740991 || isNaN(data545)) {
                          const err1368 = { instancePath: instancePath + "/superseded/" + i49 + "/citations/" + i50 + "/page", schemaPath: "#/definitions/VerificationEvaluation/properties/superseded/items/properties/citations/items/properties/page/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                          if (vErrors === null) {
                            vErrors = [err1368];
                          } else {
                            vErrors.push(err1368);
                          }
                          errors++;
                        }
                      }
                    }
                    if (data541.quote !== void 0) {
                      if (typeof data541.quote !== "string") {
                        const err1369 = { instancePath: instancePath + "/superseded/" + i49 + "/citations/" + i50 + "/quote", schemaPath: "#/definitions/VerificationEvaluation/properties/superseded/items/properties/citations/items/properties/quote/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err1369];
                        } else {
                          vErrors.push(err1369);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err1370 = { instancePath: instancePath + "/superseded/" + i49 + "/citations/" + i50, schemaPath: "#/definitions/VerificationEvaluation/properties/superseded/items/properties/citations/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                    if (vErrors === null) {
                      vErrors = [err1370];
                    } else {
                      vErrors.push(err1370);
                    }
                    errors++;
                  }
                }
              } else {
                const err1371 = { instancePath: instancePath + "/superseded/" + i49 + "/citations", schemaPath: "#/definitions/VerificationEvaluation/properties/superseded/items/properties/citations/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                if (vErrors === null) {
                  vErrors = [err1371];
                } else {
                  vErrors.push(err1371);
                }
                errors++;
              }
            }
          } else {
            const err1372 = { instancePath: instancePath + "/superseded/" + i49, schemaPath: "#/definitions/VerificationEvaluation/properties/superseded/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
              vErrors = [err1372];
            } else {
              vErrors.push(err1372);
            }
            errors++;
          }
        }
      } else {
        const err1373 = { instancePath: instancePath + "/superseded", schemaPath: "#/definitions/VerificationEvaluation/properties/superseded/type", keyword: "type", params: { type: "array" }, message: "must be array" };
        if (vErrors === null) {
          vErrors = [err1373];
        } else {
          vErrors.push(err1373);
        }
        errors++;
      }
    }
    if (data.decisions !== void 0) {
      let data547 = data.decisions;
      if (Array.isArray(data547)) {
        const len51 = data547.length;
        for (let i51 = 0; i51 < len51; i51++) {
          let data548 = data547[i51];
          if (data548 && typeof data548 == "object" && !Array.isArray(data548)) {
            if (data548.rule === void 0) {
              const err1374 = { instancePath: instancePath + "/decisions/" + i51, schemaPath: "#/definitions/VerificationEvaluation/properties/decisions/items/required", keyword: "required", params: { missingProperty: "rule" }, message: "must have required property 'rule'" };
              if (vErrors === null) {
                vErrors = [err1374];
              } else {
                vErrors.push(err1374);
              }
              errors++;
            }
            if (data548.at === void 0) {
              const err1375 = { instancePath: instancePath + "/decisions/" + i51, schemaPath: "#/definitions/VerificationEvaluation/properties/decisions/items/required", keyword: "required", params: { missingProperty: "at" }, message: "must have required property 'at'" };
              if (vErrors === null) {
                vErrors = [err1375];
              } else {
                vErrors.push(err1375);
              }
              errors++;
            }
            if (data548.kind === void 0) {
              const err1376 = { instancePath: instancePath + "/decisions/" + i51, schemaPath: "#/definitions/VerificationEvaluation/properties/decisions/items/required", keyword: "required", params: { missingProperty: "kind" }, message: "must have required property 'kind'" };
              if (vErrors === null) {
                vErrors = [err1376];
              } else {
                vErrors.push(err1376);
              }
              errors++;
            }
            if (data548.facts === void 0) {
              const err1377 = { instancePath: instancePath + "/decisions/" + i51, schemaPath: "#/definitions/VerificationEvaluation/properties/decisions/items/required", keyword: "required", params: { missingProperty: "facts" }, message: "must have required property 'facts'" };
              if (vErrors === null) {
                vErrors = [err1377];
              } else {
                vErrors.push(err1377);
              }
              errors++;
            }
            if (data548.counts === void 0) {
              const err1378 = { instancePath: instancePath + "/decisions/" + i51, schemaPath: "#/definitions/VerificationEvaluation/properties/decisions/items/required", keyword: "required", params: { missingProperty: "counts" }, message: "must have required property 'counts'" };
              if (vErrors === null) {
                vErrors = [err1378];
              } else {
                vErrors.push(err1378);
              }
              errors++;
            }
            if (data548.from === void 0) {
              const err1379 = { instancePath: instancePath + "/decisions/" + i51, schemaPath: "#/definitions/VerificationEvaluation/properties/decisions/items/required", keyword: "required", params: { missingProperty: "from" }, message: "must have required property 'from'" };
              if (vErrors === null) {
                vErrors = [err1379];
              } else {
                vErrors.push(err1379);
              }
              errors++;
            }
            for (const key96 in data548) {
              if (!(key96 === "rule" || key96 === "at" || key96 === "kind" || key96 === "facts" || key96 === "counts" || key96 === "from" || key96 === "by" || key96 === "missing")) {
                const err1380 = { instancePath: instancePath + "/decisions/" + i51, schemaPath: "#/definitions/VerificationEvaluation/properties/decisions/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key96 }, message: "must NOT have additional properties" };
                if (vErrors === null) {
                  vErrors = [err1380];
                } else {
                  vErrors.push(err1380);
                }
                errors++;
              }
            }
            if (data548.rule !== void 0) {
              if (typeof data548.rule !== "string") {
                const err1381 = { instancePath: instancePath + "/decisions/" + i51 + "/rule", schemaPath: "#/definitions/VerificationEvaluation/properties/decisions/items/properties/rule/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err1381];
                } else {
                  vErrors.push(err1381);
                }
                errors++;
              }
            }
            if (data548.at !== void 0) {
              if (typeof data548.at !== "string") {
                const err1382 = { instancePath: instancePath + "/decisions/" + i51 + "/at", schemaPath: "#/definitions/VerificationEvaluation/properties/decisions/items/properties/at/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err1382];
                } else {
                  vErrors.push(err1382);
                }
                errors++;
              }
            }
            if (data548.kind !== void 0) {
              let data551 = data548.kind;
              if (typeof data551 !== "string") {
                const err1383 = { instancePath: instancePath + "/decisions/" + i51 + "/kind", schemaPath: "#/definitions/VerificationEvaluation/properties/decisions/items/properties/kind/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err1383];
                } else {
                  vErrors.push(err1383);
                }
                errors++;
              }
              if (!(data551 === "result" || data551 === "notApplicable" || data551 === "superseded" || data551 === "needs" || data551 === "pending")) {
                const err1384 = { instancePath: instancePath + "/decisions/" + i51 + "/kind", schemaPath: "#/definitions/VerificationEvaluation/properties/decisions/items/properties/kind/enum", keyword: "enum", params: { allowedValues: schema37.properties.decisions.items.properties.kind.enum }, message: "must be equal to one of the allowed values" };
                if (vErrors === null) {
                  vErrors = [err1384];
                } else {
                  vErrors.push(err1384);
                }
                errors++;
              }
            }
            if (data548.facts !== void 0) {
              let data552 = data548.facts;
              if (Array.isArray(data552)) {
                const len52 = data552.length;
                for (let i52 = 0; i52 < len52; i52++) {
                  let data553 = data552[i52];
                  if (data553 && typeof data553 == "object" && !Array.isArray(data553)) {
                    if (data553.fact === void 0) {
                      const err1385 = { instancePath: instancePath + "/decisions/" + i51 + "/facts/" + i52, schemaPath: "#/definitions/VerificationEvaluation/properties/decisions/items/properties/facts/items/required", keyword: "required", params: { missingProperty: "fact" }, message: "must have required property 'fact'" };
                      if (vErrors === null) {
                        vErrors = [err1385];
                      } else {
                        vErrors.push(err1385);
                      }
                      errors++;
                    }
                    if (data553.value === void 0) {
                      const err1386 = { instancePath: instancePath + "/decisions/" + i51 + "/facts/" + i52, schemaPath: "#/definitions/VerificationEvaluation/properties/decisions/items/properties/facts/items/required", keyword: "required", params: { missingProperty: "value" }, message: "must have required property 'value'" };
                      if (vErrors === null) {
                        vErrors = [err1386];
                      } else {
                        vErrors.push(err1386);
                      }
                      errors++;
                    }
                    if (data553.statedIn === void 0) {
                      const err1387 = { instancePath: instancePath + "/decisions/" + i51 + "/facts/" + i52, schemaPath: "#/definitions/VerificationEvaluation/properties/decisions/items/properties/facts/items/required", keyword: "required", params: { missingProperty: "statedIn" }, message: "must have required property 'statedIn'" };
                      if (vErrors === null) {
                        vErrors = [err1387];
                      } else {
                        vErrors.push(err1387);
                      }
                      errors++;
                    }
                    for (const key97 in data553) {
                      if (!(key97 === "fdi" || key97 === "jaw" || key97 === "fact" || key97 === "value" || key97 === "statedIn")) {
                        const err1388 = { instancePath: instancePath + "/decisions/" + i51 + "/facts/" + i52, schemaPath: "#/definitions/VerificationEvaluation/properties/decisions/items/properties/facts/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key97 }, message: "must NOT have additional properties" };
                        if (vErrors === null) {
                          vErrors = [err1388];
                        } else {
                          vErrors.push(err1388);
                        }
                        errors++;
                      }
                    }
                    if (data553.fdi !== void 0) {
                      let data554 = data553.fdi;
                      if (!(typeof data554 == "number" && (!(data554 % 1) && !isNaN(data554)) && isFinite(data554))) {
                        const err1389 = { instancePath: instancePath + "/decisions/" + i51 + "/facts/" + i52 + "/fdi", schemaPath: "#/definitions/VerificationEvaluation/properties/decisions/items/properties/facts/items/properties/fdi/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                        if (vErrors === null) {
                          vErrors = [err1389];
                        } else {
                          vErrors.push(err1389);
                        }
                        errors++;
                      }
                      if (typeof data554 == "number" && isFinite(data554)) {
                        if (data554 > 9007199254740991 || isNaN(data554)) {
                          const err1390 = { instancePath: instancePath + "/decisions/" + i51 + "/facts/" + i52 + "/fdi", schemaPath: "#/definitions/VerificationEvaluation/properties/decisions/items/properties/facts/items/properties/fdi/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                          if (vErrors === null) {
                            vErrors = [err1390];
                          } else {
                            vErrors.push(err1390);
                          }
                          errors++;
                        }
                        if (data554 < -9007199254740991 || isNaN(data554)) {
                          const err1391 = { instancePath: instancePath + "/decisions/" + i51 + "/facts/" + i52 + "/fdi", schemaPath: "#/definitions/VerificationEvaluation/properties/decisions/items/properties/facts/items/properties/fdi/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                          if (vErrors === null) {
                            vErrors = [err1391];
                          } else {
                            vErrors.push(err1391);
                          }
                          errors++;
                        }
                      }
                    }
                    if (data553.jaw !== void 0) {
                      let data555 = data553.jaw;
                      if (typeof data555 !== "string") {
                        const err1392 = { instancePath: instancePath + "/decisions/" + i51 + "/facts/" + i52 + "/jaw", schemaPath: "#/definitions/VerificationEvaluation/properties/decisions/items/properties/facts/items/properties/jaw/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err1392];
                        } else {
                          vErrors.push(err1392);
                        }
                        errors++;
                      }
                      if (!(data555 === "OK" || data555 === "UK")) {
                        const err1393 = { instancePath: instancePath + "/decisions/" + i51 + "/facts/" + i52 + "/jaw", schemaPath: "#/definitions/VerificationEvaluation/properties/decisions/items/properties/facts/items/properties/jaw/enum", keyword: "enum", params: { allowedValues: schema37.properties.decisions.items.properties.facts.items.properties.jaw.enum }, message: "must be equal to one of the allowed values" };
                        if (vErrors === null) {
                          vErrors = [err1393];
                        } else {
                          vErrors.push(err1393);
                        }
                        errors++;
                      }
                    }
                    if (data553.fact !== void 0) {
                      let data556 = data553.fact;
                      if (typeof data556 !== "string") {
                        const err1394 = { instancePath: instancePath + "/decisions/" + i51 + "/facts/" + i52 + "/fact", schemaPath: "#/definitions/VerificationEvaluation/properties/decisions/items/properties/facts/items/properties/fact/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err1394];
                        } else {
                          vErrors.push(err1394);
                        }
                        errors++;
                      }
                      if (!(data556 === "fehlt" || data556 === "erhaltungswuerdig" || data556 === "krone" || data556 === "endodontisch_behandelt" || data556 === "stiftaufbau" || data556 === "brueckenanker" || data556 === "disparallel" || data556 === "wiederherstellung" || data556 === "geplant" || data556 === "lueckensituation_i")) {
                        const err1395 = { instancePath: instancePath + "/decisions/" + i51 + "/facts/" + i52 + "/fact", schemaPath: "#/definitions/VerificationEvaluation/properties/decisions/items/properties/facts/items/properties/fact/enum", keyword: "enum", params: { allowedValues: schema37.properties.decisions.items.properties.facts.items.properties.fact.enum }, message: "must be equal to one of the allowed values" };
                        if (vErrors === null) {
                          vErrors = [err1395];
                        } else {
                          vErrors.push(err1395);
                        }
                        errors++;
                      }
                    }
                    if (data553.value !== void 0) {
                      let data557 = data553.value;
                      const _errs1239 = errors;
                      let valid211 = false;
                      const _errs1240 = errors;
                      if (typeof data557 !== "boolean") {
                        const err1396 = { instancePath: instancePath + "/decisions/" + i51 + "/facts/" + i52 + "/value", schemaPath: "#/definitions/VerificationEvaluation/properties/decisions/items/properties/facts/items/properties/value/anyOf/0/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                        if (vErrors === null) {
                          vErrors = [err1396];
                        } else {
                          vErrors.push(err1396);
                        }
                        errors++;
                      }
                      var _valid6 = _errs1240 === errors;
                      valid211 = valid211 || _valid6;
                      if (!valid211) {
                        const _errs1242 = errors;
                        if (typeof data557 !== "string") {
                          const err1397 = { instancePath: instancePath + "/decisions/" + i51 + "/facts/" + i52 + "/value", schemaPath: "#/definitions/VerificationEvaluation/properties/decisions/items/properties/facts/items/properties/value/anyOf/1/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                          if (vErrors === null) {
                            vErrors = [err1397];
                          } else {
                            vErrors.push(err1397);
                          }
                          errors++;
                        }
                        var _valid6 = _errs1242 === errors;
                        valid211 = valid211 || _valid6;
                      }
                      if (!valid211) {
                        const err1398 = { instancePath: instancePath + "/decisions/" + i51 + "/facts/" + i52 + "/value", schemaPath: "#/definitions/VerificationEvaluation/properties/decisions/items/properties/facts/items/properties/value/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                        if (vErrors === null) {
                          vErrors = [err1398];
                        } else {
                          vErrors.push(err1398);
                        }
                        errors++;
                      } else {
                        errors = _errs1239;
                        if (vErrors !== null) {
                          if (_errs1239) {
                            vErrors.length = _errs1239;
                          } else {
                            vErrors = null;
                          }
                        }
                      }
                    }
                    if (data553.statedIn !== void 0) {
                      if (typeof data553.statedIn !== "string") {
                        const err1399 = { instancePath: instancePath + "/decisions/" + i51 + "/facts/" + i52 + "/statedIn", schemaPath: "#/definitions/VerificationEvaluation/properties/decisions/items/properties/facts/items/properties/statedIn/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err1399];
                        } else {
                          vErrors.push(err1399);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err1400 = { instancePath: instancePath + "/decisions/" + i51 + "/facts/" + i52, schemaPath: "#/definitions/VerificationEvaluation/properties/decisions/items/properties/facts/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                    if (vErrors === null) {
                      vErrors = [err1400];
                    } else {
                      vErrors.push(err1400);
                    }
                    errors++;
                  }
                }
              } else {
                const err1401 = { instancePath: instancePath + "/decisions/" + i51 + "/facts", schemaPath: "#/definitions/VerificationEvaluation/properties/decisions/items/properties/facts/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                if (vErrors === null) {
                  vErrors = [err1401];
                } else {
                  vErrors.push(err1401);
                }
                errors++;
              }
            }
            if (data548.counts !== void 0) {
              let data559 = data548.counts;
              if (Array.isArray(data559)) {
                const len53 = data559.length;
                for (let i53 = 0; i53 < len53; i53++) {
                  let data560 = data559[i53];
                  if (data560 && typeof data560 == "object" && !Array.isArray(data560)) {
                    if (data560.nr === void 0) {
                      const err1402 = { instancePath: instancePath + "/decisions/" + i51 + "/counts/" + i53, schemaPath: "#/definitions/VerificationEvaluation/properties/decisions/items/properties/counts/items/required", keyword: "required", params: { missingProperty: "nr" }, message: "must have required property 'nr'" };
                      if (vErrors === null) {
                        vErrors = [err1402];
                      } else {
                        vErrors.push(err1402);
                      }
                      errors++;
                    }
                    if (data560.value === void 0) {
                      const err1403 = { instancePath: instancePath + "/decisions/" + i51 + "/counts/" + i53, schemaPath: "#/definitions/VerificationEvaluation/properties/decisions/items/properties/counts/items/required", keyword: "required", params: { missingProperty: "value" }, message: "must have required property 'value'" };
                      if (vErrors === null) {
                        vErrors = [err1403];
                      } else {
                        vErrors.push(err1403);
                      }
                      errors++;
                    }
                    if (data560.statedIn === void 0) {
                      const err1404 = { instancePath: instancePath + "/decisions/" + i51 + "/counts/" + i53, schemaPath: "#/definitions/VerificationEvaluation/properties/decisions/items/properties/counts/items/required", keyword: "required", params: { missingProperty: "statedIn" }, message: "must have required property 'statedIn'" };
                      if (vErrors === null) {
                        vErrors = [err1404];
                      } else {
                        vErrors.push(err1404);
                      }
                      errors++;
                    }
                    for (const key98 in data560) {
                      if (!(key98 === "nr" || key98 === "value" || key98 === "statedIn")) {
                        const err1405 = { instancePath: instancePath + "/decisions/" + i51 + "/counts/" + i53, schemaPath: "#/definitions/VerificationEvaluation/properties/decisions/items/properties/counts/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key98 }, message: "must NOT have additional properties" };
                        if (vErrors === null) {
                          vErrors = [err1405];
                        } else {
                          vErrors.push(err1405);
                        }
                        errors++;
                      }
                    }
                    if (data560.nr !== void 0) {
                      if (typeof data560.nr !== "string") {
                        const err1406 = { instancePath: instancePath + "/decisions/" + i51 + "/counts/" + i53 + "/nr", schemaPath: "#/definitions/VerificationEvaluation/properties/decisions/items/properties/counts/items/properties/nr/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err1406];
                        } else {
                          vErrors.push(err1406);
                        }
                        errors++;
                      }
                    }
                    if (data560.value !== void 0) {
                      let data562 = data560.value;
                      if (!(typeof data562 == "number" && (!(data562 % 1) && !isNaN(data562)) && isFinite(data562))) {
                        const err1407 = { instancePath: instancePath + "/decisions/" + i51 + "/counts/" + i53 + "/value", schemaPath: "#/definitions/VerificationEvaluation/properties/decisions/items/properties/counts/items/properties/value/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                        if (vErrors === null) {
                          vErrors = [err1407];
                        } else {
                          vErrors.push(err1407);
                        }
                        errors++;
                      }
                      if (typeof data562 == "number" && isFinite(data562)) {
                        if (data562 > 9007199254740991 || isNaN(data562)) {
                          const err1408 = { instancePath: instancePath + "/decisions/" + i51 + "/counts/" + i53 + "/value", schemaPath: "#/definitions/VerificationEvaluation/properties/decisions/items/properties/counts/items/properties/value/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                          if (vErrors === null) {
                            vErrors = [err1408];
                          } else {
                            vErrors.push(err1408);
                          }
                          errors++;
                        }
                        if (data562 < -9007199254740991 || isNaN(data562)) {
                          const err1409 = { instancePath: instancePath + "/decisions/" + i51 + "/counts/" + i53 + "/value", schemaPath: "#/definitions/VerificationEvaluation/properties/decisions/items/properties/counts/items/properties/value/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                          if (vErrors === null) {
                            vErrors = [err1409];
                          } else {
                            vErrors.push(err1409);
                          }
                          errors++;
                        }
                      }
                    }
                    if (data560.statedIn !== void 0) {
                      if (typeof data560.statedIn !== "string") {
                        const err1410 = { instancePath: instancePath + "/decisions/" + i51 + "/counts/" + i53 + "/statedIn", schemaPath: "#/definitions/VerificationEvaluation/properties/decisions/items/properties/counts/items/properties/statedIn/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err1410];
                        } else {
                          vErrors.push(err1410);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err1411 = { instancePath: instancePath + "/decisions/" + i51 + "/counts/" + i53, schemaPath: "#/definitions/VerificationEvaluation/properties/decisions/items/properties/counts/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                    if (vErrors === null) {
                      vErrors = [err1411];
                    } else {
                      vErrors.push(err1411);
                    }
                    errors++;
                  }
                }
              } else {
                const err1412 = { instancePath: instancePath + "/decisions/" + i51 + "/counts", schemaPath: "#/definitions/VerificationEvaluation/properties/decisions/items/properties/counts/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                if (vErrors === null) {
                  vErrors = [err1412];
                } else {
                  vErrors.push(err1412);
                }
                errors++;
              }
            }
            if (data548.from !== void 0) {
              let data564 = data548.from;
              if (Array.isArray(data564)) {
                const len54 = data564.length;
                for (let i54 = 0; i54 < len54; i54++) {
                  let data565 = data564[i54];
                  if (data565 && typeof data565 == "object" && !Array.isArray(data565)) {
                    if (data565.rule === void 0) {
                      const err1413 = { instancePath: instancePath + "/decisions/" + i51 + "/from/" + i54, schemaPath: "#/definitions/VerificationEvaluation/properties/decisions/items/properties/from/items/required", keyword: "required", params: { missingProperty: "rule" }, message: "must have required property 'rule'" };
                      if (vErrors === null) {
                        vErrors = [err1413];
                      } else {
                        vErrors.push(err1413);
                      }
                      errors++;
                    }
                    if (data565.at === void 0) {
                      const err1414 = { instancePath: instancePath + "/decisions/" + i51 + "/from/" + i54, schemaPath: "#/definitions/VerificationEvaluation/properties/decisions/items/properties/from/items/required", keyword: "required", params: { missingProperty: "at" }, message: "must have required property 'at'" };
                      if (vErrors === null) {
                        vErrors = [err1414];
                      } else {
                        vErrors.push(err1414);
                      }
                      errors++;
                    }
                    for (const key99 in data565) {
                      if (!(key99 === "rule" || key99 === "at")) {
                        const err1415 = { instancePath: instancePath + "/decisions/" + i51 + "/from/" + i54, schemaPath: "#/definitions/VerificationEvaluation/properties/decisions/items/properties/from/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key99 }, message: "must NOT have additional properties" };
                        if (vErrors === null) {
                          vErrors = [err1415];
                        } else {
                          vErrors.push(err1415);
                        }
                        errors++;
                      }
                    }
                    if (data565.rule !== void 0) {
                      if (typeof data565.rule !== "string") {
                        const err1416 = { instancePath: instancePath + "/decisions/" + i51 + "/from/" + i54 + "/rule", schemaPath: "#/definitions/VerificationEvaluation/properties/decisions/items/properties/from/items/properties/rule/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err1416];
                        } else {
                          vErrors.push(err1416);
                        }
                        errors++;
                      }
                    }
                    if (data565.at !== void 0) {
                      if (typeof data565.at !== "string") {
                        const err1417 = { instancePath: instancePath + "/decisions/" + i51 + "/from/" + i54 + "/at", schemaPath: "#/definitions/VerificationEvaluation/properties/decisions/items/properties/from/items/properties/at/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err1417];
                        } else {
                          vErrors.push(err1417);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err1418 = { instancePath: instancePath + "/decisions/" + i51 + "/from/" + i54, schemaPath: "#/definitions/VerificationEvaluation/properties/decisions/items/properties/from/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                    if (vErrors === null) {
                      vErrors = [err1418];
                    } else {
                      vErrors.push(err1418);
                    }
                    errors++;
                  }
                }
              } else {
                const err1419 = { instancePath: instancePath + "/decisions/" + i51 + "/from", schemaPath: "#/definitions/VerificationEvaluation/properties/decisions/items/properties/from/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                if (vErrors === null) {
                  vErrors = [err1419];
                } else {
                  vErrors.push(err1419);
                }
                errors++;
              }
            }
            if (data548.by !== void 0) {
              if (typeof data548.by !== "string") {
                const err1420 = { instancePath: instancePath + "/decisions/" + i51 + "/by", schemaPath: "#/definitions/VerificationEvaluation/properties/decisions/items/properties/by/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err1420];
                } else {
                  vErrors.push(err1420);
                }
                errors++;
              }
            }
            if (data548.missing !== void 0) {
              let data569 = data548.missing;
              if (Array.isArray(data569)) {
                const len55 = data569.length;
                for (let i55 = 0; i55 < len55; i55++) {
                  if (typeof data569[i55] !== "string") {
                    const err1421 = { instancePath: instancePath + "/decisions/" + i51 + "/missing/" + i55, schemaPath: "#/definitions/VerificationEvaluation/properties/decisions/items/properties/missing/items/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err1421];
                    } else {
                      vErrors.push(err1421);
                    }
                    errors++;
                  }
                }
              } else {
                const err1422 = { instancePath: instancePath + "/decisions/" + i51 + "/missing", schemaPath: "#/definitions/VerificationEvaluation/properties/decisions/items/properties/missing/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                if (vErrors === null) {
                  vErrors = [err1422];
                } else {
                  vErrors.push(err1422);
                }
                errors++;
              }
            }
          } else {
            const err1423 = { instancePath: instancePath + "/decisions/" + i51, schemaPath: "#/definitions/VerificationEvaluation/properties/decisions/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
              vErrors = [err1423];
            } else {
              vErrors.push(err1423);
            }
            errors++;
          }
        }
      } else {
        const err1424 = { instancePath: instancePath + "/decisions", schemaPath: "#/definitions/VerificationEvaluation/properties/decisions/type", keyword: "type", params: { type: "array" }, message: "must be array" };
        if (vErrors === null) {
          vErrors = [err1424];
        } else {
          vErrors.push(err1424);
        }
        errors++;
      }
    }
    if (data.rules !== void 0) {
      let data571 = data.rules;
      if (Array.isArray(data571)) {
        const len56 = data571.length;
        for (let i56 = 0; i56 < len56; i56++) {
          let data572 = data571[i56];
          if (data572 && typeof data572 == "object" && !Array.isArray(data572)) {
            if (data572.id === void 0) {
              const err1425 = { instancePath: instancePath + "/rules/" + i56, schemaPath: "#/definitions/VerificationEvaluation/properties/rules/items/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property 'id'" };
              if (vErrors === null) {
                vErrors = [err1425];
              } else {
                vErrors.push(err1425);
              }
              errors++;
            }
            if (data572.title === void 0) {
              const err1426 = { instancePath: instancePath + "/rules/" + i56, schemaPath: "#/definitions/VerificationEvaluation/properties/rules/items/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
              if (vErrors === null) {
                vErrors = [err1426];
              } else {
                vErrors.push(err1426);
              }
              errors++;
            }
            if (data572.citations === void 0) {
              const err1427 = { instancePath: instancePath + "/rules/" + i56, schemaPath: "#/definitions/VerificationEvaluation/properties/rules/items/required", keyword: "required", params: { missingProperty: "citations" }, message: "must have required property 'citations'" };
              if (vErrors === null) {
                vErrors = [err1427];
              } else {
                vErrors.push(err1427);
              }
              errors++;
            }
            if (data572.ours === void 0) {
              const err1428 = { instancePath: instancePath + "/rules/" + i56, schemaPath: "#/definitions/VerificationEvaluation/properties/rules/items/required", keyword: "required", params: { missingProperty: "ours" }, message: "must have required property 'ours'" };
              if (vErrors === null) {
                vErrors = [err1428];
              } else {
                vErrors.push(err1428);
              }
              errors++;
            }
            for (const key100 in data572) {
              if (!(key100 === "id" || key100 === "title" || key100 === "citations" || key100 === "ours")) {
                const err1429 = { instancePath: instancePath + "/rules/" + i56, schemaPath: "#/definitions/VerificationEvaluation/properties/rules/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key100 }, message: "must NOT have additional properties" };
                if (vErrors === null) {
                  vErrors = [err1429];
                } else {
                  vErrors.push(err1429);
                }
                errors++;
              }
            }
            if (data572.id !== void 0) {
              if (typeof data572.id !== "string") {
                const err1430 = { instancePath: instancePath + "/rules/" + i56 + "/id", schemaPath: "#/definitions/VerificationEvaluation/properties/rules/items/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err1430];
                } else {
                  vErrors.push(err1430);
                }
                errors++;
              }
            }
            if (data572.title !== void 0) {
              if (typeof data572.title !== "string") {
                const err1431 = { instancePath: instancePath + "/rules/" + i56 + "/title", schemaPath: "#/definitions/VerificationEvaluation/properties/rules/items/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err1431];
                } else {
                  vErrors.push(err1431);
                }
                errors++;
              }
            }
            if (data572.citations !== void 0) {
              let data575 = data572.citations;
              if (Array.isArray(data575)) {
                const len57 = data575.length;
                for (let i57 = 0; i57 < len57; i57++) {
                  let data576 = data575[i57];
                  if (data576 && typeof data576 == "object" && !Array.isArray(data576)) {
                    if (data576.chunkId === void 0) {
                      const err1432 = { instancePath: instancePath + "/rules/" + i56 + "/citations/" + i57, schemaPath: "#/definitions/VerificationEvaluation/properties/rules/items/properties/citations/items/required", keyword: "required", params: { missingProperty: "chunkId" }, message: "must have required property 'chunkId'" };
                      if (vErrors === null) {
                        vErrors = [err1432];
                      } else {
                        vErrors.push(err1432);
                      }
                      errors++;
                    }
                    if (data576.title === void 0) {
                      const err1433 = { instancePath: instancePath + "/rules/" + i56 + "/citations/" + i57, schemaPath: "#/definitions/VerificationEvaluation/properties/rules/items/properties/citations/items/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
                      if (vErrors === null) {
                        vErrors = [err1433];
                      } else {
                        vErrors.push(err1433);
                      }
                      errors++;
                    }
                    if (data576.url === void 0) {
                      const err1434 = { instancePath: instancePath + "/rules/" + i56 + "/citations/" + i57, schemaPath: "#/definitions/VerificationEvaluation/properties/rules/items/properties/citations/items/required", keyword: "required", params: { missingProperty: "url" }, message: "must have required property 'url'" };
                      if (vErrors === null) {
                        vErrors = [err1434];
                      } else {
                        vErrors.push(err1434);
                      }
                      errors++;
                    }
                    if (data576.quote === void 0) {
                      const err1435 = { instancePath: instancePath + "/rules/" + i56 + "/citations/" + i57, schemaPath: "#/definitions/VerificationEvaluation/properties/rules/items/properties/citations/items/required", keyword: "required", params: { missingProperty: "quote" }, message: "must have required property 'quote'" };
                      if (vErrors === null) {
                        vErrors = [err1435];
                      } else {
                        vErrors.push(err1435);
                      }
                      errors++;
                    }
                    for (const key101 in data576) {
                      if (!(key101 === "chunkId" || key101 === "title" || key101 === "url" || key101 === "page" || key101 === "quote")) {
                        const err1436 = { instancePath: instancePath + "/rules/" + i56 + "/citations/" + i57, schemaPath: "#/definitions/VerificationEvaluation/properties/rules/items/properties/citations/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key101 }, message: "must NOT have additional properties" };
                        if (vErrors === null) {
                          vErrors = [err1436];
                        } else {
                          vErrors.push(err1436);
                        }
                        errors++;
                      }
                    }
                    if (data576.chunkId !== void 0) {
                      if (typeof data576.chunkId !== "string") {
                        const err1437 = { instancePath: instancePath + "/rules/" + i56 + "/citations/" + i57 + "/chunkId", schemaPath: "#/definitions/VerificationEvaluation/properties/rules/items/properties/citations/items/properties/chunkId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err1437];
                        } else {
                          vErrors.push(err1437);
                        }
                        errors++;
                      }
                    }
                    if (data576.title !== void 0) {
                      if (typeof data576.title !== "string") {
                        const err1438 = { instancePath: instancePath + "/rules/" + i56 + "/citations/" + i57 + "/title", schemaPath: "#/definitions/VerificationEvaluation/properties/rules/items/properties/citations/items/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err1438];
                        } else {
                          vErrors.push(err1438);
                        }
                        errors++;
                      }
                    }
                    if (data576.url !== void 0) {
                      if (typeof data576.url !== "string") {
                        const err1439 = { instancePath: instancePath + "/rules/" + i56 + "/citations/" + i57 + "/url", schemaPath: "#/definitions/VerificationEvaluation/properties/rules/items/properties/citations/items/properties/url/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err1439];
                        } else {
                          vErrors.push(err1439);
                        }
                        errors++;
                      }
                    }
                    if (data576.page !== void 0) {
                      let data580 = data576.page;
                      if (!(typeof data580 == "number" && (!(data580 % 1) && !isNaN(data580)) && isFinite(data580))) {
                        const err1440 = { instancePath: instancePath + "/rules/" + i56 + "/citations/" + i57 + "/page", schemaPath: "#/definitions/VerificationEvaluation/properties/rules/items/properties/citations/items/properties/page/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                        if (vErrors === null) {
                          vErrors = [err1440];
                        } else {
                          vErrors.push(err1440);
                        }
                        errors++;
                      }
                      if (typeof data580 == "number" && isFinite(data580)) {
                        if (data580 > 9007199254740991 || isNaN(data580)) {
                          const err1441 = { instancePath: instancePath + "/rules/" + i56 + "/citations/" + i57 + "/page", schemaPath: "#/definitions/VerificationEvaluation/properties/rules/items/properties/citations/items/properties/page/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                          if (vErrors === null) {
                            vErrors = [err1441];
                          } else {
                            vErrors.push(err1441);
                          }
                          errors++;
                        }
                        if (data580 < -9007199254740991 || isNaN(data580)) {
                          const err1442 = { instancePath: instancePath + "/rules/" + i56 + "/citations/" + i57 + "/page", schemaPath: "#/definitions/VerificationEvaluation/properties/rules/items/properties/citations/items/properties/page/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                          if (vErrors === null) {
                            vErrors = [err1442];
                          } else {
                            vErrors.push(err1442);
                          }
                          errors++;
                        }
                      }
                    }
                    if (data576.quote !== void 0) {
                      if (typeof data576.quote !== "string") {
                        const err1443 = { instancePath: instancePath + "/rules/" + i56 + "/citations/" + i57 + "/quote", schemaPath: "#/definitions/VerificationEvaluation/properties/rules/items/properties/citations/items/properties/quote/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err1443];
                        } else {
                          vErrors.push(err1443);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err1444 = { instancePath: instancePath + "/rules/" + i56 + "/citations/" + i57, schemaPath: "#/definitions/VerificationEvaluation/properties/rules/items/properties/citations/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                    if (vErrors === null) {
                      vErrors = [err1444];
                    } else {
                      vErrors.push(err1444);
                    }
                    errors++;
                  }
                }
              } else {
                const err1445 = { instancePath: instancePath + "/rules/" + i56 + "/citations", schemaPath: "#/definitions/VerificationEvaluation/properties/rules/items/properties/citations/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                if (vErrors === null) {
                  vErrors = [err1445];
                } else {
                  vErrors.push(err1445);
                }
                errors++;
              }
            }
            if (data572.ours !== void 0) {
              let data582 = data572.ours;
              if (Array.isArray(data582)) {
                const len58 = data582.length;
                for (let i58 = 0; i58 < len58; i58++) {
                  if (typeof data582[i58] !== "string") {
                    const err1446 = { instancePath: instancePath + "/rules/" + i56 + "/ours/" + i58, schemaPath: "#/definitions/VerificationEvaluation/properties/rules/items/properties/ours/items/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err1446];
                    } else {
                      vErrors.push(err1446);
                    }
                    errors++;
                  }
                }
              } else {
                const err1447 = { instancePath: instancePath + "/rules/" + i56 + "/ours", schemaPath: "#/definitions/VerificationEvaluation/properties/rules/items/properties/ours/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                if (vErrors === null) {
                  vErrors = [err1447];
                } else {
                  vErrors.push(err1447);
                }
                errors++;
              }
            }
          } else {
            const err1448 = { instancePath: instancePath + "/rules/" + i56, schemaPath: "#/definitions/VerificationEvaluation/properties/rules/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
              vErrors = [err1448];
            } else {
              vErrors.push(err1448);
            }
            errors++;
          }
        }
      } else {
        const err1449 = { instancePath: instancePath + "/rules", schemaPath: "#/definitions/VerificationEvaluation/properties/rules/type", keyword: "type", params: { type: "array" }, message: "must be array" };
        if (vErrors === null) {
          vErrors = [err1449];
        } else {
          vErrors.push(err1449);
        }
        errors++;
      }
    }
    if (data.grid !== void 0) {
      let data584 = data.grid;
      if (Array.isArray(data584)) {
        const len59 = data584.length;
        for (let i59 = 0; i59 < len59; i59++) {
          let data585 = data584[i59];
          if (data585 && typeof data585 == "object" && !Array.isArray(data585)) {
            if (data585.place === void 0) {
              const err1450 = { instancePath: instancePath + "/grid/" + i59, schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/required", keyword: "required", params: { missingProperty: "place" }, message: "must have required property 'place'" };
              if (vErrors === null) {
                vErrors = [err1450];
              } else {
                vErrors.push(err1450);
              }
              errors++;
            }
            if (data585.stage === void 0) {
              const err1451 = { instancePath: instancePath + "/grid/" + i59, schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/required", keyword: "required", params: { missingProperty: "stage" }, message: "must have required property 'stage'" };
              if (vErrors === null) {
                vErrors = [err1451];
              } else {
                vErrors.push(err1451);
              }
              errors++;
            }
            if (data585.state === void 0) {
              const err1452 = { instancePath: instancePath + "/grid/" + i59, schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/required", keyword: "required", params: { missingProperty: "state" }, message: "must have required property 'state'" };
              if (vErrors === null) {
                vErrors = [err1452];
              } else {
                vErrors.push(err1452);
              }
              errors++;
            }
            if (data585.owner === void 0) {
              const err1453 = { instancePath: instancePath + "/grid/" + i59, schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/required", keyword: "required", params: { missingProperty: "owner" }, message: "must have required property 'owner'" };
              if (vErrors === null) {
                vErrors = [err1453];
              } else {
                vErrors.push(err1453);
              }
              errors++;
            }
            if (data585.answer === void 0) {
              const err1454 = { instancePath: instancePath + "/grid/" + i59, schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/required", keyword: "required", params: { missingProperty: "answer" }, message: "must have required property 'answer'" };
              if (vErrors === null) {
                vErrors = [err1454];
              } else {
                vErrors.push(err1454);
              }
              errors++;
            }
            if (data585.decisions === void 0) {
              const err1455 = { instancePath: instancePath + "/grid/" + i59, schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/required", keyword: "required", params: { missingProperty: "decisions" }, message: "must have required property 'decisions'" };
              if (vErrors === null) {
                vErrors = [err1455];
              } else {
                vErrors.push(err1455);
              }
              errors++;
            }
            if (data585.facts === void 0) {
              const err1456 = { instancePath: instancePath + "/grid/" + i59, schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/required", keyword: "required", params: { missingProperty: "facts" }, message: "must have required property 'facts'" };
              if (vErrors === null) {
                vErrors = [err1456];
              } else {
                vErrors.push(err1456);
              }
              errors++;
            }
            if (data585.counts === void 0) {
              const err1457 = { instancePath: instancePath + "/grid/" + i59, schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/required", keyword: "required", params: { missingProperty: "counts" }, message: "must have required property 'counts'" };
              if (vErrors === null) {
                vErrors = [err1457];
              } else {
                vErrors.push(err1457);
              }
              errors++;
            }
            for (const key102 in data585) {
              if (!func6.call(schema37.properties.grid.items.properties, key102)) {
                const err1458 = { instancePath: instancePath + "/grid/" + i59, schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key102 }, message: "must NOT have additional properties" };
                if (vErrors === null) {
                  vErrors = [err1458];
                } else {
                  vErrors.push(err1458);
                }
                errors++;
              }
            }
            if (data585.place !== void 0) {
              if (typeof data585.place !== "string") {
                const err1459 = { instancePath: instancePath + "/grid/" + i59 + "/place", schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/properties/place/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err1459];
                } else {
                  vErrors.push(err1459);
                }
                errors++;
              }
            }
            if (data585.stage !== void 0) {
              let data587 = data585.stage;
              if (typeof data587 !== "string") {
                const err1460 = { instancePath: instancePath + "/grid/" + i59 + "/stage", schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/properties/stage/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err1460];
                } else {
                  vErrors.push(err1460);
                }
                errors++;
              }
              if (!(data587 === "kostentraeger" || data587 === "befund" || data587 === "regelversorgung" || data587 === "planung" || data587 === "versorgungsform" || data587 === "positionen")) {
                const err1461 = { instancePath: instancePath + "/grid/" + i59 + "/stage", schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/properties/stage/enum", keyword: "enum", params: { allowedValues: schema37.properties.grid.items.properties.stage.enum }, message: "must be equal to one of the allowed values" };
                if (vErrors === null) {
                  vErrors = [err1461];
                } else {
                  vErrors.push(err1461);
                }
                errors++;
              }
            }
            if (data585.state !== void 0) {
              let data588 = data585.state;
              if (typeof data588 !== "string") {
                const err1462 = { instancePath: instancePath + "/grid/" + i59 + "/state", schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/properties/state/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err1462];
                } else {
                  vErrors.push(err1462);
                }
                errors++;
              }
              if (!(data588 === "decided" || data588 === "assumed" || data588 === "open" || data588 === "waiting" || data588 === "notApplicable" || data588 === "superseded")) {
                const err1463 = { instancePath: instancePath + "/grid/" + i59 + "/state", schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/properties/state/enum", keyword: "enum", params: { allowedValues: schema37.properties.grid.items.properties.state.enum }, message: "must be equal to one of the allowed values" };
                if (vErrors === null) {
                  vErrors = [err1463];
                } else {
                  vErrors.push(err1463);
                }
                errors++;
              }
            }
            if (data585.owner !== void 0) {
              let data589 = data585.owner;
              if (typeof data589 !== "string") {
                const err1464 = { instancePath: instancePath + "/grid/" + i59 + "/owner", schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/properties/owner/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err1464];
                } else {
                  vErrors.push(err1464);
                }
                errors++;
              }
              if (!(data589 === "rule" || data589 === "dentist" || data589 === "patient" || data589 === "assumed")) {
                const err1465 = { instancePath: instancePath + "/grid/" + i59 + "/owner", schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/properties/owner/enum", keyword: "enum", params: { allowedValues: schema37.properties.grid.items.properties.owner.enum }, message: "must be equal to one of the allowed values" };
                if (vErrors === null) {
                  vErrors = [err1465];
                } else {
                  vErrors.push(err1465);
                }
                errors++;
              }
            }
            if (data585.answer !== void 0) {
              if (typeof data585.answer !== "string") {
                const err1466 = { instancePath: instancePath + "/grid/" + i59 + "/answer", schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/properties/answer/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err1466];
                } else {
                  vErrors.push(err1466);
                }
                errors++;
              }
            }
            if (data585.decisions !== void 0) {
              let data591 = data585.decisions;
              if (Array.isArray(data591)) {
                const len60 = data591.length;
                for (let i60 = 0; i60 < len60; i60++) {
                  let data592 = data591[i60];
                  if (data592 && typeof data592 == "object" && !Array.isArray(data592)) {
                    if (data592.rule === void 0) {
                      const err1467 = { instancePath: instancePath + "/grid/" + i59 + "/decisions/" + i60, schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/properties/decisions/items/required", keyword: "required", params: { missingProperty: "rule" }, message: "must have required property 'rule'" };
                      if (vErrors === null) {
                        vErrors = [err1467];
                      } else {
                        vErrors.push(err1467);
                      }
                      errors++;
                    }
                    if (data592.at === void 0) {
                      const err1468 = { instancePath: instancePath + "/grid/" + i59 + "/decisions/" + i60, schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/properties/decisions/items/required", keyword: "required", params: { missingProperty: "at" }, message: "must have required property 'at'" };
                      if (vErrors === null) {
                        vErrors = [err1468];
                      } else {
                        vErrors.push(err1468);
                      }
                      errors++;
                    }
                    for (const key103 in data592) {
                      if (!(key103 === "rule" || key103 === "at")) {
                        const err1469 = { instancePath: instancePath + "/grid/" + i59 + "/decisions/" + i60, schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/properties/decisions/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key103 }, message: "must NOT have additional properties" };
                        if (vErrors === null) {
                          vErrors = [err1469];
                        } else {
                          vErrors.push(err1469);
                        }
                        errors++;
                      }
                    }
                    if (data592.rule !== void 0) {
                      if (typeof data592.rule !== "string") {
                        const err1470 = { instancePath: instancePath + "/grid/" + i59 + "/decisions/" + i60 + "/rule", schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/properties/decisions/items/properties/rule/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err1470];
                        } else {
                          vErrors.push(err1470);
                        }
                        errors++;
                      }
                    }
                    if (data592.at !== void 0) {
                      if (typeof data592.at !== "string") {
                        const err1471 = { instancePath: instancePath + "/grid/" + i59 + "/decisions/" + i60 + "/at", schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/properties/decisions/items/properties/at/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err1471];
                        } else {
                          vErrors.push(err1471);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err1472 = { instancePath: instancePath + "/grid/" + i59 + "/decisions/" + i60, schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/properties/decisions/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                    if (vErrors === null) {
                      vErrors = [err1472];
                    } else {
                      vErrors.push(err1472);
                    }
                    errors++;
                  }
                }
              } else {
                const err1473 = { instancePath: instancePath + "/grid/" + i59 + "/decisions", schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/properties/decisions/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                if (vErrors === null) {
                  vErrors = [err1473];
                } else {
                  vErrors.push(err1473);
                }
                errors++;
              }
            }
            if (data585.facts !== void 0) {
              let data595 = data585.facts;
              if (Array.isArray(data595)) {
                const len61 = data595.length;
                for (let i61 = 0; i61 < len61; i61++) {
                  let data596 = data595[i61];
                  if (data596 && typeof data596 == "object" && !Array.isArray(data596)) {
                    if (data596.fact === void 0) {
                      const err1474 = { instancePath: instancePath + "/grid/" + i59 + "/facts/" + i61, schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/properties/facts/items/required", keyword: "required", params: { missingProperty: "fact" }, message: "must have required property 'fact'" };
                      if (vErrors === null) {
                        vErrors = [err1474];
                      } else {
                        vErrors.push(err1474);
                      }
                      errors++;
                    }
                    if (data596.value === void 0) {
                      const err1475 = { instancePath: instancePath + "/grid/" + i59 + "/facts/" + i61, schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/properties/facts/items/required", keyword: "required", params: { missingProperty: "value" }, message: "must have required property 'value'" };
                      if (vErrors === null) {
                        vErrors = [err1475];
                      } else {
                        vErrors.push(err1475);
                      }
                      errors++;
                    }
                    if (data596.statedIn === void 0) {
                      const err1476 = { instancePath: instancePath + "/grid/" + i59 + "/facts/" + i61, schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/properties/facts/items/required", keyword: "required", params: { missingProperty: "statedIn" }, message: "must have required property 'statedIn'" };
                      if (vErrors === null) {
                        vErrors = [err1476];
                      } else {
                        vErrors.push(err1476);
                      }
                      errors++;
                    }
                    if (data596.owner === void 0) {
                      const err1477 = { instancePath: instancePath + "/grid/" + i59 + "/facts/" + i61, schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/properties/facts/items/required", keyword: "required", params: { missingProperty: "owner" }, message: "must have required property 'owner'" };
                      if (vErrors === null) {
                        vErrors = [err1477];
                      } else {
                        vErrors.push(err1477);
                      }
                      errors++;
                    }
                    for (const key104 in data596) {
                      if (!(key104 === "fdi" || key104 === "jaw" || key104 === "fact" || key104 === "value" || key104 === "statedIn" || key104 === "owner")) {
                        const err1478 = { instancePath: instancePath + "/grid/" + i59 + "/facts/" + i61, schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/properties/facts/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key104 }, message: "must NOT have additional properties" };
                        if (vErrors === null) {
                          vErrors = [err1478];
                        } else {
                          vErrors.push(err1478);
                        }
                        errors++;
                      }
                    }
                    if (data596.fdi !== void 0) {
                      let data597 = data596.fdi;
                      if (!(typeof data597 == "number" && (!(data597 % 1) && !isNaN(data597)) && isFinite(data597))) {
                        const err1479 = { instancePath: instancePath + "/grid/" + i59 + "/facts/" + i61 + "/fdi", schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/properties/facts/items/properties/fdi/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                        if (vErrors === null) {
                          vErrors = [err1479];
                        } else {
                          vErrors.push(err1479);
                        }
                        errors++;
                      }
                      if (typeof data597 == "number" && isFinite(data597)) {
                        if (data597 > 9007199254740991 || isNaN(data597)) {
                          const err1480 = { instancePath: instancePath + "/grid/" + i59 + "/facts/" + i61 + "/fdi", schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/properties/facts/items/properties/fdi/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                          if (vErrors === null) {
                            vErrors = [err1480];
                          } else {
                            vErrors.push(err1480);
                          }
                          errors++;
                        }
                        if (data597 < -9007199254740991 || isNaN(data597)) {
                          const err1481 = { instancePath: instancePath + "/grid/" + i59 + "/facts/" + i61 + "/fdi", schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/properties/facts/items/properties/fdi/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                          if (vErrors === null) {
                            vErrors = [err1481];
                          } else {
                            vErrors.push(err1481);
                          }
                          errors++;
                        }
                      }
                    }
                    if (data596.jaw !== void 0) {
                      let data598 = data596.jaw;
                      if (typeof data598 !== "string") {
                        const err1482 = { instancePath: instancePath + "/grid/" + i59 + "/facts/" + i61 + "/jaw", schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/properties/facts/items/properties/jaw/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err1482];
                        } else {
                          vErrors.push(err1482);
                        }
                        errors++;
                      }
                      if (!(data598 === "OK" || data598 === "UK")) {
                        const err1483 = { instancePath: instancePath + "/grid/" + i59 + "/facts/" + i61 + "/jaw", schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/properties/facts/items/properties/jaw/enum", keyword: "enum", params: { allowedValues: schema37.properties.grid.items.properties.facts.items.properties.jaw.enum }, message: "must be equal to one of the allowed values" };
                        if (vErrors === null) {
                          vErrors = [err1483];
                        } else {
                          vErrors.push(err1483);
                        }
                        errors++;
                      }
                    }
                    if (data596.fact !== void 0) {
                      let data599 = data596.fact;
                      if (typeof data599 !== "string") {
                        const err1484 = { instancePath: instancePath + "/grid/" + i59 + "/facts/" + i61 + "/fact", schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/properties/facts/items/properties/fact/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err1484];
                        } else {
                          vErrors.push(err1484);
                        }
                        errors++;
                      }
                      if (!(data599 === "fehlt" || data599 === "erhaltungswuerdig" || data599 === "krone" || data599 === "endodontisch_behandelt" || data599 === "stiftaufbau" || data599 === "brueckenanker" || data599 === "disparallel" || data599 === "wiederherstellung" || data599 === "geplant" || data599 === "lueckensituation_i")) {
                        const err1485 = { instancePath: instancePath + "/grid/" + i59 + "/facts/" + i61 + "/fact", schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/properties/facts/items/properties/fact/enum", keyword: "enum", params: { allowedValues: schema37.properties.grid.items.properties.facts.items.properties.fact.enum }, message: "must be equal to one of the allowed values" };
                        if (vErrors === null) {
                          vErrors = [err1485];
                        } else {
                          vErrors.push(err1485);
                        }
                        errors++;
                      }
                    }
                    if (data596.value !== void 0) {
                      let data600 = data596.value;
                      const _errs1336 = errors;
                      let valid237 = false;
                      const _errs1337 = errors;
                      if (typeof data600 !== "boolean") {
                        const err1486 = { instancePath: instancePath + "/grid/" + i59 + "/facts/" + i61 + "/value", schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/properties/facts/items/properties/value/anyOf/0/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                        if (vErrors === null) {
                          vErrors = [err1486];
                        } else {
                          vErrors.push(err1486);
                        }
                        errors++;
                      }
                      var _valid7 = _errs1337 === errors;
                      valid237 = valid237 || _valid7;
                      if (!valid237) {
                        const _errs1339 = errors;
                        if (typeof data600 !== "string") {
                          const err1487 = { instancePath: instancePath + "/grid/" + i59 + "/facts/" + i61 + "/value", schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/properties/facts/items/properties/value/anyOf/1/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                          if (vErrors === null) {
                            vErrors = [err1487];
                          } else {
                            vErrors.push(err1487);
                          }
                          errors++;
                        }
                        var _valid7 = _errs1339 === errors;
                        valid237 = valid237 || _valid7;
                      }
                      if (!valid237) {
                        const err1488 = { instancePath: instancePath + "/grid/" + i59 + "/facts/" + i61 + "/value", schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/properties/facts/items/properties/value/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                        if (vErrors === null) {
                          vErrors = [err1488];
                        } else {
                          vErrors.push(err1488);
                        }
                        errors++;
                      } else {
                        errors = _errs1336;
                        if (vErrors !== null) {
                          if (_errs1336) {
                            vErrors.length = _errs1336;
                          } else {
                            vErrors = null;
                          }
                        }
                      }
                    }
                    if (data596.statedIn !== void 0) {
                      if (typeof data596.statedIn !== "string") {
                        const err1489 = { instancePath: instancePath + "/grid/" + i59 + "/facts/" + i61 + "/statedIn", schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/properties/facts/items/properties/statedIn/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err1489];
                        } else {
                          vErrors.push(err1489);
                        }
                        errors++;
                      }
                    }
                    if (data596.owner !== void 0) {
                      let data602 = data596.owner;
                      if (typeof data602 !== "string") {
                        const err1490 = { instancePath: instancePath + "/grid/" + i59 + "/facts/" + i61 + "/owner", schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/properties/facts/items/properties/owner/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err1490];
                        } else {
                          vErrors.push(err1490);
                        }
                        errors++;
                      }
                      if (!(data602 === "dentist" || data602 === "patient")) {
                        const err1491 = { instancePath: instancePath + "/grid/" + i59 + "/facts/" + i61 + "/owner", schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/properties/facts/items/properties/owner/enum", keyword: "enum", params: { allowedValues: schema37.properties.grid.items.properties.facts.items.properties.owner.enum }, message: "must be equal to one of the allowed values" };
                        if (vErrors === null) {
                          vErrors = [err1491];
                        } else {
                          vErrors.push(err1491);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err1492 = { instancePath: instancePath + "/grid/" + i59 + "/facts/" + i61, schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/properties/facts/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                    if (vErrors === null) {
                      vErrors = [err1492];
                    } else {
                      vErrors.push(err1492);
                    }
                    errors++;
                  }
                }
              } else {
                const err1493 = { instancePath: instancePath + "/grid/" + i59 + "/facts", schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/properties/facts/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                if (vErrors === null) {
                  vErrors = [err1493];
                } else {
                  vErrors.push(err1493);
                }
                errors++;
              }
            }
            if (data585.counts !== void 0) {
              let data603 = data585.counts;
              if (Array.isArray(data603)) {
                const len62 = data603.length;
                for (let i62 = 0; i62 < len62; i62++) {
                  let data604 = data603[i62];
                  if (data604 && typeof data604 == "object" && !Array.isArray(data604)) {
                    if (data604.nr === void 0) {
                      const err1494 = { instancePath: instancePath + "/grid/" + i59 + "/counts/" + i62, schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/properties/counts/items/required", keyword: "required", params: { missingProperty: "nr" }, message: "must have required property 'nr'" };
                      if (vErrors === null) {
                        vErrors = [err1494];
                      } else {
                        vErrors.push(err1494);
                      }
                      errors++;
                    }
                    if (data604.value === void 0) {
                      const err1495 = { instancePath: instancePath + "/grid/" + i59 + "/counts/" + i62, schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/properties/counts/items/required", keyword: "required", params: { missingProperty: "value" }, message: "must have required property 'value'" };
                      if (vErrors === null) {
                        vErrors = [err1495];
                      } else {
                        vErrors.push(err1495);
                      }
                      errors++;
                    }
                    if (data604.statedIn === void 0) {
                      const err1496 = { instancePath: instancePath + "/grid/" + i59 + "/counts/" + i62, schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/properties/counts/items/required", keyword: "required", params: { missingProperty: "statedIn" }, message: "must have required property 'statedIn'" };
                      if (vErrors === null) {
                        vErrors = [err1496];
                      } else {
                        vErrors.push(err1496);
                      }
                      errors++;
                    }
                    for (const key105 in data604) {
                      if (!(key105 === "nr" || key105 === "value" || key105 === "statedIn")) {
                        const err1497 = { instancePath: instancePath + "/grid/" + i59 + "/counts/" + i62, schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/properties/counts/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key105 }, message: "must NOT have additional properties" };
                        if (vErrors === null) {
                          vErrors = [err1497];
                        } else {
                          vErrors.push(err1497);
                        }
                        errors++;
                      }
                    }
                    if (data604.nr !== void 0) {
                      if (typeof data604.nr !== "string") {
                        const err1498 = { instancePath: instancePath + "/grid/" + i59 + "/counts/" + i62 + "/nr", schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/properties/counts/items/properties/nr/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err1498];
                        } else {
                          vErrors.push(err1498);
                        }
                        errors++;
                      }
                    }
                    if (data604.value !== void 0) {
                      let data606 = data604.value;
                      if (!(typeof data606 == "number" && (!(data606 % 1) && !isNaN(data606)) && isFinite(data606))) {
                        const err1499 = { instancePath: instancePath + "/grid/" + i59 + "/counts/" + i62 + "/value", schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/properties/counts/items/properties/value/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                        if (vErrors === null) {
                          vErrors = [err1499];
                        } else {
                          vErrors.push(err1499);
                        }
                        errors++;
                      }
                      if (typeof data606 == "number" && isFinite(data606)) {
                        if (data606 > 9007199254740991 || isNaN(data606)) {
                          const err1500 = { instancePath: instancePath + "/grid/" + i59 + "/counts/" + i62 + "/value", schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/properties/counts/items/properties/value/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                          if (vErrors === null) {
                            vErrors = [err1500];
                          } else {
                            vErrors.push(err1500);
                          }
                          errors++;
                        }
                        if (data606 < -9007199254740991 || isNaN(data606)) {
                          const err1501 = { instancePath: instancePath + "/grid/" + i59 + "/counts/" + i62 + "/value", schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/properties/counts/items/properties/value/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                          if (vErrors === null) {
                            vErrors = [err1501];
                          } else {
                            vErrors.push(err1501);
                          }
                          errors++;
                        }
                      }
                    }
                    if (data604.statedIn !== void 0) {
                      if (typeof data604.statedIn !== "string") {
                        const err1502 = { instancePath: instancePath + "/grid/" + i59 + "/counts/" + i62 + "/statedIn", schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/properties/counts/items/properties/statedIn/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err1502];
                        } else {
                          vErrors.push(err1502);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err1503 = { instancePath: instancePath + "/grid/" + i59 + "/counts/" + i62, schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/properties/counts/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                    if (vErrors === null) {
                      vErrors = [err1503];
                    } else {
                      vErrors.push(err1503);
                    }
                    errors++;
                  }
                }
              } else {
                const err1504 = { instancePath: instancePath + "/grid/" + i59 + "/counts", schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/properties/counts/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                if (vErrors === null) {
                  vErrors = [err1504];
                } else {
                  vErrors.push(err1504);
                }
                errors++;
              }
            }
            if (data585.proposed !== void 0) {
              let data608 = data585.proposed;
              if (data608 && typeof data608 == "object" && !Array.isArray(data608)) {
                if (data608.state === void 0) {
                  const err1505 = { instancePath: instancePath + "/grid/" + i59 + "/proposed", schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/properties/proposed/required", keyword: "required", params: { missingProperty: "state" }, message: "must have required property 'state'" };
                  if (vErrors === null) {
                    vErrors = [err1505];
                  } else {
                    vErrors.push(err1505);
                  }
                  errors++;
                }
                if (data608.answer === void 0) {
                  const err1506 = { instancePath: instancePath + "/grid/" + i59 + "/proposed", schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/properties/proposed/required", keyword: "required", params: { missingProperty: "answer" }, message: "must have required property 'answer'" };
                  if (vErrors === null) {
                    vErrors = [err1506];
                  } else {
                    vErrors.push(err1506);
                  }
                  errors++;
                }
                if (data608.decisions === void 0) {
                  const err1507 = { instancePath: instancePath + "/grid/" + i59 + "/proposed", schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/properties/proposed/required", keyword: "required", params: { missingProperty: "decisions" }, message: "must have required property 'decisions'" };
                  if (vErrors === null) {
                    vErrors = [err1507];
                  } else {
                    vErrors.push(err1507);
                  }
                  errors++;
                }
                for (const key106 in data608) {
                  if (!(key106 === "state" || key106 === "answer" || key106 === "decisions")) {
                    const err1508 = { instancePath: instancePath + "/grid/" + i59 + "/proposed", schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/properties/proposed/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key106 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                      vErrors = [err1508];
                    } else {
                      vErrors.push(err1508);
                    }
                    errors++;
                  }
                }
                if (data608.state !== void 0) {
                  let data609 = data608.state;
                  if (typeof data609 !== "string") {
                    const err1509 = { instancePath: instancePath + "/grid/" + i59 + "/proposed/state", schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/properties/proposed/properties/state/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err1509];
                    } else {
                      vErrors.push(err1509);
                    }
                    errors++;
                  }
                  if (!(data609 === "decided" || data609 === "assumed" || data609 === "open" || data609 === "waiting" || data609 === "notApplicable" || data609 === "superseded")) {
                    const err1510 = { instancePath: instancePath + "/grid/" + i59 + "/proposed/state", schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/properties/proposed/properties/state/enum", keyword: "enum", params: { allowedValues: schema37.properties.grid.items.properties.proposed.properties.state.enum }, message: "must be equal to one of the allowed values" };
                    if (vErrors === null) {
                      vErrors = [err1510];
                    } else {
                      vErrors.push(err1510);
                    }
                    errors++;
                  }
                }
                if (data608.answer !== void 0) {
                  if (typeof data608.answer !== "string") {
                    const err1511 = { instancePath: instancePath + "/grid/" + i59 + "/proposed/answer", schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/properties/proposed/properties/answer/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err1511];
                    } else {
                      vErrors.push(err1511);
                    }
                    errors++;
                  }
                }
                if (data608.decisions !== void 0) {
                  let data611 = data608.decisions;
                  if (Array.isArray(data611)) {
                    const len63 = data611.length;
                    for (let i63 = 0; i63 < len63; i63++) {
                      let data612 = data611[i63];
                      if (data612 && typeof data612 == "object" && !Array.isArray(data612)) {
                        if (data612.rule === void 0) {
                          const err1512 = { instancePath: instancePath + "/grid/" + i59 + "/proposed/decisions/" + i63, schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/properties/proposed/properties/decisions/items/required", keyword: "required", params: { missingProperty: "rule" }, message: "must have required property 'rule'" };
                          if (vErrors === null) {
                            vErrors = [err1512];
                          } else {
                            vErrors.push(err1512);
                          }
                          errors++;
                        }
                        if (data612.at === void 0) {
                          const err1513 = { instancePath: instancePath + "/grid/" + i59 + "/proposed/decisions/" + i63, schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/properties/proposed/properties/decisions/items/required", keyword: "required", params: { missingProperty: "at" }, message: "must have required property 'at'" };
                          if (vErrors === null) {
                            vErrors = [err1513];
                          } else {
                            vErrors.push(err1513);
                          }
                          errors++;
                        }
                        for (const key107 in data612) {
                          if (!(key107 === "rule" || key107 === "at")) {
                            const err1514 = { instancePath: instancePath + "/grid/" + i59 + "/proposed/decisions/" + i63, schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/properties/proposed/properties/decisions/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key107 }, message: "must NOT have additional properties" };
                            if (vErrors === null) {
                              vErrors = [err1514];
                            } else {
                              vErrors.push(err1514);
                            }
                            errors++;
                          }
                        }
                        if (data612.rule !== void 0) {
                          if (typeof data612.rule !== "string") {
                            const err1515 = { instancePath: instancePath + "/grid/" + i59 + "/proposed/decisions/" + i63 + "/rule", schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/properties/proposed/properties/decisions/items/properties/rule/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err1515];
                            } else {
                              vErrors.push(err1515);
                            }
                            errors++;
                          }
                        }
                        if (data612.at !== void 0) {
                          if (typeof data612.at !== "string") {
                            const err1516 = { instancePath: instancePath + "/grid/" + i59 + "/proposed/decisions/" + i63 + "/at", schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/properties/proposed/properties/decisions/items/properties/at/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err1516];
                            } else {
                              vErrors.push(err1516);
                            }
                            errors++;
                          }
                        }
                      } else {
                        const err1517 = { instancePath: instancePath + "/grid/" + i59 + "/proposed/decisions/" + i63, schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/properties/proposed/properties/decisions/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                        if (vErrors === null) {
                          vErrors = [err1517];
                        } else {
                          vErrors.push(err1517);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err1518 = { instancePath: instancePath + "/grid/" + i59 + "/proposed/decisions", schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/properties/proposed/properties/decisions/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                      vErrors = [err1518];
                    } else {
                      vErrors.push(err1518);
                    }
                    errors++;
                  }
                }
              } else {
                const err1519 = { instancePath: instancePath + "/grid/" + i59 + "/proposed", schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/properties/proposed/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                if (vErrors === null) {
                  vErrors = [err1519];
                } else {
                  vErrors.push(err1519);
                }
                errors++;
              }
            }
          } else {
            const err1520 = { instancePath: instancePath + "/grid/" + i59, schemaPath: "#/definitions/VerificationEvaluation/properties/grid/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
              vErrors = [err1520];
            } else {
              vErrors.push(err1520);
            }
            errors++;
          }
        }
      } else {
        const err1521 = { instancePath: instancePath + "/grid", schemaPath: "#/definitions/VerificationEvaluation/properties/grid/type", keyword: "type", params: { type: "array" }, message: "must be array" };
        if (vErrors === null) {
          vErrors = [err1521];
        } else {
          vErrors.push(err1521);
        }
        errors++;
      }
    }
    if (data.questions !== void 0) {
      let data615 = data.questions;
      if (Array.isArray(data615)) {
        const len64 = data615.length;
        for (let i64 = 0; i64 < len64; i64++) {
          let data616 = data615[i64];
          if (data616 && typeof data616 == "object" && !Array.isArray(data616)) {
            if (data616.fact === void 0) {
              const err1522 = { instancePath: instancePath + "/questions/" + i64, schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/required", keyword: "required", params: { missingProperty: "fact" }, message: "must have required property 'fact'" };
              if (vErrors === null) {
                vErrors = [err1522];
              } else {
                vErrors.push(err1522);
              }
              errors++;
            }
            if (data616.description === void 0) {
              const err1523 = { instancePath: instancePath + "/questions/" + i64, schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/required", keyword: "required", params: { missingProperty: "description" }, message: "must have required property 'description'" };
              if (vErrors === null) {
                vErrors = [err1523];
              } else {
                vErrors.push(err1523);
              }
              errors++;
            }
            if (data616.openAfterProposals === void 0) {
              const err1524 = { instancePath: instancePath + "/questions/" + i64, schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/required", keyword: "required", params: { missingProperty: "openAfterProposals" }, message: "must have required property 'openAfterProposals'" };
              if (vErrors === null) {
                vErrors = [err1524];
              } else {
                vErrors.push(err1524);
              }
              errors++;
            }
            if (data616.rules === void 0) {
              const err1525 = { instancePath: instancePath + "/questions/" + i64, schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/required", keyword: "required", params: { missingProperty: "rules" }, message: "must have required property 'rules'" };
              if (vErrors === null) {
                vErrors = [err1525];
              } else {
                vErrors.push(err1525);
              }
              errors++;
            }
            if (data616.answers === void 0) {
              const err1526 = { instancePath: instancePath + "/questions/" + i64, schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/required", keyword: "required", params: { missingProperty: "answers" }, message: "must have required property 'answers'" };
              if (vErrors === null) {
                vErrors = [err1526];
              } else {
                vErrors.push(err1526);
              }
              errors++;
            }
            for (const key108 in data616) {
              if (!(key108 === "fdi" || key108 === "jaw" || key108 === "fact" || key108 === "description" || key108 === "proposed" || key108 === "openAfterProposals" || key108 === "rules" || key108 === "answers")) {
                const err1527 = { instancePath: instancePath + "/questions/" + i64, schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key108 }, message: "must NOT have additional properties" };
                if (vErrors === null) {
                  vErrors = [err1527];
                } else {
                  vErrors.push(err1527);
                }
                errors++;
              }
            }
            if (data616.fdi !== void 0) {
              let data617 = data616.fdi;
              if (!(typeof data617 == "number" && (!(data617 % 1) && !isNaN(data617)) && isFinite(data617))) {
                const err1528 = { instancePath: instancePath + "/questions/" + i64 + "/fdi", schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/properties/fdi/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                if (vErrors === null) {
                  vErrors = [err1528];
                } else {
                  vErrors.push(err1528);
                }
                errors++;
              }
              if (typeof data617 == "number" && isFinite(data617)) {
                if (data617 > 9007199254740991 || isNaN(data617)) {
                  const err1529 = { instancePath: instancePath + "/questions/" + i64 + "/fdi", schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/properties/fdi/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err1529];
                  } else {
                    vErrors.push(err1529);
                  }
                  errors++;
                }
                if (data617 < -9007199254740991 || isNaN(data617)) {
                  const err1530 = { instancePath: instancePath + "/questions/" + i64 + "/fdi", schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/properties/fdi/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err1530];
                  } else {
                    vErrors.push(err1530);
                  }
                  errors++;
                }
              }
            }
            if (data616.jaw !== void 0) {
              let data618 = data616.jaw;
              if (typeof data618 !== "string") {
                const err1531 = { instancePath: instancePath + "/questions/" + i64 + "/jaw", schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/properties/jaw/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err1531];
                } else {
                  vErrors.push(err1531);
                }
                errors++;
              }
              if (!(data618 === "OK" || data618 === "UK")) {
                const err1532 = { instancePath: instancePath + "/questions/" + i64 + "/jaw", schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/properties/jaw/enum", keyword: "enum", params: { allowedValues: schema37.properties.questions.items.properties.jaw.enum }, message: "must be equal to one of the allowed values" };
                if (vErrors === null) {
                  vErrors = [err1532];
                } else {
                  vErrors.push(err1532);
                }
                errors++;
              }
            }
            if (data616.fact !== void 0) {
              let data619 = data616.fact;
              if (typeof data619 !== "string") {
                const err1533 = { instancePath: instancePath + "/questions/" + i64 + "/fact", schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/properties/fact/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err1533];
                } else {
                  vErrors.push(err1533);
                }
                errors++;
              }
              if (!(data619 === "fehlt" || data619 === "erhaltungswuerdig" || data619 === "krone" || data619 === "endodontisch_behandelt" || data619 === "stiftaufbau" || data619 === "brueckenanker" || data619 === "disparallel" || data619 === "wiederherstellung" || data619 === "geplant" || data619 === "lueckensituation_i")) {
                const err1534 = { instancePath: instancePath + "/questions/" + i64 + "/fact", schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/properties/fact/enum", keyword: "enum", params: { allowedValues: schema37.properties.questions.items.properties.fact.enum }, message: "must be equal to one of the allowed values" };
                if (vErrors === null) {
                  vErrors = [err1534];
                } else {
                  vErrors.push(err1534);
                }
                errors++;
              }
            }
            if (data616.description !== void 0) {
              if (typeof data616.description !== "string") {
                const err1535 = { instancePath: instancePath + "/questions/" + i64 + "/description", schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/properties/description/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err1535];
                } else {
                  vErrors.push(err1535);
                }
                errors++;
              }
            }
            if (data616.proposed !== void 0) {
              let data621 = data616.proposed;
              const _errs1386 = errors;
              let valid248 = false;
              const _errs1387 = errors;
              if (typeof data621 !== "boolean") {
                const err1536 = { instancePath: instancePath + "/questions/" + i64 + "/proposed", schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/properties/proposed/anyOf/0/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                if (vErrors === null) {
                  vErrors = [err1536];
                } else {
                  vErrors.push(err1536);
                }
                errors++;
              }
              var _valid8 = _errs1387 === errors;
              valid248 = valid248 || _valid8;
              if (!valid248) {
                const _errs1389 = errors;
                if (typeof data621 !== "string") {
                  const err1537 = { instancePath: instancePath + "/questions/" + i64 + "/proposed", schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/properties/proposed/anyOf/1/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                  if (vErrors === null) {
                    vErrors = [err1537];
                  } else {
                    vErrors.push(err1537);
                  }
                  errors++;
                }
                var _valid8 = _errs1389 === errors;
                valid248 = valid248 || _valid8;
              }
              if (!valid248) {
                const err1538 = { instancePath: instancePath + "/questions/" + i64 + "/proposed", schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/properties/proposed/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                if (vErrors === null) {
                  vErrors = [err1538];
                } else {
                  vErrors.push(err1538);
                }
                errors++;
              } else {
                errors = _errs1386;
                if (vErrors !== null) {
                  if (_errs1386) {
                    vErrors.length = _errs1386;
                  } else {
                    vErrors = null;
                  }
                }
              }
            }
            if (data616.openAfterProposals !== void 0) {
              if (typeof data616.openAfterProposals !== "boolean") {
                const err1539 = { instancePath: instancePath + "/questions/" + i64 + "/openAfterProposals", schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/properties/openAfterProposals/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                if (vErrors === null) {
                  vErrors = [err1539];
                } else {
                  vErrors.push(err1539);
                }
                errors++;
              }
            }
            if (data616.rules !== void 0) {
              let data623 = data616.rules;
              if (Array.isArray(data623)) {
                const len65 = data623.length;
                for (let i65 = 0; i65 < len65; i65++) {
                  if (typeof data623[i65] !== "string") {
                    const err1540 = { instancePath: instancePath + "/questions/" + i64 + "/rules/" + i65, schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/properties/rules/items/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err1540];
                    } else {
                      vErrors.push(err1540);
                    }
                    errors++;
                  }
                }
              } else {
                const err1541 = { instancePath: instancePath + "/questions/" + i64 + "/rules", schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/properties/rules/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                if (vErrors === null) {
                  vErrors = [err1541];
                } else {
                  vErrors.push(err1541);
                }
                errors++;
              }
            }
            if (data616.answers !== void 0) {
              let data625 = data616.answers;
              if (Array.isArray(data625)) {
                const len66 = data625.length;
                for (let i66 = 0; i66 < len66; i66++) {
                  let data626 = data625[i66];
                  if (data626 && typeof data626 == "object" && !Array.isArray(data626)) {
                    if (data626.value === void 0) {
                      const err1542 = { instancePath: instancePath + "/questions/" + i64 + "/answers/" + i66, schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/properties/answers/items/required", keyword: "required", params: { missingProperty: "value" }, message: "must have required property 'value'" };
                      if (vErrors === null) {
                        vErrors = [err1542];
                      } else {
                        vErrors.push(err1542);
                      }
                      errors++;
                    }
                    if (data626.befunde === void 0) {
                      const err1543 = { instancePath: instancePath + "/questions/" + i64 + "/answers/" + i66, schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/properties/answers/items/required", keyword: "required", params: { missingProperty: "befunde" }, message: "must have required property 'befunde'" };
                      if (vErrors === null) {
                        vErrors = [err1543];
                      } else {
                        vErrors.push(err1543);
                      }
                      errors++;
                    }
                    if (data626.settles === void 0) {
                      const err1544 = { instancePath: instancePath + "/questions/" + i64 + "/answers/" + i66, schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/properties/answers/items/required", keyword: "required", params: { missingProperty: "settles" }, message: "must have required property 'settles'" };
                      if (vErrors === null) {
                        vErrors = [err1544];
                      } else {
                        vErrors.push(err1544);
                      }
                      errors++;
                    }
                    for (const key109 in data626) {
                      if (!(key109 === "value" || key109 === "befunde" || key109 === "settles")) {
                        const err1545 = { instancePath: instancePath + "/questions/" + i64 + "/answers/" + i66, schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/properties/answers/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key109 }, message: "must NOT have additional properties" };
                        if (vErrors === null) {
                          vErrors = [err1545];
                        } else {
                          vErrors.push(err1545);
                        }
                        errors++;
                      }
                    }
                    if (data626.value !== void 0) {
                      let data627 = data626.value;
                      const _errs1403 = errors;
                      let valid254 = false;
                      const _errs1404 = errors;
                      if (typeof data627 !== "boolean") {
                        const err1546 = { instancePath: instancePath + "/questions/" + i64 + "/answers/" + i66 + "/value", schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/properties/answers/items/properties/value/anyOf/0/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                        if (vErrors === null) {
                          vErrors = [err1546];
                        } else {
                          vErrors.push(err1546);
                        }
                        errors++;
                      }
                      var _valid9 = _errs1404 === errors;
                      valid254 = valid254 || _valid9;
                      if (!valid254) {
                        const _errs1406 = errors;
                        if (typeof data627 !== "string") {
                          const err1547 = { instancePath: instancePath + "/questions/" + i64 + "/answers/" + i66 + "/value", schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/properties/answers/items/properties/value/anyOf/1/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                          if (vErrors === null) {
                            vErrors = [err1547];
                          } else {
                            vErrors.push(err1547);
                          }
                          errors++;
                        }
                        var _valid9 = _errs1406 === errors;
                        valid254 = valid254 || _valid9;
                      }
                      if (!valid254) {
                        const err1548 = { instancePath: instancePath + "/questions/" + i64 + "/answers/" + i66 + "/value", schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/properties/answers/items/properties/value/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                        if (vErrors === null) {
                          vErrors = [err1548];
                        } else {
                          vErrors.push(err1548);
                        }
                        errors++;
                      } else {
                        errors = _errs1403;
                        if (vErrors !== null) {
                          if (_errs1403) {
                            vErrors.length = _errs1403;
                          } else {
                            vErrors = null;
                          }
                        }
                      }
                    }
                    if (data626.befunde !== void 0) {
                      let data628 = data626.befunde;
                      if (Array.isArray(data628)) {
                        const len67 = data628.length;
                        for (let i67 = 0; i67 < len67; i67++) {
                          let data629 = data628[i67];
                          if (data629 && typeof data629 == "object" && !Array.isArray(data629)) {
                            if (data629.befund === void 0) {
                              const err1549 = { instancePath: instancePath + "/questions/" + i64 + "/answers/" + i66 + "/befunde/" + i67, schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/properties/answers/items/properties/befunde/items/required", keyword: "required", params: { missingProperty: "befund" }, message: "must have required property 'befund'" };
                              if (vErrors === null) {
                                vErrors = [err1549];
                              } else {
                                vErrors.push(err1549);
                              }
                              errors++;
                            }
                            if (data629.title === void 0) {
                              const err1550 = { instancePath: instancePath + "/questions/" + i64 + "/answers/" + i66 + "/befunde/" + i67, schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/properties/answers/items/properties/befunde/items/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
                              if (vErrors === null) {
                                vErrors = [err1550];
                              } else {
                                vErrors.push(err1550);
                              }
                              errors++;
                            }
                            if (data629.festzuschuss === void 0) {
                              const err1551 = { instancePath: instancePath + "/questions/" + i64 + "/answers/" + i66 + "/befunde/" + i67, schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/properties/answers/items/properties/befunde/items/required", keyword: "required", params: { missingProperty: "festzuschuss" }, message: "must have required property 'festzuschuss'" };
                              if (vErrors === null) {
                                vErrors = [err1551];
                              } else {
                                vErrors.push(err1551);
                              }
                              errors++;
                            }
                            for (const key110 in data629) {
                              if (!(key110 === "befund" || key110 === "title" || key110 === "festzuschuss")) {
                                const err1552 = { instancePath: instancePath + "/questions/" + i64 + "/answers/" + i66 + "/befunde/" + i67, schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/properties/answers/items/properties/befunde/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key110 }, message: "must NOT have additional properties" };
                                if (vErrors === null) {
                                  vErrors = [err1552];
                                } else {
                                  vErrors.push(err1552);
                                }
                                errors++;
                              }
                            }
                            if (data629.befund !== void 0) {
                              if (typeof data629.befund !== "string") {
                                const err1553 = { instancePath: instancePath + "/questions/" + i64 + "/answers/" + i66 + "/befunde/" + i67 + "/befund", schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/properties/answers/items/properties/befunde/items/properties/befund/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err1553];
                                } else {
                                  vErrors.push(err1553);
                                }
                                errors++;
                              }
                            }
                            if (data629.title !== void 0) {
                              if (typeof data629.title !== "string") {
                                const err1554 = { instancePath: instancePath + "/questions/" + i64 + "/answers/" + i66 + "/befunde/" + i67 + "/title", schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/properties/answers/items/properties/befunde/items/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                if (vErrors === null) {
                                  vErrors = [err1554];
                                } else {
                                  vErrors.push(err1554);
                                }
                                errors++;
                              }
                            }
                            if (data629.festzuschuss !== void 0) {
                              let data632 = data629.festzuschuss;
                              if (data632 && typeof data632 == "object" && !Array.isArray(data632)) {
                                if (data632.zahnaerztlich === void 0) {
                                  const err1555 = { instancePath: instancePath + "/questions/" + i64 + "/answers/" + i66 + "/befunde/" + i67 + "/festzuschuss", schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/properties/answers/items/properties/befunde/items/properties/festzuschuss/required", keyword: "required", params: { missingProperty: "zahnaerztlich" }, message: "must have required property 'zahnaerztlich'" };
                                  if (vErrors === null) {
                                    vErrors = [err1555];
                                  } else {
                                    vErrors.push(err1555);
                                  }
                                  errors++;
                                }
                                if (data632.zahntechnisch === void 0) {
                                  const err1556 = { instancePath: instancePath + "/questions/" + i64 + "/answers/" + i66 + "/befunde/" + i67 + "/festzuschuss", schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/properties/answers/items/properties/befunde/items/properties/festzuschuss/required", keyword: "required", params: { missingProperty: "zahntechnisch" }, message: "must have required property 'zahntechnisch'" };
                                  if (vErrors === null) {
                                    vErrors = [err1556];
                                  } else {
                                    vErrors.push(err1556);
                                  }
                                  errors++;
                                }
                                if (data632.prozent60 === void 0) {
                                  const err1557 = { instancePath: instancePath + "/questions/" + i64 + "/answers/" + i66 + "/befunde/" + i67 + "/festzuschuss", schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/properties/answers/items/properties/befunde/items/properties/festzuschuss/required", keyword: "required", params: { missingProperty: "prozent60" }, message: "must have required property 'prozent60'" };
                                  if (vErrors === null) {
                                    vErrors = [err1557];
                                  } else {
                                    vErrors.push(err1557);
                                  }
                                  errors++;
                                }
                                if (data632.prozent70 === void 0) {
                                  const err1558 = { instancePath: instancePath + "/questions/" + i64 + "/answers/" + i66 + "/befunde/" + i67 + "/festzuschuss", schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/properties/answers/items/properties/befunde/items/properties/festzuschuss/required", keyword: "required", params: { missingProperty: "prozent70" }, message: "must have required property 'prozent70'" };
                                  if (vErrors === null) {
                                    vErrors = [err1558];
                                  } else {
                                    vErrors.push(err1558);
                                  }
                                  errors++;
                                }
                                if (data632.prozent75 === void 0) {
                                  const err1559 = { instancePath: instancePath + "/questions/" + i64 + "/answers/" + i66 + "/befunde/" + i67 + "/festzuschuss", schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/properties/answers/items/properties/befunde/items/properties/festzuschuss/required", keyword: "required", params: { missingProperty: "prozent75" }, message: "must have required property 'prozent75'" };
                                  if (vErrors === null) {
                                    vErrors = [err1559];
                                  } else {
                                    vErrors.push(err1559);
                                  }
                                  errors++;
                                }
                                if (data632.prozent100 === void 0) {
                                  const err1560 = { instancePath: instancePath + "/questions/" + i64 + "/answers/" + i66 + "/befunde/" + i67 + "/festzuschuss", schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/properties/answers/items/properties/befunde/items/properties/festzuschuss/required", keyword: "required", params: { missingProperty: "prozent100" }, message: "must have required property 'prozent100'" };
                                  if (vErrors === null) {
                                    vErrors = [err1560];
                                  } else {
                                    vErrors.push(err1560);
                                  }
                                  errors++;
                                }
                                for (const key111 in data632) {
                                  if (!(key111 === "zahnaerztlich" || key111 === "zahntechnisch" || key111 === "prozent60" || key111 === "prozent70" || key111 === "prozent75" || key111 === "prozent100")) {
                                    const err1561 = { instancePath: instancePath + "/questions/" + i64 + "/answers/" + i66 + "/befunde/" + i67 + "/festzuschuss", schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/properties/answers/items/properties/befunde/items/properties/festzuschuss/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key111 }, message: "must NOT have additional properties" };
                                    if (vErrors === null) {
                                      vErrors = [err1561];
                                    } else {
                                      vErrors.push(err1561);
                                    }
                                    errors++;
                                  }
                                }
                                if (data632.zahnaerztlich !== void 0) {
                                  let data633 = data632.zahnaerztlich;
                                  if (!(typeof data633 == "number" && (!(data633 % 1) && !isNaN(data633)) && isFinite(data633))) {
                                    const err1562 = { instancePath: instancePath + "/questions/" + i64 + "/answers/" + i66 + "/befunde/" + i67 + "/festzuschuss/zahnaerztlich", schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/properties/answers/items/properties/befunde/items/properties/festzuschuss/properties/zahnaerztlich/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                    if (vErrors === null) {
                                      vErrors = [err1562];
                                    } else {
                                      vErrors.push(err1562);
                                    }
                                    errors++;
                                  }
                                  if (typeof data633 == "number" && isFinite(data633)) {
                                    if (data633 > 9007199254740991 || isNaN(data633)) {
                                      const err1563 = { instancePath: instancePath + "/questions/" + i64 + "/answers/" + i66 + "/befunde/" + i67 + "/festzuschuss/zahnaerztlich", schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/properties/answers/items/properties/befunde/items/properties/festzuschuss/properties/zahnaerztlich/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                                      if (vErrors === null) {
                                        vErrors = [err1563];
                                      } else {
                                        vErrors.push(err1563);
                                      }
                                      errors++;
                                    }
                                    if (data633 < -9007199254740991 || isNaN(data633)) {
                                      const err1564 = { instancePath: instancePath + "/questions/" + i64 + "/answers/" + i66 + "/befunde/" + i67 + "/festzuschuss/zahnaerztlich", schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/properties/answers/items/properties/befunde/items/properties/festzuschuss/properties/zahnaerztlich/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                                      if (vErrors === null) {
                                        vErrors = [err1564];
                                      } else {
                                        vErrors.push(err1564);
                                      }
                                      errors++;
                                    }
                                  }
                                }
                                if (data632.zahntechnisch !== void 0) {
                                  let data634 = data632.zahntechnisch;
                                  if (!(typeof data634 == "number" && (!(data634 % 1) && !isNaN(data634)) && isFinite(data634))) {
                                    const err1565 = { instancePath: instancePath + "/questions/" + i64 + "/answers/" + i66 + "/befunde/" + i67 + "/festzuschuss/zahntechnisch", schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/properties/answers/items/properties/befunde/items/properties/festzuschuss/properties/zahntechnisch/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                    if (vErrors === null) {
                                      vErrors = [err1565];
                                    } else {
                                      vErrors.push(err1565);
                                    }
                                    errors++;
                                  }
                                  if (typeof data634 == "number" && isFinite(data634)) {
                                    if (data634 > 9007199254740991 || isNaN(data634)) {
                                      const err1566 = { instancePath: instancePath + "/questions/" + i64 + "/answers/" + i66 + "/befunde/" + i67 + "/festzuschuss/zahntechnisch", schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/properties/answers/items/properties/befunde/items/properties/festzuschuss/properties/zahntechnisch/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                                      if (vErrors === null) {
                                        vErrors = [err1566];
                                      } else {
                                        vErrors.push(err1566);
                                      }
                                      errors++;
                                    }
                                    if (data634 < -9007199254740991 || isNaN(data634)) {
                                      const err1567 = { instancePath: instancePath + "/questions/" + i64 + "/answers/" + i66 + "/befunde/" + i67 + "/festzuschuss/zahntechnisch", schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/properties/answers/items/properties/befunde/items/properties/festzuschuss/properties/zahntechnisch/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                                      if (vErrors === null) {
                                        vErrors = [err1567];
                                      } else {
                                        vErrors.push(err1567);
                                      }
                                      errors++;
                                    }
                                  }
                                }
                                if (data632.prozent60 !== void 0) {
                                  let data635 = data632.prozent60;
                                  if (!(typeof data635 == "number" && (!(data635 % 1) && !isNaN(data635)) && isFinite(data635))) {
                                    const err1568 = { instancePath: instancePath + "/questions/" + i64 + "/answers/" + i66 + "/befunde/" + i67 + "/festzuschuss/prozent60", schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/properties/answers/items/properties/befunde/items/properties/festzuschuss/properties/prozent60/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                    if (vErrors === null) {
                                      vErrors = [err1568];
                                    } else {
                                      vErrors.push(err1568);
                                    }
                                    errors++;
                                  }
                                  if (typeof data635 == "number" && isFinite(data635)) {
                                    if (data635 > 9007199254740991 || isNaN(data635)) {
                                      const err1569 = { instancePath: instancePath + "/questions/" + i64 + "/answers/" + i66 + "/befunde/" + i67 + "/festzuschuss/prozent60", schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/properties/answers/items/properties/befunde/items/properties/festzuschuss/properties/prozent60/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                                      if (vErrors === null) {
                                        vErrors = [err1569];
                                      } else {
                                        vErrors.push(err1569);
                                      }
                                      errors++;
                                    }
                                    if (data635 < -9007199254740991 || isNaN(data635)) {
                                      const err1570 = { instancePath: instancePath + "/questions/" + i64 + "/answers/" + i66 + "/befunde/" + i67 + "/festzuschuss/prozent60", schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/properties/answers/items/properties/befunde/items/properties/festzuschuss/properties/prozent60/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                                      if (vErrors === null) {
                                        vErrors = [err1570];
                                      } else {
                                        vErrors.push(err1570);
                                      }
                                      errors++;
                                    }
                                  }
                                }
                                if (data632.prozent70 !== void 0) {
                                  let data636 = data632.prozent70;
                                  if (!(typeof data636 == "number" && (!(data636 % 1) && !isNaN(data636)) && isFinite(data636))) {
                                    const err1571 = { instancePath: instancePath + "/questions/" + i64 + "/answers/" + i66 + "/befunde/" + i67 + "/festzuschuss/prozent70", schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/properties/answers/items/properties/befunde/items/properties/festzuschuss/properties/prozent70/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                    if (vErrors === null) {
                                      vErrors = [err1571];
                                    } else {
                                      vErrors.push(err1571);
                                    }
                                    errors++;
                                  }
                                  if (typeof data636 == "number" && isFinite(data636)) {
                                    if (data636 > 9007199254740991 || isNaN(data636)) {
                                      const err1572 = { instancePath: instancePath + "/questions/" + i64 + "/answers/" + i66 + "/befunde/" + i67 + "/festzuschuss/prozent70", schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/properties/answers/items/properties/befunde/items/properties/festzuschuss/properties/prozent70/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                                      if (vErrors === null) {
                                        vErrors = [err1572];
                                      } else {
                                        vErrors.push(err1572);
                                      }
                                      errors++;
                                    }
                                    if (data636 < -9007199254740991 || isNaN(data636)) {
                                      const err1573 = { instancePath: instancePath + "/questions/" + i64 + "/answers/" + i66 + "/befunde/" + i67 + "/festzuschuss/prozent70", schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/properties/answers/items/properties/befunde/items/properties/festzuschuss/properties/prozent70/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                                      if (vErrors === null) {
                                        vErrors = [err1573];
                                      } else {
                                        vErrors.push(err1573);
                                      }
                                      errors++;
                                    }
                                  }
                                }
                                if (data632.prozent75 !== void 0) {
                                  let data637 = data632.prozent75;
                                  if (!(typeof data637 == "number" && (!(data637 % 1) && !isNaN(data637)) && isFinite(data637))) {
                                    const err1574 = { instancePath: instancePath + "/questions/" + i64 + "/answers/" + i66 + "/befunde/" + i67 + "/festzuschuss/prozent75", schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/properties/answers/items/properties/befunde/items/properties/festzuschuss/properties/prozent75/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                    if (vErrors === null) {
                                      vErrors = [err1574];
                                    } else {
                                      vErrors.push(err1574);
                                    }
                                    errors++;
                                  }
                                  if (typeof data637 == "number" && isFinite(data637)) {
                                    if (data637 > 9007199254740991 || isNaN(data637)) {
                                      const err1575 = { instancePath: instancePath + "/questions/" + i64 + "/answers/" + i66 + "/befunde/" + i67 + "/festzuschuss/prozent75", schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/properties/answers/items/properties/befunde/items/properties/festzuschuss/properties/prozent75/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                                      if (vErrors === null) {
                                        vErrors = [err1575];
                                      } else {
                                        vErrors.push(err1575);
                                      }
                                      errors++;
                                    }
                                    if (data637 < -9007199254740991 || isNaN(data637)) {
                                      const err1576 = { instancePath: instancePath + "/questions/" + i64 + "/answers/" + i66 + "/befunde/" + i67 + "/festzuschuss/prozent75", schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/properties/answers/items/properties/befunde/items/properties/festzuschuss/properties/prozent75/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                                      if (vErrors === null) {
                                        vErrors = [err1576];
                                      } else {
                                        vErrors.push(err1576);
                                      }
                                      errors++;
                                    }
                                  }
                                }
                                if (data632.prozent100 !== void 0) {
                                  let data638 = data632.prozent100;
                                  if (!(typeof data638 == "number" && (!(data638 % 1) && !isNaN(data638)) && isFinite(data638))) {
                                    const err1577 = { instancePath: instancePath + "/questions/" + i64 + "/answers/" + i66 + "/befunde/" + i67 + "/festzuschuss/prozent100", schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/properties/answers/items/properties/befunde/items/properties/festzuschuss/properties/prozent100/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                    if (vErrors === null) {
                                      vErrors = [err1577];
                                    } else {
                                      vErrors.push(err1577);
                                    }
                                    errors++;
                                  }
                                  if (typeof data638 == "number" && isFinite(data638)) {
                                    if (data638 > 9007199254740991 || isNaN(data638)) {
                                      const err1578 = { instancePath: instancePath + "/questions/" + i64 + "/answers/" + i66 + "/befunde/" + i67 + "/festzuschuss/prozent100", schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/properties/answers/items/properties/befunde/items/properties/festzuschuss/properties/prozent100/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                                      if (vErrors === null) {
                                        vErrors = [err1578];
                                      } else {
                                        vErrors.push(err1578);
                                      }
                                      errors++;
                                    }
                                    if (data638 < -9007199254740991 || isNaN(data638)) {
                                      const err1579 = { instancePath: instancePath + "/questions/" + i64 + "/answers/" + i66 + "/befunde/" + i67 + "/festzuschuss/prozent100", schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/properties/answers/items/properties/befunde/items/properties/festzuschuss/properties/prozent100/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                                      if (vErrors === null) {
                                        vErrors = [err1579];
                                      } else {
                                        vErrors.push(err1579);
                                      }
                                      errors++;
                                    }
                                  }
                                }
                              } else {
                                const err1580 = { instancePath: instancePath + "/questions/" + i64 + "/answers/" + i66 + "/befunde/" + i67 + "/festzuschuss", schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/properties/answers/items/properties/befunde/items/properties/festzuschuss/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                                if (vErrors === null) {
                                  vErrors = [err1580];
                                } else {
                                  vErrors.push(err1580);
                                }
                                errors++;
                              }
                            }
                          } else {
                            const err1581 = { instancePath: instancePath + "/questions/" + i64 + "/answers/" + i66 + "/befunde/" + i67, schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/properties/answers/items/properties/befunde/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                            if (vErrors === null) {
                              vErrors = [err1581];
                            } else {
                              vErrors.push(err1581);
                            }
                            errors++;
                          }
                        }
                      } else {
                        const err1582 = { instancePath: instancePath + "/questions/" + i64 + "/answers/" + i66 + "/befunde", schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/properties/answers/items/properties/befunde/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                        if (vErrors === null) {
                          vErrors = [err1582];
                        } else {
                          vErrors.push(err1582);
                        }
                        errors++;
                      }
                    }
                    if (data626.settles !== void 0) {
                      if (typeof data626.settles !== "boolean") {
                        const err1583 = { instancePath: instancePath + "/questions/" + i64 + "/answers/" + i66 + "/settles", schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/properties/answers/items/properties/settles/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                        if (vErrors === null) {
                          vErrors = [err1583];
                        } else {
                          vErrors.push(err1583);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err1584 = { instancePath: instancePath + "/questions/" + i64 + "/answers/" + i66, schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/properties/answers/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                    if (vErrors === null) {
                      vErrors = [err1584];
                    } else {
                      vErrors.push(err1584);
                    }
                    errors++;
                  }
                }
              } else {
                const err1585 = { instancePath: instancePath + "/questions/" + i64 + "/answers", schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/properties/answers/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                if (vErrors === null) {
                  vErrors = [err1585];
                } else {
                  vErrors.push(err1585);
                }
                errors++;
              }
            }
          } else {
            const err1586 = { instancePath: instancePath + "/questions/" + i64, schemaPath: "#/definitions/VerificationEvaluation/properties/questions/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
              vErrors = [err1586];
            } else {
              vErrors.push(err1586);
            }
            errors++;
          }
        }
      } else {
        const err1587 = { instancePath: instancePath + "/questions", schemaPath: "#/definitions/VerificationEvaluation/properties/questions/type", keyword: "type", params: { type: "array" }, message: "must be array" };
        if (vErrors === null) {
          vErrors = [err1587];
        } else {
          vErrors.push(err1587);
        }
        errors++;
      }
    }
    if (data.ask !== void 0) {
      let data640 = data.ask;
      if (Array.isArray(data640)) {
        const len68 = data640.length;
        for (let i68 = 0; i68 < len68; i68++) {
          let data641 = data640[i68];
          if (data641 && typeof data641 == "object" && !Array.isArray(data641)) {
            if (data641.fact === void 0) {
              const err1588 = { instancePath: instancePath + "/ask/" + i68, schemaPath: "#/definitions/VerificationEvaluation/properties/ask/items/required", keyword: "required", params: { missingProperty: "fact" }, message: "must have required property 'fact'" };
              if (vErrors === null) {
                vErrors = [err1588];
              } else {
                vErrors.push(err1588);
              }
              errors++;
            }
            for (const key112 in data641) {
              if (!(key112 === "fdi" || key112 === "jaw" || key112 === "fact")) {
                const err1589 = { instancePath: instancePath + "/ask/" + i68, schemaPath: "#/definitions/VerificationEvaluation/properties/ask/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key112 }, message: "must NOT have additional properties" };
                if (vErrors === null) {
                  vErrors = [err1589];
                } else {
                  vErrors.push(err1589);
                }
                errors++;
              }
            }
            if (data641.fdi !== void 0) {
              let data642 = data641.fdi;
              if (!(typeof data642 == "number" && (!(data642 % 1) && !isNaN(data642)) && isFinite(data642))) {
                const err1590 = { instancePath: instancePath + "/ask/" + i68 + "/fdi", schemaPath: "#/definitions/VerificationEvaluation/properties/ask/items/properties/fdi/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                if (vErrors === null) {
                  vErrors = [err1590];
                } else {
                  vErrors.push(err1590);
                }
                errors++;
              }
              if (typeof data642 == "number" && isFinite(data642)) {
                if (data642 > 9007199254740991 || isNaN(data642)) {
                  const err1591 = { instancePath: instancePath + "/ask/" + i68 + "/fdi", schemaPath: "#/definitions/VerificationEvaluation/properties/ask/items/properties/fdi/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err1591];
                  } else {
                    vErrors.push(err1591);
                  }
                  errors++;
                }
                if (data642 < -9007199254740991 || isNaN(data642)) {
                  const err1592 = { instancePath: instancePath + "/ask/" + i68 + "/fdi", schemaPath: "#/definitions/VerificationEvaluation/properties/ask/items/properties/fdi/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err1592];
                  } else {
                    vErrors.push(err1592);
                  }
                  errors++;
                }
              }
            }
            if (data641.jaw !== void 0) {
              let data643 = data641.jaw;
              if (typeof data643 !== "string") {
                const err1593 = { instancePath: instancePath + "/ask/" + i68 + "/jaw", schemaPath: "#/definitions/VerificationEvaluation/properties/ask/items/properties/jaw/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err1593];
                } else {
                  vErrors.push(err1593);
                }
                errors++;
              }
              if (!(data643 === "OK" || data643 === "UK")) {
                const err1594 = { instancePath: instancePath + "/ask/" + i68 + "/jaw", schemaPath: "#/definitions/VerificationEvaluation/properties/ask/items/properties/jaw/enum", keyword: "enum", params: { allowedValues: schema37.properties.ask.items.properties.jaw.enum }, message: "must be equal to one of the allowed values" };
                if (vErrors === null) {
                  vErrors = [err1594];
                } else {
                  vErrors.push(err1594);
                }
                errors++;
              }
            }
            if (data641.fact !== void 0) {
              let data644 = data641.fact;
              if (typeof data644 !== "string") {
                const err1595 = { instancePath: instancePath + "/ask/" + i68 + "/fact", schemaPath: "#/definitions/VerificationEvaluation/properties/ask/items/properties/fact/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err1595];
                } else {
                  vErrors.push(err1595);
                }
                errors++;
              }
              if (!(data644 === "fehlt" || data644 === "erhaltungswuerdig" || data644 === "krone" || data644 === "endodontisch_behandelt" || data644 === "stiftaufbau" || data644 === "brueckenanker" || data644 === "disparallel" || data644 === "wiederherstellung" || data644 === "geplant" || data644 === "lueckensituation_i")) {
                const err1596 = { instancePath: instancePath + "/ask/" + i68 + "/fact", schemaPath: "#/definitions/VerificationEvaluation/properties/ask/items/properties/fact/enum", keyword: "enum", params: { allowedValues: schema37.properties.ask.items.properties.fact.enum }, message: "must be equal to one of the allowed values" };
                if (vErrors === null) {
                  vErrors = [err1596];
                } else {
                  vErrors.push(err1596);
                }
                errors++;
              }
            }
          } else {
            const err1597 = { instancePath: instancePath + "/ask/" + i68, schemaPath: "#/definitions/VerificationEvaluation/properties/ask/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
              vErrors = [err1597];
            } else {
              vErrors.push(err1597);
            }
            errors++;
          }
        }
      } else {
        const err1598 = { instancePath: instancePath + "/ask", schemaPath: "#/definitions/VerificationEvaluation/properties/ask/type", keyword: "type", params: { type: "array" }, message: "must be array" };
        if (vErrors === null) {
          vErrors = [err1598];
        } else {
          vErrors.push(err1598);
        }
        errors++;
      }
    }
    if (data.noBefund !== void 0) {
      let data645 = data.noBefund;
      if (Array.isArray(data645)) {
        const len69 = data645.length;
        for (let i69 = 0; i69 < len69; i69++) {
          let data646 = data645[i69];
          if (!(typeof data646 == "number" && (!(data646 % 1) && !isNaN(data646)) && isFinite(data646))) {
            const err1599 = { instancePath: instancePath + "/noBefund/" + i69, schemaPath: "#/definitions/VerificationEvaluation/properties/noBefund/items/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
            if (vErrors === null) {
              vErrors = [err1599];
            } else {
              vErrors.push(err1599);
            }
            errors++;
          }
          if (typeof data646 == "number" && isFinite(data646)) {
            if (data646 > 9007199254740991 || isNaN(data646)) {
              const err1600 = { instancePath: instancePath + "/noBefund/" + i69, schemaPath: "#/definitions/VerificationEvaluation/properties/noBefund/items/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
              if (vErrors === null) {
                vErrors = [err1600];
              } else {
                vErrors.push(err1600);
              }
              errors++;
            }
            if (data646 < -9007199254740991 || isNaN(data646)) {
              const err1601 = { instancePath: instancePath + "/noBefund/" + i69, schemaPath: "#/definitions/VerificationEvaluation/properties/noBefund/items/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
              if (vErrors === null) {
                vErrors = [err1601];
              } else {
                vErrors.push(err1601);
              }
              errors++;
            }
          }
        }
      } else {
        const err1602 = { instancePath: instancePath + "/noBefund", schemaPath: "#/definitions/VerificationEvaluation/properties/noBefund/type", keyword: "type", params: { type: "array" }, message: "must be array" };
        if (vErrors === null) {
          vErrors = [err1602];
        } else {
          vErrors.push(err1602);
        }
        errors++;
      }
    }
    if (data.stale !== void 0) {
      let data647 = data.stale;
      if (Array.isArray(data647)) {
        const len70 = data647.length;
        for (let i70 = 0; i70 < len70; i70++) {
          let data648 = data647[i70];
          if (data648 && typeof data648 == "object" && !Array.isArray(data648)) {
            if (data648.rule === void 0) {
              const err1603 = { instancePath: instancePath + "/stale/" + i70, schemaPath: "#/definitions/VerificationEvaluation/properties/stale/items/required", keyword: "required", params: { missingProperty: "rule" }, message: "must have required property 'rule'" };
              if (vErrors === null) {
                vErrors = [err1603];
              } else {
                vErrors.push(err1603);
              }
              errors++;
            }
            if (data648.title === void 0) {
              const err1604 = { instancePath: instancePath + "/stale/" + i70, schemaPath: "#/definitions/VerificationEvaluation/properties/stale/items/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
              if (vErrors === null) {
                vErrors = [err1604];
              } else {
                vErrors.push(err1604);
              }
              errors++;
            }
            for (const key113 in data648) {
              if (!(key113 === "rule" || key113 === "title")) {
                const err1605 = { instancePath: instancePath + "/stale/" + i70, schemaPath: "#/definitions/VerificationEvaluation/properties/stale/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key113 }, message: "must NOT have additional properties" };
                if (vErrors === null) {
                  vErrors = [err1605];
                } else {
                  vErrors.push(err1605);
                }
                errors++;
              }
            }
            if (data648.rule !== void 0) {
              if (typeof data648.rule !== "string") {
                const err1606 = { instancePath: instancePath + "/stale/" + i70 + "/rule", schemaPath: "#/definitions/VerificationEvaluation/properties/stale/items/properties/rule/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err1606];
                } else {
                  vErrors.push(err1606);
                }
                errors++;
              }
            }
            if (data648.title !== void 0) {
              if (typeof data648.title !== "string") {
                const err1607 = { instancePath: instancePath + "/stale/" + i70 + "/title", schemaPath: "#/definitions/VerificationEvaluation/properties/stale/items/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err1607];
                } else {
                  vErrors.push(err1607);
                }
                errors++;
              }
            }
          } else {
            const err1608 = { instancePath: instancePath + "/stale/" + i70, schemaPath: "#/definitions/VerificationEvaluation/properties/stale/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
              vErrors = [err1608];
            } else {
              vErrors.push(err1608);
            }
            errors++;
          }
        }
      } else {
        const err1609 = { instancePath: instancePath + "/stale", schemaPath: "#/definitions/VerificationEvaluation/properties/stale/type", keyword: "type", params: { type: "array" }, message: "must be array" };
        if (vErrors === null) {
          vErrors = [err1609];
        } else {
          vErrors.push(err1609);
        }
        errors++;
      }
    }
    if (data.paths !== void 0) {
      let data651 = data.paths;
      if (Array.isArray(data651)) {
        const len71 = data651.length;
        for (let i71 = 0; i71 < len71; i71++) {
          let data652 = data651[i71];
          if (data652 && typeof data652 == "object" && !Array.isArray(data652)) {
            if (data652.id === void 0) {
              const err1610 = { instancePath: instancePath + "/paths/" + i71, schemaPath: "#/definitions/VerificationEvaluation/properties/paths/items/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property 'id'" };
              if (vErrors === null) {
                vErrors = [err1610];
              } else {
                vErrors.push(err1610);
              }
              errors++;
            }
            if (data652.title === void 0) {
              const err1611 = { instancePath: instancePath + "/paths/" + i71, schemaPath: "#/definitions/VerificationEvaluation/properties/paths/items/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
              if (vErrors === null) {
                vErrors = [err1611];
              } else {
                vErrors.push(err1611);
              }
              errors++;
            }
            if (data652.question === void 0) {
              const err1612 = { instancePath: instancePath + "/paths/" + i71, schemaPath: "#/definitions/VerificationEvaluation/properties/paths/items/required", keyword: "required", params: { missingProperty: "question" }, message: "must have required property 'question'" };
              if (vErrors === null) {
                vErrors = [err1612];
              } else {
                vErrors.push(err1612);
              }
              errors++;
            }
            if (data652.rules === void 0) {
              const err1613 = { instancePath: instancePath + "/paths/" + i71, schemaPath: "#/definitions/VerificationEvaluation/properties/paths/items/required", keyword: "required", params: { missingProperty: "rules" }, message: "must have required property 'rules'" };
              if (vErrors === null) {
                vErrors = [err1613];
              } else {
                vErrors.push(err1613);
              }
              errors++;
            }
            if (data652.notCovered === void 0) {
              const err1614 = { instancePath: instancePath + "/paths/" + i71, schemaPath: "#/definitions/VerificationEvaluation/properties/paths/items/required", keyword: "required", params: { missingProperty: "notCovered" }, message: "must have required property 'notCovered'" };
              if (vErrors === null) {
                vErrors = [err1614];
              } else {
                vErrors.push(err1614);
              }
              errors++;
            }
            if (data652.unbuilt === void 0) {
              const err1615 = { instancePath: instancePath + "/paths/" + i71, schemaPath: "#/definitions/VerificationEvaluation/properties/paths/items/required", keyword: "required", params: { missingProperty: "unbuilt" }, message: "must have required property 'unbuilt'" };
              if (vErrors === null) {
                vErrors = [err1615];
              } else {
                vErrors.push(err1615);
              }
              errors++;
            }
            for (const key114 in data652) {
              if (!(key114 === "id" || key114 === "title" || key114 === "question" || key114 === "rules" || key114 === "notCovered" || key114 === "unbuilt")) {
                const err1616 = { instancePath: instancePath + "/paths/" + i71, schemaPath: "#/definitions/VerificationEvaluation/properties/paths/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key114 }, message: "must NOT have additional properties" };
                if (vErrors === null) {
                  vErrors = [err1616];
                } else {
                  vErrors.push(err1616);
                }
                errors++;
              }
            }
            if (data652.id !== void 0) {
              let data653 = data652.id;
              if (typeof data653 !== "string") {
                const err1617 = { instancePath: instancePath + "/paths/" + i71 + "/id", schemaPath: "#/definitions/VerificationEvaluation/properties/paths/items/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err1617];
                } else {
                  vErrors.push(err1617);
                }
                errors++;
              }
              if (!(data653 === "entscheidungen" || data653 === "zuordnung" || data653 === "goz-details" || data653 === "planpflicht" || data653 === "pruefkommentar")) {
                const err1618 = { instancePath: instancePath + "/paths/" + i71 + "/id", schemaPath: "#/definitions/VerificationEvaluation/properties/paths/items/properties/id/enum", keyword: "enum", params: { allowedValues: schema37.properties.paths.items.properties.id.enum }, message: "must be equal to one of the allowed values" };
                if (vErrors === null) {
                  vErrors = [err1618];
                } else {
                  vErrors.push(err1618);
                }
                errors++;
              }
            }
            if (data652.title !== void 0) {
              if (typeof data652.title !== "string") {
                const err1619 = { instancePath: instancePath + "/paths/" + i71 + "/title", schemaPath: "#/definitions/VerificationEvaluation/properties/paths/items/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err1619];
                } else {
                  vErrors.push(err1619);
                }
                errors++;
              }
            }
            if (data652.question !== void 0) {
              if (typeof data652.question !== "string") {
                const err1620 = { instancePath: instancePath + "/paths/" + i71 + "/question", schemaPath: "#/definitions/VerificationEvaluation/properties/paths/items/properties/question/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err1620];
                } else {
                  vErrors.push(err1620);
                }
                errors++;
              }
            }
            if (data652.rules !== void 0) {
              let data656 = data652.rules;
              if (Array.isArray(data656)) {
                const len72 = data656.length;
                for (let i72 = 0; i72 < len72; i72++) {
                  let data657 = data656[i72];
                  if (data657 && typeof data657 == "object" && !Array.isArray(data657)) {
                    if (data657.id === void 0) {
                      const err1621 = { instancePath: instancePath + "/paths/" + i71 + "/rules/" + i72, schemaPath: "#/definitions/VerificationEvaluation/properties/paths/items/properties/rules/items/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property 'id'" };
                      if (vErrors === null) {
                        vErrors = [err1621];
                      } else {
                        vErrors.push(err1621);
                      }
                      errors++;
                    }
                    if (data657.title === void 0) {
                      const err1622 = { instancePath: instancePath + "/paths/" + i71 + "/rules/" + i72, schemaPath: "#/definitions/VerificationEvaluation/properties/paths/items/properties/rules/items/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
                      if (vErrors === null) {
                        vErrors = [err1622];
                      } else {
                        vErrors.push(err1622);
                      }
                      errors++;
                    }
                    for (const key115 in data657) {
                      if (!(key115 === "id" || key115 === "title")) {
                        const err1623 = { instancePath: instancePath + "/paths/" + i71 + "/rules/" + i72, schemaPath: "#/definitions/VerificationEvaluation/properties/paths/items/properties/rules/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key115 }, message: "must NOT have additional properties" };
                        if (vErrors === null) {
                          vErrors = [err1623];
                        } else {
                          vErrors.push(err1623);
                        }
                        errors++;
                      }
                    }
                    if (data657.id !== void 0) {
                      if (typeof data657.id !== "string") {
                        const err1624 = { instancePath: instancePath + "/paths/" + i71 + "/rules/" + i72 + "/id", schemaPath: "#/definitions/VerificationEvaluation/properties/paths/items/properties/rules/items/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err1624];
                        } else {
                          vErrors.push(err1624);
                        }
                        errors++;
                      }
                    }
                    if (data657.title !== void 0) {
                      if (typeof data657.title !== "string") {
                        const err1625 = { instancePath: instancePath + "/paths/" + i71 + "/rules/" + i72 + "/title", schemaPath: "#/definitions/VerificationEvaluation/properties/paths/items/properties/rules/items/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err1625];
                        } else {
                          vErrors.push(err1625);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err1626 = { instancePath: instancePath + "/paths/" + i71 + "/rules/" + i72, schemaPath: "#/definitions/VerificationEvaluation/properties/paths/items/properties/rules/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                    if (vErrors === null) {
                      vErrors = [err1626];
                    } else {
                      vErrors.push(err1626);
                    }
                    errors++;
                  }
                }
              } else {
                const err1627 = { instancePath: instancePath + "/paths/" + i71 + "/rules", schemaPath: "#/definitions/VerificationEvaluation/properties/paths/items/properties/rules/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                if (vErrors === null) {
                  vErrors = [err1627];
                } else {
                  vErrors.push(err1627);
                }
                errors++;
              }
            }
            if (data652.notCovered !== void 0) {
              if (typeof data652.notCovered !== "string") {
                const err1628 = { instancePath: instancePath + "/paths/" + i71 + "/notCovered", schemaPath: "#/definitions/VerificationEvaluation/properties/paths/items/properties/notCovered/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err1628];
                } else {
                  vErrors.push(err1628);
                }
                errors++;
              }
            }
            if (data652.unbuilt !== void 0) {
              let data661 = data652.unbuilt;
              if (Array.isArray(data661)) {
                const len73 = data661.length;
                for (let i73 = 0; i73 < len73; i73++) {
                  let data662 = data661[i73];
                  if (data662 && typeof data662 == "object" && !Array.isArray(data662)) {
                    if (data662.befund === void 0) {
                      const err1629 = { instancePath: instancePath + "/paths/" + i71 + "/unbuilt/" + i73, schemaPath: "#/definitions/VerificationEvaluation/properties/paths/items/properties/unbuilt/items/required", keyword: "required", params: { missingProperty: "befund" }, message: "must have required property 'befund'" };
                      if (vErrors === null) {
                        vErrors = [err1629];
                      } else {
                        vErrors.push(err1629);
                      }
                      errors++;
                    }
                    if (data662.title === void 0) {
                      const err1630 = { instancePath: instancePath + "/paths/" + i71 + "/unbuilt/" + i73, schemaPath: "#/definitions/VerificationEvaluation/properties/paths/items/properties/unbuilt/items/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
                      if (vErrors === null) {
                        vErrors = [err1630];
                      } else {
                        vErrors.push(err1630);
                      }
                      errors++;
                    }
                    if (data662.pages === void 0) {
                      const err1631 = { instancePath: instancePath + "/paths/" + i71 + "/unbuilt/" + i73, schemaPath: "#/definitions/VerificationEvaluation/properties/paths/items/properties/unbuilt/items/required", keyword: "required", params: { missingProperty: "pages" }, message: "must have required property 'pages'" };
                      if (vErrors === null) {
                        vErrors = [err1631];
                      } else {
                        vErrors.push(err1631);
                      }
                      errors++;
                    }
                    for (const key116 in data662) {
                      if (!(key116 === "befund" || key116 === "title" || key116 === "pages")) {
                        const err1632 = { instancePath: instancePath + "/paths/" + i71 + "/unbuilt/" + i73, schemaPath: "#/definitions/VerificationEvaluation/properties/paths/items/properties/unbuilt/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key116 }, message: "must NOT have additional properties" };
                        if (vErrors === null) {
                          vErrors = [err1632];
                        } else {
                          vErrors.push(err1632);
                        }
                        errors++;
                      }
                    }
                    if (data662.befund !== void 0) {
                      if (typeof data662.befund !== "string") {
                        const err1633 = { instancePath: instancePath + "/paths/" + i71 + "/unbuilt/" + i73 + "/befund", schemaPath: "#/definitions/VerificationEvaluation/properties/paths/items/properties/unbuilt/items/properties/befund/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err1633];
                        } else {
                          vErrors.push(err1633);
                        }
                        errors++;
                      }
                    }
                    if (data662.title !== void 0) {
                      if (typeof data662.title !== "string") {
                        const err1634 = { instancePath: instancePath + "/paths/" + i71 + "/unbuilt/" + i73 + "/title", schemaPath: "#/definitions/VerificationEvaluation/properties/paths/items/properties/unbuilt/items/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err1634];
                        } else {
                          vErrors.push(err1634);
                        }
                        errors++;
                      }
                    }
                    if (data662.pages !== void 0) {
                      let data665 = data662.pages;
                      if (Array.isArray(data665)) {
                        const len74 = data665.length;
                        for (let i74 = 0; i74 < len74; i74++) {
                          let data666 = data665[i74];
                          if (!(typeof data666 == "number" && (!(data666 % 1) && !isNaN(data666)) && isFinite(data666))) {
                            const err1635 = { instancePath: instancePath + "/paths/" + i71 + "/unbuilt/" + i73 + "/pages/" + i74, schemaPath: "#/definitions/VerificationEvaluation/properties/paths/items/properties/unbuilt/items/properties/pages/items/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                            if (vErrors === null) {
                              vErrors = [err1635];
                            } else {
                              vErrors.push(err1635);
                            }
                            errors++;
                          }
                          if (typeof data666 == "number" && isFinite(data666)) {
                            if (data666 > 9007199254740991 || isNaN(data666)) {
                              const err1636 = { instancePath: instancePath + "/paths/" + i71 + "/unbuilt/" + i73 + "/pages/" + i74, schemaPath: "#/definitions/VerificationEvaluation/properties/paths/items/properties/unbuilt/items/properties/pages/items/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err1636];
                              } else {
                                vErrors.push(err1636);
                              }
                              errors++;
                            }
                            if (data666 < -9007199254740991 || isNaN(data666)) {
                              const err1637 = { instancePath: instancePath + "/paths/" + i71 + "/unbuilt/" + i73 + "/pages/" + i74, schemaPath: "#/definitions/VerificationEvaluation/properties/paths/items/properties/unbuilt/items/properties/pages/items/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                              if (vErrors === null) {
                                vErrors = [err1637];
                              } else {
                                vErrors.push(err1637);
                              }
                              errors++;
                            }
                          }
                        }
                      } else {
                        const err1638 = { instancePath: instancePath + "/paths/" + i71 + "/unbuilt/" + i73 + "/pages", schemaPath: "#/definitions/VerificationEvaluation/properties/paths/items/properties/unbuilt/items/properties/pages/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                        if (vErrors === null) {
                          vErrors = [err1638];
                        } else {
                          vErrors.push(err1638);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err1639 = { instancePath: instancePath + "/paths/" + i71 + "/unbuilt/" + i73, schemaPath: "#/definitions/VerificationEvaluation/properties/paths/items/properties/unbuilt/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                    if (vErrors === null) {
                      vErrors = [err1639];
                    } else {
                      vErrors.push(err1639);
                    }
                    errors++;
                  }
                }
              } else {
                const err1640 = { instancePath: instancePath + "/paths/" + i71 + "/unbuilt", schemaPath: "#/definitions/VerificationEvaluation/properties/paths/items/properties/unbuilt/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                if (vErrors === null) {
                  vErrors = [err1640];
                } else {
                  vErrors.push(err1640);
                }
                errors++;
              }
            }
          } else {
            const err1641 = { instancePath: instancePath + "/paths/" + i71, schemaPath: "#/definitions/VerificationEvaluation/properties/paths/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
              vErrors = [err1641];
            } else {
              vErrors.push(err1641);
            }
            errors++;
          }
        }
      } else {
        const err1642 = { instancePath: instancePath + "/paths", schemaPath: "#/definitions/VerificationEvaluation/properties/paths/type", keyword: "type", params: { type: "array" }, message: "must be array" };
        if (vErrors === null) {
          vErrors = [err1642];
        } else {
          vErrors.push(err1642);
        }
        errors++;
      }
    }
    if (data.vocabulary !== void 0) {
      let data667 = data.vocabulary;
      if (Array.isArray(data667)) {
        const len75 = data667.length;
        for (let i75 = 0; i75 < len75; i75++) {
          let data668 = data667[i75];
          if (data668 && typeof data668 == "object" && !Array.isArray(data668)) {
            if (data668.fact === void 0) {
              const err1643 = { instancePath: instancePath + "/vocabulary/" + i75, schemaPath: "#/definitions/VerificationEvaluation/properties/vocabulary/items/required", keyword: "required", params: { missingProperty: "fact" }, message: "must have required property 'fact'" };
              if (vErrors === null) {
                vErrors = [err1643];
              } else {
                vErrors.push(err1643);
              }
              errors++;
            }
            if (data668.place === void 0) {
              const err1644 = { instancePath: instancePath + "/vocabulary/" + i75, schemaPath: "#/definitions/VerificationEvaluation/properties/vocabulary/items/required", keyword: "required", params: { missingProperty: "place" }, message: "must have required property 'place'" };
              if (vErrors === null) {
                vErrors = [err1644];
              } else {
                vErrors.push(err1644);
              }
              errors++;
            }
            if (data668.stage === void 0) {
              const err1645 = { instancePath: instancePath + "/vocabulary/" + i75, schemaPath: "#/definitions/VerificationEvaluation/properties/vocabulary/items/required", keyword: "required", params: { missingProperty: "stage" }, message: "must have required property 'stage'" };
              if (vErrors === null) {
                vErrors = [err1645];
              } else {
                vErrors.push(err1645);
              }
              errors++;
            }
            if (data668.owner === void 0) {
              const err1646 = { instancePath: instancePath + "/vocabulary/" + i75, schemaPath: "#/definitions/VerificationEvaluation/properties/vocabulary/items/required", keyword: "required", params: { missingProperty: "owner" }, message: "must have required property 'owner'" };
              if (vErrors === null) {
                vErrors = [err1646];
              } else {
                vErrors.push(err1646);
              }
              errors++;
            }
            if (data668.label === void 0) {
              const err1647 = { instancePath: instancePath + "/vocabulary/" + i75, schemaPath: "#/definitions/VerificationEvaluation/properties/vocabulary/items/required", keyword: "required", params: { missingProperty: "label" }, message: "must have required property 'label'" };
              if (vErrors === null) {
                vErrors = [err1647];
              } else {
                vErrors.push(err1647);
              }
              errors++;
            }
            if (data668.description === void 0) {
              const err1648 = { instancePath: instancePath + "/vocabulary/" + i75, schemaPath: "#/definitions/VerificationEvaluation/properties/vocabulary/items/required", keyword: "required", params: { missingProperty: "description" }, message: "must have required property 'description'" };
              if (vErrors === null) {
                vErrors = [err1648];
              } else {
                vErrors.push(err1648);
              }
              errors++;
            }
            if (data668.values === void 0) {
              const err1649 = { instancePath: instancePath + "/vocabulary/" + i75, schemaPath: "#/definitions/VerificationEvaluation/properties/vocabulary/items/required", keyword: "required", params: { missingProperty: "values" }, message: "must have required property 'values'" };
              if (vErrors === null) {
                vErrors = [err1649];
              } else {
                vErrors.push(err1649);
              }
              errors++;
            }
            if (data668.schema === void 0) {
              const err1650 = { instancePath: instancePath + "/vocabulary/" + i75, schemaPath: "#/definitions/VerificationEvaluation/properties/vocabulary/items/required", keyword: "required", params: { missingProperty: "schema" }, message: "must have required property 'schema'" };
              if (vErrors === null) {
                vErrors = [err1650];
              } else {
                vErrors.push(err1650);
              }
              errors++;
            }
            for (const key117 in data668) {
              if (!(key117 === "fact" || key117 === "place" || key117 === "stage" || key117 === "owner" || key117 === "label" || key117 === "description" || key117 === "values" || key117 === "schema")) {
                const err1651 = { instancePath: instancePath + "/vocabulary/" + i75, schemaPath: "#/definitions/VerificationEvaluation/properties/vocabulary/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key117 }, message: "must NOT have additional properties" };
                if (vErrors === null) {
                  vErrors = [err1651];
                } else {
                  vErrors.push(err1651);
                }
                errors++;
              }
            }
            if (data668.fact !== void 0) {
              let data669 = data668.fact;
              if (typeof data669 !== "string") {
                const err1652 = { instancePath: instancePath + "/vocabulary/" + i75 + "/fact", schemaPath: "#/definitions/VerificationEvaluation/properties/vocabulary/items/properties/fact/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err1652];
                } else {
                  vErrors.push(err1652);
                }
                errors++;
              }
              if (!(data669 === "fehlt" || data669 === "erhaltungswuerdig" || data669 === "krone" || data669 === "endodontisch_behandelt" || data669 === "stiftaufbau" || data669 === "brueckenanker" || data669 === "disparallel" || data669 === "wiederherstellung" || data669 === "geplant" || data669 === "lueckensituation_i")) {
                const err1653 = { instancePath: instancePath + "/vocabulary/" + i75 + "/fact", schemaPath: "#/definitions/VerificationEvaluation/properties/vocabulary/items/properties/fact/enum", keyword: "enum", params: { allowedValues: schema37.properties.vocabulary.items.properties.fact.enum }, message: "must be equal to one of the allowed values" };
                if (vErrors === null) {
                  vErrors = [err1653];
                } else {
                  vErrors.push(err1653);
                }
                errors++;
              }
            }
            if (data668.place !== void 0) {
              let data670 = data668.place;
              if (typeof data670 !== "string") {
                const err1654 = { instancePath: instancePath + "/vocabulary/" + i75 + "/place", schemaPath: "#/definitions/VerificationEvaluation/properties/vocabulary/items/properties/place/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err1654];
                } else {
                  vErrors.push(err1654);
                }
                errors++;
              }
              if (!(data670 === "tooth" || data670 === "jaw")) {
                const err1655 = { instancePath: instancePath + "/vocabulary/" + i75 + "/place", schemaPath: "#/definitions/VerificationEvaluation/properties/vocabulary/items/properties/place/enum", keyword: "enum", params: { allowedValues: schema37.properties.vocabulary.items.properties.place.enum }, message: "must be equal to one of the allowed values" };
                if (vErrors === null) {
                  vErrors = [err1655];
                } else {
                  vErrors.push(err1655);
                }
                errors++;
              }
            }
            if (data668.stage !== void 0) {
              let data671 = data668.stage;
              if (typeof data671 !== "string") {
                const err1656 = { instancePath: instancePath + "/vocabulary/" + i75 + "/stage", schemaPath: "#/definitions/VerificationEvaluation/properties/vocabulary/items/properties/stage/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err1656];
                } else {
                  vErrors.push(err1656);
                }
                errors++;
              }
              if (!(data671 === "befund" || data671 === "planung")) {
                const err1657 = { instancePath: instancePath + "/vocabulary/" + i75 + "/stage", schemaPath: "#/definitions/VerificationEvaluation/properties/vocabulary/items/properties/stage/enum", keyword: "enum", params: { allowedValues: schema37.properties.vocabulary.items.properties.stage.enum }, message: "must be equal to one of the allowed values" };
                if (vErrors === null) {
                  vErrors = [err1657];
                } else {
                  vErrors.push(err1657);
                }
                errors++;
              }
            }
            if (data668.owner !== void 0) {
              let data672 = data668.owner;
              if (typeof data672 !== "string") {
                const err1658 = { instancePath: instancePath + "/vocabulary/" + i75 + "/owner", schemaPath: "#/definitions/VerificationEvaluation/properties/vocabulary/items/properties/owner/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err1658];
                } else {
                  vErrors.push(err1658);
                }
                errors++;
              }
              if (!(data672 === "dentist" || data672 === "patient")) {
                const err1659 = { instancePath: instancePath + "/vocabulary/" + i75 + "/owner", schemaPath: "#/definitions/VerificationEvaluation/properties/vocabulary/items/properties/owner/enum", keyword: "enum", params: { allowedValues: schema37.properties.vocabulary.items.properties.owner.enum }, message: "must be equal to one of the allowed values" };
                if (vErrors === null) {
                  vErrors = [err1659];
                } else {
                  vErrors.push(err1659);
                }
                errors++;
              }
            }
            if (data668.label !== void 0) {
              if (typeof data668.label !== "string") {
                const err1660 = { instancePath: instancePath + "/vocabulary/" + i75 + "/label", schemaPath: "#/definitions/VerificationEvaluation/properties/vocabulary/items/properties/label/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err1660];
                } else {
                  vErrors.push(err1660);
                }
                errors++;
              }
            }
            if (data668.description !== void 0) {
              if (typeof data668.description !== "string") {
                const err1661 = { instancePath: instancePath + "/vocabulary/" + i75 + "/description", schemaPath: "#/definitions/VerificationEvaluation/properties/vocabulary/items/properties/description/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err1661];
                } else {
                  vErrors.push(err1661);
                }
                errors++;
              }
            }
            if (data668.values !== void 0) {
              let data675 = data668.values;
              if (Array.isArray(data675)) {
                const len76 = data675.length;
                for (let i76 = 0; i76 < len76; i76++) {
                  let data676 = data675[i76];
                  if (data676 && typeof data676 == "object" && !Array.isArray(data676)) {
                    if (data676.value === void 0) {
                      const err1662 = { instancePath: instancePath + "/vocabulary/" + i75 + "/values/" + i76, schemaPath: "#/definitions/VerificationEvaluation/properties/vocabulary/items/properties/values/items/required", keyword: "required", params: { missingProperty: "value" }, message: "must have required property 'value'" };
                      if (vErrors === null) {
                        vErrors = [err1662];
                      } else {
                        vErrors.push(err1662);
                      }
                      errors++;
                    }
                    if (data676.label === void 0) {
                      const err1663 = { instancePath: instancePath + "/vocabulary/" + i75 + "/values/" + i76, schemaPath: "#/definitions/VerificationEvaluation/properties/vocabulary/items/properties/values/items/required", keyword: "required", params: { missingProperty: "label" }, message: "must have required property 'label'" };
                      if (vErrors === null) {
                        vErrors = [err1663];
                      } else {
                        vErrors.push(err1663);
                      }
                      errors++;
                    }
                    for (const key118 in data676) {
                      if (!(key118 === "value" || key118 === "label")) {
                        const err1664 = { instancePath: instancePath + "/vocabulary/" + i75 + "/values/" + i76, schemaPath: "#/definitions/VerificationEvaluation/properties/vocabulary/items/properties/values/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key118 }, message: "must NOT have additional properties" };
                        if (vErrors === null) {
                          vErrors = [err1664];
                        } else {
                          vErrors.push(err1664);
                        }
                        errors++;
                      }
                    }
                    if (data676.value !== void 0) {
                      let data677 = data676.value;
                      const _errs1516 = errors;
                      let valid284 = false;
                      const _errs1517 = errors;
                      if (typeof data677 !== "boolean") {
                        const err1665 = { instancePath: instancePath + "/vocabulary/" + i75 + "/values/" + i76 + "/value", schemaPath: "#/definitions/VerificationEvaluation/properties/vocabulary/items/properties/values/items/properties/value/anyOf/0/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                        if (vErrors === null) {
                          vErrors = [err1665];
                        } else {
                          vErrors.push(err1665);
                        }
                        errors++;
                      }
                      var _valid10 = _errs1517 === errors;
                      valid284 = valid284 || _valid10;
                      if (!valid284) {
                        const _errs1519 = errors;
                        if (typeof data677 !== "string") {
                          const err1666 = { instancePath: instancePath + "/vocabulary/" + i75 + "/values/" + i76 + "/value", schemaPath: "#/definitions/VerificationEvaluation/properties/vocabulary/items/properties/values/items/properties/value/anyOf/1/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                          if (vErrors === null) {
                            vErrors = [err1666];
                          } else {
                            vErrors.push(err1666);
                          }
                          errors++;
                        }
                        var _valid10 = _errs1519 === errors;
                        valid284 = valid284 || _valid10;
                      }
                      if (!valid284) {
                        const err1667 = { instancePath: instancePath + "/vocabulary/" + i75 + "/values/" + i76 + "/value", schemaPath: "#/definitions/VerificationEvaluation/properties/vocabulary/items/properties/values/items/properties/value/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                        if (vErrors === null) {
                          vErrors = [err1667];
                        } else {
                          vErrors.push(err1667);
                        }
                        errors++;
                      } else {
                        errors = _errs1516;
                        if (vErrors !== null) {
                          if (_errs1516) {
                            vErrors.length = _errs1516;
                          } else {
                            vErrors = null;
                          }
                        }
                      }
                    }
                    if (data676.label !== void 0) {
                      if (typeof data676.label !== "string") {
                        const err1668 = { instancePath: instancePath + "/vocabulary/" + i75 + "/values/" + i76 + "/label", schemaPath: "#/definitions/VerificationEvaluation/properties/vocabulary/items/properties/values/items/properties/label/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err1668];
                        } else {
                          vErrors.push(err1668);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err1669 = { instancePath: instancePath + "/vocabulary/" + i75 + "/values/" + i76, schemaPath: "#/definitions/VerificationEvaluation/properties/vocabulary/items/properties/values/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                    if (vErrors === null) {
                      vErrors = [err1669];
                    } else {
                      vErrors.push(err1669);
                    }
                    errors++;
                  }
                }
              } else {
                const err1670 = { instancePath: instancePath + "/vocabulary/" + i75 + "/values", schemaPath: "#/definitions/VerificationEvaluation/properties/vocabulary/items/properties/values/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                if (vErrors === null) {
                  vErrors = [err1670];
                } else {
                  vErrors.push(err1670);
                }
                errors++;
              }
            }
            if (data668.schema !== void 0) {
              let data679 = data668.schema;
              if (data679 && typeof data679 == "object" && !Array.isArray(data679)) {
                if (data679.type === void 0) {
                  const err1671 = { instancePath: instancePath + "/vocabulary/" + i75 + "/schema", schemaPath: "#/definitions/VerificationEvaluation/properties/vocabulary/items/properties/schema/required", keyword: "required", params: { missingProperty: "type" }, message: "must have required property 'type'" };
                  if (vErrors === null) {
                    vErrors = [err1671];
                  } else {
                    vErrors.push(err1671);
                  }
                  errors++;
                }
                if (data679.title === void 0) {
                  const err1672 = { instancePath: instancePath + "/vocabulary/" + i75 + "/schema", schemaPath: "#/definitions/VerificationEvaluation/properties/vocabulary/items/properties/schema/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
                  if (vErrors === null) {
                    vErrors = [err1672];
                  } else {
                    vErrors.push(err1672);
                  }
                  errors++;
                }
                if (data679.description === void 0) {
                  const err1673 = { instancePath: instancePath + "/vocabulary/" + i75 + "/schema", schemaPath: "#/definitions/VerificationEvaluation/properties/vocabulary/items/properties/schema/required", keyword: "required", params: { missingProperty: "description" }, message: "must have required property 'description'" };
                  if (vErrors === null) {
                    vErrors = [err1673];
                  } else {
                    vErrors.push(err1673);
                  }
                  errors++;
                }
                if (data679.labels === void 0) {
                  const err1674 = { instancePath: instancePath + "/vocabulary/" + i75 + "/schema", schemaPath: "#/definitions/VerificationEvaluation/properties/vocabulary/items/properties/schema/required", keyword: "required", params: { missingProperty: "labels" }, message: "must have required property 'labels'" };
                  if (vErrors === null) {
                    vErrors = [err1674];
                  } else {
                    vErrors.push(err1674);
                  }
                  errors++;
                }
                for (const key119 in data679) {
                  if (!(key119 === "type" || key119 === "enum" || key119 === "title" || key119 === "description" || key119 === "labels")) {
                    const err1675 = { instancePath: instancePath + "/vocabulary/" + i75 + "/schema", schemaPath: "#/definitions/VerificationEvaluation/properties/vocabulary/items/properties/schema/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key119 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                      vErrors = [err1675];
                    } else {
                      vErrors.push(err1675);
                    }
                    errors++;
                  }
                }
                if (data679.type !== void 0) {
                  let data680 = data679.type;
                  if (typeof data680 !== "string") {
                    const err1676 = { instancePath: instancePath + "/vocabulary/" + i75 + "/schema/type", schemaPath: "#/definitions/VerificationEvaluation/properties/vocabulary/items/properties/schema/properties/type/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err1676];
                    } else {
                      vErrors.push(err1676);
                    }
                    errors++;
                  }
                  if (!(data680 === "boolean" || data680 === "string")) {
                    const err1677 = { instancePath: instancePath + "/vocabulary/" + i75 + "/schema/type", schemaPath: "#/definitions/VerificationEvaluation/properties/vocabulary/items/properties/schema/properties/type/enum", keyword: "enum", params: { allowedValues: schema37.properties.vocabulary.items.properties.schema.properties.type.enum }, message: "must be equal to one of the allowed values" };
                    if (vErrors === null) {
                      vErrors = [err1677];
                    } else {
                      vErrors.push(err1677);
                    }
                    errors++;
                  }
                }
                if (data679.enum !== void 0) {
                  let data681 = data679.enum;
                  if (Array.isArray(data681)) {
                    const len77 = data681.length;
                    for (let i77 = 0; i77 < len77; i77++) {
                      if (typeof data681[i77] !== "string") {
                        const err1678 = { instancePath: instancePath + "/vocabulary/" + i75 + "/schema/enum/" + i77, schemaPath: "#/definitions/VerificationEvaluation/properties/vocabulary/items/properties/schema/properties/enum/items/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                        if (vErrors === null) {
                          vErrors = [err1678];
                        } else {
                          vErrors.push(err1678);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err1679 = { instancePath: instancePath + "/vocabulary/" + i75 + "/schema/enum", schemaPath: "#/definitions/VerificationEvaluation/properties/vocabulary/items/properties/schema/properties/enum/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                      vErrors = [err1679];
                    } else {
                      vErrors.push(err1679);
                    }
                    errors++;
                  }
                }
                if (data679.title !== void 0) {
                  if (typeof data679.title !== "string") {
                    const err1680 = { instancePath: instancePath + "/vocabulary/" + i75 + "/schema/title", schemaPath: "#/definitions/VerificationEvaluation/properties/vocabulary/items/properties/schema/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err1680];
                    } else {
                      vErrors.push(err1680);
                    }
                    errors++;
                  }
                }
                if (data679.description !== void 0) {
                  if (typeof data679.description !== "string") {
                    const err1681 = { instancePath: instancePath + "/vocabulary/" + i75 + "/schema/description", schemaPath: "#/definitions/VerificationEvaluation/properties/vocabulary/items/properties/schema/properties/description/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err1681];
                    } else {
                      vErrors.push(err1681);
                    }
                    errors++;
                  }
                }
                if (data679.labels !== void 0) {
                  let data685 = data679.labels;
                  if (Array.isArray(data685)) {
                    const len78 = data685.length;
                    for (let i78 = 0; i78 < len78; i78++) {
                      let data686 = data685[i78];
                      if (data686 && typeof data686 == "object" && !Array.isArray(data686)) {
                        if (data686.value === void 0) {
                          const err1682 = { instancePath: instancePath + "/vocabulary/" + i75 + "/schema/labels/" + i78, schemaPath: "#/definitions/VerificationEvaluation/properties/vocabulary/items/properties/schema/properties/labels/items/required", keyword: "required", params: { missingProperty: "value" }, message: "must have required property 'value'" };
                          if (vErrors === null) {
                            vErrors = [err1682];
                          } else {
                            vErrors.push(err1682);
                          }
                          errors++;
                        }
                        if (data686.label === void 0) {
                          const err1683 = { instancePath: instancePath + "/vocabulary/" + i75 + "/schema/labels/" + i78, schemaPath: "#/definitions/VerificationEvaluation/properties/vocabulary/items/properties/schema/properties/labels/items/required", keyword: "required", params: { missingProperty: "label" }, message: "must have required property 'label'" };
                          if (vErrors === null) {
                            vErrors = [err1683];
                          } else {
                            vErrors.push(err1683);
                          }
                          errors++;
                        }
                        for (const key120 in data686) {
                          if (!(key120 === "value" || key120 === "label")) {
                            const err1684 = { instancePath: instancePath + "/vocabulary/" + i75 + "/schema/labels/" + i78, schemaPath: "#/definitions/VerificationEvaluation/properties/vocabulary/items/properties/schema/properties/labels/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key120 }, message: "must NOT have additional properties" };
                            if (vErrors === null) {
                              vErrors = [err1684];
                            } else {
                              vErrors.push(err1684);
                            }
                            errors++;
                          }
                        }
                        if (data686.value !== void 0) {
                          let data687 = data686.value;
                          const _errs1542 = errors;
                          let valid291 = false;
                          const _errs1543 = errors;
                          if (typeof data687 !== "boolean") {
                            const err1685 = { instancePath: instancePath + "/vocabulary/" + i75 + "/schema/labels/" + i78 + "/value", schemaPath: "#/definitions/VerificationEvaluation/properties/vocabulary/items/properties/schema/properties/labels/items/properties/value/anyOf/0/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                            if (vErrors === null) {
                              vErrors = [err1685];
                            } else {
                              vErrors.push(err1685);
                            }
                            errors++;
                          }
                          var _valid11 = _errs1543 === errors;
                          valid291 = valid291 || _valid11;
                          if (!valid291) {
                            const _errs1545 = errors;
                            if (typeof data687 !== "string") {
                              const err1686 = { instancePath: instancePath + "/vocabulary/" + i75 + "/schema/labels/" + i78 + "/value", schemaPath: "#/definitions/VerificationEvaluation/properties/vocabulary/items/properties/schema/properties/labels/items/properties/value/anyOf/1/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                              if (vErrors === null) {
                                vErrors = [err1686];
                              } else {
                                vErrors.push(err1686);
                              }
                              errors++;
                            }
                            var _valid11 = _errs1545 === errors;
                            valid291 = valid291 || _valid11;
                          }
                          if (!valid291) {
                            const err1687 = { instancePath: instancePath + "/vocabulary/" + i75 + "/schema/labels/" + i78 + "/value", schemaPath: "#/definitions/VerificationEvaluation/properties/vocabulary/items/properties/schema/properties/labels/items/properties/value/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                            if (vErrors === null) {
                              vErrors = [err1687];
                            } else {
                              vErrors.push(err1687);
                            }
                            errors++;
                          } else {
                            errors = _errs1542;
                            if (vErrors !== null) {
                              if (_errs1542) {
                                vErrors.length = _errs1542;
                              } else {
                                vErrors = null;
                              }
                            }
                          }
                        }
                        if (data686.label !== void 0) {
                          if (typeof data686.label !== "string") {
                            const err1688 = { instancePath: instancePath + "/vocabulary/" + i75 + "/schema/labels/" + i78 + "/label", schemaPath: "#/definitions/VerificationEvaluation/properties/vocabulary/items/properties/schema/properties/labels/items/properties/label/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err1688];
                            } else {
                              vErrors.push(err1688);
                            }
                            errors++;
                          }
                        }
                      } else {
                        const err1689 = { instancePath: instancePath + "/vocabulary/" + i75 + "/schema/labels/" + i78, schemaPath: "#/definitions/VerificationEvaluation/properties/vocabulary/items/properties/schema/properties/labels/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                        if (vErrors === null) {
                          vErrors = [err1689];
                        } else {
                          vErrors.push(err1689);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err1690 = { instancePath: instancePath + "/vocabulary/" + i75 + "/schema/labels", schemaPath: "#/definitions/VerificationEvaluation/properties/vocabulary/items/properties/schema/properties/labels/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                      vErrors = [err1690];
                    } else {
                      vErrors.push(err1690);
                    }
                    errors++;
                  }
                }
              } else {
                const err1691 = { instancePath: instancePath + "/vocabulary/" + i75 + "/schema", schemaPath: "#/definitions/VerificationEvaluation/properties/vocabulary/items/properties/schema/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                if (vErrors === null) {
                  vErrors = [err1691];
                } else {
                  vErrors.push(err1691);
                }
                errors++;
              }
            }
          } else {
            const err1692 = { instancePath: instancePath + "/vocabulary/" + i75, schemaPath: "#/definitions/VerificationEvaluation/properties/vocabulary/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
              vErrors = [err1692];
            } else {
              vErrors.push(err1692);
            }
            errors++;
          }
        }
      } else {
        const err1693 = { instancePath: instancePath + "/vocabulary", schemaPath: "#/definitions/VerificationEvaluation/properties/vocabulary/type", keyword: "type", params: { type: "array" }, message: "must be array" };
        if (vErrors === null) {
          vErrors = [err1693];
        } else {
          vErrors.push(err1693);
        }
        errors++;
      }
    }
  } else {
    const err1694 = { instancePath, schemaPath: "#/definitions/VerificationEvaluation/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err1694];
    } else {
      vErrors.push(err1694);
    }
    errors++;
  }
  validate31.errors = vErrors;
  return errors === 0;
}
var validateInput11 = validate32;
function validate32(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.prompt === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "prompt" }, message: "must have required property 'prompt'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    for (const key0 in data) {
      if (!(key0 === "prompt")) {
        const err1 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
    }
    if (data.prompt !== void 0) {
      let data0 = data.prompt;
      if (typeof data0 === "string") {
        if (func2(data0) > 2e4) {
          const err2 = { instancePath: instancePath + "/prompt", schemaPath: "#/properties/prompt/maxLength", keyword: "maxLength", params: { limit: 2e4 }, message: "must NOT have more than 20000 characters" };
          if (vErrors === null) {
            vErrors = [err2];
          } else {
            vErrors.push(err2);
          }
          errors++;
        }
        if (func2(data0) < 1) {
          const err3 = { instancePath: instancePath + "/prompt", schemaPath: "#/properties/prompt/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
          if (vErrors === null) {
            vErrors = [err3];
          } else {
            vErrors.push(err3);
          }
          errors++;
        }
      } else {
        const err4 = { instancePath: instancePath + "/prompt", schemaPath: "#/properties/prompt/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
  } else {
    const err5 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err5];
    } else {
      vErrors.push(err5);
    }
    errors++;
  }
  validate32.errors = vErrors;
  return errors === 0;
}
var validateOutput11 = validate33;
var schema39 = { "$schema": "http://json-schema.org/draft-07/schema#", "type": "object", "properties": { "id": { "type": "string" }, "object": { "type": "string", "const": "conversation" }, "userId": { "type": "string" }, "title": { "type": "string" }, "configuration": { "type": "string" }, "createdAt": { "type": "string", "format": "date-time", "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, "updatedAt": { "type": "string", "format": "date-time", "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, "run": { "type": "object", "properties": { "id": { "type": "string" }, "object": { "type": "string", "const": "agent_run" }, "userId": { "type": "string" }, "prompt": { "type": "string" }, "status": { "type": "string", "enum": ["queued", "running", "completed", "failed", "cancelled"] }, "output": { "anyOf": [{ "type": "string" }, { "type": "null" }] }, "error": { "anyOf": [{ "type": "string" }, { "type": "null" }] }, "createdAt": { "type": "string", "format": "date-time", "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, "completedAt": { "anyOf": [{ "type": "string", "format": "date-time", "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, { "type": "null" }] } }, "required": ["id", "object", "userId", "prompt", "status", "output", "error", "createdAt", "completedAt"], "additionalProperties": false } }, "required": ["id", "object", "userId", "title", "configuration", "createdAt", "updatedAt", "run"], "additionalProperties": false };
function validate33(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.id === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property 'id'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.object === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "object" }, message: "must have required property 'object'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.userId === void 0) {
      const err2 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "userId" }, message: "must have required property 'userId'" };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.title === void 0) {
      const err3 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "title" }, message: "must have required property 'title'" };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.configuration === void 0) {
      const err4 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "configuration" }, message: "must have required property 'configuration'" };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
    if (data.createdAt === void 0) {
      const err5 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "createdAt" }, message: "must have required property 'createdAt'" };
      if (vErrors === null) {
        vErrors = [err5];
      } else {
        vErrors.push(err5);
      }
      errors++;
    }
    if (data.updatedAt === void 0) {
      const err6 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "updatedAt" }, message: "must have required property 'updatedAt'" };
      if (vErrors === null) {
        vErrors = [err6];
      } else {
        vErrors.push(err6);
      }
      errors++;
    }
    if (data.run === void 0) {
      const err7 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "run" }, message: "must have required property 'run'" };
      if (vErrors === null) {
        vErrors = [err7];
      } else {
        vErrors.push(err7);
      }
      errors++;
    }
    for (const key0 in data) {
      if (!(key0 === "id" || key0 === "object" || key0 === "userId" || key0 === "title" || key0 === "configuration" || key0 === "createdAt" || key0 === "updatedAt" || key0 === "run")) {
        const err8 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
    }
    if (data.id !== void 0) {
      if (typeof data.id !== "string") {
        const err9 = { instancePath: instancePath + "/id", schemaPath: "#/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
    }
    if (data.object !== void 0) {
      let data1 = data.object;
      if (typeof data1 !== "string") {
        const err10 = { instancePath: instancePath + "/object", schemaPath: "#/properties/object/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err10];
        } else {
          vErrors.push(err10);
        }
        errors++;
      }
      if ("conversation" !== data1) {
        const err11 = { instancePath: instancePath + "/object", schemaPath: "#/properties/object/const", keyword: "const", params: { allowedValue: "conversation" }, message: "must be equal to constant" };
        if (vErrors === null) {
          vErrors = [err11];
        } else {
          vErrors.push(err11);
        }
        errors++;
      }
    }
    if (data.userId !== void 0) {
      if (typeof data.userId !== "string") {
        const err12 = { instancePath: instancePath + "/userId", schemaPath: "#/properties/userId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err12];
        } else {
          vErrors.push(err12);
        }
        errors++;
      }
    }
    if (data.title !== void 0) {
      if (typeof data.title !== "string") {
        const err13 = { instancePath: instancePath + "/title", schemaPath: "#/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err13];
        } else {
          vErrors.push(err13);
        }
        errors++;
      }
    }
    if (data.configuration !== void 0) {
      if (typeof data.configuration !== "string") {
        const err14 = { instancePath: instancePath + "/configuration", schemaPath: "#/properties/configuration/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err14];
        } else {
          vErrors.push(err14);
        }
        errors++;
      }
    }
    if (data.createdAt !== void 0) {
      let data5 = data.createdAt;
      if (typeof data5 === "string") {
        if (!pattern0.test(data5)) {
          const err15 = { instancePath: instancePath + "/createdAt", schemaPath: "#/properties/createdAt/pattern", keyword: "pattern", params: { pattern: "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, message: 'must match pattern "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"' };
          if (vErrors === null) {
            vErrors = [err15];
          } else {
            vErrors.push(err15);
          }
          errors++;
        }
        if (!formats0.validate(data5)) {
          const err16 = { instancePath: instancePath + "/createdAt", schemaPath: "#/properties/createdAt/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' };
          if (vErrors === null) {
            vErrors = [err16];
          } else {
            vErrors.push(err16);
          }
          errors++;
        }
      } else {
        const err17 = { instancePath: instancePath + "/createdAt", schemaPath: "#/properties/createdAt/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err17];
        } else {
          vErrors.push(err17);
        }
        errors++;
      }
    }
    if (data.updatedAt !== void 0) {
      let data6 = data.updatedAt;
      if (typeof data6 === "string") {
        if (!pattern0.test(data6)) {
          const err18 = { instancePath: instancePath + "/updatedAt", schemaPath: "#/properties/updatedAt/pattern", keyword: "pattern", params: { pattern: "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, message: 'must match pattern "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"' };
          if (vErrors === null) {
            vErrors = [err18];
          } else {
            vErrors.push(err18);
          }
          errors++;
        }
        if (!formats0.validate(data6)) {
          const err19 = { instancePath: instancePath + "/updatedAt", schemaPath: "#/properties/updatedAt/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' };
          if (vErrors === null) {
            vErrors = [err19];
          } else {
            vErrors.push(err19);
          }
          errors++;
        }
      } else {
        const err20 = { instancePath: instancePath + "/updatedAt", schemaPath: "#/properties/updatedAt/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err20];
        } else {
          vErrors.push(err20);
        }
        errors++;
      }
    }
    if (data.run !== void 0) {
      let data7 = data.run;
      if (data7 && typeof data7 == "object" && !Array.isArray(data7)) {
        if (data7.id === void 0) {
          const err21 = { instancePath: instancePath + "/run", schemaPath: "#/properties/run/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property 'id'" };
          if (vErrors === null) {
            vErrors = [err21];
          } else {
            vErrors.push(err21);
          }
          errors++;
        }
        if (data7.object === void 0) {
          const err22 = { instancePath: instancePath + "/run", schemaPath: "#/properties/run/required", keyword: "required", params: { missingProperty: "object" }, message: "must have required property 'object'" };
          if (vErrors === null) {
            vErrors = [err22];
          } else {
            vErrors.push(err22);
          }
          errors++;
        }
        if (data7.userId === void 0) {
          const err23 = { instancePath: instancePath + "/run", schemaPath: "#/properties/run/required", keyword: "required", params: { missingProperty: "userId" }, message: "must have required property 'userId'" };
          if (vErrors === null) {
            vErrors = [err23];
          } else {
            vErrors.push(err23);
          }
          errors++;
        }
        if (data7.prompt === void 0) {
          const err24 = { instancePath: instancePath + "/run", schemaPath: "#/properties/run/required", keyword: "required", params: { missingProperty: "prompt" }, message: "must have required property 'prompt'" };
          if (vErrors === null) {
            vErrors = [err24];
          } else {
            vErrors.push(err24);
          }
          errors++;
        }
        if (data7.status === void 0) {
          const err25 = { instancePath: instancePath + "/run", schemaPath: "#/properties/run/required", keyword: "required", params: { missingProperty: "status" }, message: "must have required property 'status'" };
          if (vErrors === null) {
            vErrors = [err25];
          } else {
            vErrors.push(err25);
          }
          errors++;
        }
        if (data7.output === void 0) {
          const err26 = { instancePath: instancePath + "/run", schemaPath: "#/properties/run/required", keyword: "required", params: { missingProperty: "output" }, message: "must have required property 'output'" };
          if (vErrors === null) {
            vErrors = [err26];
          } else {
            vErrors.push(err26);
          }
          errors++;
        }
        if (data7.error === void 0) {
          const err27 = { instancePath: instancePath + "/run", schemaPath: "#/properties/run/required", keyword: "required", params: { missingProperty: "error" }, message: "must have required property 'error'" };
          if (vErrors === null) {
            vErrors = [err27];
          } else {
            vErrors.push(err27);
          }
          errors++;
        }
        if (data7.createdAt === void 0) {
          const err28 = { instancePath: instancePath + "/run", schemaPath: "#/properties/run/required", keyword: "required", params: { missingProperty: "createdAt" }, message: "must have required property 'createdAt'" };
          if (vErrors === null) {
            vErrors = [err28];
          } else {
            vErrors.push(err28);
          }
          errors++;
        }
        if (data7.completedAt === void 0) {
          const err29 = { instancePath: instancePath + "/run", schemaPath: "#/properties/run/required", keyword: "required", params: { missingProperty: "completedAt" }, message: "must have required property 'completedAt'" };
          if (vErrors === null) {
            vErrors = [err29];
          } else {
            vErrors.push(err29);
          }
          errors++;
        }
        for (const key1 in data7) {
          if (!func6.call(schema39.properties.run.properties, key1)) {
            const err30 = { instancePath: instancePath + "/run", schemaPath: "#/properties/run/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
            if (vErrors === null) {
              vErrors = [err30];
            } else {
              vErrors.push(err30);
            }
            errors++;
          }
        }
        if (data7.id !== void 0) {
          if (typeof data7.id !== "string") {
            const err31 = { instancePath: instancePath + "/run/id", schemaPath: "#/properties/run/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err31];
            } else {
              vErrors.push(err31);
            }
            errors++;
          }
        }
        if (data7.object !== void 0) {
          let data9 = data7.object;
          if (typeof data9 !== "string") {
            const err32 = { instancePath: instancePath + "/run/object", schemaPath: "#/properties/run/properties/object/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err32];
            } else {
              vErrors.push(err32);
            }
            errors++;
          }
          if ("agent_run" !== data9) {
            const err33 = { instancePath: instancePath + "/run/object", schemaPath: "#/properties/run/properties/object/const", keyword: "const", params: { allowedValue: "agent_run" }, message: "must be equal to constant" };
            if (vErrors === null) {
              vErrors = [err33];
            } else {
              vErrors.push(err33);
            }
            errors++;
          }
        }
        if (data7.userId !== void 0) {
          if (typeof data7.userId !== "string") {
            const err34 = { instancePath: instancePath + "/run/userId", schemaPath: "#/properties/run/properties/userId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err34];
            } else {
              vErrors.push(err34);
            }
            errors++;
          }
        }
        if (data7.prompt !== void 0) {
          if (typeof data7.prompt !== "string") {
            const err35 = { instancePath: instancePath + "/run/prompt", schemaPath: "#/properties/run/properties/prompt/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err35];
            } else {
              vErrors.push(err35);
            }
            errors++;
          }
        }
        if (data7.status !== void 0) {
          let data12 = data7.status;
          if (typeof data12 !== "string") {
            const err36 = { instancePath: instancePath + "/run/status", schemaPath: "#/properties/run/properties/status/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err36];
            } else {
              vErrors.push(err36);
            }
            errors++;
          }
          if (!(data12 === "queued" || data12 === "running" || data12 === "completed" || data12 === "failed" || data12 === "cancelled")) {
            const err37 = { instancePath: instancePath + "/run/status", schemaPath: "#/properties/run/properties/status/enum", keyword: "enum", params: { allowedValues: schema39.properties.run.properties.status.enum }, message: "must be equal to one of the allowed values" };
            if (vErrors === null) {
              vErrors = [err37];
            } else {
              vErrors.push(err37);
            }
            errors++;
          }
        }
        if (data7.output !== void 0) {
          let data13 = data7.output;
          const _errs30 = errors;
          let valid2 = false;
          const _errs31 = errors;
          if (typeof data13 !== "string") {
            const err38 = { instancePath: instancePath + "/run/output", schemaPath: "#/properties/run/properties/output/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err38];
            } else {
              vErrors.push(err38);
            }
            errors++;
          }
          var _valid0 = _errs31 === errors;
          valid2 = valid2 || _valid0;
          if (!valid2) {
            const _errs33 = errors;
            if (data13 !== null) {
              const err39 = { instancePath: instancePath + "/run/output", schemaPath: "#/properties/run/properties/output/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
              if (vErrors === null) {
                vErrors = [err39];
              } else {
                vErrors.push(err39);
              }
              errors++;
            }
            var _valid0 = _errs33 === errors;
            valid2 = valid2 || _valid0;
          }
          if (!valid2) {
            const err40 = { instancePath: instancePath + "/run/output", schemaPath: "#/properties/run/properties/output/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
            if (vErrors === null) {
              vErrors = [err40];
            } else {
              vErrors.push(err40);
            }
            errors++;
          } else {
            errors = _errs30;
            if (vErrors !== null) {
              if (_errs30) {
                vErrors.length = _errs30;
              } else {
                vErrors = null;
              }
            }
          }
        }
        if (data7.error !== void 0) {
          let data14 = data7.error;
          const _errs36 = errors;
          let valid3 = false;
          const _errs37 = errors;
          if (typeof data14 !== "string") {
            const err41 = { instancePath: instancePath + "/run/error", schemaPath: "#/properties/run/properties/error/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err41];
            } else {
              vErrors.push(err41);
            }
            errors++;
          }
          var _valid1 = _errs37 === errors;
          valid3 = valid3 || _valid1;
          if (!valid3) {
            const _errs39 = errors;
            if (data14 !== null) {
              const err42 = { instancePath: instancePath + "/run/error", schemaPath: "#/properties/run/properties/error/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
              if (vErrors === null) {
                vErrors = [err42];
              } else {
                vErrors.push(err42);
              }
              errors++;
            }
            var _valid1 = _errs39 === errors;
            valid3 = valid3 || _valid1;
          }
          if (!valid3) {
            const err43 = { instancePath: instancePath + "/run/error", schemaPath: "#/properties/run/properties/error/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
            if (vErrors === null) {
              vErrors = [err43];
            } else {
              vErrors.push(err43);
            }
            errors++;
          } else {
            errors = _errs36;
            if (vErrors !== null) {
              if (_errs36) {
                vErrors.length = _errs36;
              } else {
                vErrors = null;
              }
            }
          }
        }
        if (data7.createdAt !== void 0) {
          let data15 = data7.createdAt;
          if (typeof data15 === "string") {
            if (!pattern0.test(data15)) {
              const err44 = { instancePath: instancePath + "/run/createdAt", schemaPath: "#/properties/run/properties/createdAt/pattern", keyword: "pattern", params: { pattern: "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, message: 'must match pattern "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"' };
              if (vErrors === null) {
                vErrors = [err44];
              } else {
                vErrors.push(err44);
              }
              errors++;
            }
            if (!formats0.validate(data15)) {
              const err45 = { instancePath: instancePath + "/run/createdAt", schemaPath: "#/properties/run/properties/createdAt/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' };
              if (vErrors === null) {
                vErrors = [err45];
              } else {
                vErrors.push(err45);
              }
              errors++;
            }
          } else {
            const err46 = { instancePath: instancePath + "/run/createdAt", schemaPath: "#/properties/run/properties/createdAt/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err46];
            } else {
              vErrors.push(err46);
            }
            errors++;
          }
        }
        if (data7.completedAt !== void 0) {
          let data16 = data7.completedAt;
          const _errs44 = errors;
          let valid4 = false;
          const _errs45 = errors;
          if (typeof data16 === "string") {
            if (!pattern0.test(data16)) {
              const err47 = { instancePath: instancePath + "/run/completedAt", schemaPath: "#/properties/run/properties/completedAt/anyOf/0/pattern", keyword: "pattern", params: { pattern: "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, message: 'must match pattern "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"' };
              if (vErrors === null) {
                vErrors = [err47];
              } else {
                vErrors.push(err47);
              }
              errors++;
            }
            if (!formats0.validate(data16)) {
              const err48 = { instancePath: instancePath + "/run/completedAt", schemaPath: "#/properties/run/properties/completedAt/anyOf/0/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' };
              if (vErrors === null) {
                vErrors = [err48];
              } else {
                vErrors.push(err48);
              }
              errors++;
            }
          } else {
            const err49 = { instancePath: instancePath + "/run/completedAt", schemaPath: "#/properties/run/properties/completedAt/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err49];
            } else {
              vErrors.push(err49);
            }
            errors++;
          }
          var _valid2 = _errs45 === errors;
          valid4 = valid4 || _valid2;
          if (!valid4) {
            const _errs47 = errors;
            if (data16 !== null) {
              const err50 = { instancePath: instancePath + "/run/completedAt", schemaPath: "#/properties/run/properties/completedAt/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
              if (vErrors === null) {
                vErrors = [err50];
              } else {
                vErrors.push(err50);
              }
              errors++;
            }
            var _valid2 = _errs47 === errors;
            valid4 = valid4 || _valid2;
          }
          if (!valid4) {
            const err51 = { instancePath: instancePath + "/run/completedAt", schemaPath: "#/properties/run/properties/completedAt/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
            if (vErrors === null) {
              vErrors = [err51];
            } else {
              vErrors.push(err51);
            }
            errors++;
          } else {
            errors = _errs44;
            if (vErrors !== null) {
              if (_errs44) {
                vErrors.length = _errs44;
              } else {
                vErrors = null;
              }
            }
          }
        }
      } else {
        const err52 = { instancePath: instancePath + "/run", schemaPath: "#/properties/run/type", keyword: "type", params: { type: "object" }, message: "must be object" };
        if (vErrors === null) {
          vErrors = [err52];
        } else {
          vErrors.push(err52);
        }
        errors++;
      }
    }
  } else {
    const err53 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err53];
    } else {
      vErrors.push(err53);
    }
    errors++;
  }
  validate33.errors = vErrors;
  return errors === 0;
}
var validateInput12 = validate34;
var schema40 = { "$schema": "http://json-schema.org/draft-07/schema#", "type": "object", "properties": { "id": { "type": "string", "minLength": 1 }, "runId": { "type": "string", "minLength": 1, "description": "A finished run of this conversation." }, "target": { "type": "string", "enum": ["reply", "case"] }, "rating": { "anyOf": [{ "type": "string", "enum": ["up", "down"] }, { "type": "null" }], "description": "null withdraws the rating." }, "note": { "description": "Only with a rating, not with a withdrawal.", "type": "string", "maxLength": 2e3 } }, "required": ["id", "runId", "target", "rating"], "additionalProperties": false };
function validate34(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.id === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property 'id'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.runId === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "runId" }, message: "must have required property 'runId'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.target === void 0) {
      const err2 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "target" }, message: "must have required property 'target'" };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.rating === void 0) {
      const err3 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "rating" }, message: "must have required property 'rating'" };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    for (const key0 in data) {
      if (!(key0 === "id" || key0 === "runId" || key0 === "target" || key0 === "rating" || key0 === "note")) {
        const err4 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
    if (data.id !== void 0) {
      let data0 = data.id;
      if (typeof data0 === "string") {
        if (func2(data0) < 1) {
          const err5 = { instancePath: instancePath + "/id", schemaPath: "#/properties/id/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
          if (vErrors === null) {
            vErrors = [err5];
          } else {
            vErrors.push(err5);
          }
          errors++;
        }
      } else {
        const err6 = { instancePath: instancePath + "/id", schemaPath: "#/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
    }
    if (data.runId !== void 0) {
      let data1 = data.runId;
      if (typeof data1 === "string") {
        if (func2(data1) < 1) {
          const err7 = { instancePath: instancePath + "/runId", schemaPath: "#/properties/runId/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
          if (vErrors === null) {
            vErrors = [err7];
          } else {
            vErrors.push(err7);
          }
          errors++;
        }
      } else {
        const err8 = { instancePath: instancePath + "/runId", schemaPath: "#/properties/runId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
    }
    if (data.target !== void 0) {
      let data2 = data.target;
      if (typeof data2 !== "string") {
        const err9 = { instancePath: instancePath + "/target", schemaPath: "#/properties/target/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
      if (!(data2 === "reply" || data2 === "case")) {
        const err10 = { instancePath: instancePath + "/target", schemaPath: "#/properties/target/enum", keyword: "enum", params: { allowedValues: schema40.properties.target.enum }, message: "must be equal to one of the allowed values" };
        if (vErrors === null) {
          vErrors = [err10];
        } else {
          vErrors.push(err10);
        }
        errors++;
      }
    }
    if (data.rating !== void 0) {
      let data3 = data.rating;
      const _errs9 = errors;
      let valid1 = false;
      const _errs10 = errors;
      if (typeof data3 !== "string") {
        const err11 = { instancePath: instancePath + "/rating", schemaPath: "#/properties/rating/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err11];
        } else {
          vErrors.push(err11);
        }
        errors++;
      }
      if (!(data3 === "up" || data3 === "down")) {
        const err12 = { instancePath: instancePath + "/rating", schemaPath: "#/properties/rating/anyOf/0/enum", keyword: "enum", params: { allowedValues: schema40.properties.rating.anyOf[0].enum }, message: "must be equal to one of the allowed values" };
        if (vErrors === null) {
          vErrors = [err12];
        } else {
          vErrors.push(err12);
        }
        errors++;
      }
      var _valid0 = _errs10 === errors;
      valid1 = valid1 || _valid0;
      if (!valid1) {
        const _errs12 = errors;
        if (data3 !== null) {
          const err13 = { instancePath: instancePath + "/rating", schemaPath: "#/properties/rating/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
          if (vErrors === null) {
            vErrors = [err13];
          } else {
            vErrors.push(err13);
          }
          errors++;
        }
        var _valid0 = _errs12 === errors;
        valid1 = valid1 || _valid0;
      }
      if (!valid1) {
        const err14 = { instancePath: instancePath + "/rating", schemaPath: "#/properties/rating/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
        if (vErrors === null) {
          vErrors = [err14];
        } else {
          vErrors.push(err14);
        }
        errors++;
      } else {
        errors = _errs9;
        if (vErrors !== null) {
          if (_errs9) {
            vErrors.length = _errs9;
          } else {
            vErrors = null;
          }
        }
      }
    }
    if (data.note !== void 0) {
      let data4 = data.note;
      if (typeof data4 === "string") {
        if (func2(data4) > 2e3) {
          const err15 = { instancePath: instancePath + "/note", schemaPath: "#/properties/note/maxLength", keyword: "maxLength", params: { limit: 2e3 }, message: "must NOT have more than 2000 characters" };
          if (vErrors === null) {
            vErrors = [err15];
          } else {
            vErrors.push(err15);
          }
          errors++;
        }
      } else {
        const err16 = { instancePath: instancePath + "/note", schemaPath: "#/properties/note/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err16];
        } else {
          vErrors.push(err16);
        }
        errors++;
      }
    }
  } else {
    const err17 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err17];
    } else {
      vErrors.push(err17);
    }
    errors++;
  }
  validate34.errors = vErrors;
  return errors === 0;
}
var validateOutput12 = validate35;
var schema41 = { "$schema": "http://json-schema.org/draft-07/schema#", "type": "object", "properties": { "object": { "type": "string", "const": "feedback" }, "runId": { "type": "string" }, "target": { "type": "string", "enum": ["reply", "case"] }, "rating": { "anyOf": [{ "type": "string", "enum": ["up", "down"] }, { "type": "null" }] }, "note": { "anyOf": [{ "type": "string" }, { "type": "null" }] }, "createdAt": { "type": "string", "format": "date-time", "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" } }, "required": ["object", "runId", "target", "rating", "note", "createdAt"], "additionalProperties": false };
function validate35(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.object === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "object" }, message: "must have required property 'object'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.runId === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "runId" }, message: "must have required property 'runId'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.target === void 0) {
      const err2 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "target" }, message: "must have required property 'target'" };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.rating === void 0) {
      const err3 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "rating" }, message: "must have required property 'rating'" };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.note === void 0) {
      const err4 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "note" }, message: "must have required property 'note'" };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
    if (data.createdAt === void 0) {
      const err5 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "createdAt" }, message: "must have required property 'createdAt'" };
      if (vErrors === null) {
        vErrors = [err5];
      } else {
        vErrors.push(err5);
      }
      errors++;
    }
    for (const key0 in data) {
      if (!(key0 === "object" || key0 === "runId" || key0 === "target" || key0 === "rating" || key0 === "note" || key0 === "createdAt")) {
        const err6 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
    }
    if (data.object !== void 0) {
      let data0 = data.object;
      if (typeof data0 !== "string") {
        const err7 = { instancePath: instancePath + "/object", schemaPath: "#/properties/object/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
      if ("feedback" !== data0) {
        const err8 = { instancePath: instancePath + "/object", schemaPath: "#/properties/object/const", keyword: "const", params: { allowedValue: "feedback" }, message: "must be equal to constant" };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
    }
    if (data.runId !== void 0) {
      if (typeof data.runId !== "string") {
        const err9 = { instancePath: instancePath + "/runId", schemaPath: "#/properties/runId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
    }
    if (data.target !== void 0) {
      let data2 = data.target;
      if (typeof data2 !== "string") {
        const err10 = { instancePath: instancePath + "/target", schemaPath: "#/properties/target/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err10];
        } else {
          vErrors.push(err10);
        }
        errors++;
      }
      if (!(data2 === "reply" || data2 === "case")) {
        const err11 = { instancePath: instancePath + "/target", schemaPath: "#/properties/target/enum", keyword: "enum", params: { allowedValues: schema41.properties.target.enum }, message: "must be equal to one of the allowed values" };
        if (vErrors === null) {
          vErrors = [err11];
        } else {
          vErrors.push(err11);
        }
        errors++;
      }
    }
    if (data.rating !== void 0) {
      let data3 = data.rating;
      const _errs9 = errors;
      let valid1 = false;
      const _errs10 = errors;
      if (typeof data3 !== "string") {
        const err12 = { instancePath: instancePath + "/rating", schemaPath: "#/properties/rating/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err12];
        } else {
          vErrors.push(err12);
        }
        errors++;
      }
      if (!(data3 === "up" || data3 === "down")) {
        const err13 = { instancePath: instancePath + "/rating", schemaPath: "#/properties/rating/anyOf/0/enum", keyword: "enum", params: { allowedValues: schema41.properties.rating.anyOf[0].enum }, message: "must be equal to one of the allowed values" };
        if (vErrors === null) {
          vErrors = [err13];
        } else {
          vErrors.push(err13);
        }
        errors++;
      }
      var _valid0 = _errs10 === errors;
      valid1 = valid1 || _valid0;
      if (!valid1) {
        const _errs12 = errors;
        if (data3 !== null) {
          const err14 = { instancePath: instancePath + "/rating", schemaPath: "#/properties/rating/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
          if (vErrors === null) {
            vErrors = [err14];
          } else {
            vErrors.push(err14);
          }
          errors++;
        }
        var _valid0 = _errs12 === errors;
        valid1 = valid1 || _valid0;
      }
      if (!valid1) {
        const err15 = { instancePath: instancePath + "/rating", schemaPath: "#/properties/rating/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
        if (vErrors === null) {
          vErrors = [err15];
        } else {
          vErrors.push(err15);
        }
        errors++;
      } else {
        errors = _errs9;
        if (vErrors !== null) {
          if (_errs9) {
            vErrors.length = _errs9;
          } else {
            vErrors = null;
          }
        }
      }
    }
    if (data.note !== void 0) {
      let data4 = data.note;
      const _errs15 = errors;
      let valid2 = false;
      const _errs16 = errors;
      if (typeof data4 !== "string") {
        const err16 = { instancePath: instancePath + "/note", schemaPath: "#/properties/note/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err16];
        } else {
          vErrors.push(err16);
        }
        errors++;
      }
      var _valid1 = _errs16 === errors;
      valid2 = valid2 || _valid1;
      if (!valid2) {
        const _errs18 = errors;
        if (data4 !== null) {
          const err17 = { instancePath: instancePath + "/note", schemaPath: "#/properties/note/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
          if (vErrors === null) {
            vErrors = [err17];
          } else {
            vErrors.push(err17);
          }
          errors++;
        }
        var _valid1 = _errs18 === errors;
        valid2 = valid2 || _valid1;
      }
      if (!valid2) {
        const err18 = { instancePath: instancePath + "/note", schemaPath: "#/properties/note/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
        if (vErrors === null) {
          vErrors = [err18];
        } else {
          vErrors.push(err18);
        }
        errors++;
      } else {
        errors = _errs15;
        if (vErrors !== null) {
          if (_errs15) {
            vErrors.length = _errs15;
          } else {
            vErrors = null;
          }
        }
      }
    }
    if (data.createdAt !== void 0) {
      let data5 = data.createdAt;
      if (typeof data5 === "string") {
        if (!pattern0.test(data5)) {
          const err19 = { instancePath: instancePath + "/createdAt", schemaPath: "#/properties/createdAt/pattern", keyword: "pattern", params: { pattern: "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, message: 'must match pattern "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"' };
          if (vErrors === null) {
            vErrors = [err19];
          } else {
            vErrors.push(err19);
          }
          errors++;
        }
        if (!formats0.validate(data5)) {
          const err20 = { instancePath: instancePath + "/createdAt", schemaPath: "#/properties/createdAt/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' };
          if (vErrors === null) {
            vErrors = [err20];
          } else {
            vErrors.push(err20);
          }
          errors++;
        }
      } else {
        const err21 = { instancePath: instancePath + "/createdAt", schemaPath: "#/properties/createdAt/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err21];
        } else {
          vErrors.push(err21);
        }
        errors++;
      }
    }
  } else {
    const err22 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err22];
    } else {
      vErrors.push(err22);
    }
    errors++;
  }
  validate35.errors = vErrors;
  return errors === 0;
}
var validateInput13 = validate36;
function validate36(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.id === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property 'id'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.prompt === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "prompt" }, message: "must have required property 'prompt'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    for (const key0 in data) {
      if (!(key0 === "id" || key0 === "prompt")) {
        const err2 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
    if (data.id !== void 0) {
      let data0 = data.id;
      if (typeof data0 === "string") {
        if (func2(data0) < 1) {
          const err3 = { instancePath: instancePath + "/id", schemaPath: "#/properties/id/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
          if (vErrors === null) {
            vErrors = [err3];
          } else {
            vErrors.push(err3);
          }
          errors++;
        }
      } else {
        const err4 = { instancePath: instancePath + "/id", schemaPath: "#/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
    if (data.prompt !== void 0) {
      let data1 = data.prompt;
      if (typeof data1 === "string") {
        if (func2(data1) > 2e4) {
          const err5 = { instancePath: instancePath + "/prompt", schemaPath: "#/properties/prompt/maxLength", keyword: "maxLength", params: { limit: 2e4 }, message: "must NOT have more than 20000 characters" };
          if (vErrors === null) {
            vErrors = [err5];
          } else {
            vErrors.push(err5);
          }
          errors++;
        }
        if (func2(data1) < 1) {
          const err6 = { instancePath: instancePath + "/prompt", schemaPath: "#/properties/prompt/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
          if (vErrors === null) {
            vErrors = [err6];
          } else {
            vErrors.push(err6);
          }
          errors++;
        }
      } else {
        const err7 = { instancePath: instancePath + "/prompt", schemaPath: "#/properties/prompt/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
    }
  } else {
    const err8 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err8];
    } else {
      vErrors.push(err8);
    }
    errors++;
  }
  validate36.errors = vErrors;
  return errors === 0;
}
var validateOutput13 = validate37;
var schema43 = { "$schema": "http://json-schema.org/draft-07/schema#", "type": "object", "properties": { "object": { "type": "string", "const": "message" }, "conversationId": { "type": "string" }, "role": { "type": "string", "const": "user" }, "content": { "type": "string" }, "run": { "type": "object", "properties": { "id": { "type": "string" }, "object": { "type": "string", "const": "agent_run" }, "userId": { "type": "string" }, "prompt": { "type": "string" }, "status": { "type": "string", "enum": ["queued", "running", "completed", "failed", "cancelled"] }, "output": { "anyOf": [{ "type": "string" }, { "type": "null" }] }, "error": { "anyOf": [{ "type": "string" }, { "type": "null" }] }, "createdAt": { "type": "string", "format": "date-time", "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, "completedAt": { "anyOf": [{ "type": "string", "format": "date-time", "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, { "type": "null" }] } }, "required": ["id", "object", "userId", "prompt", "status", "output", "error", "createdAt", "completedAt"], "additionalProperties": false } }, "required": ["object", "conversationId", "role", "content", "run"], "additionalProperties": false };
function validate37(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.object === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "object" }, message: "must have required property 'object'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.conversationId === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "conversationId" }, message: "must have required property 'conversationId'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.role === void 0) {
      const err2 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "role" }, message: "must have required property 'role'" };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.content === void 0) {
      const err3 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "content" }, message: "must have required property 'content'" };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.run === void 0) {
      const err4 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "run" }, message: "must have required property 'run'" };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
    for (const key0 in data) {
      if (!(key0 === "object" || key0 === "conversationId" || key0 === "role" || key0 === "content" || key0 === "run")) {
        const err5 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
    }
    if (data.object !== void 0) {
      let data0 = data.object;
      if (typeof data0 !== "string") {
        const err6 = { instancePath: instancePath + "/object", schemaPath: "#/properties/object/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
      if ("message" !== data0) {
        const err7 = { instancePath: instancePath + "/object", schemaPath: "#/properties/object/const", keyword: "const", params: { allowedValue: "message" }, message: "must be equal to constant" };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
    }
    if (data.conversationId !== void 0) {
      if (typeof data.conversationId !== "string") {
        const err8 = { instancePath: instancePath + "/conversationId", schemaPath: "#/properties/conversationId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
    }
    if (data.role !== void 0) {
      let data2 = data.role;
      if (typeof data2 !== "string") {
        const err9 = { instancePath: instancePath + "/role", schemaPath: "#/properties/role/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
      if ("user" !== data2) {
        const err10 = { instancePath: instancePath + "/role", schemaPath: "#/properties/role/const", keyword: "const", params: { allowedValue: "user" }, message: "must be equal to constant" };
        if (vErrors === null) {
          vErrors = [err10];
        } else {
          vErrors.push(err10);
        }
        errors++;
      }
    }
    if (data.content !== void 0) {
      if (typeof data.content !== "string") {
        const err11 = { instancePath: instancePath + "/content", schemaPath: "#/properties/content/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err11];
        } else {
          vErrors.push(err11);
        }
        errors++;
      }
    }
    if (data.run !== void 0) {
      let data4 = data.run;
      if (data4 && typeof data4 == "object" && !Array.isArray(data4)) {
        if (data4.id === void 0) {
          const err12 = { instancePath: instancePath + "/run", schemaPath: "#/properties/run/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property 'id'" };
          if (vErrors === null) {
            vErrors = [err12];
          } else {
            vErrors.push(err12);
          }
          errors++;
        }
        if (data4.object === void 0) {
          const err13 = { instancePath: instancePath + "/run", schemaPath: "#/properties/run/required", keyword: "required", params: { missingProperty: "object" }, message: "must have required property 'object'" };
          if (vErrors === null) {
            vErrors = [err13];
          } else {
            vErrors.push(err13);
          }
          errors++;
        }
        if (data4.userId === void 0) {
          const err14 = { instancePath: instancePath + "/run", schemaPath: "#/properties/run/required", keyword: "required", params: { missingProperty: "userId" }, message: "must have required property 'userId'" };
          if (vErrors === null) {
            vErrors = [err14];
          } else {
            vErrors.push(err14);
          }
          errors++;
        }
        if (data4.prompt === void 0) {
          const err15 = { instancePath: instancePath + "/run", schemaPath: "#/properties/run/required", keyword: "required", params: { missingProperty: "prompt" }, message: "must have required property 'prompt'" };
          if (vErrors === null) {
            vErrors = [err15];
          } else {
            vErrors.push(err15);
          }
          errors++;
        }
        if (data4.status === void 0) {
          const err16 = { instancePath: instancePath + "/run", schemaPath: "#/properties/run/required", keyword: "required", params: { missingProperty: "status" }, message: "must have required property 'status'" };
          if (vErrors === null) {
            vErrors = [err16];
          } else {
            vErrors.push(err16);
          }
          errors++;
        }
        if (data4.output === void 0) {
          const err17 = { instancePath: instancePath + "/run", schemaPath: "#/properties/run/required", keyword: "required", params: { missingProperty: "output" }, message: "must have required property 'output'" };
          if (vErrors === null) {
            vErrors = [err17];
          } else {
            vErrors.push(err17);
          }
          errors++;
        }
        if (data4.error === void 0) {
          const err18 = { instancePath: instancePath + "/run", schemaPath: "#/properties/run/required", keyword: "required", params: { missingProperty: "error" }, message: "must have required property 'error'" };
          if (vErrors === null) {
            vErrors = [err18];
          } else {
            vErrors.push(err18);
          }
          errors++;
        }
        if (data4.createdAt === void 0) {
          const err19 = { instancePath: instancePath + "/run", schemaPath: "#/properties/run/required", keyword: "required", params: { missingProperty: "createdAt" }, message: "must have required property 'createdAt'" };
          if (vErrors === null) {
            vErrors = [err19];
          } else {
            vErrors.push(err19);
          }
          errors++;
        }
        if (data4.completedAt === void 0) {
          const err20 = { instancePath: instancePath + "/run", schemaPath: "#/properties/run/required", keyword: "required", params: { missingProperty: "completedAt" }, message: "must have required property 'completedAt'" };
          if (vErrors === null) {
            vErrors = [err20];
          } else {
            vErrors.push(err20);
          }
          errors++;
        }
        for (const key1 in data4) {
          if (!func6.call(schema43.properties.run.properties, key1)) {
            const err21 = { instancePath: instancePath + "/run", schemaPath: "#/properties/run/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
            if (vErrors === null) {
              vErrors = [err21];
            } else {
              vErrors.push(err21);
            }
            errors++;
          }
        }
        if (data4.id !== void 0) {
          if (typeof data4.id !== "string") {
            const err22 = { instancePath: instancePath + "/run/id", schemaPath: "#/properties/run/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err22];
            } else {
              vErrors.push(err22);
            }
            errors++;
          }
        }
        if (data4.object !== void 0) {
          let data6 = data4.object;
          if (typeof data6 !== "string") {
            const err23 = { instancePath: instancePath + "/run/object", schemaPath: "#/properties/run/properties/object/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err23];
            } else {
              vErrors.push(err23);
            }
            errors++;
          }
          if ("agent_run" !== data6) {
            const err24 = { instancePath: instancePath + "/run/object", schemaPath: "#/properties/run/properties/object/const", keyword: "const", params: { allowedValue: "agent_run" }, message: "must be equal to constant" };
            if (vErrors === null) {
              vErrors = [err24];
            } else {
              vErrors.push(err24);
            }
            errors++;
          }
        }
        if (data4.userId !== void 0) {
          if (typeof data4.userId !== "string") {
            const err25 = { instancePath: instancePath + "/run/userId", schemaPath: "#/properties/run/properties/userId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err25];
            } else {
              vErrors.push(err25);
            }
            errors++;
          }
        }
        if (data4.prompt !== void 0) {
          if (typeof data4.prompt !== "string") {
            const err26 = { instancePath: instancePath + "/run/prompt", schemaPath: "#/properties/run/properties/prompt/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err26];
            } else {
              vErrors.push(err26);
            }
            errors++;
          }
        }
        if (data4.status !== void 0) {
          let data9 = data4.status;
          if (typeof data9 !== "string") {
            const err27 = { instancePath: instancePath + "/run/status", schemaPath: "#/properties/run/properties/status/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err27];
            } else {
              vErrors.push(err27);
            }
            errors++;
          }
          if (!(data9 === "queued" || data9 === "running" || data9 === "completed" || data9 === "failed" || data9 === "cancelled")) {
            const err28 = { instancePath: instancePath + "/run/status", schemaPath: "#/properties/run/properties/status/enum", keyword: "enum", params: { allowedValues: schema43.properties.run.properties.status.enum }, message: "must be equal to one of the allowed values" };
            if (vErrors === null) {
              vErrors = [err28];
            } else {
              vErrors.push(err28);
            }
            errors++;
          }
        }
        if (data4.output !== void 0) {
          let data10 = data4.output;
          const _errs24 = errors;
          let valid2 = false;
          const _errs25 = errors;
          if (typeof data10 !== "string") {
            const err29 = { instancePath: instancePath + "/run/output", schemaPath: "#/properties/run/properties/output/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err29];
            } else {
              vErrors.push(err29);
            }
            errors++;
          }
          var _valid0 = _errs25 === errors;
          valid2 = valid2 || _valid0;
          if (!valid2) {
            const _errs27 = errors;
            if (data10 !== null) {
              const err30 = { instancePath: instancePath + "/run/output", schemaPath: "#/properties/run/properties/output/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
              if (vErrors === null) {
                vErrors = [err30];
              } else {
                vErrors.push(err30);
              }
              errors++;
            }
            var _valid0 = _errs27 === errors;
            valid2 = valid2 || _valid0;
          }
          if (!valid2) {
            const err31 = { instancePath: instancePath + "/run/output", schemaPath: "#/properties/run/properties/output/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
            if (vErrors === null) {
              vErrors = [err31];
            } else {
              vErrors.push(err31);
            }
            errors++;
          } else {
            errors = _errs24;
            if (vErrors !== null) {
              if (_errs24) {
                vErrors.length = _errs24;
              } else {
                vErrors = null;
              }
            }
          }
        }
        if (data4.error !== void 0) {
          let data11 = data4.error;
          const _errs30 = errors;
          let valid3 = false;
          const _errs31 = errors;
          if (typeof data11 !== "string") {
            const err32 = { instancePath: instancePath + "/run/error", schemaPath: "#/properties/run/properties/error/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err32];
            } else {
              vErrors.push(err32);
            }
            errors++;
          }
          var _valid1 = _errs31 === errors;
          valid3 = valid3 || _valid1;
          if (!valid3) {
            const _errs33 = errors;
            if (data11 !== null) {
              const err33 = { instancePath: instancePath + "/run/error", schemaPath: "#/properties/run/properties/error/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
              if (vErrors === null) {
                vErrors = [err33];
              } else {
                vErrors.push(err33);
              }
              errors++;
            }
            var _valid1 = _errs33 === errors;
            valid3 = valid3 || _valid1;
          }
          if (!valid3) {
            const err34 = { instancePath: instancePath + "/run/error", schemaPath: "#/properties/run/properties/error/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
            if (vErrors === null) {
              vErrors = [err34];
            } else {
              vErrors.push(err34);
            }
            errors++;
          } else {
            errors = _errs30;
            if (vErrors !== null) {
              if (_errs30) {
                vErrors.length = _errs30;
              } else {
                vErrors = null;
              }
            }
          }
        }
        if (data4.createdAt !== void 0) {
          let data12 = data4.createdAt;
          if (typeof data12 === "string") {
            if (!pattern0.test(data12)) {
              const err35 = { instancePath: instancePath + "/run/createdAt", schemaPath: "#/properties/run/properties/createdAt/pattern", keyword: "pattern", params: { pattern: "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, message: 'must match pattern "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"' };
              if (vErrors === null) {
                vErrors = [err35];
              } else {
                vErrors.push(err35);
              }
              errors++;
            }
            if (!formats0.validate(data12)) {
              const err36 = { instancePath: instancePath + "/run/createdAt", schemaPath: "#/properties/run/properties/createdAt/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' };
              if (vErrors === null) {
                vErrors = [err36];
              } else {
                vErrors.push(err36);
              }
              errors++;
            }
          } else {
            const err37 = { instancePath: instancePath + "/run/createdAt", schemaPath: "#/properties/run/properties/createdAt/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err37];
            } else {
              vErrors.push(err37);
            }
            errors++;
          }
        }
        if (data4.completedAt !== void 0) {
          let data13 = data4.completedAt;
          const _errs38 = errors;
          let valid4 = false;
          const _errs39 = errors;
          if (typeof data13 === "string") {
            if (!pattern0.test(data13)) {
              const err38 = { instancePath: instancePath + "/run/completedAt", schemaPath: "#/properties/run/properties/completedAt/anyOf/0/pattern", keyword: "pattern", params: { pattern: "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, message: 'must match pattern "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"' };
              if (vErrors === null) {
                vErrors = [err38];
              } else {
                vErrors.push(err38);
              }
              errors++;
            }
            if (!formats0.validate(data13)) {
              const err39 = { instancePath: instancePath + "/run/completedAt", schemaPath: "#/properties/run/properties/completedAt/anyOf/0/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' };
              if (vErrors === null) {
                vErrors = [err39];
              } else {
                vErrors.push(err39);
              }
              errors++;
            }
          } else {
            const err40 = { instancePath: instancePath + "/run/completedAt", schemaPath: "#/properties/run/properties/completedAt/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err40];
            } else {
              vErrors.push(err40);
            }
            errors++;
          }
          var _valid2 = _errs39 === errors;
          valid4 = valid4 || _valid2;
          if (!valid4) {
            const _errs41 = errors;
            if (data13 !== null) {
              const err41 = { instancePath: instancePath + "/run/completedAt", schemaPath: "#/properties/run/properties/completedAt/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
              if (vErrors === null) {
                vErrors = [err41];
              } else {
                vErrors.push(err41);
              }
              errors++;
            }
            var _valid2 = _errs41 === errors;
            valid4 = valid4 || _valid2;
          }
          if (!valid4) {
            const err42 = { instancePath: instancePath + "/run/completedAt", schemaPath: "#/properties/run/properties/completedAt/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
            if (vErrors === null) {
              vErrors = [err42];
            } else {
              vErrors.push(err42);
            }
            errors++;
          } else {
            errors = _errs38;
            if (vErrors !== null) {
              if (_errs38) {
                vErrors.length = _errs38;
              } else {
                vErrors = null;
              }
            }
          }
        }
      } else {
        const err43 = { instancePath: instancePath + "/run", schemaPath: "#/properties/run/type", keyword: "type", params: { type: "object" }, message: "must be object" };
        if (vErrors === null) {
          vErrors = [err43];
        } else {
          vErrors.push(err43);
        }
        errors++;
      }
    }
  } else {
    const err44 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err44];
    } else {
      vErrors.push(err44);
    }
    errors++;
  }
  validate37.errors = vErrors;
  return errors === 0;
}
var validateInput14 = validate38;
function validate38(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.path === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "path" }, message: "must have required property 'path'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.content === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "content" }, message: "must have required property 'content'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    for (const key0 in data) {
      if (!(key0 === "path" || key0 === "content" || key0 === "ifMatch")) {
        const err2 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
    if (data.path !== void 0) {
      let data0 = data.path;
      if (typeof data0 === "string") {
        if (func2(data0) > 1024) {
          const err3 = { instancePath: instancePath + "/path", schemaPath: "#/properties/path/maxLength", keyword: "maxLength", params: { limit: 1024 }, message: "must NOT have more than 1024 characters" };
          if (vErrors === null) {
            vErrors = [err3];
          } else {
            vErrors.push(err3);
          }
          errors++;
        }
        if (func2(data0) < 1) {
          const err4 = { instancePath: instancePath + "/path", schemaPath: "#/properties/path/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
          if (vErrors === null) {
            vErrors = [err4];
          } else {
            vErrors.push(err4);
          }
          errors++;
        }
      } else {
        const err5 = { instancePath: instancePath + "/path", schemaPath: "#/properties/path/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
    }
    if (data.content !== void 0) {
      if (typeof data.content !== "string") {
        const err6 = { instancePath: instancePath + "/content", schemaPath: "#/properties/content/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
    }
    if (data.ifMatch !== void 0) {
      let data2 = data.ifMatch;
      if (typeof data2 === "string") {
        if (func2(data2) < 1) {
          const err7 = { instancePath: instancePath + "/ifMatch", schemaPath: "#/properties/ifMatch/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
          if (vErrors === null) {
            vErrors = [err7];
          } else {
            vErrors.push(err7);
          }
          errors++;
        }
      } else {
        const err8 = { instancePath: instancePath + "/ifMatch", schemaPath: "#/properties/ifMatch/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
    }
  } else {
    const err9 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err9];
    } else {
      vErrors.push(err9);
    }
    errors++;
  }
  validate38.errors = vErrors;
  return errors === 0;
}
var validateOutput14 = validate39;
function validate39(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.object === void 0) {
      const err0 = { instancePath, schemaPath: "#/definitions/File/required", keyword: "required", params: { missingProperty: "object" }, message: "must have required property 'object'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.path === void 0) {
      const err1 = { instancePath, schemaPath: "#/definitions/File/required", keyword: "required", params: { missingProperty: "path" }, message: "must have required property 'path'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.mimeType === void 0) {
      const err2 = { instancePath, schemaPath: "#/definitions/File/required", keyword: "required", params: { missingProperty: "mimeType" }, message: "must have required property 'mimeType'" };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.size === void 0) {
      const err3 = { instancePath, schemaPath: "#/definitions/File/required", keyword: "required", params: { missingProperty: "size" }, message: "must have required property 'size'" };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.etag === void 0) {
      const err4 = { instancePath, schemaPath: "#/definitions/File/required", keyword: "required", params: { missingProperty: "etag" }, message: "must have required property 'etag'" };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
    if (data.updatedAt === void 0) {
      const err5 = { instancePath, schemaPath: "#/definitions/File/required", keyword: "required", params: { missingProperty: "updatedAt" }, message: "must have required property 'updatedAt'" };
      if (vErrors === null) {
        vErrors = [err5];
      } else {
        vErrors.push(err5);
      }
      errors++;
    }
    for (const key0 in data) {
      if (!(key0 === "object" || key0 === "path" || key0 === "mimeType" || key0 === "size" || key0 === "etag" || key0 === "updatedAt")) {
        const err6 = { instancePath, schemaPath: "#/definitions/File/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
    }
    if (data.object !== void 0) {
      let data0 = data.object;
      if (typeof data0 !== "string") {
        const err7 = { instancePath: instancePath + "/object", schemaPath: "#/definitions/File/properties/object/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
      if ("file" !== data0) {
        const err8 = { instancePath: instancePath + "/object", schemaPath: "#/definitions/File/properties/object/const", keyword: "const", params: { allowedValue: "file" }, message: "must be equal to constant" };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
    }
    if (data.path !== void 0) {
      if (typeof data.path !== "string") {
        const err9 = { instancePath: instancePath + "/path", schemaPath: "#/definitions/File/properties/path/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
    }
    if (data.mimeType !== void 0) {
      if (typeof data.mimeType !== "string") {
        const err10 = { instancePath: instancePath + "/mimeType", schemaPath: "#/definitions/File/properties/mimeType/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err10];
        } else {
          vErrors.push(err10);
        }
        errors++;
      }
    }
    if (data.size !== void 0) {
      let data3 = data.size;
      if (!(typeof data3 == "number" && (!(data3 % 1) && !isNaN(data3)) && isFinite(data3))) {
        const err11 = { instancePath: instancePath + "/size", schemaPath: "#/definitions/File/properties/size/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
        if (vErrors === null) {
          vErrors = [err11];
        } else {
          vErrors.push(err11);
        }
        errors++;
      }
      if (typeof data3 == "number" && isFinite(data3)) {
        if (data3 > 9007199254740991 || isNaN(data3)) {
          const err12 = { instancePath: instancePath + "/size", schemaPath: "#/definitions/File/properties/size/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
          if (vErrors === null) {
            vErrors = [err12];
          } else {
            vErrors.push(err12);
          }
          errors++;
        }
        if (data3 < 0 || isNaN(data3)) {
          const err13 = { instancePath: instancePath + "/size", schemaPath: "#/definitions/File/properties/size/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
          if (vErrors === null) {
            vErrors = [err13];
          } else {
            vErrors.push(err13);
          }
          errors++;
        }
      }
    }
    if (data.etag !== void 0) {
      if (typeof data.etag !== "string") {
        const err14 = { instancePath: instancePath + "/etag", schemaPath: "#/definitions/File/properties/etag/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err14];
        } else {
          vErrors.push(err14);
        }
        errors++;
      }
    }
    if (data.updatedAt !== void 0) {
      let data5 = data.updatedAt;
      if (typeof data5 === "string") {
        if (!pattern0.test(data5)) {
          const err15 = { instancePath: instancePath + "/updatedAt", schemaPath: "#/definitions/File/properties/updatedAt/pattern", keyword: "pattern", params: { pattern: "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, message: 'must match pattern "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"' };
          if (vErrors === null) {
            vErrors = [err15];
          } else {
            vErrors.push(err15);
          }
          errors++;
        }
        if (!formats0.validate(data5)) {
          const err16 = { instancePath: instancePath + "/updatedAt", schemaPath: "#/definitions/File/properties/updatedAt/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' };
          if (vErrors === null) {
            vErrors = [err16];
          } else {
            vErrors.push(err16);
          }
          errors++;
        }
      } else {
        const err17 = { instancePath: instancePath + "/updatedAt", schemaPath: "#/definitions/File/properties/updatedAt/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err17];
        } else {
          vErrors.push(err17);
        }
        errors++;
      }
    }
  } else {
    const err18 = { instancePath, schemaPath: "#/definitions/File/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err18];
    } else {
      vErrors.push(err18);
    }
    errors++;
  }
  validate39.errors = vErrors;
  return errors === 0;
}
var validateInput15 = validate40;
var schema47 = { "$schema": "http://json-schema.org/draft-07/schema#", "type": "object", "properties": { "audioBase64": { "type": "string", "minLength": 1, "maxLength": 4e6 }, "format": { "type": "string", "enum": ["webm", "wav", "ogg", "mp3", "m4a", "flac", "aac"] } }, "required": ["audioBase64", "format"], "additionalProperties": false };
function validate40(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.audioBase64 === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "audioBase64" }, message: "must have required property 'audioBase64'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.format === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "format" }, message: "must have required property 'format'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    for (const key0 in data) {
      if (!(key0 === "audioBase64" || key0 === "format")) {
        const err2 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
    if (data.audioBase64 !== void 0) {
      let data0 = data.audioBase64;
      if (typeof data0 === "string") {
        if (func2(data0) > 4e6) {
          const err3 = { instancePath: instancePath + "/audioBase64", schemaPath: "#/properties/audioBase64/maxLength", keyword: "maxLength", params: { limit: 4e6 }, message: "must NOT have more than 4000000 characters" };
          if (vErrors === null) {
            vErrors = [err3];
          } else {
            vErrors.push(err3);
          }
          errors++;
        }
        if (func2(data0) < 1) {
          const err4 = { instancePath: instancePath + "/audioBase64", schemaPath: "#/properties/audioBase64/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
          if (vErrors === null) {
            vErrors = [err4];
          } else {
            vErrors.push(err4);
          }
          errors++;
        }
      } else {
        const err5 = { instancePath: instancePath + "/audioBase64", schemaPath: "#/properties/audioBase64/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
    }
    if (data.format !== void 0) {
      let data1 = data.format;
      if (typeof data1 !== "string") {
        const err6 = { instancePath: instancePath + "/format", schemaPath: "#/properties/format/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
      if (!(data1 === "webm" || data1 === "wav" || data1 === "ogg" || data1 === "mp3" || data1 === "m4a" || data1 === "flac" || data1 === "aac")) {
        const err7 = { instancePath: instancePath + "/format", schemaPath: "#/properties/format/enum", keyword: "enum", params: { allowedValues: schema47.properties.format.enum }, message: "must be equal to one of the allowed values" };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
    }
  } else {
    const err8 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err8];
    } else {
      vErrors.push(err8);
    }
    errors++;
  }
  validate40.errors = vErrors;
  return errors === 0;
}
var validateOutput15 = validate41;
function validate41(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.object === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "object" }, message: "must have required property 'object'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.text === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "text" }, message: "must have required property 'text'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.language === void 0) {
      const err2 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "language" }, message: "must have required property 'language'" };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.durationS === void 0) {
      const err3 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "durationS" }, message: "must have required property 'durationS'" };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    for (const key0 in data) {
      if (!(key0 === "object" || key0 === "text" || key0 === "language" || key0 === "durationS")) {
        const err4 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
    if (data.object !== void 0) {
      let data0 = data.object;
      if (typeof data0 !== "string") {
        const err5 = { instancePath: instancePath + "/object", schemaPath: "#/properties/object/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
      if ("transcription" !== data0) {
        const err6 = { instancePath: instancePath + "/object", schemaPath: "#/properties/object/const", keyword: "const", params: { allowedValue: "transcription" }, message: "must be equal to constant" };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
    }
    if (data.text !== void 0) {
      if (typeof data.text !== "string") {
        const err7 = { instancePath: instancePath + "/text", schemaPath: "#/properties/text/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
    }
    if (data.language !== void 0) {
      let data2 = data.language;
      const _errs7 = errors;
      let valid1 = false;
      const _errs8 = errors;
      if (typeof data2 !== "string") {
        const err8 = { instancePath: instancePath + "/language", schemaPath: "#/properties/language/anyOf/0/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
      var _valid0 = _errs8 === errors;
      valid1 = valid1 || _valid0;
      if (!valid1) {
        const _errs10 = errors;
        if (data2 !== null) {
          const err9 = { instancePath: instancePath + "/language", schemaPath: "#/properties/language/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
          if (vErrors === null) {
            vErrors = [err9];
          } else {
            vErrors.push(err9);
          }
          errors++;
        }
        var _valid0 = _errs10 === errors;
        valid1 = valid1 || _valid0;
      }
      if (!valid1) {
        const err10 = { instancePath: instancePath + "/language", schemaPath: "#/properties/language/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
        if (vErrors === null) {
          vErrors = [err10];
        } else {
          vErrors.push(err10);
        }
        errors++;
      } else {
        errors = _errs7;
        if (vErrors !== null) {
          if (_errs7) {
            vErrors.length = _errs7;
          } else {
            vErrors = null;
          }
        }
      }
    }
    if (data.durationS !== void 0) {
      let data3 = data.durationS;
      const _errs13 = errors;
      let valid2 = false;
      const _errs14 = errors;
      if (!(typeof data3 == "number" && isFinite(data3))) {
        const err11 = { instancePath: instancePath + "/durationS", schemaPath: "#/properties/durationS/anyOf/0/type", keyword: "type", params: { type: "number" }, message: "must be number" };
        if (vErrors === null) {
          vErrors = [err11];
        } else {
          vErrors.push(err11);
        }
        errors++;
      }
      var _valid1 = _errs14 === errors;
      valid2 = valid2 || _valid1;
      if (!valid2) {
        const _errs16 = errors;
        if (data3 !== null) {
          const err12 = { instancePath: instancePath + "/durationS", schemaPath: "#/properties/durationS/anyOf/1/type", keyword: "type", params: { type: "null" }, message: "must be null" };
          if (vErrors === null) {
            vErrors = [err12];
          } else {
            vErrors.push(err12);
          }
          errors++;
        }
        var _valid1 = _errs16 === errors;
        valid2 = valid2 || _valid1;
      }
      if (!valid2) {
        const err13 = { instancePath: instancePath + "/durationS", schemaPath: "#/properties/durationS/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
        if (vErrors === null) {
          vErrors = [err13];
        } else {
          vErrors.push(err13);
        }
        errors++;
      } else {
        errors = _errs13;
        if (vErrors !== null) {
          if (_errs13) {
            vErrors.length = _errs13;
          } else {
            vErrors = null;
          }
        }
      }
    }
  } else {
    const err14 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err14];
    } else {
      vErrors.push(err14);
    }
    errors++;
  }
  validate41.errors = vErrors;
  return errors === 0;
}
var validateInput16 = validate42;
var schema49 = { "$schema": "http://json-schema.org/draft-07/schema#", "type": "object", "properties": { "conversationId": { "type": "string", "minLength": 1, "description": "The conversation the case belongs to; the agent's is named in its prompt." }, "findings": { "type": "array", "items": { "type": "object", "properties": { "fdi": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991, "description": "The tooth, by FDI number (11\u201348)." }, "jaw": { "type": "string", "enum": ["OK", "UK"], "description": "The jaw: OK upper, UK lower." }, "fact": { "type": "string", "enum": ["fehlt", "erhaltungswuerdig", "krone", "endodontisch_behandelt", "stiftaufbau", "brueckenanker", "disparallel", "wiederherstellung", "geplant", "lueckensituation_i"], "description": "A finding, by name: at a tooth, or at a jaw (lueckensituation_i)." }, "value": { "anyOf": [{ "type": "boolean" }, { "type": "string" }] } }, "required": ["fact", "value"], "additionalProperties": false } }, "counts": { "type": "array", "items": { "type": "object", "properties": { "at": { "type": "string", "description": `Where the line is billed, as the costs list it: a tooth's number ("12"), a gap's id ("UK:45-47"), a jaw, or "patient".` }, "nr": { "type": "string", "description": "The BEMA number, e.g. 20b." }, "value": { "type": "integer", "minimum": 1, "maximum": 99, "description": "How often it goes on the HKP." } }, "required": ["at", "nr", "value"], "additionalProperties": false } }, "bonus": { "type": "string", "enum": ["prozent60", "prozent70", "prozent75", "prozent100"], "description": "The Festzuschuss level from the patient's Bonusheft: 60 % without bonus, 70 % and 75 % with, 100 % for hardship." }, "kostentraeger": { "type": "string", "enum": ["gkv_kzv_bw"], "description": "Who pays: statutory insurance, billed at the KZV Baden-W\xFCrttemberg's prices, the only one the rules cover." } }, "required": ["conversationId"], "additionalProperties": false };
function validate42(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.conversationId === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "conversationId" }, message: "must have required property 'conversationId'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    for (const key0 in data) {
      if (!(key0 === "conversationId" || key0 === "findings" || key0 === "counts" || key0 === "bonus" || key0 === "kostentraeger")) {
        const err1 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
    }
    if (data.conversationId !== void 0) {
      let data0 = data.conversationId;
      if (typeof data0 === "string") {
        if (func2(data0) < 1) {
          const err2 = { instancePath: instancePath + "/conversationId", schemaPath: "#/properties/conversationId/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
          if (vErrors === null) {
            vErrors = [err2];
          } else {
            vErrors.push(err2);
          }
          errors++;
        }
      } else {
        const err3 = { instancePath: instancePath + "/conversationId", schemaPath: "#/properties/conversationId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.findings !== void 0) {
      let data1 = data.findings;
      if (Array.isArray(data1)) {
        const len0 = data1.length;
        for (let i0 = 0; i0 < len0; i0++) {
          let data2 = data1[i0];
          if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
            if (data2.fact === void 0) {
              const err4 = { instancePath: instancePath + "/findings/" + i0, schemaPath: "#/properties/findings/items/required", keyword: "required", params: { missingProperty: "fact" }, message: "must have required property 'fact'" };
              if (vErrors === null) {
                vErrors = [err4];
              } else {
                vErrors.push(err4);
              }
              errors++;
            }
            if (data2.value === void 0) {
              const err5 = { instancePath: instancePath + "/findings/" + i0, schemaPath: "#/properties/findings/items/required", keyword: "required", params: { missingProperty: "value" }, message: "must have required property 'value'" };
              if (vErrors === null) {
                vErrors = [err5];
              } else {
                vErrors.push(err5);
              }
              errors++;
            }
            for (const key1 in data2) {
              if (!(key1 === "fdi" || key1 === "jaw" || key1 === "fact" || key1 === "value")) {
                const err6 = { instancePath: instancePath + "/findings/" + i0, schemaPath: "#/properties/findings/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
                if (vErrors === null) {
                  vErrors = [err6];
                } else {
                  vErrors.push(err6);
                }
                errors++;
              }
            }
            if (data2.fdi !== void 0) {
              let data3 = data2.fdi;
              if (!(typeof data3 == "number" && (!(data3 % 1) && !isNaN(data3)) && isFinite(data3))) {
                const err7 = { instancePath: instancePath + "/findings/" + i0 + "/fdi", schemaPath: "#/properties/findings/items/properties/fdi/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                if (vErrors === null) {
                  vErrors = [err7];
                } else {
                  vErrors.push(err7);
                }
                errors++;
              }
              if (typeof data3 == "number" && isFinite(data3)) {
                if (data3 > 9007199254740991 || isNaN(data3)) {
                  const err8 = { instancePath: instancePath + "/findings/" + i0 + "/fdi", schemaPath: "#/properties/findings/items/properties/fdi/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err8];
                  } else {
                    vErrors.push(err8);
                  }
                  errors++;
                }
                if (data3 < -9007199254740991 || isNaN(data3)) {
                  const err9 = { instancePath: instancePath + "/findings/" + i0 + "/fdi", schemaPath: "#/properties/findings/items/properties/fdi/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err9];
                  } else {
                    vErrors.push(err9);
                  }
                  errors++;
                }
              }
            }
            if (data2.jaw !== void 0) {
              let data4 = data2.jaw;
              if (typeof data4 !== "string") {
                const err10 = { instancePath: instancePath + "/findings/" + i0 + "/jaw", schemaPath: "#/properties/findings/items/properties/jaw/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err10];
                } else {
                  vErrors.push(err10);
                }
                errors++;
              }
              if (!(data4 === "OK" || data4 === "UK")) {
                const err11 = { instancePath: instancePath + "/findings/" + i0 + "/jaw", schemaPath: "#/properties/findings/items/properties/jaw/enum", keyword: "enum", params: { allowedValues: schema49.properties.findings.items.properties.jaw.enum }, message: "must be equal to one of the allowed values" };
                if (vErrors === null) {
                  vErrors = [err11];
                } else {
                  vErrors.push(err11);
                }
                errors++;
              }
            }
            if (data2.fact !== void 0) {
              let data5 = data2.fact;
              if (typeof data5 !== "string") {
                const err12 = { instancePath: instancePath + "/findings/" + i0 + "/fact", schemaPath: "#/properties/findings/items/properties/fact/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err12];
                } else {
                  vErrors.push(err12);
                }
                errors++;
              }
              if (!(data5 === "fehlt" || data5 === "erhaltungswuerdig" || data5 === "krone" || data5 === "endodontisch_behandelt" || data5 === "stiftaufbau" || data5 === "brueckenanker" || data5 === "disparallel" || data5 === "wiederherstellung" || data5 === "geplant" || data5 === "lueckensituation_i")) {
                const err13 = { instancePath: instancePath + "/findings/" + i0 + "/fact", schemaPath: "#/properties/findings/items/properties/fact/enum", keyword: "enum", params: { allowedValues: schema49.properties.findings.items.properties.fact.enum }, message: "must be equal to one of the allowed values" };
                if (vErrors === null) {
                  vErrors = [err13];
                } else {
                  vErrors.push(err13);
                }
                errors++;
              }
            }
            if (data2.value !== void 0) {
              let data6 = data2.value;
              const _errs16 = errors;
              let valid4 = false;
              const _errs17 = errors;
              if (typeof data6 !== "boolean") {
                const err14 = { instancePath: instancePath + "/findings/" + i0 + "/value", schemaPath: "#/properties/findings/items/properties/value/anyOf/0/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                if (vErrors === null) {
                  vErrors = [err14];
                } else {
                  vErrors.push(err14);
                }
                errors++;
              }
              var _valid0 = _errs17 === errors;
              valid4 = valid4 || _valid0;
              if (!valid4) {
                const _errs19 = errors;
                if (typeof data6 !== "string") {
                  const err15 = { instancePath: instancePath + "/findings/" + i0 + "/value", schemaPath: "#/properties/findings/items/properties/value/anyOf/1/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                  if (vErrors === null) {
                    vErrors = [err15];
                  } else {
                    vErrors.push(err15);
                  }
                  errors++;
                }
                var _valid0 = _errs19 === errors;
                valid4 = valid4 || _valid0;
              }
              if (!valid4) {
                const err16 = { instancePath: instancePath + "/findings/" + i0 + "/value", schemaPath: "#/properties/findings/items/properties/value/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                if (vErrors === null) {
                  vErrors = [err16];
                } else {
                  vErrors.push(err16);
                }
                errors++;
              } else {
                errors = _errs16;
                if (vErrors !== null) {
                  if (_errs16) {
                    vErrors.length = _errs16;
                  } else {
                    vErrors = null;
                  }
                }
              }
            }
          } else {
            const err17 = { instancePath: instancePath + "/findings/" + i0, schemaPath: "#/properties/findings/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
              vErrors = [err17];
            } else {
              vErrors.push(err17);
            }
            errors++;
          }
        }
      } else {
        const err18 = { instancePath: instancePath + "/findings", schemaPath: "#/properties/findings/type", keyword: "type", params: { type: "array" }, message: "must be array" };
        if (vErrors === null) {
          vErrors = [err18];
        } else {
          vErrors.push(err18);
        }
        errors++;
      }
    }
    if (data.counts !== void 0) {
      let data7 = data.counts;
      if (Array.isArray(data7)) {
        const len1 = data7.length;
        for (let i1 = 0; i1 < len1; i1++) {
          let data8 = data7[i1];
          if (data8 && typeof data8 == "object" && !Array.isArray(data8)) {
            if (data8.at === void 0) {
              const err19 = { instancePath: instancePath + "/counts/" + i1, schemaPath: "#/properties/counts/items/required", keyword: "required", params: { missingProperty: "at" }, message: "must have required property 'at'" };
              if (vErrors === null) {
                vErrors = [err19];
              } else {
                vErrors.push(err19);
              }
              errors++;
            }
            if (data8.nr === void 0) {
              const err20 = { instancePath: instancePath + "/counts/" + i1, schemaPath: "#/properties/counts/items/required", keyword: "required", params: { missingProperty: "nr" }, message: "must have required property 'nr'" };
              if (vErrors === null) {
                vErrors = [err20];
              } else {
                vErrors.push(err20);
              }
              errors++;
            }
            if (data8.value === void 0) {
              const err21 = { instancePath: instancePath + "/counts/" + i1, schemaPath: "#/properties/counts/items/required", keyword: "required", params: { missingProperty: "value" }, message: "must have required property 'value'" };
              if (vErrors === null) {
                vErrors = [err21];
              } else {
                vErrors.push(err21);
              }
              errors++;
            }
            for (const key2 in data8) {
              if (!(key2 === "at" || key2 === "nr" || key2 === "value")) {
                const err22 = { instancePath: instancePath + "/counts/" + i1, schemaPath: "#/properties/counts/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key2 }, message: "must NOT have additional properties" };
                if (vErrors === null) {
                  vErrors = [err22];
                } else {
                  vErrors.push(err22);
                }
                errors++;
              }
            }
            if (data8.at !== void 0) {
              if (typeof data8.at !== "string") {
                const err23 = { instancePath: instancePath + "/counts/" + i1 + "/at", schemaPath: "#/properties/counts/items/properties/at/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err23];
                } else {
                  vErrors.push(err23);
                }
                errors++;
              }
            }
            if (data8.nr !== void 0) {
              if (typeof data8.nr !== "string") {
                const err24 = { instancePath: instancePath + "/counts/" + i1 + "/nr", schemaPath: "#/properties/counts/items/properties/nr/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err24];
                } else {
                  vErrors.push(err24);
                }
                errors++;
              }
            }
            if (data8.value !== void 0) {
              let data11 = data8.value;
              if (!(typeof data11 == "number" && (!(data11 % 1) && !isNaN(data11)) && isFinite(data11))) {
                const err25 = { instancePath: instancePath + "/counts/" + i1 + "/value", schemaPath: "#/properties/counts/items/properties/value/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                if (vErrors === null) {
                  vErrors = [err25];
                } else {
                  vErrors.push(err25);
                }
                errors++;
              }
              if (typeof data11 == "number" && isFinite(data11)) {
                if (data11 > 99 || isNaN(data11)) {
                  const err26 = { instancePath: instancePath + "/counts/" + i1 + "/value", schemaPath: "#/properties/counts/items/properties/value/maximum", keyword: "maximum", params: { comparison: "<=", limit: 99 }, message: "must be <= 99" };
                  if (vErrors === null) {
                    vErrors = [err26];
                  } else {
                    vErrors.push(err26);
                  }
                  errors++;
                }
                if (data11 < 1 || isNaN(data11)) {
                  const err27 = { instancePath: instancePath + "/counts/" + i1 + "/value", schemaPath: "#/properties/counts/items/properties/value/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" };
                  if (vErrors === null) {
                    vErrors = [err27];
                  } else {
                    vErrors.push(err27);
                  }
                  errors++;
                }
              }
            }
          } else {
            const err28 = { instancePath: instancePath + "/counts/" + i1, schemaPath: "#/properties/counts/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
              vErrors = [err28];
            } else {
              vErrors.push(err28);
            }
            errors++;
          }
        }
      } else {
        const err29 = { instancePath: instancePath + "/counts", schemaPath: "#/properties/counts/type", keyword: "type", params: { type: "array" }, message: "must be array" };
        if (vErrors === null) {
          vErrors = [err29];
        } else {
          vErrors.push(err29);
        }
        errors++;
      }
    }
    if (data.bonus !== void 0) {
      let data12 = data.bonus;
      if (typeof data12 !== "string") {
        const err30 = { instancePath: instancePath + "/bonus", schemaPath: "#/properties/bonus/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err30];
        } else {
          vErrors.push(err30);
        }
        errors++;
      }
      if (!(data12 === "prozent60" || data12 === "prozent70" || data12 === "prozent75" || data12 === "prozent100")) {
        const err31 = { instancePath: instancePath + "/bonus", schemaPath: "#/properties/bonus/enum", keyword: "enum", params: { allowedValues: schema49.properties.bonus.enum }, message: "must be equal to one of the allowed values" };
        if (vErrors === null) {
          vErrors = [err31];
        } else {
          vErrors.push(err31);
        }
        errors++;
      }
    }
    if (data.kostentraeger !== void 0) {
      let data13 = data.kostentraeger;
      if (typeof data13 !== "string") {
        const err32 = { instancePath: instancePath + "/kostentraeger", schemaPath: "#/properties/kostentraeger/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err32];
        } else {
          vErrors.push(err32);
        }
        errors++;
      }
      if (!(data13 === "gkv_kzv_bw")) {
        const err33 = { instancePath: instancePath + "/kostentraeger", schemaPath: "#/properties/kostentraeger/enum", keyword: "enum", params: { allowedValues: schema49.properties.kostentraeger.enum }, message: "must be equal to one of the allowed values" };
        if (vErrors === null) {
          vErrors = [err33];
        } else {
          vErrors.push(err33);
        }
        errors++;
      }
    }
  } else {
    const err34 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err34];
    } else {
      vErrors.push(err34);
    }
    errors++;
  }
  validate42.errors = vErrors;
  return errors === 0;
}
var validateOutput16 = validate43;
var schema51 = { "type": "object", "properties": { "object": { "type": "string", "const": "verification_case" }, "conversationId": { "type": "string" }, "teeth": { "type": "array", "items": { "type": "object", "properties": { "fdi": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "findings": { "type": "array", "items": { "type": "object", "properties": { "fact": { "type": "string", "enum": ["fehlt", "erhaltungswuerdig", "krone", "endodontisch_behandelt", "stiftaufbau", "brueckenanker", "disparallel", "wiederherstellung", "geplant", "lueckensituation_i"], "description": "A finding, by name: at a tooth, or at a jaw (lueckensituation_i)." }, "value": { "anyOf": [{ "type": "boolean" }, { "type": "string" }] }, "status": { "type": "string", "enum": ["proposed", "confirmed"], "description": "Proposed by the agent, or confirmed by the dentist. Rules read only confirmed ones." }, "quote": { "description": "The dentist's words a proposal was read from.", "type": "string" }, "statedIn": { "description": "The statement a confirmed finding rests on.", "type": "string" } }, "required": ["fact", "value", "status"], "additionalProperties": false } } }, "required": ["fdi", "findings"], "additionalProperties": false } }, "jaws": { "type": "array", "items": { "type": "object", "properties": { "jaw": { "type": "string", "enum": ["OK", "UK"], "description": "The jaw: OK upper, UK lower." }, "findings": { "type": "array", "items": { "type": "object", "properties": { "fact": { "type": "string", "enum": ["fehlt", "erhaltungswuerdig", "krone", "endodontisch_behandelt", "stiftaufbau", "brueckenanker", "disparallel", "wiederherstellung", "geplant", "lueckensituation_i"], "description": "A finding, by name: at a tooth, or at a jaw (lueckensituation_i)." }, "value": { "anyOf": [{ "type": "boolean" }, { "type": "string" }] }, "status": { "type": "string", "enum": ["proposed", "confirmed"], "description": "Proposed by the agent, or confirmed by the dentist. Rules read only confirmed ones." }, "quote": { "description": "The dentist's words a proposal was read from.", "type": "string" }, "statedIn": { "description": "The statement a confirmed finding rests on.", "type": "string" } }, "required": ["fact", "value", "status"], "additionalProperties": false } } }, "required": ["jaw", "findings"], "additionalProperties": false }, "description": "Findings at a jaw: whether it is in L\xFCckensituation I." }, "statements": { "type": "array", "items": { "type": "object", "properties": { "id": { "type": "string" }, "at": { "type": "string", "format": "date-time", "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" } }, "required": ["id", "at"], "additionalProperties": false } }, "counts": { "type": "array", "items": { "type": "object", "properties": { "at": { "type": "string", "description": `Where the line is billed, as the costs list it: a tooth's number ("12"), a gap's id ("UK:45-47"), a jaw, or "patient".` }, "nr": { "type": "string", "description": "The BEMA number, e.g. 20b." }, "value": { "type": "integer", "minimum": 1, "maximum": 99, "description": "How often it goes on the HKP." }, "statedIn": { "type": "string" } }, "required": ["at", "nr", "value", "statedIn"], "additionalProperties": false }, "description": "The dentist's counts for BEMA lines no source counts; the costs bill these." }, "bonus": { "description": "The patient's subsidy level, once the dentist states it.", "type": "object", "properties": { "value": { "type": "string", "enum": ["prozent60", "prozent70", "prozent75", "prozent100"], "description": "The Festzuschuss level from the patient's Bonusheft: 60 % without bonus, 70 % and 75 % with, 100 % for hardship." }, "statedIn": { "type": "string" } }, "required": ["value", "statedIn"], "additionalProperties": false }, "kostentraeger": { "description": "Who pays, once the dentist confirms it; assumed until then.", "type": "object", "properties": { "value": { "type": "string", "enum": ["gkv_kzv_bw"], "description": "Who pays: statutory insurance, billed at the KZV Baden-W\xFCrttemberg's prices, the only one the rules cover." }, "statedIn": { "type": "string" } }, "required": ["value", "statedIn"], "additionalProperties": false } }, "required": ["object", "conversationId", "teeth", "jaws", "statements", "counts"], "additionalProperties": false };
function validate43(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.object === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "object" }, message: "must have required property 'object'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.case === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "case" }, message: "must have required property 'case'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.refused === void 0) {
      const err2 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "refused" }, message: "must have required property 'refused'" };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    for (const key0 in data) {
      if (!(key0 === "object" || key0 === "case" || key0 === "refused")) {
        const err3 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.object !== void 0) {
      let data0 = data.object;
      if (typeof data0 !== "string") {
        const err4 = { instancePath: instancePath + "/object", schemaPath: "#/properties/object/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
      if ("verification_change" !== data0) {
        const err5 = { instancePath: instancePath + "/object", schemaPath: "#/properties/object/const", keyword: "const", params: { allowedValue: "verification_change" }, message: "must be equal to constant" };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
    }
    if (data.case !== void 0) {
      let data1 = data.case;
      if (data1 && typeof data1 == "object" && !Array.isArray(data1)) {
        if (data1.object === void 0) {
          const err6 = { instancePath: instancePath + "/case", schemaPath: "#/definitions/VerificationCase/required", keyword: "required", params: { missingProperty: "object" }, message: "must have required property 'object'" };
          if (vErrors === null) {
            vErrors = [err6];
          } else {
            vErrors.push(err6);
          }
          errors++;
        }
        if (data1.conversationId === void 0) {
          const err7 = { instancePath: instancePath + "/case", schemaPath: "#/definitions/VerificationCase/required", keyword: "required", params: { missingProperty: "conversationId" }, message: "must have required property 'conversationId'" };
          if (vErrors === null) {
            vErrors = [err7];
          } else {
            vErrors.push(err7);
          }
          errors++;
        }
        if (data1.teeth === void 0) {
          const err8 = { instancePath: instancePath + "/case", schemaPath: "#/definitions/VerificationCase/required", keyword: "required", params: { missingProperty: "teeth" }, message: "must have required property 'teeth'" };
          if (vErrors === null) {
            vErrors = [err8];
          } else {
            vErrors.push(err8);
          }
          errors++;
        }
        if (data1.jaws === void 0) {
          const err9 = { instancePath: instancePath + "/case", schemaPath: "#/definitions/VerificationCase/required", keyword: "required", params: { missingProperty: "jaws" }, message: "must have required property 'jaws'" };
          if (vErrors === null) {
            vErrors = [err9];
          } else {
            vErrors.push(err9);
          }
          errors++;
        }
        if (data1.statements === void 0) {
          const err10 = { instancePath: instancePath + "/case", schemaPath: "#/definitions/VerificationCase/required", keyword: "required", params: { missingProperty: "statements" }, message: "must have required property 'statements'" };
          if (vErrors === null) {
            vErrors = [err10];
          } else {
            vErrors.push(err10);
          }
          errors++;
        }
        if (data1.counts === void 0) {
          const err11 = { instancePath: instancePath + "/case", schemaPath: "#/definitions/VerificationCase/required", keyword: "required", params: { missingProperty: "counts" }, message: "must have required property 'counts'" };
          if (vErrors === null) {
            vErrors = [err11];
          } else {
            vErrors.push(err11);
          }
          errors++;
        }
        for (const key1 in data1) {
          if (!(key1 === "object" || key1 === "conversationId" || key1 === "teeth" || key1 === "jaws" || key1 === "statements" || key1 === "counts" || key1 === "bonus" || key1 === "kostentraeger")) {
            const err12 = { instancePath: instancePath + "/case", schemaPath: "#/definitions/VerificationCase/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
            if (vErrors === null) {
              vErrors = [err12];
            } else {
              vErrors.push(err12);
            }
            errors++;
          }
        }
        if (data1.object !== void 0) {
          let data2 = data1.object;
          if (typeof data2 !== "string") {
            const err13 = { instancePath: instancePath + "/case/object", schemaPath: "#/definitions/VerificationCase/properties/object/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err13];
            } else {
              vErrors.push(err13);
            }
            errors++;
          }
          if ("verification_case" !== data2) {
            const err14 = { instancePath: instancePath + "/case/object", schemaPath: "#/definitions/VerificationCase/properties/object/const", keyword: "const", params: { allowedValue: "verification_case" }, message: "must be equal to constant" };
            if (vErrors === null) {
              vErrors = [err14];
            } else {
              vErrors.push(err14);
            }
            errors++;
          }
        }
        if (data1.conversationId !== void 0) {
          if (typeof data1.conversationId !== "string") {
            const err15 = { instancePath: instancePath + "/case/conversationId", schemaPath: "#/definitions/VerificationCase/properties/conversationId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err15];
            } else {
              vErrors.push(err15);
            }
            errors++;
          }
        }
        if (data1.teeth !== void 0) {
          let data4 = data1.teeth;
          if (Array.isArray(data4)) {
            const len0 = data4.length;
            for (let i0 = 0; i0 < len0; i0++) {
              let data5 = data4[i0];
              if (data5 && typeof data5 == "object" && !Array.isArray(data5)) {
                if (data5.fdi === void 0) {
                  const err16 = { instancePath: instancePath + "/case/teeth/" + i0, schemaPath: "#/definitions/VerificationCase/properties/teeth/items/required", keyword: "required", params: { missingProperty: "fdi" }, message: "must have required property 'fdi'" };
                  if (vErrors === null) {
                    vErrors = [err16];
                  } else {
                    vErrors.push(err16);
                  }
                  errors++;
                }
                if (data5.findings === void 0) {
                  const err17 = { instancePath: instancePath + "/case/teeth/" + i0, schemaPath: "#/definitions/VerificationCase/properties/teeth/items/required", keyword: "required", params: { missingProperty: "findings" }, message: "must have required property 'findings'" };
                  if (vErrors === null) {
                    vErrors = [err17];
                  } else {
                    vErrors.push(err17);
                  }
                  errors++;
                }
                for (const key2 in data5) {
                  if (!(key2 === "fdi" || key2 === "findings")) {
                    const err18 = { instancePath: instancePath + "/case/teeth/" + i0, schemaPath: "#/definitions/VerificationCase/properties/teeth/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key2 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                      vErrors = [err18];
                    } else {
                      vErrors.push(err18);
                    }
                    errors++;
                  }
                }
                if (data5.fdi !== void 0) {
                  let data6 = data5.fdi;
                  if (!(typeof data6 == "number" && (!(data6 % 1) && !isNaN(data6)) && isFinite(data6))) {
                    const err19 = { instancePath: instancePath + "/case/teeth/" + i0 + "/fdi", schemaPath: "#/definitions/VerificationCase/properties/teeth/items/properties/fdi/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err19];
                    } else {
                      vErrors.push(err19);
                    }
                    errors++;
                  }
                  if (typeof data6 == "number" && isFinite(data6)) {
                    if (data6 > 9007199254740991 || isNaN(data6)) {
                      const err20 = { instancePath: instancePath + "/case/teeth/" + i0 + "/fdi", schemaPath: "#/definitions/VerificationCase/properties/teeth/items/properties/fdi/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err20];
                      } else {
                        vErrors.push(err20);
                      }
                      errors++;
                    }
                    if (data6 < -9007199254740991 || isNaN(data6)) {
                      const err21 = { instancePath: instancePath + "/case/teeth/" + i0 + "/fdi", schemaPath: "#/definitions/VerificationCase/properties/teeth/items/properties/fdi/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err21];
                      } else {
                        vErrors.push(err21);
                      }
                      errors++;
                    }
                  }
                }
                if (data5.findings !== void 0) {
                  let data7 = data5.findings;
                  if (Array.isArray(data7)) {
                    const len1 = data7.length;
                    for (let i1 = 0; i1 < len1; i1++) {
                      let data8 = data7[i1];
                      if (data8 && typeof data8 == "object" && !Array.isArray(data8)) {
                        if (data8.fact === void 0) {
                          const err22 = { instancePath: instancePath + "/case/teeth/" + i0 + "/findings/" + i1, schemaPath: "#/definitions/VerificationCase/properties/teeth/items/properties/findings/items/required", keyword: "required", params: { missingProperty: "fact" }, message: "must have required property 'fact'" };
                          if (vErrors === null) {
                            vErrors = [err22];
                          } else {
                            vErrors.push(err22);
                          }
                          errors++;
                        }
                        if (data8.value === void 0) {
                          const err23 = { instancePath: instancePath + "/case/teeth/" + i0 + "/findings/" + i1, schemaPath: "#/definitions/VerificationCase/properties/teeth/items/properties/findings/items/required", keyword: "required", params: { missingProperty: "value" }, message: "must have required property 'value'" };
                          if (vErrors === null) {
                            vErrors = [err23];
                          } else {
                            vErrors.push(err23);
                          }
                          errors++;
                        }
                        if (data8.status === void 0) {
                          const err24 = { instancePath: instancePath + "/case/teeth/" + i0 + "/findings/" + i1, schemaPath: "#/definitions/VerificationCase/properties/teeth/items/properties/findings/items/required", keyword: "required", params: { missingProperty: "status" }, message: "must have required property 'status'" };
                          if (vErrors === null) {
                            vErrors = [err24];
                          } else {
                            vErrors.push(err24);
                          }
                          errors++;
                        }
                        for (const key3 in data8) {
                          if (!(key3 === "fact" || key3 === "value" || key3 === "status" || key3 === "quote" || key3 === "statedIn")) {
                            const err25 = { instancePath: instancePath + "/case/teeth/" + i0 + "/findings/" + i1, schemaPath: "#/definitions/VerificationCase/properties/teeth/items/properties/findings/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key3 }, message: "must NOT have additional properties" };
                            if (vErrors === null) {
                              vErrors = [err25];
                            } else {
                              vErrors.push(err25);
                            }
                            errors++;
                          }
                        }
                        if (data8.fact !== void 0) {
                          let data9 = data8.fact;
                          if (typeof data9 !== "string") {
                            const err26 = { instancePath: instancePath + "/case/teeth/" + i0 + "/findings/" + i1 + "/fact", schemaPath: "#/definitions/VerificationCase/properties/teeth/items/properties/findings/items/properties/fact/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err26];
                            } else {
                              vErrors.push(err26);
                            }
                            errors++;
                          }
                          if (!(data9 === "fehlt" || data9 === "erhaltungswuerdig" || data9 === "krone" || data9 === "endodontisch_behandelt" || data9 === "stiftaufbau" || data9 === "brueckenanker" || data9 === "disparallel" || data9 === "wiederherstellung" || data9 === "geplant" || data9 === "lueckensituation_i")) {
                            const err27 = { instancePath: instancePath + "/case/teeth/" + i0 + "/findings/" + i1 + "/fact", schemaPath: "#/definitions/VerificationCase/properties/teeth/items/properties/findings/items/properties/fact/enum", keyword: "enum", params: { allowedValues: schema51.properties.teeth.items.properties.findings.items.properties.fact.enum }, message: "must be equal to one of the allowed values" };
                            if (vErrors === null) {
                              vErrors = [err27];
                            } else {
                              vErrors.push(err27);
                            }
                            errors++;
                          }
                        }
                        if (data8.value !== void 0) {
                          let data10 = data8.value;
                          const _errs27 = errors;
                          let valid9 = false;
                          const _errs28 = errors;
                          if (typeof data10 !== "boolean") {
                            const err28 = { instancePath: instancePath + "/case/teeth/" + i0 + "/findings/" + i1 + "/value", schemaPath: "#/definitions/VerificationCase/properties/teeth/items/properties/findings/items/properties/value/anyOf/0/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                            if (vErrors === null) {
                              vErrors = [err28];
                            } else {
                              vErrors.push(err28);
                            }
                            errors++;
                          }
                          var _valid0 = _errs28 === errors;
                          valid9 = valid9 || _valid0;
                          if (!valid9) {
                            const _errs30 = errors;
                            if (typeof data10 !== "string") {
                              const err29 = { instancePath: instancePath + "/case/teeth/" + i0 + "/findings/" + i1 + "/value", schemaPath: "#/definitions/VerificationCase/properties/teeth/items/properties/findings/items/properties/value/anyOf/1/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                              if (vErrors === null) {
                                vErrors = [err29];
                              } else {
                                vErrors.push(err29);
                              }
                              errors++;
                            }
                            var _valid0 = _errs30 === errors;
                            valid9 = valid9 || _valid0;
                          }
                          if (!valid9) {
                            const err30 = { instancePath: instancePath + "/case/teeth/" + i0 + "/findings/" + i1 + "/value", schemaPath: "#/definitions/VerificationCase/properties/teeth/items/properties/findings/items/properties/value/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                            if (vErrors === null) {
                              vErrors = [err30];
                            } else {
                              vErrors.push(err30);
                            }
                            errors++;
                          } else {
                            errors = _errs27;
                            if (vErrors !== null) {
                              if (_errs27) {
                                vErrors.length = _errs27;
                              } else {
                                vErrors = null;
                              }
                            }
                          }
                        }
                        if (data8.status !== void 0) {
                          let data11 = data8.status;
                          if (typeof data11 !== "string") {
                            const err31 = { instancePath: instancePath + "/case/teeth/" + i0 + "/findings/" + i1 + "/status", schemaPath: "#/definitions/VerificationCase/properties/teeth/items/properties/findings/items/properties/status/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err31];
                            } else {
                              vErrors.push(err31);
                            }
                            errors++;
                          }
                          if (!(data11 === "proposed" || data11 === "confirmed")) {
                            const err32 = { instancePath: instancePath + "/case/teeth/" + i0 + "/findings/" + i1 + "/status", schemaPath: "#/definitions/VerificationCase/properties/teeth/items/properties/findings/items/properties/status/enum", keyword: "enum", params: { allowedValues: schema51.properties.teeth.items.properties.findings.items.properties.status.enum }, message: "must be equal to one of the allowed values" };
                            if (vErrors === null) {
                              vErrors = [err32];
                            } else {
                              vErrors.push(err32);
                            }
                            errors++;
                          }
                        }
                        if (data8.quote !== void 0) {
                          if (typeof data8.quote !== "string") {
                            const err33 = { instancePath: instancePath + "/case/teeth/" + i0 + "/findings/" + i1 + "/quote", schemaPath: "#/definitions/VerificationCase/properties/teeth/items/properties/findings/items/properties/quote/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err33];
                            } else {
                              vErrors.push(err33);
                            }
                            errors++;
                          }
                        }
                        if (data8.statedIn !== void 0) {
                          if (typeof data8.statedIn !== "string") {
                            const err34 = { instancePath: instancePath + "/case/teeth/" + i0 + "/findings/" + i1 + "/statedIn", schemaPath: "#/definitions/VerificationCase/properties/teeth/items/properties/findings/items/properties/statedIn/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err34];
                            } else {
                              vErrors.push(err34);
                            }
                            errors++;
                          }
                        }
                      } else {
                        const err35 = { instancePath: instancePath + "/case/teeth/" + i0 + "/findings/" + i1, schemaPath: "#/definitions/VerificationCase/properties/teeth/items/properties/findings/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                        if (vErrors === null) {
                          vErrors = [err35];
                        } else {
                          vErrors.push(err35);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err36 = { instancePath: instancePath + "/case/teeth/" + i0 + "/findings", schemaPath: "#/definitions/VerificationCase/properties/teeth/items/properties/findings/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                      vErrors = [err36];
                    } else {
                      vErrors.push(err36);
                    }
                    errors++;
                  }
                }
              } else {
                const err37 = { instancePath: instancePath + "/case/teeth/" + i0, schemaPath: "#/definitions/VerificationCase/properties/teeth/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                if (vErrors === null) {
                  vErrors = [err37];
                } else {
                  vErrors.push(err37);
                }
                errors++;
              }
            }
          } else {
            const err38 = { instancePath: instancePath + "/case/teeth", schemaPath: "#/definitions/VerificationCase/properties/teeth/type", keyword: "type", params: { type: "array" }, message: "must be array" };
            if (vErrors === null) {
              vErrors = [err38];
            } else {
              vErrors.push(err38);
            }
            errors++;
          }
        }
        if (data1.jaws !== void 0) {
          let data14 = data1.jaws;
          if (Array.isArray(data14)) {
            const len2 = data14.length;
            for (let i2 = 0; i2 < len2; i2++) {
              let data15 = data14[i2];
              if (data15 && typeof data15 == "object" && !Array.isArray(data15)) {
                if (data15.jaw === void 0) {
                  const err39 = { instancePath: instancePath + "/case/jaws/" + i2, schemaPath: "#/definitions/VerificationCase/properties/jaws/items/required", keyword: "required", params: { missingProperty: "jaw" }, message: "must have required property 'jaw'" };
                  if (vErrors === null) {
                    vErrors = [err39];
                  } else {
                    vErrors.push(err39);
                  }
                  errors++;
                }
                if (data15.findings === void 0) {
                  const err40 = { instancePath: instancePath + "/case/jaws/" + i2, schemaPath: "#/definitions/VerificationCase/properties/jaws/items/required", keyword: "required", params: { missingProperty: "findings" }, message: "must have required property 'findings'" };
                  if (vErrors === null) {
                    vErrors = [err40];
                  } else {
                    vErrors.push(err40);
                  }
                  errors++;
                }
                for (const key4 in data15) {
                  if (!(key4 === "jaw" || key4 === "findings")) {
                    const err41 = { instancePath: instancePath + "/case/jaws/" + i2, schemaPath: "#/definitions/VerificationCase/properties/jaws/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key4 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                      vErrors = [err41];
                    } else {
                      vErrors.push(err41);
                    }
                    errors++;
                  }
                }
                if (data15.jaw !== void 0) {
                  let data16 = data15.jaw;
                  if (typeof data16 !== "string") {
                    const err42 = { instancePath: instancePath + "/case/jaws/" + i2 + "/jaw", schemaPath: "#/definitions/VerificationCase/properties/jaws/items/properties/jaw/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err42];
                    } else {
                      vErrors.push(err42);
                    }
                    errors++;
                  }
                  if (!(data16 === "OK" || data16 === "UK")) {
                    const err43 = { instancePath: instancePath + "/case/jaws/" + i2 + "/jaw", schemaPath: "#/definitions/VerificationCase/properties/jaws/items/properties/jaw/enum", keyword: "enum", params: { allowedValues: schema51.properties.jaws.items.properties.jaw.enum }, message: "must be equal to one of the allowed values" };
                    if (vErrors === null) {
                      vErrors = [err43];
                    } else {
                      vErrors.push(err43);
                    }
                    errors++;
                  }
                }
                if (data15.findings !== void 0) {
                  let data17 = data15.findings;
                  if (Array.isArray(data17)) {
                    const len3 = data17.length;
                    for (let i3 = 0; i3 < len3; i3++) {
                      let data18 = data17[i3];
                      if (data18 && typeof data18 == "object" && !Array.isArray(data18)) {
                        if (data18.fact === void 0) {
                          const err44 = { instancePath: instancePath + "/case/jaws/" + i2 + "/findings/" + i3, schemaPath: "#/definitions/VerificationCase/properties/jaws/items/properties/findings/items/required", keyword: "required", params: { missingProperty: "fact" }, message: "must have required property 'fact'" };
                          if (vErrors === null) {
                            vErrors = [err44];
                          } else {
                            vErrors.push(err44);
                          }
                          errors++;
                        }
                        if (data18.value === void 0) {
                          const err45 = { instancePath: instancePath + "/case/jaws/" + i2 + "/findings/" + i3, schemaPath: "#/definitions/VerificationCase/properties/jaws/items/properties/findings/items/required", keyword: "required", params: { missingProperty: "value" }, message: "must have required property 'value'" };
                          if (vErrors === null) {
                            vErrors = [err45];
                          } else {
                            vErrors.push(err45);
                          }
                          errors++;
                        }
                        if (data18.status === void 0) {
                          const err46 = { instancePath: instancePath + "/case/jaws/" + i2 + "/findings/" + i3, schemaPath: "#/definitions/VerificationCase/properties/jaws/items/properties/findings/items/required", keyword: "required", params: { missingProperty: "status" }, message: "must have required property 'status'" };
                          if (vErrors === null) {
                            vErrors = [err46];
                          } else {
                            vErrors.push(err46);
                          }
                          errors++;
                        }
                        for (const key5 in data18) {
                          if (!(key5 === "fact" || key5 === "value" || key5 === "status" || key5 === "quote" || key5 === "statedIn")) {
                            const err47 = { instancePath: instancePath + "/case/jaws/" + i2 + "/findings/" + i3, schemaPath: "#/definitions/VerificationCase/properties/jaws/items/properties/findings/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key5 }, message: "must NOT have additional properties" };
                            if (vErrors === null) {
                              vErrors = [err47];
                            } else {
                              vErrors.push(err47);
                            }
                            errors++;
                          }
                        }
                        if (data18.fact !== void 0) {
                          let data19 = data18.fact;
                          if (typeof data19 !== "string") {
                            const err48 = { instancePath: instancePath + "/case/jaws/" + i2 + "/findings/" + i3 + "/fact", schemaPath: "#/definitions/VerificationCase/properties/jaws/items/properties/findings/items/properties/fact/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err48];
                            } else {
                              vErrors.push(err48);
                            }
                            errors++;
                          }
                          if (!(data19 === "fehlt" || data19 === "erhaltungswuerdig" || data19 === "krone" || data19 === "endodontisch_behandelt" || data19 === "stiftaufbau" || data19 === "brueckenanker" || data19 === "disparallel" || data19 === "wiederherstellung" || data19 === "geplant" || data19 === "lueckensituation_i")) {
                            const err49 = { instancePath: instancePath + "/case/jaws/" + i2 + "/findings/" + i3 + "/fact", schemaPath: "#/definitions/VerificationCase/properties/jaws/items/properties/findings/items/properties/fact/enum", keyword: "enum", params: { allowedValues: schema51.properties.jaws.items.properties.findings.items.properties.fact.enum }, message: "must be equal to one of the allowed values" };
                            if (vErrors === null) {
                              vErrors = [err49];
                            } else {
                              vErrors.push(err49);
                            }
                            errors++;
                          }
                        }
                        if (data18.value !== void 0) {
                          let data20 = data18.value;
                          const _errs53 = errors;
                          let valid16 = false;
                          const _errs54 = errors;
                          if (typeof data20 !== "boolean") {
                            const err50 = { instancePath: instancePath + "/case/jaws/" + i2 + "/findings/" + i3 + "/value", schemaPath: "#/definitions/VerificationCase/properties/jaws/items/properties/findings/items/properties/value/anyOf/0/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                            if (vErrors === null) {
                              vErrors = [err50];
                            } else {
                              vErrors.push(err50);
                            }
                            errors++;
                          }
                          var _valid1 = _errs54 === errors;
                          valid16 = valid16 || _valid1;
                          if (!valid16) {
                            const _errs56 = errors;
                            if (typeof data20 !== "string") {
                              const err51 = { instancePath: instancePath + "/case/jaws/" + i2 + "/findings/" + i3 + "/value", schemaPath: "#/definitions/VerificationCase/properties/jaws/items/properties/findings/items/properties/value/anyOf/1/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                              if (vErrors === null) {
                                vErrors = [err51];
                              } else {
                                vErrors.push(err51);
                              }
                              errors++;
                            }
                            var _valid1 = _errs56 === errors;
                            valid16 = valid16 || _valid1;
                          }
                          if (!valid16) {
                            const err52 = { instancePath: instancePath + "/case/jaws/" + i2 + "/findings/" + i3 + "/value", schemaPath: "#/definitions/VerificationCase/properties/jaws/items/properties/findings/items/properties/value/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                            if (vErrors === null) {
                              vErrors = [err52];
                            } else {
                              vErrors.push(err52);
                            }
                            errors++;
                          } else {
                            errors = _errs53;
                            if (vErrors !== null) {
                              if (_errs53) {
                                vErrors.length = _errs53;
                              } else {
                                vErrors = null;
                              }
                            }
                          }
                        }
                        if (data18.status !== void 0) {
                          let data21 = data18.status;
                          if (typeof data21 !== "string") {
                            const err53 = { instancePath: instancePath + "/case/jaws/" + i2 + "/findings/" + i3 + "/status", schemaPath: "#/definitions/VerificationCase/properties/jaws/items/properties/findings/items/properties/status/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err53];
                            } else {
                              vErrors.push(err53);
                            }
                            errors++;
                          }
                          if (!(data21 === "proposed" || data21 === "confirmed")) {
                            const err54 = { instancePath: instancePath + "/case/jaws/" + i2 + "/findings/" + i3 + "/status", schemaPath: "#/definitions/VerificationCase/properties/jaws/items/properties/findings/items/properties/status/enum", keyword: "enum", params: { allowedValues: schema51.properties.jaws.items.properties.findings.items.properties.status.enum }, message: "must be equal to one of the allowed values" };
                            if (vErrors === null) {
                              vErrors = [err54];
                            } else {
                              vErrors.push(err54);
                            }
                            errors++;
                          }
                        }
                        if (data18.quote !== void 0) {
                          if (typeof data18.quote !== "string") {
                            const err55 = { instancePath: instancePath + "/case/jaws/" + i2 + "/findings/" + i3 + "/quote", schemaPath: "#/definitions/VerificationCase/properties/jaws/items/properties/findings/items/properties/quote/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err55];
                            } else {
                              vErrors.push(err55);
                            }
                            errors++;
                          }
                        }
                        if (data18.statedIn !== void 0) {
                          if (typeof data18.statedIn !== "string") {
                            const err56 = { instancePath: instancePath + "/case/jaws/" + i2 + "/findings/" + i3 + "/statedIn", schemaPath: "#/definitions/VerificationCase/properties/jaws/items/properties/findings/items/properties/statedIn/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err56];
                            } else {
                              vErrors.push(err56);
                            }
                            errors++;
                          }
                        }
                      } else {
                        const err57 = { instancePath: instancePath + "/case/jaws/" + i2 + "/findings/" + i3, schemaPath: "#/definitions/VerificationCase/properties/jaws/items/properties/findings/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                        if (vErrors === null) {
                          vErrors = [err57];
                        } else {
                          vErrors.push(err57);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err58 = { instancePath: instancePath + "/case/jaws/" + i2 + "/findings", schemaPath: "#/definitions/VerificationCase/properties/jaws/items/properties/findings/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                      vErrors = [err58];
                    } else {
                      vErrors.push(err58);
                    }
                    errors++;
                  }
                }
              } else {
                const err59 = { instancePath: instancePath + "/case/jaws/" + i2, schemaPath: "#/definitions/VerificationCase/properties/jaws/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                if (vErrors === null) {
                  vErrors = [err59];
                } else {
                  vErrors.push(err59);
                }
                errors++;
              }
            }
          } else {
            const err60 = { instancePath: instancePath + "/case/jaws", schemaPath: "#/definitions/VerificationCase/properties/jaws/type", keyword: "type", params: { type: "array" }, message: "must be array" };
            if (vErrors === null) {
              vErrors = [err60];
            } else {
              vErrors.push(err60);
            }
            errors++;
          }
        }
        if (data1.statements !== void 0) {
          let data24 = data1.statements;
          if (Array.isArray(data24)) {
            const len4 = data24.length;
            for (let i4 = 0; i4 < len4; i4++) {
              let data25 = data24[i4];
              if (data25 && typeof data25 == "object" && !Array.isArray(data25)) {
                if (data25.id === void 0) {
                  const err61 = { instancePath: instancePath + "/case/statements/" + i4, schemaPath: "#/definitions/VerificationCase/properties/statements/items/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property 'id'" };
                  if (vErrors === null) {
                    vErrors = [err61];
                  } else {
                    vErrors.push(err61);
                  }
                  errors++;
                }
                if (data25.at === void 0) {
                  const err62 = { instancePath: instancePath + "/case/statements/" + i4, schemaPath: "#/definitions/VerificationCase/properties/statements/items/required", keyword: "required", params: { missingProperty: "at" }, message: "must have required property 'at'" };
                  if (vErrors === null) {
                    vErrors = [err62];
                  } else {
                    vErrors.push(err62);
                  }
                  errors++;
                }
                for (const key6 in data25) {
                  if (!(key6 === "id" || key6 === "at")) {
                    const err63 = { instancePath: instancePath + "/case/statements/" + i4, schemaPath: "#/definitions/VerificationCase/properties/statements/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key6 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                      vErrors = [err63];
                    } else {
                      vErrors.push(err63);
                    }
                    errors++;
                  }
                }
                if (data25.id !== void 0) {
                  if (typeof data25.id !== "string") {
                    const err64 = { instancePath: instancePath + "/case/statements/" + i4 + "/id", schemaPath: "#/definitions/VerificationCase/properties/statements/items/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err64];
                    } else {
                      vErrors.push(err64);
                    }
                    errors++;
                  }
                }
                if (data25.at !== void 0) {
                  let data27 = data25.at;
                  if (typeof data27 === "string") {
                    if (!pattern0.test(data27)) {
                      const err65 = { instancePath: instancePath + "/case/statements/" + i4 + "/at", schemaPath: "#/definitions/VerificationCase/properties/statements/items/properties/at/pattern", keyword: "pattern", params: { pattern: "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, message: 'must match pattern "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"' };
                      if (vErrors === null) {
                        vErrors = [err65];
                      } else {
                        vErrors.push(err65);
                      }
                      errors++;
                    }
                    if (!formats0.validate(data27)) {
                      const err66 = { instancePath: instancePath + "/case/statements/" + i4 + "/at", schemaPath: "#/definitions/VerificationCase/properties/statements/items/properties/at/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' };
                      if (vErrors === null) {
                        vErrors = [err66];
                      } else {
                        vErrors.push(err66);
                      }
                      errors++;
                    }
                  } else {
                    const err67 = { instancePath: instancePath + "/case/statements/" + i4 + "/at", schemaPath: "#/definitions/VerificationCase/properties/statements/items/properties/at/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err67];
                    } else {
                      vErrors.push(err67);
                    }
                    errors++;
                  }
                }
              } else {
                const err68 = { instancePath: instancePath + "/case/statements/" + i4, schemaPath: "#/definitions/VerificationCase/properties/statements/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                if (vErrors === null) {
                  vErrors = [err68];
                } else {
                  vErrors.push(err68);
                }
                errors++;
              }
            }
          } else {
            const err69 = { instancePath: instancePath + "/case/statements", schemaPath: "#/definitions/VerificationCase/properties/statements/type", keyword: "type", params: { type: "array" }, message: "must be array" };
            if (vErrors === null) {
              vErrors = [err69];
            } else {
              vErrors.push(err69);
            }
            errors++;
          }
        }
        if (data1.counts !== void 0) {
          let data28 = data1.counts;
          if (Array.isArray(data28)) {
            const len5 = data28.length;
            for (let i5 = 0; i5 < len5; i5++) {
              let data29 = data28[i5];
              if (data29 && typeof data29 == "object" && !Array.isArray(data29)) {
                if (data29.at === void 0) {
                  const err70 = { instancePath: instancePath + "/case/counts/" + i5, schemaPath: "#/definitions/VerificationCase/properties/counts/items/required", keyword: "required", params: { missingProperty: "at" }, message: "must have required property 'at'" };
                  if (vErrors === null) {
                    vErrors = [err70];
                  } else {
                    vErrors.push(err70);
                  }
                  errors++;
                }
                if (data29.nr === void 0) {
                  const err71 = { instancePath: instancePath + "/case/counts/" + i5, schemaPath: "#/definitions/VerificationCase/properties/counts/items/required", keyword: "required", params: { missingProperty: "nr" }, message: "must have required property 'nr'" };
                  if (vErrors === null) {
                    vErrors = [err71];
                  } else {
                    vErrors.push(err71);
                  }
                  errors++;
                }
                if (data29.value === void 0) {
                  const err72 = { instancePath: instancePath + "/case/counts/" + i5, schemaPath: "#/definitions/VerificationCase/properties/counts/items/required", keyword: "required", params: { missingProperty: "value" }, message: "must have required property 'value'" };
                  if (vErrors === null) {
                    vErrors = [err72];
                  } else {
                    vErrors.push(err72);
                  }
                  errors++;
                }
                if (data29.statedIn === void 0) {
                  const err73 = { instancePath: instancePath + "/case/counts/" + i5, schemaPath: "#/definitions/VerificationCase/properties/counts/items/required", keyword: "required", params: { missingProperty: "statedIn" }, message: "must have required property 'statedIn'" };
                  if (vErrors === null) {
                    vErrors = [err73];
                  } else {
                    vErrors.push(err73);
                  }
                  errors++;
                }
                for (const key7 in data29) {
                  if (!(key7 === "at" || key7 === "nr" || key7 === "value" || key7 === "statedIn")) {
                    const err74 = { instancePath: instancePath + "/case/counts/" + i5, schemaPath: "#/definitions/VerificationCase/properties/counts/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key7 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                      vErrors = [err74];
                    } else {
                      vErrors.push(err74);
                    }
                    errors++;
                  }
                }
                if (data29.at !== void 0) {
                  if (typeof data29.at !== "string") {
                    const err75 = { instancePath: instancePath + "/case/counts/" + i5 + "/at", schemaPath: "#/definitions/VerificationCase/properties/counts/items/properties/at/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err75];
                    } else {
                      vErrors.push(err75);
                    }
                    errors++;
                  }
                }
                if (data29.nr !== void 0) {
                  if (typeof data29.nr !== "string") {
                    const err76 = { instancePath: instancePath + "/case/counts/" + i5 + "/nr", schemaPath: "#/definitions/VerificationCase/properties/counts/items/properties/nr/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err76];
                    } else {
                      vErrors.push(err76);
                    }
                    errors++;
                  }
                }
                if (data29.value !== void 0) {
                  let data32 = data29.value;
                  if (!(typeof data32 == "number" && (!(data32 % 1) && !isNaN(data32)) && isFinite(data32))) {
                    const err77 = { instancePath: instancePath + "/case/counts/" + i5 + "/value", schemaPath: "#/definitions/VerificationCase/properties/counts/items/properties/value/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err77];
                    } else {
                      vErrors.push(err77);
                    }
                    errors++;
                  }
                  if (typeof data32 == "number" && isFinite(data32)) {
                    if (data32 > 99 || isNaN(data32)) {
                      const err78 = { instancePath: instancePath + "/case/counts/" + i5 + "/value", schemaPath: "#/definitions/VerificationCase/properties/counts/items/properties/value/maximum", keyword: "maximum", params: { comparison: "<=", limit: 99 }, message: "must be <= 99" };
                      if (vErrors === null) {
                        vErrors = [err78];
                      } else {
                        vErrors.push(err78);
                      }
                      errors++;
                    }
                    if (data32 < 1 || isNaN(data32)) {
                      const err79 = { instancePath: instancePath + "/case/counts/" + i5 + "/value", schemaPath: "#/definitions/VerificationCase/properties/counts/items/properties/value/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" };
                      if (vErrors === null) {
                        vErrors = [err79];
                      } else {
                        vErrors.push(err79);
                      }
                      errors++;
                    }
                  }
                }
                if (data29.statedIn !== void 0) {
                  if (typeof data29.statedIn !== "string") {
                    const err80 = { instancePath: instancePath + "/case/counts/" + i5 + "/statedIn", schemaPath: "#/definitions/VerificationCase/properties/counts/items/properties/statedIn/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err80];
                    } else {
                      vErrors.push(err80);
                    }
                    errors++;
                  }
                }
              } else {
                const err81 = { instancePath: instancePath + "/case/counts/" + i5, schemaPath: "#/definitions/VerificationCase/properties/counts/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                if (vErrors === null) {
                  vErrors = [err81];
                } else {
                  vErrors.push(err81);
                }
                errors++;
              }
            }
          } else {
            const err82 = { instancePath: instancePath + "/case/counts", schemaPath: "#/definitions/VerificationCase/properties/counts/type", keyword: "type", params: { type: "array" }, message: "must be array" };
            if (vErrors === null) {
              vErrors = [err82];
            } else {
              vErrors.push(err82);
            }
            errors++;
          }
        }
        if (data1.bonus !== void 0) {
          let data34 = data1.bonus;
          if (data34 && typeof data34 == "object" && !Array.isArray(data34)) {
            if (data34.value === void 0) {
              const err83 = { instancePath: instancePath + "/case/bonus", schemaPath: "#/definitions/VerificationCase/properties/bonus/required", keyword: "required", params: { missingProperty: "value" }, message: "must have required property 'value'" };
              if (vErrors === null) {
                vErrors = [err83];
              } else {
                vErrors.push(err83);
              }
              errors++;
            }
            if (data34.statedIn === void 0) {
              const err84 = { instancePath: instancePath + "/case/bonus", schemaPath: "#/definitions/VerificationCase/properties/bonus/required", keyword: "required", params: { missingProperty: "statedIn" }, message: "must have required property 'statedIn'" };
              if (vErrors === null) {
                vErrors = [err84];
              } else {
                vErrors.push(err84);
              }
              errors++;
            }
            for (const key8 in data34) {
              if (!(key8 === "value" || key8 === "statedIn")) {
                const err85 = { instancePath: instancePath + "/case/bonus", schemaPath: "#/definitions/VerificationCase/properties/bonus/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key8 }, message: "must NOT have additional properties" };
                if (vErrors === null) {
                  vErrors = [err85];
                } else {
                  vErrors.push(err85);
                }
                errors++;
              }
            }
            if (data34.value !== void 0) {
              let data35 = data34.value;
              if (typeof data35 !== "string") {
                const err86 = { instancePath: instancePath + "/case/bonus/value", schemaPath: "#/definitions/VerificationCase/properties/bonus/properties/value/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err86];
                } else {
                  vErrors.push(err86);
                }
                errors++;
              }
              if (!(data35 === "prozent60" || data35 === "prozent70" || data35 === "prozent75" || data35 === "prozent100")) {
                const err87 = { instancePath: instancePath + "/case/bonus/value", schemaPath: "#/definitions/VerificationCase/properties/bonus/properties/value/enum", keyword: "enum", params: { allowedValues: schema51.properties.bonus.properties.value.enum }, message: "must be equal to one of the allowed values" };
                if (vErrors === null) {
                  vErrors = [err87];
                } else {
                  vErrors.push(err87);
                }
                errors++;
              }
            }
            if (data34.statedIn !== void 0) {
              if (typeof data34.statedIn !== "string") {
                const err88 = { instancePath: instancePath + "/case/bonus/statedIn", schemaPath: "#/definitions/VerificationCase/properties/bonus/properties/statedIn/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err88];
                } else {
                  vErrors.push(err88);
                }
                errors++;
              }
            }
          } else {
            const err89 = { instancePath: instancePath + "/case/bonus", schemaPath: "#/definitions/VerificationCase/properties/bonus/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
              vErrors = [err89];
            } else {
              vErrors.push(err89);
            }
            errors++;
          }
        }
        if (data1.kostentraeger !== void 0) {
          let data37 = data1.kostentraeger;
          if (data37 && typeof data37 == "object" && !Array.isArray(data37)) {
            if (data37.value === void 0) {
              const err90 = { instancePath: instancePath + "/case/kostentraeger", schemaPath: "#/definitions/VerificationCase/properties/kostentraeger/required", keyword: "required", params: { missingProperty: "value" }, message: "must have required property 'value'" };
              if (vErrors === null) {
                vErrors = [err90];
              } else {
                vErrors.push(err90);
              }
              errors++;
            }
            if (data37.statedIn === void 0) {
              const err91 = { instancePath: instancePath + "/case/kostentraeger", schemaPath: "#/definitions/VerificationCase/properties/kostentraeger/required", keyword: "required", params: { missingProperty: "statedIn" }, message: "must have required property 'statedIn'" };
              if (vErrors === null) {
                vErrors = [err91];
              } else {
                vErrors.push(err91);
              }
              errors++;
            }
            for (const key9 in data37) {
              if (!(key9 === "value" || key9 === "statedIn")) {
                const err92 = { instancePath: instancePath + "/case/kostentraeger", schemaPath: "#/definitions/VerificationCase/properties/kostentraeger/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key9 }, message: "must NOT have additional properties" };
                if (vErrors === null) {
                  vErrors = [err92];
                } else {
                  vErrors.push(err92);
                }
                errors++;
              }
            }
            if (data37.value !== void 0) {
              let data38 = data37.value;
              if (typeof data38 !== "string") {
                const err93 = { instancePath: instancePath + "/case/kostentraeger/value", schemaPath: "#/definitions/VerificationCase/properties/kostentraeger/properties/value/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err93];
                } else {
                  vErrors.push(err93);
                }
                errors++;
              }
              if (!(data38 === "gkv_kzv_bw")) {
                const err94 = { instancePath: instancePath + "/case/kostentraeger/value", schemaPath: "#/definitions/VerificationCase/properties/kostentraeger/properties/value/enum", keyword: "enum", params: { allowedValues: schema51.properties.kostentraeger.properties.value.enum }, message: "must be equal to one of the allowed values" };
                if (vErrors === null) {
                  vErrors = [err94];
                } else {
                  vErrors.push(err94);
                }
                errors++;
              }
            }
            if (data37.statedIn !== void 0) {
              if (typeof data37.statedIn !== "string") {
                const err95 = { instancePath: instancePath + "/case/kostentraeger/statedIn", schemaPath: "#/definitions/VerificationCase/properties/kostentraeger/properties/statedIn/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err95];
                } else {
                  vErrors.push(err95);
                }
                errors++;
              }
            }
          } else {
            const err96 = { instancePath: instancePath + "/case/kostentraeger", schemaPath: "#/definitions/VerificationCase/properties/kostentraeger/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
              vErrors = [err96];
            } else {
              vErrors.push(err96);
            }
            errors++;
          }
        }
      } else {
        const err97 = { instancePath: instancePath + "/case", schemaPath: "#/definitions/VerificationCase/type", keyword: "type", params: { type: "object" }, message: "must be object" };
        if (vErrors === null) {
          vErrors = [err97];
        } else {
          vErrors.push(err97);
        }
        errors++;
      }
    }
    if (data.refused !== void 0) {
      let data40 = data.refused;
      if (Array.isArray(data40)) {
        const len6 = data40.length;
        for (let i6 = 0; i6 < len6; i6++) {
          let data41 = data40[i6];
          if (data41 && typeof data41 == "object" && !Array.isArray(data41)) {
            if (data41.value === void 0) {
              const err98 = { instancePath: instancePath + "/refused/" + i6, schemaPath: "#/properties/refused/items/required", keyword: "required", params: { missingProperty: "value" }, message: "must have required property 'value'" };
              if (vErrors === null) {
                vErrors = [err98];
              } else {
                vErrors.push(err98);
              }
              errors++;
            }
            if (data41.reason === void 0) {
              const err99 = { instancePath: instancePath + "/refused/" + i6, schemaPath: "#/properties/refused/items/required", keyword: "required", params: { missingProperty: "reason" }, message: "must have required property 'reason'" };
              if (vErrors === null) {
                vErrors = [err99];
              } else {
                vErrors.push(err99);
              }
              errors++;
            }
            for (const key10 in data41) {
              if (!(key10 === "fdi" || key10 === "jaw" || key10 === "fact" || key10 === "at" || key10 === "nr" || key10 === "value" || key10 === "reason")) {
                const err100 = { instancePath: instancePath + "/refused/" + i6, schemaPath: "#/properties/refused/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key10 }, message: "must NOT have additional properties" };
                if (vErrors === null) {
                  vErrors = [err100];
                } else {
                  vErrors.push(err100);
                }
                errors++;
              }
            }
            if (data41.fdi !== void 0) {
              let data42 = data41.fdi;
              if (!(typeof data42 == "number" && isFinite(data42))) {
                const err101 = { instancePath: instancePath + "/refused/" + i6 + "/fdi", schemaPath: "#/properties/refused/items/properties/fdi/type", keyword: "type", params: { type: "number" }, message: "must be number" };
                if (vErrors === null) {
                  vErrors = [err101];
                } else {
                  vErrors.push(err101);
                }
                errors++;
              }
            }
            if (data41.jaw !== void 0) {
              if (typeof data41.jaw !== "string") {
                const err102 = { instancePath: instancePath + "/refused/" + i6 + "/jaw", schemaPath: "#/properties/refused/items/properties/jaw/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err102];
                } else {
                  vErrors.push(err102);
                }
                errors++;
              }
            }
            if (data41.fact !== void 0) {
              if (typeof data41.fact !== "string") {
                const err103 = { instancePath: instancePath + "/refused/" + i6 + "/fact", schemaPath: "#/properties/refused/items/properties/fact/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err103];
                } else {
                  vErrors.push(err103);
                }
                errors++;
              }
            }
            if (data41.at !== void 0) {
              if (typeof data41.at !== "string") {
                const err104 = { instancePath: instancePath + "/refused/" + i6 + "/at", schemaPath: "#/properties/refused/items/properties/at/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err104];
                } else {
                  vErrors.push(err104);
                }
                errors++;
              }
            }
            if (data41.nr !== void 0) {
              if (typeof data41.nr !== "string") {
                const err105 = { instancePath: instancePath + "/refused/" + i6 + "/nr", schemaPath: "#/properties/refused/items/properties/nr/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err105];
                } else {
                  vErrors.push(err105);
                }
                errors++;
              }
            }
            if (data41.value !== void 0) {
              let data47 = data41.value;
              const _errs116 = errors;
              let valid28 = false;
              const _errs117 = errors;
              if (typeof data47 !== "boolean") {
                const err106 = { instancePath: instancePath + "/refused/" + i6 + "/value", schemaPath: "#/properties/refused/items/properties/value/anyOf/0/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                if (vErrors === null) {
                  vErrors = [err106];
                } else {
                  vErrors.push(err106);
                }
                errors++;
              }
              var _valid2 = _errs117 === errors;
              valid28 = valid28 || _valid2;
              if (!valid28) {
                const _errs119 = errors;
                if (typeof data47 !== "string") {
                  const err107 = { instancePath: instancePath + "/refused/" + i6 + "/value", schemaPath: "#/properties/refused/items/properties/value/anyOf/1/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                  if (vErrors === null) {
                    vErrors = [err107];
                  } else {
                    vErrors.push(err107);
                  }
                  errors++;
                }
                var _valid2 = _errs119 === errors;
                valid28 = valid28 || _valid2;
              }
              if (!valid28) {
                const err108 = { instancePath: instancePath + "/refused/" + i6 + "/value", schemaPath: "#/properties/refused/items/properties/value/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                if (vErrors === null) {
                  vErrors = [err108];
                } else {
                  vErrors.push(err108);
                }
                errors++;
              } else {
                errors = _errs116;
                if (vErrors !== null) {
                  if (_errs116) {
                    vErrors.length = _errs116;
                  } else {
                    vErrors = null;
                  }
                }
              }
            }
            if (data41.reason !== void 0) {
              if (typeof data41.reason !== "string") {
                const err109 = { instancePath: instancePath + "/refused/" + i6 + "/reason", schemaPath: "#/properties/refused/items/properties/reason/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err109];
                } else {
                  vErrors.push(err109);
                }
                errors++;
              }
            }
          } else {
            const err110 = { instancePath: instancePath + "/refused/" + i6, schemaPath: "#/properties/refused/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
              vErrors = [err110];
            } else {
              vErrors.push(err110);
            }
            errors++;
          }
        }
      } else {
        const err111 = { instancePath: instancePath + "/refused", schemaPath: "#/properties/refused/type", keyword: "type", params: { type: "array" }, message: "must be array" };
        if (vErrors === null) {
          vErrors = [err111];
        } else {
          vErrors.push(err111);
        }
        errors++;
      }
    }
  } else {
    const err112 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err112];
    } else {
      vErrors.push(err112);
    }
    errors++;
  }
  validate43.errors = vErrors;
  return errors === 0;
}
var validateInput17 = validate44;
var schema52 = { "$schema": "http://json-schema.org/draft-07/schema#", "type": "object", "properties": { "conversationId": { "type": "string", "minLength": 1, "description": "The conversation the case belongs to; the agent's is named in its prompt." }, "teeth": { "type": "array", "items": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 } }, "findings": { "type": "array", "items": { "type": "object", "properties": { "fdi": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991, "description": "The tooth, by FDI number (11\u201348)." }, "jaw": { "type": "string", "enum": ["OK", "UK"], "description": "The jaw: OK upper, UK lower." }, "fact": { "type": "string", "enum": ["fehlt", "erhaltungswuerdig", "krone", "endodontisch_behandelt", "stiftaufbau", "brueckenanker", "disparallel", "wiederherstellung", "geplant", "lueckensituation_i"], "description": "A finding, by name: at a tooth, or at a jaw (lueckensituation_i)." }, "value": { "anyOf": [{ "type": "boolean" }, { "type": "string" }] }, "quote": { "type": "string", "minLength": 1 } }, "required": ["fact", "value"], "additionalProperties": false } } }, "required": ["conversationId"], "additionalProperties": false };
function validate44(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.conversationId === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "conversationId" }, message: "must have required property 'conversationId'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    for (const key0 in data) {
      if (!(key0 === "conversationId" || key0 === "teeth" || key0 === "findings")) {
        const err1 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
    }
    if (data.conversationId !== void 0) {
      let data0 = data.conversationId;
      if (typeof data0 === "string") {
        if (func2(data0) < 1) {
          const err2 = { instancePath: instancePath + "/conversationId", schemaPath: "#/properties/conversationId/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
          if (vErrors === null) {
            vErrors = [err2];
          } else {
            vErrors.push(err2);
          }
          errors++;
        }
      } else {
        const err3 = { instancePath: instancePath + "/conversationId", schemaPath: "#/properties/conversationId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.teeth !== void 0) {
      let data1 = data.teeth;
      if (Array.isArray(data1)) {
        const len0 = data1.length;
        for (let i0 = 0; i0 < len0; i0++) {
          let data2 = data1[i0];
          if (!(typeof data2 == "number" && (!(data2 % 1) && !isNaN(data2)) && isFinite(data2))) {
            const err4 = { instancePath: instancePath + "/teeth/" + i0, schemaPath: "#/properties/teeth/items/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
            if (vErrors === null) {
              vErrors = [err4];
            } else {
              vErrors.push(err4);
            }
            errors++;
          }
          if (typeof data2 == "number" && isFinite(data2)) {
            if (data2 > 9007199254740991 || isNaN(data2)) {
              const err5 = { instancePath: instancePath + "/teeth/" + i0, schemaPath: "#/properties/teeth/items/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
              if (vErrors === null) {
                vErrors = [err5];
              } else {
                vErrors.push(err5);
              }
              errors++;
            }
            if (data2 < -9007199254740991 || isNaN(data2)) {
              const err6 = { instancePath: instancePath + "/teeth/" + i0, schemaPath: "#/properties/teeth/items/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
              if (vErrors === null) {
                vErrors = [err6];
              } else {
                vErrors.push(err6);
              }
              errors++;
            }
          }
        }
      } else {
        const err7 = { instancePath: instancePath + "/teeth", schemaPath: "#/properties/teeth/type", keyword: "type", params: { type: "array" }, message: "must be array" };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
    }
    if (data.findings !== void 0) {
      let data3 = data.findings;
      if (Array.isArray(data3)) {
        const len1 = data3.length;
        for (let i1 = 0; i1 < len1; i1++) {
          let data4 = data3[i1];
          if (data4 && typeof data4 == "object" && !Array.isArray(data4)) {
            if (data4.fact === void 0) {
              const err8 = { instancePath: instancePath + "/findings/" + i1, schemaPath: "#/properties/findings/items/required", keyword: "required", params: { missingProperty: "fact" }, message: "must have required property 'fact'" };
              if (vErrors === null) {
                vErrors = [err8];
              } else {
                vErrors.push(err8);
              }
              errors++;
            }
            if (data4.value === void 0) {
              const err9 = { instancePath: instancePath + "/findings/" + i1, schemaPath: "#/properties/findings/items/required", keyword: "required", params: { missingProperty: "value" }, message: "must have required property 'value'" };
              if (vErrors === null) {
                vErrors = [err9];
              } else {
                vErrors.push(err9);
              }
              errors++;
            }
            for (const key1 in data4) {
              if (!(key1 === "fdi" || key1 === "jaw" || key1 === "fact" || key1 === "value" || key1 === "quote")) {
                const err10 = { instancePath: instancePath + "/findings/" + i1, schemaPath: "#/properties/findings/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
                if (vErrors === null) {
                  vErrors = [err10];
                } else {
                  vErrors.push(err10);
                }
                errors++;
              }
            }
            if (data4.fdi !== void 0) {
              let data5 = data4.fdi;
              if (!(typeof data5 == "number" && (!(data5 % 1) && !isNaN(data5)) && isFinite(data5))) {
                const err11 = { instancePath: instancePath + "/findings/" + i1 + "/fdi", schemaPath: "#/properties/findings/items/properties/fdi/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                if (vErrors === null) {
                  vErrors = [err11];
                } else {
                  vErrors.push(err11);
                }
                errors++;
              }
              if (typeof data5 == "number" && isFinite(data5)) {
                if (data5 > 9007199254740991 || isNaN(data5)) {
                  const err12 = { instancePath: instancePath + "/findings/" + i1 + "/fdi", schemaPath: "#/properties/findings/items/properties/fdi/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err12];
                  } else {
                    vErrors.push(err12);
                  }
                  errors++;
                }
                if (data5 < -9007199254740991 || isNaN(data5)) {
                  const err13 = { instancePath: instancePath + "/findings/" + i1 + "/fdi", schemaPath: "#/properties/findings/items/properties/fdi/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err13];
                  } else {
                    vErrors.push(err13);
                  }
                  errors++;
                }
              }
            }
            if (data4.jaw !== void 0) {
              let data6 = data4.jaw;
              if (typeof data6 !== "string") {
                const err14 = { instancePath: instancePath + "/findings/" + i1 + "/jaw", schemaPath: "#/properties/findings/items/properties/jaw/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err14];
                } else {
                  vErrors.push(err14);
                }
                errors++;
              }
              if (!(data6 === "OK" || data6 === "UK")) {
                const err15 = { instancePath: instancePath + "/findings/" + i1 + "/jaw", schemaPath: "#/properties/findings/items/properties/jaw/enum", keyword: "enum", params: { allowedValues: schema52.properties.findings.items.properties.jaw.enum }, message: "must be equal to one of the allowed values" };
                if (vErrors === null) {
                  vErrors = [err15];
                } else {
                  vErrors.push(err15);
                }
                errors++;
              }
            }
            if (data4.fact !== void 0) {
              let data7 = data4.fact;
              if (typeof data7 !== "string") {
                const err16 = { instancePath: instancePath + "/findings/" + i1 + "/fact", schemaPath: "#/properties/findings/items/properties/fact/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err16];
                } else {
                  vErrors.push(err16);
                }
                errors++;
              }
              if (!(data7 === "fehlt" || data7 === "erhaltungswuerdig" || data7 === "krone" || data7 === "endodontisch_behandelt" || data7 === "stiftaufbau" || data7 === "brueckenanker" || data7 === "disparallel" || data7 === "wiederherstellung" || data7 === "geplant" || data7 === "lueckensituation_i")) {
                const err17 = { instancePath: instancePath + "/findings/" + i1 + "/fact", schemaPath: "#/properties/findings/items/properties/fact/enum", keyword: "enum", params: { allowedValues: schema52.properties.findings.items.properties.fact.enum }, message: "must be equal to one of the allowed values" };
                if (vErrors === null) {
                  vErrors = [err17];
                } else {
                  vErrors.push(err17);
                }
                errors++;
              }
            }
            if (data4.value !== void 0) {
              let data8 = data4.value;
              const _errs20 = errors;
              let valid6 = false;
              const _errs21 = errors;
              if (typeof data8 !== "boolean") {
                const err18 = { instancePath: instancePath + "/findings/" + i1 + "/value", schemaPath: "#/properties/findings/items/properties/value/anyOf/0/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                if (vErrors === null) {
                  vErrors = [err18];
                } else {
                  vErrors.push(err18);
                }
                errors++;
              }
              var _valid0 = _errs21 === errors;
              valid6 = valid6 || _valid0;
              if (!valid6) {
                const _errs23 = errors;
                if (typeof data8 !== "string") {
                  const err19 = { instancePath: instancePath + "/findings/" + i1 + "/value", schemaPath: "#/properties/findings/items/properties/value/anyOf/1/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                  if (vErrors === null) {
                    vErrors = [err19];
                  } else {
                    vErrors.push(err19);
                  }
                  errors++;
                }
                var _valid0 = _errs23 === errors;
                valid6 = valid6 || _valid0;
              }
              if (!valid6) {
                const err20 = { instancePath: instancePath + "/findings/" + i1 + "/value", schemaPath: "#/properties/findings/items/properties/value/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                if (vErrors === null) {
                  vErrors = [err20];
                } else {
                  vErrors.push(err20);
                }
                errors++;
              } else {
                errors = _errs20;
                if (vErrors !== null) {
                  if (_errs20) {
                    vErrors.length = _errs20;
                  } else {
                    vErrors = null;
                  }
                }
              }
            }
            if (data4.quote !== void 0) {
              let data9 = data4.quote;
              if (typeof data9 === "string") {
                if (func2(data9) < 1) {
                  const err21 = { instancePath: instancePath + "/findings/" + i1 + "/quote", schemaPath: "#/properties/findings/items/properties/quote/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                  if (vErrors === null) {
                    vErrors = [err21];
                  } else {
                    vErrors.push(err21);
                  }
                  errors++;
                }
              } else {
                const err22 = { instancePath: instancePath + "/findings/" + i1 + "/quote", schemaPath: "#/properties/findings/items/properties/quote/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err22];
                } else {
                  vErrors.push(err22);
                }
                errors++;
              }
            }
          } else {
            const err23 = { instancePath: instancePath + "/findings/" + i1, schemaPath: "#/properties/findings/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
              vErrors = [err23];
            } else {
              vErrors.push(err23);
            }
            errors++;
          }
        }
      } else {
        const err24 = { instancePath: instancePath + "/findings", schemaPath: "#/properties/findings/type", keyword: "type", params: { type: "array" }, message: "must be array" };
        if (vErrors === null) {
          vErrors = [err24];
        } else {
          vErrors.push(err24);
        }
        errors++;
      }
    }
  } else {
    const err25 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err25];
    } else {
      vErrors.push(err25);
    }
    errors++;
  }
  validate44.errors = vErrors;
  return errors === 0;
}
var validateOutput17 = validate45;
var schema54 = { "type": "object", "properties": { "object": { "type": "string", "const": "verification_case" }, "conversationId": { "type": "string" }, "teeth": { "type": "array", "items": { "type": "object", "properties": { "fdi": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991 }, "findings": { "type": "array", "items": { "type": "object", "properties": { "fact": { "type": "string", "enum": ["fehlt", "erhaltungswuerdig", "krone", "endodontisch_behandelt", "stiftaufbau", "brueckenanker", "disparallel", "wiederherstellung", "geplant", "lueckensituation_i"], "description": "A finding, by name: at a tooth, or at a jaw (lueckensituation_i)." }, "value": { "anyOf": [{ "type": "boolean" }, { "type": "string" }] }, "status": { "type": "string", "enum": ["proposed", "confirmed"], "description": "Proposed by the agent, or confirmed by the dentist. Rules read only confirmed ones." }, "quote": { "description": "The dentist's words a proposal was read from.", "type": "string" }, "statedIn": { "description": "The statement a confirmed finding rests on.", "type": "string" } }, "required": ["fact", "value", "status"], "additionalProperties": false } } }, "required": ["fdi", "findings"], "additionalProperties": false } }, "jaws": { "type": "array", "items": { "type": "object", "properties": { "jaw": { "type": "string", "enum": ["OK", "UK"], "description": "The jaw: OK upper, UK lower." }, "findings": { "type": "array", "items": { "type": "object", "properties": { "fact": { "type": "string", "enum": ["fehlt", "erhaltungswuerdig", "krone", "endodontisch_behandelt", "stiftaufbau", "brueckenanker", "disparallel", "wiederherstellung", "geplant", "lueckensituation_i"], "description": "A finding, by name: at a tooth, or at a jaw (lueckensituation_i)." }, "value": { "anyOf": [{ "type": "boolean" }, { "type": "string" }] }, "status": { "type": "string", "enum": ["proposed", "confirmed"], "description": "Proposed by the agent, or confirmed by the dentist. Rules read only confirmed ones." }, "quote": { "description": "The dentist's words a proposal was read from.", "type": "string" }, "statedIn": { "description": "The statement a confirmed finding rests on.", "type": "string" } }, "required": ["fact", "value", "status"], "additionalProperties": false } } }, "required": ["jaw", "findings"], "additionalProperties": false }, "description": "Findings at a jaw: whether it is in L\xFCckensituation I." }, "statements": { "type": "array", "items": { "type": "object", "properties": { "id": { "type": "string" }, "at": { "type": "string", "format": "date-time", "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" } }, "required": ["id", "at"], "additionalProperties": false } }, "counts": { "type": "array", "items": { "type": "object", "properties": { "at": { "type": "string", "description": `Where the line is billed, as the costs list it: a tooth's number ("12"), a gap's id ("UK:45-47"), a jaw, or "patient".` }, "nr": { "type": "string", "description": "The BEMA number, e.g. 20b." }, "value": { "type": "integer", "minimum": 1, "maximum": 99, "description": "How often it goes on the HKP." }, "statedIn": { "type": "string" } }, "required": ["at", "nr", "value", "statedIn"], "additionalProperties": false }, "description": "The dentist's counts for BEMA lines no source counts; the costs bill these." }, "bonus": { "description": "The patient's subsidy level, once the dentist states it.", "type": "object", "properties": { "value": { "type": "string", "enum": ["prozent60", "prozent70", "prozent75", "prozent100"], "description": "The Festzuschuss level from the patient's Bonusheft: 60 % without bonus, 70 % and 75 % with, 100 % for hardship." }, "statedIn": { "type": "string" } }, "required": ["value", "statedIn"], "additionalProperties": false }, "kostentraeger": { "description": "Who pays, once the dentist confirms it; assumed until then.", "type": "object", "properties": { "value": { "type": "string", "enum": ["gkv_kzv_bw"], "description": "Who pays: statutory insurance, billed at the KZV Baden-W\xFCrttemberg's prices, the only one the rules cover." }, "statedIn": { "type": "string" } }, "required": ["value", "statedIn"], "additionalProperties": false } }, "required": ["object", "conversationId", "teeth", "jaws", "statements", "counts"], "additionalProperties": false };
function validate45(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.object === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "object" }, message: "must have required property 'object'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.case === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "case" }, message: "must have required property 'case'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.refused === void 0) {
      const err2 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "refused" }, message: "must have required property 'refused'" };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    for (const key0 in data) {
      if (!(key0 === "object" || key0 === "case" || key0 === "refused")) {
        const err3 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.object !== void 0) {
      let data0 = data.object;
      if (typeof data0 !== "string") {
        const err4 = { instancePath: instancePath + "/object", schemaPath: "#/properties/object/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
      if ("verification_change" !== data0) {
        const err5 = { instancePath: instancePath + "/object", schemaPath: "#/properties/object/const", keyword: "const", params: { allowedValue: "verification_change" }, message: "must be equal to constant" };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
    }
    if (data.case !== void 0) {
      let data1 = data.case;
      if (data1 && typeof data1 == "object" && !Array.isArray(data1)) {
        if (data1.object === void 0) {
          const err6 = { instancePath: instancePath + "/case", schemaPath: "#/definitions/VerificationCase/required", keyword: "required", params: { missingProperty: "object" }, message: "must have required property 'object'" };
          if (vErrors === null) {
            vErrors = [err6];
          } else {
            vErrors.push(err6);
          }
          errors++;
        }
        if (data1.conversationId === void 0) {
          const err7 = { instancePath: instancePath + "/case", schemaPath: "#/definitions/VerificationCase/required", keyword: "required", params: { missingProperty: "conversationId" }, message: "must have required property 'conversationId'" };
          if (vErrors === null) {
            vErrors = [err7];
          } else {
            vErrors.push(err7);
          }
          errors++;
        }
        if (data1.teeth === void 0) {
          const err8 = { instancePath: instancePath + "/case", schemaPath: "#/definitions/VerificationCase/required", keyword: "required", params: { missingProperty: "teeth" }, message: "must have required property 'teeth'" };
          if (vErrors === null) {
            vErrors = [err8];
          } else {
            vErrors.push(err8);
          }
          errors++;
        }
        if (data1.jaws === void 0) {
          const err9 = { instancePath: instancePath + "/case", schemaPath: "#/definitions/VerificationCase/required", keyword: "required", params: { missingProperty: "jaws" }, message: "must have required property 'jaws'" };
          if (vErrors === null) {
            vErrors = [err9];
          } else {
            vErrors.push(err9);
          }
          errors++;
        }
        if (data1.statements === void 0) {
          const err10 = { instancePath: instancePath + "/case", schemaPath: "#/definitions/VerificationCase/required", keyword: "required", params: { missingProperty: "statements" }, message: "must have required property 'statements'" };
          if (vErrors === null) {
            vErrors = [err10];
          } else {
            vErrors.push(err10);
          }
          errors++;
        }
        if (data1.counts === void 0) {
          const err11 = { instancePath: instancePath + "/case", schemaPath: "#/definitions/VerificationCase/required", keyword: "required", params: { missingProperty: "counts" }, message: "must have required property 'counts'" };
          if (vErrors === null) {
            vErrors = [err11];
          } else {
            vErrors.push(err11);
          }
          errors++;
        }
        for (const key1 in data1) {
          if (!(key1 === "object" || key1 === "conversationId" || key1 === "teeth" || key1 === "jaws" || key1 === "statements" || key1 === "counts" || key1 === "bonus" || key1 === "kostentraeger")) {
            const err12 = { instancePath: instancePath + "/case", schemaPath: "#/definitions/VerificationCase/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
            if (vErrors === null) {
              vErrors = [err12];
            } else {
              vErrors.push(err12);
            }
            errors++;
          }
        }
        if (data1.object !== void 0) {
          let data2 = data1.object;
          if (typeof data2 !== "string") {
            const err13 = { instancePath: instancePath + "/case/object", schemaPath: "#/definitions/VerificationCase/properties/object/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err13];
            } else {
              vErrors.push(err13);
            }
            errors++;
          }
          if ("verification_case" !== data2) {
            const err14 = { instancePath: instancePath + "/case/object", schemaPath: "#/definitions/VerificationCase/properties/object/const", keyword: "const", params: { allowedValue: "verification_case" }, message: "must be equal to constant" };
            if (vErrors === null) {
              vErrors = [err14];
            } else {
              vErrors.push(err14);
            }
            errors++;
          }
        }
        if (data1.conversationId !== void 0) {
          if (typeof data1.conversationId !== "string") {
            const err15 = { instancePath: instancePath + "/case/conversationId", schemaPath: "#/definitions/VerificationCase/properties/conversationId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
              vErrors = [err15];
            } else {
              vErrors.push(err15);
            }
            errors++;
          }
        }
        if (data1.teeth !== void 0) {
          let data4 = data1.teeth;
          if (Array.isArray(data4)) {
            const len0 = data4.length;
            for (let i0 = 0; i0 < len0; i0++) {
              let data5 = data4[i0];
              if (data5 && typeof data5 == "object" && !Array.isArray(data5)) {
                if (data5.fdi === void 0) {
                  const err16 = { instancePath: instancePath + "/case/teeth/" + i0, schemaPath: "#/definitions/VerificationCase/properties/teeth/items/required", keyword: "required", params: { missingProperty: "fdi" }, message: "must have required property 'fdi'" };
                  if (vErrors === null) {
                    vErrors = [err16];
                  } else {
                    vErrors.push(err16);
                  }
                  errors++;
                }
                if (data5.findings === void 0) {
                  const err17 = { instancePath: instancePath + "/case/teeth/" + i0, schemaPath: "#/definitions/VerificationCase/properties/teeth/items/required", keyword: "required", params: { missingProperty: "findings" }, message: "must have required property 'findings'" };
                  if (vErrors === null) {
                    vErrors = [err17];
                  } else {
                    vErrors.push(err17);
                  }
                  errors++;
                }
                for (const key2 in data5) {
                  if (!(key2 === "fdi" || key2 === "findings")) {
                    const err18 = { instancePath: instancePath + "/case/teeth/" + i0, schemaPath: "#/definitions/VerificationCase/properties/teeth/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key2 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                      vErrors = [err18];
                    } else {
                      vErrors.push(err18);
                    }
                    errors++;
                  }
                }
                if (data5.fdi !== void 0) {
                  let data6 = data5.fdi;
                  if (!(typeof data6 == "number" && (!(data6 % 1) && !isNaN(data6)) && isFinite(data6))) {
                    const err19 = { instancePath: instancePath + "/case/teeth/" + i0 + "/fdi", schemaPath: "#/definitions/VerificationCase/properties/teeth/items/properties/fdi/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err19];
                    } else {
                      vErrors.push(err19);
                    }
                    errors++;
                  }
                  if (typeof data6 == "number" && isFinite(data6)) {
                    if (data6 > 9007199254740991 || isNaN(data6)) {
                      const err20 = { instancePath: instancePath + "/case/teeth/" + i0 + "/fdi", schemaPath: "#/definitions/VerificationCase/properties/teeth/items/properties/fdi/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err20];
                      } else {
                        vErrors.push(err20);
                      }
                      errors++;
                    }
                    if (data6 < -9007199254740991 || isNaN(data6)) {
                      const err21 = { instancePath: instancePath + "/case/teeth/" + i0 + "/fdi", schemaPath: "#/definitions/VerificationCase/properties/teeth/items/properties/fdi/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                      if (vErrors === null) {
                        vErrors = [err21];
                      } else {
                        vErrors.push(err21);
                      }
                      errors++;
                    }
                  }
                }
                if (data5.findings !== void 0) {
                  let data7 = data5.findings;
                  if (Array.isArray(data7)) {
                    const len1 = data7.length;
                    for (let i1 = 0; i1 < len1; i1++) {
                      let data8 = data7[i1];
                      if (data8 && typeof data8 == "object" && !Array.isArray(data8)) {
                        if (data8.fact === void 0) {
                          const err22 = { instancePath: instancePath + "/case/teeth/" + i0 + "/findings/" + i1, schemaPath: "#/definitions/VerificationCase/properties/teeth/items/properties/findings/items/required", keyword: "required", params: { missingProperty: "fact" }, message: "must have required property 'fact'" };
                          if (vErrors === null) {
                            vErrors = [err22];
                          } else {
                            vErrors.push(err22);
                          }
                          errors++;
                        }
                        if (data8.value === void 0) {
                          const err23 = { instancePath: instancePath + "/case/teeth/" + i0 + "/findings/" + i1, schemaPath: "#/definitions/VerificationCase/properties/teeth/items/properties/findings/items/required", keyword: "required", params: { missingProperty: "value" }, message: "must have required property 'value'" };
                          if (vErrors === null) {
                            vErrors = [err23];
                          } else {
                            vErrors.push(err23);
                          }
                          errors++;
                        }
                        if (data8.status === void 0) {
                          const err24 = { instancePath: instancePath + "/case/teeth/" + i0 + "/findings/" + i1, schemaPath: "#/definitions/VerificationCase/properties/teeth/items/properties/findings/items/required", keyword: "required", params: { missingProperty: "status" }, message: "must have required property 'status'" };
                          if (vErrors === null) {
                            vErrors = [err24];
                          } else {
                            vErrors.push(err24);
                          }
                          errors++;
                        }
                        for (const key3 in data8) {
                          if (!(key3 === "fact" || key3 === "value" || key3 === "status" || key3 === "quote" || key3 === "statedIn")) {
                            const err25 = { instancePath: instancePath + "/case/teeth/" + i0 + "/findings/" + i1, schemaPath: "#/definitions/VerificationCase/properties/teeth/items/properties/findings/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key3 }, message: "must NOT have additional properties" };
                            if (vErrors === null) {
                              vErrors = [err25];
                            } else {
                              vErrors.push(err25);
                            }
                            errors++;
                          }
                        }
                        if (data8.fact !== void 0) {
                          let data9 = data8.fact;
                          if (typeof data9 !== "string") {
                            const err26 = { instancePath: instancePath + "/case/teeth/" + i0 + "/findings/" + i1 + "/fact", schemaPath: "#/definitions/VerificationCase/properties/teeth/items/properties/findings/items/properties/fact/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err26];
                            } else {
                              vErrors.push(err26);
                            }
                            errors++;
                          }
                          if (!(data9 === "fehlt" || data9 === "erhaltungswuerdig" || data9 === "krone" || data9 === "endodontisch_behandelt" || data9 === "stiftaufbau" || data9 === "brueckenanker" || data9 === "disparallel" || data9 === "wiederherstellung" || data9 === "geplant" || data9 === "lueckensituation_i")) {
                            const err27 = { instancePath: instancePath + "/case/teeth/" + i0 + "/findings/" + i1 + "/fact", schemaPath: "#/definitions/VerificationCase/properties/teeth/items/properties/findings/items/properties/fact/enum", keyword: "enum", params: { allowedValues: schema54.properties.teeth.items.properties.findings.items.properties.fact.enum }, message: "must be equal to one of the allowed values" };
                            if (vErrors === null) {
                              vErrors = [err27];
                            } else {
                              vErrors.push(err27);
                            }
                            errors++;
                          }
                        }
                        if (data8.value !== void 0) {
                          let data10 = data8.value;
                          const _errs27 = errors;
                          let valid9 = false;
                          const _errs28 = errors;
                          if (typeof data10 !== "boolean") {
                            const err28 = { instancePath: instancePath + "/case/teeth/" + i0 + "/findings/" + i1 + "/value", schemaPath: "#/definitions/VerificationCase/properties/teeth/items/properties/findings/items/properties/value/anyOf/0/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                            if (vErrors === null) {
                              vErrors = [err28];
                            } else {
                              vErrors.push(err28);
                            }
                            errors++;
                          }
                          var _valid0 = _errs28 === errors;
                          valid9 = valid9 || _valid0;
                          if (!valid9) {
                            const _errs30 = errors;
                            if (typeof data10 !== "string") {
                              const err29 = { instancePath: instancePath + "/case/teeth/" + i0 + "/findings/" + i1 + "/value", schemaPath: "#/definitions/VerificationCase/properties/teeth/items/properties/findings/items/properties/value/anyOf/1/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                              if (vErrors === null) {
                                vErrors = [err29];
                              } else {
                                vErrors.push(err29);
                              }
                              errors++;
                            }
                            var _valid0 = _errs30 === errors;
                            valid9 = valid9 || _valid0;
                          }
                          if (!valid9) {
                            const err30 = { instancePath: instancePath + "/case/teeth/" + i0 + "/findings/" + i1 + "/value", schemaPath: "#/definitions/VerificationCase/properties/teeth/items/properties/findings/items/properties/value/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                            if (vErrors === null) {
                              vErrors = [err30];
                            } else {
                              vErrors.push(err30);
                            }
                            errors++;
                          } else {
                            errors = _errs27;
                            if (vErrors !== null) {
                              if (_errs27) {
                                vErrors.length = _errs27;
                              } else {
                                vErrors = null;
                              }
                            }
                          }
                        }
                        if (data8.status !== void 0) {
                          let data11 = data8.status;
                          if (typeof data11 !== "string") {
                            const err31 = { instancePath: instancePath + "/case/teeth/" + i0 + "/findings/" + i1 + "/status", schemaPath: "#/definitions/VerificationCase/properties/teeth/items/properties/findings/items/properties/status/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err31];
                            } else {
                              vErrors.push(err31);
                            }
                            errors++;
                          }
                          if (!(data11 === "proposed" || data11 === "confirmed")) {
                            const err32 = { instancePath: instancePath + "/case/teeth/" + i0 + "/findings/" + i1 + "/status", schemaPath: "#/definitions/VerificationCase/properties/teeth/items/properties/findings/items/properties/status/enum", keyword: "enum", params: { allowedValues: schema54.properties.teeth.items.properties.findings.items.properties.status.enum }, message: "must be equal to one of the allowed values" };
                            if (vErrors === null) {
                              vErrors = [err32];
                            } else {
                              vErrors.push(err32);
                            }
                            errors++;
                          }
                        }
                        if (data8.quote !== void 0) {
                          if (typeof data8.quote !== "string") {
                            const err33 = { instancePath: instancePath + "/case/teeth/" + i0 + "/findings/" + i1 + "/quote", schemaPath: "#/definitions/VerificationCase/properties/teeth/items/properties/findings/items/properties/quote/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err33];
                            } else {
                              vErrors.push(err33);
                            }
                            errors++;
                          }
                        }
                        if (data8.statedIn !== void 0) {
                          if (typeof data8.statedIn !== "string") {
                            const err34 = { instancePath: instancePath + "/case/teeth/" + i0 + "/findings/" + i1 + "/statedIn", schemaPath: "#/definitions/VerificationCase/properties/teeth/items/properties/findings/items/properties/statedIn/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err34];
                            } else {
                              vErrors.push(err34);
                            }
                            errors++;
                          }
                        }
                      } else {
                        const err35 = { instancePath: instancePath + "/case/teeth/" + i0 + "/findings/" + i1, schemaPath: "#/definitions/VerificationCase/properties/teeth/items/properties/findings/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                        if (vErrors === null) {
                          vErrors = [err35];
                        } else {
                          vErrors.push(err35);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err36 = { instancePath: instancePath + "/case/teeth/" + i0 + "/findings", schemaPath: "#/definitions/VerificationCase/properties/teeth/items/properties/findings/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                      vErrors = [err36];
                    } else {
                      vErrors.push(err36);
                    }
                    errors++;
                  }
                }
              } else {
                const err37 = { instancePath: instancePath + "/case/teeth/" + i0, schemaPath: "#/definitions/VerificationCase/properties/teeth/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                if (vErrors === null) {
                  vErrors = [err37];
                } else {
                  vErrors.push(err37);
                }
                errors++;
              }
            }
          } else {
            const err38 = { instancePath: instancePath + "/case/teeth", schemaPath: "#/definitions/VerificationCase/properties/teeth/type", keyword: "type", params: { type: "array" }, message: "must be array" };
            if (vErrors === null) {
              vErrors = [err38];
            } else {
              vErrors.push(err38);
            }
            errors++;
          }
        }
        if (data1.jaws !== void 0) {
          let data14 = data1.jaws;
          if (Array.isArray(data14)) {
            const len2 = data14.length;
            for (let i2 = 0; i2 < len2; i2++) {
              let data15 = data14[i2];
              if (data15 && typeof data15 == "object" && !Array.isArray(data15)) {
                if (data15.jaw === void 0) {
                  const err39 = { instancePath: instancePath + "/case/jaws/" + i2, schemaPath: "#/definitions/VerificationCase/properties/jaws/items/required", keyword: "required", params: { missingProperty: "jaw" }, message: "must have required property 'jaw'" };
                  if (vErrors === null) {
                    vErrors = [err39];
                  } else {
                    vErrors.push(err39);
                  }
                  errors++;
                }
                if (data15.findings === void 0) {
                  const err40 = { instancePath: instancePath + "/case/jaws/" + i2, schemaPath: "#/definitions/VerificationCase/properties/jaws/items/required", keyword: "required", params: { missingProperty: "findings" }, message: "must have required property 'findings'" };
                  if (vErrors === null) {
                    vErrors = [err40];
                  } else {
                    vErrors.push(err40);
                  }
                  errors++;
                }
                for (const key4 in data15) {
                  if (!(key4 === "jaw" || key4 === "findings")) {
                    const err41 = { instancePath: instancePath + "/case/jaws/" + i2, schemaPath: "#/definitions/VerificationCase/properties/jaws/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key4 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                      vErrors = [err41];
                    } else {
                      vErrors.push(err41);
                    }
                    errors++;
                  }
                }
                if (data15.jaw !== void 0) {
                  let data16 = data15.jaw;
                  if (typeof data16 !== "string") {
                    const err42 = { instancePath: instancePath + "/case/jaws/" + i2 + "/jaw", schemaPath: "#/definitions/VerificationCase/properties/jaws/items/properties/jaw/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err42];
                    } else {
                      vErrors.push(err42);
                    }
                    errors++;
                  }
                  if (!(data16 === "OK" || data16 === "UK")) {
                    const err43 = { instancePath: instancePath + "/case/jaws/" + i2 + "/jaw", schemaPath: "#/definitions/VerificationCase/properties/jaws/items/properties/jaw/enum", keyword: "enum", params: { allowedValues: schema54.properties.jaws.items.properties.jaw.enum }, message: "must be equal to one of the allowed values" };
                    if (vErrors === null) {
                      vErrors = [err43];
                    } else {
                      vErrors.push(err43);
                    }
                    errors++;
                  }
                }
                if (data15.findings !== void 0) {
                  let data17 = data15.findings;
                  if (Array.isArray(data17)) {
                    const len3 = data17.length;
                    for (let i3 = 0; i3 < len3; i3++) {
                      let data18 = data17[i3];
                      if (data18 && typeof data18 == "object" && !Array.isArray(data18)) {
                        if (data18.fact === void 0) {
                          const err44 = { instancePath: instancePath + "/case/jaws/" + i2 + "/findings/" + i3, schemaPath: "#/definitions/VerificationCase/properties/jaws/items/properties/findings/items/required", keyword: "required", params: { missingProperty: "fact" }, message: "must have required property 'fact'" };
                          if (vErrors === null) {
                            vErrors = [err44];
                          } else {
                            vErrors.push(err44);
                          }
                          errors++;
                        }
                        if (data18.value === void 0) {
                          const err45 = { instancePath: instancePath + "/case/jaws/" + i2 + "/findings/" + i3, schemaPath: "#/definitions/VerificationCase/properties/jaws/items/properties/findings/items/required", keyword: "required", params: { missingProperty: "value" }, message: "must have required property 'value'" };
                          if (vErrors === null) {
                            vErrors = [err45];
                          } else {
                            vErrors.push(err45);
                          }
                          errors++;
                        }
                        if (data18.status === void 0) {
                          const err46 = { instancePath: instancePath + "/case/jaws/" + i2 + "/findings/" + i3, schemaPath: "#/definitions/VerificationCase/properties/jaws/items/properties/findings/items/required", keyword: "required", params: { missingProperty: "status" }, message: "must have required property 'status'" };
                          if (vErrors === null) {
                            vErrors = [err46];
                          } else {
                            vErrors.push(err46);
                          }
                          errors++;
                        }
                        for (const key5 in data18) {
                          if (!(key5 === "fact" || key5 === "value" || key5 === "status" || key5 === "quote" || key5 === "statedIn")) {
                            const err47 = { instancePath: instancePath + "/case/jaws/" + i2 + "/findings/" + i3, schemaPath: "#/definitions/VerificationCase/properties/jaws/items/properties/findings/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key5 }, message: "must NOT have additional properties" };
                            if (vErrors === null) {
                              vErrors = [err47];
                            } else {
                              vErrors.push(err47);
                            }
                            errors++;
                          }
                        }
                        if (data18.fact !== void 0) {
                          let data19 = data18.fact;
                          if (typeof data19 !== "string") {
                            const err48 = { instancePath: instancePath + "/case/jaws/" + i2 + "/findings/" + i3 + "/fact", schemaPath: "#/definitions/VerificationCase/properties/jaws/items/properties/findings/items/properties/fact/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err48];
                            } else {
                              vErrors.push(err48);
                            }
                            errors++;
                          }
                          if (!(data19 === "fehlt" || data19 === "erhaltungswuerdig" || data19 === "krone" || data19 === "endodontisch_behandelt" || data19 === "stiftaufbau" || data19 === "brueckenanker" || data19 === "disparallel" || data19 === "wiederherstellung" || data19 === "geplant" || data19 === "lueckensituation_i")) {
                            const err49 = { instancePath: instancePath + "/case/jaws/" + i2 + "/findings/" + i3 + "/fact", schemaPath: "#/definitions/VerificationCase/properties/jaws/items/properties/findings/items/properties/fact/enum", keyword: "enum", params: { allowedValues: schema54.properties.jaws.items.properties.findings.items.properties.fact.enum }, message: "must be equal to one of the allowed values" };
                            if (vErrors === null) {
                              vErrors = [err49];
                            } else {
                              vErrors.push(err49);
                            }
                            errors++;
                          }
                        }
                        if (data18.value !== void 0) {
                          let data20 = data18.value;
                          const _errs53 = errors;
                          let valid16 = false;
                          const _errs54 = errors;
                          if (typeof data20 !== "boolean") {
                            const err50 = { instancePath: instancePath + "/case/jaws/" + i2 + "/findings/" + i3 + "/value", schemaPath: "#/definitions/VerificationCase/properties/jaws/items/properties/findings/items/properties/value/anyOf/0/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                            if (vErrors === null) {
                              vErrors = [err50];
                            } else {
                              vErrors.push(err50);
                            }
                            errors++;
                          }
                          var _valid1 = _errs54 === errors;
                          valid16 = valid16 || _valid1;
                          if (!valid16) {
                            const _errs56 = errors;
                            if (typeof data20 !== "string") {
                              const err51 = { instancePath: instancePath + "/case/jaws/" + i2 + "/findings/" + i3 + "/value", schemaPath: "#/definitions/VerificationCase/properties/jaws/items/properties/findings/items/properties/value/anyOf/1/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                              if (vErrors === null) {
                                vErrors = [err51];
                              } else {
                                vErrors.push(err51);
                              }
                              errors++;
                            }
                            var _valid1 = _errs56 === errors;
                            valid16 = valid16 || _valid1;
                          }
                          if (!valid16) {
                            const err52 = { instancePath: instancePath + "/case/jaws/" + i2 + "/findings/" + i3 + "/value", schemaPath: "#/definitions/VerificationCase/properties/jaws/items/properties/findings/items/properties/value/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                            if (vErrors === null) {
                              vErrors = [err52];
                            } else {
                              vErrors.push(err52);
                            }
                            errors++;
                          } else {
                            errors = _errs53;
                            if (vErrors !== null) {
                              if (_errs53) {
                                vErrors.length = _errs53;
                              } else {
                                vErrors = null;
                              }
                            }
                          }
                        }
                        if (data18.status !== void 0) {
                          let data21 = data18.status;
                          if (typeof data21 !== "string") {
                            const err53 = { instancePath: instancePath + "/case/jaws/" + i2 + "/findings/" + i3 + "/status", schemaPath: "#/definitions/VerificationCase/properties/jaws/items/properties/findings/items/properties/status/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err53];
                            } else {
                              vErrors.push(err53);
                            }
                            errors++;
                          }
                          if (!(data21 === "proposed" || data21 === "confirmed")) {
                            const err54 = { instancePath: instancePath + "/case/jaws/" + i2 + "/findings/" + i3 + "/status", schemaPath: "#/definitions/VerificationCase/properties/jaws/items/properties/findings/items/properties/status/enum", keyword: "enum", params: { allowedValues: schema54.properties.jaws.items.properties.findings.items.properties.status.enum }, message: "must be equal to one of the allowed values" };
                            if (vErrors === null) {
                              vErrors = [err54];
                            } else {
                              vErrors.push(err54);
                            }
                            errors++;
                          }
                        }
                        if (data18.quote !== void 0) {
                          if (typeof data18.quote !== "string") {
                            const err55 = { instancePath: instancePath + "/case/jaws/" + i2 + "/findings/" + i3 + "/quote", schemaPath: "#/definitions/VerificationCase/properties/jaws/items/properties/findings/items/properties/quote/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err55];
                            } else {
                              vErrors.push(err55);
                            }
                            errors++;
                          }
                        }
                        if (data18.statedIn !== void 0) {
                          if (typeof data18.statedIn !== "string") {
                            const err56 = { instancePath: instancePath + "/case/jaws/" + i2 + "/findings/" + i3 + "/statedIn", schemaPath: "#/definitions/VerificationCase/properties/jaws/items/properties/findings/items/properties/statedIn/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                              vErrors = [err56];
                            } else {
                              vErrors.push(err56);
                            }
                            errors++;
                          }
                        }
                      } else {
                        const err57 = { instancePath: instancePath + "/case/jaws/" + i2 + "/findings/" + i3, schemaPath: "#/definitions/VerificationCase/properties/jaws/items/properties/findings/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                        if (vErrors === null) {
                          vErrors = [err57];
                        } else {
                          vErrors.push(err57);
                        }
                        errors++;
                      }
                    }
                  } else {
                    const err58 = { instancePath: instancePath + "/case/jaws/" + i2 + "/findings", schemaPath: "#/definitions/VerificationCase/properties/jaws/items/properties/findings/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                      vErrors = [err58];
                    } else {
                      vErrors.push(err58);
                    }
                    errors++;
                  }
                }
              } else {
                const err59 = { instancePath: instancePath + "/case/jaws/" + i2, schemaPath: "#/definitions/VerificationCase/properties/jaws/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                if (vErrors === null) {
                  vErrors = [err59];
                } else {
                  vErrors.push(err59);
                }
                errors++;
              }
            }
          } else {
            const err60 = { instancePath: instancePath + "/case/jaws", schemaPath: "#/definitions/VerificationCase/properties/jaws/type", keyword: "type", params: { type: "array" }, message: "must be array" };
            if (vErrors === null) {
              vErrors = [err60];
            } else {
              vErrors.push(err60);
            }
            errors++;
          }
        }
        if (data1.statements !== void 0) {
          let data24 = data1.statements;
          if (Array.isArray(data24)) {
            const len4 = data24.length;
            for (let i4 = 0; i4 < len4; i4++) {
              let data25 = data24[i4];
              if (data25 && typeof data25 == "object" && !Array.isArray(data25)) {
                if (data25.id === void 0) {
                  const err61 = { instancePath: instancePath + "/case/statements/" + i4, schemaPath: "#/definitions/VerificationCase/properties/statements/items/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property 'id'" };
                  if (vErrors === null) {
                    vErrors = [err61];
                  } else {
                    vErrors.push(err61);
                  }
                  errors++;
                }
                if (data25.at === void 0) {
                  const err62 = { instancePath: instancePath + "/case/statements/" + i4, schemaPath: "#/definitions/VerificationCase/properties/statements/items/required", keyword: "required", params: { missingProperty: "at" }, message: "must have required property 'at'" };
                  if (vErrors === null) {
                    vErrors = [err62];
                  } else {
                    vErrors.push(err62);
                  }
                  errors++;
                }
                for (const key6 in data25) {
                  if (!(key6 === "id" || key6 === "at")) {
                    const err63 = { instancePath: instancePath + "/case/statements/" + i4, schemaPath: "#/definitions/VerificationCase/properties/statements/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key6 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                      vErrors = [err63];
                    } else {
                      vErrors.push(err63);
                    }
                    errors++;
                  }
                }
                if (data25.id !== void 0) {
                  if (typeof data25.id !== "string") {
                    const err64 = { instancePath: instancePath + "/case/statements/" + i4 + "/id", schemaPath: "#/definitions/VerificationCase/properties/statements/items/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err64];
                    } else {
                      vErrors.push(err64);
                    }
                    errors++;
                  }
                }
                if (data25.at !== void 0) {
                  let data27 = data25.at;
                  if (typeof data27 === "string") {
                    if (!pattern0.test(data27)) {
                      const err65 = { instancePath: instancePath + "/case/statements/" + i4 + "/at", schemaPath: "#/definitions/VerificationCase/properties/statements/items/properties/at/pattern", keyword: "pattern", params: { pattern: "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$" }, message: 'must match pattern "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"' };
                      if (vErrors === null) {
                        vErrors = [err65];
                      } else {
                        vErrors.push(err65);
                      }
                      errors++;
                    }
                    if (!formats0.validate(data27)) {
                      const err66 = { instancePath: instancePath + "/case/statements/" + i4 + "/at", schemaPath: "#/definitions/VerificationCase/properties/statements/items/properties/at/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"' };
                      if (vErrors === null) {
                        vErrors = [err66];
                      } else {
                        vErrors.push(err66);
                      }
                      errors++;
                    }
                  } else {
                    const err67 = { instancePath: instancePath + "/case/statements/" + i4 + "/at", schemaPath: "#/definitions/VerificationCase/properties/statements/items/properties/at/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err67];
                    } else {
                      vErrors.push(err67);
                    }
                    errors++;
                  }
                }
              } else {
                const err68 = { instancePath: instancePath + "/case/statements/" + i4, schemaPath: "#/definitions/VerificationCase/properties/statements/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                if (vErrors === null) {
                  vErrors = [err68];
                } else {
                  vErrors.push(err68);
                }
                errors++;
              }
            }
          } else {
            const err69 = { instancePath: instancePath + "/case/statements", schemaPath: "#/definitions/VerificationCase/properties/statements/type", keyword: "type", params: { type: "array" }, message: "must be array" };
            if (vErrors === null) {
              vErrors = [err69];
            } else {
              vErrors.push(err69);
            }
            errors++;
          }
        }
        if (data1.counts !== void 0) {
          let data28 = data1.counts;
          if (Array.isArray(data28)) {
            const len5 = data28.length;
            for (let i5 = 0; i5 < len5; i5++) {
              let data29 = data28[i5];
              if (data29 && typeof data29 == "object" && !Array.isArray(data29)) {
                if (data29.at === void 0) {
                  const err70 = { instancePath: instancePath + "/case/counts/" + i5, schemaPath: "#/definitions/VerificationCase/properties/counts/items/required", keyword: "required", params: { missingProperty: "at" }, message: "must have required property 'at'" };
                  if (vErrors === null) {
                    vErrors = [err70];
                  } else {
                    vErrors.push(err70);
                  }
                  errors++;
                }
                if (data29.nr === void 0) {
                  const err71 = { instancePath: instancePath + "/case/counts/" + i5, schemaPath: "#/definitions/VerificationCase/properties/counts/items/required", keyword: "required", params: { missingProperty: "nr" }, message: "must have required property 'nr'" };
                  if (vErrors === null) {
                    vErrors = [err71];
                  } else {
                    vErrors.push(err71);
                  }
                  errors++;
                }
                if (data29.value === void 0) {
                  const err72 = { instancePath: instancePath + "/case/counts/" + i5, schemaPath: "#/definitions/VerificationCase/properties/counts/items/required", keyword: "required", params: { missingProperty: "value" }, message: "must have required property 'value'" };
                  if (vErrors === null) {
                    vErrors = [err72];
                  } else {
                    vErrors.push(err72);
                  }
                  errors++;
                }
                if (data29.statedIn === void 0) {
                  const err73 = { instancePath: instancePath + "/case/counts/" + i5, schemaPath: "#/definitions/VerificationCase/properties/counts/items/required", keyword: "required", params: { missingProperty: "statedIn" }, message: "must have required property 'statedIn'" };
                  if (vErrors === null) {
                    vErrors = [err73];
                  } else {
                    vErrors.push(err73);
                  }
                  errors++;
                }
                for (const key7 in data29) {
                  if (!(key7 === "at" || key7 === "nr" || key7 === "value" || key7 === "statedIn")) {
                    const err74 = { instancePath: instancePath + "/case/counts/" + i5, schemaPath: "#/definitions/VerificationCase/properties/counts/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key7 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                      vErrors = [err74];
                    } else {
                      vErrors.push(err74);
                    }
                    errors++;
                  }
                }
                if (data29.at !== void 0) {
                  if (typeof data29.at !== "string") {
                    const err75 = { instancePath: instancePath + "/case/counts/" + i5 + "/at", schemaPath: "#/definitions/VerificationCase/properties/counts/items/properties/at/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err75];
                    } else {
                      vErrors.push(err75);
                    }
                    errors++;
                  }
                }
                if (data29.nr !== void 0) {
                  if (typeof data29.nr !== "string") {
                    const err76 = { instancePath: instancePath + "/case/counts/" + i5 + "/nr", schemaPath: "#/definitions/VerificationCase/properties/counts/items/properties/nr/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err76];
                    } else {
                      vErrors.push(err76);
                    }
                    errors++;
                  }
                }
                if (data29.value !== void 0) {
                  let data32 = data29.value;
                  if (!(typeof data32 == "number" && (!(data32 % 1) && !isNaN(data32)) && isFinite(data32))) {
                    const err77 = { instancePath: instancePath + "/case/counts/" + i5 + "/value", schemaPath: "#/definitions/VerificationCase/properties/counts/items/properties/value/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                      vErrors = [err77];
                    } else {
                      vErrors.push(err77);
                    }
                    errors++;
                  }
                  if (typeof data32 == "number" && isFinite(data32)) {
                    if (data32 > 99 || isNaN(data32)) {
                      const err78 = { instancePath: instancePath + "/case/counts/" + i5 + "/value", schemaPath: "#/definitions/VerificationCase/properties/counts/items/properties/value/maximum", keyword: "maximum", params: { comparison: "<=", limit: 99 }, message: "must be <= 99" };
                      if (vErrors === null) {
                        vErrors = [err78];
                      } else {
                        vErrors.push(err78);
                      }
                      errors++;
                    }
                    if (data32 < 1 || isNaN(data32)) {
                      const err79 = { instancePath: instancePath + "/case/counts/" + i5 + "/value", schemaPath: "#/definitions/VerificationCase/properties/counts/items/properties/value/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" };
                      if (vErrors === null) {
                        vErrors = [err79];
                      } else {
                        vErrors.push(err79);
                      }
                      errors++;
                    }
                  }
                }
                if (data29.statedIn !== void 0) {
                  if (typeof data29.statedIn !== "string") {
                    const err80 = { instancePath: instancePath + "/case/counts/" + i5 + "/statedIn", schemaPath: "#/definitions/VerificationCase/properties/counts/items/properties/statedIn/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                      vErrors = [err80];
                    } else {
                      vErrors.push(err80);
                    }
                    errors++;
                  }
                }
              } else {
                const err81 = { instancePath: instancePath + "/case/counts/" + i5, schemaPath: "#/definitions/VerificationCase/properties/counts/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                if (vErrors === null) {
                  vErrors = [err81];
                } else {
                  vErrors.push(err81);
                }
                errors++;
              }
            }
          } else {
            const err82 = { instancePath: instancePath + "/case/counts", schemaPath: "#/definitions/VerificationCase/properties/counts/type", keyword: "type", params: { type: "array" }, message: "must be array" };
            if (vErrors === null) {
              vErrors = [err82];
            } else {
              vErrors.push(err82);
            }
            errors++;
          }
        }
        if (data1.bonus !== void 0) {
          let data34 = data1.bonus;
          if (data34 && typeof data34 == "object" && !Array.isArray(data34)) {
            if (data34.value === void 0) {
              const err83 = { instancePath: instancePath + "/case/bonus", schemaPath: "#/definitions/VerificationCase/properties/bonus/required", keyword: "required", params: { missingProperty: "value" }, message: "must have required property 'value'" };
              if (vErrors === null) {
                vErrors = [err83];
              } else {
                vErrors.push(err83);
              }
              errors++;
            }
            if (data34.statedIn === void 0) {
              const err84 = { instancePath: instancePath + "/case/bonus", schemaPath: "#/definitions/VerificationCase/properties/bonus/required", keyword: "required", params: { missingProperty: "statedIn" }, message: "must have required property 'statedIn'" };
              if (vErrors === null) {
                vErrors = [err84];
              } else {
                vErrors.push(err84);
              }
              errors++;
            }
            for (const key8 in data34) {
              if (!(key8 === "value" || key8 === "statedIn")) {
                const err85 = { instancePath: instancePath + "/case/bonus", schemaPath: "#/definitions/VerificationCase/properties/bonus/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key8 }, message: "must NOT have additional properties" };
                if (vErrors === null) {
                  vErrors = [err85];
                } else {
                  vErrors.push(err85);
                }
                errors++;
              }
            }
            if (data34.value !== void 0) {
              let data35 = data34.value;
              if (typeof data35 !== "string") {
                const err86 = { instancePath: instancePath + "/case/bonus/value", schemaPath: "#/definitions/VerificationCase/properties/bonus/properties/value/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err86];
                } else {
                  vErrors.push(err86);
                }
                errors++;
              }
              if (!(data35 === "prozent60" || data35 === "prozent70" || data35 === "prozent75" || data35 === "prozent100")) {
                const err87 = { instancePath: instancePath + "/case/bonus/value", schemaPath: "#/definitions/VerificationCase/properties/bonus/properties/value/enum", keyword: "enum", params: { allowedValues: schema54.properties.bonus.properties.value.enum }, message: "must be equal to one of the allowed values" };
                if (vErrors === null) {
                  vErrors = [err87];
                } else {
                  vErrors.push(err87);
                }
                errors++;
              }
            }
            if (data34.statedIn !== void 0) {
              if (typeof data34.statedIn !== "string") {
                const err88 = { instancePath: instancePath + "/case/bonus/statedIn", schemaPath: "#/definitions/VerificationCase/properties/bonus/properties/statedIn/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err88];
                } else {
                  vErrors.push(err88);
                }
                errors++;
              }
            }
          } else {
            const err89 = { instancePath: instancePath + "/case/bonus", schemaPath: "#/definitions/VerificationCase/properties/bonus/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
              vErrors = [err89];
            } else {
              vErrors.push(err89);
            }
            errors++;
          }
        }
        if (data1.kostentraeger !== void 0) {
          let data37 = data1.kostentraeger;
          if (data37 && typeof data37 == "object" && !Array.isArray(data37)) {
            if (data37.value === void 0) {
              const err90 = { instancePath: instancePath + "/case/kostentraeger", schemaPath: "#/definitions/VerificationCase/properties/kostentraeger/required", keyword: "required", params: { missingProperty: "value" }, message: "must have required property 'value'" };
              if (vErrors === null) {
                vErrors = [err90];
              } else {
                vErrors.push(err90);
              }
              errors++;
            }
            if (data37.statedIn === void 0) {
              const err91 = { instancePath: instancePath + "/case/kostentraeger", schemaPath: "#/definitions/VerificationCase/properties/kostentraeger/required", keyword: "required", params: { missingProperty: "statedIn" }, message: "must have required property 'statedIn'" };
              if (vErrors === null) {
                vErrors = [err91];
              } else {
                vErrors.push(err91);
              }
              errors++;
            }
            for (const key9 in data37) {
              if (!(key9 === "value" || key9 === "statedIn")) {
                const err92 = { instancePath: instancePath + "/case/kostentraeger", schemaPath: "#/definitions/VerificationCase/properties/kostentraeger/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key9 }, message: "must NOT have additional properties" };
                if (vErrors === null) {
                  vErrors = [err92];
                } else {
                  vErrors.push(err92);
                }
                errors++;
              }
            }
            if (data37.value !== void 0) {
              let data38 = data37.value;
              if (typeof data38 !== "string") {
                const err93 = { instancePath: instancePath + "/case/kostentraeger/value", schemaPath: "#/definitions/VerificationCase/properties/kostentraeger/properties/value/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err93];
                } else {
                  vErrors.push(err93);
                }
                errors++;
              }
              if (!(data38 === "gkv_kzv_bw")) {
                const err94 = { instancePath: instancePath + "/case/kostentraeger/value", schemaPath: "#/definitions/VerificationCase/properties/kostentraeger/properties/value/enum", keyword: "enum", params: { allowedValues: schema54.properties.kostentraeger.properties.value.enum }, message: "must be equal to one of the allowed values" };
                if (vErrors === null) {
                  vErrors = [err94];
                } else {
                  vErrors.push(err94);
                }
                errors++;
              }
            }
            if (data37.statedIn !== void 0) {
              if (typeof data37.statedIn !== "string") {
                const err95 = { instancePath: instancePath + "/case/kostentraeger/statedIn", schemaPath: "#/definitions/VerificationCase/properties/kostentraeger/properties/statedIn/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err95];
                } else {
                  vErrors.push(err95);
                }
                errors++;
              }
            }
          } else {
            const err96 = { instancePath: instancePath + "/case/kostentraeger", schemaPath: "#/definitions/VerificationCase/properties/kostentraeger/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
              vErrors = [err96];
            } else {
              vErrors.push(err96);
            }
            errors++;
          }
        }
      } else {
        const err97 = { instancePath: instancePath + "/case", schemaPath: "#/definitions/VerificationCase/type", keyword: "type", params: { type: "object" }, message: "must be object" };
        if (vErrors === null) {
          vErrors = [err97];
        } else {
          vErrors.push(err97);
        }
        errors++;
      }
    }
    if (data.refused !== void 0) {
      let data40 = data.refused;
      if (Array.isArray(data40)) {
        const len6 = data40.length;
        for (let i6 = 0; i6 < len6; i6++) {
          let data41 = data40[i6];
          if (data41 && typeof data41 == "object" && !Array.isArray(data41)) {
            if (data41.value === void 0) {
              const err98 = { instancePath: instancePath + "/refused/" + i6, schemaPath: "#/properties/refused/items/required", keyword: "required", params: { missingProperty: "value" }, message: "must have required property 'value'" };
              if (vErrors === null) {
                vErrors = [err98];
              } else {
                vErrors.push(err98);
              }
              errors++;
            }
            if (data41.reason === void 0) {
              const err99 = { instancePath: instancePath + "/refused/" + i6, schemaPath: "#/properties/refused/items/required", keyword: "required", params: { missingProperty: "reason" }, message: "must have required property 'reason'" };
              if (vErrors === null) {
                vErrors = [err99];
              } else {
                vErrors.push(err99);
              }
              errors++;
            }
            for (const key10 in data41) {
              if (!(key10 === "fdi" || key10 === "jaw" || key10 === "fact" || key10 === "at" || key10 === "nr" || key10 === "value" || key10 === "reason")) {
                const err100 = { instancePath: instancePath + "/refused/" + i6, schemaPath: "#/properties/refused/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key10 }, message: "must NOT have additional properties" };
                if (vErrors === null) {
                  vErrors = [err100];
                } else {
                  vErrors.push(err100);
                }
                errors++;
              }
            }
            if (data41.fdi !== void 0) {
              let data42 = data41.fdi;
              if (!(typeof data42 == "number" && isFinite(data42))) {
                const err101 = { instancePath: instancePath + "/refused/" + i6 + "/fdi", schemaPath: "#/properties/refused/items/properties/fdi/type", keyword: "type", params: { type: "number" }, message: "must be number" };
                if (vErrors === null) {
                  vErrors = [err101];
                } else {
                  vErrors.push(err101);
                }
                errors++;
              }
            }
            if (data41.jaw !== void 0) {
              if (typeof data41.jaw !== "string") {
                const err102 = { instancePath: instancePath + "/refused/" + i6 + "/jaw", schemaPath: "#/properties/refused/items/properties/jaw/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err102];
                } else {
                  vErrors.push(err102);
                }
                errors++;
              }
            }
            if (data41.fact !== void 0) {
              if (typeof data41.fact !== "string") {
                const err103 = { instancePath: instancePath + "/refused/" + i6 + "/fact", schemaPath: "#/properties/refused/items/properties/fact/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err103];
                } else {
                  vErrors.push(err103);
                }
                errors++;
              }
            }
            if (data41.at !== void 0) {
              if (typeof data41.at !== "string") {
                const err104 = { instancePath: instancePath + "/refused/" + i6 + "/at", schemaPath: "#/properties/refused/items/properties/at/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err104];
                } else {
                  vErrors.push(err104);
                }
                errors++;
              }
            }
            if (data41.nr !== void 0) {
              if (typeof data41.nr !== "string") {
                const err105 = { instancePath: instancePath + "/refused/" + i6 + "/nr", schemaPath: "#/properties/refused/items/properties/nr/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err105];
                } else {
                  vErrors.push(err105);
                }
                errors++;
              }
            }
            if (data41.value !== void 0) {
              let data47 = data41.value;
              const _errs116 = errors;
              let valid28 = false;
              const _errs117 = errors;
              if (typeof data47 !== "boolean") {
                const err106 = { instancePath: instancePath + "/refused/" + i6 + "/value", schemaPath: "#/properties/refused/items/properties/value/anyOf/0/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                if (vErrors === null) {
                  vErrors = [err106];
                } else {
                  vErrors.push(err106);
                }
                errors++;
              }
              var _valid2 = _errs117 === errors;
              valid28 = valid28 || _valid2;
              if (!valid28) {
                const _errs119 = errors;
                if (typeof data47 !== "string") {
                  const err107 = { instancePath: instancePath + "/refused/" + i6 + "/value", schemaPath: "#/properties/refused/items/properties/value/anyOf/1/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                  if (vErrors === null) {
                    vErrors = [err107];
                  } else {
                    vErrors.push(err107);
                  }
                  errors++;
                }
                var _valid2 = _errs119 === errors;
                valid28 = valid28 || _valid2;
              }
              if (!valid28) {
                const err108 = { instancePath: instancePath + "/refused/" + i6 + "/value", schemaPath: "#/properties/refused/items/properties/value/anyOf", keyword: "anyOf", params: {}, message: "must match a schema in anyOf" };
                if (vErrors === null) {
                  vErrors = [err108];
                } else {
                  vErrors.push(err108);
                }
                errors++;
              } else {
                errors = _errs116;
                if (vErrors !== null) {
                  if (_errs116) {
                    vErrors.length = _errs116;
                  } else {
                    vErrors = null;
                  }
                }
              }
            }
            if (data41.reason !== void 0) {
              if (typeof data41.reason !== "string") {
                const err109 = { instancePath: instancePath + "/refused/" + i6 + "/reason", schemaPath: "#/properties/refused/items/properties/reason/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err109];
                } else {
                  vErrors.push(err109);
                }
                errors++;
              }
            }
          } else {
            const err110 = { instancePath: instancePath + "/refused/" + i6, schemaPath: "#/properties/refused/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
              vErrors = [err110];
            } else {
              vErrors.push(err110);
            }
            errors++;
          }
        }
      } else {
        const err111 = { instancePath: instancePath + "/refused", schemaPath: "#/properties/refused/type", keyword: "type", params: { type: "array" }, message: "must be array" };
        if (vErrors === null) {
          vErrors = [err111];
        } else {
          vErrors.push(err111);
        }
        errors++;
      }
    }
  } else {
    const err112 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err112];
    } else {
      vErrors.push(err112);
    }
    errors++;
  }
  validate45.errors = vErrors;
  return errors === 0;
}
var validateInput18 = validate46;
var schema55 = { "$schema": "http://json-schema.org/draft-07/schema#", "type": "object", "properties": { "conversationId": { "type": "string", "minLength": 1, "description": "The conversation the case belongs to; the agent's is named in its prompt." }, "questions": { "minItems": 1, "type": "array", "items": { "type": "object", "properties": { "fdi": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991, "description": "The tooth, by FDI number (11\u201348)." }, "jaw": { "type": "string", "enum": ["OK", "UK"], "description": "The jaw: OK upper, UK lower." }, "fact": { "type": "string", "enum": ["fehlt", "erhaltungswuerdig", "krone", "endodontisch_behandelt", "stiftaufbau", "brueckenanker", "disparallel", "wiederherstellung", "geplant", "lueckensituation_i"], "description": "A finding, by name: at a tooth, or at a jaw (lueckensituation_i)." } }, "required": ["fact"], "additionalProperties": false } } }, "required": ["conversationId", "questions"], "additionalProperties": false };
function validate46(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.conversationId === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "conversationId" }, message: "must have required property 'conversationId'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.questions === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "questions" }, message: "must have required property 'questions'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    for (const key0 in data) {
      if (!(key0 === "conversationId" || key0 === "questions")) {
        const err2 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
    if (data.conversationId !== void 0) {
      let data0 = data.conversationId;
      if (typeof data0 === "string") {
        if (func2(data0) < 1) {
          const err3 = { instancePath: instancePath + "/conversationId", schemaPath: "#/properties/conversationId/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
          if (vErrors === null) {
            vErrors = [err3];
          } else {
            vErrors.push(err3);
          }
          errors++;
        }
      } else {
        const err4 = { instancePath: instancePath + "/conversationId", schemaPath: "#/properties/conversationId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
    if (data.questions !== void 0) {
      let data1 = data.questions;
      if (Array.isArray(data1)) {
        if (data1.length < 1) {
          const err5 = { instancePath: instancePath + "/questions", schemaPath: "#/properties/questions/minItems", keyword: "minItems", params: { limit: 1 }, message: "must NOT have fewer than 1 items" };
          if (vErrors === null) {
            vErrors = [err5];
          } else {
            vErrors.push(err5);
          }
          errors++;
        }
        const len0 = data1.length;
        for (let i0 = 0; i0 < len0; i0++) {
          let data2 = data1[i0];
          if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
            if (data2.fact === void 0) {
              const err6 = { instancePath: instancePath + "/questions/" + i0, schemaPath: "#/properties/questions/items/required", keyword: "required", params: { missingProperty: "fact" }, message: "must have required property 'fact'" };
              if (vErrors === null) {
                vErrors = [err6];
              } else {
                vErrors.push(err6);
              }
              errors++;
            }
            for (const key1 in data2) {
              if (!(key1 === "fdi" || key1 === "jaw" || key1 === "fact")) {
                const err7 = { instancePath: instancePath + "/questions/" + i0, schemaPath: "#/properties/questions/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
                if (vErrors === null) {
                  vErrors = [err7];
                } else {
                  vErrors.push(err7);
                }
                errors++;
              }
            }
            if (data2.fdi !== void 0) {
              let data3 = data2.fdi;
              if (!(typeof data3 == "number" && (!(data3 % 1) && !isNaN(data3)) && isFinite(data3))) {
                const err8 = { instancePath: instancePath + "/questions/" + i0 + "/fdi", schemaPath: "#/properties/questions/items/properties/fdi/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                if (vErrors === null) {
                  vErrors = [err8];
                } else {
                  vErrors.push(err8);
                }
                errors++;
              }
              if (typeof data3 == "number" && isFinite(data3)) {
                if (data3 > 9007199254740991 || isNaN(data3)) {
                  const err9 = { instancePath: instancePath + "/questions/" + i0 + "/fdi", schemaPath: "#/properties/questions/items/properties/fdi/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err9];
                  } else {
                    vErrors.push(err9);
                  }
                  errors++;
                }
                if (data3 < -9007199254740991 || isNaN(data3)) {
                  const err10 = { instancePath: instancePath + "/questions/" + i0 + "/fdi", schemaPath: "#/properties/questions/items/properties/fdi/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err10];
                  } else {
                    vErrors.push(err10);
                  }
                  errors++;
                }
              }
            }
            if (data2.jaw !== void 0) {
              let data4 = data2.jaw;
              if (typeof data4 !== "string") {
                const err11 = { instancePath: instancePath + "/questions/" + i0 + "/jaw", schemaPath: "#/properties/questions/items/properties/jaw/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err11];
                } else {
                  vErrors.push(err11);
                }
                errors++;
              }
              if (!(data4 === "OK" || data4 === "UK")) {
                const err12 = { instancePath: instancePath + "/questions/" + i0 + "/jaw", schemaPath: "#/properties/questions/items/properties/jaw/enum", keyword: "enum", params: { allowedValues: schema55.properties.questions.items.properties.jaw.enum }, message: "must be equal to one of the allowed values" };
                if (vErrors === null) {
                  vErrors = [err12];
                } else {
                  vErrors.push(err12);
                }
                errors++;
              }
            }
            if (data2.fact !== void 0) {
              let data5 = data2.fact;
              if (typeof data5 !== "string") {
                const err13 = { instancePath: instancePath + "/questions/" + i0 + "/fact", schemaPath: "#/properties/questions/items/properties/fact/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err13];
                } else {
                  vErrors.push(err13);
                }
                errors++;
              }
              if (!(data5 === "fehlt" || data5 === "erhaltungswuerdig" || data5 === "krone" || data5 === "endodontisch_behandelt" || data5 === "stiftaufbau" || data5 === "brueckenanker" || data5 === "disparallel" || data5 === "wiederherstellung" || data5 === "geplant" || data5 === "lueckensituation_i")) {
                const err14 = { instancePath: instancePath + "/questions/" + i0 + "/fact", schemaPath: "#/properties/questions/items/properties/fact/enum", keyword: "enum", params: { allowedValues: schema55.properties.questions.items.properties.fact.enum }, message: "must be equal to one of the allowed values" };
                if (vErrors === null) {
                  vErrors = [err14];
                } else {
                  vErrors.push(err14);
                }
                errors++;
              }
            }
          } else {
            const err15 = { instancePath: instancePath + "/questions/" + i0, schemaPath: "#/properties/questions/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
              vErrors = [err15];
            } else {
              vErrors.push(err15);
            }
            errors++;
          }
        }
      } else {
        const err16 = { instancePath: instancePath + "/questions", schemaPath: "#/properties/questions/type", keyword: "type", params: { type: "array" }, message: "must be array" };
        if (vErrors === null) {
          vErrors = [err16];
        } else {
          vErrors.push(err16);
        }
        errors++;
      }
    }
  } else {
    const err17 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err17];
    } else {
      vErrors.push(err17);
    }
    errors++;
  }
  validate46.errors = vErrors;
  return errors === 0;
}
var validateOutput18 = validate47;
var schema56 = { "$schema": "http://json-schema.org/draft-07/schema#", "type": "object", "properties": { "object": { "type": "string", "const": "verification_questions" }, "asked": { "type": "array", "items": { "type": "object", "properties": { "fdi": { "type": "integer", "minimum": -9007199254740991, "maximum": 9007199254740991, "description": "The tooth, by FDI number (11\u201348)." }, "jaw": { "type": "string", "enum": ["OK", "UK"], "description": "The jaw: OK upper, UK lower." }, "fact": { "type": "string", "enum": ["fehlt", "erhaltungswuerdig", "krone", "endodontisch_behandelt", "stiftaufbau", "brueckenanker", "disparallel", "wiederherstellung", "geplant", "lueckensituation_i"], "description": "A finding, by name: at a tooth, or at a jaw (lueckensituation_i)." } }, "required": ["fact"], "additionalProperties": false }, "description": "The questions taken, in your order." }, "refused": { "type": "array", "items": { "type": "object", "properties": { "fdi": { "type": "number" }, "jaw": { "type": "string" }, "fact": { "type": "string" }, "reason": { "type": "string" } }, "required": ["fact", "reason"], "additionalProperties": false }, "description": "Questions not taken, and why. Empty when every one was." } }, "required": ["object", "asked", "refused"], "additionalProperties": false };
function validate47(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.object === void 0) {
      const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "object" }, message: "must have required property 'object'" };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.asked === void 0) {
      const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "asked" }, message: "must have required property 'asked'" };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.refused === void 0) {
      const err2 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "refused" }, message: "must have required property 'refused'" };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    for (const key0 in data) {
      if (!(key0 === "object" || key0 === "asked" || key0 === "refused")) {
        const err3 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.object !== void 0) {
      let data0 = data.object;
      if (typeof data0 !== "string") {
        const err4 = { instancePath: instancePath + "/object", schemaPath: "#/properties/object/type", keyword: "type", params: { type: "string" }, message: "must be string" };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
      if ("verification_questions" !== data0) {
        const err5 = { instancePath: instancePath + "/object", schemaPath: "#/properties/object/const", keyword: "const", params: { allowedValue: "verification_questions" }, message: "must be equal to constant" };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
    }
    if (data.asked !== void 0) {
      let data1 = data.asked;
      if (Array.isArray(data1)) {
        const len0 = data1.length;
        for (let i0 = 0; i0 < len0; i0++) {
          let data2 = data1[i0];
          if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
            if (data2.fact === void 0) {
              const err6 = { instancePath: instancePath + "/asked/" + i0, schemaPath: "#/properties/asked/items/required", keyword: "required", params: { missingProperty: "fact" }, message: "must have required property 'fact'" };
              if (vErrors === null) {
                vErrors = [err6];
              } else {
                vErrors.push(err6);
              }
              errors++;
            }
            for (const key1 in data2) {
              if (!(key1 === "fdi" || key1 === "jaw" || key1 === "fact")) {
                const err7 = { instancePath: instancePath + "/asked/" + i0, schemaPath: "#/properties/asked/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
                if (vErrors === null) {
                  vErrors = [err7];
                } else {
                  vErrors.push(err7);
                }
                errors++;
              }
            }
            if (data2.fdi !== void 0) {
              let data3 = data2.fdi;
              if (!(typeof data3 == "number" && (!(data3 % 1) && !isNaN(data3)) && isFinite(data3))) {
                const err8 = { instancePath: instancePath + "/asked/" + i0 + "/fdi", schemaPath: "#/properties/asked/items/properties/fdi/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                if (vErrors === null) {
                  vErrors = [err8];
                } else {
                  vErrors.push(err8);
                }
                errors++;
              }
              if (typeof data3 == "number" && isFinite(data3)) {
                if (data3 > 9007199254740991 || isNaN(data3)) {
                  const err9 = { instancePath: instancePath + "/asked/" + i0 + "/fdi", schemaPath: "#/properties/asked/items/properties/fdi/maximum", keyword: "maximum", params: { comparison: "<=", limit: 9007199254740991 }, message: "must be <= 9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err9];
                  } else {
                    vErrors.push(err9);
                  }
                  errors++;
                }
                if (data3 < -9007199254740991 || isNaN(data3)) {
                  const err10 = { instancePath: instancePath + "/asked/" + i0 + "/fdi", schemaPath: "#/properties/asked/items/properties/fdi/minimum", keyword: "minimum", params: { comparison: ">=", limit: -9007199254740991 }, message: "must be >= -9007199254740991" };
                  if (vErrors === null) {
                    vErrors = [err10];
                  } else {
                    vErrors.push(err10);
                  }
                  errors++;
                }
              }
            }
            if (data2.jaw !== void 0) {
              let data4 = data2.jaw;
              if (typeof data4 !== "string") {
                const err11 = { instancePath: instancePath + "/asked/" + i0 + "/jaw", schemaPath: "#/properties/asked/items/properties/jaw/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err11];
                } else {
                  vErrors.push(err11);
                }
                errors++;
              }
              if (!(data4 === "OK" || data4 === "UK")) {
                const err12 = { instancePath: instancePath + "/asked/" + i0 + "/jaw", schemaPath: "#/properties/asked/items/properties/jaw/enum", keyword: "enum", params: { allowedValues: schema56.properties.asked.items.properties.jaw.enum }, message: "must be equal to one of the allowed values" };
                if (vErrors === null) {
                  vErrors = [err12];
                } else {
                  vErrors.push(err12);
                }
                errors++;
              }
            }
            if (data2.fact !== void 0) {
              let data5 = data2.fact;
              if (typeof data5 !== "string") {
                const err13 = { instancePath: instancePath + "/asked/" + i0 + "/fact", schemaPath: "#/properties/asked/items/properties/fact/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err13];
                } else {
                  vErrors.push(err13);
                }
                errors++;
              }
              if (!(data5 === "fehlt" || data5 === "erhaltungswuerdig" || data5 === "krone" || data5 === "endodontisch_behandelt" || data5 === "stiftaufbau" || data5 === "brueckenanker" || data5 === "disparallel" || data5 === "wiederherstellung" || data5 === "geplant" || data5 === "lueckensituation_i")) {
                const err14 = { instancePath: instancePath + "/asked/" + i0 + "/fact", schemaPath: "#/properties/asked/items/properties/fact/enum", keyword: "enum", params: { allowedValues: schema56.properties.asked.items.properties.fact.enum }, message: "must be equal to one of the allowed values" };
                if (vErrors === null) {
                  vErrors = [err14];
                } else {
                  vErrors.push(err14);
                }
                errors++;
              }
            }
          } else {
            const err15 = { instancePath: instancePath + "/asked/" + i0, schemaPath: "#/properties/asked/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
              vErrors = [err15];
            } else {
              vErrors.push(err15);
            }
            errors++;
          }
        }
      } else {
        const err16 = { instancePath: instancePath + "/asked", schemaPath: "#/properties/asked/type", keyword: "type", params: { type: "array" }, message: "must be array" };
        if (vErrors === null) {
          vErrors = [err16];
        } else {
          vErrors.push(err16);
        }
        errors++;
      }
    }
    if (data.refused !== void 0) {
      let data6 = data.refused;
      if (Array.isArray(data6)) {
        const len1 = data6.length;
        for (let i1 = 0; i1 < len1; i1++) {
          let data7 = data6[i1];
          if (data7 && typeof data7 == "object" && !Array.isArray(data7)) {
            if (data7.fact === void 0) {
              const err17 = { instancePath: instancePath + "/refused/" + i1, schemaPath: "#/properties/refused/items/required", keyword: "required", params: { missingProperty: "fact" }, message: "must have required property 'fact'" };
              if (vErrors === null) {
                vErrors = [err17];
              } else {
                vErrors.push(err17);
              }
              errors++;
            }
            if (data7.reason === void 0) {
              const err18 = { instancePath: instancePath + "/refused/" + i1, schemaPath: "#/properties/refused/items/required", keyword: "required", params: { missingProperty: "reason" }, message: "must have required property 'reason'" };
              if (vErrors === null) {
                vErrors = [err18];
              } else {
                vErrors.push(err18);
              }
              errors++;
            }
            for (const key2 in data7) {
              if (!(key2 === "fdi" || key2 === "jaw" || key2 === "fact" || key2 === "reason")) {
                const err19 = { instancePath: instancePath + "/refused/" + i1, schemaPath: "#/properties/refused/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key2 }, message: "must NOT have additional properties" };
                if (vErrors === null) {
                  vErrors = [err19];
                } else {
                  vErrors.push(err19);
                }
                errors++;
              }
            }
            if (data7.fdi !== void 0) {
              let data8 = data7.fdi;
              if (!(typeof data8 == "number" && isFinite(data8))) {
                const err20 = { instancePath: instancePath + "/refused/" + i1 + "/fdi", schemaPath: "#/properties/refused/items/properties/fdi/type", keyword: "type", params: { type: "number" }, message: "must be number" };
                if (vErrors === null) {
                  vErrors = [err20];
                } else {
                  vErrors.push(err20);
                }
                errors++;
              }
            }
            if (data7.jaw !== void 0) {
              if (typeof data7.jaw !== "string") {
                const err21 = { instancePath: instancePath + "/refused/" + i1 + "/jaw", schemaPath: "#/properties/refused/items/properties/jaw/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err21];
                } else {
                  vErrors.push(err21);
                }
                errors++;
              }
            }
            if (data7.fact !== void 0) {
              if (typeof data7.fact !== "string") {
                const err22 = { instancePath: instancePath + "/refused/" + i1 + "/fact", schemaPath: "#/properties/refused/items/properties/fact/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err22];
                } else {
                  vErrors.push(err22);
                }
                errors++;
              }
            }
            if (data7.reason !== void 0) {
              if (typeof data7.reason !== "string") {
                const err23 = { instancePath: instancePath + "/refused/" + i1 + "/reason", schemaPath: "#/properties/refused/items/properties/reason/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                if (vErrors === null) {
                  vErrors = [err23];
                } else {
                  vErrors.push(err23);
                }
                errors++;
              }
            }
          } else {
            const err24 = { instancePath: instancePath + "/refused/" + i1, schemaPath: "#/properties/refused/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
              vErrors = [err24];
            } else {
              vErrors.push(err24);
            }
            errors++;
          }
        }
      } else {
        const err25 = { instancePath: instancePath + "/refused", schemaPath: "#/properties/refused/type", keyword: "type", params: { type: "array" }, message: "must be array" };
        if (vErrors === null) {
          vErrors = [err25];
        } else {
          vErrors.push(err25);
        }
        errors++;
      }
    }
  } else {
    const err26 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
      vErrors = [err26];
    } else {
      vErrors.push(err26);
    }
    errors++;
  }
  validate47.errors = vErrors;
  return errors === 0;
}
export {
  validateInput0,
  validateInput1,
  validateInput10,
  validateInput11,
  validateInput12,
  validateInput13,
  validateInput14,
  validateInput15,
  validateInput16,
  validateInput17,
  validateInput18,
  validateInput2,
  validateInput3,
  validateInput4,
  validateInput5,
  validateInput6,
  validateInput7,
  validateInput8,
  validateInput9,
  validateOutput0,
  validateOutput1,
  validateOutput10,
  validateOutput11,
  validateOutput12,
  validateOutput13,
  validateOutput14,
  validateOutput15,
  validateOutput16,
  validateOutput17,
  validateOutput18,
  validateOutput2,
  validateOutput3,
  validateOutput4,
  validateOutput5,
  validateOutput6,
  validateOutput7,
  validateOutput8,
  validateOutput9
};
